/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		354: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + chunkId + ".build-" + "ffcb87c77253e9779e24" + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 102);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return epsilon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return epsilon2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return pi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return halfPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return quarterPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return tau; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return degrees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return radians; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return abs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return atan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return atan2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return cos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ceil; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return exp; });
/* unused harmony export floor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return log; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return pow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return sin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return sign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return sqrt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return tan; });
/* harmony export (immutable) */ __webpack_exports__["b"] = acos;
/* harmony export (immutable) */ __webpack_exports__["c"] = asin;
/* harmony export (immutable) */ __webpack_exports__["m"] = haversin;
var epsilon = 1e-6;
var epsilon2 = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var quarterPi = pi / 4;
var tau = pi * 2;

var degrees = 180 / pi;
var radians = pi / 180;

var abs = Math.abs;
var atan = Math.atan;
var atan2 = Math.atan2;
var cos = Math.cos;
var ceil = Math.ceil;
var exp = Math.exp;
var floor = Math.floor;
var log = Math.log;
var pow = Math.pow;
var sin = Math.sin;
var sign = Math.sign || function(x) { return x > 0 ? 1 : x < 0 ? -1 : 0; };
var sqrt = Math.sqrt;
var tan = Math.tan;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}

function asin(x) {
  return x > 1 ? halfPi : x < -1 ? -halfPi : Math.asin(x);
}

function haversin(x) {
  return (x = sin(x / 2)) * x;
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_create__ = __webpack_require__(255);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_create__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_creator__ = __webpack_require__(39);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__src_creator__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_local__ = __webpack_require__(284);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__src_local__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_matcher__ = __webpack_require__(121);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_3__src_matcher__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_mouse__ = __webpack_require__(285);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_4__src_mouse__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_namespace__ = __webpack_require__(60);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_5__src_namespace__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_namespaces__ = __webpack_require__(61);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_6__src_namespaces__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_point__ = __webpack_require__(40);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_7__src_point__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_select__ = __webpack_require__(119);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_8__src_select__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_selectAll__ = __webpack_require__(286);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_9__src_selectAll__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_selection_index__ = __webpack_require__(6);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_10__src_selection_index__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_selector__ = __webpack_require__(62);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_11__src_selector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_selectorAll__ = __webpack_require__(120);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_12__src_selectorAll__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_selection_style__ = __webpack_require__(124);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_13__src_selection_style__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_touch__ = __webpack_require__(287);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_14__src_touch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_touches__ = __webpack_require__(288);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_15__src_touches__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_window__ = __webpack_require__(63);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_16__src_window__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_selection_on__ = __webpack_require__(64);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_17__src_selection_on__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_17__src_selection_on__["a"]; });




















/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export makeQueryString */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return makeQueryStringDync; });
/* unused harmony export makeQueryStringDynamic */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return errorServeiceHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return makeQueryFormDataDyn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_store__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eventBus__ = __webpack_require__(100);




var makeQueryString = function makeQueryString(dataObj) {
    var queryStr = '?';
    dataObj.forEach(function (data) {
        queryStr += data.key + '=' + data.value + '&';
    });
    queryStr = queryStr.substring(0, queryStr.length - 1);
    return queryStr;
};

var makeQueryStringDync = function makeQueryStringDync(dataObj) {
    if (!Object.keys(dataObj).length) return false;

    var queryStr = '?';
    for (var item in dataObj) {
        queryStr += item + '=' + dataObj[item] + '&';
    }
    queryStr = queryStr.substring(0, queryStr.length - 1);
    return queryStr;
};

var makeQueryStringDynamic = function makeQueryStringDynamic(dataObj) {
    if (!Object.keys(dataObj).length) return false;

    var queryStr = '';
    for (var item in dataObj) {
        queryStr += item + '=' + dataObj[item] + ',';
    }
    queryStr = queryStr.substring(0, queryStr.length - 1);
    return queryStr;
};

var errorServeiceHandler = function errorServeiceHandler(response) {
    if ((response.status == 200 || response.status == 201) && response.ok) {
        return response;
    } else {
        if (response.status == 401 && __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* store */].getters.getMode != "development") {
            localStorage.removeItem('NXTDigitalUser');
            localStorage.removeItem("subUser");
            __WEBPACK_IMPORTED_MODULE_2__eventBus__["a" /* eventBus */].$emit("lco-loader", false);

            var messageObj = {};
            messageObj.status = true;
            messageObj.backgroundColor = false;
            messageObj.leftalign = 0;
            messageObj.minwidth = 100;
            messageObj.message = "No valid session exist";
            __WEBPACK_IMPORTED_MODULE_2__eventBus__["a" /* eventBus */].$emit("lco-message", messageObj);

            return;
            // setTimeout(() => {
            //     vueMain.$router.push({ name: "login" })
            // }, 4000);
        }
        throw response;
    }
};

var makeQueryFormDataDyn = function makeQueryFormDataDyn(dataObj) {
    if (!Object.keys(dataObj).length) return false;
    var obj = new FormData();
    for (var data in dataObj) {
        obj.append(data, dataObj[data]);
    }
    // console.log("obj || helpers ",obj.getAll('mobileno'));
    return obj;
};

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = newInterval;
var t0 = new Date,
    t1 = new Date;

function newInterval(floori, offseti, count, field) {

  function interval(date) {
    return floori(date = new Date(+date)), date;
  }

  interval.floor = interval;

  interval.ceil = function(date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };

  interval.round = function(date) {
    var d0 = interval(date),
        d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = function(date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = function(start, stop, step) {
    var range = [], previous;
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
    while (previous < start && start < stop);
    return range;
  };

  interval.filter = function(test) {
    return newInterval(function(date) {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, function(date, step) {
      if (date >= date) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
        } else while (--step >= 0) {
          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
        }
      }
    });
  };

  if (count) {
    interval.count = function(start, end) {
      t0.setTime(+start), t1.setTime(+end);
      floori(t0), floori(t1);
      return Math.floor(count(t0, t1));
    };

    interval.every = function(step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null
          : !(step > 1) ? interval
          : interval.filter(field
              ? function(d) { return field(d) % step === 0; }
              : function(d) { return interval.count(0, d) % step === 0; });
    };
  }

  return interval;
}


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_bisect__ = __webpack_require__(107);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_bisect__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__src_bisect__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__src_bisect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_ascending__ = __webpack_require__(21);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__src_ascending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_bisector__ = __webpack_require__(108);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__src_bisector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_cross__ = __webpack_require__(231);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__src_cross__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_descending__ = __webpack_require__(232);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_4__src_descending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_deviation__ = __webpack_require__(110);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_5__src_deviation__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_extent__ = __webpack_require__(112);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_6__src_extent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_histogram__ = __webpack_require__(233);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_7__src_histogram__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_threshold_freedmanDiaconis__ = __webpack_require__(236);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_8__src_threshold_freedmanDiaconis__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_threshold_scott__ = __webpack_require__(237);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_9__src_threshold_scott__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_threshold_sturges__ = __webpack_require__(116);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_10__src_threshold_sturges__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_max__ = __webpack_require__(238);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_11__src_max__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_mean__ = __webpack_require__(239);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_12__src_mean__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_median__ = __webpack_require__(240);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_13__src_median__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_merge__ = __webpack_require__(241);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_14__src_merge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_min__ = __webpack_require__(117);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_15__src_min__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_pairs__ = __webpack_require__(109);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_16__src_pairs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_permute__ = __webpack_require__(242);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_17__src_permute__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_quantile__ = __webpack_require__(58);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_18__src_quantile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_range__ = __webpack_require__(114);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_19__src_range__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_scan__ = __webpack_require__(243);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_20__src_scan__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_shuffle__ = __webpack_require__(244);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_21__src_shuffle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_sum__ = __webpack_require__(245);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_22__src_sum__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_ticks__ = __webpack_require__(115);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_transpose__ = __webpack_require__(118);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_24__src_transpose__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__src_variance__ = __webpack_require__(111);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_25__src_variance__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__src_zip__ = __webpack_require__(246);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_26__src_zip__["a"]; });





























/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.10
 * (c) 2014-2019 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Techinically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a speical value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack becaues all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.10';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes(parentElm, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecesarry `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being pased as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anyting as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving the component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function\s*(?:[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(20), __webpack_require__(192).setImmediate))

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return root; });
/* harmony export (immutable) */ __webpack_exports__["a"] = Selection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__select__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectAll__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filter__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enter__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__exit__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__merge__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__order__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__sort__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__call__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__nodes__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__node__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__size__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__empty__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__each__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__attr__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__style__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__property__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__classed__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__text__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__html__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__raise__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__lower__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__append__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__insert__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__remove__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__clone__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__datum__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__on__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__dispatch__ = __webpack_require__(283);































var root = [null];

function Selection(groups, parents) {
  this._groups = groups;
  this._parents = parents;
}

function selection() {
  return new Selection([[document.documentElement]], root);
}

Selection.prototype = selection.prototype = {
  constructor: Selection,
  select: __WEBPACK_IMPORTED_MODULE_0__select__["a" /* default */],
  selectAll: __WEBPACK_IMPORTED_MODULE_1__selectAll__["a" /* default */],
  filter: __WEBPACK_IMPORTED_MODULE_2__filter__["a" /* default */],
  data: __WEBPACK_IMPORTED_MODULE_3__data__["a" /* default */],
  enter: __WEBPACK_IMPORTED_MODULE_4__enter__["b" /* default */],
  exit: __WEBPACK_IMPORTED_MODULE_5__exit__["a" /* default */],
  merge: __WEBPACK_IMPORTED_MODULE_6__merge__["a" /* default */],
  order: __WEBPACK_IMPORTED_MODULE_7__order__["a" /* default */],
  sort: __WEBPACK_IMPORTED_MODULE_8__sort__["a" /* default */],
  call: __WEBPACK_IMPORTED_MODULE_9__call__["a" /* default */],
  nodes: __WEBPACK_IMPORTED_MODULE_10__nodes__["a" /* default */],
  node: __WEBPACK_IMPORTED_MODULE_11__node__["a" /* default */],
  size: __WEBPACK_IMPORTED_MODULE_12__size__["a" /* default */],
  empty: __WEBPACK_IMPORTED_MODULE_13__empty__["a" /* default */],
  each: __WEBPACK_IMPORTED_MODULE_14__each__["a" /* default */],
  attr: __WEBPACK_IMPORTED_MODULE_15__attr__["a" /* default */],
  style: __WEBPACK_IMPORTED_MODULE_16__style__["a" /* default */],
  property: __WEBPACK_IMPORTED_MODULE_17__property__["a" /* default */],
  classed: __WEBPACK_IMPORTED_MODULE_18__classed__["a" /* default */],
  text: __WEBPACK_IMPORTED_MODULE_19__text__["a" /* default */],
  html: __WEBPACK_IMPORTED_MODULE_20__html__["a" /* default */],
  raise: __WEBPACK_IMPORTED_MODULE_21__raise__["a" /* default */],
  lower: __WEBPACK_IMPORTED_MODULE_22__lower__["a" /* default */],
  append: __WEBPACK_IMPORTED_MODULE_23__append__["a" /* default */],
  insert: __WEBPACK_IMPORTED_MODULE_24__insert__["a" /* default */],
  remove: __WEBPACK_IMPORTED_MODULE_25__remove__["a" /* default */],
  clone: __WEBPACK_IMPORTED_MODULE_26__clone__["a" /* default */],
  datum: __WEBPACK_IMPORTED_MODULE_27__datum__["a" /* default */],
  on: __WEBPACK_IMPORTED_MODULE_28__on__["b" /* default */],
  dispatch: __WEBPACK_IMPORTED_MODULE_29__dispatch__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["b"] = (selection);


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_value__ = __webpack_require__(66);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_value__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_array__ = __webpack_require__(131);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_array__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_basis__ = __webpack_require__(69);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__src_basis__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_basisClosed__ = __webpack_require__(129);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__src_basisClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_date__ = __webpack_require__(132);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_4__src_date__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_number__ = __webpack_require__(41);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_5__src_number__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_object__ = __webpack_require__(133);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_6__src_object__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_round__ = __webpack_require__(293);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_7__src_round__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_string__ = __webpack_require__(134);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_8__src_string__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_transform_index__ = __webpack_require__(294);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_9__src_transform_index__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_9__src_transform_index__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_zoom__ = __webpack_require__(297);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_10__src_zoom__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_rgb__ = __webpack_require__(128);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_11__src_rgb__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_11__src_rgb__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_11__src_rgb__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_hsl__ = __webpack_require__(298);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_12__src_hsl__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_12__src_hsl__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_lab__ = __webpack_require__(299);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_13__src_lab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_hcl__ = __webpack_require__(300);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_14__src_hcl__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_14__src_hcl__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__ = __webpack_require__(301);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_quantize__ = __webpack_require__(302);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_16__src_quantize__["a"]; });



















/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CREATED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SCHEDULED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return STARTING; });
/* unused harmony export STARTED */
/* unused harmony export RUNNING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ENDED; });
/* harmony export (immutable) */ __webpack_exports__["g"] = init;
/* harmony export (immutable) */ __webpack_exports__["h"] = set;
/* harmony export (immutable) */ __webpack_exports__["f"] = get;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dispatch__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_timer__ = __webpack_require__(42);



var emptyOn = Object(__WEBPACK_IMPORTED_MODULE_0_d3_dispatch__["a" /* dispatch */])("start", "end", "interrupt");
var emptyTween = [];

var CREATED = 0;
var SCHEDULED = 1;
var STARTING = 2;
var STARTED = 3;
var RUNNING = 4;
var ENDING = 5;
var ENDED = 6;

/* harmony default export */ __webpack_exports__["e"] = (function(node, name, id, index, group, timing) {
  var schedules = node.__transition;
  if (!schedules) node.__transition = {};
  else if (id in schedules) return;
  create(node, id, {
    name: name,
    index: index, // For context during callback.
    group: group, // For context during callback.
    on: emptyOn,
    tween: emptyTween,
    time: timing.time,
    delay: timing.delay,
    duration: timing.duration,
    ease: timing.ease,
    timer: null,
    state: CREATED
  });
});

function init(node, id) {
  var schedule = get(node, id);
  if (schedule.state > CREATED) throw new Error("too late; already scheduled");
  return schedule;
}

function set(node, id) {
  var schedule = get(node, id);
  if (schedule.state > STARTING) throw new Error("too late; already started");
  return schedule;
}

function get(node, id) {
  var schedule = node.__transition;
  if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
  return schedule;
}

function create(node, id, self) {
  var schedules = node.__transition,
      tween;

  // Initialize the self timer when the transition is created.
  // Note the actual delay is not known until the first callback!
  schedules[id] = self;
  self.timer = Object(__WEBPACK_IMPORTED_MODULE_1_d3_timer__["d" /* timer */])(schedule, 0, self.time);

  function schedule(elapsed) {
    self.state = SCHEDULED;
    self.timer.restart(start, self.delay, self.time);

    // If the elapsed delay is less than our first sleep, start immediately.
    if (self.delay <= elapsed) start(elapsed - self.delay);
  }

  function start(elapsed) {
    var i, j, n, o;

    // If the state is not SCHEDULED, then we previously errored on start.
    if (self.state !== SCHEDULED) return stop();

    for (i in schedules) {
      o = schedules[i];
      if (o.name !== self.name) continue;

      // While this element already has a starting transition during this frame,
      // defer starting an interrupting transition until that transition has a
      // chance to tick (and possibly end); see d3/d3-transition#54!
      if (o.state === STARTED) return Object(__WEBPACK_IMPORTED_MODULE_1_d3_timer__["c" /* timeout */])(start);

      // Interrupt the active transition, if any.
      // Dispatch the interrupt event.
      if (o.state === RUNNING) {
        o.state = ENDED;
        o.timer.stop();
        o.on.call("interrupt", node, node.__data__, o.index, o.group);
        delete schedules[i];
      }

      // Cancel any pre-empted transitions. No interrupt event is dispatched
      // because the cancelled transitions never started. Note that this also
      // removes this transition from the pending list!
      else if (+i < id) {
        o.state = ENDED;
        o.timer.stop();
        delete schedules[i];
      }
    }

    // Defer the first tick to end of the current frame; see d3/d3#1576.
    // Note the transition may be canceled after start and before the first tick!
    // Note this must be scheduled before the start event; see d3/d3-transition#16!
    // Assuming this is successful, subsequent callbacks go straight to tick.
    Object(__WEBPACK_IMPORTED_MODULE_1_d3_timer__["c" /* timeout */])(function() {
      if (self.state === STARTED) {
        self.state = RUNNING;
        self.timer.restart(tick, self.delay, self.time);
        tick(elapsed);
      }
    });

    // Dispatch the start event.
    // Note this must be done before the tween are initialized.
    self.state = STARTING;
    self.on.call("start", node, node.__data__, self.index, self.group);
    if (self.state !== STARTING) return; // interrupted
    self.state = STARTED;

    // Initialize the tween, deleting null tween.
    tween = new Array(n = self.tween.length);
    for (i = 0, j = -1; i < n; ++i) {
      if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) {
        tween[++j] = o;
      }
    }
    tween.length = j + 1;
  }

  function tick(elapsed) {
    var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1),
        i = -1,
        n = tween.length;

    while (++i < n) {
      tween[i].call(null, t);
    }

    // Dispatch the end event.
    if (self.state === ENDING) {
      self.on.call("end", node, node.__data__, self.index, self.group);
      stop();
    }
  }

  function stop() {
    self.state = ENDED;
    self.timer.stop();
    delete schedules[id];
    for (var i in schedules) return; // eslint-disable-line no-unused-vars
    delete node.__transition;
  }
}


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_color__ = __webpack_require__(67);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_lab__ = __webpack_require__(291);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__src_lab__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__src_lab__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_cubehelix__ = __webpack_require__(292);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__src_cubehelix__["a"]; });





/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = projection;
/* harmony export (immutable) */ __webpack_exports__["b"] = projectionMutator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__clip_antimeridian__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clip_circle__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__clip_rectangle__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__compose__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__identity__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rotation__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__transform__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fit__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__resample__ = __webpack_require__(396);











var transformRadians = Object(__WEBPACK_IMPORTED_MODULE_7__transform__["b" /* transformer */])({
  point: function(x, y) {
    this.stream.point(x * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */], y * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */]);
  }
});

function transformRotate(rotate) {
  return Object(__WEBPACK_IMPORTED_MODULE_7__transform__["b" /* transformer */])({
    point: function(x, y) {
      var r = rotate(x, y);
      return this.stream.point(r[0], r[1]);
    }
  });
}

function projection(project) {
  return projectionMutator(function() { return project; })();
}

function projectionMutator(projectAt) {
  var project,
      k = 150, // scale
      x = 480, y = 250, // translate
      dx, dy, lambda = 0, phi = 0, // center
      deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, projectRotate, // rotate
      theta = null, preclip = __WEBPACK_IMPORTED_MODULE_0__clip_antimeridian__["a" /* default */], // clip angle
      x0 = null, y0, x1, y1, postclip = __WEBPACK_IMPORTED_MODULE_4__identity__["a" /* default */], // clip extent
      delta2 = 0.5, projectResample = Object(__WEBPACK_IMPORTED_MODULE_9__resample__["a" /* default */])(projectTransform, delta2), // precision
      cache,
      cacheStream;

  function projection(point) {
    point = projectRotate(point[0] * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */], point[1] * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */]);
    return [point[0] * k + dx, dy - point[1] * k];
  }

  function invert(point) {
    point = projectRotate.invert((point[0] - dx) / k, (dy - point[1]) / k);
    return point && [point[0] * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */], point[1] * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */]];
  }

  function projectTransform(x, y) {
    return x = project(x, y), [x[0] * k + dx, dy - x[1] * k];
  }

  projection.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = transformRadians(transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
  };

  projection.preclip = function(_) {
    return arguments.length ? (preclip = _, theta = undefined, reset()) : preclip;
  };

  projection.postclip = function(_) {
    return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
  };

  projection.clipAngle = function(_) {
    return arguments.length ? (preclip = +_ ? Object(__WEBPACK_IMPORTED_MODULE_1__clip_circle__["a" /* default */])(theta = _ * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */]) : (theta = null, __WEBPACK_IMPORTED_MODULE_0__clip_antimeridian__["a" /* default */]), reset()) : theta * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */];
  };

  projection.clipExtent = function(_) {
    return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, __WEBPACK_IMPORTED_MODULE_4__identity__["a" /* default */]) : Object(__WEBPACK_IMPORTED_MODULE_2__clip_rectangle__["a" /* default */])(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };

  projection.scale = function(_) {
    return arguments.length ? (k = +_, recenter()) : k;
  };

  projection.translate = function(_) {
    return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [x, y];
  };

  projection.center = function(_) {
    return arguments.length ? (lambda = _[0] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */], phi = _[1] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */], recenter()) : [lambda * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */], phi * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */]];
  };

  projection.rotate = function(_) {
    return arguments.length ? (deltaLambda = _[0] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */], deltaPhi = _[1] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */], deltaGamma = _.length > 2 ? _[2] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */] : 0, recenter()) : [deltaLambda * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */], deltaPhi * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */], deltaGamma * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */]];
  };

  projection.precision = function(_) {
    return arguments.length ? (projectResample = Object(__WEBPACK_IMPORTED_MODULE_9__resample__["a" /* default */])(projectTransform, delta2 = _ * _), reset()) : Object(__WEBPACK_IMPORTED_MODULE_5__math__["u" /* sqrt */])(delta2);
  };

  projection.fitExtent = function(extent, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_8__fit__["a" /* fitExtent */])(projection, extent, object);
  };

  projection.fitSize = function(size, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_8__fit__["c" /* fitSize */])(projection, size, object);
  };

  projection.fitWidth = function(width, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_8__fit__["d" /* fitWidth */])(projection, width, object);
  };

  projection.fitHeight = function(height, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_8__fit__["b" /* fitHeight */])(projection, height, object);
  };

  function recenter() {
    projectRotate = Object(__WEBPACK_IMPORTED_MODULE_3__compose__["a" /* default */])(rotate = Object(__WEBPACK_IMPORTED_MODULE_6__rotation__["b" /* rotateRadians */])(deltaLambda, deltaPhi, deltaGamma), project);
    var center = project(lambda, phi);
    dx = x - center[0] * k;
    dy = y + center[1] * k;
    return reset();
  }

  function reset() {
    cache = cacheStream = null;
    return projection;
  }

  return function() {
    project = projectAt.apply(this, arguments);
    projection.invert = project.invert && invert;
    return recenter();
  };
}


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return durationSecond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return durationMinute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return durationHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return durationDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return durationWeek; });
var durationSecond = 1e3;
var durationMinute = 6e4;
var durationHour = 36e5;
var durationDay = 864e5;
var durationWeek = 6048e5;


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Transition;
/* harmony export (immutable) */ __webpack_exports__["b"] = transition;
/* harmony export (immutable) */ __webpack_exports__["c"] = newId;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__attr__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__attrTween__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__delay__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__duration__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ease__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__filter__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__merge__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__on__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__remove__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__select__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__selectAll__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__selection__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__style__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styleTween__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__text__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__transition__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__tween__ = __webpack_require__(43);



















var id = 0;

function Transition(groups, parents, name, id) {
  this._groups = groups;
  this._parents = parents;
  this._name = name;
  this._id = id;
}

function transition(name) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["m" /* selection */])().transition(name);
}

function newId() {
  return ++id;
}

var selection_prototype = __WEBPACK_IMPORTED_MODULE_0_d3_selection__["m" /* selection */].prototype;

Transition.prototype = transition.prototype = {
  constructor: Transition,
  select: __WEBPACK_IMPORTED_MODULE_10__select__["a" /* default */],
  selectAll: __WEBPACK_IMPORTED_MODULE_11__selectAll__["a" /* default */],
  filter: __WEBPACK_IMPORTED_MODULE_6__filter__["a" /* default */],
  merge: __WEBPACK_IMPORTED_MODULE_7__merge__["a" /* default */],
  selection: __WEBPACK_IMPORTED_MODULE_12__selection__["a" /* default */],
  transition: __WEBPACK_IMPORTED_MODULE_16__transition__["a" /* default */],
  call: selection_prototype.call,
  nodes: selection_prototype.nodes,
  node: selection_prototype.node,
  size: selection_prototype.size,
  empty: selection_prototype.empty,
  each: selection_prototype.each,
  on: __WEBPACK_IMPORTED_MODULE_8__on__["a" /* default */],
  attr: __WEBPACK_IMPORTED_MODULE_1__attr__["a" /* default */],
  attrTween: __WEBPACK_IMPORTED_MODULE_2__attrTween__["a" /* default */],
  style: __WEBPACK_IMPORTED_MODULE_13__style__["a" /* default */],
  styleTween: __WEBPACK_IMPORTED_MODULE_14__styleTween__["a" /* default */],
  text: __WEBPACK_IMPORTED_MODULE_15__text__["a" /* default */],
  remove: __WEBPACK_IMPORTED_MODULE_9__remove__["a" /* default */],
  tween: __WEBPACK_IMPORTED_MODULE_17__tween__["a" /* default */],
  delay: __WEBPACK_IMPORTED_MODULE_3__delay__["a" /* default */],
  duration: __WEBPACK_IMPORTED_MODULE_4__duration__["a" /* default */],
  ease: __WEBPACK_IMPORTED_MODULE_5__ease__["a" /* default */]
};


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = noop;
function noop() {}


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_dispatch__ = __webpack_require__(253);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_dispatch__["a"]; });



/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_path__ = __webpack_require__(343);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_path__["a"]; });



/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function streamGeometry(geometry, stream) {
  if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) {
    streamGeometryType[geometry.type](geometry, stream);
  }
}

var streamObjectType = {
  Feature: function(object, stream) {
    streamGeometry(object.geometry, stream);
  },
  FeatureCollection: function(object, stream) {
    var features = object.features, i = -1, n = features.length;
    while (++i < n) streamGeometry(features[i].geometry, stream);
  }
};

var streamGeometryType = {
  Sphere: function(object, stream) {
    stream.sphere();
  },
  Point: function(object, stream) {
    object = object.coordinates;
    stream.point(object[0], object[1], object[2]);
  },
  MultiPoint: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) object = coordinates[i], stream.point(object[0], object[1], object[2]);
  },
  LineString: function(object, stream) {
    streamLine(object.coordinates, stream, 0);
  },
  MultiLineString: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) streamLine(coordinates[i], stream, 0);
  },
  Polygon: function(object, stream) {
    streamPolygon(object.coordinates, stream);
  },
  MultiPolygon: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) streamPolygon(coordinates[i], stream);
  },
  GeometryCollection: function(object, stream) {
    var geometries = object.geometries, i = -1, n = geometries.length;
    while (++i < n) streamGeometry(geometries[i], stream);
  }
};

function streamLine(coordinates, stream, closed) {
  var i = -1, n = coordinates.length - closed, coordinate;
  stream.lineStart();
  while (++i < n) coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
  stream.lineEnd();
}

function streamPolygon(coordinates, stream) {
  var i = -1, n = coordinates.length;
  stream.polygonStart();
  while (++i < n) streamLine(coordinates[i], stream, 1);
  stream.polygonEnd();
}

/* harmony default export */ __webpack_exports__["a"] = (function(object, stream) {
  if (object && streamObjectType.hasOwnProperty(object.type)) {
    streamObjectType[object.type](object, stream);
  } else {
    streamGeometry(object, stream);
  }
});


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
var array = Array.prototype;

var map = array.map;
var slice = array.slice;


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function constant() {
    return x;
  };
});


/***/ }),
/* 19 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 20 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
});


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Adds floating point numbers with twice the normal precision.
// Reference: J. R. Shewchuk, Adaptive Precision Floating-Point Arithmetic and
// Fast Robust Geometric Predicates, Discrete & Computational Geometry 18(3)
// 305–363 (1997).
// Code adapted from GeographicLib by Charles F. F. Karney,
// http://geographiclib.sourceforge.net/

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return new Adder;
});

function Adder() {
  this.reset();
}

Adder.prototype = {
  constructor: Adder,
  reset: function() {
    this.s = // rounded value
    this.t = 0; // exact error
  },
  add: function(y) {
    add(temp, y, this.t);
    add(this, temp.s, this.s);
    if (this.s) this.t += temp.t;
    else this.s = temp.t;
  },
  valueOf: function() {
    return this.s;
  }
};

var temp = new Adder;

function add(adder, a, b) {
  var x = adder.s = a + b,
      bv = x - a,
      av = x - bv;
  adder.t = (a - av) + (b - bv);
}


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Math.random();
});


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(198)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x === null ? NaN : +x;
});


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = hue;
/* harmony export (immutable) */ __webpack_exports__["b"] = gamma;
/* harmony export (immutable) */ __webpack_exports__["a"] = nogamma;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(130);


function linear(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function hue(a, b) {
  var d = b - a;
  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear(a, d) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_nest__ = __webpack_require__(344);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__src_nest__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_set__ = __webpack_require__(345);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__src_set__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_map__ = __webpack_require__(72);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__src_map__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_keys__ = __webpack_require__(346);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__src_keys__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_values__ = __webpack_require__(347);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_4__src_values__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_entries__ = __webpack_require__(348);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__src_entries__["a"]; });








/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = spherical;
/* harmony export (immutable) */ __webpack_exports__["a"] = cartesian;
/* harmony export (immutable) */ __webpack_exports__["d"] = cartesianDot;
/* harmony export (immutable) */ __webpack_exports__["c"] = cartesianCross;
/* harmony export (immutable) */ __webpack_exports__["b"] = cartesianAddInPlace;
/* harmony export (immutable) */ __webpack_exports__["f"] = cartesianScale;
/* harmony export (immutable) */ __webpack_exports__["e"] = cartesianNormalizeInPlace;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);


function spherical(cartesian) {
  return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(cartesian[1], cartesian[0]), Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])(cartesian[2])];
}

function cartesian(spherical) {
  var lambda = spherical[0], phi = spherical[1], cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(phi);
  return [cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(lambda), cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(lambda), Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(phi)];
}

function cartesianDot(a, b) {
  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}

function cartesianCross(a, b) {
  return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
}

// TODO return a
function cartesianAddInPlace(a, b) {
  a[0] += b[0], a[1] += b[1], a[2] += b[2];
}

function cartesianScale(vector, k) {
  return [vector[0] * k, vector[1] * k, vector[2] * k];
}

// TODO return d
function cartesianNormalizeInPlace(d) {
  var l = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
  d[0] /= l, d[1] /= l, d[2] /= l;
}


/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = azimuthalRaw;
/* harmony export (immutable) */ __webpack_exports__["a"] = azimuthalInvert;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);


function azimuthalRaw(scale) {
  return function(x, y) {
    var cx = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(x),
        cy = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y),
        k = scale(cx * cy);
    return [
      k * cy * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(x),
      k * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y)
    ];
  }
}

function azimuthalInvert(angle) {
  return function(x, y) {
    var z = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(x * x + y * y),
        c = angle(z),
        sc = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(c),
        cc = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(c);
    return [
      Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(x * sc, z * cc),
      Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])(z && y * sc / z)
    ];
  }
}


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (x1 - x0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.y0 = y0, node.y1 = y1;
    node.x0 = x0, node.x1 = x0 += node.value * k;
  }
});


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = linearish;
/* harmony export (immutable) */ __webpack_exports__["a"] = linear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tickFormat__ = __webpack_require__(456);





function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function(count) {
    var d = domain();
    return Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["B" /* ticks */])(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function(count, specifier) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__tickFormat__["a" /* default */])(domain(), count, specifier);
  };

  scale.nice = function(count) {
    if (count == null) count = 10;

    var d = domain(),
        i0 = 0,
        i1 = d.length - 1,
        start = d[i0],
        stop = d[i1],
        step;

    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }

    step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["z" /* tickIncrement */])(start, stop, count);

    if (step > 0) {
      start = Math.floor(start / step) * step;
      stop = Math.ceil(stop / step) * step;
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["z" /* tickIncrement */])(start, stop, count);
    } else if (step < 0) {
      start = Math.ceil(start * step) / step;
      stop = Math.floor(stop * step) / step;
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["z" /* tickIncrement */])(start, stop, count);
    }

    if (step > 0) {
      d[i0] = Math.floor(start / step) * step;
      d[i1] = Math.ceil(stop / step) * step;
      domain(d);
    } else if (step < 0) {
      d[i0] = Math.ceil(start * step) / step;
      d[i1] = Math.floor(stop * step) / step;
      domain(d);
    }

    return scale;
  };

  return scale;
}

function linear() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_2__continuous__["c" /* deinterpolateLinear */], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["m" /* interpolateNumber */]);

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" /* copy */])(scale, linear());
  };

  return linearish(scale);
}


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(s) {
  return s.match(/.{6}/g).map(function(x) {
    return "#" + x;
  });
});


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return abs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return atan2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return cos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return max; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return min; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return sin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return sqrt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return epsilon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return pi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return halfPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return tau; });
/* harmony export (immutable) */ __webpack_exports__["b"] = acos;
/* harmony export (immutable) */ __webpack_exports__["c"] = asin;
var abs = Math.abs;
var atan2 = Math.atan2;
var cos = Math.cos;
var max = Math.max;
var min = Math.min;
var sin = Math.sin;
var sqrt = Math.sqrt;

var epsilon = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = 2 * pi;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}

function asin(x) {
  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}


/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
    s0 = s1, s1 = series[order[i]];
    for (j = 0; j < m; ++j) {
      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
  }
});


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  var n = series.length, o = new Array(n);
  while (--n >= 0) o[n] = n;
  return o;
});


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return epsilon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return epsilon2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return beaches; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return cells; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return circles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return edges; });
/* harmony export (immutable) */ __webpack_exports__["d"] = Diagram;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Beach__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Cell__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Circle__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Edge__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RedBlackTree__ = __webpack_require__(96);






var epsilon = 1e-6;
var epsilon2 = 1e-12;
var beaches;
var cells;
var circles;
var edges;

function triangleArea(a, b, c) {
  return (a[0] - c[0]) * (b[1] - a[1]) - (a[0] - b[0]) * (c[1] - a[1]);
}

function lexicographic(a, b) {
  return b[1] - a[1]
      || b[0] - a[0];
}

function Diagram(sites, extent) {
  var site = sites.sort(lexicographic).pop(),
      x,
      y,
      circle;

  edges = [];
  cells = new Array(sites.length);
  beaches = new __WEBPACK_IMPORTED_MODULE_4__RedBlackTree__["b" /* default */];
  circles = new __WEBPACK_IMPORTED_MODULE_4__RedBlackTree__["b" /* default */];

  while (true) {
    circle = __WEBPACK_IMPORTED_MODULE_2__Circle__["c" /* firstCircle */];
    if (site && (!circle || site[1] < circle.y || (site[1] === circle.y && site[0] < circle.x))) {
      if (site[0] !== x || site[1] !== y) {
        Object(__WEBPACK_IMPORTED_MODULE_0__Beach__["a" /* addBeach */])(site);
        x = site[0], y = site[1];
      }
      site = sites.pop();
    } else if (circle) {
      Object(__WEBPACK_IMPORTED_MODULE_0__Beach__["b" /* removeBeach */])(circle.arc);
    } else {
      break;
    }
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__Cell__["d" /* sortCellHalfedges */])();

  if (extent) {
    var x0 = +extent[0][0],
        y0 = +extent[0][1],
        x1 = +extent[1][0],
        y1 = +extent[1][1];
    Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["a" /* clipEdges */])(x0, y0, x1, y1);
    Object(__WEBPACK_IMPORTED_MODULE_1__Cell__["b" /* clipCells */])(x0, y0, x1, y1);
  }

  this.edges = edges;
  this.cells = cells;

  beaches =
  circles =
  edges =
  cells = null;
}

Diagram.prototype = {
  constructor: Diagram,

  polygons: function() {
    var edges = this.edges;

    return this.cells.map(function(cell) {
      var polygon = cell.halfedges.map(function(i) { return Object(__WEBPACK_IMPORTED_MODULE_1__Cell__["a" /* cellHalfedgeStart */])(cell, edges[i]); });
      polygon.data = cell.site.data;
      return polygon;
    });
  },

  triangles: function() {
    var triangles = [],
        edges = this.edges;

    this.cells.forEach(function(cell, i) {
      if (!(m = (halfedges = cell.halfedges).length)) return;
      var site = cell.site,
          halfedges,
          j = -1,
          m,
          s0,
          e1 = edges[halfedges[m - 1]],
          s1 = e1.left === site ? e1.right : e1.left;

      while (++j < m) {
        s0 = s1;
        e1 = edges[halfedges[j]];
        s1 = e1.left === site ? e1.right : e1.left;
        if (s0 && s1 && i < s0.index && i < s1.index && triangleArea(site, s0, s1) < 0) {
          triangles.push([site.data, s0.data, s1.data]);
        }
      }
    });

    return triangles;
  },

  links: function() {
    return this.edges.filter(function(edge) {
      return edge.right;
    }).map(function(edge) {
      return {
        source: edge.left.data,
        target: edge.right.data
      };
    });
  },

  find: function(x, y, radius) {
    var that = this, i0, i1 = that._found || 0, n = that.cells.length, cell;

    // Use the previously-found cell, or start with an arbitrary one.
    while (!(cell = that.cells[i1])) if (++i1 >= n) return null;
    var dx = x - cell.site[0], dy = y - cell.site[1], d2 = dx * dx + dy * dy;

    // Traverse the half-edges to find a closer cell, if any.
    do {
      cell = that.cells[i0 = i1], i1 = null;
      cell.halfedges.forEach(function(e) {
        var edge = that.edges[e], v = edge.left;
        if ((v === cell.site || !v) && !(v = edge.right)) return;
        var vx = x - v[0], vy = y - v[1], v2 = vx * vx + vy * vy;
        if (v2 < d2) d2 = v2, i1 = v.index;
      });
    } while (i1 !== null);

    that._found = i0;

    return radius == null || d2 <= radius * radius ? cell.site : null;
  }
}


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["__extends"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["__rest"] = __rest;
/* harmony export (immutable) */ __webpack_exports__["__decorate"] = __decorate;
/* harmony export (immutable) */ __webpack_exports__["__param"] = __param;
/* harmony export (immutable) */ __webpack_exports__["__metadata"] = __metadata;
/* harmony export (immutable) */ __webpack_exports__["__awaiter"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["__generator"] = __generator;
/* harmony export (immutable) */ __webpack_exports__["__createBinding"] = __createBinding;
/* harmony export (immutable) */ __webpack_exports__["__exportStar"] = __exportStar;
/* harmony export (immutable) */ __webpack_exports__["__values"] = __values;
/* harmony export (immutable) */ __webpack_exports__["__read"] = __read;
/* harmony export (immutable) */ __webpack_exports__["__spread"] = __spread;
/* harmony export (immutable) */ __webpack_exports__["__spreadArrays"] = __spreadArrays;
/* harmony export (immutable) */ __webpack_exports__["__await"] = __await;
/* harmony export (immutable) */ __webpack_exports__["__asyncGenerator"] = __asyncGenerator;
/* harmony export (immutable) */ __webpack_exports__["__asyncDelegator"] = __asyncDelegator;
/* harmony export (immutable) */ __webpack_exports__["__asyncValues"] = __asyncValues;
/* harmony export (immutable) */ __webpack_exports__["__makeTemplateObject"] = __makeTemplateObject;
/* harmony export (immutable) */ __webpack_exports__["__importStar"] = __importStar;
/* harmony export (immutable) */ __webpack_exports__["__importDefault"] = __importDefault;
/* harmony export (immutable) */ __webpack_exports__["__classPrivateFieldGet"] = __classPrivateFieldGet;
/* harmony export (immutable) */ __webpack_exports__["__classPrivateFieldSet"] = __classPrivateFieldSet;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__namespace__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__namespaces__ = __webpack_require__(61);



function creatorInherit(name) {
  return function() {
    var document = this.ownerDocument,
        uri = this.namespaceURI;
    return uri === __WEBPACK_IMPORTED_MODULE_1__namespaces__["b" /* xhtml */] && document.documentElement.namespaceURI === __WEBPACK_IMPORTED_MODULE_1__namespaces__["b" /* xhtml */]
        ? document.createElement(name)
        : document.createElementNS(uri, name);
  };
}

function creatorFixed(fullname) {
  return function() {
    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var fullname = Object(__WEBPACK_IMPORTED_MODULE_0__namespace__["a" /* default */])(name);
  return (fullname.local
      ? creatorFixed
      : creatorInherit)(fullname);
});


/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(node, event) {
  var svg = node.ownerSVGElement || node;

  if (svg.createSVGPoint) {
    var point = svg.createSVGPoint();
    point.x = event.clientX, point.y = event.clientY;
    point = point.matrixTransform(node.getScreenCTM().inverse());
    return [point.x, point.y];
  }

  var rect = node.getBoundingClientRect();
  return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
});


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return a + b * t;
  };
});


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_timer__ = __webpack_require__(71);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_timer__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__src_timer__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__src_timer__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_timeout__ = __webpack_require__(305);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__src_timeout__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_interval__ = __webpack_require__(306);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__src_interval__["a"]; });







/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = tweenValue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(8);


function tweenRemove(id, name) {
  var tween0, tween1;
  return function() {
    var schedule = Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = tween0 = tween;
      for (var i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1 = tween1.slice();
          tween1.splice(i, 1);
          break;
        }
      }
    }

    schedule.tween = tween1;
  };
}

function tweenFunction(id, name, value) {
  var tween0, tween1;
  if (typeof value !== "function") throw new Error;
  return function() {
    var schedule = Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = (tween0 = tween).slice();
      for (var t = {name: name, value: value}, i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1[i] = t;
          break;
        }
      }
      if (i === n) tween1.push(t);
    }

    schedule.tween = tween1;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var id = this._id;

  name += "";

  if (arguments.length < 2) {
    var tween = Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).tween;
    for (var i = 0, n = tween.length, t; i < n; ++i) {
      if ((t = tween[i]).name === name) {
        return t.value;
      }
    }
    return null;
  }

  return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
});

function tweenValue(transition, name, value) {
  var id = transition._id;

  transition.each(function() {
    var schedule = Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id);
    (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
  });

  return function(node) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(node, id).value[name];
  };
}


/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(79);


/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(Math.abs(x)), x ? x[1] : NaN;
});


/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = rotateRadians;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(0);



function rotationIdentity(lambda, phi) {
  return [lambda > __WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */] ? lambda - __WEBPACK_IMPORTED_MODULE_1__math__["w" /* tau */] : lambda < -__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */] ? lambda + __WEBPACK_IMPORTED_MODULE_1__math__["w" /* tau */] : lambda, phi];
}

rotationIdentity.invert = rotationIdentity;

function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
  return (deltaLambda %= __WEBPACK_IMPORTED_MODULE_1__math__["w" /* tau */]) ? (deltaPhi || deltaGamma ? Object(__WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */])(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma))
    : rotationLambda(deltaLambda))
    : (deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma)
    : rotationIdentity);
}

function forwardRotationLambda(deltaLambda) {
  return function(lambda, phi) {
    return lambda += deltaLambda, [lambda > __WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */] ? lambda - __WEBPACK_IMPORTED_MODULE_1__math__["w" /* tau */] : lambda < -__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */] ? lambda + __WEBPACK_IMPORTED_MODULE_1__math__["w" /* tau */] : lambda, phi];
  };
}

function rotationLambda(deltaLambda) {
  var rotation = forwardRotationLambda(deltaLambda);
  rotation.invert = forwardRotationLambda(-deltaLambda);
  return rotation;
}

function rotationPhiGamma(deltaPhi, deltaGamma) {
  var cosDeltaPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(deltaPhi),
      sinDeltaPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(deltaPhi),
      cosDeltaGamma = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(deltaGamma),
      sinDeltaGamma = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(deltaGamma);

  function rotation(lambda, phi) {
    var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi),
        x = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(lambda) * cosPhi,
        y = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(lambda) * cosPhi,
        z = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi),
        k = z * cosDeltaPhi + x * sinDeltaPhi;
    return [
      Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
      Object(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* asin */])(k * cosDeltaGamma + y * sinDeltaGamma)
    ];
  }

  rotation.invert = function(lambda, phi) {
    var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi),
        x = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(lambda) * cosPhi,
        y = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(lambda) * cosPhi,
        z = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi),
        k = z * cosDeltaGamma - y * sinDeltaGamma;
    return [
      Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
      Object(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* asin */])(k * cosDeltaPhi - x * sinDeltaPhi)
    ];
  };

  return rotation;
}

/* harmony default export */ __webpack_exports__["a"] = (function(rotate) {
  rotate = rotateRadians(rotate[0] * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], rotate[1] * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], rotate.length > 2 ? rotate[2] * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */] : 0);

  function forward(coordinates) {
    coordinates = rotate(coordinates[0] * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], coordinates[1] * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */]);
    return coordinates[0] *= __WEBPACK_IMPORTED_MODULE_1__math__["h" /* degrees */], coordinates[1] *= __WEBPACK_IMPORTED_MODULE_1__math__["h" /* degrees */], coordinates;
  }

  forward.invert = function(coordinates) {
    coordinates = rotate.invert(coordinates[0] * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], coordinates[1] * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */]);
    return coordinates[0] *= __WEBPACK_IMPORTED_MODULE_1__math__["h" /* degrees */], coordinates[1] *= __WEBPACK_IMPORTED_MODULE_1__math__["h" /* degrees */], coordinates;
  };

  return forward;
});


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = clipRectangle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buffer__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__line__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rejoin__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_array__ = __webpack_require__(4);






var clipMax = 1e9, clipMin = -clipMax;

// TODO Use d3-polygon’s polygonContains here for the ring check?
// TODO Eliminate duplicate buffering in clipBuffer and polygon.push?

function clipRectangle(x0, y0, x1, y1) {

  function visible(x, y) {
    return x0 <= x && x <= x1 && y0 <= y && y <= y1;
  }

  function interpolate(from, to, direction, stream) {
    var a = 0, a1 = 0;
    if (from == null
        || (a = corner(from, direction)) !== (a1 = corner(to, direction))
        || comparePoint(from, to) < 0 ^ direction > 0) {
      do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
      while ((a = (a + direction + 4) % 4) !== a1);
    } else {
      stream.point(to[0], to[1]);
    }
  }

  function corner(p, direction) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(p[0] - x0) < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */] ? direction > 0 ? 0 : 3
        : Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(p[0] - x1) < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */] ? direction > 0 ? 2 : 1
        : Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(p[1] - y0) < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */] ? direction > 0 ? 1 : 0
        : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
  }

  function compareIntersection(a, b) {
    return comparePoint(a.x, b.x);
  }

  function comparePoint(a, b) {
    var ca = corner(a, 1),
        cb = corner(b, 1);
    return ca !== cb ? ca - cb
        : ca === 0 ? b[1] - a[1]
        : ca === 1 ? a[0] - b[0]
        : ca === 2 ? a[1] - b[1]
        : b[0] - a[0];
  }

  return function(stream) {
    var activeStream = stream,
        bufferStream = Object(__WEBPACK_IMPORTED_MODULE_1__buffer__["a" /* default */])(),
        segments,
        polygon,
        ring,
        x__, y__, v__, // first point
        x_, y_, v_, // previous point
        first,
        clean;

    var clipStream = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: polygonStart,
      polygonEnd: polygonEnd
    };

    function point(x, y) {
      if (visible(x, y)) activeStream.point(x, y);
    }

    function polygonInside() {
      var winding = 0;

      for (var i = 0, n = polygon.length; i < n; ++i) {
        for (var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j) {
          a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
          if (a1 <= y1) { if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding; }
          else { if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding; }
        }
      }

      return winding;
    }

    // Buffer geometry within a polygon and then clip it en masse.
    function polygonStart() {
      activeStream = bufferStream, segments = [], polygon = [], clean = true;
    }

    function polygonEnd() {
      var startInside = polygonInside(),
          cleanInside = clean && startInside,
          visible = (segments = Object(__WEBPACK_IMPORTED_MODULE_4_d3_array__["n" /* merge */])(segments)).length;
      if (cleanInside || visible) {
        stream.polygonStart();
        if (cleanInside) {
          stream.lineStart();
          interpolate(null, null, 1, stream);
          stream.lineEnd();
        }
        if (visible) {
          Object(__WEBPACK_IMPORTED_MODULE_3__rejoin__["a" /* default */])(segments, compareIntersection, startInside, interpolate, stream);
        }
        stream.polygonEnd();
      }
      activeStream = stream, segments = polygon = ring = null;
    }

    function lineStart() {
      clipStream.point = linePoint;
      if (polygon) polygon.push(ring = []);
      first = true;
      v_ = false;
      x_ = y_ = NaN;
    }

    // TODO rather than special-case polygons, simply handle them separately.
    // Ideally, coincident intersection points should be jittered to avoid
    // clipping issues.
    function lineEnd() {
      if (segments) {
        linePoint(x__, y__);
        if (v__ && v_) bufferStream.rejoin();
        segments.push(bufferStream.result());
      }
      clipStream.point = point;
      if (v_) activeStream.lineEnd();
    }

    function linePoint(x, y) {
      var v = visible(x, y);
      if (polygon) ring.push([x, y]);
      if (first) {
        x__ = x, y__ = y, v__ = v;
        first = false;
        if (v) {
          activeStream.lineStart();
          activeStream.point(x, y);
        }
      } else {
        if (v && v_) activeStream.point(x, y);
        else {
          var a = [x_ = Math.max(clipMin, Math.min(clipMax, x_)), y_ = Math.max(clipMin, Math.min(clipMax, y_))],
              b = [x = Math.max(clipMin, Math.min(clipMax, x)), y = Math.max(clipMin, Math.min(clipMax, y))];
          if (Object(__WEBPACK_IMPORTED_MODULE_2__line__["a" /* default */])(a, b, x0, y0, x1, y1)) {
            if (!v_) {
              activeStream.lineStart();
              activeStream.point(a[0], a[1]);
            }
            activeStream.point(b[0], b[1]);
            if (!v) activeStream.lineEnd();
            clean = false;
          } else if (v) {
            activeStream.lineStart();
            activeStream.point(x, y);
            clean = false;
          }
        }
      }
      x_ = x, y_ = y, v_ = v;
    }

    return clipStream;
  };
}


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = transformer;
/* harmony default export */ __webpack_exports__["a"] = (function(methods) {
  return {
    stream: transformer(methods)
  };
});

function transformer(methods) {
  return function(stream) {
    var s = new TransformStream;
    for (var key in methods) s[key] = methods[key];
    s.stream = stream;
    return s;
  };
}

function TransformStream() {}

TransformStream.prototype = {
  constructor: TransformStream,
  point: function(x, y) { this.stream.point(x, y); },
  sphere: function() { this.stream.sphere(); },
  lineStart: function() { this.stream.lineStart(); },
  lineEnd: function() { this.stream.lineEnd(); },
  polygonStart: function() { this.stream.polygonStart(); },
  polygonEnd: function() { this.stream.polygonEnd(); }
};


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (y1 - y0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.x0 = x0, node.x1 = x1;
    node.y0 = y0, node.y1 = y0 += node.value * k;
  }
});


/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__request__ = __webpack_require__(88);


/* harmony default export */ __webpack_exports__["a"] = (function(defaultMimeType, response) {
  return function(url, callback) {
    var r = Object(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])(url).mimeType(defaultMimeType).response(response);
    if (callback != null) {
      if (typeof callback !== "function") throw new Error("invalid callback: " + callback);
      return r.get(callback);
    }
    return r;
  };
});


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = deinterpolateLinear;
/* harmony export (immutable) */ __webpack_exports__["a"] = copy;
/* harmony export (immutable) */ __webpack_exports__["b"] = continuous;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(167);






var unit = [0, 1];

function deinterpolateLinear(a, b) {
  return (b -= (a = +a))
      ? function(x) { return (x - a) / b; }
      : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(b);
}

function deinterpolateClamp(deinterpolate) {
  return function(a, b) {
    var d = deinterpolate(a = +a, b = +b);
    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
  };
}

function reinterpolateClamp(reinterpolate) {
  return function(a, b) {
    var r = reinterpolate(a = +a, b = +b);
    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
  };
}

function bimap(domain, range, deinterpolate, reinterpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
  return function(x) { return r0(d0(x)); };
}

function polymap(domain, range, deinterpolate, reinterpolate) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }

  while (++i < j) {
    d[i] = deinterpolate(domain[i], domain[i + 1]);
    r[i] = reinterpolate(range[i], range[i + 1]);
  }

  return function(x) {
    var i = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy(source, target) {
  return target
      .domain(source.domain())
      .range(source.range())
      .interpolate(source.interpolate())
      .clamp(source.clamp());
}

// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
function continuous(deinterpolate, reinterpolate) {
  var domain = unit,
      range = unit,
      interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["a" /* interpolate */],
      clamp = false,
      piecewise,
      output,
      input;

  function rescale() {
    piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return (output || (output = piecewise(domain, range, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate)))(+x);
  }

  scale.invert = function(y) {
    return (input || (input = piecewise(range, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
  };

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_2__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]), rescale()) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["r" /* interpolateRound */], rescale();
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, rescale()) : clamp;
  };

  scale.interpolate = function(_) {
    return arguments.length ? (interpolate = _, rescale()) : interpolate;
  };

  return rescale();
}


/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_interval__ = __webpack_require__(3);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__src_interval__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_millisecond__ = __webpack_require__(462);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__src_millisecond__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_1__src_millisecond__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_1__src_millisecond__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_1__src_millisecond__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_second__ = __webpack_require__(463);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_2__src_second__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_2__src_second__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_2__src_second__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_2__src_second__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_minute__ = __webpack_require__(464);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_3__src_minute__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_3__src_minute__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_hour__ = __webpack_require__(465);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__src_hour__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_4__src_hour__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_day__ = __webpack_require__(466);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__src_day__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__src_day__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_week__ = __webpack_require__(467);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["n"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_month__ = __webpack_require__(468);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_7__src_month__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_7__src_month__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_year__ = __webpack_require__(469);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_8__src_year__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_8__src_year__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_utcMinute__ = __webpack_require__(470);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_9__src_utcMinute__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_9__src_utcMinute__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_utcHour__ = __webpack_require__(471);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_10__src_utcHour__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_10__src_utcHour__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_utcDay__ = __webpack_require__(472);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_11__src_utcDay__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_11__src_utcDay__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__ = __webpack_require__(473);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["n"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_utcMonth__ = __webpack_require__(474);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_13__src_utcMonth__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_13__src_utcMonth__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_utcYear__ = __webpack_require__(475);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return __WEBPACK_IMPORTED_MODULE_14__src_utcYear__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return __WEBPACK_IMPORTED_MODULE_14__src_utcYear__["b"]; });































/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function Linear(context) {
  this._context = context;
}

Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: this._context.lineTo(x, y); break;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Linear(context);
});


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {});


/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = point;
/* harmony export (immutable) */ __webpack_exports__["a"] = Basis;
function point(that, x, y) {
  that._context.bezierCurveTo(
    (2 * that._x0 + that._x1) / 3,
    (2 * that._y0 + that._y1) / 3,
    (that._x0 + 2 * that._x1) / 3,
    (that._y0 + 2 * that._y1) / 3,
    (that._x0 + 4 * that._x1 + x) / 6,
    (that._y0 + 4 * that._y1 + y) / 6
  );
}

function Basis(context) {
  this._context = context;
}

Basis.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3: point(this, this._x1, this._y1); // proceed
      case 2: this._context.lineTo(this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
      default: point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["b"] = (function(context) {
  return new Basis(context);
});


/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = point;
/* harmony export (immutable) */ __webpack_exports__["a"] = Cardinal;
function point(that, x, y) {
  that._context.bezierCurveTo(
    that._x1 + that._k * (that._x2 - that._x0),
    that._y1 + that._k * (that._y2 - that._y0),
    that._x2 + that._k * (that._x1 - x),
    that._y2 + that._k * (that._y1 - y),
    that._x2,
    that._y2
  );
}

function Cardinal(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

Cardinal.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: point(this, this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
      case 2: this._point = 3; // proceed
      default: point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["b"] = ((function custom(tension) {

  function cardinal(context) {
    return new Cardinal(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = __webpack_require__(38);

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */
var CONSTANTS = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */
    NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */
    NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */
    SDK_VERSION: '${JSCORE_VERSION}'
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Throws an error if the provided assertion is falsy
 */
var assert = function (assertion, message) {
    if (!assertion) {
        throw assertionError(message);
    }
};
/**
 * Returns an Error object suitable for throwing.
 */
var assertionError = function (message) {
    return new Error('Firebase Database (' +
        CONSTANTS.SDK_VERSION +
        ') INTERNAL ASSERT FAILED: ' +
        message);
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var stringToByteArray = function (str) {
    // TODO(user): Use native implementations if/when available
    var out = [];
    var p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if ((c & 0xfc00) === 0xd800 &&
            i + 1 < str.length &&
            (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */
var byteArrayToString = function (bytes) {
    // TODO(user): Use native implementations if/when available
    var out = [];
    var pos = 0, c = 0;
    while (pos < bytes.length) {
        var c1 = bytes[pos++];
        if (c1 < 128) {
            out[c++] = String.fromCharCode(c1);
        }
        else if (c1 > 191 && c1 < 224) {
            var c2 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 31) << 6) | (c2 & 63));
        }
        else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            var c2 = bytes[pos++];
            var c3 = bytes[pos++];
            var c4 = bytes[pos++];
            var u = (((c1 & 7) << 18) | ((c2 & 63) << 12) | ((c3 & 63) << 6) | (c4 & 63)) -
                0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        }
        else {
            var c2 = bytes[pos++];
            var c3 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
        }
    }
    return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
var base64 = {
    /**
     * Maps bytes to characters.
     */
    byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */
    charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */
    byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */
    charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */
    ENCODED_VALS_BASE: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz' + '0123456789',
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */
    get ENCODED_VALS() {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     */
    get ENCODED_VALS_WEBSAFE() {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */
    HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */
    encodeByteArray: function (input, webSafe) {
        if (!Array.isArray(input)) {
            throw Error('encodeByteArray takes an array as a parameter');
        }
        this.init_();
        var byteToCharMap = webSafe
            ? this.byteToCharMapWebSafe_
            : this.byteToCharMap_;
        var output = [];
        for (var i = 0; i < input.length; i += 3) {
            var byte1 = input[i];
            var haveByte2 = i + 1 < input.length;
            var byte2 = haveByte2 ? input[i + 1] : 0;
            var haveByte3 = i + 2 < input.length;
            var byte3 = haveByte3 ? input[i + 2] : 0;
            var outByte1 = byte1 >> 2;
            var outByte2 = ((byte1 & 0x03) << 4) | (byte2 >> 4);
            var outByte3 = ((byte2 & 0x0f) << 2) | (byte3 >> 6);
            var outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) {
                    outByte3 = 64;
                }
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */
    encodeString: function (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) {
            return btoa(input);
        }
        return this.encodeByteArray(stringToByteArray(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */
    decodeString: function (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) {
            return atob(input);
        }
        return byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */
    decodeStringToByteArray: function (input, webSafe) {
        this.init_();
        var charToByteMap = webSafe
            ? this.charToByteMapWebSafe_
            : this.charToByteMap_;
        var output = [];
        for (var i = 0; i < input.length;) {
            var byte1 = charToByteMap[input.charAt(i++)];
            var haveByte2 = i < input.length;
            var byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            var haveByte3 = i < input.length;
            var byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            var haveByte4 = i < input.length;
            var byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) {
                throw Error();
            }
            var outByte1 = (byte1 << 2) | (byte2 >> 4);
            output.push(outByte1);
            if (byte3 !== 64) {
                var outByte2 = ((byte2 << 4) & 0xf0) | (byte3 >> 2);
                output.push(outByte2);
                if (byte4 !== 64) {
                    var outByte3 = ((byte3 << 6) & 0xc0) | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */
    init_: function () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for (var i = 0; i < this.ENCODED_VALS.length; i++) {
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * URL-safe base64 encoding
 */
var base64Encode = function (str) {
    var utf8Bytes = stringToByteArray(str);
    return base64.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */
var base64Decode = function (str) {
    try {
        return base64.decodeString(str, true);
    }
    catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */
function deepCopy(value) {
    return deepExtend(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 */
function deepExtend(target, source) {
    if (!(source instanceof Object)) {
        return source;
    }
    switch (source.constructor) {
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            var dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) {
                target = {};
            }
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for (var prop in source) {
        if (!source.hasOwnProperty(prop)) {
            continue;
        }
        target[prop] = deepExtend(target[prop], source[prop]);
    }
    return target;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Deferred = /** @class */ (function () {
    function Deferred() {
        var _this = this;
        this.reject = function () { };
        this.resolve = function () { };
        this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */
    Deferred.prototype.wrapCallback = function (callback) {
        var _this = this;
        return function (error, value) {
            if (error) {
                _this.reject(error);
            }
            else {
                _this.resolve(value);
            }
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                _this.promise.catch(function () { });
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) {
                    callback(error);
                }
                else {
                    callback(error, value);
                }
            }
        };
    };
    return Deferred;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */
function getUA() {
    if (typeof navigator !== 'undefined' &&
        typeof navigator['userAgent'] === 'string') {
        return navigator['userAgent'];
    }
    else {
        return '';
    }
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */
function isMobileCordova() {
    return (typeof window !== 'undefined' &&
        // @ts-ignore Setting up an broadly applicable index signature for Window
        // just to deal with this case would probably be a bad idea.
        !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) &&
        /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(getUA()));
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected.
 */
// Node detection logic from: https://github.com/iliakan/detect-node/
function isNode() {
    try {
        return (Object.prototype.toString.call(global.process) === '[object process]');
    }
    catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */
function isBrowser() {
    return typeof self === 'object' && self.self === self;
}
function isBrowserExtension() {
    var runtime = typeof chrome === 'object'
        ? chrome.runtime
        : typeof browser === 'object'
            ? browser.runtime
            : undefined;
    return typeof runtime === 'object' && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */
function isReactNative() {
    return (typeof navigator === 'object' && navigator['product'] === 'ReactNative');
}
/** Detects Electron apps. */
function isElectron() {
    return getUA().indexOf('Electron/') >= 0;
}
/** Detects Internet Explorer. */
function isIE() {
    var ua = getUA();
    return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
}
/** Detects Universal Windows Platform apps. */
function isUWP() {
    return getUA().indexOf('MSAppHost/') >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */
function isNodeSdk() {
    return CONSTANTS.NODE_CLIENT === true || CONSTANTS.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */
function isSafari() {
    return (!isNode() &&
        navigator.userAgent.includes('Safari') &&
        !navigator.userAgent.includes('Chrome'));
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */
function isIndexedDBAvailable() {
    return 'indexedDB' in self && indexedDB != null;
}
/**
 * This method validates browser context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 */
function validateIndexedDBOpenable() {
    return new Promise(function (resolve, reject) {
        try {
            var preExist_1 = true;
            var DB_CHECK_NAME_1 = 'validate-browser-context-for-indexeddb-analytics-module';
            var request_1 = window.indexedDB.open(DB_CHECK_NAME_1);
            request_1.onsuccess = function () {
                request_1.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist_1) {
                    window.indexedDB.deleteDatabase(DB_CHECK_NAME_1);
                }
                resolve(true);
            };
            request_1.onupgradeneeded = function () {
                preExist_1 = false;
            };
            request_1.onerror = function () {
                var _a;
                reject(((_a = request_1.error) === null || _a === void 0 ? void 0 : _a.message) || '');
            };
        }
        catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */
function areCookiesEnabled() {
    if (!navigator || !navigator.cookieEnabled) {
        return false;
    }
    return true;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
var FirebaseError = /** @class */ (function (_super) {
    tslib.__extends(FirebaseError, _super);
    function FirebaseError(code, message) {
        var _this = _super.call(this, message) || this;
        _this.code = code;
        _this.name = ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, FirebaseError.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, ErrorFactory.prototype.create);
        }
        return _this;
    }
    return FirebaseError;
}(Error));
var ErrorFactory = /** @class */ (function () {
    function ErrorFactory(service, serviceName, errors) {
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    ErrorFactory.prototype.create = function (code) {
        var data = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            data[_i - 1] = arguments[_i];
        }
        var customData = data[0] || {};
        var fullCode = this.service + "/" + code;
        var template = this.errors[code];
        var message = template ? replaceTemplate(template, customData) : 'Error';
        // Service Name: Error message (service/code).
        var fullMessage = this.serviceName + ": " + message + " (" + fullCode + ").";
        var error = new FirebaseError(fullCode, fullMessage);
        // Keys with an underscore at the end of their name are not included in
        // error.data for some reason.
        // TODO: Replace with Object.entries when lib is updated to es2017.
        for (var _a = 0, _b = Object.keys(customData); _a < _b.length; _a++) {
            var key = _b[_a];
            if (key.slice(-1) !== '_') {
                if (key in error) {
                    console.warn("Overwriting FirebaseError base field \"" + key + "\" can cause unexpected behavior.");
                }
                error[key] = customData[key];
            }
        }
        return error;
    };
    return ErrorFactory;
}());
function replaceTemplate(template, data) {
    return template.replace(PATTERN, function (_, key) {
        var value = data[key];
        return value != null ? String(value) : "<" + key + "?>";
    });
}
var PATTERN = /\{\$([^}]+)}/g;

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */
function jsonEval(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */
function stringify(data) {
    return JSON.stringify(data);
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
var decode = function (token) {
    var header = {}, claims = {}, data = {}, signature = '';
    try {
        var parts = token.split('.');
        header = jsonEval(base64Decode(parts[0]) || '');
        claims = jsonEval(base64Decode(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    }
    catch (e) { }
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
var isValidTimestamp = function (token) {
    var claims = decode(token).claims;
    var now = Math.floor(new Date().getTime() / 1000);
    var validSince = 0, validUntil = 0;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) {
            validSince = claims['nbf'];
        }
        else if (claims.hasOwnProperty('iat')) {
            validSince = claims['iat'];
        }
        if (claims.hasOwnProperty('exp')) {
            validUntil = claims['exp'];
        }
        else {
            // token will expire after 24h by default
            validUntil = validSince + 86400;
        }
    }
    return (!!now &&
        !!validSince &&
        !!validUntil &&
        now >= validSince &&
        now <= validUntil);
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
var issuedAtTime = function (token) {
    var claims = decode(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) {
        return claims['iat'];
    }
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
var isValidFormat = function (token) {
    var decoded = decode(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
var isAdmin = function (token) {
    var claims = decode(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function contains(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function safeGet(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
        return obj[key];
    }
    else {
        return undefined;
    }
}
function isEmpty(obj) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            return false;
        }
    }
    return true;
}
function map(obj, fn, contextObj) {
    var res = {};
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            res[key] = fn.call(contextObj, obj[key], key, obj);
        }
    }
    return res;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */
function querystring(querystringParams) {
    var params = [];
    var _loop_1 = function (key, value) {
        if (Array.isArray(value)) {
            value.forEach(function (arrayVal) {
                params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
            });
        }
        else {
            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
        }
    };
    for (var _i = 0, _a = Object.entries(querystringParams); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        _loop_1(key, value);
    }
    return params.length ? '&' + params.join('&') : '';
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */
function querystringDecode(querystring) {
    var obj = {};
    var tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach(function (token) {
        if (token) {
            var key = token.split('=');
            obj[key[0]] = key[1];
        }
    });
    return obj;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */
/**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */
var Sha1 = /** @class */ (function () {
    function Sha1() {
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */
        this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */
        this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */
        this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */
        this.pad_ = [];
        /**
         * @private {number}
         */
        this.inbuf_ = 0;
        /**
         * @private {number}
         */
        this.total_ = 0;
        this.blockSize = 512 / 8;
        this.pad_[0] = 128;
        for (var i = 1; i < this.blockSize; ++i) {
            this.pad_[i] = 0;
        }
        this.reset();
    }
    Sha1.prototype.reset = function () {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    };
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */
    Sha1.prototype.compress_ = function (buf, offset) {
        if (!offset) {
            offset = 0;
        }
        var W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') {
            for (var i = 0; i < 16; i++) {
                // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
                // have a bug that turns the post-increment ++ operator into pre-increment
                // during JIT compilation.  We have code that depends heavily on SHA-1 for
                // correctness and which is affected by this bug, so I've removed all uses
                // of post-increment ++ in which the result value is used.  We can revert
                // this change once the Safari bug
                // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
                // most clients have been updated.
                W[i] =
                    (buf.charCodeAt(offset) << 24) |
                        (buf.charCodeAt(offset + 1) << 16) |
                        (buf.charCodeAt(offset + 2) << 8) |
                        buf.charCodeAt(offset + 3);
                offset += 4;
            }
        }
        else {
            for (var i = 0; i < 16; i++) {
                W[i] =
                    (buf[offset] << 24) |
                        (buf[offset + 1] << 16) |
                        (buf[offset + 2] << 8) |
                        buf[offset + 3];
                offset += 4;
            }
        }
        // expand to 80 words
        for (var i = 16; i < 80; i++) {
            var t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = ((t << 1) | (t >>> 31)) & 0xffffffff;
        }
        var a = this.chain_[0];
        var b = this.chain_[1];
        var c = this.chain_[2];
        var d = this.chain_[3];
        var e = this.chain_[4];
        var f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for (var i = 0; i < 80; i++) {
            if (i < 40) {
                if (i < 20) {
                    f = d ^ (b & (c ^ d));
                    k = 0x5a827999;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            }
            else {
                if (i < 60) {
                    f = (b & c) | (d & (b | c));
                    k = 0x8f1bbcdc;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0xca62c1d6;
                }
            }
            var t = (((a << 5) | (a >>> 27)) + f + e + k + W[i]) & 0xffffffff;
            e = d;
            d = c;
            c = ((b << 30) | (b >>> 2)) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = (this.chain_[0] + a) & 0xffffffff;
        this.chain_[1] = (this.chain_[1] + b) & 0xffffffff;
        this.chain_[2] = (this.chain_[2] + c) & 0xffffffff;
        this.chain_[3] = (this.chain_[3] + d) & 0xffffffff;
        this.chain_[4] = (this.chain_[4] + e) & 0xffffffff;
    };
    Sha1.prototype.update = function (bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) {
            return;
        }
        if (length === undefined) {
            length = bytes.length;
        }
        var lengthMinusBlock = length - this.blockSize;
        var n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        var buf = this.buf_;
        var inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while (n < length) {
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) {
                while (n <= lengthMinusBlock) {
                    this.compress_(bytes, n);
                    n += this.blockSize;
                }
            }
            if (typeof bytes === 'string') {
                while (n < length) {
                    buf[inbuf] = bytes.charCodeAt(n);
                    ++inbuf;
                    ++n;
                    if (inbuf === this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
            else {
                while (n < length) {
                    buf[inbuf] = bytes[n];
                    ++inbuf;
                    ++n;
                    if (inbuf === this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    };
    /** @override */
    Sha1.prototype.digest = function () {
        var digest = [];
        var totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) {
            this.update(this.pad_, 56 - this.inbuf_);
        }
        else {
            this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        }
        // Add # bits.
        for (var i = this.blockSize - 1; i >= 56; i--) {
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        var n = 0;
        for (var i = 0; i < 5; i++) {
            for (var j = 24; j >= 0; j -= 8) {
                digest[n] = (this.chain_[i] >> j) & 255;
                ++n;
            }
        }
        return digest;
    };
    return Sha1;
}());

/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */
function createSubscribe(executor, onNoObservers) {
    var proxy = new ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */
var ObserverProxy = /** @class */ (function () {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */
    function ObserverProxy(executor, onNoObservers) {
        var _this = this;
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task
            .then(function () {
            executor(_this);
        })
            .catch(function (e) {
            _this.error(e);
        });
    }
    ObserverProxy.prototype.next = function (value) {
        this.forEachObserver(function (observer) {
            observer.next(value);
        });
    };
    ObserverProxy.prototype.error = function (error) {
        this.forEachObserver(function (observer) {
            observer.error(error);
        });
        this.close(error);
    };
    ObserverProxy.prototype.complete = function () {
        this.forEachObserver(function (observer) {
            observer.complete();
        });
        this.close();
    };
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */
    ObserverProxy.prototype.subscribe = function (nextOrObserver, error, complete) {
        var _this = this;
        var observer;
        if (nextOrObserver === undefined &&
            error === undefined &&
            complete === undefined) {
            throw new Error('Missing Observer.');
        }
        // Assemble an Observer object when passed as callback functions.
        if (implementsAnyMethods(nextOrObserver, [
            'next',
            'error',
            'complete'
        ])) {
            observer = nextOrObserver;
        }
        else {
            observer = {
                next: nextOrObserver,
                error: error,
                complete: complete
            };
        }
        if (observer.next === undefined) {
            observer.next = noop;
        }
        if (observer.error === undefined) {
            observer.error = noop;
        }
        if (observer.complete === undefined) {
            observer.complete = noop;
        }
        var unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.task.then(function () {
                try {
                    if (_this.finalError) {
                        observer.error(_this.finalError);
                    }
                    else {
                        observer.complete();
                    }
                }
                catch (e) {
                    // nothing
                }
                return;
            });
        }
        this.observers.push(observer);
        return unsub;
    };
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    ObserverProxy.prototype.unsubscribeOne = function (i) {
        if (this.observers === undefined || this.observers[i] === undefined) {
            return;
        }
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) {
            this.onNoObservers(this);
        }
    };
    ObserverProxy.prototype.forEachObserver = function (fn) {
        if (this.finalized) {
            // Already closed by previous event....just eat the additional values.
            return;
        }
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for (var i = 0; i < this.observers.length; i++) {
            this.sendOne(i, fn);
        }
    };
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    ObserverProxy.prototype.sendOne = function (i, fn) {
        var _this = this;
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(function () {
            if (_this.observers !== undefined && _this.observers[i] !== undefined) {
                try {
                    fn(_this.observers[i]);
                }
                catch (e) {
                    // Ignore exceptions raised in Observers or missing methods of an
                    // Observer.
                    // Log error to console. b/31404806
                    if (typeof console !== 'undefined' && console.error) {
                        console.error(e);
                    }
                }
            }
        });
    };
    ObserverProxy.prototype.close = function (err) {
        var _this = this;
        if (this.finalized) {
            return;
        }
        this.finalized = true;
        if (err !== undefined) {
            this.finalError = err;
        }
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(function () {
            _this.observers = undefined;
            _this.onNoObservers = undefined;
        });
    };
    return ObserverProxy;
}());
/** Turn synchronous function into one called asynchronously. */
// eslint-disable-next-line @typescript-eslint/ban-types
function async(fn, onError) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        Promise.resolve(true)
            .then(function () {
            fn.apply(void 0, args);
        })
            .catch(function (error) {
            if (onError) {
                onError(error);
            }
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */
function implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) {
        return false;
    }
    for (var _i = 0, methods_1 = methods; _i < methods_1.length; _i++) {
        var method = methods_1[_i];
        if (method in obj && typeof obj[method] === 'function') {
            return true;
        }
    }
    return false;
}
function noop() {
    // do nothing
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */
var validateArgCount = function (fnName, minCount, maxCount, argCount) {
    var argError;
    if (argCount < minCount) {
        argError = 'at least ' + minCount;
    }
    else if (argCount > maxCount) {
        argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    }
    if (argError) {
        var error = fnName +
            ' failed: Was called with ' +
            argCount +
            (argCount === 1 ? ' argument.' : ' arguments.') +
            ' Expects ' +
            argError +
            '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argumentNumber The index of the argument
 * @param optional Whether or not the argument is optional
 * @return The prefix to add to the error thrown for validation.
 */
function errorPrefix(fnName, argumentNumber, optional) {
    var argName = '';
    switch (argumentNumber) {
        case 1:
            argName = optional ? 'first' : 'First';
            break;
        case 2:
            argName = optional ? 'second' : 'Second';
            break;
        case 3:
            argName = optional ? 'third' : 'Third';
            break;
        case 4:
            argName = optional ? 'fourth' : 'Fourth';
            break;
        default:
            throw new Error('errorPrefix called with argumentNumber > 4.  Need to update it?');
    }
    var error = fnName + ' failed: ';
    error += argName + ' argument ';
    return error;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */
function validateNamespace(fnName, argumentNumber, namespace, optional) {
    if (optional && !namespace) {
        return;
    }
    if (typeof namespace !== 'string') {
        //TODO: I should do more validation here. We only allow certain chars in namespaces.
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid firebase namespace.');
    }
}
function validateCallback(fnName, argumentNumber, 
// eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) {
        return;
    }
    if (typeof callback !== 'function') {
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid function.');
    }
}
function validateContextObject(fnName, argumentNumber, context, optional) {
    if (optional && !context) {
        return;
    }
    if (typeof context !== 'object' || context === null) {
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid context object.');
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */
var stringToByteArray$1 = function (str) {
    var out = [];
    var p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            var high = c - 0xd800; // the high 10 bits.
            i++;
            assert(i < str.length, 'Surrogate pair missing trail surrogate.');
            var low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if (c < 65536) {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */
var stringLength = function (str) {
    var p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        if (c < 128) {
            p++;
        }
        else if (c < 2048) {
            p += 2;
        }
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        }
        else {
            p += 3;
        }
    }
    return p;
};

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The amount of milliseconds to exponentially increase.
 */
var DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */
var DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */
var MAX_VALUE_MILLIS = 4 * 60 * 60 * 1000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */
var RANDOM_FACTOR = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */
function calculateBackoffMillis(backoffCount, intervalMillis, backoffFactor) {
    if (intervalMillis === void 0) { intervalMillis = DEFAULT_INTERVAL_MILLIS; }
    if (backoffFactor === void 0) { backoffFactor = DEFAULT_BACKOFF_FACTOR; }
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    var currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    var randomWait = Math.round(
    // A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    RANDOM_FACTOR *
        currBaseValue *
        // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
        // if we add or subtract.
        (Math.random() - 0.5) *
        2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min(MAX_VALUE_MILLIS, currBaseValue + randomWait);
}

exports.CONSTANTS = CONSTANTS;
exports.Deferred = Deferred;
exports.ErrorFactory = ErrorFactory;
exports.FirebaseError = FirebaseError;
exports.MAX_VALUE_MILLIS = MAX_VALUE_MILLIS;
exports.RANDOM_FACTOR = RANDOM_FACTOR;
exports.Sha1 = Sha1;
exports.areCookiesEnabled = areCookiesEnabled;
exports.assert = assert;
exports.assertionError = assertionError;
exports.async = async;
exports.base64 = base64;
exports.base64Decode = base64Decode;
exports.base64Encode = base64Encode;
exports.calculateBackoffMillis = calculateBackoffMillis;
exports.contains = contains;
exports.createSubscribe = createSubscribe;
exports.decode = decode;
exports.deepCopy = deepCopy;
exports.deepExtend = deepExtend;
exports.errorPrefix = errorPrefix;
exports.getUA = getUA;
exports.isAdmin = isAdmin;
exports.isBrowser = isBrowser;
exports.isBrowserExtension = isBrowserExtension;
exports.isElectron = isElectron;
exports.isEmpty = isEmpty;
exports.isIE = isIE;
exports.isIndexedDBAvailable = isIndexedDBAvailable;
exports.isMobileCordova = isMobileCordova;
exports.isNode = isNode;
exports.isNodeSdk = isNodeSdk;
exports.isReactNative = isReactNative;
exports.isSafari = isSafari;
exports.isUWP = isUWP;
exports.isValidFormat = isValidFormat;
exports.isValidTimestamp = isValidTimestamp;
exports.issuedAtTime = issuedAtTime;
exports.jsonEval = jsonEval;
exports.map = map;
exports.querystring = querystring;
exports.querystringDecode = querystringDecode;
exports.safeGet = safeGet;
exports.stringLength = stringLength;
exports.stringToByteArray = stringToByteArray$1;
exports.stringify = stringify;
exports.validateArgCount = validateArgCount;
exports.validateCallback = validateCallback;
exports.validateContextObject = validateContextObject;
exports.validateIndexedDBOpenable = validateIndexedDBOpenable;
exports.validateNamespace = validateNamespace;
//# sourceMappingURL=index.cjs.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(20)))

/***/ }),
/* 57 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(26);


/* harmony default export */ __webpack_exports__["a"] = (function(values, p, valueof) {
  if (valueof == null) valueof = __WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */];
  if (!(n = values.length)) return;
  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
  var n,
      i = (n - 1) * p,
      i0 = Math.floor(i),
      value0 = +valueof(values[i0], i0, values),
      value1 = +valueof(values[i0 + 1], i0 + 1, values);
  return value0 + (value1 - value0) * (i - i0);
});


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_drag__ = __webpack_require__(254);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_drag__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_nodrag__ = __webpack_require__(125);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_nodrag__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__src_nodrag__["b"]; });




/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__namespaces__ = __webpack_require__(61);


/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var prefix = name += "", i = prefix.indexOf(":");
  if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
  return __WEBPACK_IMPORTED_MODULE_0__namespaces__["a" /* default */].hasOwnProperty(prefix) ? {space: __WEBPACK_IMPORTED_MODULE_0__namespaces__["a" /* default */][prefix], local: name} : name;
});


/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return xhtml; });
var xhtml = "http://www.w3.org/1999/xhtml";

/* harmony default export */ __webpack_exports__["a"] = ({
  svg: "http://www.w3.org/2000/svg",
  xhtml: xhtml,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
});


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function none() {}

/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return selector == null ? none : function() {
    return this.querySelector(selector);
  };
});


/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(node) {
  return (node.ownerDocument && node.ownerDocument.defaultView) // node is a Node
      || (node.document && node) // node is a Window
      || node.defaultView; // node is a Document
});


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return event; });
/* harmony export (immutable) */ __webpack_exports__["a"] = customEvent;
var filterEvents = {};

var event = null;

if (typeof document !== "undefined") {
  var element = document.documentElement;
  if (!("onmouseenter" in element)) {
    filterEvents = {mouseenter: "mouseover", mouseleave: "mouseout"};
  }
}

function filterContextListener(listener, index, group) {
  listener = contextListener(listener, index, group);
  return function(event) {
    var related = event.relatedTarget;
    if (!related || (related !== this && !(related.compareDocumentPosition(this) & 8))) {
      listener.call(this, event);
    }
  };
}

function contextListener(listener, index, group) {
  return function(event1) {
    var event0 = event; // Events can be reentrant (e.g., focus).
    event = event1;
    try {
      listener.call(this, this.__data__, index, group);
    } finally {
      event = event0;
    }
  };
}

function parseTypenames(typenames) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    return {type: t, name: name};
  });
}

function onRemove(typename) {
  return function() {
    var on = this.__on;
    if (!on) return;
    for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.capture);
      } else {
        on[++i] = o;
      }
    }
    if (++i) on.length = i;
    else delete this.__on;
  };
}

function onAdd(typename, value, capture) {
  var wrap = filterEvents.hasOwnProperty(typename.type) ? filterContextListener : contextListener;
  return function(d, i, group) {
    var on = this.__on, o, listener = wrap(value, i, group);
    if (on) for (var j = 0, m = on.length; j < m; ++j) {
      if ((o = on[j]).type === typename.type && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.capture);
        this.addEventListener(o.type, o.listener = listener, o.capture = capture);
        o.value = value;
        return;
      }
    }
    this.addEventListener(typename.type, listener, capture);
    o = {type: typename.type, name: typename.name, value: value, listener: listener, capture: capture};
    if (!on) this.__on = [o];
    else on.push(o);
  };
}

/* harmony default export */ __webpack_exports__["b"] = (function(typename, value, capture) {
  var typenames = parseTypenames(typename + ""), i, n = typenames.length, t;

  if (arguments.length < 2) {
    var on = this.node().__on;
    if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
      for (i = 0, o = on[j]; i < n; ++i) {
        if ((t = typenames[i]).type === o.type && t.name === o.name) {
          return o.value;
        }
      }
    }
    return;
  }

  on = value ? onAdd : onRemove;
  if (capture == null) capture = false;
  for (i = 0; i < n; ++i) this.each(on(typenames[i], value, capture));
  return this;
});

function customEvent(event1, listener, that, args) {
  var event0 = event;
  event1.sourceEvent = event;
  event = event1;
  try {
    return listener.apply(that, args);
  } finally {
    event = event0;
  }
}


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selection_on__ = __webpack_require__(64);


/* harmony default export */ __webpack_exports__["a"] = (function() {
  var current = __WEBPACK_IMPORTED_MODULE_0__selection_on__["c" /* event */], source;
  while (source = current.sourceEvent) current = source;
  return current;
});


/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rgb__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__date__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__object__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__string__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constant__ = __webpack_require__(130);









/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? Object(__WEBPACK_IMPORTED_MODULE_7__constant__["a" /* default */])(b)
      : (t === "number" ? __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]
      : t === "string" ? ((c = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* color */])(b)) ? (b = c, __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]) : __WEBPACK_IMPORTED_MODULE_6__string__["a" /* default */])
      : b instanceof __WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* color */] ? __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]
      : b instanceof Date ? __WEBPACK_IMPORTED_MODULE_3__date__["a" /* default */]
      : Array.isArray(b) ? __WEBPACK_IMPORTED_MODULE_2__array__["a" /* default */]
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? __WEBPACK_IMPORTED_MODULE_5__object__["a" /* default */]
      : __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */])(a, b);
});


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Color;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return darker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return brighter; });
/* harmony export (immutable) */ __webpack_exports__["e"] = color;
/* harmony export (immutable) */ __webpack_exports__["h"] = rgbConvert;
/* harmony export (immutable) */ __webpack_exports__["g"] = rgb;
/* harmony export (immutable) */ __webpack_exports__["b"] = Rgb;
/* unused harmony export hslConvert */
/* harmony export (immutable) */ __webpack_exports__["f"] = hsl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(68);


function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex3 = /^#([0-9a-f]{3})$/,
    reHex6 = /^#([0-9a-f]{6})$/,
    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Color, color, {
  displayable: function() {
    return this.rgb().displayable();
  },
  toString: function() {
    return this.rgb() + "";
  }
});

function color(format) {
  var m;
  format = (format + "").trim().toLowerCase();
  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named.hasOwnProperty(format) ? rgbn(named[format])
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Rgb, rgb, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return (0 <= this.r && this.r <= 255)
        && (0 <= this.g && this.g <= 255)
        && (0 <= this.b && this.b <= 255)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  toString: function() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(")
        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
        + (a === 1 ? ")" : ", " + a + ")");
  }
}));

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Hsl, hsl, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extend;
/* harmony default export */ __webpack_exports__["a"] = (function(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
});

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = basis;
function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1, t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
      + (4 - 6 * t2 + 3 * t3) * v1
      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
      + t3 * v3) / 6;
}

/* harmony default export */ __webpack_exports__["b"] = (function(values) {
  var n = values.length - 1;
  return function(t) {
    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
        v1 = values[i],
        v2 = values[i + 1],
        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_selection_index__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_transition_index__ = __webpack_require__(12);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__src_transition_index__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_active__ = __webpack_require__(334);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__src_active__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_interrupt__ = __webpack_require__(135);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__src_interrupt__["a"]; });






/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = now;
/* harmony export (immutable) */ __webpack_exports__["a"] = Timer;
/* harmony export (immutable) */ __webpack_exports__["c"] = timer;
/* harmony export (immutable) */ __webpack_exports__["d"] = timerFlush;
var frame = 0, // is an animation frame pending?
    timeout = 0, // is a timeout pending?
    interval = 0, // are any timers active?
    pokeDelay = 1000, // how frequently we check for clock skew
    taskHead,
    taskTail,
    clockLast = 0,
    clockNow = 0,
    clockSkew = 0,
    clock = typeof performance === "object" && performance.now ? performance : Date,
    setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) { setTimeout(f, 17); };

function now() {
  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}

function clearNow() {
  clockNow = 0;
}

function Timer() {
  this._call =
  this._time =
  this._next = null;
}

Timer.prototype = timer.prototype = {
  constructor: Timer,
  restart: function(callback, delay, time) {
    if (typeof callback !== "function") throw new TypeError("callback is not a function");
    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
    if (!this._next && taskTail !== this) {
      if (taskTail) taskTail._next = this;
      else taskHead = this;
      taskTail = this;
    }
    this._call = callback;
    this._time = time;
    sleep();
  },
  stop: function() {
    if (this._call) {
      this._call = null;
      this._time = Infinity;
      sleep();
    }
  }
};

function timer(callback, delay, time) {
  var t = new Timer;
  t.restart(callback, delay, time);
  return t;
}

function timerFlush() {
  now(); // Get the current time, if not already set.
  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
  var t = taskHead, e;
  while (t) {
    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
    t = t._next;
  }
  --frame;
}

function wake() {
  clockNow = (clockLast = clock.now()) + clockSkew;
  frame = timeout = 0;
  try {
    timerFlush();
  } finally {
    frame = 0;
    nap();
    clockNow = 0;
  }
}

function poke() {
  var now = clock.now(), delay = now - clockLast;
  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
}

function nap() {
  var t0, t1 = taskHead, t2, time = Infinity;
  while (t1) {
    if (t1._call) {
      if (time > t1._time) time = t1._time;
      t0 = t1, t1 = t1._next;
    } else {
      t2 = t1._next, t1._next = null;
      t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
  }
  taskTail = t0;
  sleep(time);
}

function sleep(time) {
  if (frame) return; // Soonest alarm already set, or will be.
  if (timeout) timeout = clearTimeout(timeout);
  var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
  if (delay > 24) {
    if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
    if (interval) interval = clearInterval(interval);
  } else {
    if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
    frame = 1, setFrame(wake);
  }
}


/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefix; });
var prefix = "$";

function Map() {}

Map.prototype = map.prototype = {
  constructor: Map,
  has: function(key) {
    return (prefix + key) in this;
  },
  get: function(key) {
    return this[prefix + key];
  },
  set: function(key, value) {
    this[prefix + key] = value;
    return this;
  },
  remove: function(key) {
    var property = prefix + key;
    return property in this && delete this[property];
  },
  clear: function() {
    for (var property in this) if (property[0] === prefix) delete this[property];
  },
  keys: function() {
    var keys = [];
    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
    return keys;
  },
  values: function() {
    var values = [];
    for (var property in this) if (property[0] === prefix) values.push(this[property]);
    return values;
  },
  entries: function() {
    var entries = [];
    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
    return entries;
  },
  size: function() {
    var size = 0;
    for (var property in this) if (property[0] === prefix) ++size;
    return size;
  },
  empty: function() {
    for (var property in this) if (property[0] === prefix) return false;
    return true;
  },
  each: function(f) {
    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
  }
};

function map(object, f) {
  var map = new Map;

  // Copy constructor.
  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });

  // Index array by numeric index or specified key function.
  else if (Array.isArray(object)) {
    var i = -1,
        n = object.length,
        o;

    if (f == null) while (++i < n) map.set(i, object[i]);
    else while (++i < n) map.set(f(o = object[i], i, object), o);
  }

  // Convert object to map.
  else if (object) for (var key in object) map.set(key, object[key]);

  return map;
}

/* harmony default export */ __webpack_exports__["a"] = (map);


/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_dsv__ = __webpack_require__(74);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__src_dsv__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_csv__ = __webpack_require__(349);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__src_csv__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__src_csv__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__src_csv__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_csv__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_tsv__ = __webpack_require__(350);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_2__src_tsv__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_2__src_tsv__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__src_tsv__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__src_tsv__["b"]; });





/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var EOL = {},
    EOF = {},
    QUOTE = 34,
    NEWLINE = 10,
    RETURN = 13;

function objectConverter(columns) {
  return new Function("d", "return {" + columns.map(function(name, i) {
    return JSON.stringify(name) + ": d[" + i + "]";
  }).join(",") + "}");
}

function customConverter(columns, f) {
  var object = objectConverter(columns);
  return function(row, i) {
    return f(object(row), i, columns);
  };
}

// Compute unique columns in order of discovery.
function inferColumns(rows) {
  var columnSet = Object.create(null),
      columns = [];

  rows.forEach(function(row) {
    for (var column in row) {
      if (!(column in columnSet)) {
        columns.push(columnSet[column] = column);
      }
    }
  });

  return columns;
}

/* harmony default export */ __webpack_exports__["a"] = (function(delimiter) {
  var reFormat = new RegExp("[\"" + delimiter + "\n\r]"),
      DELIMITER = delimiter.charCodeAt(0);

  function parse(text, f) {
    var convert, columns, rows = parseRows(text, function(row, i) {
      if (convert) return convert(row, i - 1);
      columns = row, convert = f ? customConverter(row, f) : objectConverter(row);
    });
    rows.columns = columns || [];
    return rows;
  }

  function parseRows(text, f) {
    var rows = [], // output rows
        N = text.length,
        I = 0, // current character index
        n = 0, // current line number
        t, // current token
        eof = N <= 0, // current token followed by EOF?
        eol = false; // current token followed by EOL?

    // Strip the trailing newline.
    if (text.charCodeAt(N - 1) === NEWLINE) --N;
    if (text.charCodeAt(N - 1) === RETURN) --N;

    function token() {
      if (eof) return EOF;
      if (eol) return eol = false, EOL;

      // Unescape quotes.
      var i, j = I, c;
      if (text.charCodeAt(j) === QUOTE) {
        while (I++ < N && text.charCodeAt(I) !== QUOTE || text.charCodeAt(++I) === QUOTE);
        if ((i = I) >= N) eof = true;
        else if ((c = text.charCodeAt(I++)) === NEWLINE) eol = true;
        else if (c === RETURN) { eol = true; if (text.charCodeAt(I) === NEWLINE) ++I; }
        return text.slice(j + 1, i - 1).replace(/""/g, "\"");
      }

      // Find next delimiter or newline.
      while (I < N) {
        if ((c = text.charCodeAt(i = I++)) === NEWLINE) eol = true;
        else if (c === RETURN) { eol = true; if (text.charCodeAt(I) === NEWLINE) ++I; }
        else if (c !== DELIMITER) continue;
        return text.slice(j, i);
      }

      // Return last token before EOF.
      return eof = true, text.slice(j, N);
    }

    while ((t = token()) !== EOF) {
      var row = [];
      while (t !== EOL && t !== EOF) row.push(t), t = token();
      if (f && (row = f(row, n++)) == null) continue;
      rows.push(row);
    }

    return rows;
  }

  function format(rows, columns) {
    if (columns == null) columns = inferColumns(rows);
    return [columns.map(formatValue).join(delimiter)].concat(rows.map(function(row) {
      return columns.map(function(column) {
        return formatValue(row[column]);
      }).join(delimiter);
    })).join("\n");
  }

  function formatRows(rows) {
    return rows.map(formatRow).join("\n");
  }

  function formatRow(row) {
    return row.map(formatValue).join(delimiter);
  }

  function formatValue(text) {
    return text == null ? ""
        : reFormat.test(text += "") ? "\"" + text.replace(/"/g, "\"\"") + "\""
        : text;
  }

  return {
    parse: parse,
    parseRows: parseRows,
    format: format,
    formatRows: formatRows
  };
});


/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  return (Math.random() - 0.5) * 1e-6;
});


/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_quadtree__ = __webpack_require__(354);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_quadtree__["a"]; });



/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(node, x0, y0, x1, y1) {
  this.node = node;
  this.x0 = x0;
  this.y0 = y0;
  this.x1 = x1;
  this.y1 = y1;
});


/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__ = __webpack_require__(372);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_locale__ = __webpack_require__(140);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__src_locale__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_formatSpecifier__ = __webpack_require__(141);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__src_formatSpecifier__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_precisionFixed__ = __webpack_require__(378);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__src_precisionFixed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_precisionPrefix__ = __webpack_require__(379);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_4__src_precisionPrefix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_precisionRound__ = __webpack_require__(380);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_5__src_precisionRound__["a"]; });








/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimal(1.23) returns ["123", 0].
/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i, coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
});


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = conicEqualAreaRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conic__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cylindricalEqualArea__ = __webpack_require__(397);




function conicEqualAreaRaw(y0, y1) {
  var sy0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y0), n = (sy0 + Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y1)) / 2;

  // Are the parallels symmetrical around the Equator?
  if (Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(n) < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]) return Object(__WEBPACK_IMPORTED_MODULE_2__cylindricalEqualArea__["a" /* cylindricalEqualAreaRaw */])(y0);

  var c = 1 + sy0 * (2 * n - sy0), r0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(c) / n;

  function project(x, y) {
    var r = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(c - 2 * n * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y)) / n;
    return [r * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(x *= n), r0 - r * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(x)];
  }

  project.invert = function(x, y) {
    var r0y = r0 - y;
    return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(x, Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(r0y)) / n * Object(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(r0y), Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])((c - (x * x + r0y * r0y) * n * n) / (2 * n))];
  };

  return project;
}

/* harmony default export */ __webpack_exports__["b"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__conic__["a" /* conicProjection */])(conicEqualAreaRaw)
      .scale(155.424)
      .center([0, 33.6442]);
});


/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = conicProjection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(10);



function conicProjection(projectAt) {
  var phi0 = 0,
      phi1 = __WEBPACK_IMPORTED_MODULE_0__math__["o" /* pi */] / 3,
      m = Object(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* projectionMutator */])(projectAt),
      p = m(phi0, phi1);

  p.parallels = function(_) {
    return arguments.length ? m(phi0 = _[0] * __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */], phi1 = _[1] * __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */]) : [phi0 * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */], phi1 * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */]];
  };

  return p;
}


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fitExtent;
/* harmony export (immutable) */ __webpack_exports__["c"] = fitSize;
/* harmony export (immutable) */ __webpack_exports__["d"] = fitWidth;
/* harmony export (immutable) */ __webpack_exports__["b"] = fitHeight;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stream__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__path_bounds__ = __webpack_require__(156);



function fit(projection, fitBounds, object) {
  var clip = projection.clipExtent && projection.clipExtent();
  projection.scale(150).translate([0, 0]);
  if (clip != null) projection.clipExtent(null);
  Object(__WEBPACK_IMPORTED_MODULE_0__stream__["a" /* default */])(object, projection.stream(__WEBPACK_IMPORTED_MODULE_1__path_bounds__["a" /* default */]));
  fitBounds(__WEBPACK_IMPORTED_MODULE_1__path_bounds__["a" /* default */].result());
  if (clip != null) projection.clipExtent(clip);
  return projection;
}

function fitExtent(projection, extent, object) {
  return fit(projection, function(b) {
    var w = extent[1][0] - extent[0][0],
        h = extent[1][1] - extent[0][1],
        k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])),
        x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2,
        y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
    projection.scale(150 * k).translate([x, y]);
  }, object);
}

function fitSize(projection, size, object) {
  return fitExtent(projection, [[0, 0], size], object);
}

function fitWidth(projection, width, object) {
  return fit(projection, function(b) {
    var w = +width,
        k = w / (b[1][0] - b[0][0]),
        x = (w - k * (b[1][0] + b[0][0])) / 2,
        y = -k * b[0][1];
    projection.scale(150 * k).translate([x, y]);
  }, object);
}

function fitHeight(projection, height, object) {
  return fit(projection, function(b) {
    var h = +height,
        k = h / (b[1][1] - b[0][1]),
        x = -k * b[0][0],
        y = (h - k * (b[1][1] + b[0][1])) / 2;
    projection.scale(150 * k).translate([x, y]);
  }, object);
}


/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = mercatorRaw;
/* harmony export (immutable) */ __webpack_exports__["b"] = mercatorProjection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rotation__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(10);




function mercatorRaw(lambda, phi) {
  return [lambda, Object(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* log */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["v" /* tan */])((__WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */] + phi) / 2))];
}

mercatorRaw.invert = function(x, y) {
  return [x, 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* atan */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["k" /* exp */])(y)) - __WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */]];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return mercatorProjection(mercatorRaw)
      .scale(961 / __WEBPACK_IMPORTED_MODULE_0__math__["w" /* tau */]);
});

function mercatorProjection(project) {
  var m = Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(project),
      center = m.center,
      scale = m.scale,
      translate = m.translate,
      clipExtent = m.clipExtent,
      x0 = null, y0, x1, y1; // clip extent

  m.scale = function(_) {
    return arguments.length ? (scale(_), reclip()) : scale();
  };

  m.translate = function(_) {
    return arguments.length ? (translate(_), reclip()) : translate();
  };

  m.center = function(_) {
    return arguments.length ? (center(_), reclip()) : center();
  };

  m.clipExtent = function(_) {
    return arguments.length ? ((_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1])), reclip()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };

  function reclip() {
    var k = __WEBPACK_IMPORTED_MODULE_0__math__["o" /* pi */] * scale(),
        t = m(Object(__WEBPACK_IMPORTED_MODULE_1__rotation__["a" /* default */])(m.rotate()).invert([0, 0]));
    return clipExtent(x0 == null
        ? [[t[0] - k, t[1] - k], [t[0] + k, t[1] + k]] : project === mercatorRaw
        ? [[Math.max(t[0] - k, x0), y0], [Math.min(t[0] + k, x1), y1]]
        : [[x0, Math.max(t[1] - k, y0)], [x1, Math.min(t[1] + k, y1)]]);
  }

  return reclip();
}


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = hierarchy;
/* harmony export (immutable) */ __webpack_exports__["b"] = computeHeight;
/* harmony export (immutable) */ __webpack_exports__["a"] = Node;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__count__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__each__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eachBefore__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eachAfter__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sum__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sort__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__path__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ancestors__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__descendants__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__leaves__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__links__ = __webpack_require__(421);












function hierarchy(data, children) {
  var root = new Node(data),
      valued = +data.value && (root.value = data.value),
      node,
      nodes = [root],
      child,
      childs,
      i,
      n;

  if (children == null) children = defaultChildren;

  while (node = nodes.pop()) {
    if (valued) node.value = +node.data.value;
    if ((childs = children(node.data)) && (n = childs.length)) {
      node.children = new Array(n);
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = node.children[i] = new Node(childs[i]));
        child.parent = node;
        child.depth = node.depth + 1;
      }
    }
  }

  return root.eachBefore(computeHeight);
}

function node_copy() {
  return hierarchy(this).eachBefore(copyData);
}

function defaultChildren(d) {
  return d.children;
}

function copyData(node) {
  node.data = node.data.data;
}

function computeHeight(node) {
  var height = 0;
  do node.height = height;
  while ((node = node.parent) && (node.height < ++height));
}

function Node(data) {
  this.data = data;
  this.depth =
  this.height = 0;
  this.parent = null;
}

Node.prototype = hierarchy.prototype = {
  constructor: Node,
  count: __WEBPACK_IMPORTED_MODULE_0__count__["a" /* default */],
  each: __WEBPACK_IMPORTED_MODULE_1__each__["a" /* default */],
  eachAfter: __WEBPACK_IMPORTED_MODULE_3__eachAfter__["a" /* default */],
  eachBefore: __WEBPACK_IMPORTED_MODULE_2__eachBefore__["a" /* default */],
  sum: __WEBPACK_IMPORTED_MODULE_4__sum__["a" /* default */],
  sort: __WEBPACK_IMPORTED_MODULE_5__sort__["a" /* default */],
  path: __WEBPACK_IMPORTED_MODULE_6__path__["a" /* default */],
  ancestors: __WEBPACK_IMPORTED_MODULE_7__ancestors__["a" /* default */],
  descendants: __WEBPACK_IMPORTED_MODULE_8__descendants__["a" /* default */],
  leaves: __WEBPACK_IMPORTED_MODULE_9__leaves__["a" /* default */],
  links: __WEBPACK_IMPORTED_MODULE_10__links__["a" /* default */],
  copy: node_copy
};


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = optional;
/* harmony export (immutable) */ __webpack_exports__["b"] = required;
function optional(f) {
  return f == null ? null : required(f);
}

function required(f) {
  if (typeof f !== "function") throw new Error;
  return f;
}


/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return phi; });
/* harmony export (immutable) */ __webpack_exports__["c"] = squarifyRatio;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dice__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slice__ = __webpack_require__(48);



var phi = (1 + Math.sqrt(5)) / 2;

function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
  var rows = [],
      nodes = parent.children,
      row,
      nodeValue,
      i0 = 0,
      i1 = 0,
      n = nodes.length,
      dx, dy,
      value = parent.value,
      sumValue,
      minValue,
      maxValue,
      newRatio,
      minRatio,
      alpha,
      beta;

  while (i0 < n) {
    dx = x1 - x0, dy = y1 - y0;

    // Find the next non-empty node.
    do sumValue = nodes[i1++].value; while (!sumValue && i1 < n);
    minValue = maxValue = sumValue;
    alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
    beta = sumValue * sumValue * alpha;
    minRatio = Math.max(maxValue / beta, beta / minValue);

    // Keep adding nodes while the aspect ratio maintains or improves.
    for (; i1 < n; ++i1) {
      sumValue += nodeValue = nodes[i1].value;
      if (nodeValue < minValue) minValue = nodeValue;
      if (nodeValue > maxValue) maxValue = nodeValue;
      beta = sumValue * sumValue * alpha;
      newRatio = Math.max(maxValue / beta, beta / minValue);
      if (newRatio > minRatio) { sumValue -= nodeValue; break; }
      minRatio = newRatio;
    }

    // Position and record the row orientation.
    rows.push(row = {value: sumValue, dice: dx < dy, children: nodes.slice(i0, i1)});
    if (row.dice) Object(__WEBPACK_IMPORTED_MODULE_0__dice__["a" /* default */])(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
    else Object(__WEBPACK_IMPORTED_MODULE_1__slice__["a" /* default */])(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
    value -= sumValue, i0 = i1;
  }

  return rows;
}

/* harmony default export */ __webpack_exports__["a"] = ((function custom(ratio) {

  function squarify(parent, x0, y0, x1, y1) {
    squarifyRatio(ratio, parent, x0, y0, x1, y1);
  }

  squarify.ratio = function(x) {
    return custom((x = +x) > 1 ? x : 1);
  };

  return squarify;
})(phi));


/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_collection__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_dispatch__ = __webpack_require__(14);



/* harmony default export */ __webpack_exports__["a"] = (function(url, callback) {
  var request,
      event = Object(__WEBPACK_IMPORTED_MODULE_1_d3_dispatch__["a" /* dispatch */])("beforesend", "progress", "load", "error"),
      mimeType,
      headers = Object(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["c" /* map */])(),
      xhr = new XMLHttpRequest,
      user = null,
      password = null,
      response,
      responseType,
      timeout = 0;

  // If IE does not support CORS, use XDomainRequest.
  if (typeof XDomainRequest !== "undefined"
      && !("withCredentials" in xhr)
      && /^(http(s)?:)?\/\//.test(url)) xhr = new XDomainRequest;

  "onload" in xhr
      ? xhr.onload = xhr.onerror = xhr.ontimeout = respond
      : xhr.onreadystatechange = function(o) { xhr.readyState > 3 && respond(o); };

  function respond(o) {
    var status = xhr.status, result;
    if (!status && hasResponse(xhr)
        || status >= 200 && status < 300
        || status === 304) {
      if (response) {
        try {
          result = response.call(request, xhr);
        } catch (e) {
          event.call("error", request, e);
          return;
        }
      } else {
        result = xhr;
      }
      event.call("load", request, result);
    } else {
      event.call("error", request, o);
    }
  }

  xhr.onprogress = function(e) {
    event.call("progress", request, e);
  };

  request = {
    header: function(name, value) {
      name = (name + "").toLowerCase();
      if (arguments.length < 2) return headers.get(name);
      if (value == null) headers.remove(name);
      else headers.set(name, value + "");
      return request;
    },

    // If mimeType is non-null and no Accept header is set, a default is used.
    mimeType: function(value) {
      if (!arguments.length) return mimeType;
      mimeType = value == null ? null : value + "";
      return request;
    },

    // Specifies what type the response value should take;
    // for instance, arraybuffer, blob, document, or text.
    responseType: function(value) {
      if (!arguments.length) return responseType;
      responseType = value;
      return request;
    },

    timeout: function(value) {
      if (!arguments.length) return timeout;
      timeout = +value;
      return request;
    },

    user: function(value) {
      return arguments.length < 1 ? user : (user = value == null ? null : value + "", request);
    },

    password: function(value) {
      return arguments.length < 1 ? password : (password = value == null ? null : value + "", request);
    },

    // Specify how to convert the response content to a specific type;
    // changes the callback value on "load" events.
    response: function(value) {
      response = value;
      return request;
    },

    // Alias for send("GET", …).
    get: function(data, callback) {
      return request.send("GET", data, callback);
    },

    // Alias for send("POST", …).
    post: function(data, callback) {
      return request.send("POST", data, callback);
    },

    // If callback is non-null, it will be used for error and load events.
    send: function(method, data, callback) {
      xhr.open(method, url, true, user, password);
      if (mimeType != null && !headers.has("accept")) headers.set("accept", mimeType + ",*/*");
      if (xhr.setRequestHeader) headers.each(function(value, name) { xhr.setRequestHeader(name, value); });
      if (mimeType != null && xhr.overrideMimeType) xhr.overrideMimeType(mimeType);
      if (responseType != null) xhr.responseType = responseType;
      if (timeout > 0) xhr.timeout = timeout;
      if (callback == null && typeof data === "function") callback = data, data = null;
      if (callback != null && callback.length === 1) callback = fixCallback(callback);
      if (callback != null) request.on("error", callback).on("load", function(xhr) { callback(null, xhr); });
      event.call("beforesend", request, xhr);
      xhr.send(data == null ? null : data);
      return request;
    },

    abort: function() {
      xhr.abort();
      return request;
    },

    on: function() {
      var value = event.on.apply(event, arguments);
      return value === event ? request : value;
    }
  };

  if (callback != null) {
    if (typeof callback !== "function") throw new Error("invalid callback: " + callback);
    return request.get(callback);
  }

  return request;
});

function fixCallback(callback) {
  return function(error, xhr) {
    callback(error == null ? xhr : null);
  };
}

function hasResponse(xhr) {
  var type = xhr.responseType;
  return type && type !== "text"
      ? xhr.response // null on error
      : xhr.responseText; // "" on error
}


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__ = __webpack_require__(91);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_locale__ = __webpack_require__(170);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__src_locale__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_isoFormat__ = __webpack_require__(171);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__src_isoFormat__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_isoParse__ = __webpack_require__(476);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__src_isoParse__["a"]; });






/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return timeFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return timeParse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return utcFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return utcParse; });
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultLocale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__(170);


var locale;
var timeFormat;
var timeParse;
var utcFormat;
var utcParse;

defaultLocale({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});

function defaultLocale(definition) {
  locale = Object(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* default */])(definition);
  timeFormat = locale.format;
  timeParse = locale.parse;
  utcFormat = locale.utcFormat;
  utcParse = locale.utcParse;
  return locale;
}


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curve_linear__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__point__ = __webpack_require__(93);





/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x = __WEBPACK_IMPORTED_MODULE_3__point__["a" /* x */],
      y = __WEBPACK_IMPORTED_MODULE_3__point__["b" /* y */],
      defined = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(true),
      context = null,
      curve = __WEBPACK_IMPORTED_MODULE_2__curve_linear__["a" /* default */],
      output = null;

  function line(data) {
    var i,
        n = data.length,
        d,
        defined0 = false,
        buffer;

    if (context == null) output = curve(buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) output.lineStart();
        else output.lineEnd();
      }
      if (defined0) output.point(+x(d, i, data), +y(d, i, data));
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  line.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), line) : x;
  };

  line.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), line) : y;
  };

  line.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(!!_), line) : defined;
  };

  line.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
  };

  line.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
  };

  return line;
});


/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = x;
/* harmony export (immutable) */ __webpack_exports__["b"] = y;
function x(p) {
  return p[0];
}

function y(p) {
  return p[1];
}


/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = point;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardinal__ = __webpack_require__(55);



function point(that, x, y) {
  var x1 = that._x1,
      y1 = that._y1,
      x2 = that._x2,
      y2 = that._y2;

  if (that._l01_a > __WEBPACK_IMPORTED_MODULE_0__math__["f" /* epsilon */]) {
    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
  }

  if (that._l23_a > __WEBPACK_IMPORTED_MODULE_0__math__["f" /* epsilon */]) {
    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
  }

  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}

function CatmullRom(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRom.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: this.point(this._x2, this._y2); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; // proceed
      default: point(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRom(context, alpha) : new __WEBPACK_IMPORTED_MODULE_1__cardinal__["a" /* Cardinal */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = sum;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(36);


/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  var sums = series.map(sum);
  return Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).sort(function(a, b) { return sums[a] - sums[b]; });
});

function sum(series) {
  var s = 0, i = -1, n = series.length, v;
  while (++i < n) if (v = +series[i][1]) s += v;
  return s;
}


/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = RedBlackNode;
function RedBlackTree() {
  this._ = null; // root node
}

function RedBlackNode(node) {
  node.U = // parent node
  node.C = // color - true for red, false for black
  node.L = // left node
  node.R = // right node
  node.P = // previous node
  node.N = null; // next node
}

RedBlackTree.prototype = {
  constructor: RedBlackTree,

  insert: function(after, node) {
    var parent, grandpa, uncle;

    if (after) {
      node.P = after;
      node.N = after.N;
      if (after.N) after.N.P = node;
      after.N = node;
      if (after.R) {
        after = after.R;
        while (after.L) after = after.L;
        after.L = node;
      } else {
        after.R = node;
      }
      parent = after;
    } else if (this._) {
      after = RedBlackFirst(this._);
      node.P = null;
      node.N = after;
      after.P = after.L = node;
      parent = after;
    } else {
      node.P = node.N = null;
      this._ = node;
      parent = null;
    }
    node.L = node.R = null;
    node.U = parent;
    node.C = true;

    after = node;
    while (parent && parent.C) {
      grandpa = parent.U;
      if (parent === grandpa.L) {
        uncle = grandpa.R;
        if (uncle && uncle.C) {
          parent.C = uncle.C = false;
          grandpa.C = true;
          after = grandpa;
        } else {
          if (after === parent.R) {
            RedBlackRotateLeft(this, parent);
            after = parent;
            parent = after.U;
          }
          parent.C = false;
          grandpa.C = true;
          RedBlackRotateRight(this, grandpa);
        }
      } else {
        uncle = grandpa.L;
        if (uncle && uncle.C) {
          parent.C = uncle.C = false;
          grandpa.C = true;
          after = grandpa;
        } else {
          if (after === parent.L) {
            RedBlackRotateRight(this, parent);
            after = parent;
            parent = after.U;
          }
          parent.C = false;
          grandpa.C = true;
          RedBlackRotateLeft(this, grandpa);
        }
      }
      parent = after.U;
    }
    this._.C = false;
  },

  remove: function(node) {
    if (node.N) node.N.P = node.P;
    if (node.P) node.P.N = node.N;
    node.N = node.P = null;

    var parent = node.U,
        sibling,
        left = node.L,
        right = node.R,
        next,
        red;

    if (!left) next = right;
    else if (!right) next = left;
    else next = RedBlackFirst(right);

    if (parent) {
      if (parent.L === node) parent.L = next;
      else parent.R = next;
    } else {
      this._ = next;
    }

    if (left && right) {
      red = next.C;
      next.C = node.C;
      next.L = left;
      left.U = next;
      if (next !== right) {
        parent = next.U;
        next.U = node.U;
        node = next.R;
        parent.L = node;
        next.R = right;
        right.U = next;
      } else {
        next.U = parent;
        parent = next;
        node = next.R;
      }
    } else {
      red = node.C;
      node = next;
    }

    if (node) node.U = parent;
    if (red) return;
    if (node && node.C) { node.C = false; return; }

    do {
      if (node === this._) break;
      if (node === parent.L) {
        sibling = parent.R;
        if (sibling.C) {
          sibling.C = false;
          parent.C = true;
          RedBlackRotateLeft(this, parent);
          sibling = parent.R;
        }
        if ((sibling.L && sibling.L.C)
            || (sibling.R && sibling.R.C)) {
          if (!sibling.R || !sibling.R.C) {
            sibling.L.C = false;
            sibling.C = true;
            RedBlackRotateRight(this, sibling);
            sibling = parent.R;
          }
          sibling.C = parent.C;
          parent.C = sibling.R.C = false;
          RedBlackRotateLeft(this, parent);
          node = this._;
          break;
        }
      } else {
        sibling = parent.L;
        if (sibling.C) {
          sibling.C = false;
          parent.C = true;
          RedBlackRotateRight(this, parent);
          sibling = parent.L;
        }
        if ((sibling.L && sibling.L.C)
          || (sibling.R && sibling.R.C)) {
          if (!sibling.L || !sibling.L.C) {
            sibling.R.C = false;
            sibling.C = true;
            RedBlackRotateLeft(this, sibling);
            sibling = parent.L;
          }
          sibling.C = parent.C;
          parent.C = sibling.L.C = false;
          RedBlackRotateRight(this, parent);
          node = this._;
          break;
        }
      }
      sibling.C = true;
      node = parent;
      parent = parent.U;
    } while (!node.C);

    if (node) node.C = false;
  }
};

function RedBlackRotateLeft(tree, node) {
  var p = node,
      q = node.R,
      parent = p.U;

  if (parent) {
    if (parent.L === p) parent.L = q;
    else parent.R = q;
  } else {
    tree._ = q;
  }

  q.U = parent;
  p.U = q;
  p.R = q.L;
  if (p.R) p.R.U = p;
  q.L = p;
}

function RedBlackRotateRight(tree, node) {
  var p = node,
      q = node.L,
      parent = p.U;

  if (parent) {
    if (parent.L === p) parent.L = q;
    else parent.R = q;
  } else {
    tree._ = q;
  }

  q.U = parent;
  p.U = q;
  p.L = q.R;
  if (p.L) p.L.U = p;
  q.R = p;
}

function RedBlackFirst(node) {
  while (node.L) node = node.L;
  return node;
}

/* harmony default export */ __webpack_exports__["b"] = (RedBlackTree);


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = createEdge;
/* harmony export (immutable) */ __webpack_exports__["b"] = createBorderEdge;
/* harmony export (immutable) */ __webpack_exports__["d"] = setEdgeEnd;
/* harmony export (immutable) */ __webpack_exports__["a"] = clipEdges;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Diagram__ = __webpack_require__(37);


function createEdge(left, right, v0, v1) {
  var edge = [null, null],
      index = __WEBPACK_IMPORTED_MODULE_0__Diagram__["e" /* edges */].push(edge) - 1;
  edge.left = left;
  edge.right = right;
  if (v0) setEdgeEnd(edge, left, right, v0);
  if (v1) setEdgeEnd(edge, right, left, v1);
  __WEBPACK_IMPORTED_MODULE_0__Diagram__["b" /* cells */][left.index].halfedges.push(index);
  __WEBPACK_IMPORTED_MODULE_0__Diagram__["b" /* cells */][right.index].halfedges.push(index);
  return edge;
}

function createBorderEdge(left, v0, v1) {
  var edge = [v0, v1];
  edge.left = left;
  return edge;
}

function setEdgeEnd(edge, left, right, vertex) {
  if (!edge[0] && !edge[1]) {
    edge[0] = vertex;
    edge.left = left;
    edge.right = right;
  } else if (edge.left === right) {
    edge[1] = vertex;
  } else {
    edge[0] = vertex;
  }
}

// Liang–Barsky line clipping.
function clipEdge(edge, x0, y0, x1, y1) {
  var a = edge[0],
      b = edge[1],
      ax = a[0],
      ay = a[1],
      bx = b[0],
      by = b[1],
      t0 = 0,
      t1 = 1,
      dx = bx - ax,
      dy = by - ay,
      r;

  r = x0 - ax;
  if (!dx && r > 0) return;
  r /= dx;
  if (dx < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dx > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = x1 - ax;
  if (!dx && r < 0) return;
  r /= dx;
  if (dx < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dx > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  r = y0 - ay;
  if (!dy && r > 0) return;
  r /= dy;
  if (dy < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dy > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = y1 - ay;
  if (!dy && r < 0) return;
  r /= dy;
  if (dy < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dy > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  if (!(t0 > 0) && !(t1 < 1)) return true; // TODO Better check?

  if (t0 > 0) edge[0] = [ax + t0 * dx, ay + t0 * dy];
  if (t1 < 1) edge[1] = [ax + t1 * dx, ay + t1 * dy];
  return true;
}

function connectEdge(edge, x0, y0, x1, y1) {
  var v1 = edge[1];
  if (v1) return true;

  var v0 = edge[0],
      left = edge.left,
      right = edge.right,
      lx = left[0],
      ly = left[1],
      rx = right[0],
      ry = right[1],
      fx = (lx + rx) / 2,
      fy = (ly + ry) / 2,
      fm,
      fb;

  if (ry === ly) {
    if (fx < x0 || fx >= x1) return;
    if (lx > rx) {
      if (!v0) v0 = [fx, y0];
      else if (v0[1] >= y1) return;
      v1 = [fx, y1];
    } else {
      if (!v0) v0 = [fx, y1];
      else if (v0[1] < y0) return;
      v1 = [fx, y0];
    }
  } else {
    fm = (lx - rx) / (ry - ly);
    fb = fy - fm * fx;
    if (fm < -1 || fm > 1) {
      if (lx > rx) {
        if (!v0) v0 = [(y0 - fb) / fm, y0];
        else if (v0[1] >= y1) return;
        v1 = [(y1 - fb) / fm, y1];
      } else {
        if (!v0) v0 = [(y1 - fb) / fm, y1];
        else if (v0[1] < y0) return;
        v1 = [(y0 - fb) / fm, y0];
      }
    } else {
      if (ly < ry) {
        if (!v0) v0 = [x0, fm * x0 + fb];
        else if (v0[0] >= x1) return;
        v1 = [x1, fm * x1 + fb];
      } else {
        if (!v0) v0 = [x1, fm * x1 + fb];
        else if (v0[0] < x0) return;
        v1 = [x0, fm * x0 + fb];
      }
    }
  }

  edge[0] = v0;
  edge[1] = v1;
  return true;
}

function clipEdges(x0, y0, x1, y1) {
  var i = __WEBPACK_IMPORTED_MODULE_0__Diagram__["e" /* edges */].length,
      edge;

  while (i--) {
    if (!connectEdge(edge = __WEBPACK_IMPORTED_MODULE_0__Diagram__["e" /* edges */][i], x0, y0, x1, y1)
        || !clipEdge(edge, x0, y0, x1, y1)
        || !(Math.abs(edge[0][0] - edge[1][0]) > __WEBPACK_IMPORTED_MODULE_0__Diagram__["f" /* epsilon */]
            || Math.abs(edge[0][1] - edge[1][1]) > __WEBPACK_IMPORTED_MODULE_0__Diagram__["f" /* epsilon */])) {
      delete __WEBPACK_IMPORTED_MODULE_0__Diagram__["e" /* edges */][i];
    }
  }
}


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var tslib = __webpack_require__(38);
var util = __webpack_require__(56);
var component = __webpack_require__(99);
var logger$1 = __webpack_require__(523);

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a;
var ERRORS = (_a = {},
    _a["no-app" /* NO_APP */] = "No Firebase App '{$appName}' has been created - " +
        'call Firebase App.initializeApp()',
    _a["bad-app-name" /* BAD_APP_NAME */] = "Illegal App name: '{$appName}",
    _a["duplicate-app" /* DUPLICATE_APP */] = "Firebase App named '{$appName}' already exists",
    _a["app-deleted" /* APP_DELETED */] = "Firebase App named '{$appName}' already deleted",
    _a["invalid-app-argument" /* INVALID_APP_ARGUMENT */] = 'firebase.{$appName}() takes either no argument or a ' +
        'Firebase App instance.',
    _a["invalid-log-argument" /* INVALID_LOG_ARGUMENT */] = 'First argument to `onLog` must be null or a function.',
    _a);
var ERROR_FACTORY = new util.ErrorFactory('app', 'Firebase', ERRORS);

var name$1 = "@firebase/app";
var version = "0.6.11";

var name$2 = "@firebase/analytics";

var name$3 = "@firebase/auth";

var name$4 = "@firebase/database";

var name$5 = "@firebase/functions";

var name$6 = "@firebase/installations";

var name$7 = "@firebase/messaging";

var name$8 = "@firebase/performance";

var name$9 = "@firebase/remote-config";

var name$a = "@firebase/storage";

var name$b = "@firebase/firestore";

var name$c = "firebase-wrapper";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a$1;
var DEFAULT_ENTRY_NAME = '[DEFAULT]';
var PLATFORM_LOG_STRING = (_a$1 = {},
    _a$1[name$1] = 'fire-core',
    _a$1[name$2] = 'fire-analytics',
    _a$1[name$3] = 'fire-auth',
    _a$1[name$4] = 'fire-rtdb',
    _a$1[name$5] = 'fire-fn',
    _a$1[name$6] = 'fire-iid',
    _a$1[name$7] = 'fire-fcm',
    _a$1[name$8] = 'fire-perf',
    _a$1[name$9] = 'fire-rc',
    _a$1[name$a] = 'fire-gcs',
    _a$1[name$b] = 'fire-fst',
    _a$1['fire-js'] = 'fire-js',
    _a$1[name$c] = 'fire-js-all',
    _a$1);

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var logger = new logger$1.Logger('@firebase/app');

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Global context object for a collection of services using
 * a shared authentication state.
 */
var FirebaseAppImpl = /** @class */ (function () {
    function FirebaseAppImpl(options, config, firebase_) {
        var e_1, _a;
        var _this = this;
        this.firebase_ = firebase_;
        this.isDeleted_ = false;
        this.name_ = config.name;
        this.automaticDataCollectionEnabled_ =
            config.automaticDataCollectionEnabled || false;
        this.options_ = util.deepCopy(options);
        this.container = new component.ComponentContainer(config.name);
        // add itself to container
        this._addComponent(new component.Component('app', function () { return _this; }, "PUBLIC" /* PUBLIC */));
        try {
            // populate ComponentContainer with existing components
            for (var _b = tslib.__values(this.firebase_.INTERNAL.components.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var component$1 = _c.value;
                this._addComponent(component$1);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    Object.defineProperty(FirebaseAppImpl.prototype, "automaticDataCollectionEnabled", {
        get: function () {
            this.checkDestroyed_();
            return this.automaticDataCollectionEnabled_;
        },
        set: function (val) {
            this.checkDestroyed_();
            this.automaticDataCollectionEnabled_ = val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FirebaseAppImpl.prototype, "name", {
        get: function () {
            this.checkDestroyed_();
            return this.name_;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FirebaseAppImpl.prototype, "options", {
        get: function () {
            this.checkDestroyed_();
            return this.options_;
        },
        enumerable: false,
        configurable: true
    });
    FirebaseAppImpl.prototype.delete = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.checkDestroyed_();
            resolve();
        })
            .then(function () {
            _this.firebase_.INTERNAL.removeApp(_this.name_);
            return Promise.all(_this.container.getProviders().map(function (provider) { return provider.delete(); }));
        })
            .then(function () {
            _this.isDeleted_ = true;
        });
    };
    /**
     * Return a service instance associated with this app (creating it
     * on demand), identified by the passed instanceIdentifier.
     *
     * NOTE: Currently storage and functions are the only ones that are leveraging this
     * functionality. They invoke it by calling:
     *
     * ```javascript
     * firebase.app().storage('STORAGE BUCKET ID')
     * ```
     *
     * The service name is passed to this already
     * @internal
     */
    FirebaseAppImpl.prototype._getService = function (name, instanceIdentifier) {
        if (instanceIdentifier === void 0) { instanceIdentifier = DEFAULT_ENTRY_NAME; }
        this.checkDestroyed_();
        // getImmediate will always succeed because _getService is only called for registered components.
        return this.container.getProvider(name).getImmediate({
            identifier: instanceIdentifier
        });
    };
    /**
     * Remove a service instance from the cache, so we will create a new instance for this service
     * when people try to get this service again.
     *
     * NOTE: currently only firestore is using this functionality to support firestore shutdown.
     *
     * @param name The service name
     * @param instanceIdentifier instance identifier in case multiple instances are allowed
     * @internal
     */
    FirebaseAppImpl.prototype._removeServiceInstance = function (name, instanceIdentifier) {
        if (instanceIdentifier === void 0) { instanceIdentifier = DEFAULT_ENTRY_NAME; }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.container.getProvider(name).clearInstance(instanceIdentifier);
    };
    /**
     * @param component the component being added to this app's container
     */
    FirebaseAppImpl.prototype._addComponent = function (component) {
        try {
            this.container.addComponent(component);
        }
        catch (e) {
            logger.debug("Component " + component.name + " failed to register with FirebaseApp " + this.name, e);
        }
    };
    FirebaseAppImpl.prototype._addOrOverwriteComponent = function (component) {
        this.container.addOrOverwriteComponent(component);
    };
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */
    FirebaseAppImpl.prototype.checkDestroyed_ = function () {
        if (this.isDeleted_) {
            throw ERROR_FACTORY.create("app-deleted" /* APP_DELETED */, { appName: this.name_ });
        }
    };
    return FirebaseAppImpl;
}());
// Prevent dead-code elimination of these methods w/o invalid property
// copying.
(FirebaseAppImpl.prototype.name && FirebaseAppImpl.prototype.options) ||
    FirebaseAppImpl.prototype.delete ||
    console.log('dc');

var version$1 = "7.20.0";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Because auth can't share code with other components, we attach the utility functions
 * in an internal namespace to share code.
 * This function return a firebase namespace object without
 * any utility functions, so it can be shared between the regular firebaseNamespace and
 * the lite version.
 */
function createFirebaseNamespaceCore(firebaseAppImpl) {
    var apps = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var components = new Map();
    // A namespace is a plain JavaScript Object.
    var namespace = {
        // Hack to prevent Babel from modifying the object returned
        // as the firebase namespace.
        // @ts-ignore
        __esModule: true,
        initializeApp: initializeApp,
        // @ts-ignore
        app: app,
        registerVersion: registerVersion,
        setLogLevel: logger$1.setLogLevel,
        onLog: onLog,
        // @ts-ignore
        apps: null,
        SDK_VERSION: version$1,
        INTERNAL: {
            registerComponent: registerComponent,
            removeApp: removeApp,
            components: components,
            useAsService: useAsService
        }
    };
    // Inject a circular default export to allow Babel users who were previously
    // using:
    //
    //   import firebase from 'firebase';
    //   which becomes: var firebase = require('firebase').default;
    //
    // instead of
    //
    //   import * as firebase from 'firebase';
    //   which becomes: var firebase = require('firebase');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    namespace['default'] = namespace;
    // firebase.apps is a read-only getter.
    Object.defineProperty(namespace, 'apps', {
        get: getApps
    });
    /**
     * Called by App.delete() - but before any services associated with the App
     * are deleted.
     */
    function removeApp(name) {
        delete apps[name];
    }
    /**
     * Get the App object for a given name (or DEFAULT).
     */
    function app(name) {
        name = name || DEFAULT_ENTRY_NAME;
        if (!util.contains(apps, name)) {
            throw ERROR_FACTORY.create("no-app" /* NO_APP */, { appName: name });
        }
        return apps[name];
    }
    // @ts-ignore
    app['App'] = firebaseAppImpl;
    function initializeApp(options, rawConfig) {
        if (rawConfig === void 0) { rawConfig = {}; }
        if (typeof rawConfig !== 'object' || rawConfig === null) {
            var name_1 = rawConfig;
            rawConfig = { name: name_1 };
        }
        var config = rawConfig;
        if (config.name === undefined) {
            config.name = DEFAULT_ENTRY_NAME;
        }
        var name = config.name;
        if (typeof name !== 'string' || !name) {
            throw ERROR_FACTORY.create("bad-app-name" /* BAD_APP_NAME */, {
                appName: String(name)
            });
        }
        if (util.contains(apps, name)) {
            throw ERROR_FACTORY.create("duplicate-app" /* DUPLICATE_APP */, { appName: name });
        }
        var app = new firebaseAppImpl(options, config, namespace);
        apps[name] = app;
        return app;
    }
    /*
     * Return an array of all the non-deleted FirebaseApps.
     */
    function getApps() {
        // Make a copy so caller cannot mutate the apps list.
        return Object.keys(apps).map(function (name) { return apps[name]; });
    }
    function registerComponent(component) {
        var e_1, _a;
        var componentName = component.name;
        if (components.has(componentName)) {
            logger.debug("There were multiple attempts to register component " + componentName + ".");
            return component.type === "PUBLIC" /* PUBLIC */
                ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    namespace[componentName]
                : null;
        }
        components.set(componentName, component);
        // create service namespace for public components
        if (component.type === "PUBLIC" /* PUBLIC */) {
            // The Service namespace is an accessor function ...
            var serviceNamespace = function (appArg) {
                if (appArg === void 0) { appArg = app(); }
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (typeof appArg[componentName] !== 'function') {
                    // Invalid argument.
                    // This happens in the following case: firebase.storage('gs:/')
                    throw ERROR_FACTORY.create("invalid-app-argument" /* INVALID_APP_ARGUMENT */, {
                        appName: componentName
                    });
                }
                // Forward service instance lookup to the FirebaseApp.
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return appArg[componentName]();
            };
            // ... and a container for service-level properties.
            if (component.serviceProps !== undefined) {
                util.deepExtend(serviceNamespace, component.serviceProps);
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            namespace[componentName] = serviceNamespace;
            // Patch the FirebaseAppImpl prototype
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            firebaseAppImpl.prototype[componentName] =
                // TODO: The eslint disable can be removed and the 'ignoreRestArgs'
                // option added to the no-explicit-any rule when ESlint releases it.
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    var serviceFxn = this._getService.bind(this, componentName);
                    return serviceFxn.apply(this, component.multipleInstances ? args : []);
                };
        }
        try {
            // add the component to existing app instances
            for (var _b = tslib.__values(Object.keys(apps)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var appName = _c.value;
                apps[appName]._addComponent(component);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return component.type === "PUBLIC" /* PUBLIC */
            ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                namespace[componentName]
            : null;
    }
    function registerVersion(libraryKeyOrName, version, variant) {
        var _a;
        // TODO: We can use this check to whitelist strings when/if we set up
        // a good whitelist system.
        var library = (_a = PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
        if (variant) {
            library += "-" + variant;
        }
        var libraryMismatch = library.match(/\s|\//);
        var versionMismatch = version.match(/\s|\//);
        if (libraryMismatch || versionMismatch) {
            var warning = [
                "Unable to register library \"" + library + "\" with version \"" + version + "\":"
            ];
            if (libraryMismatch) {
                warning.push("library name \"" + library + "\" contains illegal characters (whitespace or \"/\")");
            }
            if (libraryMismatch && versionMismatch) {
                warning.push('and');
            }
            if (versionMismatch) {
                warning.push("version name \"" + version + "\" contains illegal characters (whitespace or \"/\")");
            }
            logger.warn(warning.join(' '));
            return;
        }
        registerComponent(new component.Component(library + "-version", function () { return ({ library: library, version: version }); }, "VERSION" /* VERSION */));
    }
    function onLog(logCallback, options) {
        if (logCallback !== null && typeof logCallback !== 'function') {
            throw ERROR_FACTORY.create("invalid-log-argument" /* INVALID_LOG_ARGUMENT */, {
                appName: name
            });
        }
        logger$1.setUserLogHandler(logCallback, options);
    }
    // Map the requested service to a registered service name
    // (used to map auth to serverAuth service when needed).
    function useAsService(app, name) {
        if (name === 'serverAuth') {
            return null;
        }
        var useService = name;
        return useService;
    }
    return namespace;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Return a firebase namespace object.
 *
 * In production, this will be called exactly once and the result
 * assigned to the 'firebase' global.  It may be called multiple times
 * in unit tests.
 */
function createFirebaseNamespace() {
    var namespace = createFirebaseNamespaceCore(FirebaseAppImpl);
    namespace.INTERNAL = tslib.__assign(tslib.__assign({}, namespace.INTERNAL), { createFirebaseNamespace: createFirebaseNamespace,
        extendNamespace: extendNamespace,
        createSubscribe: util.createSubscribe,
        ErrorFactory: util.ErrorFactory,
        deepExtend: util.deepExtend });
    /**
     * Patch the top-level firebase namespace with additional properties.
     *
     * firebase.INTERNAL.extendNamespace()
     */
    function extendNamespace(props) {
        util.deepExtend(namespace, props);
    }
    return namespace;
}
var firebase = createFirebaseNamespace();

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var PlatformLoggerService = /** @class */ (function () {
    function PlatformLoggerService(container) {
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    PlatformLoggerService.prototype.getPlatformInfoString = function () {
        var providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers
            .map(function (provider) {
            if (isVersionServiceProvider(provider)) {
                var service = provider.getImmediate();
                return service.library + "/" + service.version;
            }
            else {
                return null;
            }
        })
            .filter(function (logString) { return logString; })
            .join(' ');
    };
    return PlatformLoggerService;
}());
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */
function isVersionServiceProvider(provider) {
    var component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* VERSION */;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function registerCoreComponents(firebase, variant) {
    firebase.INTERNAL.registerComponent(new component.Component('platform-logger', function (container) { return new PlatformLoggerService(container); }, "PRIVATE" /* PRIVATE */));
    // Register `app` package.
    firebase.registerVersion(name$1, version, variant);
    // Register platform SDK identifier (no version).
    firebase.registerVersion('fire-js', '');
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Firebase Lite detection test
// eslint-disable-next-line @typescript-eslint/no-explicit-any
if (util.isBrowser() && self.firebase !== undefined) {
    logger.warn("\n    Warning: Firebase is already defined in the global scope. Please make sure\n    Firebase library is only loaded once.\n  ");
    // eslint-disable-next-line
    var sdkVersion = self.firebase.SDK_VERSION;
    if (sdkVersion && sdkVersion.indexOf('LITE') >= 0) {
        logger.warn("\n    Warning: You are trying to load Firebase while using Firebase Performance standalone script.\n    You should load Firebase Performance with this instance of Firebase to avoid loading duplicate code.\n    ");
    }
}
var initializeApp = firebase.initializeApp;
// TODO: This disable can be removed and the 'ignoreRestArgs' option added to
// the no-explicit-any rule when ESlint releases it.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
firebase.initializeApp = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    // Environment check before initializing app
    // Do the check in initializeApp, so people have a chance to disable it by setting logLevel
    // in @firebase/logger
    if (util.isNode()) {
        logger.warn("\n      Warning: This is a browser-targeted Firebase bundle but it appears it is being\n      run in a Node environment.  If running in a Node environment, make sure you\n      are using the bundle specified by the \"main\" field in package.json.\n      \n      If you are using Webpack, you can specify \"main\" as the first item in\n      \"resolve.mainFields\":\n      https://webpack.js.org/configuration/resolve/#resolvemainfields\n      \n      If using Rollup, use the rollup-plugin-node-resolve plugin and specify \"main\"\n      as the first item in \"mainFields\", e.g. ['main', 'module'].\n      https://github.com/rollup/rollup-plugin-node-resolve\n      ");
    }
    return initializeApp.apply(undefined, args);
};
var firebase$1 = firebase;
registerCoreComponents(firebase$1);

exports.default = firebase$1;
exports.firebase = firebase$1;
//# sourceMappingURL=index.cjs.js.map


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var tslib = __webpack_require__(38);
var util = __webpack_require__(56);

/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */
var Component = /** @class */ (function () {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */
    function Component(name, instanceFactory, type) {
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */
        this.serviceProps = {};
        this.instantiationMode = "LAZY" /* LAZY */;
    }
    Component.prototype.setInstantiationMode = function (mode) {
        this.instantiationMode = mode;
        return this;
    };
    Component.prototype.setMultipleInstances = function (multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    };
    Component.prototype.setServiceProps = function (props) {
        this.serviceProps = props;
        return this;
    };
    return Component;
}());

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DEFAULT_ENTRY_NAME = '[DEFAULT]';

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */
var Provider = /** @class */ (function () {
    function Provider(name, container) {
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
    }
    /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */
    Provider.prototype.get = function (identifier) {
        if (identifier === void 0) { identifier = DEFAULT_ENTRY_NAME; }
        // if multipleInstances is not supported, use the default name
        var normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            var deferred = new util.Deferred();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            // If the service instance is available, resolve the promise with it immediately
            try {
                var instance = this.getOrInitializeService(normalizedIdentifier);
                if (instance) {
                    deferred.resolve(instance);
                }
            }
            catch (e) {
                // when the instance factory throws an exception during get(), it should not cause
                // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    };
    Provider.prototype.getImmediate = function (options) {
        var _a = tslib.__assign({ identifier: DEFAULT_ENTRY_NAME, optional: false }, options), identifier = _a.identifier, optional = _a.optional;
        // if multipleInstances is not supported, use the default name
        var normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        try {
            var instance = this.getOrInitializeService(normalizedIdentifier);
            if (!instance) {
                if (optional) {
                    return null;
                }
                throw Error("Service " + this.name + " is not available");
            }
            return instance;
        }
        catch (e) {
            if (optional) {
                return null;
            }
            else {
                throw e;
            }
        }
    };
    Provider.prototype.getComponent = function () {
        return this.component;
    };
    Provider.prototype.setComponent = function (component) {
        var e_1, _a;
        if (component.name !== this.name) {
            throw Error("Mismatching Component " + component.name + " for Provider " + this.name + ".");
        }
        if (this.component) {
            throw Error("Component for " + this.name + " has already been provided");
        }
        this.component = component;
        // if the service is eager, initialize the default instance
        if (isComponentEager(component)) {
            try {
                this.getOrInitializeService(DEFAULT_ENTRY_NAME);
            }
            catch (e) {
                // when the instance factory for an eager Component throws an exception during the eager
                // initialization, it should not cause a fatal error.
                // TODO: Investigate if we need to make it configurable, because some component may want to cause
                // a fatal error in this case?
            }
        }
        try {
            // Create service instances for the pending promises and resolve them
            // NOTE: if this.multipleInstances is false, only the default instance will be created
            // and all promises with resolve with it regardless of the identifier.
            for (var _b = tslib.__values(this.instancesDeferred.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = tslib.__read(_c.value, 2), instanceIdentifier = _d[0], instanceDeferred = _d[1];
                var normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
                try {
                    // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                    var instance = this.getOrInitializeService(normalizedIdentifier);
                    instanceDeferred.resolve(instance);
                }
                catch (e) {
                    // when the instance factory throws an exception, it should not cause
                    // a fatal error. We just leave the promise unresolved.
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    Provider.prototype.clearInstance = function (identifier) {
        if (identifier === void 0) { identifier = DEFAULT_ENTRY_NAME; }
        this.instancesDeferred.delete(identifier);
        this.instances.delete(identifier);
    };
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    Provider.prototype.delete = function () {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var services;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        services = Array.from(this.instances.values());
                        return [4 /*yield*/, Promise.all(tslib.__spread(services
                                .filter(function (service) { return 'INTERNAL' in service; }) // legacy services
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                .map(function (service) { return service.INTERNAL.delete(); }), services
                                .filter(function (service) { return '_delete' in service; }) // modularized services
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                .map(function (service) { return service._delete(); })))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Provider.prototype.isComponentSet = function () {
        return this.component != null;
    };
    Provider.prototype.getOrInitializeService = function (identifier) {
        var instance = this.instances.get(identifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, normalizeIdentifierForFactory(identifier));
            this.instances.set(identifier, instance);
        }
        return instance || null;
    };
    Provider.prototype.normalizeInstanceIdentifier = function (identifier) {
        if (this.component) {
            return this.component.multipleInstances ? identifier : DEFAULT_ENTRY_NAME;
        }
        else {
            return identifier; // assume multiple instances are supported before the component is provided.
        }
    };
    return Provider;
}());
// undefined should be passed to the service factory for the default instance
function normalizeIdentifierForFactory(identifier) {
    return identifier === DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* EAGER */;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */
var ComponentContainer = /** @class */ (function () {
    function ComponentContainer(name) {
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */
    ComponentContainer.prototype.addComponent = function (component) {
        var provider = this.getProvider(component.name);
        if (provider.isComponentSet()) {
            throw new Error("Component " + component.name + " has already been registered with " + this.name);
        }
        provider.setComponent(component);
    };
    ComponentContainer.prototype.addOrOverwriteComponent = function (component) {
        var provider = this.getProvider(component.name);
        if (provider.isComponentSet()) {
            // delete the existing provider from the container, so we can register the new component
            this.providers.delete(component.name);
        }
        this.addComponent(component);
    };
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */
    ComponentContainer.prototype.getProvider = function (name) {
        if (this.providers.has(name)) {
            return this.providers.get(name);
        }
        // create a Provider for a service that hasn't registered with Firebase
        var provider = new Provider(name, this);
        this.providers.set(name, provider);
        return provider;
    };
    ComponentContainer.prototype.getProviders = function () {
        return Array.from(this.providers.values());
    };
    return ComponentContainer;
}());

exports.Component = Component;
exports.ComponentContainer = ComponentContainer;
exports.Provider = Provider;
//# sourceMappingURL=index.cjs.js.map


/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return eventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);

var eventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export Store */
/* unused harmony export install */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return mapState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return mapMutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return mapGetters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mapActions; });
/* unused harmony export createNamespacedHelpers */
/**
 * vuex v3.1.1
 * (c) 2019 Evan You
 * @license MIT
 */
function applyMixin (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if ( options === void 0 ) options = {};

      options.init = options.init
        ? [vuexInit].concat(options.init)
        : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit () {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function'
        ? options.store()
        : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
}

var target = typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
    ? global
    : {};
var devtoolHook = target.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin (store) {
  if (!devtoolHook) { return }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */

/**
 * forEach for object
 */
function forEachValue (obj, fn) {
  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isPromise (val) {
  return val && typeof val.then === 'function'
}

function assert (condition, msg) {
  if (!condition) { throw new Error(("[vuex] " + msg)) }
}

function partial (fn, arg) {
  return function () {
    return fn(arg)
  }
}

// Base data struct for store's module, package with some attribute and method
var Module = function Module (rawModule, runtime) {
  this.runtime = runtime;
  // Store some children item
  this._children = Object.create(null);
  // Store the origin module object which passed by programmer
  this._rawModule = rawModule;
  var rawState = rawModule.state;

  // Store the origin module's state
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors = { namespaced: { configurable: true } };

prototypeAccessors.namespaced.get = function () {
  return !!this._rawModule.namespaced
};

Module.prototype.addChild = function addChild (key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild (key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild (key) {
  return this._children[key]
};

Module.prototype.update = function update (rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild (fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter (fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction (fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation (fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties( Module.prototype, prototypeAccessors );

var ModuleCollection = function ModuleCollection (rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get (path) {
  return path.reduce(function (module, key) {
    return module.getChild(key)
  }, this.root)
};

ModuleCollection.prototype.getNamespace = function getNamespace (path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '')
  }, '')
};

ModuleCollection.prototype.update = function update$1 (rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
    var this$1 = this;
    if ( runtime === void 0 ) runtime = true;

  if (false) {
    assertRawModule(path, rawModule);
  }

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  if (!parent.getChild(key).runtime) { return }

  parent.removeChild(key);
};

function update (path, targetModule, newModule) {
  if (false) {
    assertRawModule(path, newModule);
  }

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if (false) {
          console.warn(
            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
            'manual reload is needed'
          );
        }
        return
      }
      update(
        path.concat(key),
        targetModule.getChild(key),
        newModule.modules[key]
      );
    }
  }
}

var functionAssert = {
  assert: function (value) { return typeof value === 'function'; },
  expected: 'function'
};

var objectAssert = {
  assert: function (value) { return typeof value === 'function' ||
    (typeof value === 'object' && typeof value.handler === 'function'); },
  expected: 'function or object with "handler" function'
};

var assertTypes = {
  getters: functionAssert,
  mutations: functionAssert,
  actions: objectAssert
};

function assertRawModule (path, rawModule) {
  Object.keys(assertTypes).forEach(function (key) {
    if (!rawModule[key]) { return }

    var assertOptions = assertTypes[key];

    forEachValue(rawModule[key], function (value, type) {
      assert(
        assertOptions.assert(value),
        makeAssertionMessage(path, key, type, value, assertOptions.expected)
      );
    });
  });
}

function makeAssertionMessage (path, key, type, value, expected) {
  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
  if (path.length > 0) {
    buf += " in module \"" + (path.join('.')) + "\"";
  }
  buf += " is " + (JSON.stringify(value)) + ".";
  return buf
}

var Vue; // bind on install

var Store = function Store (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if (false) {
    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    assert(this instanceof Store, "store must be called with the new operator.");
  }

  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
  var strict = options.strict; if ( strict === void 0 ) strict = false;

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch (type, payload) {
    return dispatch.call(store, type, payload)
  };
  this.commit = function boundCommit (type, payload, options) {
    return commit.call(store, type, payload, options)
  };

  // strict mode
  this.strict = strict;

  var state = this._modules.root.state;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) { return plugin(this$1); });

  var useDevtools = options.devtools !== undefined ? options.devtools : Vue.config.devtools;
  if (useDevtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors$1 = { state: { configurable: true } };

prototypeAccessors$1.state.get = function () {
  return this._vm._data.$$state
};

prototypeAccessors$1.state.set = function (v) {
  if (false) {
    assert(false, "use store.replaceState() to explicit replace store state.");
  }
};

Store.prototype.commit = function commit (_type, _payload, _options) {
    var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    if (false) {
      console.error(("[vuex] unknown mutation type: " + type));
    }
    return
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator (handler) {
      handler(payload);
    });
  });
  this._subscribers.forEach(function (sub) { return sub(mutation, this$1.state); });

  if (
    false
  ) {
    console.warn(
      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
      'Use the filter functionality in the vue-devtools'
    );
  }
};

Store.prototype.dispatch = function dispatch (_type, _payload) {
    var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    if (false) {
      console.error(("[vuex] unknown action type: " + type));
    }
    return
  }

  try {
    this._actionSubscribers
      .filter(function (sub) { return sub.before; })
      .forEach(function (sub) { return sub.before(action, this$1.state); });
  } catch (e) {
    if (false) {
      console.warn("[vuex] error in before action subscribers: ");
      console.error(e);
    }
  }

  var result = entry.length > 1
    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
    : entry[0](payload);

  return result.then(function (res) {
    try {
      this$1._actionSubscribers
        .filter(function (sub) { return sub.after; })
        .forEach(function (sub) { return sub.after(action, this$1.state); });
    } catch (e) {
      if (false) {
        console.warn("[vuex] error in after action subscribers: ");
        console.error(e);
      }
    }
    return res
  })
};

Store.prototype.subscribe = function subscribe (fn) {
  return genericSubscribe(fn, this._subscribers)
};

Store.prototype.subscribeAction = function subscribeAction (fn) {
  var subs = typeof fn === 'function' ? { before: fn } : fn;
  return genericSubscribe(subs, this._actionSubscribers)
};

Store.prototype.watch = function watch (getter, cb, options) {
    var this$1 = this;

  if (false) {
    assert(typeof getter === 'function', "store.watch only accepts a function.");
  }
  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
};

Store.prototype.replaceState = function replaceState (state) {
    var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule (path, rawModule, options) {
    if ( options === void 0 ) options = {};

  if (typeof path === 'string') { path = [path]; }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
    assert(path.length > 0, 'cannot register the root module by using registerModule.');
  }

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule (path) {
    var this$1 = this;

  if (typeof path === 'string') { path = [path]; }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hotUpdate = function hotUpdate (newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit (fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties( Store.prototype, prototypeAccessors$1 );

function genericSubscribe (fn, subs) {
  if (subs.indexOf(fn) < 0) {
    subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  }
}

function resetStore (store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM (store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    // direct inline function use will lead to closure preserving oldVm.
    // using partial to return function with only arguments preserved in closure enviroment.
    computed[key] = partial(fn, store);
    Object.defineProperty(store.getters, key, {
      get: function () { return store._vm[key]; },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () { return oldVm.$destroy(); });
  }
}

function installModule (store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext (store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      return store.dispatch(type, payload)
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace
        ? function () { return store.getters; }
        : function () { return makeLocalGetters(store, namespace); }
    },
    state: {
      get: function () { return getNestedState(store.state, path); }
    }
  });

  return local
}

function makeLocalGetters (store, namespace) {
  var gettersProxy = {};

  var splitPos = namespace.length;
  Object.keys(store.getters).forEach(function (type) {
    // skip if the target getter is not match this namespace
    if (type.slice(0, splitPos) !== namespace) { return }

    // extract local getter type
    var localType = type.slice(splitPos);

    // Add a port to the getters proxy.
    // Define as getter property because
    // we do not want to evaluate the getters in this time.
    Object.defineProperty(gettersProxy, localType, {
      get: function () { return store.getters[type]; },
      enumerable: true
    });
  });

  return gettersProxy
}

function registerMutation (store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler (payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction (store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler (payload, cb) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload, cb);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err
      })
    } else {
      return res
    }
  });
}

function registerGetter (store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if (false) {
      console.error(("[vuex] duplicate getter key: " + type));
    }
    return
  }
  store._wrappedGetters[type] = function wrappedGetter (store) {
    return rawGetter(
      local.state, // local state
      local.getters, // local getters
      store.state, // root state
      store.getters // root getters
    )
  };
}

function enableStrictMode (store) {
  store._vm.$watch(function () { return this._data.$$state }, function () {
    if (false) {
      assert(store._committing, "do not mutate vuex store state outside mutation handlers.");
    }
  }, { deep: true, sync: true });
}

function getNestedState (state, path) {
  return path.length
    ? path.reduce(function (state, key) { return state[key]; }, state)
    : state
}

function unifyObjectStyle (type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if (false) {
    assert(typeof type === 'string', ("expects string as the type, but found " + (typeof type) + "."));
  }

  return { type: type, payload: payload, options: options }
}

function install (_Vue) {
  if (Vue && _Vue === Vue) {
    if (false) {
      console.error(
        '[vuex] already installed. Vue.use(Vuex) should be called only once.'
      );
    }
    return
  }
  Vue = _Vue;
  applyMixin(Vue);
}

/**
 * Reduce the code which written in Vue.js for getting the state.
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} states # Object's item can be a function which accept state and getters for param, you can do something for state and getters in it.
 * @param {Object}
 */
var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState () {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function'
        ? val.call(this, state, getters)
        : state[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for committing the mutation
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} mutations # Object's item can be a function which accept `commit` function as the first param, it can accept anthor params. You can commit mutation and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      // Get the commit method from store
      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return
        }
        commit = module.context.commit;
      }
      return typeof val === 'function'
        ? val.apply(this, [commit].concat(args))
        : commit.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for getting the getters
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} getters
 * @return {Object}
 */
var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    // The namespace has been mutated by normalizeNamespace
    val = namespace + val;
    res[key] = function mappedGetter () {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return
      }
      if (false) {
        console.error(("[vuex] unknown getter: " + val));
        return
      }
      return this.$store.getters[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for dispatch the action
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} actions # Object's item can be a function which accept `dispatch` function as the first param, it can accept anthor params. You can dispatch action and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      // get dispatch function from store
      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function'
        ? val.apply(this, [dispatch].concat(args))
        : dispatch.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

/**
 * Rebinding namespace param for mapXXX function in special scoped, and return them by simple object
 * @param {String} namespace
 * @return {Object}
 */
var createNamespacedHelpers = function (namespace) { return ({
  mapState: mapState.bind(null, namespace),
  mapGetters: mapGetters.bind(null, namespace),
  mapMutations: mapMutations.bind(null, namespace),
  mapActions: mapActions.bind(null, namespace)
}); };

/**
 * Normalize the map
 * normalizeMap([1, 2, 3]) => [ { key: 1, val: 1 }, { key: 2, val: 2 }, { key: 3, val: 3 } ]
 * normalizeMap({a: 1, b: 2, c: 3}) => [ { key: 'a', val: 1 }, { key: 'b', val: 2 }, { key: 'c', val: 3 } ]
 * @param {Array|Object} map
 * @return {Object}
 */
function normalizeMap (map) {
  return Array.isArray(map)
    ? map.map(function (key) { return ({ key: key, val: key }); })
    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
}

/**
 * Return a function expect two param contains namespace and map. it will normalize the namespace and then the param's function will handle the new namespace and the map.
 * @param {Function} fn
 * @return {Function}
 */
function normalizeNamespace (fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map)
  }
}

/**
 * Search a special module from store by namespace. if module not exist, print error message.
 * @param {Object} store
 * @param {String} helper
 * @param {String} namespace
 * @return {Object}
 */
function getModuleByNamespace (store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if (false) {
    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
  }
  return module
}

var index_esm = {
  Store: Store,
  install: install,
  version: '3.1.1',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers
};

/* harmony default export */ __webpack_exports__["a"] = (index_esm);


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(20)))

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Loader_vue__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Snackbar_vue__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_router__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_store__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__foreGroundMessage__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_styles_main_style_css__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_styles_main_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_styles_main_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_styles_media_query_css__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_styles_media_query_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_styles_media_query_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_d3__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_d3__);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_d3___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('lco-loader', __WEBPACK_IMPORTED_MODULE_2__Loader_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('lco-message', __WEBPACK_IMPORTED_MODULE_3__Snackbar_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('getStringellips', function (data) {
    if (data) {
        return data;
    }
    return '---';
});

var vueMain = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_4__router_router__["a" /* router */],
    store: __WEBPACK_IMPORTED_MODULE_5__store_store__["a" /* store */],
    render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
    }
});

/* harmony default export */ __webpack_exports__["default"] = (vueMain);

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eventBus__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_description_firebaseIssue__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_description_firebaseIssue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_description_firebaseIssue__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app",
  data: function data() {
    return {
      isActive: false,
      isMessage: false,
      message: "",
      backgroundColor: "",
      leftalign: 0,
      minwidth: 0,
      topalign: 0,
      snackbarClass: "snackbar"
    };
  },

  watch: {
    $route: function $route() {
      this.checkStatusRoute();
      this.isMessage = false;
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["getMode", "getSubuserInfo", "getSideNavInfo", 'getsideNav', 'getUniqueCustomerId']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["e" /* mapState */])(["version"])),
  methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["actGetUserInfo", 'actGetSubuserInfo']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])(["setUserInfo"]), {
    checkStatusRoute: function checkStatusRoute() {
      console.log(this.$route.name);
      if (this.$route.name !== "register" && this.$route.name !== "changepassword" && this.$route.name !== "support" && this.$route.name !== "helpcenter" && this.$route.name !== "privacy" && this.$route.name !== "covid19awareness" && this.$route.name !== "covid19awarenessid" && this.$route.name !== "maintenance" && this.$route.name !== "newportal" && this.$route.name !== "maintenancelogin" && this.$route.name !== "termsforservices" && this.$route.name !== "paymentstatuscheck" && this.$route.name !== "supportlogin") {
        if (!localStorage.getItem("NXTDigitalUser")) {
          this.$router.push({ name: "login" });
        }
      }
    },
    updatedUser: function updatedUser() {
      var _this = this;

      var user = JSON.parse(localStorage.getItem("subUser"));
      this.actGetUserInfo().then(function (response) {
        if (user) {
          if (user.lcosubuserid) {
            _this.getSubUserData(response.credit);
          } else {
            _this.setUserInfo(response);
            localStorage.setItem("NXTDigitalUser", JSON.stringify(response));
            if (_this.getMode == "development") {
              _this.setUserInfo(JSON.parse(localStorage.getItem("NXTDigitalUser")));
            }
          }
        } else {
          localStorage.removeItem("NXTDigitalUser");
          localStorage.removeItem("subUser");
          localStorage.removeItem("showDashboardPopup");
          _this.$router.push({ name: "login" });
        }
      }, function (error) {
        localStorage.removeItem("NXTDigitalUser");
        localStorage.removeItem("subUser");
        localStorage.removeItem("showDashboardPopup");
        _this.$router.push({ name: "login" });
      });
    },
    getSubUserData: function getSubUserData(credit) {
      var _this2 = this;

      var data = {};
      var user = JSON.parse(localStorage.getItem("subUser"));
      data.subuserid = user.lcosubuserid;
      this.actGetUserInfo(data).then(function (response) {
        response.credit = credit;
        _this2.setUserInfo(response);
        localStorage.setItem("NXTDigitalUser", JSON.stringify(response));
        localStorage.setItem("subUser", JSON.stringify(response));
        if (_this2.getMode == "development") {
          _this2.setUserInfo(JSON.parse(localStorage.getItem("NXTDigitalUser")));
        }
      }, function (error) {
        localStorage.removeItem("NXTDigitalUser");
        localStorage.removeItem("subUser");
        _this2.$router.push({ name: "login" });
      });
    },
    checkConnection: function checkConnection() {
      var _this3 = this;

      window.addEventListener("offline", function () {
        _this3.isMessage = true;
        _this3.message = "Please Check Your Internet Connection";
        _this3.backgroundColor = "#EC4C47";
        _this3.minwidth = "100";
        _this3.snackbarClass = "login-snackbar";
        setTimeout(function () {
          _this3.isMessage = false;
        }, 3000);
      });
    },
    messagesSnackbar: function messagesSnackbar() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0__eventBus__["a" /* eventBus */].$on("lco-message", function (state) {
        console.log("entered app.vue", state);
        _this4.message = state.message;
        console.log("message ", _this4.message);
        if (!_this4.message) {
          return;
        }
        console.log(_typeof(_this4.message));
        if (_typeof(_this4.message) == "object") {
          _this4.message = "No valid session exist";
          return;
        }

        if (!state.backgroundColor) {
          _this4.backgroundColor = "#EC4C47";
        } else {
          _this4.backgroundColor = "#47B881";
        }
        _this4.isMessage = state.status;

        // if (!state.leftalign) {
        //   this.leftalign = 15;
        // } else {
        //   this.leftalign = state.leftalign;
        // }

        // if (!state.minwidth) {
        //   this.minwidth = 85;
        // } else {
        //   this.minwidth = state.minwidth;
        // }

        if (_this4.message == "No valid session exist") {
          localStorage.removeItem("NXTDigitalUser");
          localStorage.removeItem("subUser");
          localStorage.removeItem("token");
          localStorage.removeItem("showDashboardPopup");
          _this4.topalign = 0;
          _this4.leftalign = 0;
          _this4.minwidth = 100;
          _this4.snackbarClass = "login-snackbar";
          _this4.$router.push({ name: "login" });
        }
        if (_this4.message == "User is not valid.") {
          _this4.$router.push({ name: "login" });
          localStorage.removeItem("NXTDigitalUser");
          localStorage.removeItem("subUser");
          localStorage.removeItem("token");
          localStorage.removeItem("showDashboardPopup");
          _this4.topalign = 0;
          _this4.leftalign = 0;
          _this4.minwidth = 100;
          _this4.snackbarClass = "login-snackbar";
        }
        if (_this4.message == "Unauthorized") {
          localStorage.removeItem("NXTDigitalUser");
          localStorage.removeItem("subUser");
          localStorage.removeItem("token");
          localStorage.removeItem("showDashboardPopup");
          _this4.topalign = 0;
          _this4.leftalign = 0;
          _this4.minwidth = 100;
          _this4.snackbarClass = "login-snackbar";
          _this4.message = "No valid session exist";
        }

        if (window.matchMedia("(max-width: 1024px)").matches) {
          _this4.leftalign = 0;
          _this4.minwidth = 100;
          _this4.rightalign = 0;
        } else {
          _this4.rightalign = "-6px";
        }

        // console.log("message ", this.message);
        // // if (this.leftalign == 15.4) {
        // //   this.leftalign = 14.5;
        // //   this.minwidth = 86;
        // // }
        // console.log("route name ", this.$route.name);

        // if (window.matchMedia("(min-width: 1025px)").matches) {
        //   if (
        //     this.$route.name == "login" ||
        //     this.$route.name == "register" ||
        //     this.$route.name == "changepassword" ||
        //     this.$route.name == "paymentstatuscheck" ||
        //     this.$route.name == "contactverify" ||
        //     this.message == "No valid session exist"
        //   ) {
        //     console.log("entered");
        //     this.topalign = 0;
        //     this.leftalign = 0;
        //     this.minwidth = 100;
        //     this.snackbarClass = "login-snackbar";
        //   } else if (
        //     this.$route.name == "dashboard" ||
        //     this.$route.name == "alert" ||
        //     this.$route.name == "quiz" ||
        //     this.$route.name == "download" ||
        //     this.$route.name == "checkout" ||
        //     this.$route.name == "topup" ||
        //     this.$route.name == "subuser" ||
        //     this.$route.name == "generatenewinvoice" ||
        //     this.$route.name == "invoicecheckout"
        //   ) {
        //     this.topalign = 42;
        //     this.leftalign = 5;
        //     this.minwidth = 95;
        //     this.snackbarClass = "snackbar";
        //   } else {
        //     if (this.getsideNav) {
        //       this.topalign = 42;
        //       this.leftalign = 15.4;
        //       this.minwidth = 86;
        //       this.snackbarClass = "snackbar";
        //     } else {
        //       this.topalign = 42;
        //       this.leftalign = 5;
        //       this.minwidth = 95;
        //       this.snackbarClass = "snackbar";
        //     }
        //   }
        // } else {
        //   this.topalign = 0;
        //   this.leftalign = 0;
        //   this.minwidth = 100;
        //   this.snackbarClass = "login-snackbar";
        // }
        // if (this.getUniqueCustomerId) {
        //   this.topalign = 42;
        //   this.leftalign = 2.5;
        //   this.minwidth = 95;
        //   this.snackbarClass = "snackbar";
        // }
        setTimeout(function () {
          _this4.isMessage = false;
        }, 3000);
      });
    },
    checkoutMessage: function checkoutMessage() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_0__eventBus__["a" /* eventBus */].$on("checkout-message", function (state) {
        if (!state.backgroundColor) {
          _this5.backgroundColor = "#EC4C47";
        } else {
          _this5.backgroundColor = "#47B881";
        }
        _this5.isMessage = true;
        _this5.message = state.message;
        _this5.topalign = 42;
        // this.leftalign = 15.4;
        _this5.minwidth = 100;
        _this5.snackbarClass = "snackbar";
        setTimeout(function () {
          _this5.isMessage = false;
        }, 3000);
      });
    },
    hideMessage: function hideMessage() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_0__eventBus__["a" /* eventBus */].$on("hide-message", function (state) {
        _this6.isMessage = state;
      });
    },
    events: function events() {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_0__eventBus__["a" /* eventBus */].$on("lco-loader", function (state) {
        _this7.isActive = state;
      });
      __WEBPACK_IMPORTED_MODULE_0__eventBus__["a" /* eventBus */].$on("updateLocalStorage", function (state) {
        _this7.updatedUser();
      });
    }
  }),
  mounted: function mounted() {
    if (JSON.parse(localStorage.getItem("NXTDigitalUser"))) {
      this.updatedUser();
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (localStorage.getItem("NXTDigitalUser")) {
      next();
    } else {
      next({ name: "login" });
    }
  },
  created: function created() {
    // if(this.getMode != "development") {
    //   console.log = function() {}
    // }
    this.events();
    this.messagesSnackbar();
    this.checkoutMessage();
    this.hideMessage();
    console.log("version:::", this.version);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_0__eventBus__["a" /* eventBus */].$off("lco-loader");
    __WEBPACK_IMPORTED_MODULE_0__eventBus__["a" /* eventBus */].$off("lco-message");
    __WEBPACK_IMPORTED_MODULE_0__eventBus__["a" /* eventBus */].$off("checkout-message");
    __WEBPACK_IMPORTED_MODULE_0__eventBus__["a" /* eventBus */].$off("hide-message");
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['message', 'backgroundColor', 'leftalign', 'minwidth', "rightalign", "topalign", "snackbarClass"],
  created: function created() {
    console.log("snackbar ", this.topalign);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_registrationModule__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_headerModule__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_dashboardModule__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_alertModule__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_customerModule__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_productModule_addpacksModule__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_productModule_packsModule__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_productModule_renewModule__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_productModule_modifyModule__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_productModule_bulkModule__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_deviceModule__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_reportModule__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modules_downloadModule__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modules_cartSubscribeModule__ = __webpack_require__(229);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);




















var serverType = 'PROD';
var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: {
        name: 'NXTDigital LCO Portal',
        version: 'v1.0.6',
        mode: "production",
        baseUrl: getAPIUrl(),
        firebaseUrl: 'https://imcl-lco-35e48.firebaseio.com',
        userInfo: undefined,
        subuserInfo: undefined,
        SubscriberDetails: undefined,
        getCartDetails: {},
        pageNameProduct: '',
        AutoRenewItem: {},
        getCustomerNumber: undefined,
        getCheckoutDetails: {},
        getSideNavInfoDetails: '',
        ReportQueueing: {},
        invoiceCartDetails: {},
        sideNav: true,
        customerEnteredId: '',
        uniqueCustomerId: '',
        showAllModule: '',
        ottVerifiedUsers: {},
        changeBasePack: {},
        changeValidity: {},
        SMSTemplates: [{ smsid: 'SMS1',
            content: 'Dear Subscriber, Your NXTDigital TV subscription is due to expire in next 5 days. Please contact your local cable operator OR call us on 1800 210 0300 to avoid service disruption',
            displayText: 'Expiry in 5 days' }, { smsid: 'SMS2',
            content: 'Dear Subscriber, Your NXTDigital TV subscription is due to expire in next 3 days. Please contact your local cable operator OR call us on 1800 210 0300 to avoid service disruption',
            displayText: 'Expiry in 3 days' }, { smsid: 'SMS3',
            content: 'Dear Subscriber, Your NXTDigital TV subscription is due to expire TOMORROW. Please contact your local cable operator OR call us on 1800 210 0300 to avoid service disruption',
            displayText: 'Expiring tomorrow' }, { smsid: 'SMS4',
            content: 'Dear Subscriber, Your NXTDigital TV subscription HAS EXPIRED. Please contact your local cable operator OR call us on 1800 210 0300 to RENEW',
            displayText: 'Expired' }],
        verifiedBroadbandCustomer: false,
        sitekey: captchaSiteKey(serverType) ? '6LfVCHYoAAAAALYgugUK5noScAmzDzugh2_LnItm' : '6Lf0DHYoAAAAADWhvp559CdGFYVyddD_ifbD-tG3',
        cryptoSecretKey: 'CBCSHAAES256',
        cryptoIVKey: 'CBCSHAAES256VECTOR',
        whatsappURL: 'https://api.whatsapp.com/send?phone=919004815767&&text=Hello',
        uniqueNewCustomerId: '',
        renewTypeDashboard: ''
    },
    getters: __WEBPACK_IMPORTED_MODULE_2__getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_4__actions__,
    modules: {
        registrationModule: __WEBPACK_IMPORTED_MODULE_5__modules_registrationModule__["a" /* default */],
        headerModule: __WEBPACK_IMPORTED_MODULE_6__modules_headerModule__["a" /* default */],
        dashboardModule: __WEBPACK_IMPORTED_MODULE_7__modules_dashboardModule__["a" /* default */],
        alertModule: __WEBPACK_IMPORTED_MODULE_8__modules_alertModule__["a" /* default */],
        customerModule: __WEBPACK_IMPORTED_MODULE_9__modules_customerModule__["a" /* default */],
        addpacksModule: __WEBPACK_IMPORTED_MODULE_10__modules_productModule_addpacksModule__["a" /* default */],
        packsModule: __WEBPACK_IMPORTED_MODULE_11__modules_productModule_packsModule__["a" /* default */],
        renewModule: __WEBPACK_IMPORTED_MODULE_12__modules_productModule_renewModule__["a" /* default */],
        modifyModule: __WEBPACK_IMPORTED_MODULE_13__modules_productModule_modifyModule__["a" /* default */],
        bulkModule: __WEBPACK_IMPORTED_MODULE_14__modules_productModule_bulkModule__["a" /* default */],
        deviceModule: __WEBPACK_IMPORTED_MODULE_15__modules_deviceModule__["a" /* default */],
        reportModule: __WEBPACK_IMPORTED_MODULE_16__modules_reportModule__["a" /* default */],
        downloadModule: __WEBPACK_IMPORTED_MODULE_17__modules_downloadModule__["a" /* default */],
        cartSubscribeModule: __WEBPACK_IMPORTED_MODULE_18__modules_cartSubscribeModule__["a" /* default */]
    }
});
function captchaSiteKey(data) {
    console.log(data);
    if (data == 'UAT') {
        return true;
    }
    return false;
}
function getAPIUrl() {
    var isLocalhost = window.location.origin.includes('localhost');
    return isLocalhost
    //   ? 'https://lcoportalbeta.mobiotics.com/' 
    ? 'https://lcoportalnew7.nxtdigital.in/' : window.location.origin + '/';
};

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bisectRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bisectLeft; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisector__ = __webpack_require__(108);



var ascendingBisect = Object(__WEBPACK_IMPORTED_MODULE_1__bisector__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]);
var bisectRight = ascendingBisect.right;
var bisectLeft = ascendingBisect.left;
/* harmony default export */ __webpack_exports__["c"] = (bisectRight);


/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(21);


/* harmony default export */ __webpack_exports__["a"] = (function(compare) {
  if (compare.length === 1) compare = ascendingComparator(compare);
  return {
    left: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) < 0) lo = mid + 1;
        else hi = mid;
      }
      return lo;
    },
    right: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) > 0) hi = mid;
        else lo = mid + 1;
      }
      return lo;
    }
  };
});

function ascendingComparator(f) {
  return function(d, x) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */])(f(d), x);
  };
}


/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = pair;
/* harmony default export */ __webpack_exports__["a"] = (function(array, f) {
  if (f == null) f = pair;
  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
  while (i < n) pairs[i] = f(p, p = array[++i]);
  return pairs;
});

function pair(a, b) {
  return [a, b];
}


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__variance__ = __webpack_require__(111);


/* harmony default export */ __webpack_exports__["a"] = (function(array, f) {
  var v = Object(__WEBPACK_IMPORTED_MODULE_0__variance__["a" /* default */])(array, f);
  return v ? Math.sqrt(v) : v;
});


/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(26);


/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      m = 0,
      i = -1,
      mean = 0,
      value,
      delta,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  if (m > 1) return sum / (m - 1);
});


/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  return [min, max];
});


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
var array = Array.prototype;

var slice = array.slice;
var map = array.map;


/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
});


/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = tickIncrement;
/* harmony export (immutable) */ __webpack_exports__["c"] = tickStep;
var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, count) {
  var reverse,
      i = -1,
      n,
      ticks,
      step;

  stop = +stop, start = +start, count = +count;
  if (start === stop && count > 0) return [start];
  if (reverse = stop < start) n = start, start = stop, stop = n;
  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    start = Math.ceil(start / step);
    stop = Math.floor(stop / step);
    ticks = new Array(n = Math.ceil(stop - start + 1));
    while (++i < n) ticks[i] = (start + i) * step;
  } else {
    start = Math.floor(start * step);
    stop = Math.ceil(stop * step);
    ticks = new Array(n = Math.ceil(start - stop + 1));
    while (++i < n) ticks[i] = (start - i) / step;
  }

  if (reverse) ticks.reverse();

  return ticks;
});

function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
});


/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  return min;
});


/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__min__ = __webpack_require__(117);


/* harmony default export */ __webpack_exports__["a"] = (function(matrix) {
  if (!(n = matrix.length)) return [];
  for (var i = -1, m = Object(__WEBPACK_IMPORTED_MODULE_0__min__["a" /* default */])(matrix, length), transpose = new Array(m); ++i < m;) {
    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
      row[j] = matrix[j][i];
    }
  }
  return transpose;
});

function length(d) {
  return d.length;
}


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selection_index__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return typeof selector === "string"
      ? new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([[document.querySelector(selector)]], [document.documentElement])
      : new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([[selector]], __WEBPACK_IMPORTED_MODULE_0__selection_index__["c" /* root */]);
});


/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function empty() {
  return [];
}

/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return selector == null ? empty : function() {
    return this.querySelectorAll(selector);
  };
});


/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var matcher = function(selector) {
  return function() {
    return this.matches(selector);
  };
};

if (typeof document !== "undefined") {
  var element = document.documentElement;
  if (!element.matches) {
    var vendorMatches = element.webkitMatchesSelector
        || element.msMatchesSelector
        || element.mozMatchesSelector
        || element.oMatchesSelector;
    matcher = function(selector) {
      return function() {
        return vendorMatches.call(this, selector);
      };
    };
  }
}

/* harmony default export */ __webpack_exports__["a"] = (matcher);


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = EnterNode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sparse__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(6);



/* harmony default export */ __webpack_exports__["b"] = (function() {
  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Selection */](this._enter || this._groups.map(__WEBPACK_IMPORTED_MODULE_0__sparse__["a" /* default */]), this._parents);
});

function EnterNode(parent, datum) {
  this.ownerDocument = parent.ownerDocument;
  this.namespaceURI = parent.namespaceURI;
  this._next = null;
  this._parent = parent;
  this.__data__ = datum;
}

EnterNode.prototype = {
  constructor: EnterNode,
  appendChild: function(child) { return this._parent.insertBefore(child, this._next); },
  insertBefore: function(child, next) { return this._parent.insertBefore(child, next); },
  querySelector: function(selector) { return this._parent.querySelector(selector); },
  querySelectorAll: function(selector) { return this._parent.querySelectorAll(selector); }
};


/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(update) {
  return new Array(update.length);
});


/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = styleValue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__window__ = __webpack_require__(63);


function styleRemove(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant(name, value, priority) {
  return function() {
    this.style.setProperty(name, value, priority);
  };
}

function styleFunction(name, value, priority) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.style.removeProperty(name);
    else this.style.setProperty(name, v, priority);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value, priority) {
  return arguments.length > 1
      ? this.each((value == null
            ? styleRemove : typeof value === "function"
            ? styleFunction
            : styleConstant)(name, value, priority == null ? "" : priority))
      : styleValue(this.node(), name);
});

function styleValue(node, name) {
  return node.style.getPropertyValue(name)
      || Object(__WEBPACK_IMPORTED_MODULE_0__window__["a" /* default */])(node).getComputedStyle(node, null).getPropertyValue(name);
}


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = yesdrag;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noevent__ = __webpack_require__(126);



/* harmony default export */ __webpack_exports__["a"] = (function(view) {
  var root = view.document.documentElement,
      selection = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["k" /* select */])(view).on("dragstart.drag", __WEBPACK_IMPORTED_MODULE_1__noevent__["a" /* default */], true);
  if ("onselectstart" in root) {
    selection.on("selectstart.drag", __WEBPACK_IMPORTED_MODULE_1__noevent__["a" /* default */], true);
  } else {
    root.__noselect = root.style.MozUserSelect;
    root.style.MozUserSelect = "none";
  }
});

function yesdrag(view, noclick) {
  var root = view.document.documentElement,
      selection = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["k" /* select */])(view).on("dragstart.drag", null);
  if (noclick) {
    selection.on("click.drag", __WEBPACK_IMPORTED_MODULE_1__noevent__["a" /* default */], true);
    setTimeout(function() { selection.on("click.drag", null); }, 0);
  }
  if ("onselectstart" in root) {
    selection.on("selectstart.drag", null);
  } else {
    root.style.MozUserSelect = root.__noselect;
    delete root.__noselect;
  }
}


/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = nopropagation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(1);


function nopropagation() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["e" /* event */].stopImmediatePropagation();
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["e" /* event */].preventDefault();
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["e" /* event */].stopImmediatePropagation();
});


/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deg2rad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return rad2deg; });
var deg2rad = Math.PI / 180;
var rad2deg = 180 / Math.PI;


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return rgbBasis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return rgbBasisClosed; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basisClosed__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__color__ = __webpack_require__(27);





/* harmony default export */ __webpack_exports__["a"] = ((function rgbGamma(y) {
  var color = Object(__WEBPACK_IMPORTED_MODULE_3__color__["b" /* gamma */])(y);

  function rgb(start, end) {
    var r = color((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* rgb */])(start)).r, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* rgb */])(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_3__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb.gamma = rgbGamma;

  return rgb;
})(1));

function rgbSpline(spline) {
  return function(colors) {
    var n = colors.length,
        r = new Array(n),
        g = new Array(n),
        b = new Array(n),
        i, color;
    for (i = 0; i < n; ++i) {
      color = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* rgb */])(colors[i]);
      r[i] = color.r || 0;
      g[i] = color.g || 0;
      b[i] = color.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color.opacity = 1;
    return function(t) {
      color.r = r(t);
      color.g = g(t);
      color.b = b(t);
      return color + "";
    };
  };
}

var rgbBasis = rgbSpline(__WEBPACK_IMPORTED_MODULE_1__basis__["b" /* default */]);
var rgbBasisClosed = rgbSpline(__WEBPACK_IMPORTED_MODULE_2__basisClosed__["a" /* default */]);


/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(69);


/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  var n = values.length;
  return function(t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
        v0 = values[(i + n - 1) % n],
        v1 = values[i % n],
        v2 = values[(i + 1) % n],
        v3 = values[(i + 2) % n];
    return Object(__WEBPACK_IMPORTED_MODULE_0__basis__["a" /* basis */])((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(66);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(na),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = Object(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
});


/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var d = new Date;
  return a = +a, b -= a, function(t) {
    return d.setTime(a + b * t), d;
  };
});


/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(66);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = Object(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
});


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(41);


var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
});


/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transition_schedule__ = __webpack_require__(8);


/* harmony default export */ __webpack_exports__["a"] = (function(node, name) {
  var schedules = node.__transition,
      schedule,
      active,
      empty = true,
      i;

  if (!schedules) return;

  name = name == null ? null : name + "";

  for (i in schedules) {
    if ((schedule = schedules[i]).name !== name) { empty = false; continue; }
    active = schedule.state > __WEBPACK_IMPORTED_MODULE_0__transition_schedule__["d" /* STARTING */] && schedule.state < __WEBPACK_IMPORTED_MODULE_0__transition_schedule__["b" /* ENDING */];
    schedule.state = __WEBPACK_IMPORTED_MODULE_0__transition_schedule__["a" /* ENDED */];
    schedule.timer.stop();
    if (active) schedule.on.call("interrupt", node, node.__data__, schedule.index, schedule.group);
    delete schedules[i];
  }

  if (empty) delete node.__transition;
});


/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var c;
  return (typeof b === "number" ? __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["m" /* interpolateNumber */]
      : b instanceof __WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* color */] ? __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["o" /* interpolateRgb */]
      : (c = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* color */])(b)) ? (b = c, __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["o" /* interpolateRgb */])
      : __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["s" /* interpolateString */])(a, b);
});


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_linear__ = __webpack_require__(324);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_0__src_linear__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_quad__ = __webpack_require__(325);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_1__src_quad__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_1__src_quad__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_1__src_quad__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_1__src_quad__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_cubic__ = __webpack_require__(326);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_2__src_cubic__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_2__src_cubic__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_2__src_cubic__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_2__src_cubic__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_poly__ = __webpack_require__(327);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_3__src_poly__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_3__src_poly__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_3__src_poly__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_3__src_poly__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_sin__ = __webpack_require__(328);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_4__src_sin__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_4__src_sin__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_4__src_sin__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_4__src_sin__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_exp__ = __webpack_require__(329);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_5__src_exp__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_5__src_exp__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_5__src_exp__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_5__src_exp__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_circle__ = __webpack_require__(330);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_6__src_circle__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_6__src_circle__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_6__src_circle__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_6__src_circle__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_bounce__ = __webpack_require__(331);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_7__src_bounce__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_7__src_bounce__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__src_bounce__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_7__src_bounce__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_back__ = __webpack_require__(332);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_8__src_back__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_8__src_back__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_8__src_back__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_8__src_back__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_elastic__ = __webpack_require__(333);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_9__src_elastic__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_9__src_elastic__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_9__src_elastic__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_9__src_elastic__["b"]; });





















/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return sin; });
/* unused harmony export pi */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return halfPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return tau; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return max; });
var cos = Math.cos;
var sin = Math.sin;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = pi * 2;
var max = Math.max;


/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = x;
/* harmony export (immutable) */ __webpack_exports__["c"] = y;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dispatch__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_collection__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_timer__ = __webpack_require__(42);




function x(d) {
  return d.x;
}

function y(d) {
  return d.y;
}

var initialRadius = 10,
    initialAngle = Math.PI * (3 - Math.sqrt(5));

/* harmony default export */ __webpack_exports__["a"] = (function(nodes) {
  var simulation,
      alpha = 1,
      alphaMin = 0.001,
      alphaDecay = 1 - Math.pow(alphaMin, 1 / 300),
      alphaTarget = 0,
      velocityDecay = 0.6,
      forces = Object(__WEBPACK_IMPORTED_MODULE_1_d3_collection__["c" /* map */])(),
      stepper = Object(__WEBPACK_IMPORTED_MODULE_2_d3_timer__["d" /* timer */])(step),
      event = Object(__WEBPACK_IMPORTED_MODULE_0_d3_dispatch__["a" /* dispatch */])("tick", "end");

  if (nodes == null) nodes = [];

  function step() {
    tick();
    event.call("tick", simulation);
    if (alpha < alphaMin) {
      stepper.stop();
      event.call("end", simulation);
    }
  }

  function tick() {
    var i, n = nodes.length, node;

    alpha += (alphaTarget - alpha) * alphaDecay;

    forces.each(function(force) {
      force(alpha);
    });

    for (i = 0; i < n; ++i) {
      node = nodes[i];
      if (node.fx == null) node.x += node.vx *= velocityDecay;
      else node.x = node.fx, node.vx = 0;
      if (node.fy == null) node.y += node.vy *= velocityDecay;
      else node.y = node.fy, node.vy = 0;
    }
  }

  function initializeNodes() {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.index = i;
      if (isNaN(node.x) || isNaN(node.y)) {
        var radius = initialRadius * Math.sqrt(i), angle = i * initialAngle;
        node.x = radius * Math.cos(angle);
        node.y = radius * Math.sin(angle);
      }
      if (isNaN(node.vx) || isNaN(node.vy)) {
        node.vx = node.vy = 0;
      }
    }
  }

  function initializeForce(force) {
    if (force.initialize) force.initialize(nodes);
    return force;
  }

  initializeNodes();

  return simulation = {
    tick: tick,

    restart: function() {
      return stepper.restart(step), simulation;
    },

    stop: function() {
      return stepper.stop(), simulation;
    },

    nodes: function(_) {
      return arguments.length ? (nodes = _, initializeNodes(), forces.each(initializeForce), simulation) : nodes;
    },

    alpha: function(_) {
      return arguments.length ? (alpha = +_, simulation) : alpha;
    },

    alphaMin: function(_) {
      return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
    },

    alphaDecay: function(_) {
      return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
    },

    alphaTarget: function(_) {
      return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
    },

    velocityDecay: function(_) {
      return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
    },

    force: function(name, _) {
      return arguments.length > 1 ? ((_ == null ? forces.remove(name) : forces.set(name, initializeForce(_))), simulation) : forces.get(name);
    },

    find: function(x, y, radius) {
      var i = 0,
          n = nodes.length,
          dx,
          dy,
          d2,
          node,
          closest;

      if (radius == null) radius = Infinity;
      else radius *= radius;

      for (i = 0; i < n; ++i) {
        node = nodes[i];
        dx = x - node.x;
        dy = y - node.y;
        d2 = dx * dx + dy * dy;
        if (d2 < radius) closest = node, radius = d2;
      }

      return closest;
    },

    on: function(name, _) {
      return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
    }
  };
});


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatGroup__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatNumerals__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__formatSpecifier__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__formatTypes__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__formatPrefixAuto__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__identity__ = __webpack_require__(377);








var prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];

/* harmony default export */ __webpack_exports__["a"] = (function(locale) {
  var group = locale.grouping && locale.thousands ? Object(__WEBPACK_IMPORTED_MODULE_1__formatGroup__["a" /* default */])(locale.grouping, locale.thousands) : __WEBPACK_IMPORTED_MODULE_6__identity__["a" /* default */],
      currency = locale.currency,
      decimal = locale.decimal,
      numerals = locale.numerals ? Object(__WEBPACK_IMPORTED_MODULE_2__formatNumerals__["a" /* default */])(locale.numerals) : __WEBPACK_IMPORTED_MODULE_6__identity__["a" /* default */],
      percent = locale.percent || "%";

  function newFormat(specifier) {
    specifier = Object(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier__["a" /* default */])(specifier);

    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        type = specifier.type;

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = __WEBPACK_IMPORTED_MODULE_4__formatTypes__["a" /* default */][type],
        maybeSuffix = !type || /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision == null ? (type ? 6 : 12)
        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i, n, c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Perform the initial formatting.
        var valueNegative = value < 0;
        value = formatType(Math.abs(value), precision);

        // If a negative value rounds to zero during formatting, treat as positive.
        if (valueNegative && +value === 0) valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = (type === "s" ? prefixes[8 + __WEBPACK_IMPORTED_MODULE_5__formatPrefixAuto__["b" /* prefixExponent */] / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }

      return numerals(value);
    }

    format.toString = function() {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = Object(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier__["a" /* default */])(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function(value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
});


/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatSpecifier;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatTypes__ = __webpack_require__(142);


// [[fill]align][sign][symbol][0][width][,][.precision][type]
var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  return new FormatSpecifier(specifier);
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);

  var match,
      fill = match[1] || " ",
      align = match[2] || ">",
      sign = match[3] || "-",
      symbol = match[4] || "",
      zero = !!match[5],
      width = match[6] && +match[6],
      comma = !!match[7],
      precision = match[8] && +match[8].slice(1),
      type = match[9] || "";

  // The "n" type is an alias for ",g".
  if (type === "n") comma = true, type = "g";

  // Map invalid types to the default format.
  else if (!__WEBPACK_IMPORTED_MODULE_0__formatTypes__["a" /* default */][type]) type = "";

  // If zero fill is specified, padding goes after sign and before digits.
  if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

  this.fill = fill;
  this.align = align;
  this.sign = sign;
  this.symbol = symbol;
  this.zero = zero;
  this.width = width;
  this.comma = comma;
  this.precision = precision;
  this.type = type;
}

FormatSpecifier.prototype.toString = function() {
  return this.fill
      + this.align
      + this.sign
      + this.symbol
      + (this.zero ? "0" : "")
      + (this.width == null ? "" : Math.max(1, this.width | 0))
      + (this.comma ? "," : "")
      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
      + this.type;
};


/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDefault__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatPrefixAuto__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatRounded__ = __webpack_require__(376);




/* harmony default export */ __webpack_exports__["a"] = ({
  "": __WEBPACK_IMPORTED_MODULE_0__formatDefault__["a" /* default */],
  "%": function(x, p) { return (x * 100).toFixed(p); },
  "b": function(x) { return Math.round(x).toString(2); },
  "c": function(x) { return x + ""; },
  "d": function(x) { return Math.round(x).toString(10); },
  "e": function(x, p) { return x.toExponential(p); },
  "f": function(x, p) { return x.toFixed(p); },
  "g": function(x, p) { return x.toPrecision(p); },
  "o": function(x) { return Math.round(x).toString(8); },
  "p": function(x, p) { return Object(__WEBPACK_IMPORTED_MODULE_2__formatRounded__["a" /* default */])(x * 100, p); },
  "r": __WEBPACK_IMPORTED_MODULE_2__formatRounded__["a" /* default */],
  "s": __WEBPACK_IMPORTED_MODULE_1__formatPrefixAuto__["a" /* default */],
  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
  "x": function(x) { return Math.round(x).toString(16); }
});


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefixExponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(79);


var prefixExponent;

/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  var d = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, Math.max(0, p + i - 1))[0]; // less than 1y!
});


/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return areaRingSum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return areaStream; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noop__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stream__ = __webpack_require__(16);





var areaRingSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])();

var areaSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    lambda00,
    phi00,
    lambda0,
    cosPhi0,
    sinPhi0;

var areaStream = {
  point: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineStart: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineEnd: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  polygonStart: function() {
    areaRingSum.reset();
    areaStream.lineStart = areaRingStart;
    areaStream.lineEnd = areaRingEnd;
  },
  polygonEnd: function() {
    var areaRing = +areaRingSum;
    areaSum.add(areaRing < 0 ? __WEBPACK_IMPORTED_MODULE_1__math__["w" /* tau */] + areaRing : areaRing);
    this.lineStart = this.lineEnd = this.point = __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */];
  },
  sphere: function() {
    areaSum.add(__WEBPACK_IMPORTED_MODULE_1__math__["w" /* tau */]);
  }
};

function areaRingStart() {
  areaStream.point = areaPointFirst;
}

function areaRingEnd() {
  areaPoint(lambda00, phi00);
}

function areaPointFirst(lambda, phi) {
  areaStream.point = areaPoint;
  lambda00 = lambda, phi00 = phi;
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */];
  lambda0 = lambda, cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi = phi / 2 + __WEBPACK_IMPORTED_MODULE_1__math__["q" /* quarterPi */]), sinPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi);
}

function areaPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */];
  phi = phi / 2 + __WEBPACK_IMPORTED_MODULE_1__math__["q" /* quarterPi */]; // half the angular distance from south pole

  // Spherical excess E for a spherical triangle with vertices: south pole,
  // previous point, current point.  Uses a formula derived from Cagnoli’s
  // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
  var dLambda = lambda - lambda0,
      sdLambda = dLambda >= 0 ? 1 : -1,
      adLambda = sdLambda * dLambda,
      cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi),
      sinPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi),
      k = sinPhi0 * sinPhi,
      u = cosPhi0 * cosPhi + k * Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(adLambda),
      v = k * sdLambda * Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(adLambda);
  areaRingSum.add(Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(v, u));

  // Advance the previous points.
  lambda0 = lambda, cosPhi0 = cosPhi, sinPhi0 = sinPhi;
}

/* harmony default export */ __webpack_exports__["c"] = (function(object) {
  areaSum.reset();
  Object(__WEBPACK_IMPORTED_MODULE_3__stream__["a" /* default */])(object, areaStream);
  return areaSum * 2;
});


/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = circleStream;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cartesian__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rotation__ = __webpack_require__(45);





// Generates a circle centered at [0°, 0°], with a given radius and precision.
function circleStream(stream, radius, delta, direction, t0, t1) {
  if (!delta) return;
  var cosRadius = Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(radius),
      sinRadius = Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" /* sin */])(radius),
      step = direction * delta;
  if (t0 == null) {
    t0 = radius + direction * __WEBPACK_IMPORTED_MODULE_2__math__["w" /* tau */];
    t1 = radius - step / 2;
  } else {
    t0 = circleRadius(cosRadius, t0);
    t1 = circleRadius(cosRadius, t1);
    if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * __WEBPACK_IMPORTED_MODULE_2__math__["w" /* tau */];
  }
  for (var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step) {
    point = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["g" /* spherical */])([cosRadius, -sinRadius * Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(t), -sinRadius * Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" /* sin */])(t)]);
    stream.point(point[0], point[1]);
  }
}

// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
function circleRadius(cosRadius, point) {
  point = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["a" /* cartesian */])(point), point[0] -= cosRadius;
  Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["e" /* cartesianNormalizeInPlace */])(point);
  var radius = Object(__WEBPACK_IMPORTED_MODULE_2__math__["b" /* acos */])(-point[1]);
  return ((-point[2] < 0 ? -radius : radius) + __WEBPACK_IMPORTED_MODULE_2__math__["w" /* tau */] - __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */]) % __WEBPACK_IMPORTED_MODULE_2__math__["w" /* tau */];
}

/* harmony default export */ __webpack_exports__["b"] = (function() {
  var center = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])([0, 0]),
      radius = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(90),
      precision = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(6),
      ring,
      rotate,
      stream = {point: point};

  function point(x, y) {
    ring.push(x = rotate(x, y));
    x[0] *= __WEBPACK_IMPORTED_MODULE_2__math__["h" /* degrees */], x[1] *= __WEBPACK_IMPORTED_MODULE_2__math__["h" /* degrees */];
  }

  function circle() {
    var c = center.apply(this, arguments),
        r = radius.apply(this, arguments) * __WEBPACK_IMPORTED_MODULE_2__math__["r" /* radians */],
        p = precision.apply(this, arguments) * __WEBPACK_IMPORTED_MODULE_2__math__["r" /* radians */];
    ring = [];
    rotate = Object(__WEBPACK_IMPORTED_MODULE_3__rotation__["b" /* rotateRadians */])(-c[0] * __WEBPACK_IMPORTED_MODULE_2__math__["r" /* radians */], -c[1] * __WEBPACK_IMPORTED_MODULE_2__math__["r" /* radians */], 0).invert;
    circleStream(stream, r, p, 1);
    c = {type: "Polygon", coordinates: [ring]};
    ring = rotate = null;
    return c;
  }

  circle.center = function(_) {
    return arguments.length ? (center = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])([+_[0], +_[1]]), circle) : center;
  };

  circle.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), circle) : radius;
  };

  circle.precision = function(_) {
    return arguments.length ? (precision = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), circle) : precision;
  };

  return circle;
});


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {

  function compose(x, y) {
    return x = a(x, y), b(x[0], x[1]);
  }

  if (a.invert && b.invert) compose.invert = function(x, y) {
    return x = b.invert(x, y), x && a.invert(x[0], x[1]);
  };

  return compose;
});


/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])(
  function() { return true; },
  clipAntimeridianLine,
  clipAntimeridianInterpolate,
  [-__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], -__WEBPACK_IMPORTED_MODULE_1__math__["l" /* halfPi */]]
));

// Takes a line and cuts into visible segments. Return values: 0 - there were
// intersections or the line was empty; 1 - no intersections; 2 - there were
// intersections, and the first and last segments should be rejoined.
function clipAntimeridianLine(stream) {
  var lambda0 = NaN,
      phi0 = NaN,
      sign0 = NaN,
      clean; // no intersections

  return {
    lineStart: function() {
      stream.lineStart();
      clean = 1;
    },
    point: function(lambda1, phi1) {
      var sign1 = lambda1 > 0 ? __WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */] : -__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */],
          delta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(lambda1 - lambda0);
      if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(delta - __WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */]) < __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]) { // line crosses a pole
        stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? __WEBPACK_IMPORTED_MODULE_1__math__["l" /* halfPi */] : -__WEBPACK_IMPORTED_MODULE_1__math__["l" /* halfPi */]);
        stream.point(sign0, phi0);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi0);
        stream.point(lambda1, phi0);
        clean = 0;
      } else if (sign0 !== sign1 && delta >= __WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */]) { // line crosses antimeridian
        if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(lambda0 - sign0) < __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]) lambda0 -= sign0 * __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]; // handle degeneracies
        if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(lambda1 - sign1) < __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]) lambda1 -= sign1 * __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */];
        phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
        stream.point(sign0, phi0);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi0);
        clean = 0;
      }
      stream.point(lambda0 = lambda1, phi0 = phi1);
      sign0 = sign1;
    },
    lineEnd: function() {
      stream.lineEnd();
      lambda0 = phi0 = NaN;
    },
    clean: function() {
      return 2 - clean; // if intersections, rejoin first and last segments
    }
  };
}

function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
  var cosPhi0,
      cosPhi1,
      sinLambda0Lambda1 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(lambda0 - lambda1);
  return Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(sinLambda0Lambda1) > __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]
      ? Object(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* atan */])((Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi0) * (cosPhi1 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi1)) * Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(lambda1)
          - Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi1) * (cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi0)) * Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(lambda0))
          / (cosPhi0 * cosPhi1 * sinLambda0Lambda1))
      : (phi0 + phi1) / 2;
}

function clipAntimeridianInterpolate(from, to, direction, stream) {
  var phi;
  if (from == null) {
    phi = direction * __WEBPACK_IMPORTED_MODULE_1__math__["l" /* halfPi */];
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], phi);
    stream.point(0, phi);
    stream.point(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], phi);
    stream.point(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], 0);
    stream.point(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], -phi);
    stream.point(0, -phi);
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], -phi);
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], 0);
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], phi);
  } else if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(from[0] - to[0]) > __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]) {
    var lambda = from[0] < to[0] ? __WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */] : -__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */];
    phi = direction * lambda / 2;
    stream.point(-lambda, phi);
    stream.point(0, phi);
    stream.point(lambda, phi);
  } else {
    stream.point(to[0], to[1]);
  }
}


/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__buffer__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rejoin__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__polygonContains__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_array__ = __webpack_require__(4);






/* harmony default export */ __webpack_exports__["a"] = (function(pointVisible, clipLine, interpolate, start) {
  return function(sink) {
    var line = clipLine(sink),
        ringBuffer = Object(__WEBPACK_IMPORTED_MODULE_0__buffer__["a" /* default */])(),
        ringSink = clipLine(ringBuffer),
        polygonStarted = false,
        polygon,
        segments,
        ring;

    var clip = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() {
        clip.point = pointRing;
        clip.lineStart = ringStart;
        clip.lineEnd = ringEnd;
        segments = [];
        polygon = [];
      },
      polygonEnd: function() {
        clip.point = point;
        clip.lineStart = lineStart;
        clip.lineEnd = lineEnd;
        segments = Object(__WEBPACK_IMPORTED_MODULE_4_d3_array__["n" /* merge */])(segments);
        var startInside = Object(__WEBPACK_IMPORTED_MODULE_3__polygonContains__["a" /* default */])(polygon, start);
        if (segments.length) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          Object(__WEBPACK_IMPORTED_MODULE_1__rejoin__["a" /* default */])(segments, compareIntersection, startInside, interpolate, sink);
        } else if (startInside) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          interpolate(null, null, 1, sink);
          sink.lineEnd();
        }
        if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
        segments = polygon = null;
      },
      sphere: function() {
        sink.polygonStart();
        sink.lineStart();
        interpolate(null, null, 1, sink);
        sink.lineEnd();
        sink.polygonEnd();
      }
    };

    function point(lambda, phi) {
      if (pointVisible(lambda, phi)) sink.point(lambda, phi);
    }

    function pointLine(lambda, phi) {
      line.point(lambda, phi);
    }

    function lineStart() {
      clip.point = pointLine;
      line.lineStart();
    }

    function lineEnd() {
      clip.point = point;
      line.lineEnd();
    }

    function pointRing(lambda, phi) {
      ring.push([lambda, phi]);
      ringSink.point(lambda, phi);
    }

    function ringStart() {
      ringSink.lineStart();
      ring = [];
    }

    function ringEnd() {
      pointRing(ring[0][0], ring[0][1]);
      ringSink.lineEnd();

      var clean = ringSink.clean(),
          ringSegments = ringBuffer.result(),
          i, n = ringSegments.length, m,
          segment,
          point;

      ring.pop();
      polygon.push(ring);
      ring = null;

      if (!n) return;

      // No intersections.
      if (clean & 1) {
        segment = ringSegments[0];
        if ((m = segment.length - 1) > 0) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          for (i = 0; i < m; ++i) sink.point((point = segment[i])[0], point[1]);
          sink.lineEnd();
        }
        return;
      }

      // Rejoin connected segments.
      // TODO reuse ringBuffer.rejoin()?
      if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));

      segments.push(ringSegments.filter(validSegment));
    }

    return clip;
  };
});

function validSegment(segment) {
  return segment.length > 1;
}

// Intersections are sorted along the clip edge. For both antimeridian cutting
// and circle clipping, the same comparison is used.
function compareIntersection(a, b) {
  return ((a = a.x)[0] < 0 ? a[1] - __WEBPACK_IMPORTED_MODULE_2__math__["l" /* halfPi */] - __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */] : __WEBPACK_IMPORTED_MODULE_2__math__["l" /* halfPi */] - a[1])
       - ((b = b.x)[0] < 0 ? b[1] - __WEBPACK_IMPORTED_MODULE_2__math__["l" /* halfPi */] - __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */] : __WEBPACK_IMPORTED_MODULE_2__math__["l" /* halfPi */] - b[1]);
}


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(13);


/* harmony default export */ __webpack_exports__["a"] = (function() {
  var lines = [],
      line;
  return {
    point: function(x, y) {
      line.push([x, y]);
    },
    lineStart: function() {
      lines.push(line = []);
    },
    lineEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
    rejoin: function() {
      if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
    },
    result: function() {
      var result = lines;
      lines = [];
      line = null;
      return result;
    }
  };
});


/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pointEqual__ = __webpack_require__(151);


function Intersection(point, points, other, entry) {
  this.x = point;
  this.z = points;
  this.o = other; // another intersection
  this.e = entry; // is an entry?
  this.v = false; // visited
  this.n = this.p = null; // next & previous
}

// A generalized polygon clipping algorithm: given a polygon that has been cut
// into its visible line segments, and rejoins the segments by interpolating
// along the clip edge.
/* harmony default export */ __webpack_exports__["a"] = (function(segments, compareIntersection, startInside, interpolate, stream) {
  var subject = [],
      clip = [],
      i,
      n;

  segments.forEach(function(segment) {
    if ((n = segment.length - 1) <= 0) return;
    var n, p0 = segment[0], p1 = segment[n], x;

    // If the first and last points of a segment are coincident, then treat as a
    // closed ring. TODO if all rings are closed, then the winding order of the
    // exterior ring should be checked.
    if (Object(__WEBPACK_IMPORTED_MODULE_0__pointEqual__["a" /* default */])(p0, p1)) {
      stream.lineStart();
      for (i = 0; i < n; ++i) stream.point((p0 = segment[i])[0], p0[1]);
      stream.lineEnd();
      return;
    }

    subject.push(x = new Intersection(p0, segment, null, true));
    clip.push(x.o = new Intersection(p0, null, x, false));
    subject.push(x = new Intersection(p1, segment, null, false));
    clip.push(x.o = new Intersection(p1, null, x, true));
  });

  if (!subject.length) return;

  clip.sort(compareIntersection);
  link(subject);
  link(clip);

  for (i = 0, n = clip.length; i < n; ++i) {
    clip[i].e = startInside = !startInside;
  }

  var start = subject[0],
      points,
      point;

  while (1) {
    // Find first unvisited intersection.
    var current = start,
        isSubject = true;
    while (current.v) if ((current = current.n) === start) return;
    points = current.z;
    stream.lineStart();
    do {
      current.v = current.o.v = true;
      if (current.e) {
        if (isSubject) {
          for (i = 0, n = points.length; i < n; ++i) stream.point((point = points[i])[0], point[1]);
        } else {
          interpolate(current.x, current.n.x, 1, stream);
        }
        current = current.n;
      } else {
        if (isSubject) {
          points = current.p.z;
          for (i = points.length - 1; i >= 0; --i) stream.point((point = points[i])[0], point[1]);
        } else {
          interpolate(current.x, current.p.x, -1, stream);
        }
        current = current.p;
      }
      current = current.o;
      points = current.z;
      isSubject = !isSubject;
    } while (!current.v);
    stream.lineEnd();
  }
});

function link(array) {
  if (!(n = array.length)) return;
  var n,
      i = 0,
      a = array[0],
      b;
  while (++i < n) {
    a.n = b = array[i];
    b.p = a;
    a = b;
  }
  a.n = b = array[0];
  b.p = a;
}


/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(a[0] - b[0]) < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */] && Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(a[1] - b[1]) < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */];
});


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cartesian__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(0);




var sum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])();

/* harmony default export */ __webpack_exports__["a"] = (function(polygon, point) {
  var lambda = point[0],
      phi = point[1],
      normal = [Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" /* sin */])(lambda), -Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(lambda), 0],
      angle = 0,
      winding = 0;

  sum.reset();

  for (var i = 0, n = polygon.length; i < n; ++i) {
    if (!(m = (ring = polygon[i]).length)) continue;
    var ring,
        m,
        point0 = ring[m - 1],
        lambda0 = point0[0],
        phi0 = point0[1] / 2 + __WEBPACK_IMPORTED_MODULE_2__math__["q" /* quarterPi */],
        sinPhi0 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" /* sin */])(phi0),
        cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(phi0);

    for (var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1) {
      var point1 = ring[j],
          lambda1 = point1[0],
          phi1 = point1[1] / 2 + __WEBPACK_IMPORTED_MODULE_2__math__["q" /* quarterPi */],
          sinPhi1 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" /* sin */])(phi1),
          cosPhi1 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(phi1),
          delta = lambda1 - lambda0,
          sign = delta >= 0 ? 1 : -1,
          absDelta = sign * delta,
          antimeridian = absDelta > __WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */],
          k = sinPhi0 * sinPhi1;

      sum.add(Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* atan2 */])(k * sign * Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" /* sin */])(absDelta), cosPhi0 * cosPhi1 + k * Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(absDelta)));
      angle += antimeridian ? delta + sign * __WEBPACK_IMPORTED_MODULE_2__math__["w" /* tau */] : delta;

      // Are the longitudes either side of the point’s meridian (lambda),
      // and are the latitudes smaller than the parallel (phi)?
      if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
        var arc = Object(__WEBPACK_IMPORTED_MODULE_1__cartesian__["c" /* cartesianCross */])(Object(__WEBPACK_IMPORTED_MODULE_1__cartesian__["a" /* cartesian */])(point0), Object(__WEBPACK_IMPORTED_MODULE_1__cartesian__["a" /* cartesian */])(point1));
        Object(__WEBPACK_IMPORTED_MODULE_1__cartesian__["e" /* cartesianNormalizeInPlace */])(arc);
        var intersection = Object(__WEBPACK_IMPORTED_MODULE_1__cartesian__["c" /* cartesianCross */])(normal, arc);
        Object(__WEBPACK_IMPORTED_MODULE_1__cartesian__["e" /* cartesianNormalizeInPlace */])(intersection);
        var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * Object(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* asin */])(intersection[2]);
        if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) {
          winding += antimeridian ^ delta >= 0 ? 1 : -1;
        }
      }
    }
  }

  // First, determine whether the South pole is inside or outside:
  //
  // It is inside if:
  // * the polygon winds around it in a clockwise direction.
  // * the polygon does not (cumulatively) wind around it, but has a negative
  //   (counter-clockwise) area.
  //
  // Second, count the (signed) number of times a segment crosses a lambda
  // from the point to the South pole.  If it is zero, then the point is the
  // same side as the South pole.

  return (angle < -__WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */] || angle < __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */] && sum < -__WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */]) ^ (winding & 1);
});


/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cartesian__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__circle__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pointEqual__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index__ = __webpack_require__(148);






/* harmony default export */ __webpack_exports__["a"] = (function(radius) {
  var cr = Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(radius),
      delta = 6 * __WEBPACK_IMPORTED_MODULE_2__math__["r" /* radians */],
      smallRadius = cr > 0,
      notHemisphere = Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(cr) > __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */]; // TODO optimise for this common case

  function interpolate(from, to, direction, stream) {
    Object(__WEBPACK_IMPORTED_MODULE_1__circle__["a" /* circleStream */])(stream, radius, delta, direction, from, to);
  }

  function visible(lambda, phi) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(lambda) * Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(phi) > cr;
  }

  // Takes a line and cuts into visible segments. Return values used for polygon
  // clipping: 0 - there were intersections or the line was empty; 1 - no
  // intersections 2 - there were intersections, and the first and last segments
  // should be rejoined.
  function clipLine(stream) {
    var point0, // previous point
        c0, // code for previous point
        v0, // visibility of previous point
        v00, // visibility of first point
        clean; // no intersections
    return {
      lineStart: function() {
        v00 = v0 = false;
        clean = 1;
      },
      point: function(lambda, phi) {
        var point1 = [lambda, phi],
            point2,
            v = visible(lambda, phi),
            c = smallRadius
              ? v ? 0 : code(lambda, phi)
              : v ? code(lambda + (lambda < 0 ? __WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */] : -__WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */]), phi) : 0;
        if (!point0 && (v00 = v0 = v)) stream.lineStart();
        // Handle degeneracies.
        // TODO ignore if not clipping polygons.
        if (v !== v0) {
          point2 = intersect(point0, point1);
          if (!point2 || Object(__WEBPACK_IMPORTED_MODULE_3__pointEqual__["a" /* default */])(point0, point2) || Object(__WEBPACK_IMPORTED_MODULE_3__pointEqual__["a" /* default */])(point1, point2)) {
            point1[0] += __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */];
            point1[1] += __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */];
            v = visible(point1[0], point1[1]);
          }
        }
        if (v !== v0) {
          clean = 0;
          if (v) {
            // outside going in
            stream.lineStart();
            point2 = intersect(point1, point0);
            stream.point(point2[0], point2[1]);
          } else {
            // inside going out
            point2 = intersect(point0, point1);
            stream.point(point2[0], point2[1]);
            stream.lineEnd();
          }
          point0 = point2;
        } else if (notHemisphere && point0 && smallRadius ^ v) {
          var t;
          // If the codes for two points are different, or are both zero,
          // and there this segment intersects with the small circle.
          if (!(c & c0) && (t = intersect(point1, point0, true))) {
            clean = 0;
            if (smallRadius) {
              stream.lineStart();
              stream.point(t[0][0], t[0][1]);
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
            } else {
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
              stream.lineStart();
              stream.point(t[0][0], t[0][1]);
            }
          }
        }
        if (v && (!point0 || !Object(__WEBPACK_IMPORTED_MODULE_3__pointEqual__["a" /* default */])(point0, point1))) {
          stream.point(point1[0], point1[1]);
        }
        point0 = point1, v0 = v, c0 = c;
      },
      lineEnd: function() {
        if (v0) stream.lineEnd();
        point0 = null;
      },
      // Rejoin first and last segments if there were intersections and the first
      // and last points were visible.
      clean: function() {
        return clean | ((v00 && v0) << 1);
      }
    };
  }

  // Intersects the great circle between a and b with the clip circle.
  function intersect(a, b, two) {
    var pa = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["a" /* cartesian */])(a),
        pb = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["a" /* cartesian */])(b);

    // We have two planes, n1.p = d1 and n2.p = d2.
    // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
    var n1 = [1, 0, 0], // normal
        n2 = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["c" /* cartesianCross */])(pa, pb),
        n2n2 = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["d" /* cartesianDot */])(n2, n2),
        n1n2 = n2[0], // cartesianDot(n1, n2),
        determinant = n2n2 - n1n2 * n1n2;

    // Two polar points.
    if (!determinant) return !two && a;

    var c1 =  cr * n2n2 / determinant,
        c2 = -cr * n1n2 / determinant,
        n1xn2 = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["c" /* cartesianCross */])(n1, n2),
        A = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["f" /* cartesianScale */])(n1, c1),
        B = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["f" /* cartesianScale */])(n2, c2);
    Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["b" /* cartesianAddInPlace */])(A, B);

    // Solve |p(t)|^2 = 1.
    var u = n1xn2,
        w = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["d" /* cartesianDot */])(A, u),
        uu = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["d" /* cartesianDot */])(u, u),
        t2 = w * w - uu * (Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["d" /* cartesianDot */])(A, A) - 1);

    if (t2 < 0) return;

    var t = Object(__WEBPACK_IMPORTED_MODULE_2__math__["u" /* sqrt */])(t2),
        q = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["f" /* cartesianScale */])(u, (-w - t) / uu);
    Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["b" /* cartesianAddInPlace */])(q, A);
    q = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["g" /* spherical */])(q);

    if (!two) return q;

    // Two intersection points.
    var lambda0 = a[0],
        lambda1 = b[0],
        phi0 = a[1],
        phi1 = b[1],
        z;

    if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;

    var delta = lambda1 - lambda0,
        polar = Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(delta - __WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */]) < __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */],
        meridian = polar || delta < __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */];

    if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;

    // Check that the first point is between a and b.
    if (meridian
        ? polar
          ? phi0 + phi1 > 0 ^ q[1] < (Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(q[0] - lambda0) < __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */] ? phi0 : phi1)
          : phi0 <= q[1] && q[1] <= phi1
        : delta > __WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */] ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
      var q1 = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["f" /* cartesianScale */])(u, (-w + t) / uu);
      Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["b" /* cartesianAddInPlace */])(q1, A);
      return [q, Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["g" /* spherical */])(q1)];
    }
  }

  // Generates a 4-bit vector representing the location of a point relative to
  // the small circle's bounding box.
  function code(lambda, phi) {
    var r = smallRadius ? radius : __WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */] - radius,
        code = 0;
    if (lambda < -r) code |= 1; // left
    else if (lambda > r) code |= 2; // right
    if (phi < -r) code |= 4; // below
    else if (phi > r) code |= 8; // above
    return code;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_4__index__["a" /* default */])(visible, clipLine, interpolate, smallRadius ? [0, -radius] : [-__WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */], radius - __WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */]]);
});


/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__length__ = __webpack_require__(155);


var coordinates = [null, null],
    object = {type: "LineString", coordinates: coordinates};

/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  coordinates[0] = a;
  coordinates[1] = b;
  return Object(__WEBPACK_IMPORTED_MODULE_0__length__["a" /* default */])(object);
});


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noop__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stream__ = __webpack_require__(16);





var lengthSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    lambda0,
    sinPhi0,
    cosPhi0;

var lengthStream = {
  sphere: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  point: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineStart: lengthLineStart,
  lineEnd: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  polygonStart: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  polygonEnd: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */]
};

function lengthLineStart() {
  lengthStream.point = lengthPointFirst;
  lengthStream.lineEnd = lengthLineEnd;
}

function lengthLineEnd() {
  lengthStream.point = lengthStream.lineEnd = __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */];
}

function lengthPointFirst(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */];
  lambda0 = lambda, sinPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi), cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi);
  lengthStream.point = lengthPoint;
}

function lengthPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */];
  var sinPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi),
      cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi),
      delta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(lambda - lambda0),
      cosDelta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(delta),
      sinDelta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(delta),
      x = cosPhi * sinDelta,
      y = cosPhi0 * sinPhi - sinPhi0 * cosPhi * cosDelta,
      z = sinPhi0 * sinPhi + cosPhi0 * cosPhi * cosDelta;
  lengthSum.add(Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["u" /* sqrt */])(x * x + y * y), z));
  lambda0 = lambda, sinPhi0 = sinPhi, cosPhi0 = cosPhi;
}

/* harmony default export */ __webpack_exports__["a"] = (function(object) {
  lengthSum.reset();
  Object(__WEBPACK_IMPORTED_MODULE_3__stream__["a" /* default */])(object, lengthStream);
  return +lengthSum;
});


/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(13);


var x0 = Infinity,
    y0 = x0,
    x1 = -x0,
    y1 = x1;

var boundsStream = {
  point: boundsPoint,
  lineStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  polygonStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  polygonEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  result: function() {
    var bounds = [[x0, y0], [x1, y1]];
    x1 = y1 = -(y0 = x0 = Infinity);
    return bounds;
  }
};

function boundsPoint(x, y) {
  if (x < x0) x0 = x;
  if (x > x1) x1 = x;
  if (y < y0) y0 = y;
  if (y > y1) y1 = y;
}

/* harmony default export */ __webpack_exports__["a"] = (boundsStream);


/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__conicEqualArea__ = __webpack_require__(81);


/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__conicEqualArea__["b" /* default */])()
      .parallels([29.5, 45.5])
      .scale(1070)
      .translate([480, 250])
      .rotate([96, 0])
      .center([-0.6, 38.7]);
});


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = equirectangularRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(10);


function equirectangularRaw(lambda, phi) {
  return [lambda, phi];
}

equirectangularRaw.invert = equirectangularRaw;

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])(equirectangularRaw)
      .scale(152.63);
});


/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = packEnclose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enclose__ = __webpack_require__(160);


function place(a, b, c) {
  var ax = a.x,
      ay = a.y,
      da = b.r + c.r,
      db = a.r + c.r,
      dx = b.x - ax,
      dy = b.y - ay,
      dc = dx * dx + dy * dy;
  if (dc) {
    var x = 0.5 + ((db *= db) - (da *= da)) / (2 * dc),
        y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
    c.x = ax + x * dx + y * dy;
    c.y = ay + x * dy - y * dx;
  } else {
    c.x = ax + db;
    c.y = ay;
  }
}

function intersects(a, b) {
  var dx = b.x - a.x,
      dy = b.y - a.y,
      dr = a.r + b.r;
  return dr * dr - 1e-6 > dx * dx + dy * dy;
}

function score(node) {
  var a = node._,
      b = node.next._,
      ab = a.r + b.r,
      dx = (a.x * b.r + b.x * a.r) / ab,
      dy = (a.y * b.r + b.y * a.r) / ab;
  return dx * dx + dy * dy;
}

function Node(circle) {
  this._ = circle;
  this.next = null;
  this.previous = null;
}

function packEnclose(circles) {
  if (!(n = circles.length)) return 0;

  var a, b, c, n, aa, ca, i, j, k, sj, sk;

  // Place the first circle.
  a = circles[0], a.x = 0, a.y = 0;
  if (!(n > 1)) return a.r;

  // Place the second circle.
  b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
  if (!(n > 2)) return a.r + b.r;

  // Place the third circle.
  place(b, a, c = circles[2]);

  // Initialize the front-chain using the first three circles a, b and c.
  a = new Node(a), b = new Node(b), c = new Node(c);
  a.next = c.previous = b;
  b.next = a.previous = c;
  c.next = b.previous = a;

  // Attempt to place each remaining circle…
  pack: for (i = 3; i < n; ++i) {
    place(a._, b._, c = circles[i]), c = new Node(c);

    // Find the closest intersecting circle on the front-chain, if any.
    // “Closeness” is determined by linear distance along the front-chain.
    // “Ahead” or “behind” is likewise determined by linear distance.
    j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
    do {
      if (sj <= sk) {
        if (intersects(j._, c._)) {
          b = j, a.next = b, b.previous = a, --i;
          continue pack;
        }
        sj += j._.r, j = j.next;
      } else {
        if (intersects(k._, c._)) {
          a = k, a.next = b, b.previous = a, --i;
          continue pack;
        }
        sk += k._.r, k = k.previous;
      }
    } while (j !== k.next);

    // Success! Insert the new circle c between a and b.
    c.previous = a, c.next = b, a.next = b.previous = b = c;

    // Compute the new closest circle pair to the centroid.
    aa = score(a);
    while ((c = c.next) !== b) {
      if ((ca = score(c)) < aa) {
        a = c, aa = ca;
      }
    }
    b = a.next;
  }

  // Compute the enclosing circle of the front chain.
  a = [b._], c = b; while ((c = c.next) !== b) a.push(c._); c = Object(__WEBPACK_IMPORTED_MODULE_0__enclose__["a" /* default */])(a);

  // Translate the circles to put the enclosing circle around the origin.
  for (i = 0; i < n; ++i) a = circles[i], a.x -= c.x, a.y -= c.y;

  return c.r;
}

/* harmony default export */ __webpack_exports__["a"] = (function(circles) {
  packEnclose(circles);
  return circles;
});


/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(423);


/* harmony default export */ __webpack_exports__["a"] = (function(circles) {
  var i = 0, n = (circles = Object(__WEBPACK_IMPORTED_MODULE_0__array__["a" /* shuffle */])(__WEBPACK_IMPORTED_MODULE_0__array__["b" /* slice */].call(circles))).length, B = [], p, e;

  while (i < n) {
    p = circles[i];
    if (e && enclosesWeak(e, p)) ++i;
    else e = encloseBasis(B = extendBasis(B, p)), i = 0;
  }

  return e;
});

function extendBasis(B, p) {
  var i, j;

  if (enclosesWeakAll(p, B)) return [p];

  // If we get here then B must have at least one element.
  for (i = 0; i < B.length; ++i) {
    if (enclosesNot(p, B[i])
        && enclosesWeakAll(encloseBasis2(B[i], p), B)) {
      return [B[i], p];
    }
  }

  // If we get here then B must have at least two elements.
  for (i = 0; i < B.length - 1; ++i) {
    for (j = i + 1; j < B.length; ++j) {
      if (enclosesNot(encloseBasis2(B[i], B[j]), p)
          && enclosesNot(encloseBasis2(B[i], p), B[j])
          && enclosesNot(encloseBasis2(B[j], p), B[i])
          && enclosesWeakAll(encloseBasis3(B[i], B[j], p), B)) {
        return [B[i], B[j], p];
      }
    }
  }

  // If we get here then something is very wrong.
  throw new Error;
}

function enclosesNot(a, b) {
  var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
  return dr < 0 || dr * dr < dx * dx + dy * dy;
}

function enclosesWeak(a, b) {
  var dr = a.r - b.r + 1e-6, dx = b.x - a.x, dy = b.y - a.y;
  return dr > 0 && dr * dr > dx * dx + dy * dy;
}

function enclosesWeakAll(a, B) {
  for (var i = 0; i < B.length; ++i) {
    if (!enclosesWeak(a, B[i])) {
      return false;
    }
  }
  return true;
}

function encloseBasis(B) {
  switch (B.length) {
    case 1: return encloseBasis1(B[0]);
    case 2: return encloseBasis2(B[0], B[1]);
    case 3: return encloseBasis3(B[0], B[1], B[2]);
  }
}

function encloseBasis1(a) {
  return {
    x: a.x,
    y: a.y,
    r: a.r
  };
}

function encloseBasis2(a, b) {
  var x1 = a.x, y1 = a.y, r1 = a.r,
      x2 = b.x, y2 = b.y, r2 = b.r,
      x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1,
      l = Math.sqrt(x21 * x21 + y21 * y21);
  return {
    x: (x1 + x2 + x21 / l * r21) / 2,
    y: (y1 + y2 + y21 / l * r21) / 2,
    r: (l + r1 + r2) / 2
  };
}

function encloseBasis3(a, b, c) {
  var x1 = a.x, y1 = a.y, r1 = a.r,
      x2 = b.x, y2 = b.y, r2 = b.r,
      x3 = c.x, y3 = c.y, r3 = c.r,
      a2 = x1 - x2,
      a3 = x1 - x3,
      b2 = y1 - y2,
      b3 = y1 - y3,
      c2 = r2 - r1,
      c3 = r3 - r1,
      d1 = x1 * x1 + y1 * y1 - r1 * r1,
      d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2,
      d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3,
      ab = a3 * b2 - a2 * b3,
      xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1,
      xb = (b3 * c2 - b2 * c3) / ab,
      ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1,
      yb = (a2 * c3 - a3 * c2) / ab,
      A = xb * xb + yb * yb - 1,
      B = 2 * (r1 + xa * xb + ya * yb),
      C = xa * xa + ya * ya - r1 * r1,
      r = -(A ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
  return {
    x: x1 + xa + xb * r,
    y: y1 + ya + yb * r,
    r: r
  };
}


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = constantZero;
function constantZero() {
  return 0;
}

/* harmony default export */ __webpack_exports__["b"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(node) {
  node.x0 = Math.round(node.x0);
  node.y0 = Math.round(node.y0);
  node.x1 = Math.round(node.x1);
  node.y1 = Math.round(node.y1);
});


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultSource__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ((function sourceRandomNormal(source) {
  function randomNormal(mu, sigma) {
    var x, r;
    mu = mu == null ? 0 : +mu;
    sigma = sigma == null ? 1 : +sigma;
    return function() {
      var y;

      // If available, use the second previously-generated uniform random.
      if (x != null) y = x, x = null;

      // Otherwise, generate a new x and y.
      else do {
        x = source() * 2 - 1;
        y = source() * 2 - 1;
        r = x * x + y * y;
      } while (!r || r > 1);

      return mu + sigma * y * Math.sqrt(-2 * Math.log(r) / r);
    };
  }

  randomNormal.source = sourceRandomNormal;

  return randomNormal;
})(__WEBPACK_IMPORTED_MODULE_0__defaultSource__["a" /* default */]));


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultSource__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ((function sourceRandomIrwinHall(source) {
  function randomIrwinHall(n) {
    return function() {
      for (var sum = 0, i = 0; i < n; ++i) sum += source();
      return sum;
    };
  }

  randomIrwinHall.source = sourceRandomIrwinHall;

  return randomIrwinHall;
})(__WEBPACK_IMPORTED_MODULE_0__defaultSource__["a" /* default */]));


/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__request__ = __webpack_require__(88);


/* harmony default export */ __webpack_exports__["a"] = (function(defaultMimeType, parse) {
  return function(url, row, callback) {
    if (arguments.length < 3) callback = row, row = null;
    var r = Object(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])(url).mimeType(defaultMimeType);
    r.row = function(_) { return arguments.length ? r.response(responseOf(parse, row = _)) : row; };
    r.row(row);
    return callback ? r.get(callback) : r;
  };
});

function responseOf(parse, row) {
  return function(request) {
    return parse(request.responseText, row);
  };
}


/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return implicit; });
/* harmony export (immutable) */ __webpack_exports__["a"] = ordinal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_collection__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(17);



var implicit = {name: "implicit"};

function ordinal(range) {
  var index = Object(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["c" /* map */])(),
      domain = [],
      unknown = implicit;

  range = range == null ? [] : __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(range);

  function scale(d) {
    var key = d + "", i = index.get(key);
    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }
    return range[(i - 1) % range.length];
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = Object(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["c" /* map */])();
    var i = -1, n = _.length, d, key;
    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
    return scale;
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), scale) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return ordinal()
        .domain(domain)
        .range(range)
        .unknown(unknown);
  };

  return scale;
}


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return +x;
});


/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(domain, interval) {
  domain = domain.slice();

  var i0 = 0,
      i1 = domain.length - 1,
      x0 = domain[i0],
      x1 = domain[i1],
      t;

  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }

  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
});


/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calendar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_time_format__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__array__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__continuous__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nice__ = __webpack_require__(168);








var durationSecond = 1000,
    durationMinute = durationSecond * 60,
    durationHour = durationMinute * 60,
    durationDay = durationHour * 24,
    durationWeek = durationDay * 7,
    durationMonth = durationDay * 30,
    durationYear = durationDay * 365;

function date(t) {
  return new Date(t);
}

function number(t) {
  return t instanceof Date ? +t : +new Date(+t);
}

function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_5__continuous__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_5__continuous__["c" /* deinterpolateLinear */], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["m" /* interpolateNumber */]),
      invert = scale.invert,
      domain = scale.domain;

  var formatMillisecond = format(".%L"),
      formatSecond = format(":%S"),
      formatMinute = format("%I:%M"),
      formatHour = format("%I %p"),
      formatDay = format("%a %d"),
      formatWeek = format("%b %d"),
      formatMonth = format("%B"),
      formatYear = format("%Y");

  var tickIntervals = [
    [second,  1,      durationSecond],
    [second,  5,  5 * durationSecond],
    [second, 15, 15 * durationSecond],
    [second, 30, 30 * durationSecond],
    [minute,  1,      durationMinute],
    [minute,  5,  5 * durationMinute],
    [minute, 15, 15 * durationMinute],
    [minute, 30, 30 * durationMinute],
    [  hour,  1,      durationHour  ],
    [  hour,  3,  3 * durationHour  ],
    [  hour,  6,  6 * durationHour  ],
    [  hour, 12, 12 * durationHour  ],
    [   day,  1,      durationDay   ],
    [   day,  2,  2 * durationDay   ],
    [  week,  1,      durationWeek  ],
    [ month,  1,      durationMonth ],
    [ month,  3,  3 * durationMonth ],
    [  year,  1,      durationYear  ]
  ];

  function tickFormat(date) {
    return (second(date) < date ? formatMillisecond
        : minute(date) < date ? formatSecond
        : hour(date) < date ? formatMinute
        : day(date) < date ? formatHour
        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
        : year(date) < date ? formatMonth
        : formatYear)(date);
  }

  function tickInterval(interval, start, stop, step) {
    if (interval == null) interval = 10;

    // If a desired tick count is specified, pick a reasonable tick interval
    // based on the extent of the domain and a rough estimate of tick size.
    // Otherwise, assume interval is already a time interval and use it.
    if (typeof interval === "number") {
      var target = Math.abs(stop - start) / interval,
          i = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["e" /* bisector */])(function(i) { return i[2]; }).right(tickIntervals, target);
      if (i === tickIntervals.length) {
        step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["A" /* tickStep */])(start / durationYear, stop / durationYear, interval);
        interval = year;
      } else if (i) {
        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        step = i[1];
        interval = i[0];
      } else {
        step = Math.max(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["A" /* tickStep */])(start, stop, interval), 1);
        interval = millisecond;
      }
    }

    return step == null ? interval : interval.every(step);
  }

  scale.invert = function(y) {
    return new Date(invert(y));
  };

  scale.domain = function(_) {
    return arguments.length ? domain(__WEBPACK_IMPORTED_MODULE_4__array__["a" /* map */].call(_, number)) : domain().map(date);
  };

  scale.ticks = function(interval, step) {
    var d = domain(),
        t0 = d[0],
        t1 = d[d.length - 1],
        r = t1 < t0,
        t;
    if (r) t = t0, t0 = t1, t1 = t;
    t = tickInterval(interval, t0, t1, step);
    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
    return r ? t.reverse() : t;
  };

  scale.tickFormat = function(count, specifier) {
    return specifier == null ? tickFormat : format(specifier);
  };

  scale.nice = function(interval, step) {
    var d = domain();
    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
        ? domain(Object(__WEBPACK_IMPORTED_MODULE_6__nice__["a" /* default */])(d, interval))
        : scale;
  };

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_5__continuous__["a" /* copy */])(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
  };

  return scale;
}

/* harmony default export */ __webpack_exports__["b"] = (function() {
  return calendar(__WEBPACK_IMPORTED_MODULE_2_d3_time__["D" /* timeYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["n" /* timeMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["B" /* timeWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["a" /* timeDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["e" /* timeHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["j" /* timeMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["r" /* timeSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["h" /* timeMillisecond */], __WEBPACK_IMPORTED_MODULE_3_d3_time_format__["c" /* timeFormat */]).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
});


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatLocale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_time__ = __webpack_require__(51);


function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newYear(y) {
  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
}

function formatLocale(locale) {
  var locale_dateTime = locale.dateTime,
      locale_date = locale.date,
      locale_time = locale.time,
      locale_periods = locale.periods,
      locale_weekdays = locale.days,
      locale_shortWeekdays = locale.shortDays,
      locale_months = locale.months,
      locale_shortMonths = locale.shortMonths;

  var periodRe = formatRe(locale_periods),
      periodLookup = formatLookup(locale_periods),
      weekdayRe = formatRe(locale_weekdays),
      weekdayLookup = formatLookup(locale_weekdays),
      shortWeekdayRe = formatRe(locale_shortWeekdays),
      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
      monthRe = formatRe(locale_months),
      monthLookup = formatLookup(locale_months),
      shortMonthRe = formatRe(locale_shortMonths),
      shortMonthLookup = formatLookup(locale_shortMonths);

  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "f": formatMicroseconds,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatSeconds,
    "u": formatWeekdayNumberMonday,
    "U": formatWeekNumberSunday,
    "V": formatWeekNumberISO,
    "w": formatWeekdayNumberSunday,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };

  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "f": formatUTCMicroseconds,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatUTCSeconds,
    "u": formatUTCWeekdayNumberMonday,
    "U": formatUTCWeekNumberSunday,
    "V": formatUTCWeekNumberISO,
    "w": formatUTCWeekdayNumberSunday,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };

  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "f": parseMicroseconds,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "Q": parseUnixTimestamp,
    "s": parseUnixTimestampSeconds,
    "S": parseSeconds,
    "u": parseWeekdayNumberMonday,
    "U": parseWeekNumberSunday,
    "V": parseWeekNumberISO,
    "w": parseWeekdayNumberSunday,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function(date) {
      var string = [],
          i = -1,
          j = 0,
          n = specifier.length,
          c,
          pad,
          format;

      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
          else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }

  function newParse(specifier, newDate) {
    return function(string) {
      var d = newYear(1900),
          i = parseSpecifier(d, specifier, string += "", 0),
          week, day;
      if (i != string.length) return null;

      // If a UNIX timestamp is specified, return it.
      if ("Q" in d) return new Date(d.Q);

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("V" in d) {
        if (d.V < 1 || d.V > 53) return null;
        if (!("w" in d)) d.w = 1;
        if ("Z" in d) {
          week = utcDate(newYear(d.y)), day = week.getUTCDay();
          week = day > 4 || day === 0 ? __WEBPACK_IMPORTED_MODULE_0_d3_time__["P" /* utcMonday */].ceil(week) : Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["P" /* utcMonday */])(week);
          week = __WEBPACK_IMPORTED_MODULE_0_d3_time__["F" /* utcDay */].offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + (d.w + 6) % 7;
        } else {
          week = newDate(newYear(d.y)), day = week.getDay();
          week = day > 4 || day === 0 ? __WEBPACK_IMPORTED_MODULE_0_d3_time__["l" /* timeMonday */].ceil(week) : Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["l" /* timeMonday */])(week);
          week = __WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* timeDay */].offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + (d.w + 6) % 7;
        }
      } else if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
        day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }

      // Otherwise, all fields are in local time.
      return newDate(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
        n = specifier.length,
        m = string.length,
        c,
        parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  return {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function() { return specifier; };
      return f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", localDate);
      p.toString = function() { return specifier; };
      return p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function() { return specifier; };
      return f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier, utcDate);
      p.toString = function() { return specifier; };
      return p;
    }
  };
}

var pads = {"-": "", "_": " ", "0": "0"},
    numberRe = /^\s*\d+/, // note: ignores next directive
    percentRe = /^%/,
    requoteRe = /[\\^$*+?|[\]().{}]/g;

function pad(value, fill, width) {
  var sign = value < 0 ? "-" : "",
      string = (sign ? -value : value) + "",
      length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote(s) {
  return s.replace(requoteRe, "\\$&");
}

function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}

function formatLookup(names) {
  var map = {}, i = -1, n = names.length;
  while (++i < n) map[names[i].toLowerCase()] = i;
  return map;
}

function parseWeekdayNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}

function parseWeekdayNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.u = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberISO(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.V = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}

function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}

function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}

function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}

function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}

function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}

function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}

function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}

function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}

function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}

function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}

function parseMicroseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 6));
  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}

function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function parseUnixTimestamp(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = +n[0], i + n[0].length) : -1;
}

function parseUnixTimestampSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = (+n[0]) * 1000, i + n[0].length) : -1;
}

function formatDayOfMonth(d, p) {
  return pad(d.getDate(), p, 2);
}

function formatHour24(d, p) {
  return pad(d.getHours(), p, 2);
}

function formatHour12(d, p) {
  return pad(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* timeDay */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["D" /* timeYear */])(d), d), p, 3);
}

function formatMilliseconds(d, p) {
  return pad(d.getMilliseconds(), p, 3);
}

function formatMicroseconds(d, p) {
  return formatMilliseconds(d, p) + "000";
}

function formatMonthNumber(d, p) {
  return pad(d.getMonth() + 1, p, 2);
}

function formatMinutes(d, p) {
  return pad(d.getMinutes(), p, 2);
}

function formatSeconds(d, p) {
  return pad(d.getSeconds(), p, 2);
}

function formatWeekdayNumberMonday(d) {
  var day = d.getDay();
  return day === 0 ? 7 : day;
}

function formatWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["t" /* timeSunday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["D" /* timeYear */])(d), d), p, 2);
}

function formatWeekNumberISO(d, p) {
  var day = d.getDay();
  d = (day >= 4 || day === 0) ? Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* timeThursday */])(d) : __WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* timeThursday */].ceil(d);
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* timeThursday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["D" /* timeYear */])(d), d) + (Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["D" /* timeYear */])(d).getDay() === 4), p, 2);
}

function formatWeekdayNumberSunday(d) {
  return d.getDay();
}

function formatWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["l" /* timeMonday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["D" /* timeYear */])(d), d), p, 2);
}

function formatYear(d, p) {
  return pad(d.getFullYear() % 100, p, 2);
}

function formatFullYear(d, p) {
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+"))
      + pad(z / 60 | 0, "0", 2)
      + pad(z % 60, "0", 2);
}

function formatUTCDayOfMonth(d, p) {
  return pad(d.getUTCDate(), p, 2);
}

function formatUTCHour24(d, p) {
  return pad(d.getUTCHours(), p, 2);
}

function formatUTCHour12(d, p) {
  return pad(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["F" /* utcDay */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["_7" /* utcYear */])(d), d), p, 3);
}

function formatUTCMilliseconds(d, p) {
  return pad(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMicroseconds(d, p) {
  return formatUTCMilliseconds(d, p) + "000";
}

function formatUTCMonthNumber(d, p) {
  return pad(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes(d, p) {
  return pad(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds(d, p) {
  return pad(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekdayNumberMonday(d) {
  var dow = d.getUTCDay();
  return dow === 0 ? 7 : dow;
}

function formatUTCWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["X" /* utcSunday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["_7" /* utcYear */])(d), d), p, 2);
}

function formatUTCWeekNumberISO(d, p) {
  var day = d.getUTCDay();
  d = (day >= 4 || day === 0) ? Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["Z" /* utcThursday */])(d) : __WEBPACK_IMPORTED_MODULE_0_d3_time__["Z" /* utcThursday */].ceil(d);
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["Z" /* utcThursday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["_7" /* utcYear */])(d), d) + (Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["_7" /* utcYear */])(d).getUTCDay() === 4), p, 2);
}

function formatUTCWeekdayNumberSunday(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["P" /* utcMonday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["_7" /* utcYear */])(d), d), p, 2);
}

function formatUTCYear(d, p) {
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear(d, p) {
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone() {
  return "+0000";
}

function formatLiteralPercent() {
  return "%";
}

function formatUnixTimestamp(d) {
  return +d;
}

function formatUnixTimestampSeconds(d) {
  return Math.floor(+d / 1000);
}


/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isoSpecifier; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultLocale__ = __webpack_require__(91);


var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";

function formatIsoNative(date) {
  return date.toISOString();
}

var formatIso = Date.prototype.toISOString
    ? formatIsoNative
    : Object(__WEBPACK_IMPORTED_MODULE_0__defaultLocale__["d" /* utcFormat */])(isoSpecifier);

/* harmony default export */ __webpack_exports__["a"] = (formatIso);


/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curve_linear__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__line__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__point__ = __webpack_require__(93);






/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x0 = __WEBPACK_IMPORTED_MODULE_4__point__["a" /* x */],
      x1 = null,
      y0 = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(0),
      y1 = __WEBPACK_IMPORTED_MODULE_4__point__["b" /* y */],
      defined = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(true),
      context = null,
      curve = __WEBPACK_IMPORTED_MODULE_2__curve_linear__["a" /* default */],
      output = null;

  function area(data) {
    var i,
        j,
        k,
        n = data.length,
        d,
        defined0 = false,
        buffer,
        x0z = new Array(n),
        y0z = new Array(n);

    if (context == null) output = curve(buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k = i - 1; k >= j; --k) {
            output.point(x0z[k], y0z[k]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
      }
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  function arealine() {
    return Object(__WEBPACK_IMPORTED_MODULE_3__line__["a" /* default */])().defined(defined).curve(curve).context(context);
  }

  area.x = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), x1 = null, area) : x0;
  };

  area.x0 = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : x0;
  };

  area.x1 = function(_) {
    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : x1;
  };

  area.y = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), y1 = null, area) : y0;
  };

  area.y0 = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : y0;
  };

  area.y1 = function(_) {
    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : y1;
  };

  area.lineX0 =
  area.lineY0 = function() {
    return arealine().x(x0).y(y0);
  };

  area.lineY1 = function() {
    return arealine().x(x0).y(y1);
  };

  area.lineX1 = function() {
    return arealine().x(x1).y(y0);
  };

  area.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(!!_), area) : defined;
  };

  area.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
  };

  area.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
  };

  return area;
});


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return curveRadialLinear; });
/* harmony export (immutable) */ __webpack_exports__["b"] = curveRadial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(52);


var curveRadialLinear = curveRadial(__WEBPACK_IMPORTED_MODULE_0__linear__["a" /* default */]);

function Radial(curve) {
  this._curve = curve;
}

Radial.prototype = {
  areaStart: function() {
    this._curve.areaStart();
  },
  areaEnd: function() {
    this._curve.areaEnd();
  },
  lineStart: function() {
    this._curve.lineStart();
  },
  lineEnd: function() {
    this._curve.lineEnd();
  },
  point: function(a, r) {
    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
  }
};

function curveRadial(curve) {

  function radial(context) {
    return new Radial(curve(context));
  }

  radial._curve = curve;

  return radial;
}


/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = lineRadial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curve_radial__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__line__ = __webpack_require__(92);



function lineRadial(l) {
  var c = l.curve;

  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;

  l.curve = function(_) {
    return arguments.length ? c(Object(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["b" /* default */])(_)) : c()._curve;
  };

  return l;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return lineRadial(Object(__WEBPACK_IMPORTED_MODULE_1__line__["a" /* default */])().curve(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["a" /* curveRadialLinear */]));
});


/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x, y) {
  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
});


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var slice = Array.prototype.slice;


/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / __WEBPACK_IMPORTED_MODULE_0__math__["j" /* pi */]);
    context.moveTo(r, 0);
    context.arc(0, 0, r, 0, __WEBPACK_IMPORTED_MODULE_0__math__["m" /* tau */]);
  }
});


/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / 5) / 2;
    context.moveTo(-3 * r, -r);
    context.lineTo(-r, -r);
    context.lineTo(-r, -3 * r);
    context.lineTo(r, -3 * r);
    context.lineTo(r, -r);
    context.lineTo(3 * r, -r);
    context.lineTo(3 * r, r);
    context.lineTo(r, r);
    context.lineTo(r, 3 * r);
    context.lineTo(-r, 3 * r);
    context.lineTo(-r, r);
    context.lineTo(-3 * r, r);
    context.closePath();
  }
});


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var tan30 = Math.sqrt(1 / 3),
    tan30_2 = tan30 * 2;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var y = Math.sqrt(size / tan30_2),
        x = y * tan30;
    context.moveTo(0, -y);
    context.lineTo(x, 0);
    context.lineTo(0, y);
    context.lineTo(-x, 0);
    context.closePath();
  }
});


/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(34);


var ka = 0.89081309152928522810,
    kr = Math.sin(__WEBPACK_IMPORTED_MODULE_0__math__["j" /* pi */] / 10) / Math.sin(7 * __WEBPACK_IMPORTED_MODULE_0__math__["j" /* pi */] / 10),
    kx = Math.sin(__WEBPACK_IMPORTED_MODULE_0__math__["m" /* tau */] / 10) * kr,
    ky = -Math.cos(__WEBPACK_IMPORTED_MODULE_0__math__["m" /* tau */] / 10) * kr;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size * ka),
        x = kx * r,
        y = ky * r;
    context.moveTo(0, -r);
    context.lineTo(x, y);
    for (var i = 1; i < 5; ++i) {
      var a = __WEBPACK_IMPORTED_MODULE_0__math__["m" /* tau */] * i / 5,
          c = Math.cos(a),
          s = Math.sin(a);
      context.lineTo(s * r, -c * r);
      context.lineTo(c * x - s * y, s * x + c * y);
    }
    context.closePath();
  }
});


/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var w = Math.sqrt(size),
        x = -w / 2;
    context.rect(x, x, w, w);
  }
});


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var sqrt3 = Math.sqrt(3);

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var y = -Math.sqrt(size / (sqrt3 * 3));
    context.moveTo(0, y * 2);
    context.lineTo(-sqrt3 * y, -y);
    context.lineTo(sqrt3 * y, -y);
    context.closePath();
  }
});


/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var c = -0.5,
    s = Math.sqrt(3) / 2,
    k = 1 / Math.sqrt(12),
    a = (k / 2 + 1) * 3;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / a),
        x0 = r / 2,
        y0 = r * k,
        x1 = x0,
        y1 = r * k + r,
        x2 = -x1,
        y2 = y1;
    context.moveTo(x0, y0);
    context.lineTo(x1, y1);
    context.lineTo(x2, y2);
    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
    context.closePath();
  }
});


/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CardinalClosed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardinal__ = __webpack_require__(55);



function CardinalClosed(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: Object(__WEBPACK_IMPORTED_MODULE_1__cardinal__["c" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["b"] = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalClosed(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CardinalOpen;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinal__ = __webpack_require__(55);


function CardinalOpen(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: Object(__WEBPACK_IMPORTED_MODULE_0__cardinal__["c" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["b"] = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalOpen(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = createCell;
/* harmony export (immutable) */ __webpack_exports__["a"] = cellHalfedgeStart;
/* unused harmony export cellHalfedgeEnd */
/* harmony export (immutable) */ __webpack_exports__["d"] = sortCellHalfedges;
/* harmony export (immutable) */ __webpack_exports__["b"] = clipCells;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Edge__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Diagram__ = __webpack_require__(37);



function createCell(site) {
  return __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */][site.index] = {
    site: site,
    halfedges: []
  };
}

function cellHalfedgeAngle(cell, edge) {
  var site = cell.site,
      va = edge.left,
      vb = edge.right;
  if (site === vb) vb = va, va = site;
  if (vb) return Math.atan2(vb[1] - va[1], vb[0] - va[0]);
  if (site === va) va = edge[1], vb = edge[0];
  else va = edge[0], vb = edge[1];
  return Math.atan2(va[0] - vb[0], vb[1] - va[1]);
}

function cellHalfedgeStart(cell, edge) {
  return edge[+(edge.left !== cell.site)];
}

function cellHalfedgeEnd(cell, edge) {
  return edge[+(edge.left === cell.site)];
}

function sortCellHalfedges() {
  for (var i = 0, n = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */].length, cell, halfedges, j, m; i < n; ++i) {
    if ((cell = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */][i]) && (m = (halfedges = cell.halfedges).length)) {
      var index = new Array(m),
          array = new Array(m);
      for (j = 0; j < m; ++j) index[j] = j, array[j] = cellHalfedgeAngle(cell, __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */][halfedges[j]]);
      index.sort(function(i, j) { return array[j] - array[i]; });
      for (j = 0; j < m; ++j) array[j] = halfedges[index[j]];
      for (j = 0; j < m; ++j) halfedges[j] = array[j];
    }
  }
}

function clipCells(x0, y0, x1, y1) {
  var nCells = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */].length,
      iCell,
      cell,
      site,
      iHalfedge,
      halfedges,
      nHalfedges,
      start,
      startX,
      startY,
      end,
      endX,
      endY,
      cover = true;

  for (iCell = 0; iCell < nCells; ++iCell) {
    if (cell = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */][iCell]) {
      site = cell.site;
      halfedges = cell.halfedges;
      iHalfedge = halfedges.length;

      // Remove any dangling clipped edges.
      while (iHalfedge--) {
        if (!__WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */][halfedges[iHalfedge]]) {
          halfedges.splice(iHalfedge, 1);
        }
      }

      // Insert any border edges as necessary.
      iHalfedge = 0, nHalfedges = halfedges.length;
      while (iHalfedge < nHalfedges) {
        end = cellHalfedgeEnd(cell, __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */][halfedges[iHalfedge]]), endX = end[0], endY = end[1];
        start = cellHalfedgeStart(cell, __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */][halfedges[++iHalfedge % nHalfedges]]), startX = start[0], startY = start[1];
        if (Math.abs(endX - startX) > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] || Math.abs(endY - startY) > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */]) {
          halfedges.splice(iHalfedge, 0, __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */].push(Object(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site, end,
              Math.abs(endX - x0) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] && y1 - endY > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? [x0, Math.abs(startX - x0) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? startY : y1]
              : Math.abs(endY - y1) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] && x1 - endX > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? [Math.abs(startY - y1) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? startX : x1, y1]
              : Math.abs(endX - x1) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] && endY - y0 > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? [x1, Math.abs(startX - x1) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? startY : y0]
              : Math.abs(endY - y0) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] && endX - x0 > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? [Math.abs(startY - y0) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? startX : x0, y0]
              : null)) - 1);
          ++nHalfedges;
        }
      }

      if (nHalfedges) cover = false;
    }
  }

  // If there weren’t any edges, have the closest site cover the extent.
  // It doesn’t matter which corner of the extent we measure!
  if (cover) {
    var dx, dy, d2, dc = Infinity;

    for (iCell = 0, cover = null; iCell < nCells; ++iCell) {
      if (cell = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */][iCell]) {
        site = cell.site;
        dx = site[0] - x0;
        dy = site[1] - y0;
        d2 = dx * dx + dy * dy;
        if (d2 < dc) dc = d2, cover = cell;
      }
    }

    if (cover) {
      var v00 = [x0, y0], v01 = [x0, y1], v11 = [x1, y1], v10 = [x1, y0];
      cover.halfedges.push(
        __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */].push(Object(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site = cover.site, v00, v01)) - 1,
        __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */].push(Object(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site, v01, v11)) - 1,
        __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */].push(Object(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site, v11, v10)) - 1,
        __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */].push(Object(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site, v10, v00)) - 1
      );
    }
  }

  // Lastly delete any cells with no edges; these were entirely clipped.
  for (iCell = 0; iCell < nCells; ++iCell) {
    if (cell = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */][iCell]) {
      if (!cell.halfedges.length) {
        delete __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */][iCell];
      }
    }
  }
}


/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return firstCircle; });
/* harmony export (immutable) */ __webpack_exports__["a"] = attachCircle;
/* harmony export (immutable) */ __webpack_exports__["b"] = detachCircle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RedBlackTree__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Diagram__ = __webpack_require__(37);



var circlePool = [];

var firstCircle;

function Circle() {
  Object(__WEBPACK_IMPORTED_MODULE_0__RedBlackTree__["a" /* RedBlackNode */])(this);
  this.x =
  this.y =
  this.arc =
  this.site =
  this.cy = null;
}

function attachCircle(arc) {
  var lArc = arc.P,
      rArc = arc.N;

  if (!lArc || !rArc) return;

  var lSite = lArc.site,
      cSite = arc.site,
      rSite = rArc.site;

  if (lSite === rSite) return;

  var bx = cSite[0],
      by = cSite[1],
      ax = lSite[0] - bx,
      ay = lSite[1] - by,
      cx = rSite[0] - bx,
      cy = rSite[1] - by;

  var d = 2 * (ax * cy - ay * cx);
  if (d >= -__WEBPACK_IMPORTED_MODULE_1__Diagram__["g" /* epsilon2 */]) return;

  var ha = ax * ax + ay * ay,
      hc = cx * cx + cy * cy,
      x = (cy * ha - ay * hc) / d,
      y = (ax * hc - cx * ha) / d;

  var circle = circlePool.pop() || new Circle;
  circle.arc = arc;
  circle.site = cSite;
  circle.x = x + bx;
  circle.y = (circle.cy = y + by) + Math.sqrt(x * x + y * y); // y bottom

  arc.circle = circle;

  var before = null,
      node = __WEBPACK_IMPORTED_MODULE_1__Diagram__["c" /* circles */]._;

  while (node) {
    if (circle.y < node.y || (circle.y === node.y && circle.x <= node.x)) {
      if (node.L) node = node.L;
      else { before = node.P; break; }
    } else {
      if (node.R) node = node.R;
      else { before = node; break; }
    }
  }

  __WEBPACK_IMPORTED_MODULE_1__Diagram__["c" /* circles */].insert(before, circle);
  if (!before) firstCircle = circle;
}

function detachCircle(arc) {
  var circle = arc.circle;
  if (circle) {
    if (!circle.P) firstCircle = circle.N;
    __WEBPACK_IMPORTED_MODULE_1__Diagram__["c" /* circles */].remove(circle);
    circlePool.push(circle);
    Object(__WEBPACK_IMPORTED_MODULE_0__RedBlackTree__["a" /* RedBlackNode */])(circle);
    arc.circle = null;
  }
}


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Transform;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return identity; });
/* harmony export (immutable) */ __webpack_exports__["b"] = transform;
function Transform(k, x, y) {
  this.k = k;
  this.x = x;
  this.y = y;
}

Transform.prototype = {
  constructor: Transform,
  scale: function(k) {
    return k === 1 ? this : new Transform(this.k * k, this.x, this.y);
  },
  translate: function(x, y) {
    return x === 0 & y === 0 ? this : new Transform(this.k, this.x + this.k * x, this.y + this.k * y);
  },
  apply: function(point) {
    return [point[0] * this.k + this.x, point[1] * this.k + this.y];
  },
  applyX: function(x) {
    return x * this.k + this.x;
  },
  applyY: function(y) {
    return y * this.k + this.y;
  },
  invert: function(location) {
    return [(location[0] - this.x) / this.k, (location[1] - this.y) / this.k];
  },
  invertX: function(x) {
    return (x - this.x) / this.k;
  },
  invertY: function(y) {
    return (y - this.y) / this.k;
  },
  rescaleX: function(x) {
    return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
  },
  rescaleY: function(y) {
    return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};

var identity = new Transform(1, 0, 0);

transform.prototype = Transform.prototype;

function transform(node) {
  return node.__zoom || identity;
}


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = global || self, factory(global.idb = {}));
}(this, function (exports) { 'use strict';

  function toArray(arr) {
    return Array.prototype.slice.call(arr);
  }

  function promisifyRequest(request) {
    return new Promise(function(resolve, reject) {
      request.onsuccess = function() {
        resolve(request.result);
      };

      request.onerror = function() {
        reject(request.error);
      };
    });
  }

  function promisifyRequestCall(obj, method, args) {
    var request;
    var p = new Promise(function(resolve, reject) {
      request = obj[method].apply(obj, args);
      promisifyRequest(request).then(resolve, reject);
    });

    p.request = request;
    return p;
  }

  function promisifyCursorRequestCall(obj, method, args) {
    var p = promisifyRequestCall(obj, method, args);
    return p.then(function(value) {
      if (!value) return;
      return new Cursor(value, p.request);
    });
  }

  function proxyProperties(ProxyClass, targetProp, properties) {
    properties.forEach(function(prop) {
      Object.defineProperty(ProxyClass.prototype, prop, {
        get: function() {
          return this[targetProp][prop];
        },
        set: function(val) {
          this[targetProp][prop] = val;
        }
      });
    });
  }

  function proxyRequestMethods(ProxyClass, targetProp, Constructor, properties) {
    properties.forEach(function(prop) {
      if (!(prop in Constructor.prototype)) return;
      ProxyClass.prototype[prop] = function() {
        return promisifyRequestCall(this[targetProp], prop, arguments);
      };
    });
  }

  function proxyMethods(ProxyClass, targetProp, Constructor, properties) {
    properties.forEach(function(prop) {
      if (!(prop in Constructor.prototype)) return;
      ProxyClass.prototype[prop] = function() {
        return this[targetProp][prop].apply(this[targetProp], arguments);
      };
    });
  }

  function proxyCursorRequestMethods(ProxyClass, targetProp, Constructor, properties) {
    properties.forEach(function(prop) {
      if (!(prop in Constructor.prototype)) return;
      ProxyClass.prototype[prop] = function() {
        return promisifyCursorRequestCall(this[targetProp], prop, arguments);
      };
    });
  }

  function Index(index) {
    this._index = index;
  }

  proxyProperties(Index, '_index', [
    'name',
    'keyPath',
    'multiEntry',
    'unique'
  ]);

  proxyRequestMethods(Index, '_index', IDBIndex, [
    'get',
    'getKey',
    'getAll',
    'getAllKeys',
    'count'
  ]);

  proxyCursorRequestMethods(Index, '_index', IDBIndex, [
    'openCursor',
    'openKeyCursor'
  ]);

  function Cursor(cursor, request) {
    this._cursor = cursor;
    this._request = request;
  }

  proxyProperties(Cursor, '_cursor', [
    'direction',
    'key',
    'primaryKey',
    'value'
  ]);

  proxyRequestMethods(Cursor, '_cursor', IDBCursor, [
    'update',
    'delete'
  ]);

  // proxy 'next' methods
  ['advance', 'continue', 'continuePrimaryKey'].forEach(function(methodName) {
    if (!(methodName in IDBCursor.prototype)) return;
    Cursor.prototype[methodName] = function() {
      var cursor = this;
      var args = arguments;
      return Promise.resolve().then(function() {
        cursor._cursor[methodName].apply(cursor._cursor, args);
        return promisifyRequest(cursor._request).then(function(value) {
          if (!value) return;
          return new Cursor(value, cursor._request);
        });
      });
    };
  });

  function ObjectStore(store) {
    this._store = store;
  }

  ObjectStore.prototype.createIndex = function() {
    return new Index(this._store.createIndex.apply(this._store, arguments));
  };

  ObjectStore.prototype.index = function() {
    return new Index(this._store.index.apply(this._store, arguments));
  };

  proxyProperties(ObjectStore, '_store', [
    'name',
    'keyPath',
    'indexNames',
    'autoIncrement'
  ]);

  proxyRequestMethods(ObjectStore, '_store', IDBObjectStore, [
    'put',
    'add',
    'delete',
    'clear',
    'get',
    'getAll',
    'getKey',
    'getAllKeys',
    'count'
  ]);

  proxyCursorRequestMethods(ObjectStore, '_store', IDBObjectStore, [
    'openCursor',
    'openKeyCursor'
  ]);

  proxyMethods(ObjectStore, '_store', IDBObjectStore, [
    'deleteIndex'
  ]);

  function Transaction(idbTransaction) {
    this._tx = idbTransaction;
    this.complete = new Promise(function(resolve, reject) {
      idbTransaction.oncomplete = function() {
        resolve();
      };
      idbTransaction.onerror = function() {
        reject(idbTransaction.error);
      };
      idbTransaction.onabort = function() {
        reject(idbTransaction.error);
      };
    });
  }

  Transaction.prototype.objectStore = function() {
    return new ObjectStore(this._tx.objectStore.apply(this._tx, arguments));
  };

  proxyProperties(Transaction, '_tx', [
    'objectStoreNames',
    'mode'
  ]);

  proxyMethods(Transaction, '_tx', IDBTransaction, [
    'abort'
  ]);

  function UpgradeDB(db, oldVersion, transaction) {
    this._db = db;
    this.oldVersion = oldVersion;
    this.transaction = new Transaction(transaction);
  }

  UpgradeDB.prototype.createObjectStore = function() {
    return new ObjectStore(this._db.createObjectStore.apply(this._db, arguments));
  };

  proxyProperties(UpgradeDB, '_db', [
    'name',
    'version',
    'objectStoreNames'
  ]);

  proxyMethods(UpgradeDB, '_db', IDBDatabase, [
    'deleteObjectStore',
    'close'
  ]);

  function DB(db) {
    this._db = db;
  }

  DB.prototype.transaction = function() {
    return new Transaction(this._db.transaction.apply(this._db, arguments));
  };

  proxyProperties(DB, '_db', [
    'name',
    'version',
    'objectStoreNames'
  ]);

  proxyMethods(DB, '_db', IDBDatabase, [
    'close'
  ]);

  // Add cursor iterators
  // TODO: remove this once browsers do the right thing with promises
  ['openCursor', 'openKeyCursor'].forEach(function(funcName) {
    [ObjectStore, Index].forEach(function(Constructor) {
      // Don't create iterateKeyCursor if openKeyCursor doesn't exist.
      if (!(funcName in Constructor.prototype)) return;

      Constructor.prototype[funcName.replace('open', 'iterate')] = function() {
        var args = toArray(arguments);
        var callback = args[args.length - 1];
        var nativeObject = this._store || this._index;
        var request = nativeObject[funcName].apply(nativeObject, args.slice(0, -1));
        request.onsuccess = function() {
          callback(request.result);
        };
      };
    });
  });

  // polyfill getAll
  [Index, ObjectStore].forEach(function(Constructor) {
    if (Constructor.prototype.getAll) return;
    Constructor.prototype.getAll = function(query, count) {
      var instance = this;
      var items = [];

      return new Promise(function(resolve) {
        instance.iterateCursor(query, function(cursor) {
          if (!cursor) {
            resolve(items);
            return;
          }
          items.push(cursor.value);

          if (count !== undefined && items.length == count) {
            resolve(items);
            return;
          }
          cursor.continue();
        });
      });
    };
  });

  function openDb(name, version, upgradeCallback) {
    var p = promisifyRequestCall(indexedDB, 'open', [name, version]);
    var request = p.request;

    if (request) {
      request.onupgradeneeded = function(event) {
        if (upgradeCallback) {
          upgradeCallback(new UpgradeDB(request.result, event.oldVersion, request.transaction));
        }
      };
    }

    return p.then(function(db) {
      return new DB(db);
    });
  }

  function deleteDb(name) {
    return promisifyRequestCall(indexedDB, 'deleteDatabase', [name]);
  }

  exports.openDb = openDb;
  exports.deleteDb = deleteDb;

  Object.defineProperty(exports, '__esModule', { value: true });

}));


/***/ }),
/* 190 */
/***/ (function(module, exports) {

module.exports = function escape(url) {
    if (typeof url !== 'string') {
        return url
    }
    // If url is already wrapped in quotes, remove them
    if (/^['"].*['"]$/.test(url)) {
        url = url.slice(1, -1);
    }
    // Should url be wrapped?
    // See https://drafts.csswg.org/css-values-3/#urls
    if (/["'() \t\n]/.test(url)) {
        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
    }

    return url
}


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_package__ = __webpack_require__(230);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "version", function() { return __WEBPACK_IMPORTED_MODULE_0__build_package__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_array__ = __webpack_require__(4);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "bisect", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "bisectRight", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "bisectLeft", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ascending", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "bisector", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "cross", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "descending", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "deviation", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "extent", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "histogram", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "thresholdFreedmanDiaconis", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["w"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "thresholdScott", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["x"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "thresholdSturges", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["y"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "max", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "mean", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "median", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "merge", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "min", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["o"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "pairs", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["p"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "permute", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "quantile", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["r"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "range", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["s"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "scan", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["t"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "shuffle", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["u"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "sum", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["v"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ticks", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["B"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "tickIncrement", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["z"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "tickStep", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["A"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "transpose", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["C"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "variance", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["D"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "zip", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["E"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_axis__ = __webpack_require__(247);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "axisTop", function() { return __WEBPACK_IMPORTED_MODULE_2_d3_axis__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "axisRight", function() { return __WEBPACK_IMPORTED_MODULE_2_d3_axis__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "axisBottom", function() { return __WEBPACK_IMPORTED_MODULE_2_d3_axis__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "axisLeft", function() { return __WEBPACK_IMPORTED_MODULE_2_d3_axis__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_brush__ = __webpack_require__(251);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "brush", function() { return __WEBPACK_IMPORTED_MODULE_3_d3_brush__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "brushX", function() { return __WEBPACK_IMPORTED_MODULE_3_d3_brush__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "brushY", function() { return __WEBPACK_IMPORTED_MODULE_3_d3_brush__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "brushSelection", function() { return __WEBPACK_IMPORTED_MODULE_3_d3_brush__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_chord__ = __webpack_require__(338);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "chord", function() { return __WEBPACK_IMPORTED_MODULE_4_d3_chord__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ribbon", function() { return __WEBPACK_IMPORTED_MODULE_4_d3_chord__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_d3_collection__ = __webpack_require__(28);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "nest", function() { return __WEBPACK_IMPORTED_MODULE_5_d3_collection__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "set", function() { return __WEBPACK_IMPORTED_MODULE_5_d3_collection__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "map", function() { return __WEBPACK_IMPORTED_MODULE_5_d3_collection__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "keys", function() { return __WEBPACK_IMPORTED_MODULE_5_d3_collection__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "values", function() { return __WEBPACK_IMPORTED_MODULE_5_d3_collection__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "entries", function() { return __WEBPACK_IMPORTED_MODULE_5_d3_collection__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_d3_color__ = __webpack_require__(9);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "color", function() { return __WEBPACK_IMPORTED_MODULE_6_d3_color__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "rgb", function() { return __WEBPACK_IMPORTED_MODULE_6_d3_color__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "hsl", function() { return __WEBPACK_IMPORTED_MODULE_6_d3_color__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "lab", function() { return __WEBPACK_IMPORTED_MODULE_6_d3_color__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "hcl", function() { return __WEBPACK_IMPORTED_MODULE_6_d3_color__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "cubehelix", function() { return __WEBPACK_IMPORTED_MODULE_6_d3_color__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_d3_dispatch__ = __webpack_require__(14);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "dispatch", function() { return __WEBPACK_IMPORTED_MODULE_7_d3_dispatch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_d3_drag__ = __webpack_require__(59);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "drag", function() { return __WEBPACK_IMPORTED_MODULE_8_d3_drag__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "dragDisable", function() { return __WEBPACK_IMPORTED_MODULE_8_d3_drag__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "dragEnable", function() { return __WEBPACK_IMPORTED_MODULE_8_d3_drag__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_d3_dsv__ = __webpack_require__(73);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "dsvFormat", function() { return __WEBPACK_IMPORTED_MODULE_9_d3_dsv__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "csvParse", function() { return __WEBPACK_IMPORTED_MODULE_9_d3_dsv__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "csvParseRows", function() { return __WEBPACK_IMPORTED_MODULE_9_d3_dsv__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "csvFormat", function() { return __WEBPACK_IMPORTED_MODULE_9_d3_dsv__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "csvFormatRows", function() { return __WEBPACK_IMPORTED_MODULE_9_d3_dsv__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "tsvParse", function() { return __WEBPACK_IMPORTED_MODULE_9_d3_dsv__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "tsvParseRows", function() { return __WEBPACK_IMPORTED_MODULE_9_d3_dsv__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "tsvFormat", function() { return __WEBPACK_IMPORTED_MODULE_9_d3_dsv__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "tsvFormatRows", function() { return __WEBPACK_IMPORTED_MODULE_9_d3_dsv__["g"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_d3_ease__ = __webpack_require__(137);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeLinear", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["y"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeQuad", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["D"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeQuadIn", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["E"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeQuadOut", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["G"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeQuadInOut", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["F"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeCubic", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeCubicIn", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeCubicOut", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["p"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeCubicInOut", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["o"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easePoly", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["z"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easePolyIn", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["A"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easePolyOut", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["C"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easePolyInOut", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["B"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeSin", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["H"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeSinIn", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["I"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeSinOut", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["K"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeSinInOut", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["J"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeExp", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["u"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeExpIn", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["v"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeExpOut", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["x"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeExpInOut", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["w"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeCircle", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeCircleIn", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeCircleOut", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeCircleInOut", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeBounce", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeBounceIn", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeBounceOut", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeBounceInOut", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeBack", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeBackIn", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeBackOut", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeBackInOut", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeElastic", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeElasticIn", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["r"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeElasticOut", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["t"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeElasticInOut", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["s"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_d3_force__ = __webpack_require__(351);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "forceCenter", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_force__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "forceCollide", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_force__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "forceLink", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_force__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "forceManyBody", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_force__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "forceRadial", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_force__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "forceSimulation", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_force__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "forceX", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_force__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "forceY", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_force__["h"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_d3_format__ = __webpack_require__(78);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "formatDefaultLocale", function() { return __WEBPACK_IMPORTED_MODULE_12_d3_format__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "format", function() { return __WEBPACK_IMPORTED_MODULE_12_d3_format__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "formatPrefix", function() { return __WEBPACK_IMPORTED_MODULE_12_d3_format__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "formatLocale", function() { return __WEBPACK_IMPORTED_MODULE_12_d3_format__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "formatSpecifier", function() { return __WEBPACK_IMPORTED_MODULE_12_d3_format__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "precisionFixed", function() { return __WEBPACK_IMPORTED_MODULE_12_d3_format__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "precisionPrefix", function() { return __WEBPACK_IMPORTED_MODULE_12_d3_format__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "precisionRound", function() { return __WEBPACK_IMPORTED_MODULE_12_d3_format__["h"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_d3_geo__ = __webpack_require__(381);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoArea", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoBounds", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoCentroid", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoCircle", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoClipAntimeridian", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoClipCircle", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoClipExtent", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoClipRectangle", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoContains", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["u"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoDistance", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["v"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoGraticule", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["A"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoGraticule10", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["B"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoInterpolate", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["D"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoLength", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["E"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoPath", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["L"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoAlbers", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoAlbersUsa", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoAzimuthalEqualArea", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoAzimuthalEqualAreaRaw", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoAzimuthalEquidistant", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoAzimuthalEquidistantRaw", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoConicConformal", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["o"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoConicConformalRaw", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["p"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoConicEqualArea", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoConicEqualAreaRaw", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["r"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoConicEquidistant", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["s"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoConicEquidistantRaw", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["t"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoEquirectangular", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["w"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoEquirectangularRaw", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["x"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoGnomonic", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["y"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoGnomonicRaw", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["z"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoIdentity", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["C"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoProjection", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["M"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoProjectionMutator", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["N"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoMercator", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["F"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoMercatorRaw", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["G"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoNaturalEarth1", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["H"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoNaturalEarth1Raw", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["I"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoOrthographic", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["J"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoOrthographicRaw", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["K"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoStereographic", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["P"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoStereographicRaw", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["Q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoTransverseMercator", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["T"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoTransverseMercatorRaw", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["U"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoRotation", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["O"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoStream", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["R"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoTransform", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["S"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_d3_hierarchy__ = __webpack_require__(409);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "cluster", function() { return __WEBPACK_IMPORTED_MODULE_14_d3_hierarchy__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "hierarchy", function() { return __WEBPACK_IMPORTED_MODULE_14_d3_hierarchy__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "pack", function() { return __WEBPACK_IMPORTED_MODULE_14_d3_hierarchy__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "packSiblings", function() { return __WEBPACK_IMPORTED_MODULE_14_d3_hierarchy__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "packEnclose", function() { return __WEBPACK_IMPORTED_MODULE_14_d3_hierarchy__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "partition", function() { return __WEBPACK_IMPORTED_MODULE_14_d3_hierarchy__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "stratify", function() { return __WEBPACK_IMPORTED_MODULE_14_d3_hierarchy__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "tree", function() { return __WEBPACK_IMPORTED_MODULE_14_d3_hierarchy__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "treemap", function() { return __WEBPACK_IMPORTED_MODULE_14_d3_hierarchy__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "treemapBinary", function() { return __WEBPACK_IMPORTED_MODULE_14_d3_hierarchy__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "treemapDice", function() { return __WEBPACK_IMPORTED_MODULE_14_d3_hierarchy__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "treemapSlice", function() { return __WEBPACK_IMPORTED_MODULE_14_d3_hierarchy__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "treemapSliceDice", function() { return __WEBPACK_IMPORTED_MODULE_14_d3_hierarchy__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "treemapSquarify", function() { return __WEBPACK_IMPORTED_MODULE_14_d3_hierarchy__["o"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "treemapResquarify", function() { return __WEBPACK_IMPORTED_MODULE_14_d3_hierarchy__["l"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__ = __webpack_require__(7);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolate", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateArray", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateBasis", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateBasisClosed", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateDate", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateNumber", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateObject", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateRound", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["r"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateString", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["s"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateTransformCss", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["t"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateTransformSvg", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["u"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateZoom", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["v"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateRgb", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["o"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateRgbBasis", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["p"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateRgbBasisClosed", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateHsl", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateHslLong", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateLab", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateHcl", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateHclLong", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateCubehelix", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateCubehelixLong", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "quantize", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["w"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_d3_path__ = __webpack_require__(15);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "path", function() { return __WEBPACK_IMPORTED_MODULE_16_d3_path__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_d3_polygon__ = __webpack_require__(431);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "polygonArea", function() { return __WEBPACK_IMPORTED_MODULE_17_d3_polygon__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "polygonCentroid", function() { return __WEBPACK_IMPORTED_MODULE_17_d3_polygon__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "polygonHull", function() { return __WEBPACK_IMPORTED_MODULE_17_d3_polygon__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "polygonContains", function() { return __WEBPACK_IMPORTED_MODULE_17_d3_polygon__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "polygonLength", function() { return __WEBPACK_IMPORTED_MODULE_17_d3_polygon__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_d3_quadtree__ = __webpack_require__(76);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "quadtree", function() { return __WEBPACK_IMPORTED_MODULE_18_d3_quadtree__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_d3_queue__ = __webpack_require__(438);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "queue", function() { return __WEBPACK_IMPORTED_MODULE_19_d3_queue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_d3_random__ = __webpack_require__(441);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "randomUniform", function() { return __WEBPACK_IMPORTED_MODULE_20_d3_random__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "randomNormal", function() { return __WEBPACK_IMPORTED_MODULE_20_d3_random__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "randomLogNormal", function() { return __WEBPACK_IMPORTED_MODULE_20_d3_random__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "randomBates", function() { return __WEBPACK_IMPORTED_MODULE_20_d3_random__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "randomIrwinHall", function() { return __WEBPACK_IMPORTED_MODULE_20_d3_random__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "randomExponential", function() { return __WEBPACK_IMPORTED_MODULE_20_d3_random__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_d3_request__ = __webpack_require__(446);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "request", function() { return __WEBPACK_IMPORTED_MODULE_21_d3_request__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "html", function() { return __WEBPACK_IMPORTED_MODULE_21_d3_request__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "json", function() { return __WEBPACK_IMPORTED_MODULE_21_d3_request__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "text", function() { return __WEBPACK_IMPORTED_MODULE_21_d3_request__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "xml", function() { return __WEBPACK_IMPORTED_MODULE_21_d3_request__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "csv", function() { return __WEBPACK_IMPORTED_MODULE_21_d3_request__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "tsv", function() { return __WEBPACK_IMPORTED_MODULE_21_d3_request__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_d3_scale__ = __webpack_require__(453);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "scaleBand", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "scalePoint", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["o"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "scaleIdentity", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "scaleLinear", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "scaleLog", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "scaleOrdinal", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "scaleImplicit", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "scalePow", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["p"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "scaleSqrt", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["t"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "scaleQuantile", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "scaleQuantize", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["r"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "scaleThreshold", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["u"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "scaleTime", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["v"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "scaleUtc", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["w"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "schemeCategory10", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["x"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "schemeCategory20b", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["z"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "schemeCategory20c", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["A"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "schemeCategory20", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["y"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateCubehelixDefault", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateRainbow", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateWarm", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateCool", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateViridis", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateMagma", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateInferno", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolatePlasma", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "scaleSequential", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["s"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_d3_selection__ = __webpack_require__(1);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "create", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_selection__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "creator", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_selection__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "local", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_selection__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "matcher", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_selection__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "mouse", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_selection__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "namespace", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_selection__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "namespaces", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_selection__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "clientPoint", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_selection__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "select", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_selection__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "selectAll", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_selection__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "selection", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_selection__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "selector", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_selection__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "selectorAll", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_selection__["o"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "style", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_selection__["p"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "touch", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_selection__["q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "touches", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_selection__["r"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "window", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_selection__["s"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "event", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_selection__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "customEvent", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_selection__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_d3_shape__ = __webpack_require__(486);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "arc", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "area", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "line", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["v"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "pie", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["A"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "areaRadial", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "radialArea", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["C"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "lineRadial", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["w"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "radialLine", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["D"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "pointRadial", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["B"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "linkHorizontal", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["x"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "linkVertical", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["z"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "linkRadial", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["y"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "symbol", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["P"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "symbols", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["X"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "symbolCircle", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["Q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "symbolCross", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["R"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "symbolDiamond", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["S"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "symbolSquare", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["T"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "symbolStar", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["U"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "symbolTriangle", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["V"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "symbolWye", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["W"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "curveBasisClosed", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "curveBasisOpen", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "curveBasis", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "curveBundle", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "curveCardinalClosed", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "curveCardinalOpen", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "curveCardinal", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "curveCatmullRomClosed", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "curveCatmullRomOpen", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "curveCatmullRom", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "curveLinearClosed", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["o"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "curveLinear", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "curveMonotoneX", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["p"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "curveMonotoneY", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "curveNatural", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["r"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "curveStep", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["s"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "curveStepAfter", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["t"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "curveStepBefore", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["u"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "stack", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["E"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "stackOffsetExpand", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["G"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "stackOffsetDiverging", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["F"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "stackOffsetNone", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["H"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "stackOffsetSilhouette", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["I"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "stackOffsetWiggle", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["J"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "stackOrderAscending", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["K"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "stackOrderDescending", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["L"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "stackOrderInsideOut", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["M"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "stackOrderNone", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["N"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "stackOrderReverse", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["O"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_d3_time__ = __webpack_require__(51);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeInterval", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeMillisecond", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeMilliseconds", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcMillisecond", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["L"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcMilliseconds", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["M"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeSecond", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["r"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeSeconds", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["s"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcSecond", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["V"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcSeconds", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["W"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeMinute", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeMinutes", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeHour", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeHours", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeDay", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeDays", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeWeek", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["B"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeWeeks", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["C"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeSunday", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["t"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeSundays", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["u"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeMonday", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeMondays", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeTuesday", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["x"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeTuesdays", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["y"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeWednesday", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["z"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeWednesdays", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["A"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeThursday", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["v"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeThursdays", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["w"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeFriday", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeFridays", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeSaturday", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["p"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeSaturdays", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeMonth", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeMonths", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["o"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeYear", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["D"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeYears", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["E"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcMinute", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["N"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcMinutes", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["O"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcHour", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["J"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcHours", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["K"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcDay", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["F"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcDays", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["G"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcWeek", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["_5"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcWeeks", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["_6"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcSunday", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["X"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcSundays", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["Y"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcMonday", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["P"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcMondays", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["Q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcTuesday", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["_1"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcTuesdays", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["_2"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcWednesday", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["_3"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcWednesdays", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["_4"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcThursday", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["Z"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcThursdays", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["_0"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcFriday", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["H"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcFridays", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["I"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcSaturday", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["T"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcSaturdays", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["U"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcMonth", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["R"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcMonths", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["S"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcYear", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["_7"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcYears", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["_8"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_d3_time_format__ = __webpack_require__(90);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeFormatDefaultLocale", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time_format__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeFormat", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time_format__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeParse", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time_format__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcFormat", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time_format__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcParse", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time_format__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeFormatLocale", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time_format__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isoFormat", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time_format__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isoParse", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time_format__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_d3_timer__ = __webpack_require__(42);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "now", function() { return __WEBPACK_IMPORTED_MODULE_27_d3_timer__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timer", function() { return __WEBPACK_IMPORTED_MODULE_27_d3_timer__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timerFlush", function() { return __WEBPACK_IMPORTED_MODULE_27_d3_timer__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeout", function() { return __WEBPACK_IMPORTED_MODULE_27_d3_timer__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interval", function() { return __WEBPACK_IMPORTED_MODULE_27_d3_timer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_d3_transition__ = __webpack_require__(70);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "transition", function() { return __WEBPACK_IMPORTED_MODULE_28_d3_transition__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "active", function() { return __WEBPACK_IMPORTED_MODULE_28_d3_transition__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interrupt", function() { return __WEBPACK_IMPORTED_MODULE_28_d3_transition__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_d3_voronoi__ = __webpack_require__(511);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "voronoi", function() { return __WEBPACK_IMPORTED_MODULE_29_d3_voronoi__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_d3_zoom__ = __webpack_require__(516);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "zoom", function() { return __WEBPACK_IMPORTED_MODULE_30_d3_zoom__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "zoomTransform", function() { return __WEBPACK_IMPORTED_MODULE_30_d3_zoom__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "zoomIdentity", function() { return __WEBPACK_IMPORTED_MODULE_30_d3_zoom__["b"]; });

































/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(193);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(20)))

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(20), __webpack_require__(194)))

/***/ }),
/* 194 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(103);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b37cc15_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(200);
function injectStyle (ssrContext) {
  __webpack_require__(196)
}
var normalizeComponent = __webpack_require__(57)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b37cc15_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(197);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(25)("657c6734", content, true, {});

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(19)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 198 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*! @license Firebase v3.3.0
    Build: 3.3.0-rc.7
    Terms: https://developers.google.com/terms */
(function () {
    var aa = "function" == typeof Object.defineProperties ? Object.defineProperty : function (a, b, c) {
        if (c.get || c.set) throw new TypeError("ES3 does not support getters and setters.");a != Array.prototype && a != Object.prototype && (a[b] = c.value);
    },
        h = "undefined" != typeof window && window === this ? this : "undefined" != typeof global ? global : this,
        _l = function l() {
        _l = function l() {};h.Symbol || (h.Symbol = ba);
    },
        ca = 0,
        ba = function ba(a) {
        return "jscomp_symbol_" + (a || "") + ca++;
    },
        _p = function p() {
        _l();var a = h.Symbol.iterator;a || (a = h.Symbol.iterator = h.Symbol("iterator"));
        "function" != typeof Array.prototype[a] && aa(Array.prototype, a, { configurable: !0, writable: !0, value: function value() {
                return m(this);
            } });_p = function p() {};
    },
        m = function m(a) {
        var b = 0;return da(function () {
            return b < a.length ? { done: !1, value: a[b++] } : { done: !0 };
        });
    },
        da = function da(a) {
        _p();a = { next: a };a[h.Symbol.iterator] = function () {
            return this;
        };return a;
    },
        q = this,
        r = function r() {},
        t = function t(a) {
        var b = typeof a === "undefined" ? "undefined" : _typeof(a);if ("object" == b) {
            if (a) {
                if (a instanceof Array) return "array";if (a instanceof Object) return b;var c = Object.prototype.toString.call(a);
                if ("[object Window]" == c) return "object";if ("[object Array]" == c || "number" == typeof a.length && "undefined" != typeof a.splice && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("splice")) return "array";if ("[object Function]" == c || "undefined" != typeof a.call && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("call")) return "function";
            } else return "null";
        } else if ("function" == b && "undefined" == typeof a.call) return "object";return b;
    },
        u = function u(a) {
        return "function" == t(a);
    },
        ea = function ea(a, b, c) {
        return a.call.apply(a.bind, arguments);
    },
        fa = function fa(a, b, c) {
        if (!a) throw Error();if (2 < arguments.length) {
            var d = Array.prototype.slice.call(arguments, 2);return function () {
                var c = Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c, d);return a.apply(b, c);
            };
        }return function () {
            return a.apply(b, arguments);
        };
    },
        _v = function v(a, b, c) {
        _v = Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? ea : fa;return _v.apply(null, arguments);
    },
        w = function w(a, b) {
        var c = Array.prototype.slice.call(arguments, 1);return function () {
            var b = c.slice();b.push.apply(b, arguments);return a.apply(this, b);
        };
    },
        x = function x(a, b) {
        function c() {}c.prototype = b.prototype;a.ga = b.prototype;a.prototype = new c();a.prototype.constructor = a;a.fa = function (a, c, g) {
            for (var f = Array(arguments.length - 2), k = 2; k < arguments.length; k++) {
                f[k - 2] = arguments[k];
            }return b.prototype[c].apply(a, f);
        };
    };var y = "undefined" !== typeof window ? window : global;function __extends(a, b) {
        function c() {
            this.constructor = a;
        }for (var d in b) {
            b.hasOwnProperty(d) && (a[d] = b[d]);
        }a.prototype = null === b ? Object.create(b) : (c.prototype = b.prototype, new c());
    }
    function __decorate(a, b, c, d) {
        var e = arguments.length,
            g = 3 > e ? b : null === d ? d = Object.getOwnPropertyDescriptor(b, c) : d,
            f;f = y.Reflect;if ("object" === (typeof f === "undefined" ? "undefined" : _typeof(f)) && "function" === typeof f.decorate) g = f.decorate(a, b, c, d);else for (var k = a.length - 1; 0 <= k; k--) {
            if (f = a[k]) g = (3 > e ? f(g) : 3 < e ? f(b, c, g) : f(b, c)) || g;
        }return 3 < e && g && Object.defineProperty(b, c, g), g;
    }function __metadata(a, b) {
        var c = y.Reflect;if ("object" === (typeof c === "undefined" ? "undefined" : _typeof(c)) && "function" === typeof c.metadata) return c.metadata(a, b);
    }
    var __param = function __param(a, b) {
        return function (c, d) {
            b(c, d, a);
        };
    },
        __awaiter = function __awaiter(a, b, c, d) {
        return new (c || (c = Promise))(function (e, g) {
            function f(a) {
                try {
                    n(d.next(a));
                } catch (b) {
                    g(b);
                }
            }function k(a) {
                try {
                    n(d.throw(a));
                } catch (b) {
                    g(b);
                }
            }function n(a) {
                a.done ? e(a.value) : new c(function (b) {
                    b(a.value);
                }).then(f, k);
            }n((d = d.apply(a, b)).next());
        });
    };"undefined" !== typeof y.L && y.L || "undefined" === typeof global || (global.ca = __extends, global.ba = __decorate, global.da = __metadata, global.ea = __param, global.aa = __awaiter);var z = function z(a) {
        if (Error.captureStackTrace) Error.captureStackTrace(this, z);else {
            var b = Error().stack;b && (this.stack = b);
        }a && (this.message = String(a));
    };x(z, Error);z.prototype.name = "CustomError";var ga = function ga(a, b) {
        for (var c = a.split("%s"), d = "", e = Array.prototype.slice.call(arguments, 1); e.length && 1 < c.length;) {
            d += c.shift() + e.shift();
        }return d + c.join("%s");
    };var A = function A(a, b) {
        b.unshift(a);z.call(this, ga.apply(null, b));b.shift();
    };x(A, z);A.prototype.name = "AssertionError";var ha = function ha(a, b, c, d) {
        var e = "Assertion failed";if (c) var e = e + (": " + c),
            g = d;else a && (e += ": " + a, g = b);throw new A("" + e, g || []);
    },
        B = function B(a, b, c) {
        a || ha("", null, b, Array.prototype.slice.call(arguments, 2));
    },
        C = function C(a, b, c) {
        u(a) || ha("Expected function but got %s: %s.", [t(a), a], b, Array.prototype.slice.call(arguments, 2));
    };var D = function D(a, b, c) {
        this.S = c;this.M = a;this.U = b;this.s = 0;this.o = null;
    };D.prototype.get = function () {
        var a;0 < this.s ? (this.s--, a = this.o, this.o = a.next, a.next = null) : a = this.M();return a;
    };D.prototype.put = function (a) {
        this.U(a);this.s < this.S && (this.s++, a.next = this.o, this.o = a);
    };var E;a: {
        var ia = q.navigator;if (ia) {
            var ja = ia.userAgent;if (ja) {
                E = ja;break a;
            }
        }E = "";
    };var ka = function ka(a) {
        q.setTimeout(function () {
            throw a;
        }, 0);
    },
        F,
        la = function la() {
        var a = q.MessageChannel;"undefined" === typeof a && "undefined" !== typeof window && window.postMessage && window.addEventListener && -1 == E.indexOf("Presto") && (a = function a() {
            var a = document.createElement("IFRAME");a.style.display = "none";a.src = "";document.documentElement.appendChild(a);var b = a.contentWindow,
                a = b.document;a.open();a.write("");a.close();var c = "callImmediate" + Math.random(),
                d = "file:" == b.location.protocol ? "*" : b.location.protocol + "//" + b.location.host,
                a = _v(function (a) {
                if (("*" == d || a.origin == d) && a.data == c) this.port1.onmessage();
            }, this);b.addEventListener("message", a, !1);this.port1 = {};this.port2 = { postMessage: function postMessage() {
                    b.postMessage(c, d);
                } };
        });if ("undefined" !== typeof a && -1 == E.indexOf("Trident") && -1 == E.indexOf("MSIE")) {
            var b = new a(),
                c = {},
                d = c;b.port1.onmessage = function () {
                if (void 0 !== c.next) {
                    c = c.next;var a = c.F;c.F = null;a();
                }
            };return function (a) {
                d.next = { F: a };d = d.next;b.port2.postMessage(0);
            };
        }return "undefined" !== typeof document && "onreadystatechange" in document.createElement("SCRIPT") ? function (a) {
            var b = document.createElement("SCRIPT");b.onreadystatechange = function () {
                b.onreadystatechange = null;b.parentNode.removeChild(b);b = null;a();a = null;
            };document.documentElement.appendChild(b);
        } : function (a) {
            q.setTimeout(a, 0);
        };
    };var G = function G() {
        this.v = this.f = null;
    },
        ma = new D(function () {
        return new H();
    }, function (a) {
        a.reset();
    }, 100);G.prototype.add = function (a, b) {
        var c = ma.get();c.set(a, b);this.v ? this.v.next = c : (B(!this.f), this.f = c);this.v = c;
    };G.prototype.remove = function () {
        var a = null;this.f && (a = this.f, this.f = this.f.next, this.f || (this.v = null), a.next = null);return a;
    };var H = function H() {
        this.next = this.scope = this.B = null;
    };H.prototype.set = function (a, b) {
        this.B = a;this.scope = b;this.next = null;
    };
    H.prototype.reset = function () {
        this.next = this.scope = this.B = null;
    };var L = function L(a, b) {
        I || na();K || (I(), K = !0);oa.add(a, b);
    },
        I,
        na = function na() {
        if (q.Promise && q.Promise.resolve) {
            var a = q.Promise.resolve(void 0);I = function I() {
                a.then(pa);
            };
        } else I = function I() {
            var a = pa;!u(q.setImmediate) || q.Window && q.Window.prototype && -1 == E.indexOf("Edge") && q.Window.prototype.setImmediate == q.setImmediate ? (F || (F = la()), F(a)) : q.setImmediate(a);
        };
    },
        K = !1,
        oa = new G(),
        pa = function pa() {
        for (var a; a = oa.remove();) {
            try {
                a.B.call(a.scope);
            } catch (b) {
                ka(b);
            }ma.put(a);
        }K = !1;
    };var N = function N(a, b) {
        this.b = 0;this.K = void 0;this.j = this.g = this.u = null;this.m = this.A = !1;if (a != r) try {
            var c = this;a.call(b, function (a) {
                M(c, 2, a);
            }, function (a) {
                try {
                    if (a instanceof Error) throw a;throw Error("Promise rejected.");
                } catch (b) {}M(c, 3, a);
            });
        } catch (d) {
            M(this, 3, d);
        }
    },
        qa = function qa() {
        this.next = this.context = this.h = this.c = this.child = null;this.w = !1;
    };qa.prototype.reset = function () {
        this.context = this.h = this.c = this.child = null;this.w = !1;
    };
    var ra = new D(function () {
        return new qa();
    }, function (a) {
        a.reset();
    }, 100),
        sa = function sa(a, b, c) {
        var d = ra.get();d.c = a;d.h = b;d.context = c;return d;
    },
        ua = function ua(a, b, c) {
        ta(a, b, c, null) || L(w(b, a));
    };N.prototype.then = function (a, b, c) {
        null != a && C(a, "opt_onFulfilled should be a function.");null != b && C(b, "opt_onRejected should be a function. Did you pass opt_context as the second argument instead of the third?");return va(this, u(a) ? a : null, u(b) ? b : null, c);
    };N.prototype.then = N.prototype.then;N.prototype.$goog_Thenable = !0;
    N.prototype.X = function (a, b) {
        return va(this, null, a, b);
    };var xa = function xa(a, b) {
        a.g || 2 != a.b && 3 != a.b || wa(a);B(null != b.c);a.j ? a.j.next = b : a.g = b;a.j = b;
    },
        va = function va(a, b, c, d) {
        var e = sa(null, null, null);e.child = new N(function (a, f) {
            e.c = b ? function (c) {
                try {
                    var e = b.call(d, c);a(e);
                } catch (J) {
                    f(J);
                }
            } : a;e.h = c ? function (b) {
                try {
                    var e = c.call(d, b);a(e);
                } catch (J) {
                    f(J);
                }
            } : f;
        });e.child.u = a;xa(a, e);return e.child;
    };N.prototype.Y = function (a) {
        B(1 == this.b);this.b = 0;M(this, 2, a);
    };N.prototype.Z = function (a) {
        B(1 == this.b);this.b = 0;M(this, 3, a);
    };
    var M = function M(a, b, c) {
        0 == a.b && (a === c && (b = 3, c = new TypeError("Promise cannot resolve to itself")), a.b = 1, ta(c, a.Y, a.Z, a) || (a.K = c, a.b = b, a.u = null, wa(a), 3 != b || ya(a, c)));
    },
        ta = function ta(a, b, c, d) {
        if (a instanceof N) return null != b && C(b, "opt_onFulfilled should be a function."), null != c && C(c, "opt_onRejected should be a function. Did you pass opt_context as the second argument instead of the third?"), xa(a, sa(b || r, c || null, d)), !0;var e;if (a) try {
            e = !!a.$goog_Thenable;
        } catch (f) {
            e = !1;
        } else e = !1;if (e) return a.then(b, c, d), !0;e = typeof a === "undefined" ? "undefined" : _typeof(a);if ("object" == e && null != a || "function" == e) try {
            var g = a.then;if (u(g)) return za(a, g, b, c, d), !0;
        } catch (f) {
            return c.call(d, f), !0;
        }return !1;
    },
        za = function za(a, b, c, d, e) {
        var g = !1,
            f = function f(a) {
            g || (g = !0, c.call(e, a));
        },
            k = function k(a) {
            g || (g = !0, d.call(e, a));
        };try {
            b.call(a, f, k);
        } catch (n) {
            k(n);
        }
    },
        wa = function wa(a) {
        a.A || (a.A = !0, L(a.O, a));
    },
        Aa = function Aa(a) {
        var b = null;a.g && (b = a.g, a.g = b.next, b.next = null);a.g || (a.j = null);null != b && B(null != b.c);return b;
    };
    N.prototype.O = function () {
        for (var a; a = Aa(this);) {
            var b = this.b,
                c = this.K;if (3 == b && a.h && !a.w) {
                var d;for (d = this; d && d.m; d = d.u) {
                    d.m = !1;
                }
            }if (a.child) a.child.u = null, Ba(a, b, c);else try {
                a.w ? a.c.call(a.context) : Ba(a, b, c);
            } catch (e) {
                Ca.call(null, e);
            }ra.put(a);
        }this.A = !1;
    };var Ba = function Ba(a, b, c) {
        2 == b ? a.c.call(a.context, c) : a.h && a.h.call(a.context, c);
    },
        ya = function ya(a, b) {
        a.m = !0;L(function () {
            a.m && Ca.call(null, b);
        });
    },
        Ca = ka;function O(a, b) {
        if (!(b instanceof Object)) return b;switch (b.constructor) {case Date:
                return new Date(b.getTime());case Object:
                void 0 === a && (a = {});break;case Array:
                a = [];break;default:
                return b;}for (var c in b) {
            b.hasOwnProperty(c) && (a[c] = O(a[c], b[c]));
        }return a;
    };var Da = Error.captureStackTrace,
        Q = function Q(a, b) {
        this.code = a;this.message = b;if (Da) Da(this, P.prototype.create);else {
            var c = Error.apply(this, arguments);this.name = "FirebaseError";Object.defineProperty(this, "stack", { get: function get() {
                    return c.stack;
                } });
        }
    };Q.prototype = Object.create(Error.prototype);Q.prototype.constructor = Q;Q.prototype.name = "FirebaseError";var P = function P(a, b, c) {
        this.V = a;this.W = b;this.N = c;this.pattern = /\{\$([^}]+)}/g;
    };
    P.prototype.create = function (a, b) {
        void 0 === b && (b = {});var c = this.N[a];a = this.V + "/" + a;var c = void 0 === c ? "Error" : c.replace(this.pattern, function (a, c) {
            a = b[c];return void 0 !== a ? a.toString() : "<" + c + "?>";
        }),
            c = this.W + ": " + c + " (" + a + ").",
            c = new Q(a, c),
            d;for (d in b) {
            b.hasOwnProperty(d) && "_" !== d.slice(-1) && (c[d] = b[d]);
        }return c;
    };N.all = function (a) {
        return new N(function (b, c) {
            var d = a.length,
                e = [];if (d) for (var g = function g(a, c) {
                d--;e[a] = c;0 == d && b(e);
            }, f = function f(a) {
                c(a);
            }, k = 0, n; k < a.length; k++) {
                n = a[k], ua(n, w(g, k), f);
            } else b(e);
        });
    };N.resolve = function (a) {
        if (a instanceof N) return a;var b = new N(r);M(b, 2, a);return b;
    };N.reject = function (a) {
        return new N(function (b, c) {
            c(a);
        });
    };N.prototype["catch"] = N.prototype.X;var R = N;"undefined" !== typeof Promise && (R = Promise);var Ea = R;function Fa(a, b) {
        a = new S(a, b);return a.subscribe.bind(a);
    }var S = function S(a, b) {
        var c = this;this.a = [];this.J = 0;this.task = Ea.resolve();this.l = !1;this.D = b;this.task.then(function () {
            a(c);
        }).catch(function (a) {
            c.error(a);
        });
    };S.prototype.next = function (a) {
        T(this, function (b) {
            b.next(a);
        });
    };S.prototype.error = function (a) {
        T(this, function (b) {
            b.error(a);
        });this.close(a);
    };S.prototype.complete = function () {
        T(this, function (a) {
            a.complete();
        });this.close();
    };
    S.prototype.subscribe = function (a, b, c) {
        var d = this,
            e;if (void 0 === a && void 0 === b && void 0 === c) throw Error("Missing Observer.");e = Ga(a) ? a : { next: a, error: b, complete: c };void 0 === e.next && (e.next = U);void 0 === e.error && (e.error = U);void 0 === e.complete && (e.complete = U);a = this.$.bind(this, this.a.length);this.l && this.task.then(function () {
            try {
                d.G ? e.error(d.G) : e.complete();
            } catch (a) {}
        });this.a.push(e);return a;
    };
    S.prototype.$ = function (a) {
        void 0 !== this.a && void 0 !== this.a[a] && (delete this.a[a], --this.J, 0 === this.J && void 0 !== this.D && this.D(this));
    };var T = function T(a, b) {
        if (!a.l) for (var c = 0; c < a.a.length; c++) {
            Ha(a, c, b);
        }
    },
        Ha = function Ha(a, b, c) {
        a.task.then(function () {
            if (void 0 !== a.a && void 0 !== a.a[b]) try {
                c(a.a[b]);
            } catch (d) {}
        });
    };S.prototype.close = function (a) {
        var b = this;this.l || (this.l = !0, void 0 !== a && (this.G = a), this.task.then(function () {
            b.a = void 0;b.D = void 0;
        }));
    };
    function Ga(a) {
        if ("object" !== (typeof a === "undefined" ? "undefined" : _typeof(a)) || null === a) return !1;var b;b = ["next", "error", "complete"];_p();var c = b[Symbol.iterator];b = c ? c.call(b) : m(b);for (c = b.next(); !c.done; c = b.next()) {
            if (c = c.value, c in a && "function" === typeof a[c]) return !0;
        }return !1;
    }function U() {};var V = R,
        W = function W(a, b, c) {
        var d = this;this.H = c;this.I = !1;this.i = {};this.C = b;this.T = O(void 0, a);Object.keys(c.INTERNAL.factories).forEach(function (a) {
            var b = c.INTERNAL.useAsService(d, a);null !== b && (d[a] = d.R.bind(d, b));
        });
    };W.prototype.delete = function () {
        var a = this;return new V(function (b) {
            X(a);b();
        }).then(function () {
            a.H.INTERNAL.removeApp(a.C);return V.all(Object.keys(a.i).map(function (b) {
                return a.i[b].INTERNAL.delete();
            }));
        }).then(function () {
            a.I = !0;a.i = {};
        });
    };
    W.prototype.R = function (a) {
        X(this);void 0 === this.i[a] && (this.i[a] = this.H.INTERNAL.factories[a](this, this.P.bind(this)));return this.i[a];
    };W.prototype.P = function (a) {
        O(this, a);
    };var X = function X(a) {
        a.I && Y(Ia("deleted", { name: a.C }));
    };h.Object.defineProperties(W.prototype, { name: { configurable: !0, enumerable: !0, get: function get() {
                X(this);return this.C;
            } }, options: { configurable: !0, enumerable: !0, get: function get() {
                X(this);return this.T;
            } } });W.prototype.name && W.prototype.options || W.prototype.delete || console.log("dc");
    function Ja() {
        function a(a) {
            a = a || "[DEFAULT]";var b = d[a];void 0 === b && Y("noApp", { name: a });return b;
        }function b(a, b) {
            Object.keys(e).forEach(function (d) {
                d = c(a, d);if (null !== d && g[d]) g[d](b, a);
            });
        }function c(a, b) {
            if ("serverAuth" === b) return null;var c = b;a = a.options;"auth" === b && (a.serviceAccount || a.credential) && (c = "serverAuth");return c;
        }var d = {},
            e = {},
            g = {},
            f = {
            __esModule: !0, initializeApp: function initializeApp(a, c) {
                void 0 === c ? c = "[DEFAULT]" : "string" === typeof c && "" !== c || Y("bad-app-name", { name: c + "" });void 0 !== d[c] && Y("dupApp", { name: c });a = new W(a, c, f);d[c] = a;b(a, "create");void 0 != a.INTERNAL && void 0 != a.INTERNAL.getToken || O(a, { INTERNAL: { getToken: function getToken() {
                            return V.resolve(null);
                        }, addAuthTokenListener: function addAuthTokenListener() {}, removeAuthTokenListener: function removeAuthTokenListener() {} } });return a;
            }, app: a, apps: null, Promise: V, SDK_VERSION: "0.0.0", INTERNAL: {
                registerService: function registerService(b, c, d, Z) {
                    e[b] && Y("dupService", { name: b });e[b] = c;Z && (g[b] = Z);c = function c(_c) {
                        void 0 === _c && (_c = a());return _c[b]();
                    };void 0 !== d && O(c, d);return f[b] = c;
                }, createFirebaseNamespace: Ja, extendNamespace: function extendNamespace(a) {
                    O(f, a);
                }, createSubscribe: Fa, ErrorFactory: P, removeApp: function removeApp(a) {
                    b(d[a], "delete");delete d[a];
                }, factories: e, useAsService: c, Promise: N, deepExtend: O
            }
        };f["default"] = f;Object.defineProperty(f, "apps", { get: function get() {
                return Object.keys(d).map(function (a) {
                    return d[a];
                });
            } });a.App = W;return f;
    }function Y(a, b) {
        throw Error(Ia(a, b));
    }
    function Ia(a, b) {
        b = b || {};b = { noApp: "No Firebase App '" + b.name + "' has been created - call Firebase App.initializeApp().", "bad-app-name": "Illegal App name: '" + b.name + "'.", dupApp: "Firebase App named '" + b.name + "' already exists.", deleted: "Firebase App named '" + b.name + "' already deleted.", dupService: "Firebase Service named '" + b.name + "' already registered." }[a];return void 0 === b ? "Application Error: (" + a + ")" : b;
    };"undefined" !== typeof window && (window.firebase = Ja());
})();
firebase.SDK_VERSION = "3.3.0";
(function () {
    var h,
        aa = aa || {},
        l = this,
        ba = function ba() {},
        m = function m(a) {
        var b = typeof a === "undefined" ? "undefined" : _typeof(a);if ("object" == b) {
            if (a) {
                if (a instanceof Array) return "array";if (a instanceof Object) return b;var c = Object.prototype.toString.call(a);if ("[object Window]" == c) return "object";if ("[object Array]" == c || "number" == typeof a.length && "undefined" != typeof a.splice && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("splice")) return "array";if ("[object Function]" == c || "undefined" != typeof a.call && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("call")) return "function";
            } else return "null";
        } else if ("function" == b && "undefined" == typeof a.call) return "object";return b;
    },
        ca = function ca(a) {
        return null === a;
    },
        da = function da(a) {
        return "array" == m(a);
    },
        ea = function ea(a) {
        var b = m(a);return "array" == b || "object" == b && "number" == typeof a.length;
    },
        n = function n(a) {
        return "string" == typeof a;
    },
        fa = function fa(a) {
        return "number" == typeof a;
    },
        p = function p(a) {
        return "function" == m(a);
    },
        ga = function ga(a) {
        var b = typeof a === "undefined" ? "undefined" : _typeof(a);return "object" == b && null != a || "function" == b;
    },
        ha = function ha(a, b, c) {
        return a.call.apply(a.bind, arguments);
    },
        ia = function ia(a, b, c) {
        if (!a) throw Error();if (2 < arguments.length) {
            var d = Array.prototype.slice.call(arguments, 2);return function () {
                var c = Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c, d);return a.apply(b, c);
            };
        }return function () {
            return a.apply(b, arguments);
        };
    },
        _r = function r(a, b, c) {
        _r = Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? ha : ia;return _r.apply(null, arguments);
    },
        ja = function ja(a, b) {
        var c = Array.prototype.slice.call(arguments, 1);return function () {
            var b = c.slice();b.push.apply(b, arguments);return a.apply(this, b);
        };
    },
        ka = Date.now || function () {
        return +new Date();
    },
        t = function t(a, b) {
        function c() {}c.prototype = b.prototype;a.Pc = b.prototype;a.prototype = new c();a.prototype.constructor = a;a.Ne = function (a, c, f) {
            for (var g = Array(arguments.length - 2), k = 2; k < arguments.length; k++) {
                g[k - 2] = arguments[k];
            }return b.prototype[c].apply(a, g);
        };
    };var u = function u(a) {
        if (Error.captureStackTrace) Error.captureStackTrace(this, u);else {
            var b = Error().stack;b && (this.stack = b);
        }a && (this.message = String(a));
    };t(u, Error);u.prototype.name = "CustomError";var la = function la(a, b) {
        for (var c = a.split("%s"), d = "", e = Array.prototype.slice.call(arguments, 1); e.length && 1 < c.length;) {
            d += c.shift() + e.shift();
        }return d + c.join("%s");
    },
        ma = String.prototype.trim ? function (a) {
        return a.trim();
    } : function (a) {
        return a.replace(/^[\s\xa0]+|[\s\xa0]+$/g, "");
    },
        na = /&/g,
        oa = /</g,
        pa = />/g,
        qa = /"/g,
        sa = /'/g,
        ta = /\x00/g,
        ua = /[\x00&<>"']/,
        v = function v(a, b) {
        return -1 != a.indexOf(b);
    },
        va = function va(a, b) {
        return a < b ? -1 : a > b ? 1 : 0;
    };var wa = function wa(a, b) {
        b.unshift(a);u.call(this, la.apply(null, b));b.shift();
    };t(wa, u);wa.prototype.name = "AssertionError";
    var xa = function xa(a, b, c, d) {
        var e = "Assertion failed";if (c) var e = e + (": " + c),
            f = d;else a && (e += ": " + a, f = b);throw new wa("" + e, f || []);
    },
        w = function w(a, b, c) {
        a || xa("", null, b, Array.prototype.slice.call(arguments, 2));
    },
        ya = function ya(a, b) {
        throw new wa("Failure" + (a ? ": " + a : ""), Array.prototype.slice.call(arguments, 1));
    },
        za = function za(a, b, c) {
        fa(a) || xa("Expected number but got %s: %s.", [m(a), a], b, Array.prototype.slice.call(arguments, 2));return a;
    },
        Aa = function Aa(a, b, c) {
        n(a) || xa("Expected string but got %s: %s.", [m(a), a], b, Array.prototype.slice.call(arguments, 2));
    },
        Ba = function Ba(a, b, c) {
        p(a) || xa("Expected function but got %s: %s.", [m(a), a], b, Array.prototype.slice.call(arguments, 2));
    };var Ca = Array.prototype.indexOf ? function (a, b, c) {
        w(null != a.length);return Array.prototype.indexOf.call(a, b, c);
    } : function (a, b, c) {
        c = null == c ? 0 : 0 > c ? Math.max(0, a.length + c) : c;if (n(a)) return n(b) && 1 == b.length ? a.indexOf(b, c) : -1;for (; c < a.length; c++) {
            if (c in a && a[c] === b) return c;
        }return -1;
    },
        x = Array.prototype.forEach ? function (a, b, c) {
        w(null != a.length);Array.prototype.forEach.call(a, b, c);
    } : function (a, b, c) {
        for (var d = a.length, e = n(a) ? a.split("") : a, f = 0; f < d; f++) {
            f in e && b.call(c, e[f], f, a);
        }
    },
        Da = function Da(a, b) {
        for (var c = n(a) ? a.split("") : a, d = a.length - 1; 0 <= d; --d) {
            d in c && b.call(void 0, c[d], d, a);
        }
    },
        Ea = Array.prototype.map ? function (a, b, c) {
        w(null != a.length);return Array.prototype.map.call(a, b, c);
    } : function (a, b, c) {
        for (var d = a.length, e = Array(d), f = n(a) ? a.split("") : a, g = 0; g < d; g++) {
            g in f && (e[g] = b.call(c, f[g], g, a));
        }return e;
    },
        Fa = Array.prototype.some ? function (a, b, c) {
        w(null != a.length);return Array.prototype.some.call(a, b, c);
    } : function (a, b, c) {
        for (var d = a.length, e = n(a) ? a.split("") : a, f = 0; f < d; f++) {
            if (f in e && b.call(c, e[f], f, a)) return !0;
        }return !1;
    },
        Ha = function Ha(a) {
        var b;a: {
            b = Ga;for (var c = a.length, d = n(a) ? a.split("") : a, e = 0; e < c; e++) {
                if (e in d && b.call(void 0, d[e], e, a)) {
                    b = e;break a;
                }
            }b = -1;
        }return 0 > b ? null : n(a) ? a.charAt(b) : a[b];
    },
        Ia = function Ia(a, b) {
        return 0 <= Ca(a, b);
    },
        Ka = function Ka(a, b) {
        b = Ca(a, b);var c;(c = 0 <= b) && Ja(a, b);return c;
    },
        Ja = function Ja(a, b) {
        w(null != a.length);return 1 == Array.prototype.splice.call(a, b, 1).length;
    },
        La = function La(a, b) {
        var c = 0;Da(a, function (d, e) {
            b.call(void 0, d, e, a) && Ja(a, e) && c++;
        });
    },
        Ma = function Ma(a) {
        return Array.prototype.concat.apply(Array.prototype, arguments);
    },
        Na = function Na(a) {
        return Array.prototype.concat.apply(Array.prototype, arguments);
    },
        Oa = function Oa(a) {
        var b = a.length;if (0 < b) {
            for (var c = Array(b), d = 0; d < b; d++) {
                c[d] = a[d];
            }return c;
        }return [];
    },
        Pa = function Pa(a, b) {
        for (var c = 1; c < arguments.length; c++) {
            var d = arguments[c];if (ea(d)) {
                var e = a.length || 0,
                    f = d.length || 0;a.length = e + f;for (var g = 0; g < f; g++) {
                    a[e + g] = d[g];
                }
            } else a.push(d);
        }
    };var Qa = function Qa(a, b) {
        for (var c in a) {
            b.call(void 0, a[c], c, a);
        }
    },
        Ra = function Ra(a) {
        var b = [],
            c = 0,
            d;for (d in a) {
            b[c++] = a[d];
        }return b;
    },
        Sa = function Sa(a) {
        var b = [],
            c = 0,
            d;for (d in a) {
            b[c++] = d;
        }return b;
    },
        Ta = function Ta(a) {
        for (var b in a) {
            return !1;
        }return !0;
    },
        Ua = function Ua(a, b) {
        for (var c in a) {
            if (!(c in b) || a[c] !== b[c]) return !1;
        }for (c in b) {
            if (!(c in a)) return !1;
        }return !0;
    },
        Va = function Va(a) {
        var b = {},
            c;for (c in a) {
            b[c] = a[c];
        }return b;
    },
        Wa = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" "),
        Xa = function Xa(a, b) {
        for (var c, d, e = 1; e < arguments.length; e++) {
            d = arguments[e];for (c in d) {
                a[c] = d[c];
            }for (var f = 0; f < Wa.length; f++) {
                c = Wa[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
            }
        }
    };var Ya;a: {
        var Za = l.navigator;if (Za) {
            var $a = Za.userAgent;if ($a) {
                Ya = $a;break a;
            }
        }Ya = "";
    }var y = function y(a) {
        return v(Ya, a);
    };var ab = function ab(a) {
        ab[" "](a);return a;
    };ab[" "] = ba;var cb = function cb(a, b) {
        var c = bb;return Object.prototype.hasOwnProperty.call(c, a) ? c[a] : c[a] = b(a);
    };var db = y("Opera"),
        z = y("Trident") || y("MSIE"),
        eb = y("Edge"),
        fb = eb || z,
        gb = y("Gecko") && !(v(Ya.toLowerCase(), "webkit") && !y("Edge")) && !(y("Trident") || y("MSIE")) && !y("Edge"),
        hb = v(Ya.toLowerCase(), "webkit") && !y("Edge"),
        ib = function ib() {
        var a = l.document;return a ? a.documentMode : void 0;
    },
        jb;
    a: {
        var kb = "",
            lb = function () {
            var a = Ya;if (gb) return (/rv\:([^\);]+)(\)|;)/.exec(a)
            );if (eb) return (/Edge\/([\d\.]+)/.exec(a)
            );if (z) return (/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a)
            );if (hb) return (/WebKit\/(\S+)/.exec(a)
            );if (db) return (/(?:Version)[ \/]?(\S+)/.exec(a)
            );
        }();lb && (kb = lb ? lb[1] : "");if (z) {
            var mb = ib();if (null != mb && mb > parseFloat(kb)) {
                jb = String(mb);break a;
            }
        }jb = kb;
    }
    var nb = jb,
        bb = {},
        A = function A(a) {
        return cb(a, function () {
            for (var b = 0, c = ma(String(nb)).split("."), d = ma(String(a)).split("."), e = Math.max(c.length, d.length), f = 0; 0 == b && f < e; f++) {
                var g = c[f] || "",
                    k = d[f] || "";do {
                    g = /(\d*)(\D*)(.*)/.exec(g) || ["", "", "", ""];k = /(\d*)(\D*)(.*)/.exec(k) || ["", "", "", ""];if (0 == g[0].length && 0 == k[0].length) break;b = va(0 == g[1].length ? 0 : parseInt(g[1], 10), 0 == k[1].length ? 0 : parseInt(k[1], 10)) || va(0 == g[2].length, 0 == k[2].length) || va(g[2], k[2]);g = g[3];k = k[3];
                } while (0 == b);
            }return 0 <= b;
        });
    },
        ob = l.document,
        pb = ob && z ? ib() || ("CSS1Compat" == ob.compatMode ? parseInt(nb, 10) : 5) : void 0;var qb = null,
        rb = null,
        tb = function tb(a) {
        var b = "";sb(a, function (a) {
            b += String.fromCharCode(a);
        });return b;
    },
        sb = function sb(a, b) {
        function c(b) {
            for (; d < a.length;) {
                var c = a.charAt(d++),
                    e = rb[c];if (null != e) return e;if (!/^[\s\xa0]*$/.test(c)) throw Error("Unknown base64 encoding at char: " + c);
            }return b;
        }ub();for (var d = 0;;) {
            var e = c(-1),
                f = c(0),
                g = c(64),
                k = c(64);if (64 === k && -1 === e) break;b(e << 2 | f >> 4);64 != g && (b(f << 4 & 240 | g >> 2), 64 != k && b(g << 6 & 192 | k));
        }
    },
        ub = function ub() {
        if (!qb) {
            qb = {};rb = {};for (var a = 0; 65 > a; a++) {
                qb[a] = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(a), rb[qb[a]] = a, 62 <= a && (rb["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_.".charAt(a)] = a);
            }
        }
    };var wb = function wb() {
        this.ec = "";this.Md = vb;
    };wb.prototype.Nb = !0;wb.prototype.Ib = function () {
        return this.ec;
    };wb.prototype.toString = function () {
        return "Const{" + this.ec + "}";
    };var xb = function xb(a) {
        if (a instanceof wb && a.constructor === wb && a.Md === vb) return a.ec;ya("expected object of type Const, got '" + a + "'");return "type_error:Const";
    },
        vb = {};var B = function B() {
        this.ja = "";this.Ld = yb;
    };B.prototype.Nb = !0;B.prototype.Ib = function () {
        return this.ja;
    };B.prototype.toString = function () {
        return "SafeUrl{" + this.ja + "}";
    };
    var zb = function zb(a) {
        if (a instanceof B && a.constructor === B && a.Ld === yb) return a.ja;ya("expected object of type SafeUrl, got '" + a + "' of type " + m(a));return "type_error:SafeUrl";
    },
        Ab = /^(?:(?:https?|mailto|ftp):|[^&:/?#]*(?:[/?#]|$))/i,
        Cb = function Cb(a) {
        if (a instanceof B) return a;a = a.Nb ? a.Ib() : String(a);Ab.test(a) || (a = "about:invalid#zClosurez");return Bb(a);
    },
        yb = {},
        Bb = function Bb(a) {
        var b = new B();b.ja = a;return b;
    };Bb("about:blank");var Eb = function Eb() {
        this.Vb = "";this.Nd = Db;
    };Eb.prototype.Nb = !0;Eb.prototype.Ib = function () {
        return this.Vb;
    };Eb.prototype.toString = function () {
        return "TrustedResourceUrl{" + this.Vb + "}";
    };var Db = {};var Gb = function Gb() {
        this.ja = "";this.Kd = Fb;
    };Gb.prototype.Nb = !0;Gb.prototype.Ib = function () {
        return this.ja;
    };Gb.prototype.toString = function () {
        return "SafeHtml{" + this.ja + "}";
    };var Hb = function Hb(a) {
        if (a instanceof Gb && a.constructor === Gb && a.Kd === Fb) return a.ja;ya("expected object of type SafeHtml, got '" + a + "' of type " + m(a));return "type_error:SafeHtml";
    },
        Fb = {};Gb.prototype.ne = function (a) {
        this.ja = a;return this;
    };var Ib = function Ib(a, b) {
        b = b instanceof B ? b : Cb(b);a.href = zb(b);
    };var Jb = !z || 9 <= Number(pb),
        Kb = z && !A("9");!hb || A("528");gb && A("1.9b") || z && A("8") || db && A("9.5") || hb && A("528");gb && !A("8") || z && A("9");var Lb = function Lb() {
        this.ya = this.ya;this.Sb = this.Sb;
    };Lb.prototype.ya = !1;Lb.prototype.isDisposed = function () {
        return this.ya;
    };Lb.prototype.Oa = function () {
        if (this.Sb) for (; this.Sb.length;) {
            this.Sb.shift()();
        }
    };var Mb = function Mb(a, b) {
        this.type = a;this.currentTarget = this.target = b;this.defaultPrevented = this.Va = !1;this.ud = !0;
    };Mb.prototype.preventDefault = function () {
        this.defaultPrevented = !0;this.ud = !1;
    };var Nb = function Nb(a, b) {
        Mb.call(this, a ? a.type : "");this.relatedTarget = this.currentTarget = this.target = null;this.charCode = this.keyCode = this.button = this.screenY = this.screenX = this.clientY = this.clientX = this.offsetY = this.offsetX = 0;this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;this.kb = this.state = null;a && this.init(a, b);
    };t(Nb, Mb);
    Nb.prototype.init = function (a, b) {
        var c = this.type = a.type,
            d = a.changedTouches ? a.changedTouches[0] : null;this.target = a.target || a.srcElement;this.currentTarget = b;if (b = a.relatedTarget) {
            if (gb) {
                var e;a: {
                    try {
                        ab(b.nodeName);e = !0;break a;
                    } catch (f) {}e = !1;
                }e || (b = null);
            }
        } else "mouseover" == c ? b = a.fromElement : "mouseout" == c && (b = a.toElement);this.relatedTarget = b;null === d ? (this.offsetX = hb || void 0 !== a.offsetX ? a.offsetX : a.layerX, this.offsetY = hb || void 0 !== a.offsetY ? a.offsetY : a.layerY, this.clientX = void 0 !== a.clientX ? a.clientX : a.pageX, this.clientY = void 0 !== a.clientY ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0) : (this.clientX = void 0 !== d.clientX ? d.clientX : d.pageX, this.clientY = void 0 !== d.clientY ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0);this.button = a.button;this.keyCode = a.keyCode || 0;this.charCode = a.charCode || ("keypress" == c ? a.keyCode : 0);this.ctrlKey = a.ctrlKey;this.altKey = a.altKey;this.shiftKey = a.shiftKey;this.metaKey = a.metaKey;this.state = a.state;this.kb = a;a.defaultPrevented && this.preventDefault();
    };Nb.prototype.preventDefault = function () {
        Nb.Pc.preventDefault.call(this);var a = this.kb;if (a.preventDefault) a.preventDefault();else if (a.returnValue = !1, Kb) try {
            if (a.ctrlKey || 112 <= a.keyCode && 123 >= a.keyCode) a.keyCode = -1;
        } catch (b) {}
    };Nb.prototype.ce = function () {
        return this.kb;
    };var Ob = "closure_listenable_" + (1E6 * Math.random() | 0),
        Pb = 0;var Qb = function Qb(a, b, c, d, e) {
        this.listener = a;this.Wb = null;this.src = b;this.type = c;this.Bb = !!d;this.Kb = e;this.key = ++Pb;this.$a = this.Ab = !1;
    },
        Rb = function Rb(a) {
        a.$a = !0;a.listener = null;a.Wb = null;a.src = null;a.Kb = null;
    };var Sb = function Sb(a) {
        this.src = a;this.w = {};this.xb = 0;
    };Sb.prototype.add = function (a, b, c, d, e) {
        var f = a.toString();a = this.w[f];a || (a = this.w[f] = [], this.xb++);var g = Tb(a, b, d, e);-1 < g ? (b = a[g], c || (b.Ab = !1)) : (b = new Qb(b, this.src, f, !!d, e), b.Ab = c, a.push(b));return b;
    };Sb.prototype.remove = function (a, b, c, d) {
        a = a.toString();if (!(a in this.w)) return !1;var e = this.w[a];b = Tb(e, b, c, d);return -1 < b ? (Rb(e[b]), Ja(e, b), 0 == e.length && (delete this.w[a], this.xb--), !0) : !1;
    };
    var Ub = function Ub(a, b) {
        var c = b.type;c in a.w && Ka(a.w[c], b) && (Rb(b), 0 == a.w[c].length && (delete a.w[c], a.xb--));
    };Sb.prototype.tc = function (a, b, c, d) {
        a = this.w[a.toString()];var e = -1;a && (e = Tb(a, b, c, d));return -1 < e ? a[e] : null;
    };var Tb = function Tb(a, b, c, d) {
        for (var e = 0; e < a.length; ++e) {
            var f = a[e];if (!f.$a && f.listener == b && f.Bb == !!c && f.Kb == d) return e;
        }return -1;
    };var Vb = "closure_lm_" + (1E6 * Math.random() | 0),
        Wb = {},
        Xb = 0,
        Yb = function Yb(a, b, c, d, e) {
        if (da(b)) for (var f = 0; f < b.length; f++) {
            Yb(a, b[f], c, d, e);
        } else c = Zb(c), a && a[Ob] ? a.listen(b, c, d, e) : $b(a, b, c, !1, d, e);
    },
        $b = function $b(a, b, c, d, e, f) {
        if (!b) throw Error("Invalid event type");var g = !!e,
            k = ac(a);k || (a[Vb] = k = new Sb(a));c = k.add(b, c, d, e, f);if (c.Wb) return;d = bc();c.Wb = d;d.src = a;d.listener = c;if (a.addEventListener) a.addEventListener(b.toString(), d, g);else if (a.attachEvent) a.attachEvent(cc(b.toString()), d);else throw Error("addEventListener and attachEvent are unavailable.");
        Xb++;
    },
        bc = function bc() {
        var a = dc,
            b = Jb ? function (c) {
            return a.call(b.src, b.listener, c);
        } : function (c) {
            c = a.call(b.src, b.listener, c);if (!c) return c;
        };return b;
    },
        ec = function ec(a, b, c, d, e) {
        if (da(b)) for (var f = 0; f < b.length; f++) {
            ec(a, b[f], c, d, e);
        } else c = Zb(c), a && a[Ob] ? fc(a, b, c, d, e) : $b(a, b, c, !0, d, e);
    },
        gc = function gc(a, b, c, d, e) {
        if (da(b)) for (var f = 0; f < b.length; f++) {
            gc(a, b[f], c, d, e);
        } else c = Zb(c), a && a[Ob] ? a.Y.remove(String(b), c, d, e) : a && (a = ac(a)) && (b = a.tc(b, c, !!d, e)) && hc(b);
    },
        hc = function hc(a) {
        if (!fa(a) && a && !a.$a) {
            var b = a.src;if (b && b[Ob]) Ub(b.Y, a);else {
                var c = a.type,
                    d = a.Wb;b.removeEventListener ? b.removeEventListener(c, d, a.Bb) : b.detachEvent && b.detachEvent(cc(c), d);Xb--;(c = ac(b)) ? (Ub(c, a), 0 == c.xb && (c.src = null, b[Vb] = null)) : Rb(a);
            }
        }
    },
        cc = function cc(a) {
        return a in Wb ? Wb[a] : Wb[a] = "on" + a;
    },
        jc = function jc(a, b, c, d) {
        var e = !0;if (a = ac(a)) if (b = a.w[b.toString()]) for (b = b.concat(), a = 0; a < b.length; a++) {
            var f = b[a];f && f.Bb == c && !f.$a && (f = ic(f, d), e = e && !1 !== f);
        }return e;
    },
        ic = function ic(a, b) {
        var c = a.listener,
            d = a.Kb || a.src;a.Ab && hc(a);return c.call(d, b);
    },
        dc = function dc(a, b) {
        if (a.$a) return !0;
        if (!Jb) {
            if (!b) a: {
                b = ["window", "event"];for (var c = l, d; d = b.shift();) {
                    if (null != c[d]) c = c[d];else {
                        b = null;break a;
                    }
                }b = c;
            }d = b;b = new Nb(d, this);c = !0;if (!(0 > d.keyCode || void 0 != d.returnValue)) {
                a: {
                    var e = !1;if (0 == d.keyCode) try {
                        d.keyCode = -1;break a;
                    } catch (g) {
                        e = !0;
                    }if (e || void 0 == d.returnValue) d.returnValue = !0;
                }d = [];for (e = b.currentTarget; e; e = e.parentNode) {
                    d.push(e);
                }a = a.type;for (e = d.length - 1; !b.Va && 0 <= e; e--) {
                    b.currentTarget = d[e];var f = jc(d[e], a, !0, b),
                        c = c && f;
                }for (e = 0; !b.Va && e < d.length; e++) {
                    b.currentTarget = d[e], f = jc(d[e], a, !1, b), c = c && f;
                }
            }return c;
        }return ic(a, new Nb(b, this));
    },
        ac = function ac(a) {
        a = a[Vb];return a instanceof Sb ? a : null;
    },
        kc = "__closure_events_fn_" + (1E9 * Math.random() >>> 0),
        Zb = function Zb(a) {
        w(a, "Listener can not be null.");if (p(a)) return a;w(a.handleEvent, "An object listener must have handleEvent method.");a[kc] || (a[kc] = function (b) {
            return a.handleEvent(b);
        });return a[kc];
    };var lc = /^[+a-zA-Z0-9_.!#$%&'*\/=?^`{|}~-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z0-9]{2,63}$/;var mc = function mc(a) {
        a = String(a);if (/^\s*$/.test(a) ? 0 : /^[\],:{}\s\u2028\u2029]*$/.test(a.replace(/\\["\\\/bfnrtu]/g, "@").replace(/(?:"[^"\\\n\r\u2028\u2029\x00-\x08\x0a-\x1f]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)[\s\u2028\u2029]*(?=:|,|]|}|$)/g, "]").replace(/(?:^|:|,)(?:[\s\u2028\u2029]*\[)+/g, ""))) try {
            return eval("(" + a + ")");
        } catch (b) {}throw Error("Invalid JSON string: " + a);
    },
        pc = function pc(a) {
        var b = [];nc(new oc(), a, b);return b.join("");
    },
        oc = function oc() {
        this.$b = void 0;
    },
        nc = function nc(a, b, c) {
        if (null == b) c.push("null");else {
            if ("object" == (typeof b === "undefined" ? "undefined" : _typeof(b))) {
                if (da(b)) {
                    var d = b;b = d.length;c.push("[");for (var e = "", f = 0; f < b; f++) {
                        c.push(e), e = d[f], nc(a, a.$b ? a.$b.call(d, String(f), e) : e, c), e = ",";
                    }c.push("]");return;
                }if (b instanceof String || b instanceof Number || b instanceof Boolean) b = b.valueOf();else {
                    c.push("{");f = "";for (d in b) {
                        Object.prototype.hasOwnProperty.call(b, d) && (e = b[d], "function" != typeof e && (c.push(f), qc(d, c), c.push(":"), nc(a, a.$b ? a.$b.call(b, d, e) : e, c), f = ","));
                    }c.push("}");return;
                }
            }switch (typeof b === "undefined" ? "undefined" : _typeof(b)) {
                case "string":
                    qc(b, c);break;case "number":
                    c.push(isFinite(b) && !isNaN(b) ? String(b) : "null");break;case "boolean":
                    c.push(String(b));break;case "function":
                    c.push("null");break;default:
                    throw Error("Unknown type: " + (typeof b === "undefined" ? "undefined" : _typeof(b)));
            }
        }
    },
        rc = { '"': '\\"', "\\": "\\\\", "/": "\\/", "\b": "\\b", "\f": "\\f", "\n": "\\n", "\r": "\\r", "\t": "\\t", "\x0B": "\\u000b" },
        sc = /\uffff/.test("\uFFFF") ? /[\\\"\x00-\x1f\x7f-\uffff]/g : /[\\\"\x00-\x1f\x7f-\xff]/g,
        qc = function qc(a, b) {
        b.push('"', a.replace(sc, function (a) {
            var b = rc[a];b || (b = "\\u" + (a.charCodeAt(0) | 65536).toString(16).substr(1), rc[a] = b);return b;
        }), '"');
    };var tc = function tc() {};tc.prototype.Tc = null;var uc = function uc(a) {
        return a.Tc || (a.Tc = a.xc());
    };var vc,
        wc = function wc() {};t(wc, tc);wc.prototype.Cb = function () {
        var a = xc(this);return a ? new ActiveXObject(a) : new XMLHttpRequest();
    };wc.prototype.xc = function () {
        var a = {};xc(this) && (a[0] = !0, a[1] = !0);return a;
    };
    var xc = function xc(a) {
        if (!a.gd && "undefined" == typeof XMLHttpRequest && "undefined" != typeof ActiveXObject) {
            for (var b = ["MSXML2.XMLHTTP.6.0", "MSXML2.XMLHTTP.3.0", "MSXML2.XMLHTTP", "Microsoft.XMLHTTP"], c = 0; c < b.length; c++) {
                var d = b[c];try {
                    return new ActiveXObject(d), a.gd = d;
                } catch (e) {}
            }throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");
        }return a.gd;
    };vc = new wc();var yc = function yc() {};t(yc, tc);yc.prototype.Cb = function () {
        var a = new XMLHttpRequest();if ("withCredentials" in a) return a;if ("undefined" != typeof XDomainRequest) return new zc();throw Error("Unsupported browser");
    };yc.prototype.xc = function () {
        return {};
    };
    var zc = function zc() {
        this.na = new XDomainRequest();this.readyState = 0;this.onreadystatechange = null;this.responseText = "";this.status = -1;this.statusText = this.responseXML = null;this.na.onload = _r(this.ee, this);this.na.onerror = _r(this.ed, this);this.na.onprogress = _r(this.fe, this);this.na.ontimeout = _r(this.ge, this);
    };h = zc.prototype;h.open = function (a, b, c) {
        if (null != c && !c) throw Error("Only async requests are supported.");this.na.open(a, b);
    };
    h.send = function (a) {
        if (a) {
            if ("string" == typeof a) this.na.send(a);else throw Error("Only string data is supported");
        } else this.na.send();
    };h.abort = function () {
        this.na.abort();
    };h.setRequestHeader = function () {};h.ee = function () {
        this.status = 200;this.responseText = this.na.responseText;Ac(this, 4);
    };h.ed = function () {
        this.status = 500;this.responseText = "";Ac(this, 4);
    };h.ge = function () {
        this.ed();
    };h.fe = function () {
        this.status = 200;Ac(this, 1);
    };var Ac = function Ac(a, b) {
        a.readyState = b;if (a.onreadystatechange) a.onreadystatechange();
    };var C = function C(a, b) {
        this.h = [];this.g = b;for (var c = !0, d = a.length - 1; 0 <= d; d--) {
            var e = a[d] | 0;c && e == b || (this.h[d] = e, c = !1);
        }
    },
        Bc = {},
        Cc = function Cc(a) {
        if (-128 <= a && 128 > a) {
            var b = Bc[a];if (b) return b;
        }b = new C([a | 0], 0 > a ? -1 : 0);-128 <= a && 128 > a && (Bc[a] = b);return b;
    },
        F = function F(a) {
        if (isNaN(a) || !isFinite(a)) return D;if (0 > a) return E(F(-a));for (var b = [], c = 1, d = 0; a >= c; d++) {
            b[d] = a / c | 0, c *= 4294967296;
        }return new C(b, 0);
    },
        Dc = function Dc(a, b) {
        if (0 == a.length) throw Error("number format error: empty string");b = b || 10;if (2 > b || 36 < b) throw Error("radix out of range: " + b);if ("-" == a.charAt(0)) return E(Dc(a.substring(1), b));if (0 <= a.indexOf("-")) throw Error('number format error: interior "-" character');for (var c = F(Math.pow(b, 8)), d = D, e = 0; e < a.length; e += 8) {
            var f = Math.min(8, a.length - e),
                g = parseInt(a.substring(e, e + f), b);8 > f ? (f = F(Math.pow(b, f)), d = d.multiply(f).add(F(g))) : (d = d.multiply(c), d = d.add(F(g)));
        }return d;
    },
        D = Cc(0),
        Ec = Cc(1),
        Fc = Cc(16777216),
        Gc = function Gc(a) {
        if (-1 == a.g) return -Gc(E(a));for (var b = 0, c = 1, d = 0; d < a.h.length; d++) {
            b += Hc(a, d) * c, c *= 4294967296;
        }return b;
    };
    C.prototype.toString = function (a) {
        a = a || 10;if (2 > a || 36 < a) throw Error("radix out of range: " + a);if (G(this)) return "0";if (-1 == this.g) return "-" + E(this).toString(a);for (var b = F(Math.pow(a, 6)), c = this, d = "";;) {
            var e = Ic(c, b),
                c = Jc(c, e.multiply(b)),
                f = ((0 < c.h.length ? c.h[0] : c.g) >>> 0).toString(a),
                c = e;if (G(c)) return f + d;for (; 6 > f.length;) {
                f = "0" + f;
            }d = "" + f + d;
        }
    };
    var H = function H(a, b) {
        return 0 > b ? 0 : b < a.h.length ? a.h[b] : a.g;
    },
        Hc = function Hc(a, b) {
        a = H(a, b);return 0 <= a ? a : 4294967296 + a;
    },
        G = function G(a) {
        if (0 != a.g) return !1;for (var b = 0; b < a.h.length; b++) {
            if (0 != a.h[b]) return !1;
        }return !0;
    };C.prototype.Eb = function (a) {
        if (this.g != a.g) return !1;for (var b = Math.max(this.h.length, a.h.length), c = 0; c < b; c++) {
            if (H(this, c) != H(a, c)) return !1;
        }return !0;
    };C.prototype.compare = function (a) {
        a = Jc(this, a);return -1 == a.g ? -1 : G(a) ? 0 : 1;
    };
    var E = function E(a) {
        for (var b = a.h.length, c = [], d = 0; d < b; d++) {
            c[d] = ~a.h[d];
        }return new C(c, ~a.g).add(Ec);
    };C.prototype.add = function (a) {
        for (var b = Math.max(this.h.length, a.h.length), c = [], d = 0, e = 0; e <= b; e++) {
            var f = d + (H(this, e) & 65535) + (H(a, e) & 65535),
                g = (f >>> 16) + (H(this, e) >>> 16) + (H(a, e) >>> 16),
                d = g >>> 16,
                f = f & 65535,
                g = g & 65535;c[e] = g << 16 | f;
        }return new C(c, c[c.length - 1] & -2147483648 ? -1 : 0);
    };var Jc = function Jc(a, b) {
        return a.add(E(b));
    };
    C.prototype.multiply = function (a) {
        if (G(this) || G(a)) return D;if (-1 == this.g) return -1 == a.g ? E(this).multiply(E(a)) : E(E(this).multiply(a));if (-1 == a.g) return E(this.multiply(E(a)));if (0 > this.compare(Fc) && 0 > a.compare(Fc)) return F(Gc(this) * Gc(a));for (var b = this.h.length + a.h.length, c = [], d = 0; d < 2 * b; d++) {
            c[d] = 0;
        }for (d = 0; d < this.h.length; d++) {
            for (var e = 0; e < a.h.length; e++) {
                var f = H(this, d) >>> 16,
                    g = H(this, d) & 65535,
                    k = H(a, e) >>> 16,
                    q = H(a, e) & 65535;c[2 * d + 2 * e] += g * q;Kc(c, 2 * d + 2 * e);c[2 * d + 2 * e + 1] += f * q;Kc(c, 2 * d + 2 * e + 1);c[2 * d + 2 * e + 1] += g * k;Kc(c, 2 * d + 2 * e + 1);c[2 * d + 2 * e + 2] += f * k;Kc(c, 2 * d + 2 * e + 2);
            }
        }for (d = 0; d < b; d++) {
            c[d] = c[2 * d + 1] << 16 | c[2 * d];
        }for (d = b; d < 2 * b; d++) {
            c[d] = 0;
        }return new C(c, 0);
    };
    var Kc = function Kc(a, b) {
        for (; (a[b] & 65535) != a[b];) {
            a[b + 1] += a[b] >>> 16, a[b] &= 65535;
        }
    },
        Ic = function Ic(a, b) {
        if (G(b)) throw Error("division by zero");if (G(a)) return D;if (-1 == a.g) return -1 == b.g ? Ic(E(a), E(b)) : E(Ic(E(a), b));if (-1 == b.g) return E(Ic(a, E(b)));if (30 < a.h.length) {
            if (-1 == a.g || -1 == b.g) throw Error("slowDivide_ only works with positive integers.");for (var c = Ec; 0 >= b.compare(a);) {
                c = c.shiftLeft(1), b = b.shiftLeft(1);
            }var d = Lc(c, 1),
                e = Lc(b, 1),
                f;b = Lc(b, 2);for (c = Lc(c, 2); !G(b);) {
                f = e.add(b), 0 >= f.compare(a) && (d = d.add(c), e = f), b = Lc(b, 1), c = Lc(c, 1);
            }return d;
        }for (c = D; 0 <= a.compare(b);) {
            d = Math.max(1, Math.floor(Gc(a) / Gc(b)));e = Math.ceil(Math.log(d) / Math.LN2);e = 48 >= e ? 1 : Math.pow(2, e - 48);f = F(d);for (var g = f.multiply(b); -1 == g.g || 0 < g.compare(a);) {
                d -= e, f = F(d), g = f.multiply(b);
            }G(f) && (f = Ec);c = c.add(f);a = Jc(a, g);
        }return c;
    },
        Mc = function Mc(a, b) {
        for (var c = Math.max(a.h.length, b.h.length), d = [], e = 0; e < c; e++) {
            d[e] = H(a, e) | H(b, e);
        }return new C(d, a.g | b.g);
    };
    C.prototype.shiftLeft = function (a) {
        var b = a >> 5;a %= 32;for (var c = this.h.length + b + (0 < a ? 1 : 0), d = [], e = 0; e < c; e++) {
            d[e] = 0 < a ? H(this, e - b) << a | H(this, e - b - 1) >>> 32 - a : H(this, e - b);
        }return new C(d, this.g);
    };var Lc = function Lc(a, b) {
        var c = b >> 5;b %= 32;for (var d = a.h.length - c, e = [], f = 0; f < d; f++) {
            e[f] = 0 < b ? H(a, f + c) >>> b | H(a, f + c + 1) << 32 - b : H(a, f + c);
        }return new C(e, a.g);
    };var Nc = function Nc(a, b) {
        this.ob = a;this.ma = b;
    };Nc.prototype.Eb = function (a) {
        return this.ma == a.ma && this.ob.Eb(Va(a.ob));
    };
    var Qc = function Qc(a) {
        try {
            var b;if (b = 0 == a.lastIndexOf("[", 0)) {
                var c = a.length - 1;b = 0 <= c && a.indexOf("]", c) == c;
            }return b ? new Oc(a.substring(1, a.length - 1)) : new Pc(a);
        } catch (d) {
            return null;
        }
    },
        Pc = function Pc(a) {
        var b = D;if (a instanceof C) {
            if (0 != a.g || 0 > a.compare(D) || 0 < a.compare(Rc)) throw Error("The address does not look like an IPv4.");b = Va(a);
        } else {
            if (!Sc.test(a)) throw Error(a + " does not look like an IPv4 address.");var c = a.split(".");if (4 != c.length) throw Error(a + " does not look like an IPv4 address.");for (var d = 0; d < c.length; d++) {
                var e;e = c[d];var f = Number(e);e = 0 == f && /^[\s\xa0]*$/.test(e) ? NaN : f;if (isNaN(e) || 0 > e || 255 < e || 1 != c[d].length && 0 == c[d].lastIndexOf("0", 0)) throw Error("In " + a + ", octet " + d + " is not valid");e = F(e);b = Mc(b.shiftLeft(8), e);
            }
        }Nc.call(this, b, 4);
    };t(Pc, Nc);var Sc = /^[0-9.]*$/,
        Rc = Jc(Ec.shiftLeft(32), Ec);Pc.prototype.toString = function () {
        if (this.Ca) return this.Ca;for (var a = Hc(this.ob, 0), b = [], c = 3; 0 <= c; c--) {
            b[c] = String(a & 255), a >>>= 8;
        }return this.Ca = b.join(".");
    };
    var Oc = function Oc(a) {
        var b = D;if (a instanceof C) {
            if (0 != a.g || 0 > a.compare(D) || 0 < a.compare(Tc)) throw Error("The address does not look like a valid IPv6.");b = Va(a);
        } else {
            if (!Uc.test(a)) throw Error(a + " is not a valid IPv6 address.");var c = a.split(":");if (-1 != c[c.length - 1].indexOf(".")) {
                a = Hc(Va(new Pc(c[c.length - 1]).ob), 0);var d = [];d.push((a >>> 16 & 65535).toString(16));d.push((a & 65535).toString(16));Ja(c, c.length - 1);Pa(c, d);a = c.join(":");
            }d = a.split("::");if (2 < d.length || 1 == d.length && 8 != c.length) throw Error(a + " is not a valid IPv6 address.");if (1 < d.length) {
                c = d[0].split(":");d = d[1].split(":");1 == c.length && "" == c[0] && (c = []);1 == d.length && "" == d[0] && (d = []);var e = 8 - (c.length + d.length);if (1 > e) c = [];else {
                    for (var f = [], g = 0; g < e; g++) {
                        f[g] = "0";
                    }c = Na(c, f, d);
                }
            }if (8 != c.length) throw Error(a + " is not a valid IPv6 address");for (d = 0; d < c.length; d++) {
                e = Dc(c[d], 16);if (0 > e.compare(D) || 0 < e.compare(Vc)) throw Error(c[d] + " in " + a + " is not a valid hextet.");b = Mc(b.shiftLeft(16), e);
            }
        }Nc.call(this, b, 6);
    };t(Oc, Nc);
    var Uc = /^([a-fA-F0-9]*:){2}[a-fA-F0-9:.]*$/,
        Vc = Cc(65535),
        Tc = Jc(Ec.shiftLeft(128), Ec);Oc.prototype.toString = function () {
        if (this.Ca) return this.Ca;for (var a = [], b = 3; 0 <= b; b--) {
            var c = Hc(this.ob, b),
                d = c & 65535;a.push((c >>> 16).toString(16));a.push(d.toString(16));
        }for (var c = b = -1, e = d = 0, f = 0; f < a.length; f++) {
            "0" == a[f] ? (e++, -1 == c && (c = f), e > d && (d = e, b = c)) : (c = -1, e = 0);
        }0 < d && (b + d == a.length && a.push(""), a.splice(b, d, ""), 0 == b && (a = [""].concat(a)));return this.Ca = a.join(":");
    };!gb && !z || z && 9 <= Number(pb) || gb && A("1.9.1");z && A("9");var Xc = function Xc(a, b) {
        Qa(b, function (b, d) {
            "style" == d ? a.style.cssText = b : "class" == d ? a.className = b : "for" == d ? a.htmlFor = b : Wc.hasOwnProperty(d) ? a.setAttribute(Wc[d], b) : 0 == d.lastIndexOf("aria-", 0) || 0 == d.lastIndexOf("data-", 0) ? a.setAttribute(d, b) : a[d] = b;
        });
    },
        Wc = { cellpadding: "cellPadding", cellspacing: "cellSpacing", colspan: "colSpan", frameborder: "frameBorder", height: "height", maxlength: "maxLength", nonce: "nonce", role: "role", rowspan: "rowSpan", type: "type", usemap: "useMap", valign: "vAlign", width: "width" };var Yc = function Yc(a, b, c) {
        this.pe = c;this.Td = a;this.ye = b;this.Rb = 0;this.Lb = null;
    };Yc.prototype.get = function () {
        var a;0 < this.Rb ? (this.Rb--, a = this.Lb, this.Lb = a.next, a.next = null) : a = this.Td();return a;
    };Yc.prototype.put = function (a) {
        this.ye(a);this.Rb < this.pe && (this.Rb++, a.next = this.Lb, this.Lb = a);
    };var Zc = function Zc(a) {
        l.setTimeout(function () {
            throw a;
        }, 0);
    },
        $c,
        ad = function ad() {
        var a = l.MessageChannel;"undefined" === typeof a && "undefined" !== typeof window && window.postMessage && window.addEventListener && !y("Presto") && (a = function a() {
            var a = document.createElement("IFRAME");a.style.display = "none";a.src = "";document.documentElement.appendChild(a);var b = a.contentWindow,
                a = b.document;a.open();a.write("");a.close();var c = "callImmediate" + Math.random(),
                d = "file:" == b.location.protocol ? "*" : b.location.protocol + "//" + b.location.host,
                a = _r(function (a) {
                if (("*" == d || a.origin == d) && a.data == c) this.port1.onmessage();
            }, this);b.addEventListener("message", a, !1);this.port1 = {};this.port2 = { postMessage: function postMessage() {
                    b.postMessage(c, d);
                } };
        });if ("undefined" !== typeof a && !y("Trident") && !y("MSIE")) {
            var b = new a(),
                c = {},
                d = c;b.port1.onmessage = function () {
                if (void 0 !== c.next) {
                    c = c.next;var a = c.Xc;c.Xc = null;a();
                }
            };return function (a) {
                d.next = { Xc: a };d = d.next;b.port2.postMessage(0);
            };
        }return "undefined" !== typeof document && "onreadystatechange" in document.createElement("SCRIPT") ? function (a) {
            var b = document.createElement("SCRIPT");b.onreadystatechange = function () {
                b.onreadystatechange = null;b.parentNode.removeChild(b);b = null;a();a = null;
            };document.documentElement.appendChild(b);
        } : function (a) {
            l.setTimeout(a, 0);
        };
    };var bd = function bd() {
        this.jc = this.Ja = null;
    },
        dd = new Yc(function () {
        return new cd();
    }, function (a) {
        a.reset();
    }, 100);bd.prototype.add = function (a, b) {
        var c = dd.get();c.set(a, b);this.jc ? this.jc.next = c : (w(!this.Ja), this.Ja = c);this.jc = c;
    };bd.prototype.remove = function () {
        var a = null;this.Ja && (a = this.Ja, this.Ja = this.Ja.next, this.Ja || (this.jc = null), a.next = null);return a;
    };var cd = function cd() {
        this.next = this.scope = this.sc = null;
    };cd.prototype.set = function (a, b) {
        this.sc = a;this.scope = b;this.next = null;
    };
    cd.prototype.reset = function () {
        this.next = this.scope = this.sc = null;
    };var id = function id(a, b) {
        ed || fd();gd || (ed(), gd = !0);hd.add(a, b);
    },
        ed,
        fd = function fd() {
        if (l.Promise && l.Promise.resolve) {
            var a = l.Promise.resolve(void 0);ed = function ed() {
                a.then(jd);
            };
        } else ed = function ed() {
            var a = jd;!p(l.setImmediate) || l.Window && l.Window.prototype && !y("Edge") && l.Window.prototype.setImmediate == l.setImmediate ? ($c || ($c = ad()), $c(a)) : l.setImmediate(a);
        };
    },
        gd = !1,
        hd = new bd(),
        jd = function jd() {
        for (var a; a = hd.remove();) {
            try {
                a.sc.call(a.scope);
            } catch (b) {
                Zc(b);
            }dd.put(a);
        }gd = !1;
    };var kd = function kd(a) {
        a.prototype.then = a.prototype.then;a.prototype.$goog_Thenable = !0;
    },
        ld = function ld(a) {
        if (!a) return !1;try {
            return !!a.$goog_Thenable;
        } catch (b) {
            return !1;
        }
    };var I = function I(a, b) {
        this.F = 0;this.ka = void 0;this.Ma = this.fa = this.o = null;this.Jb = this.rc = !1;if (a != ba) try {
            var c = this;a.call(b, function (a) {
                md(c, 2, a);
            }, function (a) {
                if (!(a instanceof nd)) try {
                    if (a instanceof Error) throw a;throw Error("Promise rejected.");
                } catch (b) {}md(c, 3, a);
            });
        } catch (d) {
            md(this, 3, d);
        }
    },
        od = function od() {
        this.next = this.context = this.Sa = this.Ea = this.child = null;this.ib = !1;
    };od.prototype.reset = function () {
        this.context = this.Sa = this.Ea = this.child = null;this.ib = !1;
    };
    var pd = new Yc(function () {
        return new od();
    }, function (a) {
        a.reset();
    }, 100),
        qd = function qd(a, b, c) {
        var d = pd.get();d.Ea = a;d.Sa = b;d.context = c;return d;
    },
        J = function J(a) {
        if (a instanceof I) return a;var b = new I(ba);md(b, 2, a);return b;
    },
        K = function K(a) {
        return new I(function (b, c) {
            c(a);
        });
    },
        sd = function sd(a, b, c) {
        rd(a, b, c, null) || id(ja(b, a));
    },
        td = function td(a) {
        return new I(function (b) {
            var c = a.length,
                d = [];if (c) for (var e = function e(a, _e, f) {
                c--;d[a] = _e ? { be: !0, value: f } : { be: !1, reason: f };0 == c && b(d);
            }, f = 0, g; f < a.length; f++) {
                g = a[f], sd(g, ja(e, f, !0), ja(e, f, !1));
            } else b(d);
        });
    };I.prototype.then = function (a, b, c) {
        null != a && Ba(a, "opt_onFulfilled should be a function.");null != b && Ba(b, "opt_onRejected should be a function. Did you pass opt_context as the second argument instead of the third?");return ud(this, p(a) ? a : null, p(b) ? b : null, c);
    };kd(I);var wd = function wd(a, b) {
        b = qd(b, b, void 0);b.ib = !0;vd(a, b);return a;
    };I.prototype.l = function (a, b) {
        return ud(this, null, a, b);
    };I.prototype.cancel = function (a) {
        0 == this.F && id(function () {
            var b = new nd(a);xd(this, b);
        }, this);
    };
    var xd = function xd(a, b) {
        if (0 == a.F) if (a.o) {
            var c = a.o;if (c.fa) {
                for (var d = 0, e = null, f = null, g = c.fa; g && (g.ib || (d++, g.child == a && (e = g), !(e && 1 < d))); g = g.next) {
                    e || (f = g);
                }e && (0 == c.F && 1 == d ? xd(c, b) : (f ? (d = f, w(c.fa), w(null != d), d.next == c.Ma && (c.Ma = d), d.next = d.next.next) : yd(c), zd(c, e, 3, b)));
            }a.o = null;
        } else md(a, 3, b);
    },
        vd = function vd(a, b) {
        a.fa || 2 != a.F && 3 != a.F || Ad(a);w(null != b.Ea);a.Ma ? a.Ma.next = b : a.fa = b;a.Ma = b;
    },
        ud = function ud(a, b, c, d) {
        var e = qd(null, null, null);e.child = new I(function (a, g) {
            e.Ea = b ? function (c) {
                try {
                    var e = b.call(d, c);a(e);
                } catch (ra) {
                    g(ra);
                }
            } : a;e.Sa = c ? function (b) {
                try {
                    var e = c.call(d, b);void 0 === e && b instanceof nd ? g(b) : a(e);
                } catch (ra) {
                    g(ra);
                }
            } : g;
        });e.child.o = a;vd(a, e);return e.child;
    };I.prototype.He = function (a) {
        w(1 == this.F);this.F = 0;md(this, 2, a);
    };I.prototype.Ie = function (a) {
        w(1 == this.F);this.F = 0;md(this, 3, a);
    };
    var md = function md(a, b, c) {
        0 == a.F && (a === c && (b = 3, c = new TypeError("Promise cannot resolve to itself")), a.F = 1, rd(c, a.He, a.Ie, a) || (a.ka = c, a.F = b, a.o = null, Ad(a), 3 != b || c instanceof nd || Bd(a, c)));
    },
        rd = function rd(a, b, c, d) {
        if (a instanceof I) return null != b && Ba(b, "opt_onFulfilled should be a function."), null != c && Ba(c, "opt_onRejected should be a function. Did you pass opt_context as the second argument instead of the third?"), vd(a, qd(b || ba, c || null, d)), !0;if (ld(a)) return a.then(b, c, d), !0;if (ga(a)) try {
            var e = a.then;if (p(e)) return Cd(a, e, b, c, d), !0;
        } catch (f) {
            return c.call(d, f), !0;
        }return !1;
    },
        Cd = function Cd(a, b, c, d, e) {
        var f = !1,
            g = function g(a) {
            f || (f = !0, c.call(e, a));
        },
            k = function k(a) {
            f || (f = !0, d.call(e, a));
        };try {
            b.call(a, g, k);
        } catch (q) {
            k(q);
        }
    },
        Ad = function Ad(a) {
        a.rc || (a.rc = !0, id(a.Xd, a));
    },
        yd = function yd(a) {
        var b = null;a.fa && (b = a.fa, a.fa = b.next, b.next = null);a.fa || (a.Ma = null);null != b && w(null != b.Ea);return b;
    };I.prototype.Xd = function () {
        for (var a; a = yd(this);) {
            zd(this, a, this.F, this.ka);
        }this.rc = !1;
    };
    var zd = function zd(a, b, c, d) {
        if (3 == c && b.Sa && !b.ib) for (; a && a.Jb; a = a.o) {
            a.Jb = !1;
        }if (b.child) b.child.o = null, Dd(b, c, d);else try {
            b.ib ? b.Ea.call(b.context) : Dd(b, c, d);
        } catch (e) {
            Ed.call(null, e);
        }pd.put(b);
    },
        Dd = function Dd(a, b, c) {
        2 == b ? a.Ea.call(a.context, c) : a.Sa && a.Sa.call(a.context, c);
    },
        Bd = function Bd(a, b) {
        a.Jb = !0;id(function () {
            a.Jb && Ed.call(null, b);
        });
    },
        Ed = Zc,
        nd = function nd(a) {
        u.call(this, a);
    };t(nd, u);nd.prototype.name = "cancel"; /*
                                             Portions of this code are from MochiKit, received by
                                             The Closure Authors under the MIT license. All other code is Copyright
                                             2005-2009 The Closure Authors. All Rights Reserved.
                                             */
    var Fd = function Fd(a, b) {
        this.ac = [];this.nd = a;this.Zc = b || null;this.mb = this.Qa = !1;this.ka = void 0;this.Nc = this.Sc = this.mc = !1;this.hc = 0;this.o = null;this.nc = 0;
    };Fd.prototype.cancel = function (a) {
        if (this.Qa) this.ka instanceof Fd && this.ka.cancel();else {
            if (this.o) {
                var b = this.o;delete this.o;a ? b.cancel(a) : (b.nc--, 0 >= b.nc && b.cancel());
            }this.nd ? this.nd.call(this.Zc, this) : this.Nc = !0;this.Qa || Gd(this, new Hd());
        }
    };Fd.prototype.Yc = function (a, b) {
        this.mc = !1;Id(this, a, b);
    };
    var Id = function Id(a, b, c) {
        a.Qa = !0;a.ka = c;a.mb = !b;Jd(a);
    },
        Ld = function Ld(a) {
        if (a.Qa) {
            if (!a.Nc) throw new Kd();a.Nc = !1;
        }
    };Fd.prototype.callback = function (a) {
        Ld(this);Md(a);Id(this, !0, a);
    };
    var Gd = function Gd(a, b) {
        Ld(a);Md(b);Id(a, !1, b);
    },
        Md = function Md(a) {
        w(!(a instanceof Fd), "An execution sequence may not be initiated with a blocking Deferred.");
    },
        Qd = function Qd(a) {
        var b = Nd("https://apis.google.com/js/client.js?onload=" + Od);Pd(b, null, a, void 0);
    },
        Pd = function Pd(a, b, c, d) {
        w(!a.Sc, "Blocking Deferreds can not be re-used");a.ac.push([b, c, d]);a.Qa && Jd(a);
    };Fd.prototype.then = function (a, b, c) {
        var d,
            e,
            f = new I(function (a, b) {
            d = a;e = b;
        });Pd(this, d, function (a) {
            a instanceof Hd ? f.cancel() : e(a);
        });return f.then(a, b, c);
    };
    kd(Fd);
    var Rd = function Rd(a) {
        return Fa(a.ac, function (a) {
            return p(a[1]);
        });
    },
        Jd = function Jd(a) {
        if (a.hc && a.Qa && Rd(a)) {
            var b = a.hc,
                c = Sd[b];c && (l.clearTimeout(c.nb), delete Sd[b]);a.hc = 0;
        }a.o && (a.o.nc--, delete a.o);for (var b = a.ka, d = c = !1; a.ac.length && !a.mc;) {
            var e = a.ac.shift(),
                f = e[0],
                g = e[1],
                e = e[2];if (f = a.mb ? g : f) try {
                var k = f.call(e || a.Zc, b);void 0 !== k && (a.mb = a.mb && (k == b || k instanceof Error), a.ka = b = k);if (ld(b) || "function" === typeof l.Promise && b instanceof l.Promise) d = !0, a.mc = !0;
            } catch (q) {
                b = q, a.mb = !0, Rd(a) || (c = !0);
            }
        }a.ka = b;d && (k = _r(a.Yc, a, !0), d = _r(a.Yc, a, !1), b instanceof Fd ? (Pd(b, k, d), b.Sc = !0) : b.then(k, d));c && (b = new Td(b), Sd[b.nb] = b, a.hc = b.nb);
    },
        Kd = function Kd() {
        u.call(this);
    };t(Kd, u);Kd.prototype.message = "Deferred has already fired";Kd.prototype.name = "AlreadyCalledError";var Hd = function Hd() {
        u.call(this);
    };t(Hd, u);Hd.prototype.message = "Deferred was canceled";Hd.prototype.name = "CanceledError";var Td = function Td(a) {
        this.nb = l.setTimeout(_r(this.Ge, this), 0);this.J = a;
    };
    Td.prototype.Ge = function () {
        w(Sd[this.nb], "Cannot throw an error that is not scheduled.");delete Sd[this.nb];throw this.J;
    };var Sd = {};var Nd = function Nd(a) {
        var b = new Eb();b.Vb = a;return Ud(b);
    },
        Ud = function Ud(a) {
        var b = {},
            c = b.document || document,
            d;a instanceof Eb && a.constructor === Eb && a.Nd === Db ? d = a.Vb : (ya("expected object of type TrustedResourceUrl, got '" + a + "' of type " + m(a)), d = "type_error:TrustedResourceUrl");var e = document.createElement("SCRIPT");a = { vd: e, wb: void 0 };var f = new Fd(Vd, a),
            g = null,
            k = null != b.timeout ? b.timeout : 5E3;0 < k && (g = window.setTimeout(function () {
            Wd(e, !0);Gd(f, new Xd(1, "Timeout reached for loading script " + d));
        }, k), a.wb = g);e.onload = e.onreadystatechange = function () {
            e.readyState && "loaded" != e.readyState && "complete" != e.readyState || (Wd(e, b.Oe || !1, g), f.callback(null));
        };e.onerror = function () {
            Wd(e, !0, g);Gd(f, new Xd(0, "Error while loading script " + d));
        };a = b.attributes || {};Xa(a, { type: "text/javascript", charset: "UTF-8", src: d });Xc(e, a);Yd(c).appendChild(e);return f;
    },
        Yd = function Yd(a) {
        var b;return (b = (a || document).getElementsByTagName("HEAD")) && 0 != b.length ? b[0] : a.documentElement;
    },
        Vd = function Vd() {
        if (this && this.vd) {
            var a = this.vd;a && "SCRIPT" == a.tagName && Wd(a, !0, this.wb);
        }
    },
        Wd = function Wd(a, b, c) {
        null != c && l.clearTimeout(c);a.onload = ba;a.onerror = ba;a.onreadystatechange = ba;b && window.setTimeout(function () {
            a && a.parentNode && a.parentNode.removeChild(a);
        }, 0);
    },
        Xd = function Xd(a, b) {
        var c = "Jsloader error (code #" + a + ")";b && (c += ": " + b);u.call(this, c);this.code = a;
    };t(Xd, u);var Zd = function Zd() {
        Lb.call(this);this.Y = new Sb(this);this.Qd = this;this.Cc = null;
    };t(Zd, Lb);Zd.prototype[Ob] = !0;h = Zd.prototype;h.addEventListener = function (a, b, c, d) {
        Yb(this, a, b, c, d);
    };h.removeEventListener = function (a, b, c, d) {
        gc(this, a, b, c, d);
    };
    h.dispatchEvent = function (a) {
        $d(this);var b,
            c = this.Cc;if (c) {
            b = [];for (var d = 1; c; c = c.Cc) {
                b.push(c), w(1E3 > ++d, "infinite loop");
            }
        }c = this.Qd;d = a.type || a;if (n(a)) a = new Mb(a, c);else if (a instanceof Mb) a.target = a.target || c;else {
            var e = a;a = new Mb(d, c);Xa(a, e);
        }var e = !0,
            f;if (b) for (var g = b.length - 1; !a.Va && 0 <= g; g--) {
            f = a.currentTarget = b[g], e = ae(f, d, !0, a) && e;
        }a.Va || (f = a.currentTarget = c, e = ae(f, d, !0, a) && e, a.Va || (e = ae(f, d, !1, a) && e));if (b) for (g = 0; !a.Va && g < b.length; g++) {
            f = a.currentTarget = b[g], e = ae(f, d, !1, a) && e;
        }return e;
    };
    h.Oa = function () {
        Zd.Pc.Oa.call(this);if (this.Y) {
            var a = this.Y,
                b = 0,
                c;for (c in a.w) {
                for (var d = a.w[c], e = 0; e < d.length; e++) {
                    ++b, Rb(d[e]);
                }delete a.w[c];a.xb--;
            }
        }this.Cc = null;
    };h.listen = function (a, b, c, d) {
        $d(this);return this.Y.add(String(a), b, !1, c, d);
    };
    var fc = function fc(a, b, c, d, e) {
        a.Y.add(String(b), c, !0, d, e);
    },
        ae = function ae(a, b, c, d) {
        b = a.Y.w[String(b)];if (!b) return !0;b = b.concat();for (var e = !0, f = 0; f < b.length; ++f) {
            var g = b[f];if (g && !g.$a && g.Bb == c) {
                var k = g.listener,
                    q = g.Kb || g.src;g.Ab && Ub(a.Y, g);e = !1 !== k.call(q, d) && e;
            }
        }return e && 0 != d.ud;
    };Zd.prototype.tc = function (a, b, c, d) {
        return this.Y.tc(String(a), b, c, d);
    };var $d = function $d(a) {
        w(a.Y, "Event target is not initialized. Did you call the superclass (goog.events.EventTarget) constructor?");
    };var be = "StopIteration" in l ? l.StopIteration : { message: "StopIteration", stack: "" },
        ce = function ce() {};ce.prototype.next = function () {
        throw be;
    };ce.prototype.Pd = function () {
        return this;
    };var de = function de(a, b) {
        this.Z = {};this.s = [];this.ma = this.i = 0;var c = arguments.length;if (1 < c) {
            if (c % 2) throw Error("Uneven number of arguments");for (var d = 0; d < c; d += 2) {
                this.set(arguments[d], arguments[d + 1]);
            }
        } else a && this.addAll(a);
    };h = de.prototype;h.dd = function () {
        return this.i;
    };h.T = function () {
        ee(this);for (var a = [], b = 0; b < this.s.length; b++) {
            a.push(this.Z[this.s[b]]);
        }return a;
    };h.ha = function () {
        ee(this);return this.s.concat();
    };h.jb = function (a) {
        return fe(this.Z, a);
    };
    h.Eb = function (a, b) {
        if (this === a) return !0;if (this.i != a.dd()) return !1;b = b || ge;ee(this);for (var c, d = 0; c = this.s[d]; d++) {
            if (!b(this.get(c), a.get(c))) return !1;
        }return !0;
    };var ge = function ge(a, b) {
        return a === b;
    };de.prototype.remove = function (a) {
        return fe(this.Z, a) ? (delete this.Z[a], this.i--, this.ma++, this.s.length > 2 * this.i && ee(this), !0) : !1;
    };
    var ee = function ee(a) {
        if (a.i != a.s.length) {
            for (var b = 0, c = 0; b < a.s.length;) {
                var d = a.s[b];fe(a.Z, d) && (a.s[c++] = d);b++;
            }a.s.length = c;
        }if (a.i != a.s.length) {
            for (var e = {}, c = b = 0; b < a.s.length;) {
                d = a.s[b], fe(e, d) || (a.s[c++] = d, e[d] = 1), b++;
            }a.s.length = c;
        }
    };h = de.prototype;h.get = function (a, b) {
        return fe(this.Z, a) ? this.Z[a] : b;
    };h.set = function (a, b) {
        fe(this.Z, a) || (this.i++, this.s.push(a), this.ma++);this.Z[a] = b;
    };
    h.addAll = function (a) {
        var b;a instanceof de ? (b = a.ha(), a = a.T()) : (b = Sa(a), a = Ra(a));for (var c = 0; c < b.length; c++) {
            this.set(b[c], a[c]);
        }
    };h.forEach = function (a, b) {
        for (var c = this.ha(), d = 0; d < c.length; d++) {
            var e = c[d],
                f = this.get(e);a.call(b, f, e, this);
        }
    };h.clone = function () {
        return new de(this);
    };h.Pd = function (a) {
        ee(this);var b = 0,
            c = this.ma,
            d = this,
            e = new ce();e.next = function () {
            if (c != d.ma) throw Error("The map has changed since the iterator was created");if (b >= d.s.length) throw be;var e = d.s[b++];return a ? e : d.Z[e];
        };return e;
    };
    var fe = function fe(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    };var he = function he(a) {
        if (a.T && "function" == typeof a.T) return a.T();if (n(a)) return a.split("");if (ea(a)) {
            for (var b = [], c = a.length, d = 0; d < c; d++) {
                b.push(a[d]);
            }return b;
        }return Ra(a);
    },
        ie = function ie(a) {
        if (a.ha && "function" == typeof a.ha) return a.ha();if (!a.T || "function" != typeof a.T) {
            if (ea(a) || n(a)) {
                var b = [];a = a.length;for (var c = 0; c < a; c++) {
                    b.push(c);
                }return b;
            }return Sa(a);
        }
    },
        je = function je(a, b) {
        if (a.forEach && "function" == typeof a.forEach) a.forEach(b, void 0);else if (ea(a) || n(a)) x(a, b, void 0);else for (var c = ie(a), d = he(a), e = d.length, f = 0; f < e; f++) {
            b.call(void 0, d[f], c && c[f], a);
        }
    };var ke = function ke(a, b, c, d, e) {
        this.reset(a, b, c, d, e);
    };ke.prototype.ad = null;var le = 0;ke.prototype.reset = function (a, b, c, d, e) {
        "number" == typeof e || le++;d || ka();this.qb = a;this.re = b;delete this.ad;
    };ke.prototype.yd = function (a) {
        this.qb = a;
    };var me = function me(a) {
        this.se = a;this.fd = this.oc = this.qb = this.o = null;
    },
        ne = function ne(a, b) {
        this.name = a;this.value = b;
    };ne.prototype.toString = function () {
        return this.name;
    };var oe = new ne("SEVERE", 1E3),
        pe = new ne("CONFIG", 700),
        qe = new ne("FINE", 500);me.prototype.getParent = function () {
        return this.o;
    };me.prototype.yd = function (a) {
        this.qb = a;
    };var re = function re(a) {
        if (a.qb) return a.qb;if (a.o) return re(a.o);ya("Root logger has no level set.");return null;
    };
    me.prototype.log = function (a, b, c) {
        if (a.value >= re(this).value) for (p(b) && (b = b()), a = new ke(a, String(b), this.se), c && (a.ad = c), c = "log:" + a.re, l.console && (l.console.timeStamp ? l.console.timeStamp(c) : l.console.markTimeline && l.console.markTimeline(c)), l.msWriteProfilerMark && l.msWriteProfilerMark(c), c = this; c;) {
            b = c;var d = a;if (b.fd) for (var e = 0, f; f = b.fd[e]; e++) {
                f(d);
            }c = c.getParent();
        }
    };
    var se = {},
        te = null,
        ue = function ue(a) {
        te || (te = new me(""), se[""] = te, te.yd(pe));var b;if (!(b = se[a])) {
            b = new me(a);var c = a.lastIndexOf("."),
                d = a.substr(c + 1),
                c = ue(a.substr(0, c));c.oc || (c.oc = {});c.oc[d] = b;b.o = c;se[a] = b;
        }return b;
    };var L = function L(a, b) {
        a && a.log(qe, b, void 0);
    };var ve = function ve(a, b, c) {
        if (p(a)) c && (a = _r(a, c));else if (a && "function" == typeof a.handleEvent) a = _r(a.handleEvent, a);else throw Error("Invalid listener argument");return 2147483647 < Number(b) ? -1 : l.setTimeout(a, b || 0);
    },
        we = function we(a) {
        var b = null;return new I(function (c, d) {
            b = ve(function () {
                c(void 0);
            }, a);-1 == b && d(Error("Failed to schedule timer."));
        }).l(function (a) {
            l.clearTimeout(b);throw a;
        });
    };var xe = /^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/,
        ye = function ye(a, b) {
        if (a) {
            a = a.split("&");for (var c = 0; c < a.length; c++) {
                var d = a[c].indexOf("="),
                    e,
                    f = null;0 <= d ? (e = a[c].substring(0, d), f = a[c].substring(d + 1)) : e = a[c];b(e, f ? decodeURIComponent(f.replace(/\+/g, " ")) : "");
            }
        }
    };var M = function M(a) {
        Zd.call(this);this.headers = new de();this.lc = a || null;this.oa = !1;this.kc = this.a = null;this.pb = this.ld = this.Qb = "";this.Ba = this.wc = this.Ob = this.qc = !1;this.fb = 0;this.gc = null;this.td = "";this.ic = this.xe = this.Gd = !1;
    };t(M, Zd);var ze = M.prototype,
        Ae = ue("goog.net.XhrIo");ze.P = Ae;var Be = /^https?$/i,
        Ce = ["POST", "PUT"];
    M.prototype.send = function (a, b, c, d) {
        if (this.a) throw Error("[goog.net.XhrIo] Object is active with another request=" + this.Qb + "; newUri=" + a);b = b ? b.toUpperCase() : "GET";this.Qb = a;this.pb = "";this.ld = b;this.qc = !1;this.oa = !0;this.a = this.lc ? this.lc.Cb() : vc.Cb();this.kc = this.lc ? uc(this.lc) : uc(vc);this.a.onreadystatechange = _r(this.qd, this);this.xe && "onprogress" in this.a && (this.a.onprogress = _r(function (a) {
            this.pd(a, !0);
        }, this), this.a.upload && (this.a.upload.onprogress = _r(this.pd, this)));try {
            L(this.P, De(this, "Opening Xhr")), this.wc = !0, this.a.open(b, String(a), !0), this.wc = !1;
        } catch (f) {
            L(this.P, De(this, "Error opening Xhr: " + f.message));this.J(5, f);return;
        }a = c || "";var e = this.headers.clone();d && je(d, function (a, b) {
            e.set(b, a);
        });d = Ha(e.ha());c = l.FormData && a instanceof l.FormData;!Ia(Ce, b) || d || c || e.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");e.forEach(function (a, b) {
            this.a.setRequestHeader(b, a);
        }, this);this.td && (this.a.responseType = this.td);"withCredentials" in this.a && this.a.withCredentials !== this.Gd && (this.a.withCredentials = this.Gd);try {
            Ee(this), 0 < this.fb && (this.ic = Fe(this.a), L(this.P, De(this, "Will abort after " + this.fb + "ms if incomplete, xhr2 " + this.ic)), this.ic ? (this.a.timeout = this.fb, this.a.ontimeout = _r(this.wb, this)) : this.gc = ve(this.wb, this.fb, this)), L(this.P, De(this, "Sending request")), this.Ob = !0, this.a.send(a), this.Ob = !1;
        } catch (f) {
            L(this.P, De(this, "Send error: " + f.message)), this.J(5, f);
        }
    };var Fe = function Fe(a) {
        return z && A(9) && fa(a.timeout) && void 0 !== a.ontimeout;
    },
        Ga = function Ga(a) {
        return "content-type" == a.toLowerCase();
    };
    M.prototype.wb = function () {
        "undefined" != typeof aa && this.a && (this.pb = "Timed out after " + this.fb + "ms, aborting", L(this.P, De(this, this.pb)), this.dispatchEvent("timeout"), this.abort(8));
    };M.prototype.J = function (a, b) {
        this.oa = !1;this.a && (this.Ba = !0, this.a.abort(), this.Ba = !1);this.pb = b;Ge(this);He(this);
    };var Ge = function Ge(a) {
        a.qc || (a.qc = !0, a.dispatchEvent("complete"), a.dispatchEvent("error"));
    };
    M.prototype.abort = function () {
        this.a && this.oa && (L(this.P, De(this, "Aborting")), this.oa = !1, this.Ba = !0, this.a.abort(), this.Ba = !1, this.dispatchEvent("complete"), this.dispatchEvent("abort"), He(this));
    };M.prototype.Oa = function () {
        this.a && (this.oa && (this.oa = !1, this.Ba = !0, this.a.abort(), this.Ba = !1), He(this, !0));M.Pc.Oa.call(this);
    };M.prototype.qd = function () {
        this.isDisposed() || (this.wc || this.Ob || this.Ba ? Ie(this) : this.ve());
    };M.prototype.ve = function () {
        Ie(this);
    };
    var Ie = function Ie(a) {
        if (a.oa && "undefined" != typeof aa) if (a.kc[1] && 4 == Je(a) && 2 == Ke(a)) L(a.P, De(a, "Local request error detected and ignored"));else if (a.Ob && 4 == Je(a)) ve(a.qd, 0, a);else if (a.dispatchEvent("readystatechange"), 4 == Je(a)) {
            L(a.P, De(a, "Request complete"));a.oa = !1;try {
                var b = Ke(a),
                    c;a: switch (b) {case 200:case 201:case 202:case 204:case 206:case 304:case 1223:
                        c = !0;break a;default:
                        c = !1;}var d;if (!(d = c)) {
                    var e;if (e = 0 === b) {
                        var f = String(a.Qb).match(xe)[1] || null;if (!f && l.self && l.self.location) var g = l.self.location.protocol,
                            f = g.substr(0, g.length - 1);e = !Be.test(f ? f.toLowerCase() : "");
                    }d = e;
                }if (d) a.dispatchEvent("complete"), a.dispatchEvent("success");else {
                    var k;try {
                        k = 2 < Je(a) ? a.a.statusText : "";
                    } catch (q) {
                        L(a.P, "Can not get status: " + q.message), k = "";
                    }a.pb = k + " [" + Ke(a) + "]";Ge(a);
                }
            } finally {
                He(a);
            }
        }
    };M.prototype.pd = function (a, b) {
        w("progress" === a.type, "goog.net.EventType.PROGRESS is of the same type as raw XHR progress.");this.dispatchEvent(Le(a, "progress"));this.dispatchEvent(Le(a, b ? "downloadprogress" : "uploadprogress"));
    };
    var Le = function Le(a, b) {
        return { type: b, lengthComputable: a.lengthComputable, loaded: a.loaded, total: a.total };
    },
        He = function He(a, b) {
        if (a.a) {
            Ee(a);var c = a.a,
                d = a.kc[0] ? ba : null;a.a = null;a.kc = null;b || a.dispatchEvent("ready");try {
                c.onreadystatechange = d;
            } catch (e) {
                (a = a.P) && a.log(oe, "Problem encountered resetting onreadystatechange: " + e.message, void 0);
            }
        }
    },
        Ee = function Ee(a) {
        a.a && a.ic && (a.a.ontimeout = null);fa(a.gc) && (l.clearTimeout(a.gc), a.gc = null);
    },
        Je = function Je(a) {
        return a.a ? a.a.readyState : 0;
    },
        Ke = function Ke(a) {
        try {
            return 2 < Je(a) ? a.a.status : -1;
        } catch (b) {
            return -1;
        }
    },
        Me = function Me(a) {
        try {
            return a.a ? a.a.responseText : "";
        } catch (b) {
            return L(a.P, "Can not get responseText: " + b.message), "";
        }
    },
        De = function De(a, b) {
        return b + " [" + a.ld + " " + a.Qb + " " + Ke(a) + "]";
    };var Ne = function Ne(a, b) {
        this.ga = this.Ia = this.la = "";this.Ua = null;this.Aa = this.qa = "";this.M = this.oe = !1;var c;a instanceof Ne ? (this.M = void 0 !== b ? b : a.M, Oe(this, a.la), c = a.Ia, N(this), this.Ia = c, Pe(this, a.ga), Qe(this, a.Ua), Re(this, a.qa), Se(this, a.aa.clone()), a = a.Aa, N(this), this.Aa = a) : a && (c = String(a).match(xe)) ? (this.M = !!b, Oe(this, c[1] || "", !0), a = c[2] || "", N(this), this.Ia = Te(a), Pe(this, c[3] || "", !0), Qe(this, c[4]), Re(this, c[5] || "", !0), Se(this, c[6] || "", !0), a = c[7] || "", N(this), this.Aa = Te(a)) : (this.M = !!b, this.aa = new O(null, 0, this.M));
    };Ne.prototype.toString = function () {
        var a = [],
            b = this.la;b && a.push(Ue(b, Ve, !0), ":");var c = this.ga;if (c || "file" == b) a.push("//"), (b = this.Ia) && a.push(Ue(b, Ve, !0), "@"), a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.Ua, null != c && a.push(":", String(c));if (c = this.qa) this.ga && "/" != c.charAt(0) && a.push("/"), a.push(Ue(c, "/" == c.charAt(0) ? We : Xe, !0));(c = this.aa.toString()) && a.push("?", c);(c = this.Aa) && a.push("#", Ue(c, Ye));return a.join("");
    };
    Ne.prototype.resolve = function (a) {
        var b = this.clone(),
            c = !!a.la;c ? Oe(b, a.la) : c = !!a.Ia;if (c) {
            var d = a.Ia;N(b);b.Ia = d;
        } else c = !!a.ga;c ? Pe(b, a.ga) : c = null != a.Ua;d = a.qa;if (c) Qe(b, a.Ua);else if (c = !!a.qa) {
            if ("/" != d.charAt(0)) if (this.ga && !this.qa) d = "/" + d;else {
                var e = b.qa.lastIndexOf("/");-1 != e && (d = b.qa.substr(0, e + 1) + d);
            }e = d;if (".." == e || "." == e) d = "";else if (v(e, "./") || v(e, "/.")) {
                for (var d = 0 == e.lastIndexOf("/", 0), e = e.split("/"), f = [], g = 0; g < e.length;) {
                    var k = e[g++];"." == k ? d && g == e.length && f.push("") : ".." == k ? ((1 < f.length || 1 == f.length && "" != f[0]) && f.pop(), d && g == e.length && f.push("")) : (f.push(k), d = !0);
                }d = f.join("/");
            } else d = e;
        }c ? Re(b, d) : c = "" !== a.aa.toString();c ? Se(b, Te(a.aa.toString())) : c = !!a.Aa;c && (a = a.Aa, N(b), b.Aa = a);return b;
    };Ne.prototype.clone = function () {
        return new Ne(this);
    };
    var Oe = function Oe(a, b, c) {
        N(a);a.la = c ? Te(b, !0) : b;a.la && (a.la = a.la.replace(/:$/, ""));
    },
        Pe = function Pe(a, b, c) {
        N(a);a.ga = c ? Te(b, !0) : b;
    },
        Qe = function Qe(a, b) {
        N(a);if (b) {
            b = Number(b);if (isNaN(b) || 0 > b) throw Error("Bad port number " + b);a.Ua = b;
        } else a.Ua = null;
    },
        Re = function Re(a, b, c) {
        N(a);a.qa = c ? Te(b, !0) : b;
    },
        Se = function Se(a, b, c) {
        N(a);b instanceof O ? (a.aa = b, a.aa.Mc(a.M)) : (c || (b = Ue(b, Ze)), a.aa = new O(b, 0, a.M));
    },
        P = function P(a, b, c) {
        N(a);a.aa.set(b, c);
    },
        N = function N(a) {
        if (a.oe) throw Error("Tried to modify a read-only Uri");
    };
    Ne.prototype.Mc = function (a) {
        this.M = a;this.aa && this.aa.Mc(a);return this;
    };
    var $e = function $e(a) {
        return a instanceof Ne ? a.clone() : new Ne(a, void 0);
    },
        af = function af(a, b) {
        var c = new Ne(null, void 0);Oe(c, "https");a && Pe(c, a);b && Re(c, b);return c;
    },
        Te = function Te(a, b) {
        return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : "";
    },
        Ue = function Ue(a, b, c) {
        return n(a) ? (a = encodeURI(a).replace(b, bf), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
    },
        bf = function bf(a) {
        a = a.charCodeAt(0);return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
    },
        Ve = /[#\/\?@]/g,
        Xe = /[\#\?:]/g,
        We = /[\#\?]/g,
        Ze = /[\#\?@]/g,
        Ye = /#/g,
        O = function O(a, b, c) {
        this.i = this.j = null;this.I = a || null;this.M = !!c;
    },
        cf = function cf(a) {
        a.j || (a.j = new de(), a.i = 0, a.I && ye(a.I, function (b, c) {
            a.add(decodeURIComponent(b.replace(/\+/g, " ")), c);
        }));
    },
        ef = function ef(a) {
        var b = ie(a);if ("undefined" == typeof b) throw Error("Keys are undefined");var c = new O(null, 0, void 0);a = he(a);for (var d = 0; d < b.length; d++) {
            var e = b[d],
                f = a[d];da(f) ? df(c, e, f) : c.add(e, f);
        }return c;
    };h = O.prototype;h.dd = function () {
        cf(this);return this.i;
    };
    h.add = function (a, b) {
        cf(this);this.I = null;a = this.K(a);var c = this.j.get(a);c || this.j.set(a, c = []);c.push(b);this.i = za(this.i) + 1;return this;
    };h.remove = function (a) {
        cf(this);a = this.K(a);return this.j.jb(a) ? (this.I = null, this.i = za(this.i) - this.j.get(a).length, this.j.remove(a)) : !1;
    };h.jb = function (a) {
        cf(this);a = this.K(a);return this.j.jb(a);
    };h.ha = function () {
        cf(this);for (var a = this.j.T(), b = this.j.ha(), c = [], d = 0; d < b.length; d++) {
            for (var e = a[d], f = 0; f < e.length; f++) {
                c.push(b[d]);
            }
        }return c;
    };
    h.T = function (a) {
        cf(this);var b = [];if (n(a)) this.jb(a) && (b = Ma(b, this.j.get(this.K(a))));else {
            a = this.j.T();for (var c = 0; c < a.length; c++) {
                b = Ma(b, a[c]);
            }
        }return b;
    };h.set = function (a, b) {
        cf(this);this.I = null;a = this.K(a);this.jb(a) && (this.i = za(this.i) - this.j.get(a).length);this.j.set(a, [b]);this.i = za(this.i) + 1;return this;
    };h.get = function (a, b) {
        a = a ? this.T(a) : [];return 0 < a.length ? String(a[0]) : b;
    };var df = function df(a, b, c) {
        a.remove(b);0 < c.length && (a.I = null, a.j.set(a.K(b), Oa(c)), a.i = za(a.i) + c.length);
    };
    O.prototype.toString = function () {
        if (this.I) return this.I;if (!this.j) return "";for (var a = [], b = this.j.ha(), c = 0; c < b.length; c++) {
            for (var d = b[c], e = encodeURIComponent(String(d)), d = this.T(d), f = 0; f < d.length; f++) {
                var g = e;"" !== d[f] && (g += "=" + encodeURIComponent(String(d[f])));a.push(g);
            }
        }return this.I = a.join("&");
    };O.prototype.clone = function () {
        var a = new O();a.I = this.I;this.j && (a.j = this.j.clone(), a.i = this.i);return a;
    };O.prototype.K = function (a) {
        a = String(a);this.M && (a = a.toLowerCase());return a;
    };
    O.prototype.Mc = function (a) {
        a && !this.M && (cf(this), this.I = null, this.j.forEach(function (a, c) {
            var d = c.toLowerCase();c != d && (this.remove(c), df(this, d, a));
        }, this));this.M = a;
    };var gf = function gf() {
        var a = ff();return z && !!pb && 11 == pb || /Edge\/\d+/.test(a);
    },
        hf = function hf() {
        return l.window && l.window.location.href || "";
    },
        jf = function jf(a, b) {
        var c = [],
            d;for (d in a) {
            d in b ? _typeof(a[d]) != _typeof(b[d]) ? c.push(d) : da(a[d]) ? Ua(a[d], b[d]) || c.push(d) : "object" == _typeof(a[d]) && null != a[d] && null != b[d] ? 0 < jf(a[d], b[d]).length && c.push(d) : a[d] !== b[d] && c.push(d) : c.push(d);
        }for (d in b) {
            d in a || c.push(d);
        }return c;
    },
        lf = function lf() {
        var a;a = ff();a = "Chrome" != kf(a) ? null : (a = a.match(/\sChrome\/(\d+)/i)) && 2 == a.length ? parseInt(a[1], 10) : null;return a && 30 > a ? !1 : !z || !pb || 9 < pb;
    },
        mf = function mf(a) {
        (a || l.window).close();
    },
        nf = function nf(a, b, c) {
        var d = Math.floor(1E9 * Math.random()).toString();b = b || 500;c = c || 600;var e = (window.screen.availHeight - c) / 2,
            f = (window.screen.availWidth - b) / 2;b = { width: b, height: c, top: 0 < e ? e : 0, left: 0 < f ? f : 0, location: !0, resizable: !0, statusbar: !0, toolbar: !1 };d && (b.target = d);"Firefox" == kf(ff()) && (a = a || "http://localhost", b.scrollbars = !0);var g;c = a || "about:blank";(d = b) || (d = {});a = window;b = c instanceof B ? c : Cb("undefined" != typeof c.href ? c.href : String(c));c = d.target || c.target;e = [];for (g in d) {
            switch (g) {case "width":case "height":case "top":case "left":
                    e.push(g + "=" + d[g]);break;case "target":case "noreferrer":
                    break;default:
                    e.push(g + "=" + (d[g] ? 1 : 0));}
        }g = e.join(",");(y("iPhone") && !y("iPod") && !y("iPad") || y("iPad") || y("iPod")) && a.navigator && a.navigator.standalone && c && "_self" != c ? (g = a.document.createElement("A"), b = b instanceof B ? b : Cb(b), g.href = zb(b), g.setAttribute("target", c), d.noreferrer && g.setAttribute("rel", "noreferrer"), d = document.createEvent("MouseEvent"), d.initMouseEvent("click", !0, !0, a, 1), g.dispatchEvent(d), g = {}) : d.noreferrer ? (g = a.open("", c, g), d = zb(b), g && (fb && v(d, ";") && (d = "'" + d.replace(/'/g, "%27") + "'"), g.opener = null, a = new wb(), a.ec = "b/12014412, meta tag with sanitized URL", ua.test(d) && (-1 != d.indexOf("&") && (d = d.replace(na, "&amp;")), -1 != d.indexOf("<") && (d = d.replace(oa, "&lt;")), -1 != d.indexOf(">") && (d = d.replace(pa, "&gt;")), -1 != d.indexOf('"') && (d = d.replace(qa, "&quot;")), -1 != d.indexOf("'") && (d = d.replace(sa, "&#39;")), -1 != d.indexOf("\x00") && (d = d.replace(ta, "&#0;"))), d = '<META HTTP-EQUIV="refresh" content="0; url=' + d + '">', Aa(xb(a), "must provide justification"), w(!/^[\s\xa0]*$/.test(xb(a)), "must provide non-empty justification"), g.document.write(Hb(new Gb().ne(d))), g.document.close())) : g = a.open(zb(b), c, g);if (g) try {
            g.focus();
        } catch (k) {}return g;
    },
        of = function of(a) {
        return new I(function (b) {
            var c = function c() {
                we(2E3).then(function () {
                    if (!a || a.closed) b();else return c();
                });
            };return c();
        });
    },
        pf = function pf() {
        var a = null;return new I(function (b) {
            "complete" == l.document.readyState ? b() : (a = function a() {
                b();
            }, ec(window, "load", a));
        }).l(function (b) {
            gc(window, "load", a);throw b;
        });
    },
        qf = function qf(a) {
        switch (a || l.navigator && l.navigator.product || "") {case "ReactNative":
                return "ReactNative";default:
                return "undefined" !== typeof l.process ? "Node" : "Browser";}
    },
        rf = function rf() {
        var a = qf();return "ReactNative" === a || "Node" === a;
    },
        kf = function kf(a) {
        var b = a.toLowerCase();if (v(b, "opera/") || v(b, "opr/") || v(b, "opios/")) return "Opera";if (v(b, "iemobile")) return "IEMobile";if (v(b, "msie") || v(b, "trident/")) return "IE";if (v(b, "edge/")) return "Edge";if (v(b, "firefox/")) return "Firefox";if (v(b, "silk/")) return "Silk";if (v(b, "blackberry")) return "Blackberry";if (v(b, "webos")) return "Webos";if (!v(b, "safari/") || v(b, "chrome/") || v(b, "crios/") || v(b, "android")) {
            if (!v(b, "chrome/") && !v(b, "crios/") || v(b, "edge/")) {
                if (v(b, "android")) return "Android";if ((a = a.match(/([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/)) && 2 == a.length) return a[1];
            } else return "Chrome";
        } else return "Safari";return "Other";
    },
        sf = function sf(a) {
        var b = qf(void 0);return ("Browser" === b ? kf(ff()) : b) + "/JsCore/" + a;
    },
        ff = function ff() {
        return l.navigator && l.navigator.userAgent || "";
    },
        tf = function tf(a) {
        a = a.split(".");for (var b = l, c = 0; c < a.length && "object" == (typeof b === "undefined" ? "undefined" : _typeof(b)) && null != b; c++) {
            b = b[a[c]];
        }c != a.length && (b = void 0);return b;
    },
        vf = function vf() {
        var a;if (!(a = !l.location || !l.location.protocol || "http:" != l.location.protocol && "https:" != l.location.protocol || rf())) {
            var b;a: {
                try {
                    var c = l.localStorage,
                        d = uf();if (c) {
                        c.setItem(d, "1");c.removeItem(d);b = gf() ? !!l.indexedDB : !0;break a;
                    }
                } catch (e) {}b = !1;
            }a = !b;
        }return !a;
    },
        wf = function wf(a) {
        a = a || ff();var b = (a || ff()).toLowerCase();return b.match(/android/) || b.match(/webos/) || b.match(/iphone|ipad|ipod/) || b.match(/blackberry/) || b.match(/windows phone/) || b.match(/iemobile/) || "Firefox" == kf(a) ? !1 : !0;
    },
        xf = function xf(a) {
        return "undefined" === typeof a ? null : pc(a);
    },
        yf = function yf(a) {
        if (null !== a) {
            var b;try {
                b = mc(a);
            } catch (c) {
                try {
                    b = JSON.parse(a);
                } catch (d) {
                    throw c;
                }
            }return b;
        }
    },
        uf = function uf(a) {
        return a ? a : "" + Math.floor(1E9 * Math.random()).toString();
    },
        zf = function zf() {
        var a = l.___jsl;if (a && a.H) for (var b in a.H) {
            if (a.H[b].r = a.H[b].r || [], a.H[b].L = a.H[b].L || [], a.H[b].r = a.H[b].L.concat(), a.CP) for (var c = 0; c < a.CP.length; c++) {
                a.CP[c] = null;
            }
        }
    };var Af;try {
        var Bf = {};Object.defineProperty(Bf, "abcd", { configurable: !0, enumerable: !0, value: 1 });Object.defineProperty(Bf, "abcd", { configurable: !0, enumerable: !0, value: 2 });Af = 2 == Bf.abcd;
    } catch (a) {
        Af = !1;
    }
    var Q = function Q(a, b, c) {
        Af ? Object.defineProperty(a, b, { configurable: !0, enumerable: !0, value: c }) : a[b] = c;
    },
        Cf = function Cf(a, b) {
        if (b) for (var c in b) {
            b.hasOwnProperty(c) && Q(a, c, b[c]);
        }
    },
        Df = function Df(a) {
        var b = {},
            c;for (c in a) {
            a.hasOwnProperty(c) && (b[c] = a[c]);
        }return b;
    },
        Ef = function Ef(a, b) {
        if (!b || !b.length) return !0;if (!a) return !1;for (var c = 0; c < b.length; c++) {
            var d = a[b[c]];if (void 0 === d || null === d || "" === d) return !1;
        }return !0;
    };var Ff = { Hd: { tb: 985, sb: 735, providerId: "facebook.com" }, Id: { tb: 500, sb: 620, providerId: "github.com" }, Jd: { tb: 515, sb: 680, providerId: "google.com" }, Od: { tb: 485, sb: 705, providerId: "twitter.com" } },
        Gf = function Gf(a) {
        for (var b in Ff) {
            if (Ff[b].providerId == a) return Ff[b];
        }return null;
    };var R = function R(a, b) {
        this.code = "auth/" + a;this.message = b || Hf[a] || "";
    };t(R, Error);R.prototype.G = function () {
        return { name: this.code, code: this.code, message: this.message };
    };
    var Hf = {
        "argument-error": "", "app-not-authorized": "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.", "cors-unsupported": "This browser is not supported.", "credential-already-in-use": "This credential is already associated with a different user account.", "custom-token-mismatch": "The custom token corresponds to a different audience.", "requires-recent-login": "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
        "email-already-in-use": "The email address is already in use by another account.", "expired-action-code": "The action code has expired. ", "cancelled-popup-request": "This operation has been cancelled due to another conflicting popup being opened.", "internal-error": "An internal error has occurred.", "invalid-user-token": "The user's credential is no longer valid. The user must sign in again.", "invalid-auth-event": "An internal error has occurred.", "invalid-custom-token": "The custom token format is incorrect. Please check the documentation.",
        "invalid-email": "The email address is badly formatted.", "invalid-api-key": "Your API key is invalid, please check you have copied it correctly.", "invalid-credential": "The supplied auth credential is malformed or has expired.", "invalid-oauth-provider": "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.", "unauthorized-domain": "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
        "invalid-action-code": "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.", "wrong-password": "The password is invalid or the user does not have a password.", "missing-iframe-start": "An internal error has occurred.", "auth-domain-config-required": "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.", "app-deleted": "This instance of FirebaseApp has been deleted.", "account-exists-with-different-credential": "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
        "network-request-failed": "A network error (such as timeout, interrupted connection or unreachable host) has occurred.", "no-auth-event": "An internal error has occurred.", "no-such-provider": "User was not linked to an account with the given provider.", "operation-not-allowed": "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.", "operation-not-supported-in-this-environment": 'This operation is not supported in the environment this application is running on. "location.protocol" must be http or https and web storage must be enabled.',
        "popup-blocked": "Unable to establish a connection with the popup. It may have been blocked by the browser.", "popup-closed-by-user": "The popup has been closed by the user before finalizing the operation.", "provider-already-linked": "User can only be linked to one identity for the given provider.", timeout: "The operation has timed out.", "user-token-expired": "The user's credential is no longer valid. The user must sign in again.", "too-many-requests": "We have blocked all requests from this device due to unusual activity. Try again later.",
        "user-not-found": "There is no user record corresponding to this identifier. The user may have been deleted.", "user-disabled": "The user account has been disabled by an administrator.", "user-mismatch": "The supplied credentials do not correspond to the previously signed in user.", "user-signed-out": "", "weak-password": "The password must be 6 characters long or more.", "web-storage-unsupported": "This browser is not supported."
    };var If = function If(a, b, c, d, e) {
        this.ua = a;this.za = b || null;this.hb = c || null;this.bc = d || null;this.J = e || null;if (this.hb || this.J) {
            if (this.hb && this.J) throw new R("invalid-auth-event");if (this.hb && !this.bc) throw new R("invalid-auth-event");
        } else throw new R("invalid-auth-event");
    };If.prototype.getError = function () {
        return this.J;
    };If.prototype.G = function () {
        return { type: this.ua, eventId: this.za, urlResponse: this.hb, sessionId: this.bc, error: this.J && this.J.G() };
    };var Jf = function Jf(a) {
        var b = "unauthorized-domain",
            c = void 0,
            d = $e(a);a = d.ga;d = d.la;"http" != d && "https" != d ? b = "operation-not-supported-in-this-environment" : c = la("This domain (%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.", a);R.call(this, b, c);
    };t(Jf, R);var Kf = function Kf(a) {
        this.qe = a.sub;ka();this.Db = a.email || null;
    };var Lf = function Lf(a, b, c, d) {
        var e = {};ga(c) ? e = c : b && n(c) && n(d) ? e = { oauthToken: c, oauthTokenSecret: d } : !b && n(c) && (e = { accessToken: c });if (b || !e.idToken && !e.accessToken) {
            if (b && e.oauthToken && e.oauthTokenSecret) Q(this, "accessToken", e.oauthToken), Q(this, "secret", e.oauthTokenSecret);else {
                if (b) throw new R("argument-error", "credential failed: expected 2 arguments (the OAuth access token and secret).");throw new R("argument-error", "credential failed: expected 1 argument (the OAuth access token).");
            }
        } else e.idToken && Q(this, "idToken", e.idToken), e.accessToken && Q(this, "accessToken", e.accessToken);Q(this, "provider", a);
    };Lf.prototype.Gb = function (a) {
        var b = Mf(this);return S(a, Nf, b);
    };Lf.prototype.md = function (a, b) {
        var c = Mf(this);c.idToken = b;return S(a, Of, c);
    };var Mf = function Mf(a) {
        var b = {};a.idToken && (b.id_token = a.idToken);a.accessToken && (b.access_token = a.accessToken);a.secret && (b.oauth_token_secret = a.secret);b.providerId = a.provider;return { postBody: ef(b).toString(), requestUri: vf() ? hf() : "http://localhost" };
    };
    Lf.prototype.G = function () {
        var a = { provider: this.provider };this.idToken && (a.oauthIdToken = this.idToken);this.accessToken && (a.oauthAccessToken = this.accessToken);this.secret && (a.oauthTokenSecret = this.secret);return a;
    };
    var Pf = function Pf(a, b) {
        var c = !!b;b = function b() {
            Cf(this, { providerId: a, isOAuthProvider: !0 });this.Lc = [];"google.com" == a && this.addScope("profile");
        };c || (b.prototype.addScope = function (a) {
            Ia(this.Lc, a) || this.Lc.push(a);
        });b.prototype.Hb = function () {
            return Oa(this.Lc);
        };b.credential = function (b, e) {
            return new Lf(a, c, b, e);
        };Cf(b, { PROVIDER_ID: a });return b;
    },
        Qf = Pf("facebook.com");Qf.prototype.addScope = Qf.prototype.addScope || void 0;var Rf = Pf("github.com");Rf.prototype.addScope = Rf.prototype.addScope || void 0;var Sf = Pf("google.com");
    Sf.prototype.addScope = Sf.prototype.addScope || void 0;Sf.credential = function (a, b) {
        if (!a && !b) throw new R("argument-error", "credential failed: must provide the ID token and/or the access token.");return new Lf("google.com", !1, ga(a) ? a : { idToken: a || null, accessToken: b || null });
    };var Tf = Pf("twitter.com", !0),
        Uf = function Uf(a, b) {
        this.Db = a;this.Dc = b;Q(this, "provider", "password");
    };Uf.prototype.Gb = function (a) {
        return S(a, Vf, { email: this.Db, password: this.Dc });
    };
    Uf.prototype.md = function (a, b) {
        return S(a, Wf, { idToken: b, email: this.Db, password: this.Dc });
    };Uf.prototype.G = function () {
        return { email: this.Db, password: this.Dc };
    };var Xf = function Xf() {
        Cf(this, { providerId: "password", isOAuthProvider: !1 });
    };Cf(Xf, { PROVIDER_ID: "password" });
    var Yf = { Me: Xf, Hd: Qf, Jd: Sf, Id: Rf, Od: Tf },
        Zf = function Zf(a) {
        var b = a && a.providerId;if (!b) return null;var c = a && a.oauthAccessToken,
            d = a && a.oauthTokenSecret;a = a && a.oauthIdToken;for (var e in Yf) {
            if (Yf[e].PROVIDER_ID == b) try {
                return Yf[e].credential({ accessToken: c, idToken: a, oauthToken: c, oauthTokenSecret: d });
            } catch (f) {
                break;
            }
        }return null;
    };var $f = function $f(a, b, c) {
        R.call(this, "account-exists-with-different-credential", c);Q(this, "email", a);Q(this, "credential", b);
    };t($f, R);$f.prototype.G = function () {
        var a = { code: this.code, message: this.message, email: this.email },
            b = this.credential && this.credential.G();b && (Xa(a, b), a.providerId = b.provider, delete a.provider);return a;
    };var ag = function ag(a) {
        this.Le = a;
    };t(ag, tc);ag.prototype.Cb = function () {
        return new this.Le();
    };ag.prototype.xc = function () {
        return {};
    };
    var T = function T(a, b, c) {
        var d;d = "Node" == qf();d = l.XMLHttpRequest || d && firebase.INTERNAL.node && firebase.INTERNAL.node.XMLHttpRequest;if (!d) throw new R("internal-error", "The XMLHttpRequest compatibility library was not found.");this.v = a;a = b || {};this.Ae = a.secureTokenEndpoint || "https://securetoken.googleapis.com/v1/token";this.Be = a.secureTokenTimeout || 1E4;this.wd = Va(a.secureTokenHeaders || bg);this.$d = a.firebaseEndpoint || "https://www.googleapis.com/identitytoolkit/v3/relyingparty/";this.ae = a.firebaseTimeout || 1E4;this.cd = Va(a.firebaseHeaders || cg);c && (this.cd["X-Client-Version"] = c, this.wd["X-Client-Version"] = c);this.Sd = new yc();this.Ke = new ag(d);
    },
        dg,
        bg = { "Content-Type": "application/x-www-form-urlencoded" },
        cg = { "Content-Type": "application/json" },
        fg = function fg(a, b, c, d, e, f, g) {
        lf() ? a = _r(a.De, a) : (dg || (dg = new I(function (a, b) {
            eg(a, b);
        })), a = _r(a.Ce, a));a(b, c, d, e, f, g);
    };
    T.prototype.De = function (a, b, c, d, e, f) {
        var g = "Node" == qf(),
            k = rf() ? g ? new M(this.Ke) : new M() : new M(this.Sd),
            q;f && (k.fb = Math.max(0, f), q = setTimeout(function () {
            k.dispatchEvent("timeout");
        }, f));k.listen("complete", function () {
            q && clearTimeout(q);var a = null;try {
                var c;c = this.a ? mc(this.a.responseText) : void 0;a = c || null;
            } catch (d) {
                try {
                    a = JSON.parse(Me(this)) || null;
                } catch (e) {
                    a = null;
                }
            }b && b(a);
        });fc(k, "ready", function () {
            q && clearTimeout(q);this.ya || (this.ya = !0, this.Oa());
        });fc(k, "timeout", function () {
            q && clearTimeout(q);this.ya || (this.ya = !0, this.Oa());b && b(null);
        });k.send(a, c, d, e);
    };var Od = "__fcb" + Math.floor(1E6 * Math.random()).toString(),
        eg = function eg(a, b) {
        ((window.gapi || {}).client || {}).request ? a() : (l[Od] = function () {
            ((window.gapi || {}).client || {}).request ? a() : b(Error("CORS_UNSUPPORTED"));
        }, Qd(function () {
            b(Error("CORS_UNSUPPORTED"));
        }));
    };
    T.prototype.Ce = function (a, b, c, d, e) {
        var f = this;dg.then(function () {
            window.gapi.client.setApiKey(f.v);var g = window.gapi.auth.getToken();window.gapi.auth.setToken(null);window.gapi.client.request({ path: a, method: c, body: d, headers: e, authType: "none", callback: function callback(a) {
                    window.gapi.auth.setToken(g);b && b(a);
                } });
        }).l(function (a) {
            b && b({ error: { message: a && a.message || "CORS_UNSUPPORTED" } });
        });
    };
    var hg = function hg(a, b) {
        return new I(function (c, d) {
            "refresh_token" == b.grant_type && b.refresh_token || "authorization_code" == b.grant_type && b.code ? fg(a, a.Ae + "?key=" + encodeURIComponent(a.v), function (a) {
                a ? a.error ? d(gg(a)) : a.access_token && a.refresh_token ? c(a) : d(new R("internal-error")) : d(new R("network-request-failed"));
            }, "POST", ef(b).toString(), a.wd, a.Be) : d(new R("internal-error"));
        });
    },
        ig = function ig(a) {
        var b = {},
            c;for (c in a) {
            null !== a[c] && void 0 !== a[c] && (b[c] = a[c]);
        }return pc(b);
    },
        jg = function jg(a, b, c, d, e) {
        var f = a.$d + b + "?key=" + encodeURIComponent(a.v);e && (f += "&cb=" + ka().toString());return new I(function (b, e) {
            fg(a, f, function (a) {
                a ? a.error ? e(gg(a)) : b(a) : e(new R("network-request-failed"));
            }, c, ig(d), a.cd, a.ae);
        });
    },
        kg = function kg(a) {
        if (!lc.test(a.email)) throw new R("invalid-email");
    },
        lg = function lg(a) {
        "email" in a && kg(a);
    },
        ng = function ng(a, b) {
        var c = vf() ? hf() : "http://localhost";return S(a, mg, { identifier: b, continueUri: c }).then(function (a) {
            return a.allProviders || [];
        });
    },
        pg = function pg(a) {
        return S(a, og, {}).then(function (a) {
            return a.authorizedDomains || [];
        });
    },
        qg = function qg(a) {
        if (!a.idToken) throw new R("internal-error");
    };T.prototype.signInAnonymously = function () {
        return S(this, rg, {});
    };T.prototype.updateEmail = function (a, b) {
        return S(this, sg, { idToken: a, email: b });
    };T.prototype.updatePassword = function (a, b) {
        return S(this, Wf, { idToken: a, password: b });
    };var tg = { displayName: "DISPLAY_NAME", photoUrl: "PHOTO_URL" };
    T.prototype.updateProfile = function (a, b) {
        var c = { idToken: a },
            d = [];Qa(tg, function (a, f) {
            var g = b[f];null === g ? d.push(a) : f in b && (c[f] = g);
        });d.length && (c.deleteAttribute = d);return S(this, sg, c);
    };T.prototype.sendPasswordResetEmail = function (a) {
        return S(this, ug, { requestType: "PASSWORD_RESET", email: a });
    };T.prototype.sendEmailVerification = function (a) {
        return S(this, vg, { requestType: "VERIFY_EMAIL", idToken: a });
    };
    var xg = function xg(a, b, c) {
        return S(a, wg, { idToken: b, deleteProvider: c });
    },
        yg = function yg(a) {
        if (!a.requestUri || !a.sessionId && !a.postBody) throw new R("internal-error");
    },
        zg = function zg(a) {
        if (a.needConfirmation) throw (a && a.email ? new $f(a.email, Zf(a), a.message) : null) || new R("account-exists-with-different-credential");if (!a.idToken) throw new R("internal-error");
    },
        Ag = function Ag(a) {
        if (!a.oobCode) throw new R("invalid-action-code");
    };T.prototype.confirmPasswordReset = function (a, b) {
        return S(this, Bg, { oobCode: a, newPassword: b });
    };
    T.prototype.checkActionCode = function (a) {
        return S(this, Cg, { oobCode: a });
    };T.prototype.applyActionCode = function (a) {
        return S(this, Dg, { oobCode: a });
    };
    var Dg = { endpoint: "setAccountInfo", D: Ag, cb: "email" },
        Cg = { endpoint: "resetPassword", D: Ag, sa: function sa(a) {
            if (!lc.test(a.email)) throw new R("internal-error");
        } },
        Eg = { endpoint: "signupNewUser", D: function D(a) {
            kg(a);if (!a.password) throw new R("weak-password");
        }, sa: qg, ta: !0 },
        mg = { endpoint: "createAuthUri" },
        Fg = { endpoint: "deleteAccount", ab: ["idToken"] },
        wg = { endpoint: "setAccountInfo", ab: ["idToken", "deleteProvider"], D: function D(a) {
            if (!da(a.deleteProvider)) throw new R("internal-error");
        } },
        Gg = { endpoint: "getAccountInfo" },
        vg = { endpoint: "getOobConfirmationCode", ab: ["idToken", "requestType"], D: function D(a) {
            if ("VERIFY_EMAIL" != a.requestType) throw new R("internal-error");
        }, cb: "email" },
        ug = { endpoint: "getOobConfirmationCode", ab: ["requestType"], D: function D(a) {
            if ("PASSWORD_RESET" != a.requestType) throw new R("internal-error");kg(a);
        }, cb: "email" },
        og = { Rd: !0, endpoint: "getProjectConfig", je: "GET" },
        Bg = { endpoint: "resetPassword", D: Ag, cb: "email" },
        sg = { endpoint: "setAccountInfo", ab: ["idToken"], D: lg, ta: !0 },
        Wf = {
        endpoint: "setAccountInfo", ab: ["idToken"],
        D: function D(a) {
            lg(a);if (!a.password) throw new R("weak-password");
        }, sa: qg, ta: !0
    },
        rg = { endpoint: "signupNewUser", sa: qg, ta: !0 },
        Nf = { endpoint: "verifyAssertion", D: yg, sa: zg, ta: !0 },
        Of = { endpoint: "verifyAssertion", D: function D(a) {
            yg(a);if (!a.idToken) throw new R("internal-error");
        }, sa: zg, ta: !0 },
        Hg = { endpoint: "verifyCustomToken", D: function D(a) {
            if (!a.token) throw new R("invalid-custom-token");
        }, sa: qg, ta: !0 },
        Vf = { endpoint: "verifyPassword", D: function D(a) {
            kg(a);if (!a.password) throw new R("wrong-password");
        }, sa: qg, ta: !0 },
        S = function S(a, b, c) {
        if (!Ef(c, b.ab)) return K(new R("internal-error"));var d = b.je || "POST",
            e;return J(c).then(b.D).then(function () {
            b.ta && (c.returnSecureToken = !0);return jg(a, b.endpoint, d, c, b.Rd || !1);
        }).then(function (a) {
            return e = a;
        }).then(b.sa).then(function () {
            if (!b.cb) return e;if (!(b.cb in e)) throw new R("internal-error");return e[b.cb];
        });
    },
        gg = function gg(a) {
        var b, c;c = (a.error && a.error.errors && a.error.errors[0] || {}).reason || "";var d = { keyInvalid: "invalid-api-key", ipRefererBlocked: "app-not-authorized" };if (c = d[c] ? new R(d[c]) : null) return c;c = a.error && a.error.message || "";d = {
            INVALID_CUSTOM_TOKEN: "invalid-custom-token", CREDENTIAL_MISMATCH: "custom-token-mismatch", MISSING_CUSTOM_TOKEN: "internal-error", INVALID_IDENTIFIER: "invalid-email", MISSING_CONTINUE_URI: "internal-error", INVALID_EMAIL: "invalid-email", INVALID_PASSWORD: "wrong-password", USER_DISABLED: "user-disabled", MISSING_PASSWORD: "internal-error", EMAIL_EXISTS: "email-already-in-use", PASSWORD_LOGIN_DISABLED: "operation-not-allowed", INVALID_IDP_RESPONSE: "invalid-credential",
            FEDERATED_USER_ID_ALREADY_LINKED: "credential-already-in-use", EMAIL_NOT_FOUND: "user-not-found", EXPIRED_OOB_CODE: "expired-action-code", INVALID_OOB_CODE: "invalid-action-code", MISSING_OOB_CODE: "internal-error", CREDENTIAL_TOO_OLD_LOGIN_AGAIN: "requires-recent-login", INVALID_ID_TOKEN: "invalid-user-token", TOKEN_EXPIRED: "user-token-expired", USER_NOT_FOUND: "user-token-expired", CORS_UNSUPPORTED: "cors-unsupported", TOO_MANY_ATTEMPTS_TRY_LATER: "too-many-requests", WEAK_PASSWORD: "weak-password", OPERATION_NOT_ALLOWED: "operation-not-allowed"
        };
        b = (b = c.match(/:\s*(.*)$/)) && 1 < b.length ? b[1] : void 0;for (var e in d) {
            if (0 === c.indexOf(e)) return new R(d[e], b);
        }!b && a && (b = xf(a));return new R("internal-error", b);
    };var Ig = function Ig(a) {
        this.R = a;
    };Ig.prototype.value = function () {
        return this.R;
    };Ig.prototype.zd = function (a) {
        this.R.style = a;return this;
    };var Jg = function Jg(a) {
        this.R = a || {};
    };Jg.prototype.value = function () {
        return this.R;
    };Jg.prototype.zd = function (a) {
        this.R.style = a;return this;
    };var Lg = function Lg(a) {
        this.Je = a;this.vc = null;this.od = Kg(this);
    };Lg.prototype.Bc = function () {
        return this.od;
    };
    var Mg = function Mg(a) {
        var b = new Jg();b.R.where = document.body;b.R.url = a.Je;b.R.messageHandlersFilter = tf("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER");b.R.attributes = b.R.attributes || {};new Ig(b.R.attributes).zd({ position: "absolute", top: "-100px", width: "1px", height: "1px" });b.R.dontclear = !0;return b;
    },
        Kg = function Kg(a) {
        return Ng().then(function () {
            return new I(function (b, c) {
                tf("gapi.iframes.getContext")().open(Mg(a).value(), function (d) {
                    a.vc = d;a.vc.restyle({ setHideOnLeave: !1 });var e = setTimeout(function () {
                        c(Error("Network Error"));
                    }, 5E3),
                        f = function f() {
                        clearTimeout(e);b();
                    };d.ping(f).then(f, function () {
                        c(Error("Network Error"));
                    });
                });
            });
        });
    },
        Og = function Og(a, b) {
        a.od.then(function () {
            a.vc.register("authEvent", b, tf("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"));
        });
    },
        Pg = "__iframefcb" + Math.floor(1E6 * Math.random()).toString(),
        Ng = function Ng() {
        return new I(function (a, b) {
            var c = function c() {
                zf();tf("gapi.load")("gapi.iframes", { callback: a, ontimeout: function ontimeout() {
                        zf();b(Error("Network Error"));
                    }, timeout: 3E3 });
            };tf("gapi.iframes.Iframe") ? a() : tf("gapi.load") ? c() : (l[Pg] = function () {
                tf("gapi.load") ? c() : b(Error("Network Error"));
            }, J(Nd("https://apis.google.com/js/api.js?onload=" + Pg)).l(function () {
                b(Error("Network Error"));
            }));
        });
    };var Rg = function Rg(a, b, c, d) {
        this.X = a;this.v = b;this.ea = c;d = this.xa = d || null;a = af(a, "/__/auth/iframe");P(a, "apiKey", b);P(a, "appName", c);d && P(a, "v", d);this.ke = a.toString();this.hd = new Lg(this.ke);this.yb = [];Qg(this);
    };Rg.prototype.Bc = function () {
        return this.hd.Bc();
    };
    var Sg = function Sg(a, b, c, d, e, f, g, k, q) {
        a = af(a, "/__/auth/handler");P(a, "apiKey", b);P(a, "appName", c);P(a, "authType", d);P(a, "providerId", e);f && f.length && P(a, "scopes", f.join(","));g && P(a, "redirectUrl", g);k && P(a, "eventId", k);q && P(a, "v", q);return a.toString();
    },
        Qg = function Qg(a) {
        Og(a.hd, function (b) {
            var c = {};if (b && b.authEvent) {
                var d = !1;b = b.authEvent || {};if (b.type) {
                    if (c = b.error) var e = (c = b.error) && (c.name || c.code),
                        c = e ? new R(e.substring(5), c.message) : null;b = new If(b.type, b.eventId, b.urlResponse, b.sessionId, c);
                } else b = null;for (c = 0; c < a.yb.length; c++) {
                    d = a.yb[c](b) || d;
                }c = {};c.status = d ? "ACK" : "ERROR";return J(c);
            }c.status = "ERROR";return J(c);
        });
    },
        Tg = function Tg(a, b) {
        La(a.yb, function (a) {
            return a == b;
        });
    };var Ug = function Ug(a) {
        this.u = a || firebase.INTERNAL.reactNative && firebase.INTERNAL.reactNative.AsyncStorage;if (!this.u) throw new R("internal-error", "The React Native compatibility library was not found.");
    };h = Ug.prototype;h.get = function (a) {
        return J(this.u.getItem(a)).then(function (a) {
            return a && yf(a);
        });
    };h.set = function (a, b) {
        return J(this.u.setItem(a, xf(b)));
    };h.remove = function (a) {
        return J(this.u.removeItem(a));
    };h.Ka = function () {};h.Za = function () {};var Vg = function Vg() {
        this.u = {};
    };h = Vg.prototype;h.get = function (a) {
        return J(this.u[a]);
    };h.set = function (a, b) {
        this.u[a] = b;return J();
    };h.remove = function (a) {
        delete this.u[a];return J();
    };h.Ka = function () {};h.Za = function () {};var Xg = function Xg() {
        if (!Wg()) {
            if ("Node" == qf()) throw new R("internal-error", "The LocalStorage compatibility library was not found.");throw new R("web-storage-unsupported");
        }this.u = l.localStorage || firebase.INTERNAL.node.localStorage;
    },
        Wg = function Wg() {
        var a = "Node" == qf(),
            a = l.localStorage || a && firebase.INTERNAL.node && firebase.INTERNAL.node.localStorage;if (!a) return !1;try {
            return a.setItem("__sak", "1"), a.removeItem("__sak"), !0;
        } catch (b) {
            return !1;
        }
    };h = Xg.prototype;
    h.get = function (a) {
        var b = this;return J().then(function () {
            var c = b.u.getItem(a);return yf(c);
        });
    };h.set = function (a, b) {
        var c = this;return J().then(function () {
            var d = xf(b);null === d ? c.remove(a) : c.u.setItem(a, d);
        });
    };h.remove = function (a) {
        var b = this;return J().then(function () {
            b.u.removeItem(a);
        });
    };h.Ka = function (a) {
        l.window && Yb(l.window, "storage", a);
    };h.Za = function (a) {
        l.window && gc(l.window, "storage", a);
    };var Yg = function Yg() {
        this.u = {};
    };h = Yg.prototype;h.get = function () {
        return J(null);
    };h.set = function () {
        return J();
    };h.remove = function () {
        return J();
    };h.Ka = function () {};h.Za = function () {};var $g = function $g() {
        if (!Zg()) {
            if ("Node" == qf()) throw new R("internal-error", "The SessionStorage compatibility library was not found.");throw new R("web-storage-unsupported");
        }this.u = l.sessionStorage || firebase.INTERNAL.node.sessionStorage;
    },
        Zg = function Zg() {
        var a = "Node" == qf(),
            a = l.sessionStorage || a && firebase.INTERNAL.node && firebase.INTERNAL.node.sessionStorage;if (!a) return !1;try {
            return a.setItem("__sak", "1"), a.removeItem("__sak"), !0;
        } catch (b) {
            return !1;
        }
    };h = $g.prototype;
    h.get = function (a) {
        var b = this;return J().then(function () {
            var c = b.u.getItem(a);return yf(c);
        });
    };h.set = function (a, b) {
        var c = this;return J().then(function () {
            var d = xf(b);null === d ? c.remove(a) : c.u.setItem(a, d);
        });
    };h.remove = function (a) {
        var b = this;return J().then(function () {
            b.u.removeItem(a);
        });
    };h.Ka = function () {};h.Za = function () {};var ah = function ah(a, b, c, d, e, f) {
        if (!window.indexedDB) throw new R("web-storage-unsupported");this.Ud = a;this.Ac = b;this.pc = c;this.Fd = d;this.ma = e;this.O = {};this.ub = [];this.rb = 0;this.le = f || l.indexedDB;
    },
        bh,
        ch = function ch(a) {
        return new I(function (b, c) {
            var d = a.le.open(a.Ud, a.ma);d.onerror = function (a) {
                c(Error(a.target.errorCode));
            };d.onupgradeneeded = function (b) {
                b = b.target.result;try {
                    b.createObjectStore(a.Ac, { keyPath: a.pc });
                } catch (d) {
                    c(d);
                }
            };d.onsuccess = function (a) {
                b(a.target.result);
            };
        });
    },
        dh = function dh(a) {
        a.jd || (a.jd = ch(a));return a.jd;
    },
        eh = function eh(a, b) {
        return b.objectStore(a.Ac);
    },
        fh = function fh(a, b, c) {
        return b.transaction([a.Ac], c ? "readwrite" : "readonly");
    },
        gh = function gh(a) {
        return new I(function (b, c) {
            a.onsuccess = function (a) {
                a && a.target ? b(a.target.result) : b();
            };a.onerror = function (a) {
                c(Error(a.target.errorCode));
            };
        });
    };h = ah.prototype;
    h.set = function (a, b) {
        var c = !1,
            d,
            e = this;return wd(dh(this).then(function (b) {
            d = b;b = eh(e, fh(e, d, !0));return gh(b.get(a));
        }).then(function (f) {
            var g = eh(e, fh(e, d, !0));if (f) return f.value = b, gh(g.put(f));e.rb++;c = !0;f = {};f[e.pc] = a;f[e.Fd] = b;return gh(g.add(f));
        }).then(function () {
            e.O[a] = b;
        }), function () {
            c && e.rb--;
        });
    };h.get = function (a) {
        var b = this;return dh(this).then(function (c) {
            return gh(eh(b, fh(b, c, !1)).get(a));
        }).then(function (a) {
            return a && a.value;
        });
    };
    h.remove = function (a) {
        var b = !1,
            c = this;return wd(dh(this).then(function (d) {
            b = !0;c.rb++;return gh(eh(c, fh(c, d, !0))["delete"](a));
        }).then(function () {
            delete c.O[a];
        }), function () {
            b && c.rb--;
        });
    };
    h.Fe = function () {
        var a = this;return dh(this).then(function (b) {
            var c = eh(a, fh(a, b, !1));return c.getAll ? gh(c.getAll()) : new I(function (a, b) {
                var f = [],
                    g = c.openCursor();g.onsuccess = function (b) {
                    (b = b.target.result) ? (f.push(b.value), b["continue"]()) : a(f);
                };g.onerror = function (a) {
                    b(Error(a.target.errorCode));
                };
            });
        }).then(function (b) {
            var c = {},
                d = [];if (0 == a.rb) {
                for (d = 0; d < b.length; d++) {
                    c[b[d][a.pc]] = b[d][a.Fd];
                }d = jf(a.O, c);a.O = c;
            }return d;
        });
    };h.Ka = function (a) {
        0 == this.ub.length && this.Oc();this.ub.push(a);
    };
    h.Za = function (a) {
        La(this.ub, function (b) {
            return b == a;
        });0 == this.ub.length && this.dc();
    };h.Oc = function () {
        var a = this;this.dc();var b = function b() {
            a.Fc = we(800).then(_r(a.Fe, a)).then(function (b) {
                0 < b.length && x(a.ub, function (a) {
                    a(b);
                });
            }).then(b).l(function (a) {
                "STOP_EVENT" != a.message && b();
            });return a.Fc;
        };b();
    };h.dc = function () {
        this.Fc && this.Fc.cancel("STOP_EVENT");
    };var kh = function kh() {
        this.$c = { Browser: hh, Node: ih, ReactNative: jh }[qf()];
    },
        lh,
        hh = { V: Xg, Qc: $g },
        ih = { V: Xg, Qc: $g },
        jh = { V: Ug, Qc: Yg };var mh = "First Second Third Fourth Fifth Sixth Seventh Eighth Ninth".split(" "),
        U = function U(a, b) {
        return { name: a || "", ca: "a valid string", optional: !!b, da: n };
    },
        nh = function nh(a) {
        return { name: a || "", ca: "a valid object", optional: !1, da: ga };
    },
        oh = function oh(a, b) {
        return { name: a || "", ca: "a function", optional: !!b, da: p };
    },
        ph = function ph() {
        return { name: "", ca: "null", optional: !1, da: ca };
    },
        qh = function qh() {
        return { name: "credential", ca: "a valid credential", optional: !1, da: function da(a) {
                return !(!a || !a.Gb);
            } };
    },
        rh = function rh() {
        return {
            name: "authProvider",
            ca: "a valid Auth provider", optional: !1, da: function da(a) {
                return !!(a && a.providerId && a.hasOwnProperty && a.hasOwnProperty("isOAuthProvider"));
            }
        };
    },
        sh = function sh(a, b, c, d) {
        return { name: c || "", ca: a.ca + " or " + b.ca, optional: !!d, da: function da(c) {
                return a.da(c) || b.da(c);
            } };
    };var uh = function uh(a, b) {
        for (var c in b) {
            var d = b[c].name;a[d] = th(d, a[c], b[c].b);
        }
    },
        V = function V(a, b, c, d) {
        a[b] = th(b, c, d);
    },
        th = function th(a, b, c) {
        if (!c) return b;var d = vh(a);a = function a() {
            var a = Array.prototype.slice.call(arguments),
                e;a: {
                e = Array.prototype.slice.call(a);var k;k = 0;for (var q = !1, ra = 0; ra < c.length; ra++) {
                    if (c[ra].optional) q = !0;else {
                        if (q) throw new R("internal-error", "Argument validator encountered a required argument after an optional argument.");k++;
                    }
                }q = c.length;if (e.length < k || q < e.length) e = "Expected " + (k == q ? 1 == k ? "1 argument" : k + " arguments" : k + "-" + q + " arguments") + " but got " + e.length + ".";else {
                    for (k = 0; k < e.length; k++) {
                        if (q = c[k].optional && void 0 === e[k], !c[k].da(e[k]) && !q) {
                            e = c[k];if (0 > k || k >= mh.length) throw new R("internal-error", "Argument validator received an unsupported number of arguments.");e = mh[k] + " argument " + (e.name ? '"' + e.name + '" ' : "") + "must be " + e.ca + ".";break a;
                        }
                    }e = null;
                }
            }if (e) throw new R("argument-error", d + " failed: " + e);return b.apply(this, a);
        };for (var e in b) {
            a[e] = b[e];
        }for (e in b.prototype) {
            a.prototype[e] = b.prototype[e];
        }return a;
    },
        vh = function vh(a) {
        a = a.split(".");return a[a.length - 1];
    };var wh = function wh(a, b, c, d) {
        this.te = a;this.xd = b;this.ze = c;this.eb = d;this.N = {};lh || (lh = new kh());a = lh;try {
            var e;gf() ? (bh || (bh = new ah("firebaseLocalStorageDb", "firebaseLocalStorage", "fbase_key", "value", 1)), e = bh) : e = new a.$c.V();this.Ta = e;
        } catch (f) {
            this.Ta = new Vg(), this.eb = !0;
        }try {
            this.fc = new a.$c.Qc();
        } catch (f) {
            this.fc = new Vg();
        }this.Ad = _r(this.Bd, this);this.O = {};
    },
        xh,
        yh = function yh() {
        xh || (xh = new wh("firebase", ":", "Safari" == kf(ff()) && l.window && l.window != l.window.top ? !0 : !1, wf()));return xh;
    };h = wh.prototype;
    h.K = function (a, b) {
        return this.te + this.xd + a.name + (b ? this.xd + b : "");
    };h.get = function (a, b) {
        return (a.V ? this.Ta : this.fc).get(this.K(a, b));
    };h.remove = function (a, b) {
        b = this.K(a, b);a.V && !this.eb && (this.O[b] = null);return (a.V ? this.Ta : this.fc).remove(b);
    };h.set = function (a, b, c) {
        var d = this.K(a, c),
            e = this,
            f = a.V ? this.Ta : this.fc;return f.set(d, b).then(function () {
            return f.get(d);
        }).then(function (b) {
            a.V && !this.eb && (e.O[d] = b);
        });
    };
    h.addListener = function (a, b, c) {
        a = this.K(a, b);this.eb || (this.O[a] = l.localStorage.getItem(a));Ta(this.N) && this.Oc();this.N[a] || (this.N[a] = []);this.N[a].push(c);
    };h.removeListener = function (a, b, c) {
        a = this.K(a, b);this.N[a] && (La(this.N[a], function (a) {
            return a == c;
        }), 0 == this.N[a].length && delete this.N[a]);Ta(this.N) && this.dc();
    };h.Oc = function () {
        this.Ta.Ka(this.Ad);this.eb || zh(this);
    };
    var zh = function zh(a) {
        Ah(a);a.zc = setInterval(function () {
            for (var b in a.N) {
                var c = l.localStorage.getItem(b);c != a.O[b] && (a.O[b] = c, c = new Nb({ type: "storage", key: b, target: window, oldValue: a.O[b], newValue: c }), a.Bd(c));
            }
        }, 1E3);
    },
        Ah = function Ah(a) {
        a.zc && (clearInterval(a.zc), a.zc = null);
    };wh.prototype.dc = function () {
        this.Ta.Za(this.Ad);this.eb || Ah(this);
    };
    wh.prototype.Bd = function (a) {
        if (a && a.ce) {
            var b = a.kb.key;if (this.ze) {
                var c = l.localStorage.getItem(b);a = a.kb.newValue;a != c && (a ? l.localStorage.setItem(b, a) : a || l.localStorage.removeItem(b));
            }this.O[b] = l.localStorage.getItem(b);this.Vc(b);
        } else x(a, _r(this.Vc, this));
    };wh.prototype.Vc = function (a) {
        this.N[a] && x(this.N[a], function (a) {
            a();
        });
    };var Bh = function Bh(a) {
        this.B = a;this.A = yh();
    },
        Ch = { name: "pendingRedirect", V: !1 },
        Dh = function Dh(a) {
        return a.A.set(Ch, "pending", a.B);
    },
        Eh = function Eh(a) {
        return a.A.remove(Ch, a.B);
    },
        Fh = function Fh(a) {
        return a.A.get(Ch, a.B).then(function (a) {
            return "pending" == a;
        });
    };var Ih = function Ih(a, b, c) {
        var d = this,
            e = (this.xa = firebase.SDK_VERSION || null) ? sf(this.xa) : null;this.f = new T(b, null, e);this.pa = null;this.X = a;this.v = b;this.ea = c;this.vb = [];this.Pb = !1;this.Rc = _r(this.de, this);this.Wa = new Gh(this);this.rd = new Hh(this);this.Ec = new Bh(this.v + ":" + this.ea);this.gb = {};this.gb.unknown = this.Wa;this.gb.signInViaRedirect = this.Wa;this.gb.linkViaRedirect = this.Wa;this.gb.signInViaPopup = this.rd;this.gb.linkViaPopup = this.rd;this.Zb = this.bb = null;this.Tb = new I(function (a, b) {
            d.bb = a;d.Zb = b;
        });
    };
    Ih.prototype.reset = function () {
        var a = this;this.pa = null;this.Tb.cancel();this.Pb = !1;this.Zb = this.bb = null;this.Mb && Tg(this.Mb, this.Rc);this.Tb = new I(function (b, c) {
            a.bb = b;a.Zb = c;
        });
    };
    var Jh = function Jh(a) {
        var b = hf();return pg(a).then(function (a) {
            a: {
                for (var d = $e(b).ga, e = 0; e < a.length; e++) {
                    var f;var g = a[e];f = d;var k = Qc(g);k ? f = (f = Qc(f)) ? k.Eb(f) : !1 : (k = g.split(".").join("\\."), f = new RegExp("^(.+\\." + k + "|" + k + ")$", "i").test(f));if (f) {
                        a = !0;break a;
                    }
                }a = !1;
            }if (!a) throw new Jf(hf());
        });
    },
        Kh = function Kh(a) {
        a.Pb || (a.Pb = !0, pf().then(function () {
            a.Mb = new Rg(a.X, a.v, a.ea, a.xa);a.Mb.Bc().l(function () {
                a.Zb(new R("network-request-failed"));a.reset();
            });a.Mb.yb.push(a.Rc);
        }));return a.Tb;
    };
    Ih.prototype.subscribe = function (a) {
        Ia(this.vb, a) || this.vb.push(a);if (!this.Pb) {
            var b = this,
                c = function c() {
                var a = ff(),
                    c;(c = wf(a)) || (a = a || ff(), c = "Safari" == kf(a) || a.toLowerCase().match(/iphone|ipad|ipod/) ? !1 : !0);c ? Lh(b.Wa) : Kh(b);
            };Fh(this.Ec).then(function (a) {
                a ? Eh(b.Ec).then(function () {
                    Kh(b);
                }) : c();
            }).l(function () {
                c();
            });
        }
    };Ih.prototype.unsubscribe = function (a) {
        La(this.vb, function (b) {
            return b == a;
        });
    };
    Ih.prototype.de = function (a) {
        if (!a) throw new R("invalid-auth-event");this.bb && (this.bb(), this.bb = null);for (var b = !1, c = 0; c < this.vb.length; c++) {
            var d = this.vb[c];if (d.Wc(a.ua, a.za)) {
                (b = this.gb[a.ua]) && b.sd(a, d);b = !0;break;
            }
        }Lh(this.Wa);return b;
    };Ih.prototype.getRedirectResult = function () {
        return this.Wa.getRedirectResult();
    };
    var Nh = function Nh(a, b, c, d, e, f) {
        if (!b) return K(new R("popup-blocked"));if (f) return Kh(a), J();a.pa || (a.pa = Jh(a.f));return a.pa.then(function () {
            return Kh(a);
        }).then(function () {
            Mh(d);var f = Sg(a.X, a.v, a.ea, c, d.providerId, d.Hb(), null, e, a.xa);Ib((b || l.window).location, f);
        }).l(function (b) {
            "auth/network-request-failed" == b.code && (a.pa = null);throw b;
        });
    },
        Oh = function Oh(a, b, c, d) {
        a.pa || (a.pa = Jh(a.f));return a.pa.then(function () {
            Mh(c);var e = Sg(a.X, a.v, a.ea, b, c.providerId, c.Hb(), hf(), d, a.xa);Dh(a.Ec).then(function () {
                Ib(l.window.location, e);
            });
        });
    },
        Ph = function Ph(a, b, c, d, e) {
        var f = new R("popup-closed-by-user");return a.Tb.l(function () {}).then(function () {
            return of(d);
        }).then(function () {
            return we(2E3).then(function () {
                b.Ha(c, null, f, e);
            });
        });
    },
        Mh = function Mh(a) {
        if (!a.isOAuthProvider) throw new R("invalid-oauth-provider");
    },
        Qh = {},
        Rh = function Rh(a, b, c) {
        var d = b + ":" + c;Qh[d] || (Qh[d] = new Ih(a, b, c));return Qh[d];
    },
        Gh = function Gh(a) {
        this.A = a;this.Jc = this.Yb = this.Xa = this.W = null;this.Ic = !1;
    };
    Gh.prototype.sd = function (a, b) {
        if (!a) return K(new R("invalid-auth-event"));this.Ic = !0;var c = a.ua,
            d = a.za;"unknown" == c ? (this.W || Sh(this, !1, null, null), a = J()) : a = a.J ? this.Gc(a, b) : b.lb(c, d) ? this.Hc(a, b) : K(new R("invalid-auth-event"));return a;
    };var Lh = function Lh(a) {
        a.Ic || (a.Ic = !0, Sh(a, !1, null, null));
    };Gh.prototype.Gc = function (a) {
        this.W || Sh(this, !0, null, a.getError());return J();
    };
    Gh.prototype.Hc = function (a, b) {
        var c = this,
            d = a.ua;b = b.lb(d, a.za);var e = a.hb;a = a.bc;var f = "signInViaRedirect" == d || "linkViaRedirect" == d;return this.W ? J() : b(e, a).then(function (a) {
            c.W || Sh(c, f, a, null);
        }).l(function (a) {
            c.W || Sh(c, f, null, a);
        });
    };var Sh = function Sh(a, b, c, d) {
        b ? d ? (a.W = function () {
            return K(d);
        }, a.Yb && a.Yb(d)) : (a.W = function () {
            return J(c);
        }, a.Xa && a.Xa(c)) : (a.W = function () {
            return J({ user: null });
        }, a.Xa && a.Xa({ user: null }));a.Xa = null;a.Yb = null;
    };
    Gh.prototype.getRedirectResult = function () {
        var a = this;this.Uc || (this.Uc = new I(function (b, c) {
            a.W ? a.W().then(b, c) : (a.Xa = b, a.Yb = c, Th(a));
        }));return this.Uc;
    };var Th = function Th(a) {
        var b = new R("timeout");a.Jc && a.Jc.cancel();a.Jc = we(1E4).then(function () {
            a.W || Sh(a, !0, null, b);
        });
    },
        Hh = function Hh(a) {
        this.A = a;
    };Hh.prototype.sd = function (a, b) {
        if (!a) return K(new R("invalid-auth-event"));var c = a.ua,
            d = a.za;return a.J ? this.Gc(a, b) : b.lb(c, d) ? this.Hc(a, b) : K(new R("invalid-auth-event"));
    };
    Hh.prototype.Gc = function (a, b) {
        b.Ha(a.ua, null, a.getError(), a.za);return J();
    };Hh.prototype.Hc = function (a, b) {
        var c = a.za,
            d = a.ua;return b.lb(d, c)(a.hb, a.bc).then(function (a) {
            b.Ha(d, a, null, c);
        }).l(function (a) {
            b.Ha(d, null, a, c);
        });
    };var Uh = function Uh(a) {
        this.f = a;this.wa = this.S = null;this.Pa = 0;
    };Uh.prototype.G = function () {
        return { apiKey: this.f.v, refreshToken: this.S, accessToken: this.wa, expirationTime: this.Pa };
    };
    var Wh = function Wh(a, b) {
        var c = b.idToken,
            d = b.refreshToken;b = Vh(b.expiresIn);a.wa = c;a.Pa = b;a.S = d;
    },
        Vh = function Vh(a) {
        return ka() + 1E3 * parseInt(a, 10);
    },
        Xh = function Xh(a, b) {
        return hg(a.f, b).then(function (b) {
            a.wa = b.access_token;a.Pa = Vh(b.expires_in);a.S = b.refresh_token;return { accessToken: a.wa, expirationTime: a.Pa, refreshToken: a.S };
        }).l(function (b) {
            "auth/user-token-expired" == b.code && (a.S = null);throw b;
        });
    },
        Yh = function Yh(a) {
        return !(!a.wa || a.S);
    };
    Uh.prototype.getToken = function (a) {
        a = !!a;return Yh(this) ? K(new R("user-token-expired")) : a || !this.wa || ka() > this.Pa - 3E4 ? this.S ? Xh(this, { grant_type: "refresh_token", refresh_token: this.S }) : J(null) : J({ accessToken: this.wa, expirationTime: this.Pa, refreshToken: this.S });
    };var Zh = function Zh(a, b, c, d, e) {
        Cf(this, { uid: a, displayName: d || null, photoURL: e || null, email: c || null, providerId: b });
    },
        $h = function $h(a, b) {
        Mb.call(this, a);for (var c in b) {
            this[c] = b[c];
        }
    };t($h, Mb);
    var W = function W(a, b, c) {
        this.U = [];this.v = a.apiKey;this.ea = a.appName;this.X = a.authDomain || null;a = firebase.SDK_VERSION ? sf(firebase.SDK_VERSION) : null;this.f = new T(this.v, null, a);this.ba = new Uh(this.f);ai(this, b.idToken);Wh(this.ba, b);Q(this, "refreshToken", this.ba.S);bi(this, c || {});Zd.call(this);this.Ub = !1;this.X && vf() && (this.m = Rh(this.X, this.v, this.ea));this.cc = [];
    };t(W, Zd);
    var ai = function ai(a, b) {
        a.kd = b;Q(a, "_lat", b);
    },
        ci = function ci(a, b) {
        La(a.cc, function (a) {
            return a == b;
        });
    },
        di = function di(a) {
        for (var b = [], c = 0; c < a.cc.length; c++) {
            b.push(a.cc[c](a));
        }return td(b).then(function () {
            return a;
        });
    },
        ei = function ei(a) {
        a.m && !a.Ub && (a.Ub = !0, a.m.subscribe(a));
    },
        bi = function bi(a, b) {
        Cf(a, { uid: b.uid, displayName: b.displayName || null, photoURL: b.photoURL || null, email: b.email || null, emailVerified: b.emailVerified || !1, isAnonymous: b.isAnonymous || !1, providerData: [] });
    };Q(W.prototype, "providerId", "firebase");
    var fi = function fi() {},
        gi = function gi(a) {
        return J().then(function () {
            if (a.Vd) throw new R("app-deleted");
        });
    },
        hi = function hi(a) {
        return Ea(a.providerData, function (a) {
            return a.providerId;
        });
    },
        ji = function ji(a, b) {
        b && (ii(a, b.providerId), a.providerData.push(b));
    },
        ii = function ii(a, b) {
        La(a.providerData, function (a) {
            return a.providerId == b;
        });
    },
        ki = function ki(a, b, c) {
        ("uid" != b || c) && a.hasOwnProperty(b) && Q(a, b, c);
    };
    W.prototype.copy = function (a) {
        var b = this;b != a && (Cf(this, { uid: a.uid, displayName: a.displayName, photoURL: a.photoURL, email: a.email, emailVerified: a.emailVerified, isAnonymous: a.isAnonymous, providerData: [] }), x(a.providerData, function (a) {
            ji(b, a);
        }), this.ba = a.ba, Q(this, "refreshToken", this.ba.S));
    };W.prototype.reload = function () {
        var a = this;return gi(this).then(function () {
            return li(a).then(function () {
                return di(a);
            }).then(fi);
        });
    };
    var li = function li(a) {
        return a.getToken().then(function (b) {
            var c = a.isAnonymous;return mi(a, b).then(function () {
                c || ki(a, "isAnonymous", !1);return b;
            }).l(function (b) {
                "auth/user-token-expired" == b.code && (a.dispatchEvent(new $h("userDeleted")), ni(a));throw b;
            });
        });
    };
    W.prototype.getToken = function (a) {
        var b = this,
            c = Yh(this.ba);return gi(this).then(function () {
            return b.ba.getToken(a);
        }).then(function (a) {
            if (!a) throw new R("internal-error");a.accessToken != b.kd && (ai(b, a.accessToken), b.Da());ki(b, "refreshToken", a.refreshToken);return a.accessToken;
        }).l(function (a) {
            if ("auth/user-token-expired" == a.code && !c) return di(b).then(function () {
                ki(b, "refreshToken", null);throw a;
            });throw a;
        });
    };
    var oi = function oi(a, b) {
        b.idToken && a.kd != b.idToken && (Wh(a.ba, b), a.Da(), ai(a, b.idToken), ki(a, "refreshToken", a.ba.S));
    };W.prototype.Da = function () {
        this.dispatchEvent(new $h("tokenChanged"));
    };var mi = function mi(a, b) {
        return S(a.f, Gg, { idToken: b }).then(_r(a.we, a));
    };
    W.prototype.we = function (a) {
        a = a.users;if (!a || !a.length) throw new R("internal-error");a = a[0];bi(this, { uid: a.localId, displayName: a.displayName, photoURL: a.photoUrl, email: a.email, emailVerified: !!a.emailVerified });for (var b = pi(a), c = 0; c < b.length; c++) {
            ji(this, b[c]);
        }ki(this, "isAnonymous", !(this.email && a.passwordHash) && !(this.providerData && this.providerData.length));
    };
    var pi = function pi(a) {
        return (a = a.providerUserInfo) && a.length ? Ea(a, function (a) {
            return new Zh(a.rawId, a.providerId, a.email, a.displayName, a.photoUrl);
        }) : [];
    };W.prototype.reauthenticate = function (a) {
        var b = this;return this.c(a.Gb(this.f).then(function (a) {
            var d;a: {
                var e = a.idToken.split(".");if (3 == e.length) {
                    for (var e = e[1], f = (4 - e.length % 4) % 4, g = 0; g < f; g++) {
                        e += ".";
                    }try {
                        var k = mc(tb(e));if (k.sub && k.iss && k.aud && k.exp) {
                            d = new Kf(k);break a;
                        }
                    } catch (q) {}
                }d = null;
            }if (!d || b.uid != d.qe) throw new R("user-mismatch");oi(b, a);return b.reload();
        }));
    };
    var qi = function qi(a, b) {
        return li(a).then(function () {
            if (Ia(hi(a), b)) return di(a).then(function () {
                throw new R("provider-already-linked");
            });
        });
    };h = W.prototype;h.link = function (a) {
        var b = this;return this.c(qi(this, a.provider).then(function () {
            return b.getToken();
        }).then(function (c) {
            return a.md(b.f, c);
        }).then(_r(this.bd, this)));
    };h.bd = function (a) {
        oi(this, a);var b = this;return this.reload().then(function () {
            return b;
        });
    };
    h.updateEmail = function (a) {
        var b = this;return this.c(this.getToken().then(function (c) {
            return b.f.updateEmail(c, a);
        }).then(function (a) {
            oi(b, a);return b.reload();
        }));
    };h.updatePassword = function (a) {
        var b = this;return this.c(this.getToken().then(function (c) {
            return b.f.updatePassword(c, a);
        }).then(function (a) {
            oi(b, a);return b.reload();
        }));
    };
    h.updateProfile = function (a) {
        if (void 0 === a.displayName && void 0 === a.photoURL) return gi(this);var b = this;return this.c(this.getToken().then(function (c) {
            return b.f.updateProfile(c, { displayName: a.displayName, photoUrl: a.photoURL });
        }).then(function (a) {
            oi(b, a);ki(b, "displayName", a.displayName || null);ki(b, "photoURL", a.photoUrl || null);return di(b);
        }).then(fi));
    };
    h.unlink = function (a) {
        var b = this;return this.c(li(this).then(function (c) {
            return Ia(hi(b), a) ? xg(b.f, c, [a]).then(function (a) {
                var c = {};x(a.providerUserInfo || [], function (a) {
                    c[a.providerId] = !0;
                });x(hi(b), function (a) {
                    c[a] || ii(b, a);
                });return di(b);
            }) : di(b).then(function () {
                throw new R("no-such-provider");
            });
        }));
    };h.delete = function () {
        var a = this;return this.c(this.getToken().then(function (b) {
            return S(a.f, Fg, { idToken: b });
        }).then(function () {
            a.dispatchEvent(new $h("userDeleted"));
        })).then(function () {
            ni(a);
        });
    };
    h.Wc = function (a, b) {
        return "linkViaPopup" == a && (this.ia || null) == b && this.$ || "linkViaRedirect" == a && (this.Xb || null) == b ? !0 : !1;
    };h.Ha = function (a, b, c, d) {
        "linkViaPopup" == a && d == (this.ia || null) && (c && this.Fa ? this.Fa(c) : b && !c && this.$ && this.$(b), this.C && (this.C.cancel(), this.C = null), delete this.$, delete this.Fa);
    };h.lb = function (a, b) {
        return "linkViaPopup" == a && b == (this.ia || null) || "linkViaRedirect" == a && (this.Xb || null) == b ? _r(this.Yd, this) : null;
    };h.Fb = function () {
        return uf(this.uid + ":::");
    };
    h.linkWithPopup = function (a) {
        if (!vf()) return K(new R("operation-not-supported-in-this-environment"));var b = this,
            c = Gf(a.providerId),
            d = this.Fb(),
            e = null;!wf() && this.X && a.isOAuthProvider && (e = Sg(this.X, this.v, this.ea, "linkViaPopup", a.providerId, a.Hb(), null, d, firebase.SDK_VERSION || null));var f = nf(e, c && c.tb, c && c.sb),
            c = qi(this, a.providerId).then(function () {
            return di(b);
        }).then(function () {
            ri(b);return b.getToken();
        }).then(function () {
            return Nh(b.m, f, "linkViaPopup", a, d, !!e);
        }).then(function () {
            return new I(function (a, c) {
                b.Ha("linkViaPopup", null, new R("cancelled-popup-request"), b.ia || null);b.$ = a;b.Fa = c;b.ia = d;b.C = Ph(b.m, b, "linkViaPopup", f, d);
            });
        }).then(function (a) {
            f && mf(f);return a;
        }).l(function (a) {
            f && mf(f);throw a;
        });return this.c(c);
    };
    h.linkWithRedirect = function (a) {
        if (!vf()) return K(new R("operation-not-supported-in-this-environment"));var b = this,
            c = null,
            d = this.Fb(),
            e = qi(this, a.providerId).then(function () {
            ri(b);return b.getToken();
        }).then(function () {
            b.Xb = d;return di(b);
        }).then(function (a) {
            b.Ga && (a = b.Ga, a = a.A.set(si, b.G(), a.B));return a;
        }).then(function () {
            return Oh(b.m, "linkViaRedirect", a, d);
        }).l(function (a) {
            c = a;if (b.Ga) return ti(b.Ga);throw c;
        }).then(function () {
            if (c) throw c;
        });return this.c(e);
    };
    var ri = function ri(a) {
        if (a.m && a.Ub) return;if (a.m && !a.Ub) throw new R("internal-error");throw new R("auth-domain-config-required");
    };W.prototype.Yd = function (a, b) {
        var c = this;this.C && (this.C.cancel(), this.C = null);var d = null,
            e = this.getToken().then(function (d) {
            return S(c.f, Of, { requestUri: a, sessionId: b, idToken: d });
        }).then(function (a) {
            d = Zf(a);return c.bd(a);
        }).then(function (a) {
            return { user: a, credential: d };
        });return this.c(e);
    };
    W.prototype.sendEmailVerification = function () {
        var a = this;return this.c(this.getToken().then(function (b) {
            return a.f.sendEmailVerification(b);
        }).then(function (b) {
            if (a.email != b) return a.reload();
        }).then(function () {}));
    };var ni = function ni(a) {
        for (var b = 0; b < a.U.length; b++) {
            a.U[b].cancel("app-deleted");
        }a.U = [];a.Vd = !0;Q(a, "refreshToken", null);a.m && a.m.unsubscribe(a);
    };W.prototype.c = function (a) {
        var b = this;this.U.push(a);wd(a, function () {
            Ka(b.U, a);
        });return a;
    };W.prototype.toJSON = function () {
        return this.G();
    };
    W.prototype.G = function () {
        var a = { uid: this.uid, displayName: this.displayName, photoURL: this.photoURL, email: this.email, emailVerified: this.emailVerified, isAnonymous: this.isAnonymous, providerData: [], apiKey: this.v, appName: this.ea, authDomain: this.X, stsTokenManager: this.ba.G(), redirectEventId: this.Xb || null };x(this.providerData, function (b) {
            a.providerData.push(Df(b));
        });return a;
    };
    var ui = function ui(a) {
        if (!a.apiKey) return null;var b = { apiKey: a.apiKey, authDomain: a.authDomain, appName: a.appName },
            c = {};if (a.stsTokenManager && a.stsTokenManager.accessToken && a.stsTokenManager.expirationTime) c.idToken = a.stsTokenManager.accessToken, c.refreshToken = a.stsTokenManager.refreshToken || null, c.expiresIn = (a.stsTokenManager.expirationTime - ka()) / 1E3;else return null;var d = new W(b, c, a);a.providerData && x(a.providerData, function (a) {
            if (a) {
                var b = {};Cf(b, a);ji(d, b);
            }
        });a.redirectEventId && (d.Xb = a.redirectEventId);
        return d;
    },
        vi = function vi(a, b, c) {
        var d = new W(a, b);c && (d.Ga = c);return d.reload().then(function () {
            return d;
        });
    };var wi = function wi(a) {
        this.B = a;this.A = yh();
    },
        si = { name: "redirectUser", V: !1 },
        ti = function ti(a) {
        return a.A.remove(si, a.B);
    },
        xi = function xi(a, b) {
        return a.A.get(si, a.B).then(function (a) {
            a && b && (a.authDomain = b);return ui(a || {});
        });
    };var yi = function yi(a) {
        this.B = a;this.A = yh();
    },
        zi = { name: "authUser", V: !0 },
        Ai = function Ai(a) {
        return a.A.remove(zi, a.B);
    },
        Bi = function Bi(a, b) {
        return a.A.get(zi, a.B).then(function (a) {
            a && b && (a.authDomain = b);return ui(a || {});
        });
    };var Y = function Y(a) {
        this.Na = !1;Q(this, "app", a);if (X(this).options && X(this).options.apiKey) a = firebase.SDK_VERSION ? sf(firebase.SDK_VERSION) : null, this.f = new T(X(this).options && X(this).options.apiKey, null, a);else throw new R("invalid-api-key");this.U = [];this.La = [];this.ue = firebase.INTERNAL.createSubscribe(_r(this.me, this));Ci(this, null);this.va = new yi(X(this).options.apiKey + ":" + X(this).name);this.Ya = new wi(X(this).options.apiKey + ":" + X(this).name);this.zb = this.c(Di(this));this.ra = this.c(Ei(this));this.yc = !1;this.uc = _r(this.Ee, this);this.Dd = _r(this.Ra, this);this.Ed = _r(this.ie, this);this.Cd = _r(this.he, this);Fi(this);this.INTERNAL = {};this.INTERNAL.delete = _r(this.delete, this);
    };Y.prototype.toJSON = function () {
        return { apiKey: X(this).options.apiKey, authDomain: X(this).options.authDomain, appName: X(this).name, currentUser: Z(this) && Z(this).G() };
    };
    var Gi = function Gi(a) {
        return a.Wd || K(new R("auth-domain-config-required"));
    },
        Fi = function Fi(a) {
        var b = X(a).options.authDomain,
            c = X(a).options.apiKey;b && vf() && (a.Wd = a.zb.then(function () {
            if (!a.Na) return a.m = Rh(b, c, X(a).name), a.m.subscribe(a), Z(a) && ei(Z(a)), a.Kc && (ei(a.Kc), a.Kc = null), a.m;
        }));
    };h = Y.prototype;h.Wc = function (a, b) {
        switch (a) {case "unknown":case "signInViaRedirect":
                return !0;case "signInViaPopup":
                return this.ia == b && !!this.$;default:
                return !1;}
    };
    h.Ha = function (a, b, c, d) {
        "signInViaPopup" == a && this.ia == d && (c && this.Fa ? this.Fa(c) : b && !c && this.$ && this.$(b), this.C && (this.C.cancel(), this.C = null), delete this.$, delete this.Fa);
    };h.lb = function (a, b) {
        return "signInViaRedirect" == a || "signInViaPopup" == a && this.ia == b && this.$ ? _r(this.Zd, this) : null;
    };
    h.Zd = function (a, b) {
        var c = this;a = { requestUri: a, sessionId: b };this.C && (this.C.cancel(), this.C = null);var d = null,
            e = S(c.f, Nf, a).then(function (a) {
            d = Zf(a);return a;
        });a = c.zb.then(function () {
            return e;
        }).then(function (a) {
            return Hi(c, a);
        }).then(function () {
            return { user: Z(c), credential: d };
        });return this.c(a);
    };h.Fb = function () {
        return uf();
    };
    h.signInWithPopup = function (a) {
        if (!vf()) return K(new R("operation-not-supported-in-this-environment"));var b = this,
            c = Gf(a.providerId),
            d = this.Fb(),
            e = null;!wf() && X(this).options.authDomain && a.isOAuthProvider && (e = Sg(X(this).options.authDomain, X(this).options.apiKey, X(this).name, "signInViaPopup", a.providerId, a.Hb(), null, d, firebase.SDK_VERSION || null));var f = nf(e, c && c.tb, c && c.sb),
            c = Gi(this).then(function (b) {
            return Nh(b, f, "signInViaPopup", a, d, !!e);
        }).then(function () {
            return new I(function (a, c) {
                b.Ha("signInViaPopup", null, new R("cancelled-popup-request"), b.ia);b.$ = a;b.Fa = c;b.ia = d;b.C = Ph(b.m, b, "signInViaPopup", f, d);
            });
        }).then(function (a) {
            f && mf(f);return a;
        }).l(function (a) {
            f && mf(f);throw a;
        });return this.c(c);
    };h.signInWithRedirect = function (a) {
        if (!vf()) return K(new R("operation-not-supported-in-this-environment"));var b = this,
            c = Gi(this).then(function () {
            return Oh(b.m, "signInViaRedirect", a);
        });return this.c(c);
    };
    h.getRedirectResult = function () {
        if (!vf()) return K(new R("operation-not-supported-in-this-environment"));var a = this,
            b = Gi(this).then(function () {
            return a.m.getRedirectResult();
        });return this.c(b);
    };
    var Hi = function Hi(a, b) {
        var c = {};c.apiKey = X(a).options.apiKey;c.authDomain = X(a).options.authDomain;c.appName = X(a).name;return a.zb.then(function () {
            return vi(c, b, a.Ya);
        }).then(function (b) {
            if (Z(a) && b.uid == Z(a).uid) return Z(a).copy(b), a.Ra(b);Ci(a, b);ei(b);return a.Ra(b);
        }).then(function () {
            a.Da();
        });
    },
        Ci = function Ci(a, b) {
        Z(a) && (ci(Z(a), a.Dd), gc(Z(a), "tokenChanged", a.Ed), gc(Z(a), "userDeleted", a.Cd));b && (b.cc.push(a.Dd), Yb(b, "tokenChanged", a.Ed), Yb(b, "userDeleted", a.Cd));Q(a, "currentUser", b);
    };
    Y.prototype.signOut = function () {
        var a = this,
            b = this.ra.then(function () {
            if (!Z(a)) return J();Ci(a, null);return Ai(a.va).then(function () {
                a.Da();
            });
        });return this.c(b);
    };
    var Ii = function Ii(a) {
        var b = xi(a.Ya, X(a).options.authDomain).then(function (b) {
            if (a.Kc = b) b.Ga = a.Ya;return ti(a.Ya);
        });return a.c(b);
    },
        Di = function Di(a) {
        var b = X(a).options.authDomain,
            c = Ii(a).then(function () {
            return Bi(a.va, b);
        }).then(function (b) {
            return b ? (b.Ga = a.Ya, b.reload().then(function () {
                return b;
            }).l(function (c) {
                return "auth/network-request-failed" == c.code ? b : Ai(a.va);
            })) : null;
        }).then(function (b) {
            Ci(a, b || null);
        });return a.c(c);
    },
        Ei = function Ei(a) {
        return a.zb.then(function () {
            return a.getRedirectResult();
        }).l(function () {}).then(function () {
            if (!a.Na) return a.uc();
        }).l(function () {}).then(function () {
            if (!a.Na) {
                a.yc = !0;var b = a.va;b.A.addListener(zi, b.B, a.uc);
            }
        });
    };Y.prototype.Ee = function () {
        var a = this;return Bi(this.va, X(this).options.authDomain).then(function (b) {
            if (!a.Na) {
                var c;if (c = Z(a) && b) {
                    c = Z(a).uid;var d = b.uid;c = void 0 === c || null === c || "" === c || void 0 === d || null === d || "" === d ? !1 : c == d;
                }if (c) return Z(a).copy(b), Z(a).getToken();if (Z(a) || b) Ci(a, b), b && (ei(b), b.Ga = a.Ya), a.m && a.m.subscribe(a), a.Da();
            }
        });
    };Y.prototype.Ra = function (a) {
        var b = this.va;return b.A.set(zi, a.G(), b.B);
    };Y.prototype.ie = function () {
        this.Da();this.Ra(Z(this));
    };
    Y.prototype.he = function () {
        this.signOut();
    };var Ji = function Ji(a, b) {
        return a.c(b.then(function (b) {
            return Hi(a, b);
        }).then(function () {
            return Z(a);
        }));
    };h = Y.prototype;h.me = function (a) {
        var b = this;this.addAuthTokenListener(function () {
            a.next(Z(b));
        });
    };h.onAuthStateChanged = function (a, b, c) {
        var d = this;this.yc && firebase.Promise.resolve().then(function () {
            p(a) ? a(Z(d)) : p(a.next) && a.next(Z(d));
        });return this.ue(a, b, c);
    };
    h.getToken = function (a) {
        var b = this,
            c = this.ra.then(function () {
            return Z(b) ? Z(b).getToken(a).then(function (a) {
                return { accessToken: a };
            }) : null;
        });return this.c(c);
    };h.signInWithCustomToken = function (a) {
        var b = this;return this.ra.then(function () {
            return Ji(b, S(b.f, Hg, { token: a }));
        }).then(function (a) {
            ki(a, "isAnonymous", !1);return b.Ra(a);
        }).then(function () {
            return Z(b);
        });
    };h.signInWithEmailAndPassword = function (a, b) {
        var c = this;return this.ra.then(function () {
            return Ji(c, S(c.f, Vf, { email: a, password: b }));
        });
    };
    h.createUserWithEmailAndPassword = function (a, b) {
        var c = this;return this.ra.then(function () {
            return Ji(c, S(c.f, Eg, { email: a, password: b }));
        });
    };h.signInWithCredential = function (a) {
        var b = this;return this.ra.then(function () {
            return Ji(b, a.Gb(b.f));
        });
    };h.signInAnonymously = function () {
        var a = Z(this),
            b = this;return a && a.isAnonymous ? J(a) : this.ra.then(function () {
            return Ji(b, b.f.signInAnonymously());
        }).then(function (a) {
            ki(a, "isAnonymous", !0);return b.Ra(a);
        }).then(function () {
            return Z(b);
        });
    };
    var X = function X(a) {
        return a.app;
    },
        Z = function Z(a) {
        return a.currentUser;
    };h = Y.prototype;h.Da = function () {
        if (this.yc) for (var a = 0; a < this.La.length; a++) {
            if (this.La[a]) this.La[a](Z(this) && Z(this)._lat || null);
        }
    };h.addAuthTokenListener = function (a) {
        var b = this;this.La.push(a);this.c(this.ra.then(function () {
            b.Na || Ia(b.La, a) && a(Z(b) && Z(b)._lat || null);
        }));
    };h.removeAuthTokenListener = function (a) {
        La(this.La, function (b) {
            return b == a;
        });
    };
    h.delete = function () {
        this.Na = !0;for (var a = 0; a < this.U.length; a++) {
            this.U[a].cancel("app-deleted");
        }this.U = [];this.va && (a = this.va, a.A.removeListener(zi, a.B, this.uc));this.m && this.m.unsubscribe(this);return firebase.Promise.resolve();
    };h.c = function (a) {
        var b = this;this.U.push(a);wd(a, function () {
            Ka(b.U, a);
        });return a;
    };h.fetchProvidersForEmail = function (a) {
        return this.c(ng(this.f, a));
    };h.verifyPasswordResetCode = function (a) {
        return this.checkActionCode(a).then(function (a) {
            return a.data.email;
        });
    };
    h.confirmPasswordReset = function (a, b) {
        return this.c(this.f.confirmPasswordReset(a, b).then(function () {}));
    };h.checkActionCode = function (a) {
        return this.c(this.f.checkActionCode(a).then(function (a) {
            return { data: { email: a.email } };
        }));
    };h.applyActionCode = function (a) {
        return this.c(this.f.applyActionCode(a).then(function () {}));
    };h.sendPasswordResetEmail = function (a) {
        return this.c(this.f.sendPasswordResetEmail(a).then(function () {}));
    };uh(Y.prototype, {
        applyActionCode: { name: "applyActionCode", b: [U("code")] }, checkActionCode: { name: "checkActionCode", b: [U("code")] }, confirmPasswordReset: { name: "confirmPasswordReset", b: [U("code"), U("newPassword")] }, createUserWithEmailAndPassword: { name: "createUserWithEmailAndPassword", b: [U("email"), U("password")] }, fetchProvidersForEmail: { name: "fetchProvidersForEmail", b: [U("email")] }, getRedirectResult: { name: "getRedirectResult", b: [] }, onAuthStateChanged: {
            name: "onAuthStateChanged", b: [sh(nh(), oh(), "nextOrObserver"), oh("opt_error", !0), oh("opt_completed", !0)]
        }, sendPasswordResetEmail: { name: "sendPasswordResetEmail", b: [U("email")] }, signInAnonymously: { name: "signInAnonymously", b: [] }, signInWithCredential: { name: "signInWithCredential", b: [qh()] }, signInWithCustomToken: { name: "signInWithCustomToken", b: [U("token")] }, signInWithEmailAndPassword: { name: "signInWithEmailAndPassword", b: [U("email"), U("password")] }, signInWithPopup: { name: "signInWithPopup", b: [rh()] }, signInWithRedirect: { name: "signInWithRedirect", b: [rh()] }, signOut: {
            name: "signOut",
            b: []
        }, toJSON: { name: "toJSON", b: [U(null, !0)] }, verifyPasswordResetCode: { name: "verifyPasswordResetCode", b: [U("code")] }
    });
    uh(W.prototype, {
        "delete": { name: "delete", b: [] }, getToken: { name: "getToken", b: [{ name: "opt_forceRefresh", ca: "a boolean", optional: !0, da: function da(a) {
                    return "boolean" == typeof a;
                } }] }, link: { name: "link", b: [qh()] }, linkWithPopup: { name: "linkWithPopup", b: [rh()] }, linkWithRedirect: { name: "linkWithRedirect", b: [rh()] }, reauthenticate: { name: "reauthenticate", b: [qh()] }, reload: { name: "reload", b: [] }, sendEmailVerification: { name: "sendEmailVerification", b: [] }, toJSON: { name: "toJSON", b: [U(null, !0)] }, unlink: { name: "unlink", b: [U("provider")] },
        updateEmail: { name: "updateEmail", b: [U("email")] }, updatePassword: { name: "updatePassword", b: [U("password")] }, updateProfile: { name: "updateProfile", b: [nh("profile")] }
    });uh(I.prototype, { l: { name: "catch" }, then: { name: "then" } });V(Xf, "credential", function (a, b) {
        return new Uf(a, b);
    }, [U("email"), U("password")]);uh(Qf.prototype, { addScope: { name: "addScope", b: [U("scope")] } });V(Qf, "credential", Qf.credential, [sh(U(), nh(), "token")]);uh(Rf.prototype, { addScope: { name: "addScope", b: [U("scope")] } });
    V(Rf, "credential", Rf.credential, [sh(U(), nh(), "token")]);uh(Sf.prototype, { addScope: { name: "addScope", b: [U("scope")] } });V(Sf, "credential", Sf.credential, [sh(U(), sh(nh(), ph()), "idToken"), sh(U(), ph(), "accessToken", !0)]);V(Tf, "credential", Tf.credential, [sh(U(), nh(), "token"), U("secret", !0)]);
    (function () {
        if ("undefined" !== typeof firebase && firebase.INTERNAL && firebase.INTERNAL.registerService) {
            var a = { Auth: Y, Error: R };V(a, "EmailAuthProvider", Xf, []);V(a, "FacebookAuthProvider", Qf, []);V(a, "GithubAuthProvider", Rf, []);V(a, "GoogleAuthProvider", Sf, []);V(a, "TwitterAuthProvider", Tf, []);firebase.INTERNAL.registerService("auth", function (a, c) {
                a = new Y(a);c({ INTERNAL: { getToken: _r(a.getToken, a), addAuthTokenListener: _r(a.addAuthTokenListener, a), removeAuthTokenListener: _r(a.removeAuthTokenListener, a) } });return a;
            }, a, function (a, c) {
                if ("create" === a) try {
                    c.auth();
                } catch (d) {}
            });firebase.INTERNAL.extendNamespace({ User: W });
        } else throw Error("Cannot find the firebase namespace; be sure to include firebase-app.js before this library.");
    })();
})();
(function () {
    var h,
        n = this;function p(a) {
        return void 0 !== a;
    }function aa() {}function ba(a) {
        a.Wb = function () {
            return a.bf ? a.bf : a.bf = new a();
        };
    }
    function ca(a) {
        var b = typeof a === "undefined" ? "undefined" : _typeof(a);if ("object" == b) {
            if (a) {
                if (a instanceof Array) return "array";if (a instanceof Object) return b;var c = Object.prototype.toString.call(a);if ("[object Window]" == c) return "object";if ("[object Array]" == c || "number" == typeof a.length && "undefined" != typeof a.splice && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("splice")) return "array";if ("[object Function]" == c || "undefined" != typeof a.call && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("call")) return "function";
            } else return "null";
        } else if ("function" == b && "undefined" == typeof a.call) return "object";return b;
    }function da(a) {
        return "array" == ca(a);
    }function ea(a) {
        var b = ca(a);return "array" == b || "object" == b && "number" == typeof a.length;
    }function q(a) {
        return "string" == typeof a;
    }function fa(a) {
        return "number" == typeof a;
    }function ga(a) {
        return "function" == ca(a);
    }function ha(a) {
        var b = typeof a === "undefined" ? "undefined" : _typeof(a);return "object" == b && null != a || "function" == b;
    }function ia(a, b, c) {
        return a.call.apply(a.bind, arguments);
    }
    function ja(a, b, c) {
        if (!a) throw Error();if (2 < arguments.length) {
            var d = Array.prototype.slice.call(arguments, 2);return function () {
                var c = Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c, d);return a.apply(b, c);
            };
        }return function () {
            return a.apply(b, arguments);
        };
    }function r(a, b, c) {
        r = Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? ia : ja;return r.apply(null, arguments);
    }
    function ka(a, b) {
        function c() {}c.prototype = b.prototype;a.Ig = b.prototype;a.prototype = new c();a.prototype.constructor = a;a.Eg = function (a, c, f) {
            for (var g = Array(arguments.length - 2), k = 2; k < arguments.length; k++) {
                g[k - 2] = arguments[k];
            }return b.prototype[c].apply(a, g);
        };
    };function la() {
        this.Ya = -1;
    };function ma() {
        this.Ya = -1;this.Ya = 64;this.N = [];this.Wd = [];this.Jf = [];this.zd = [];this.zd[0] = 128;for (var a = 1; a < this.Ya; ++a) {
            this.zd[a] = 0;
        }this.Pd = this.ac = 0;this.reset();
    }ka(ma, la);ma.prototype.reset = function () {
        this.N[0] = 1732584193;this.N[1] = 4023233417;this.N[2] = 2562383102;this.N[3] = 271733878;this.N[4] = 3285377520;this.Pd = this.ac = 0;
    };
    function na(a, b, c) {
        c || (c = 0);var d = a.Jf;if (q(b)) for (var e = 0; 16 > e; e++) {
            d[e] = b.charCodeAt(c) << 24 | b.charCodeAt(c + 1) << 16 | b.charCodeAt(c + 2) << 8 | b.charCodeAt(c + 3), c += 4;
        } else for (e = 0; 16 > e; e++) {
            d[e] = b[c] << 24 | b[c + 1] << 16 | b[c + 2] << 8 | b[c + 3], c += 4;
        }for (e = 16; 80 > e; e++) {
            var f = d[e - 3] ^ d[e - 8] ^ d[e - 14] ^ d[e - 16];d[e] = (f << 1 | f >>> 31) & 4294967295;
        }b = a.N[0];c = a.N[1];for (var g = a.N[2], k = a.N[3], m = a.N[4], l, e = 0; 80 > e; e++) {
            40 > e ? 20 > e ? (f = k ^ c & (g ^ k), l = 1518500249) : (f = c ^ g ^ k, l = 1859775393) : 60 > e ? (f = c & g | k & (c | g), l = 2400959708) : (f = c ^ g ^ k, l = 3395469782), f = (b << 5 | b >>> 27) + f + m + l + d[e] & 4294967295, m = k, k = g, g = (c << 30 | c >>> 2) & 4294967295, c = b, b = f;
        }a.N[0] = a.N[0] + b & 4294967295;a.N[1] = a.N[1] + c & 4294967295;a.N[2] = a.N[2] + g & 4294967295;a.N[3] = a.N[3] + k & 4294967295;a.N[4] = a.N[4] + m & 4294967295;
    }
    ma.prototype.update = function (a, b) {
        if (null != a) {
            p(b) || (b = a.length);for (var c = b - this.Ya, d = 0, e = this.Wd, f = this.ac; d < b;) {
                if (0 == f) for (; d <= c;) {
                    na(this, a, d), d += this.Ya;
                }if (q(a)) for (; d < b;) {
                    if (e[f] = a.charCodeAt(d), ++f, ++d, f == this.Ya) {
                        na(this, e);f = 0;break;
                    }
                } else for (; d < b;) {
                    if (e[f] = a[d], ++f, ++d, f == this.Ya) {
                        na(this, e);f = 0;break;
                    }
                }
            }this.ac = f;this.Pd += b;
        }
    };function t(a, b) {
        for (var c in a) {
            b.call(void 0, a[c], c, a);
        }
    }function oa(a, b) {
        var c = {},
            d;for (d in a) {
            c[d] = b.call(void 0, a[d], d, a);
        }return c;
    }function pa(a, b) {
        for (var c in a) {
            if (!b.call(void 0, a[c], c, a)) return !1;
        }return !0;
    }function qa(a) {
        var b = 0,
            c;for (c in a) {
            b++;
        }return b;
    }function ra(a) {
        for (var b in a) {
            return b;
        }
    }function sa(a) {
        var b = [],
            c = 0,
            d;for (d in a) {
            b[c++] = a[d];
        }return b;
    }function ta(a) {
        var b = [],
            c = 0,
            d;for (d in a) {
            b[c++] = d;
        }return b;
    }function ua(a, b) {
        for (var c in a) {
            if (a[c] == b) return !0;
        }return !1;
    }
    function va(a, b, c) {
        for (var d in a) {
            if (b.call(c, a[d], d, a)) return d;
        }
    }function wa(a, b) {
        var c = va(a, b, void 0);return c && a[c];
    }function xa(a) {
        for (var b in a) {
            return !1;
        }return !0;
    }function ya(a) {
        var b = {},
            c;for (c in a) {
            b[c] = a[c];
        }return b;
    };function za(a) {
        a = String(a);if (/^\s*$/.test(a) ? 0 : /^[\],:{}\s\u2028\u2029]*$/.test(a.replace(/\\["\\\/bfnrtu]/g, "@").replace(/"[^"\\\n\r\u2028\u2029\x00-\x08\x0a-\x1f]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, "]").replace(/(?:^|:|,)(?:[\s\u2028\u2029]*\[)+/g, ""))) try {
            return eval("(" + a + ")");
        } catch (b) {}throw Error("Invalid JSON string: " + a);
    }function Aa() {
        this.Fd = void 0;
    }
    function Ba(a, b, c) {
        switch (typeof b === "undefined" ? "undefined" : _typeof(b)) {
            case "string":
                Ca(b, c);break;case "number":
                c.push(isFinite(b) && !isNaN(b) ? b : "null");break;case "boolean":
                c.push(b);break;case "undefined":
                c.push("null");break;case "object":
                if (null == b) {
                    c.push("null");break;
                }if (da(b)) {
                    var d = b.length;c.push("[");for (var e = "", f = 0; f < d; f++) {
                        c.push(e), e = b[f], Ba(a, a.Fd ? a.Fd.call(b, String(f), e) : e, c), e = ",";
                    }c.push("]");break;
                }c.push("{");d = "";for (f in b) {
                    Object.prototype.hasOwnProperty.call(b, f) && (e = b[f], "function" != typeof e && (c.push(d), Ca(f, c), c.push(":"), Ba(a, a.Fd ? a.Fd.call(b, f, e) : e, c), d = ","));
                }c.push("}");break;case "function":
                break;default:
                throw Error("Unknown type: " + (typeof b === "undefined" ? "undefined" : _typeof(b)));
        }
    }var Da = { '"': '\\"', "\\": "\\\\", "/": "\\/", "\b": "\\b", "\f": "\\f", "\n": "\\n", "\r": "\\r", "\t": "\\t", "\x0B": "\\u000b" },
        Ea = /\uffff/.test("\uFFFF") ? /[\\\"\x00-\x1f\x7f-\uffff]/g : /[\\\"\x00-\x1f\x7f-\xff]/g;
    function Ca(a, b) {
        b.push('"', a.replace(Ea, function (a) {
            if (a in Da) return Da[a];var b = a.charCodeAt(0),
                e = "\\u";16 > b ? e += "000" : 256 > b ? e += "00" : 4096 > b && (e += "0");return Da[a] = e + b.toString(16);
        }), '"');
    };var v;a: {
        var Fa = n.navigator;if (Fa) {
            var Ga = Fa.userAgent;if (Ga) {
                v = Ga;break a;
            }
        }v = "";
    };function Ha(a) {
        if (Error.captureStackTrace) Error.captureStackTrace(this, Ha);else {
            var b = Error().stack;b && (this.stack = b);
        }a && (this.message = String(a));
    }ka(Ha, Error);Ha.prototype.name = "CustomError";var w = Array.prototype,
        Ia = w.indexOf ? function (a, b, c) {
        return w.indexOf.call(a, b, c);
    } : function (a, b, c) {
        c = null == c ? 0 : 0 > c ? Math.max(0, a.length + c) : c;if (q(a)) return q(b) && 1 == b.length ? a.indexOf(b, c) : -1;for (; c < a.length; c++) {
            if (c in a && a[c] === b) return c;
        }return -1;
    },
        Ja = w.forEach ? function (a, b, c) {
        w.forEach.call(a, b, c);
    } : function (a, b, c) {
        for (var d = a.length, e = q(a) ? a.split("") : a, f = 0; f < d; f++) {
            f in e && b.call(c, e[f], f, a);
        }
    },
        Ka = w.filter ? function (a, b, c) {
        return w.filter.call(a, b, c);
    } : function (a, b, c) {
        for (var d = a.length, e = [], f = 0, g = q(a) ? a.split("") : a, k = 0; k < d; k++) {
            if (k in g) {
                var m = g[k];b.call(c, m, k, a) && (e[f++] = m);
            }
        }return e;
    },
        La = w.map ? function (a, b, c) {
        return w.map.call(a, b, c);
    } : function (a, b, c) {
        for (var d = a.length, e = Array(d), f = q(a) ? a.split("") : a, g = 0; g < d; g++) {
            g in f && (e[g] = b.call(c, f[g], g, a));
        }return e;
    },
        Ma = w.reduce ? function (a, b, c, d) {
        for (var e = [], f = 1, g = arguments.length; f < g; f++) {
            e.push(arguments[f]);
        }d && (e[0] = r(b, d));return w.reduce.apply(a, e);
    } : function (a, b, c, d) {
        var e = c;Ja(a, function (c, g) {
            e = b.call(d, e, c, g, a);
        });return e;
    },
        Na = w.every ? function (a, b, c) {
        return w.every.call(a, b, c);
    } : function (a, b, c) {
        for (var d = a.length, e = q(a) ? a.split("") : a, f = 0; f < d; f++) {
            if (f in e && !b.call(c, e[f], f, a)) return !1;
        }return !0;
    };function Oa(a, b) {
        var c = Pa(a, b, void 0);return 0 > c ? null : q(a) ? a.charAt(c) : a[c];
    }function Pa(a, b, c) {
        for (var d = a.length, e = q(a) ? a.split("") : a, f = 0; f < d; f++) {
            if (f in e && b.call(c, e[f], f, a)) return f;
        }return -1;
    }function Qa(a, b) {
        var c = Ia(a, b);0 <= c && w.splice.call(a, c, 1);
    }function Ra(a, b, c) {
        return 2 >= arguments.length ? w.slice.call(a, b) : w.slice.call(a, b, c);
    }
    function Sa(a, b) {
        a.sort(b || Ta);
    }function Ta(a, b) {
        return a > b ? 1 : a < b ? -1 : 0;
    };var Ua = -1 != v.indexOf("Opera") || -1 != v.indexOf("OPR"),
        Va = -1 != v.indexOf("Trident") || -1 != v.indexOf("MSIE"),
        Wa = -1 != v.indexOf("Gecko") && -1 == v.toLowerCase().indexOf("webkit") && !(-1 != v.indexOf("Trident") || -1 != v.indexOf("MSIE")),
        Xa = -1 != v.toLowerCase().indexOf("webkit");
    (function () {
        var a = "",
            b;if (Ua && n.opera) return a = n.opera.version, ga(a) ? a() : a;Wa ? b = /rv\:([^\);]+)(\)|;)/ : Va ? b = /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/ : Xa && (b = /WebKit\/(\S+)/);b && (a = (a = b.exec(v)) ? a[1] : "");return Va && (b = (b = n.document) ? b.documentMode : void 0, b > parseFloat(a)) ? String(b) : a;
    })();var Ya = null,
        Za = null,
        $a = null;function ab(a, b) {
        if (!ea(a)) throw Error("encodeByteArray takes an array as a parameter");bb();for (var c = b ? Za : Ya, d = [], e = 0; e < a.length; e += 3) {
            var f = a[e],
                g = e + 1 < a.length,
                k = g ? a[e + 1] : 0,
                m = e + 2 < a.length,
                l = m ? a[e + 2] : 0,
                u = f >> 2,
                f = (f & 3) << 4 | k >> 4,
                k = (k & 15) << 2 | l >> 6,
                l = l & 63;m || (l = 64, g || (k = 64));d.push(c[u], c[f], c[k], c[l]);
        }return d.join("");
    }
    function bb() {
        if (!Ya) {
            Ya = {};Za = {};$a = {};for (var a = 0; 65 > a; a++) {
                Ya[a] = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(a), Za[a] = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_.".charAt(a), $a[Za[a]] = a, 62 <= a && ($a["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(a)] = a);
            }
        }
    };function cb(a) {
        n.setTimeout(function () {
            throw a;
        }, 0);
    }var db;
    function eb() {
        var a = n.MessageChannel;"undefined" === typeof a && "undefined" !== typeof window && window.postMessage && window.addEventListener && -1 == v.indexOf("Presto") && (a = function a() {
            var a = document.createElement("iframe");a.style.display = "none";a.src = "";document.documentElement.appendChild(a);var b = a.contentWindow,
                a = b.document;a.open();a.write("");a.close();var c = "callImmediate" + Math.random(),
                d = "file:" == b.location.protocol ? "*" : b.location.protocol + "//" + b.location.host,
                a = r(function (a) {
                if (("*" == d || a.origin == d) && a.data == c) this.port1.onmessage();
            }, this);b.addEventListener("message", a, !1);this.port1 = {};this.port2 = { postMessage: function postMessage() {
                    b.postMessage(c, d);
                } };
        });if ("undefined" !== typeof a && -1 == v.indexOf("Trident") && -1 == v.indexOf("MSIE")) {
            var b = new a(),
                c = {},
                d = c;b.port1.onmessage = function () {
                if (p(c.next)) {
                    c = c.next;var a = c.Le;c.Le = null;a();
                }
            };return function (a) {
                d.next = { Le: a };d = d.next;b.port2.postMessage(0);
            };
        }return "undefined" !== typeof document && "onreadystatechange" in document.createElement("script") ? function (a) {
            var b = document.createElement("script");b.onreadystatechange = function () {
                b.onreadystatechange = null;b.parentNode.removeChild(b);b = null;a();a = null;
            };document.documentElement.appendChild(b);
        } : function (a) {
            n.setTimeout(a, 0);
        };
    };function fb(a, b) {
        gb || hb();ib || (gb(), ib = !0);jb.push(new kb(a, b));
    }var gb;function hb() {
        if (n.Promise && n.Promise.resolve) {
            var a = n.Promise.resolve();gb = function gb() {
                a.then(lb);
            };
        } else gb = function gb() {
            var a = lb;!ga(n.setImmediate) || n.Window && n.Window.prototype && n.Window.prototype.setImmediate == n.setImmediate ? (db || (db = eb()), db(a)) : n.setImmediate(a);
        };
    }var ib = !1,
        jb = [];[].push(function () {
        ib = !1;jb = [];
    });
    function lb() {
        for (; jb.length;) {
            var a = jb;jb = [];for (var b = 0; b < a.length; b++) {
                var c = a[b];try {
                    c.Wf.call(c.scope);
                } catch (d) {
                    cb(d);
                }
            }
        }ib = !1;
    }function kb(a, b) {
        this.Wf = a;this.scope = b;
    };function mb(a, b) {
        this.L = nb;this.uf = void 0;this.Ca = this.Ha = null;this.jd = this.be = !1;if (a == ob) pb(this, qb, b);else try {
            var c = this;a.call(b, function (a) {
                pb(c, qb, a);
            }, function (a) {
                if (!(a instanceof rb)) try {
                    if (a instanceof Error) throw a;throw Error("Promise rejected.");
                } catch (b) {}pb(c, sb, a);
            });
        } catch (d) {
            pb(this, sb, d);
        }
    }var nb = 0,
        qb = 2,
        sb = 3;function ob() {}mb.prototype.then = function (a, b, c) {
        return tb(this, ga(a) ? a : null, ga(b) ? b : null, c);
    };mb.prototype.then = mb.prototype.then;mb.prototype.$goog_Thenable = !0;h = mb.prototype;
    h.Ag = function (a, b) {
        return tb(this, null, a, b);
    };h.cancel = function (a) {
        this.L == nb && fb(function () {
            var b = new rb(a);ub(this, b);
        }, this);
    };function ub(a, b) {
        if (a.L == nb) if (a.Ha) {
            var c = a.Ha;if (c.Ca) {
                for (var d = 0, e = -1, f = 0, g; g = c.Ca[f]; f++) {
                    if (g = g.m) if (d++, g == a && (e = f), 0 <= e && 1 < d) break;
                }0 <= e && (c.L == nb && 1 == d ? ub(c, b) : (d = c.Ca.splice(e, 1)[0], vb(c, d, sb, b)));
            }a.Ha = null;
        } else pb(a, sb, b);
    }function wb(a, b) {
        a.Ca && a.Ca.length || a.L != qb && a.L != sb || xb(a);a.Ca || (a.Ca = []);a.Ca.push(b);
    }
    function tb(a, b, c, d) {
        var e = { m: null, hf: null, kf: null };e.m = new mb(function (a, g) {
            e.hf = b ? function (c) {
                try {
                    var e = b.call(d, c);a(e);
                } catch (l) {
                    g(l);
                }
            } : a;e.kf = c ? function (b) {
                try {
                    var e = c.call(d, b);!p(e) && b instanceof rb ? g(b) : a(e);
                } catch (l) {
                    g(l);
                }
            } : g;
        });e.m.Ha = a;wb(a, e);return e.m;
    }h.Cf = function (a) {
        this.L = nb;pb(this, qb, a);
    };h.Df = function (a) {
        this.L = nb;pb(this, sb, a);
    };
    function pb(a, b, c) {
        if (a.L == nb) {
            if (a == c) b = sb, c = new TypeError("Promise cannot resolve to itself");else {
                var d;if (c) try {
                    d = !!c.$goog_Thenable;
                } catch (e) {
                    d = !1;
                } else d = !1;if (d) {
                    a.L = 1;c.then(a.Cf, a.Df, a);return;
                }if (ha(c)) try {
                    var f = c.then;if (ga(f)) {
                        yb(a, c, f);return;
                    }
                } catch (g) {
                    b = sb, c = g;
                }
            }a.uf = c;a.L = b;a.Ha = null;xb(a);b != sb || c instanceof rb || zb(a, c);
        }
    }function yb(a, b, c) {
        function d(b) {
            f || (f = !0, a.Df(b));
        }function e(b) {
            f || (f = !0, a.Cf(b));
        }a.L = 1;var f = !1;try {
            c.call(b, e, d);
        } catch (g) {
            d(g);
        }
    }
    function xb(a) {
        a.be || (a.be = !0, fb(a.Uf, a));
    }h.Uf = function () {
        for (; this.Ca && this.Ca.length;) {
            var a = this.Ca;this.Ca = null;for (var b = 0; b < a.length; b++) {
                vb(this, a[b], this.L, this.uf);
            }
        }this.be = !1;
    };function vb(a, b, c, d) {
        if (c == qb) b.hf(d);else {
            if (b.m) for (; a && a.jd; a = a.Ha) {
                a.jd = !1;
            }b.kf(d);
        }
    }function zb(a, b) {
        a.jd = !0;fb(function () {
            a.jd && Ab.call(null, b);
        });
    }var Ab = cb;function rb(a) {
        Ha.call(this, a);
    }ka(rb, Ha);rb.prototype.name = "cancel";function Bb(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }function x(a, b) {
        if (Object.prototype.hasOwnProperty.call(a, b)) return a[b];
    }function Cb(a, b) {
        for (var c in a) {
            Object.prototype.hasOwnProperty.call(a, c) && b(c, a[c]);
        }
    };function y(a, b, c, d) {
        var e;d < b ? e = "at least " + b : d > c && (e = 0 === c ? "none" : "no more than " + c);if (e) throw Error(a + " failed: Was called with " + d + (1 === d ? " argument." : " arguments.") + " Expects " + e + ".");
    }function Db(a, b, c) {
        var d = "";switch (b) {case 1:
                d = c ? "first" : "First";break;case 2:
                d = c ? "second" : "Second";break;case 3:
                d = c ? "third" : "Third";break;case 4:
                d = c ? "fourth" : "Fourth";break;default:
                throw Error("errorPrefix called with argumentNumber > 4.  Need to update it?");}return a = a + " failed: " + (d + " argument ");
    }
    function A(a, b, c, d) {
        if ((!d || p(c)) && !ga(c)) throw Error(Db(a, b, d) + "must be a valid function.");
    }function Eb(a, b, c) {
        if (p(c) && (!ha(c) || null === c)) throw Error(Db(a, b, !0) + "must be a valid context object.");
    };function Fb(a) {
        var b = [];Cb(a, function (a, d) {
            da(d) ? Ja(d, function (d) {
                b.push(encodeURIComponent(a) + "=" + encodeURIComponent(d));
            }) : b.push(encodeURIComponent(a) + "=" + encodeURIComponent(d));
        });return b.length ? "&" + b.join("&") : "";
    };var Gb = n.Promise || mb;mb.prototype["catch"] = mb.prototype.Ag;function Hb() {
        var a = this;this.reject = this.resolve = null;this.ra = new Gb(function (b, c) {
            a.resolve = b;a.reject = c;
        });
    }function Ib(a, b) {
        return function (c, d) {
            c ? a.reject(c) : a.resolve(d);ga(b) && (Jb(a.ra), 1 === b.length ? b(c) : b(c, d));
        };
    }function Jb(a) {
        a.then(void 0, aa);
    };function Kb(a, b) {
        if (!a) throw Lb(b);
    }function Lb(a) {
        return Error("Firebase Database (" + firebase.SDK_VERSION + ") INTERNAL ASSERT FAILED: " + a);
    };function Mb(a) {
        for (var b = [], c = 0, d = 0; d < a.length; d++) {
            var e = a.charCodeAt(d);55296 <= e && 56319 >= e && (e -= 55296, d++, Kb(d < a.length, "Surrogate pair missing trail surrogate."), e = 65536 + (e << 10) + (a.charCodeAt(d) - 56320));128 > e ? b[c++] = e : (2048 > e ? b[c++] = e >> 6 | 192 : (65536 > e ? b[c++] = e >> 12 | 224 : (b[c++] = e >> 18 | 240, b[c++] = e >> 12 & 63 | 128), b[c++] = e >> 6 & 63 | 128), b[c++] = e & 63 | 128);
        }return b;
    }function Nb(a) {
        for (var b = 0, c = 0; c < a.length; c++) {
            var d = a.charCodeAt(c);128 > d ? b++ : 2048 > d ? b += 2 : 55296 <= d && 56319 >= d ? (b += 4, c++) : b += 3;
        }return b;
    };function Ob(a) {
        return "undefined" !== typeof JSON && p(JSON.parse) ? JSON.parse(a) : za(a);
    }function B(a) {
        if ("undefined" !== typeof JSON && p(JSON.stringify)) a = JSON.stringify(a);else {
            var b = [];Ba(new Aa(), a, b);a = b.join("");
        }return a;
    };function Pb(a, b) {
        this.committed = a;this.snapshot = b;
    };function Qb() {
        return "undefined" !== typeof window && !!(window.cordova || window.phonegap || window.PhoneGap) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test("undefined" !== typeof navigator && "string" === typeof navigator.userAgent ? navigator.userAgent : "");
    };function Rb(a) {
        this.te = a;this.Bd = [];this.Rb = 0;this.Yd = -1;this.Gb = null;
    }function Sb(a, b, c) {
        a.Yd = b;a.Gb = c;a.Yd < a.Rb && (a.Gb(), a.Gb = null);
    }function Tb(a, b, c) {
        for (a.Bd[b] = c; a.Bd[a.Rb];) {
            var d = a.Bd[a.Rb];delete a.Bd[a.Rb];for (var e = 0; e < d.length; ++e) {
                if (d[e]) {
                    var f = a;Ub(function () {
                        f.te(d[e]);
                    });
                }
            }if (a.Rb === a.Yd) {
                a.Gb && (clearTimeout(a.Gb), a.Gb(), a.Gb = null);break;
            }a.Rb++;
        }
    };function Vb() {
        this.qc = {};
    }Vb.prototype.set = function (a, b) {
        null == b ? delete this.qc[a] : this.qc[a] = b;
    };Vb.prototype.get = function (a) {
        return Bb(this.qc, a) ? this.qc[a] : null;
    };Vb.prototype.remove = function (a) {
        delete this.qc[a];
    };Vb.prototype.cf = !0;function Wb(a) {
        this.vc = a;this.Cd = "firebase:";
    }h = Wb.prototype;h.set = function (a, b) {
        null == b ? this.vc.removeItem(this.Cd + a) : this.vc.setItem(this.Cd + a, B(b));
    };h.get = function (a) {
        a = this.vc.getItem(this.Cd + a);return null == a ? null : Ob(a);
    };h.remove = function (a) {
        this.vc.removeItem(this.Cd + a);
    };h.cf = !1;h.toString = function () {
        return this.vc.toString();
    };function Xb(a) {
        try {
            if ("undefined" !== typeof window && "undefined" !== typeof window[a]) {
                var b = window[a];b.setItem("firebase:sentinel", "cache");b.removeItem("firebase:sentinel");return new Wb(b);
            }
        } catch (c) {}return new Vb();
    }var Yb = Xb("localStorage"),
        Zb = Xb("sessionStorage");function $b(a, b, c) {
        this.type = ac;this.source = a;this.path = b;this.Ja = c;
    }$b.prototype.Nc = function (a) {
        return this.path.e() ? new $b(this.source, C, this.Ja.R(a)) : new $b(this.source, D(this.path), this.Ja);
    };$b.prototype.toString = function () {
        return "Operation(" + this.path + ": " + this.source.toString() + " overwrite: " + this.Ja.toString() + ")";
    };function bc(a, b) {
        this.type = cc;this.source = a;this.path = b;
    }bc.prototype.Nc = function () {
        return this.path.e() ? new bc(this.source, C) : new bc(this.source, D(this.path));
    };bc.prototype.toString = function () {
        return "Operation(" + this.path + ": " + this.source.toString() + " listen_complete)";
    };function dc(a) {
        this.He = a;
    }dc.prototype.getToken = function (a) {
        return this.He.INTERNAL.getToken(a).then(null, function (a) {
            return a && "auth/token-not-initialized" === a.code ? (E("Got auth/token-not-initialized error.  Treating as null token."), null) : Promise.reject(a);
        });
    };function ec(a, b) {
        a.He.INTERNAL.addAuthTokenListener(b);
    };function fc() {
        this.Jd = F;
    }fc.prototype.j = function (a) {
        return this.Jd.Q(a);
    };fc.prototype.toString = function () {
        return this.Jd.toString();
    };function gc(a, b, c, d, e) {
        this.host = a.toLowerCase();this.domain = this.host.substr(this.host.indexOf(".") + 1);this.Sc = b;this.pe = c;this.Cg = d;this.nf = e || "";this.bb = Yb.get("host:" + a) || this.host;
    }function hc(a, b) {
        b !== a.bb && (a.bb = b, "s-" === a.bb.substr(0, 2) && Yb.set("host:" + a.host, a.bb));
    }
    function ic(a, b, c) {
        H("string" === typeof b, "typeof type must == string");H("object" === (typeof c === "undefined" ? "undefined" : _typeof(c)), "typeof params must == object");if ("websocket" === b) b = (a.Sc ? "wss://" : "ws://") + a.bb + "/.ws?";else if ("long_polling" === b) b = (a.Sc ? "https://" : "http://") + a.bb + "/.lp?";else throw Error("Unknown connection type: " + b);a.host !== a.bb && (c.ns = a.pe);var d = [];t(c, function (a, b) {
            d.push(b + "=" + a);
        });return b + d.join("&");
    }
    gc.prototype.toString = function () {
        var a = (this.Sc ? "https://" : "http://") + this.host;this.nf && (a += "<" + this.nf + ">");return a;
    };function jc(a, b) {
        this.zf = {};this.Vc = new kc(a);this.va = b;var c = 1E4 + 2E4 * Math.random();setTimeout(r(this.rf, this), Math.floor(c));
    }jc.prototype.rf = function () {
        var a = this.Vc.get(),
            b = {},
            c = !1,
            d;for (d in a) {
            0 < a[d] && Bb(this.zf, d) && (b[d] = a[d], c = !0);
        }c && this.va.ye(b);setTimeout(r(this.rf, this), Math.floor(6E5 * Math.random()));
    };function lc() {
        this.uc = {};
    }function mc(a, b, c) {
        p(c) || (c = 1);Bb(a.uc, b) || (a.uc[b] = 0);a.uc[b] += c;
    }lc.prototype.get = function () {
        return ya(this.uc);
    };function kc(a) {
        this.Nf = a;this.rd = null;
    }kc.prototype.get = function () {
        var a = this.Nf.get(),
            b = ya(a);if (this.rd) for (var c in this.rd) {
            b[c] -= this.rd[c];
        }this.rd = a;return b;
    };var nc = {},
        oc = {};function pc(a) {
        a = a.toString();nc[a] || (nc[a] = new lc());return nc[a];
    }function qc(a, b) {
        var c = a.toString();oc[c] || (oc[c] = b());return oc[c];
    };function rc() {
        this.wb = [];
    }function sc(a, b) {
        for (var c = null, d = 0; d < b.length; d++) {
            var e = b[d],
                f = e.Zb();null === c || f.ca(c.Zb()) || (a.wb.push(c), c = null);null === c && (c = new tc(f));c.add(e);
        }c && a.wb.push(c);
    }function uc(a, b, c) {
        sc(a, c);vc(a, function (a) {
            return a.ca(b);
        });
    }function wc(a, b, c) {
        sc(a, c);vc(a, function (a) {
            return a.contains(b) || b.contains(a);
        });
    }
    function vc(a, b) {
        for (var c = !0, d = 0; d < a.wb.length; d++) {
            var e = a.wb[d];if (e) if (e = e.Zb(), b(e)) {
                for (var e = a.wb[d], f = 0; f < e.hd.length; f++) {
                    var g = e.hd[f];if (null !== g) {
                        e.hd[f] = null;var k = g.Ub();xc && E("event: " + g.toString());Ub(k);
                    }
                }a.wb[d] = null;
            } else c = !1;
        }c && (a.wb = []);
    }function tc(a) {
        this.qa = a;this.hd = [];
    }tc.prototype.add = function (a) {
        this.hd.push(a);
    };tc.prototype.Zb = function () {
        return this.qa;
    };function yc(a, b, c, d) {
        this.ae = b;this.Md = c;this.Dd = d;this.gd = a;
    }yc.prototype.Zb = function () {
        var a = this.Md.xb();return "value" === this.gd ? a.path : a.getParent().path;
    };yc.prototype.ge = function () {
        return this.gd;
    };yc.prototype.Ub = function () {
        return this.ae.Ub(this);
    };yc.prototype.toString = function () {
        return this.Zb().toString() + ":" + this.gd + ":" + B(this.Md.Ue());
    };function zc(a, b, c) {
        this.ae = a;this.error = b;this.path = c;
    }zc.prototype.Zb = function () {
        return this.path;
    };zc.prototype.ge = function () {
        return "cancel";
    };
    zc.prototype.Ub = function () {
        return this.ae.Ub(this);
    };zc.prototype.toString = function () {
        return this.path.toString() + ":cancel";
    };function Ac() {}Ac.prototype.Xe = function () {
        return null;
    };Ac.prototype.fe = function () {
        return null;
    };var Bc = new Ac();function Cc(a, b, c) {
        this.Gf = a;this.Na = b;this.yd = c;
    }Cc.prototype.Xe = function (a) {
        var b = this.Na.O;if (Dc(b, a)) return b.j().R(a);b = null != this.yd ? new Ec(this.yd, !0, !1) : this.Na.u();return this.Gf.rc(a, b);
    };Cc.prototype.fe = function (a, b, c) {
        var d = null != this.yd ? this.yd : Fc(this.Na);a = this.Gf.Xd(d, b, 1, c, a);return 0 === a.length ? null : a[0];
    };function I(a, b, c, d) {
        this.type = a;this.Ma = b;this.Za = c;this.qe = d;this.Dd = void 0;
    }function Gc(a) {
        return new I(Hc, a);
    }var Hc = "value";function Ec(a, b, c) {
        this.A = a;this.ea = b;this.Tb = c;
    }function Ic(a) {
        return a.ea;
    }function Jc(a) {
        return a.Tb;
    }function Kc(a, b) {
        return b.e() ? a.ea && !a.Tb : Dc(a, J(b));
    }function Dc(a, b) {
        return a.ea && !a.Tb || a.A.Fa(b);
    }Ec.prototype.j = function () {
        return this.A;
    };function Lc(a, b) {
        return Mc(a.name, b.name);
    }function Nc(a, b) {
        return Mc(a, b);
    };function K(a, b) {
        this.name = a;this.S = b;
    }function Oc(a, b) {
        return new K(a, b);
    };function Pc(a, b) {
        return a && "object" === (typeof a === "undefined" ? "undefined" : _typeof(a)) ? (H(".sv" in a, "Unexpected leaf node or priority contents"), b[a[".sv"]]) : a;
    }function Qc(a, b) {
        var c = new Rc();Sc(a, new L(""), function (a, e) {
            Tc(c, a, Uc(e, b));
        });return c;
    }function Uc(a, b) {
        var c = a.C().H(),
            c = Pc(c, b),
            d;if (a.J()) {
            var e = Pc(a.Ea(), b);return e !== a.Ea() || c !== a.C().H() ? new Vc(e, M(c)) : a;
        }d = a;c !== a.C().H() && (d = d.ga(new Vc(c)));a.P(N, function (a, c) {
            var e = Uc(c, b);e !== c && (d = d.U(a, e));
        });return d;
    };var Wc = function () {
        var a = 1;return function () {
            return a++;
        };
    }(),
        H = Kb,
        Xc = Lb;
    function Yc(a) {
        try {
            var b;bb();for (var c = $a, d = [], e = 0; e < a.length;) {
                var f = c[a.charAt(e++)],
                    g = e < a.length ? c[a.charAt(e)] : 0;++e;var k = e < a.length ? c[a.charAt(e)] : 64;++e;var m = e < a.length ? c[a.charAt(e)] : 64;++e;if (null == f || null == g || null == k || null == m) throw Error();d.push(f << 2 | g >> 4);64 != k && (d.push(g << 4 & 240 | k >> 2), 64 != m && d.push(k << 6 & 192 | m));
            }if (8192 > d.length) b = String.fromCharCode.apply(null, d);else {
                a = "";for (c = 0; c < d.length; c += 8192) {
                    a += String.fromCharCode.apply(null, Ra(d, c, c + 8192));
                }b = a;
            }return b;
        } catch (l) {
            E("base64Decode failed: ", l);
        }return null;
    }function Zc(a) {
        var b = Mb(a);a = new ma();a.update(b);var b = [],
            c = 8 * a.Pd;56 > a.ac ? a.update(a.zd, 56 - a.ac) : a.update(a.zd, a.Ya - (a.ac - 56));for (var d = a.Ya - 1; 56 <= d; d--) {
            a.Wd[d] = c & 255, c /= 256;
        }na(a, a.Wd);for (d = c = 0; 5 > d; d++) {
            for (var e = 24; 0 <= e; e -= 8) {
                b[c] = a.N[d] >> e & 255, ++c;
            }
        }return ab(b);
    }function $c(a) {
        for (var b = "", c = 0; c < arguments.length; c++) {
            b = ea(arguments[c]) ? b + $c.apply(null, arguments[c]) : "object" === _typeof(arguments[c]) ? b + B(arguments[c]) : b + arguments[c], b += " ";
        }return b;
    }var xc = null,
        ad = !0;
    function bd(a, b) {
        Kb(!b || !0 === a || !1 === a, "Can't turn on custom loggers persistently.");!0 === a ? ("undefined" !== typeof console && ("function" === typeof console.log ? xc = r(console.log, console) : "object" === _typeof(console.log) && (xc = function xc(a) {
            console.log(a);
        })), b && Zb.set("logging_enabled", !0)) : ga(a) ? xc = a : (xc = null, Zb.remove("logging_enabled"));
    }function E(a) {
        !0 === ad && (ad = !1, null === xc && !0 === Zb.get("logging_enabled") && bd(!0));if (xc) {
            var b = $c.apply(null, arguments);xc(b);
        }
    }
    function cd(a) {
        return function () {
            E(a, arguments);
        };
    }function dd(a) {
        if ("undefined" !== typeof console) {
            var b = "FIREBASE INTERNAL ERROR: " + $c.apply(null, arguments);"undefined" !== typeof console.error ? console.error(b) : console.log(b);
        }
    }function ed(a) {
        var b = $c.apply(null, arguments);throw Error("FIREBASE FATAL ERROR: " + b);
    }function O(a) {
        if ("undefined" !== typeof console) {
            var b = "FIREBASE WARNING: " + $c.apply(null, arguments);"undefined" !== typeof console.warn ? console.warn(b) : console.log(b);
        }
    }
    function fd(a) {
        var b,
            c,
            d,
            e,
            f,
            g = a;f = c = a = b = "";d = !0;e = "https";if (q(g)) {
            var k = g.indexOf("//");0 <= k && (e = g.substring(0, k - 1), g = g.substring(k + 2));k = g.indexOf("/");-1 === k && (k = g.length);b = g.substring(0, k);f = "";g = g.substring(k).split("/");for (k = 0; k < g.length; k++) {
                if (0 < g[k].length) {
                    var m = g[k];try {
                        m = decodeURIComponent(m.replace(/\+/g, " "));
                    } catch (l) {}f += "/" + m;
                }
            }g = b.split(".");3 === g.length ? (a = g[1], c = g[0].toLowerCase()) : 2 === g.length && (a = g[0]);k = b.indexOf(":");0 <= k && (d = "https" === e || "wss" === e);
        }"firebase" === a && ed(b + " is no longer supported. Please use <YOUR FIREBASE>.firebaseio.com instead");
        c && "undefined" != c || ed("Cannot parse Firebase url. Please use https://<YOUR FIREBASE>.firebaseio.com");d || "undefined" !== typeof window && window.location && window.location.protocol && -1 !== window.location.protocol.indexOf("https:") && O("Insecure Firebase access from a secure page. Please use https in calls to new Firebase().");return { kc: new gc(b, d, c, "ws" === e || "wss" === e), path: new L(f) };
    }function gd(a) {
        return fa(a) && (a != a || a == Number.POSITIVE_INFINITY || a == Number.NEGATIVE_INFINITY);
    }
    function hd(a) {
        if ("complete" === document.readyState) a();else {
            var b = !1,
                c = function c() {
                document.body ? b || (b = !0, a()) : setTimeout(c, Math.floor(10));
            };document.addEventListener ? (document.addEventListener("DOMContentLoaded", c, !1), window.addEventListener("load", c, !1)) : document.attachEvent && (document.attachEvent("onreadystatechange", function () {
                "complete" === document.readyState && c();
            }), window.attachEvent("onload", c));
        }
    }
    function Mc(a, b) {
        if (a === b) return 0;if ("[MIN_NAME]" === a || "[MAX_NAME]" === b) return -1;if ("[MIN_NAME]" === b || "[MAX_NAME]" === a) return 1;var c = id(a),
            d = id(b);return null !== c ? null !== d ? 0 == c - d ? a.length - b.length : c - d : -1 : null !== d ? 1 : a < b ? -1 : 1;
    }function jd(a, b) {
        if (b && a in b) return b[a];throw Error("Missing required key (" + a + ") in object: " + B(b));
    }
    function kd(a) {
        if ("object" !== (typeof a === "undefined" ? "undefined" : _typeof(a)) || null === a) return B(a);var b = [],
            c;for (c in a) {
            b.push(c);
        }b.sort();c = "{";for (var d = 0; d < b.length; d++) {
            0 !== d && (c += ","), c += B(b[d]), c += ":", c += kd(a[b[d]]);
        }return c + "}";
    }function ld(a, b) {
        if (a.length <= b) return [a];for (var c = [], d = 0; d < a.length; d += b) {
            d + b > a ? c.push(a.substring(d, a.length)) : c.push(a.substring(d, d + b));
        }return c;
    }function md(a, b) {
        if (da(a)) for (var c = 0; c < a.length; ++c) {
            b(c, a[c]);
        } else t(a, b);
    }
    function nd(a) {
        H(!gd(a), "Invalid JSON number");var b, c, d, e;0 === a ? (d = c = 0, b = -Infinity === 1 / a ? 1 : 0) : (b = 0 > a, a = Math.abs(a), a >= Math.pow(2, -1022) ? (d = Math.min(Math.floor(Math.log(a) / Math.LN2), 1023), c = d + 1023, d = Math.round(a * Math.pow(2, 52 - d) - Math.pow(2, 52))) : (c = 0, d = Math.round(a / Math.pow(2, -1074))));e = [];for (a = 52; a; --a) {
            e.push(d % 2 ? 1 : 0), d = Math.floor(d / 2);
        }for (a = 11; a; --a) {
            e.push(c % 2 ? 1 : 0), c = Math.floor(c / 2);
        }e.push(b ? 1 : 0);e.reverse();b = e.join("");c = "";for (a = 0; 64 > a; a += 8) {
            d = parseInt(b.substr(a, 8), 2).toString(16), 1 === d.length && (d = "0" + d), c += d;
        }return c.toLowerCase();
    }var od = /^-?\d{1,10}$/;function id(a) {
        return od.test(a) && (a = Number(a), -2147483648 <= a && 2147483647 >= a) ? a : null;
    }function Ub(a) {
        try {
            a();
        } catch (b) {
            setTimeout(function () {
                O("Exception was thrown by user callback.", b.stack || "");throw b;
            }, Math.floor(0));
        }
    }function pd(a, b, c) {
        Object.defineProperty(a, b, { get: c });
    };function qd(a) {
        var b = {},
            c = {},
            d = {},
            e = "";try {
            var f = a.split("."),
                b = Ob(Yc(f[0]) || ""),
                c = Ob(Yc(f[1]) || ""),
                e = f[2],
                d = c.d || {};delete c.d;
        } catch (g) {}return { Fg: b, Me: c, data: d, xg: e };
    }function rd(a) {
        a = qd(a);var b = a.Me;return !!a.xg && !!b && "object" === (typeof b === "undefined" ? "undefined" : _typeof(b)) && b.hasOwnProperty("iat");
    }function sd(a) {
        a = qd(a).Me;return "object" === (typeof a === "undefined" ? "undefined" : _typeof(a)) && !0 === x(a, "admin");
    };var ud = null;"undefined" !== typeof MozWebSocket ? ud = MozWebSocket : "undefined" !== typeof WebSocket && (ud = WebSocket);function vd(a, b, c, d) {
        this.Zd = a;this.f = cd(this.Zd);this.frames = this.Ac = null;this.qb = this.rb = this.Fe = 0;this.Xa = pc(b);a = { v: "5" };"undefined" !== typeof location && location.href && -1 !== location.href.indexOf("firebaseio.com") && (a.r = "f");c && (a.s = c);d && (a.ls = d);this.Ne = ic(b, "websocket", a);
    }var wd;
    vd.prototype.open = function (a, b) {
        this.kb = b;this.hg = a;this.f("Websocket connecting to " + this.Ne);this.xc = !1;Yb.set("previous_websocket_failure", !0);try {
            this.La = new ud(this.Ne);
        } catch (c) {
            this.f("Error instantiating WebSocket.");var d = c.message || c.data;d && this.f(d);this.fb();return;
        }var e = this;this.La.onopen = function () {
            e.f("Websocket connected.");e.xc = !0;
        };this.La.onclose = function () {
            e.f("Websocket connection was disconnected.");e.La = null;e.fb();
        };this.La.onmessage = function (a) {
            if (null !== e.La) if (a = a.data, e.qb += a.length, mc(e.Xa, "bytes_received", a.length), xd(e), null !== e.frames) yd(e, a);else {
                a: {
                    H(null === e.frames, "We already have a frame buffer");if (6 >= a.length) {
                        var b = Number(a);if (!isNaN(b)) {
                            e.Fe = b;e.frames = [];a = null;break a;
                        }
                    }e.Fe = 1;e.frames = [];
                }null !== a && yd(e, a);
            }
        };this.La.onerror = function (a) {
            e.f("WebSocket error.  Closing connection.");(a = a.message || a.data) && e.f(a);e.fb();
        };
    };vd.prototype.start = function () {};
    vd.isAvailable = function () {
        var a = !1;if ("undefined" !== typeof navigator && navigator.userAgent) {
            var b = navigator.userAgent.match(/Android ([0-9]{0,}\.[0-9]{0,})/);b && 1 < b.length && 4.4 > parseFloat(b[1]) && (a = !0);
        }return !a && null !== ud && !wd;
    };vd.responsesRequiredToBeHealthy = 2;vd.healthyTimeout = 3E4;h = vd.prototype;h.sd = function () {
        Yb.remove("previous_websocket_failure");
    };function yd(a, b) {
        a.frames.push(b);if (a.frames.length == a.Fe) {
            var c = a.frames.join("");a.frames = null;c = Ob(c);a.hg(c);
        }
    }
    h.send = function (a) {
        xd(this);a = B(a);this.rb += a.length;mc(this.Xa, "bytes_sent", a.length);a = ld(a, 16384);1 < a.length && zd(this, String(a.length));for (var b = 0; b < a.length; b++) {
            zd(this, a[b]);
        }
    };h.Tc = function () {
        this.Bb = !0;this.Ac && (clearInterval(this.Ac), this.Ac = null);this.La && (this.La.close(), this.La = null);
    };h.fb = function () {
        this.Bb || (this.f("WebSocket is closing itself"), this.Tc(), this.kb && (this.kb(this.xc), this.kb = null));
    };h.close = function () {
        this.Bb || (this.f("WebSocket is being closed"), this.Tc());
    };
    function xd(a) {
        clearInterval(a.Ac);a.Ac = setInterval(function () {
            a.La && zd(a, "0");xd(a);
        }, Math.floor(45E3));
    }function zd(a, b) {
        try {
            a.La.send(b);
        } catch (c) {
            a.f("Exception thrown from WebSocket.send():", c.message || c.data, "Closing connection."), setTimeout(r(a.fb, a), 0);
        }
    };function Ad(a, b, c) {
        this.f = cd("p:rest:");this.M = a;this.Hb = b;this.Vd = c;this.$ = {};
    }function Bd(a, b) {
        if (p(b)) return "tag$" + b;H(Cd(a.n), "should have a tag if it's not a default query.");return a.path.toString();
    }h = Ad.prototype;
    h.df = function (a, b, c, d) {
        var e = a.path.toString();this.f("Listen called for " + e + " " + a.ya());var f = Bd(a, c),
            g = {};this.$[f] = g;a = Dd(a.n);var k = this;Ed(this, e + ".json", a, function (a, b) {
            var u = b;404 === a && (a = u = null);null === a && k.Hb(e, u, !1, c);x(k.$, f) === g && d(a ? 401 == a ? "permission_denied" : "rest_error:" + a : "ok", null);
        });
    };h.Ef = function (a, b) {
        var c = Bd(a, b);delete this.$[c];
    };h.qf = function () {};h.re = function () {};h.gf = function () {};h.xd = function () {};h.put = function () {};h.ef = function () {};h.ye = function () {};
    function Ed(a, b, c, d) {
        c = c || {};c.format = "export";a.Vd.getToken(!1).then(function (e) {
            (e = e && e.accessToken) && (c.auth = e);var f = (a.M.Sc ? "https://" : "http://") + a.M.host + b + "?" + Fb(c);a.f("Sending REST request for " + f);var g = new XMLHttpRequest();g.onreadystatechange = function () {
                if (d && 4 === g.readyState) {
                    a.f("REST Response for " + f + " received. status:", g.status, "response:", g.responseText);var b = null;if (200 <= g.status && 300 > g.status) {
                        try {
                            b = Ob(g.responseText);
                        } catch (c) {
                            O("Failed to parse JSON response for " + f + ": " + g.responseText);
                        }d(null, b);
                    } else 401 !== g.status && 404 !== g.status && O("Got unsuccessful REST response for " + f + " Status: " + g.status), d(g.status);d = null;
                }
            };g.open("GET", f, !0);g.send();
        });
    };function Fd(a, b, c) {
        this.type = Gd;this.source = a;this.path = b;this.children = c;
    }Fd.prototype.Nc = function (a) {
        if (this.path.e()) return a = this.children.subtree(new L(a)), a.e() ? null : a.value ? new $b(this.source, C, a.value) : new Fd(this.source, C, a);H(J(this.path) === a, "Can't get a merge for a child not on the path of the operation");return new Fd(this.source, D(this.path), this.children);
    };Fd.prototype.toString = function () {
        return "Operation(" + this.path + ": " + this.source.toString() + " merge: " + this.children.toString() + ")";
    };function Hd() {
        this.hb = {};
    }
    function Id(a, b) {
        var c = b.type,
            d = b.Za;H("child_added" == c || "child_changed" == c || "child_removed" == c, "Only child changes supported for tracking");H(".priority" !== d, "Only non-priority child changes can be tracked.");var e = x(a.hb, d);if (e) {
            var f = e.type;if ("child_added" == c && "child_removed" == f) a.hb[d] = new I("child_changed", b.Ma, d, e.Ma);else if ("child_removed" == c && "child_added" == f) delete a.hb[d];else if ("child_removed" == c && "child_changed" == f) a.hb[d] = new I("child_removed", e.qe, d);else if ("child_changed" == c && "child_added" == f) a.hb[d] = new I("child_added", b.Ma, d);else if ("child_changed" == c && "child_changed" == f) a.hb[d] = new I("child_changed", b.Ma, d, e.qe);else throw Xc("Illegal combination of changes: " + b + " occurred after " + e);
        } else a.hb[d] = b;
    };function Jd(a) {
        this.W = a;this.g = a.n.g;
    }function Kd(a, b, c, d) {
        var e = [],
            f = [];Ja(b, function (b) {
            "child_changed" === b.type && a.g.nd(b.qe, b.Ma) && f.push(new I("child_moved", b.Ma, b.Za));
        });Ld(a, e, "child_removed", b, d, c);Ld(a, e, "child_added", b, d, c);Ld(a, e, "child_moved", f, d, c);Ld(a, e, "child_changed", b, d, c);Ld(a, e, Hc, b, d, c);return e;
    }function Ld(a, b, c, d, e, f) {
        d = Ka(d, function (a) {
            return a.type === c;
        });Sa(d, r(a.Of, a));Ja(d, function (c) {
            var d = Md(a, c, f);Ja(e, function (e) {
                e.tf(c.type) && b.push(e.createEvent(d, a.W));
            });
        });
    }
    function Md(a, b, c) {
        "value" !== b.type && "child_removed" !== b.type && (b.Dd = c.Ze(b.Za, b.Ma, a.g));return b;
    }Jd.prototype.Of = function (a, b) {
        if (null == a.Za || null == b.Za) throw Xc("Should only compare child_ events.");return this.g.compare(new K(a.Za, a.Ma), new K(b.Za, b.Ma));
    };function Nd(a, b) {
        this.Sd = a;this.Mf = b;
    }function Od(a) {
        this.V = a;
    }
    Od.prototype.gb = function (a, b, c, d) {
        var e = new Hd(),
            f;if (b.type === ac) b.source.ee ? c = Pd(this, a, b.path, b.Ja, c, d, e) : (H(b.source.We, "Unknown source."), f = b.source.Ee || Jc(a.u()) && !b.path.e(), c = Qd(this, a, b.path, b.Ja, c, d, f, e));else if (b.type === Gd) b.source.ee ? c = Rd(this, a, b.path, b.children, c, d, e) : (H(b.source.We, "Unknown source."), f = b.source.Ee || Jc(a.u()), c = Sd(this, a, b.path, b.children, c, d, f, e));else if (b.type === Td) {
            if (b.Id) {
                if (b = b.path, null != c.mc(b)) c = a;else {
                    f = new Cc(c, a, d);d = a.O.j();if (b.e() || ".priority" === J(b)) Ic(a.u()) ? b = c.Ba(Fc(a)) : (b = a.u().j(), H(b instanceof P, "serverChildren would be complete if leaf node"), b = c.sc(b)), b = this.V.za(d, b, e);else {
                        var g = J(b),
                            k = c.rc(g, a.u());null == k && Dc(a.u(), g) && (k = d.R(g));b = null != k ? this.V.F(d, g, k, D(b), f, e) : a.O.j().Fa(g) ? this.V.F(d, g, F, D(b), f, e) : d;b.e() && Ic(a.u()) && (d = c.Ba(Fc(a)), d.J() && (b = this.V.za(b, d, e)));
                    }d = Ic(a.u()) || null != c.mc(C);c = Ud(a, b, d, this.V.Qa());
                }
            } else c = Vd(this, a, b.path, b.Pb, c, d, e);
        } else if (b.type === cc) d = b.path, b = a.u(), f = b.j(), g = b.ea || d.e(), c = Wd(this, new Xd(a.O, new Ec(f, g, b.Tb)), d, c, Bc, e);else throw Xc("Unknown operation type: " + b.type);e = sa(e.hb);d = c;b = d.O;b.ea && (f = b.j().J() || b.j().e(), g = Yd(a), (0 < e.length || !a.O.ea || f && !b.j().ca(g) || !b.j().C().ca(g.C())) && e.push(Gc(Yd(d))));return new Nd(c, e);
    };
    function Wd(a, b, c, d, e, f) {
        var g = b.O;if (null != d.mc(c)) return b;var k;if (c.e()) H(Ic(b.u()), "If change path is empty, we must have complete server data"), Jc(b.u()) ? (e = Fc(b), d = d.sc(e instanceof P ? e : F)) : d = d.Ba(Fc(b)), f = a.V.za(b.O.j(), d, f);else {
            var m = J(c);if (".priority" == m) H(1 == Zd(c), "Can't have a priority with additional path components"), f = g.j(), k = b.u().j(), d = d.$c(c, f, k), f = null != d ? a.V.ga(f, d) : g.j();else {
                var l = D(c);Dc(g, m) ? (k = b.u().j(), d = d.$c(c, g.j(), k), d = null != d ? g.j().R(m).F(l, d) : g.j().R(m)) : d = d.rc(m, b.u());f = null != d ? a.V.F(g.j(), m, d, l, e, f) : g.j();
            }
        }return Ud(b, f, g.ea || c.e(), a.V.Qa());
    }function Qd(a, b, c, d, e, f, g, k) {
        var m = b.u();g = g ? a.V : a.V.Vb();if (c.e()) d = g.za(m.j(), d, null);else if (g.Qa() && !m.Tb) d = m.j().F(c, d), d = g.za(m.j(), d, null);else {
            var l = J(c);if (!Kc(m, c) && 1 < Zd(c)) return b;var u = D(c);d = m.j().R(l).F(u, d);d = ".priority" == l ? g.ga(m.j(), d) : g.F(m.j(), l, d, u, Bc, null);
        }m = m.ea || c.e();b = new Xd(b.O, new Ec(d, m, g.Qa()));return Wd(a, b, c, e, new Cc(e, b, f), k);
    }
    function Pd(a, b, c, d, e, f, g) {
        var k = b.O;e = new Cc(e, b, f);if (c.e()) g = a.V.za(b.O.j(), d, g), a = Ud(b, g, !0, a.V.Qa());else if (f = J(c), ".priority" === f) g = a.V.ga(b.O.j(), d), a = Ud(b, g, k.ea, k.Tb);else {
            c = D(c);var m = k.j().R(f);if (!c.e()) {
                var l = e.Xe(f);d = null != l ? ".priority" === $d(c) && l.Q(c.parent()).e() ? l : l.F(c, d) : F;
            }m.ca(d) ? a = b : (g = a.V.F(k.j(), f, d, c, e, g), a = Ud(b, g, k.ea, a.V.Qa()));
        }return a;
    }
    function Rd(a, b, c, d, e, f, g) {
        var k = b;ae(d, function (d, l) {
            var u = c.m(d);Dc(b.O, J(u)) && (k = Pd(a, k, u, l, e, f, g));
        });ae(d, function (d, l) {
            var u = c.m(d);Dc(b.O, J(u)) || (k = Pd(a, k, u, l, e, f, g));
        });return k;
    }function be(a, b) {
        ae(b, function (b, d) {
            a = a.F(b, d);
        });return a;
    }
    function Sd(a, b, c, d, e, f, g, k) {
        if (b.u().j().e() && !Ic(b.u())) return b;var m = b;c = c.e() ? d : ce(Q, c, d);var l = b.u().j();c.children.ia(function (c, d) {
            if (l.Fa(c)) {
                var G = b.u().j().R(c),
                    G = be(G, d);m = Qd(a, m, new L(c), G, e, f, g, k);
            }
        });c.children.ia(function (c, d) {
            var G = !Dc(b.u(), c) && null == d.value;l.Fa(c) || G || (G = b.u().j().R(c), G = be(G, d), m = Qd(a, m, new L(c), G, e, f, g, k));
        });return m;
    }
    function Vd(a, b, c, d, e, f, g) {
        if (null != e.mc(c)) return b;var k = Jc(b.u()),
            m = b.u();if (null != d.value) {
            if (c.e() && m.ea || Kc(m, c)) return Qd(a, b, c, m.j().Q(c), e, f, k, g);if (c.e()) {
                var l = Q;m.j().P(de, function (a, b) {
                    l = l.set(new L(a), b);
                });return Sd(a, b, c, l, e, f, k, g);
            }return b;
        }l = Q;ae(d, function (a) {
            var b = c.m(a);Kc(m, b) && (l = l.set(a, m.j().Q(b)));
        });return Sd(a, b, c, l, e, f, k, g);
    };function ee(a) {
        this.g = a;
    }h = ee.prototype;h.F = function (a, b, c, d, e, f) {
        H(a.zc(this.g), "A node must be indexed if only a child is updated");e = a.R(b);if (e.Q(d).ca(c.Q(d)) && e.e() == c.e()) return a;null != f && (c.e() ? a.Fa(b) ? Id(f, new I("child_removed", e, b)) : H(a.J(), "A child remove without an old child only makes sense on a leaf node") : e.e() ? Id(f, new I("child_added", c, b)) : Id(f, new I("child_changed", c, b, e)));return a.J() && c.e() ? a : a.U(b, c).ob(this.g);
    };
    h.za = function (a, b, c) {
        null != c && (a.J() || a.P(N, function (a, e) {
            b.Fa(a) || Id(c, new I("child_removed", e, a));
        }), b.J() || b.P(N, function (b, e) {
            if (a.Fa(b)) {
                var f = a.R(b);f.ca(e) || Id(c, new I("child_changed", e, b, f));
            } else Id(c, new I("child_added", e, b));
        }));return b.ob(this.g);
    };h.ga = function (a, b) {
        return a.e() ? F : a.ga(b);
    };h.Qa = function () {
        return !1;
    };h.Vb = function () {
        return this;
    };function fe(a) {
        this.he = new ee(a.g);this.g = a.g;var b;a.ka ? (b = ge(a), b = a.g.Fc(he(a), b)) : b = a.g.Ic();this.Uc = b;a.na ? (b = ie(a), a = a.g.Fc(je(a), b)) : a = a.g.Gc();this.wc = a;
    }h = fe.prototype;h.matches = function (a) {
        return 0 >= this.g.compare(this.Uc, a) && 0 >= this.g.compare(a, this.wc);
    };h.F = function (a, b, c, d, e, f) {
        this.matches(new K(b, c)) || (c = F);return this.he.F(a, b, c, d, e, f);
    };
    h.za = function (a, b, c) {
        b.J() && (b = F);var d = b.ob(this.g),
            d = d.ga(F),
            e = this;b.P(N, function (a, b) {
            e.matches(new K(a, b)) || (d = d.U(a, F));
        });return this.he.za(a, d, c);
    };h.ga = function (a) {
        return a;
    };h.Qa = function () {
        return !0;
    };h.Vb = function () {
        return this.he;
    };function ke(a) {
        this.sa = new fe(a);this.g = a.g;H(a.xa, "Only valid if limit has been set");this.oa = a.oa;this.Jb = !le(a);
    }h = ke.prototype;h.F = function (a, b, c, d, e, f) {
        this.sa.matches(new K(b, c)) || (c = F);return a.R(b).ca(c) ? a : a.Fb() < this.oa ? this.sa.Vb().F(a, b, c, d, e, f) : me(this, a, b, c, e, f);
    };
    h.za = function (a, b, c) {
        var d;if (b.J() || b.e()) d = F.ob(this.g);else if (2 * this.oa < b.Fb() && b.zc(this.g)) {
            d = F.ob(this.g);b = this.Jb ? b.$b(this.sa.wc, this.g) : b.Yb(this.sa.Uc, this.g);for (var e = 0; 0 < b.Sa.length && e < this.oa;) {
                var f = R(b),
                    g;if (g = this.Jb ? 0 >= this.g.compare(this.sa.Uc, f) : 0 >= this.g.compare(f, this.sa.wc)) d = d.U(f.name, f.S), e++;else break;
            }
        } else {
            d = b.ob(this.g);d = d.ga(F);var k, m, l;if (this.Jb) {
                b = d.$e(this.g);k = this.sa.wc;m = this.sa.Uc;var u = ne(this.g);l = function l(a, b) {
                    return u(b, a);
                };
            } else b = d.Xb(this.g), k = this.sa.Uc, m = this.sa.wc, l = ne(this.g);for (var e = 0, z = !1; 0 < b.Sa.length;) {
                f = R(b), !z && 0 >= l(k, f) && (z = !0), (g = z && e < this.oa && 0 >= l(f, m)) ? e++ : d = d.U(f.name, F);
            }
        }return this.sa.Vb().za(a, d, c);
    };h.ga = function (a) {
        return a;
    };h.Qa = function () {
        return !0;
    };h.Vb = function () {
        return this.sa.Vb();
    };
    function me(a, b, c, d, e, f) {
        var g;if (a.Jb) {
            var k = ne(a.g);g = function g(a, b) {
                return k(b, a);
            };
        } else g = ne(a.g);H(b.Fb() == a.oa, "");var m = new K(c, d),
            l = a.Jb ? oe(b, a.g) : pe(b, a.g),
            u = a.sa.matches(m);if (b.Fa(c)) {
            for (var z = b.R(c), l = e.fe(a.g, l, a.Jb); null != l && (l.name == c || b.Fa(l.name));) {
                l = e.fe(a.g, l, a.Jb);
            }e = null == l ? 1 : g(l, m);if (u && !d.e() && 0 <= e) return null != f && Id(f, new I("child_changed", d, c, z)), b.U(c, d);null != f && Id(f, new I("child_removed", z, c));b = b.U(c, F);return null != l && a.sa.matches(l) ? (null != f && Id(f, new I("child_added", l.S, l.name)), b.U(l.name, l.S)) : b;
        }return d.e() ? b : u && 0 <= g(l, m) ? (null != f && (Id(f, new I("child_removed", l.S, l.name)), Id(f, new I("child_added", d, c))), b.U(c, d).U(l.name, F)) : b;
    };function Vc(a, b) {
        this.B = a;H(p(this.B) && null !== this.B, "LeafNode shouldn't be created with null/undefined value.");this.aa = b || F;qe(this.aa);this.Eb = null;
    }var re = ["object", "boolean", "number", "string"];h = Vc.prototype;h.J = function () {
        return !0;
    };h.C = function () {
        return this.aa;
    };h.ga = function (a) {
        return new Vc(this.B, a);
    };h.R = function (a) {
        return ".priority" === a ? this.aa : F;
    };h.Q = function (a) {
        return a.e() ? this : ".priority" === J(a) ? this.aa : F;
    };h.Fa = function () {
        return !1;
    };h.Ze = function () {
        return null;
    };
    h.U = function (a, b) {
        return ".priority" === a ? this.ga(b) : b.e() && ".priority" !== a ? this : F.U(a, b).ga(this.aa);
    };h.F = function (a, b) {
        var c = J(a);if (null === c) return b;if (b.e() && ".priority" !== c) return this;H(".priority" !== c || 1 === Zd(a), ".priority must be the last token in a path");return this.U(c, F.F(D(a), b));
    };h.e = function () {
        return !1;
    };h.Fb = function () {
        return 0;
    };h.P = function () {
        return !1;
    };h.H = function (a) {
        return a && !this.C().e() ? { ".value": this.Ea(), ".priority": this.C().H() } : this.Ea();
    };
    h.hash = function () {
        if (null === this.Eb) {
            var a = "";this.aa.e() || (a += "priority:" + se(this.aa.H()) + ":");var b = _typeof(this.B),
                a = a + (b + ":"),
                a = "number" === b ? a + nd(this.B) : a + this.B;this.Eb = Zc(a);
        }return this.Eb;
    };h.Ea = function () {
        return this.B;
    };h.tc = function (a) {
        if (a === F) return 1;if (a instanceof P) return -1;H(a.J(), "Unknown node type");var b = _typeof(a.B),
            c = _typeof(this.B),
            d = Ia(re, b),
            e = Ia(re, c);H(0 <= d, "Unknown leaf type: " + b);H(0 <= e, "Unknown leaf type: " + c);return d === e ? "object" === c ? 0 : this.B < a.B ? -1 : this.B === a.B ? 0 : 1 : e - d;
    };
    h.ob = function () {
        return this;
    };h.zc = function () {
        return !0;
    };h.ca = function (a) {
        return a === this ? !0 : a.J() ? this.B === a.B && this.aa.ca(a.aa) : !1;
    };h.toString = function () {
        return B(this.H(!0));
    };function te() {}var ue = {};function ne(a) {
        return r(a.compare, a);
    }te.prototype.nd = function (a, b) {
        return 0 !== this.compare(new K("[MIN_NAME]", a), new K("[MIN_NAME]", b));
    };te.prototype.Ic = function () {
        return ve;
    };function we(a) {
        H(!a.e() && ".priority" !== J(a), "Can't create PathIndex with empty path or .priority key");this.cc = a;
    }ka(we, te);h = we.prototype;h.yc = function (a) {
        return !a.Q(this.cc).e();
    };h.compare = function (a, b) {
        var c = a.S.Q(this.cc),
            d = b.S.Q(this.cc),
            c = c.tc(d);return 0 === c ? Mc(a.name, b.name) : c;
    };
    h.Fc = function (a, b) {
        var c = M(a),
            c = F.F(this.cc, c);return new K(b, c);
    };h.Gc = function () {
        var a = F.F(this.cc, xe);return new K("[MAX_NAME]", a);
    };h.toString = function () {
        return this.cc.slice().join("/");
    };function ye() {}ka(ye, te);h = ye.prototype;h.compare = function (a, b) {
        var c = a.S.C(),
            d = b.S.C(),
            c = c.tc(d);return 0 === c ? Mc(a.name, b.name) : c;
    };h.yc = function (a) {
        return !a.C().e();
    };h.nd = function (a, b) {
        return !a.C().ca(b.C());
    };h.Ic = function () {
        return ve;
    };h.Gc = function () {
        return new K("[MAX_NAME]", new Vc("[PRIORITY-POST]", xe));
    };
    h.Fc = function (a, b) {
        var c = M(a);return new K(b, new Vc("[PRIORITY-POST]", c));
    };h.toString = function () {
        return ".priority";
    };var N = new ye();function ze() {}ka(ze, te);h = ze.prototype;h.compare = function (a, b) {
        return Mc(a.name, b.name);
    };h.yc = function () {
        throw Xc("KeyIndex.isDefinedOn not expected to be called.");
    };h.nd = function () {
        return !1;
    };h.Ic = function () {
        return ve;
    };h.Gc = function () {
        return new K("[MAX_NAME]", F);
    };h.Fc = function (a) {
        H(q(a), "KeyIndex indexValue must always be a string.");return new K(a, F);
    };h.toString = function () {
        return ".key";
    };
    var de = new ze();function Ae() {}ka(Ae, te);h = Ae.prototype;h.compare = function (a, b) {
        var c = a.S.tc(b.S);return 0 === c ? Mc(a.name, b.name) : c;
    };h.yc = function () {
        return !0;
    };h.nd = function (a, b) {
        return !a.ca(b);
    };h.Ic = function () {
        return ve;
    };h.Gc = function () {
        return Be;
    };h.Fc = function (a, b) {
        var c = M(a);return new K(b, c);
    };h.toString = function () {
        return ".value";
    };var Ce = new Ae();function De() {
        this.Sb = this.na = this.Lb = this.ka = this.xa = !1;this.oa = 0;this.oc = "";this.ec = null;this.Ab = "";this.bc = null;this.yb = "";this.g = N;
    }var Ee = new De();function le(a) {
        return "" === a.oc ? a.ka : "l" === a.oc;
    }function he(a) {
        H(a.ka, "Only valid if start has been set");return a.ec;
    }function ge(a) {
        H(a.ka, "Only valid if start has been set");return a.Lb ? a.Ab : "[MIN_NAME]";
    }function je(a) {
        H(a.na, "Only valid if end has been set");return a.bc;
    }
    function ie(a) {
        H(a.na, "Only valid if end has been set");return a.Sb ? a.yb : "[MAX_NAME]";
    }function Fe(a) {
        var b = new De();b.xa = a.xa;b.oa = a.oa;b.ka = a.ka;b.ec = a.ec;b.Lb = a.Lb;b.Ab = a.Ab;b.na = a.na;b.bc = a.bc;b.Sb = a.Sb;b.yb = a.yb;b.g = a.g;return b;
    }h = De.prototype;h.ne = function (a) {
        var b = Fe(this);b.xa = !0;b.oa = a;b.oc = "l";return b;
    };h.oe = function (a) {
        var b = Fe(this);b.xa = !0;b.oa = a;b.oc = "r";return b;
    };h.Nd = function (a, b) {
        var c = Fe(this);c.ka = !0;p(a) || (a = null);c.ec = a;null != b ? (c.Lb = !0, c.Ab = b) : (c.Lb = !1, c.Ab = "");return c;
    };
    h.fd = function (a, b) {
        var c = Fe(this);c.na = !0;p(a) || (a = null);c.bc = a;p(b) ? (c.Sb = !0, c.yb = b) : (c.Hg = !1, c.yb = "");return c;
    };function Ge(a, b) {
        var c = Fe(a);c.g = b;return c;
    }function He(a) {
        var b = {};a.ka && (b.sp = a.ec, a.Lb && (b.sn = a.Ab));a.na && (b.ep = a.bc, a.Sb && (b.en = a.yb));if (a.xa) {
            b.l = a.oa;var c = a.oc;"" === c && (c = le(a) ? "l" : "r");b.vf = c;
        }a.g !== N && (b.i = a.g.toString());return b;
    }function S(a) {
        return !(a.ka || a.na || a.xa);
    }function Cd(a) {
        return S(a) && a.g == N;
    }
    function Dd(a) {
        var b = {};if (Cd(a)) return b;var c;a.g === N ? c = "$priority" : a.g === Ce ? c = "$value" : a.g === de ? c = "$key" : (H(a.g instanceof we, "Unrecognized index type!"), c = a.g.toString());b.orderBy = B(c);a.ka && (b.startAt = B(a.ec), a.Lb && (b.startAt += "," + B(a.Ab)));a.na && (b.endAt = B(a.bc), a.Sb && (b.endAt += "," + B(a.yb)));a.xa && (le(a) ? b.limitToFirst = a.oa : b.limitToLast = a.oa);return b;
    }h.toString = function () {
        return B(He(this));
    };function Ie(a, b) {
        this.od = a;this.dc = b;
    }Ie.prototype.get = function (a) {
        var b = x(this.od, a);if (!b) throw Error("No index defined for " + a);return b === ue ? null : b;
    };function Je(a, b, c) {
        var d = oa(a.od, function (d, f) {
            var g = x(a.dc, f);H(g, "Missing index implementation for " + f);if (d === ue) {
                if (g.yc(b.S)) {
                    for (var k = [], m = c.Xb(Oc), l = R(m); l;) {
                        l.name != b.name && k.push(l), l = R(m);
                    }k.push(b);return Ke(k, ne(g));
                }return ue;
            }g = c.get(b.name);k = d;g && (k = k.remove(new K(b.name, g)));return k.Ra(b, b.S);
        });return new Ie(d, a.dc);
    }
    function Le(a, b, c) {
        var d = oa(a.od, function (a) {
            if (a === ue) return a;var d = c.get(b.name);return d ? a.remove(new K(b.name, d)) : a;
        });return new Ie(d, a.dc);
    }var Me = new Ie({ ".priority": ue }, { ".priority": N });function Ne() {
        this.set = {};
    }h = Ne.prototype;h.add = function (a, b) {
        this.set[a] = null !== b ? b : !0;
    };h.contains = function (a) {
        return Bb(this.set, a);
    };h.get = function (a) {
        return this.contains(a) ? this.set[a] : void 0;
    };h.remove = function (a) {
        delete this.set[a];
    };h.clear = function () {
        this.set = {};
    };h.e = function () {
        return xa(this.set);
    };h.count = function () {
        return qa(this.set);
    };function Oe(a, b) {
        t(a.set, function (a, d) {
            b(d, a);
        });
    }h.keys = function () {
        var a = [];t(this.set, function (b, c) {
            a.push(c);
        });return a;
    };function Pe(a, b, c, d) {
        this.Zd = a;this.f = cd(a);this.kc = b;this.qb = this.rb = 0;this.Xa = pc(b);this.Bf = c;this.xc = !1;this.Db = d;this.Yc = function (a) {
            return ic(b, "long_polling", a);
        };
    }var Qe, Re;
    Pe.prototype.open = function (a, b) {
        this.Qe = 0;this.ja = b;this.ff = new Rb(a);this.Bb = !1;var c = this;this.tb = setTimeout(function () {
            c.f("Timed out trying to connect.");c.fb();c.tb = null;
        }, Math.floor(3E4));hd(function () {
            if (!c.Bb) {
                c.Wa = new Se(function (a, b, d, k, m) {
                    Te(c, arguments);if (c.Wa) if (c.tb && (clearTimeout(c.tb), c.tb = null), c.xc = !0, "start" == a) c.id = b, c.mf = d;else if ("close" === a) b ? (c.Wa.Kd = !1, Sb(c.ff, b, function () {
                        c.fb();
                    })) : c.fb();else throw Error("Unrecognized command received: " + a);
                }, function (a, b) {
                    Te(c, arguments);
                    Tb(c.ff, a, b);
                }, function () {
                    c.fb();
                }, c.Yc);var a = { start: "t" };a.ser = Math.floor(1E8 * Math.random());c.Wa.Qd && (a.cb = c.Wa.Qd);a.v = "5";c.Bf && (a.s = c.Bf);c.Db && (a.ls = c.Db);"undefined" !== typeof location && location.href && -1 !== location.href.indexOf("firebaseio.com") && (a.r = "f");a = c.Yc(a);c.f("Connecting via long-poll to " + a);Ue(c.Wa, a, function () {});
            }
        });
    };
    Pe.prototype.start = function () {
        var a = this.Wa,
            b = this.mf;a.fg = this.id;a.gg = b;for (a.Ud = !0; Ve(a);) {}a = this.id;b = this.mf;this.gc = document.createElement("iframe");var c = { dframe: "t" };c.id = a;c.pw = b;this.gc.src = this.Yc(c);this.gc.style.display = "none";document.body.appendChild(this.gc);
    };
    Pe.isAvailable = function () {
        return Qe || !Re && "undefined" !== typeof document && null != document.createElement && !("object" === (typeof window === "undefined" ? "undefined" : _typeof(window)) && window.chrome && window.chrome.extension && !/^chrome/.test(window.location.href)) && !("object" === (typeof Windows === "undefined" ? "undefined" : _typeof(Windows)) && "object" === _typeof(Windows.Dg)) && !0;
    };h = Pe.prototype;h.sd = function () {};h.Tc = function () {
        this.Bb = !0;this.Wa && (this.Wa.close(), this.Wa = null);this.gc && (document.body.removeChild(this.gc), this.gc = null);this.tb && (clearTimeout(this.tb), this.tb = null);
    };
    h.fb = function () {
        this.Bb || (this.f("Longpoll is closing itself"), this.Tc(), this.ja && (this.ja(this.xc), this.ja = null));
    };h.close = function () {
        this.Bb || (this.f("Longpoll is being closed."), this.Tc());
    };h.send = function (a) {
        a = B(a);this.rb += a.length;mc(this.Xa, "bytes_sent", a.length);a = Mb(a);a = ab(a, !0);a = ld(a, 1840);for (var b = 0; b < a.length; b++) {
            var c = this.Wa;c.Qc.push({ ug: this.Qe, Bg: a.length, Se: a[b] });c.Ud && Ve(c);this.Qe++;
        }
    };function Te(a, b) {
        var c = B(b).length;a.qb += c;mc(a.Xa, "bytes_received", c);
    }
    function Se(a, b, c, d) {
        this.Yc = d;this.kb = c;this.ve = new Ne();this.Qc = [];this.$d = Math.floor(1E8 * Math.random());this.Kd = !0;this.Qd = Wc();window["pLPCommand" + this.Qd] = a;window["pRTLPCB" + this.Qd] = b;a = document.createElement("iframe");a.style.display = "none";if (document.body) {
            document.body.appendChild(a);try {
                a.contentWindow.document || E("No IE domain setting required");
            } catch (e) {
                a.src = "javascript:void((function(){document.open();document.domain='" + document.domain + "';document.close();})())";
            }
        } else throw "Document body has not initialized. Wait to initialize Firebase until after the document is ready.";
        a.contentDocument ? a.ib = a.contentDocument : a.contentWindow ? a.ib = a.contentWindow.document : a.document && (a.ib = a.document);this.Ga = a;a = "";this.Ga.src && "javascript:" === this.Ga.src.substr(0, 11) && (a = '<script>document.domain="' + document.domain + '";\x3c/script>');a = "<html><body>" + a + "</body></html>";try {
            this.Ga.ib.open(), this.Ga.ib.write(a), this.Ga.ib.close();
        } catch (f) {
            E("frame writing exception"), f.stack && E(f.stack), E(f);
        }
    }
    Se.prototype.close = function () {
        this.Ud = !1;if (this.Ga) {
            this.Ga.ib.body.innerHTML = "";var a = this;setTimeout(function () {
                null !== a.Ga && (document.body.removeChild(a.Ga), a.Ga = null);
            }, Math.floor(0));
        }var b = this.kb;b && (this.kb = null, b());
    };
    function Ve(a) {
        if (a.Ud && a.Kd && a.ve.count() < (0 < a.Qc.length ? 2 : 1)) {
            a.$d++;var b = {};b.id = a.fg;b.pw = a.gg;b.ser = a.$d;for (var b = a.Yc(b), c = "", d = 0; 0 < a.Qc.length;) {
                if (1870 >= a.Qc[0].Se.length + 30 + c.length) {
                    var e = a.Qc.shift(),
                        c = c + "&seg" + d + "=" + e.ug + "&ts" + d + "=" + e.Bg + "&d" + d + "=" + e.Se;d++;
                } else break;
            }We(a, b + c, a.$d);return !0;
        }return !1;
    }function We(a, b, c) {
        function d() {
            a.ve.remove(c);Ve(a);
        }a.ve.add(c, 1);var e = setTimeout(d, Math.floor(25E3));Ue(a, b, function () {
            clearTimeout(e);d();
        });
    }
    function Ue(a, b, c) {
        setTimeout(function () {
            try {
                if (a.Kd) {
                    var d = a.Ga.ib.createElement("script");d.type = "text/javascript";d.async = !0;d.src = b;d.onload = d.onreadystatechange = function () {
                        var a = d.readyState;a && "loaded" !== a && "complete" !== a || (d.onload = d.onreadystatechange = null, d.parentNode && d.parentNode.removeChild(d), c());
                    };d.onerror = function () {
                        E("Long-poll script failed to load: " + b);a.Kd = !1;a.close();
                    };a.Ga.ib.body.appendChild(d);
                }
            } catch (e) {}
        }, Math.floor(1));
    };function Xe(a) {
        Ye(this, a);
    }var Ze = [Pe, vd];function Ye(a, b) {
        var c = vd && vd.isAvailable(),
            d = c && !(Yb.cf || !0 === Yb.get("previous_websocket_failure"));b.Cg && (c || O("wss:// URL used, but browser isn't known to support websockets.  Trying anyway."), d = !0);if (d) a.Wc = [vd];else {
            var e = a.Wc = [];md(Ze, function (a, b) {
                b && b.isAvailable() && e.push(b);
            });
        }
    }function $e(a) {
        if (0 < a.Wc.length) return a.Wc[0];throw Error("No transports available");
    };function af(a, b, c, d, e, f, g) {
        this.id = a;this.f = cd("c:" + this.id + ":");this.te = c;this.Mc = d;this.ja = e;this.se = f;this.M = b;this.Ad = [];this.Oe = 0;this.Af = new Xe(b);this.L = 0;this.Db = g;this.f("Connection created");bf(this);
    }
    function bf(a) {
        var b = $e(a.Af);a.I = new b("c:" + a.id + ":" + a.Oe++, a.M, void 0, a.Db);a.xe = b.responsesRequiredToBeHealthy || 0;var c = cf(a, a.I),
            d = df(a, a.I);a.Xc = a.I;a.Rc = a.I;a.D = null;a.Cb = !1;setTimeout(function () {
            a.I && a.I.open(c, d);
        }, Math.floor(0));b = b.healthyTimeout || 0;0 < b && (a.md = setTimeout(function () {
            a.md = null;a.Cb || (a.I && 102400 < a.I.qb ? (a.f("Connection exceeded healthy timeout but has received " + a.I.qb + " bytes.  Marking connection healthy."), a.Cb = !0, a.I.sd()) : a.I && 10240 < a.I.rb ? a.f("Connection exceeded healthy timeout but has sent " + a.I.rb + " bytes.  Leaving connection alive.") : (a.f("Closing unhealthy connection after timeout."), a.close()));
        }, Math.floor(b)));
    }function df(a, b) {
        return function (c) {
            b === a.I ? (a.I = null, c || 0 !== a.L ? 1 === a.L && a.f("Realtime connection lost.") : (a.f("Realtime connection failed."), "s-" === a.M.bb.substr(0, 2) && (Yb.remove("host:" + a.M.host), a.M.bb = a.M.host)), a.close()) : b === a.D ? (a.f("Secondary connection lost."), c = a.D, a.D = null, a.Xc !== c && a.Rc !== c || a.close()) : a.f("closing an old connection");
        };
    }
    function cf(a, b) {
        return function (c) {
            if (2 != a.L) if (b === a.Rc) {
                var d = jd("t", c);c = jd("d", c);if ("c" == d) {
                    if (d = jd("t", c), "d" in c) if (c = c.d, "h" === d) {
                        var d = c.ts,
                            e = c.v,
                            f = c.h;a.yf = c.s;hc(a.M, f);0 == a.L && (a.I.start(), ef(a, a.I, d), "5" !== e && O("Protocol version mismatch detected"), c = a.Af, (c = 1 < c.Wc.length ? c.Wc[1] : null) && ff(a, c));
                    } else if ("n" === d) {
                        a.f("recvd end transmission on primary");a.Rc = a.D;for (c = 0; c < a.Ad.length; ++c) {
                            a.wd(a.Ad[c]);
                        }a.Ad = [];gf(a);
                    } else "s" === d ? (a.f("Connection shutdown command received. Shutting down..."), a.se && (a.se(c), a.se = null), a.ja = null, a.close()) : "r" === d ? (a.f("Reset packet received.  New host: " + c), hc(a.M, c), 1 === a.L ? a.close() : (hf(a), bf(a))) : "e" === d ? dd("Server Error: " + c) : "o" === d ? (a.f("got pong on primary."), jf(a), kf(a)) : dd("Unknown control packet command: " + d);
                } else "d" == d && a.wd(c);
            } else if (b === a.D) {
                if (d = jd("t", c), c = jd("d", c), "c" == d) "t" in c && (c = c.t, "a" === c ? lf(a) : "r" === c ? (a.f("Got a reset on secondary, closing it"), a.D.close(), a.Xc !== a.D && a.Rc !== a.D || a.close()) : "o" === c && (a.f("got pong on secondary."), a.xf--, lf(a)));else if ("d" == d) a.Ad.push(c);else throw Error("Unknown protocol layer: " + d);
            } else a.f("message on old connection");
        };
    }af.prototype.ua = function (a) {
        mf(this, { t: "d", d: a });
    };function gf(a) {
        a.Xc === a.D && a.Rc === a.D && (a.f("cleaning up and promoting a connection: " + a.D.Zd), a.I = a.D, a.D = null);
    }
    function lf(a) {
        0 >= a.xf ? (a.f("Secondary connection is healthy."), a.Cb = !0, a.D.sd(), a.D.start(), a.f("sending client ack on secondary"), a.D.send({ t: "c", d: { t: "a", d: {} } }), a.f("Ending transmission on primary"), a.I.send({ t: "c", d: { t: "n", d: {} } }), a.Xc = a.D, gf(a)) : (a.f("sending ping on secondary."), a.D.send({ t: "c", d: { t: "p", d: {} } }));
    }af.prototype.wd = function (a) {
        jf(this);this.te(a);
    };function jf(a) {
        a.Cb || (a.xe--, 0 >= a.xe && (a.f("Primary connection is healthy."), a.Cb = !0, a.I.sd()));
    }
    function ff(a, b) {
        a.D = new b("c:" + a.id + ":" + a.Oe++, a.M, a.yf);a.xf = b.responsesRequiredToBeHealthy || 0;a.D.open(cf(a, a.D), df(a, a.D));setTimeout(function () {
            a.D && (a.f("Timed out trying to upgrade."), a.D.close());
        }, Math.floor(6E4));
    }function ef(a, b, c) {
        a.f("Realtime connection established.");a.I = b;a.L = 1;a.Mc && (a.Mc(c, a.yf), a.Mc = null);0 === a.xe ? (a.f("Primary connection is healthy."), a.Cb = !0) : setTimeout(function () {
            kf(a);
        }, Math.floor(5E3));
    }
    function kf(a) {
        a.Cb || 1 !== a.L || (a.f("sending ping on primary."), mf(a, { t: "c", d: { t: "p", d: {} } }));
    }function mf(a, b) {
        if (1 !== a.L) throw "Connection is not connected";a.Xc.send(b);
    }af.prototype.close = function () {
        2 !== this.L && (this.f("Closing realtime connection."), this.L = 2, hf(this), this.ja && (this.ja(), this.ja = null));
    };function hf(a) {
        a.f("Shutting down all connections");a.I && (a.I.close(), a.I = null);a.D && (a.D.close(), a.D = null);a.md && (clearTimeout(a.md), a.md = null);
    };function L(a, b) {
        if (1 == arguments.length) {
            this.o = a.split("/");for (var c = 0, d = 0; d < this.o.length; d++) {
                0 < this.o[d].length && (this.o[c] = this.o[d], c++);
            }this.o.length = c;this.Z = 0;
        } else this.o = a, this.Z = b;
    }function T(a, b) {
        var c = J(a);if (null === c) return b;if (c === J(b)) return T(D(a), D(b));throw Error("INTERNAL ERROR: innerPath (" + b + ") is not within outerPath (" + a + ")");
    }
    function nf(a, b) {
        for (var c = a.slice(), d = b.slice(), e = 0; e < c.length && e < d.length; e++) {
            var f = Mc(c[e], d[e]);if (0 !== f) return f;
        }return c.length === d.length ? 0 : c.length < d.length ? -1 : 1;
    }function J(a) {
        return a.Z >= a.o.length ? null : a.o[a.Z];
    }function Zd(a) {
        return a.o.length - a.Z;
    }function D(a) {
        var b = a.Z;b < a.o.length && b++;return new L(a.o, b);
    }function $d(a) {
        return a.Z < a.o.length ? a.o[a.o.length - 1] : null;
    }h = L.prototype;
    h.toString = function () {
        for (var a = "", b = this.Z; b < this.o.length; b++) {
            "" !== this.o[b] && (a += "/" + this.o[b]);
        }return a || "/";
    };h.slice = function (a) {
        return this.o.slice(this.Z + (a || 0));
    };h.parent = function () {
        if (this.Z >= this.o.length) return null;for (var a = [], b = this.Z; b < this.o.length - 1; b++) {
            a.push(this.o[b]);
        }return new L(a, 0);
    };
    h.m = function (a) {
        for (var b = [], c = this.Z; c < this.o.length; c++) {
            b.push(this.o[c]);
        }if (a instanceof L) for (c = a.Z; c < a.o.length; c++) {
            b.push(a.o[c]);
        } else for (a = a.split("/"), c = 0; c < a.length; c++) {
            0 < a[c].length && b.push(a[c]);
        }return new L(b, 0);
    };h.e = function () {
        return this.Z >= this.o.length;
    };h.ca = function (a) {
        if (Zd(this) !== Zd(a)) return !1;for (var b = this.Z, c = a.Z; b <= this.o.length; b++, c++) {
            if (this.o[b] !== a.o[c]) return !1;
        }return !0;
    };
    h.contains = function (a) {
        var b = this.Z,
            c = a.Z;if (Zd(this) > Zd(a)) return !1;for (; b < this.o.length;) {
            if (this.o[b] !== a.o[c]) return !1;++b;++c;
        }return !0;
    };var C = new L("");function of(a, b) {
        this.Ta = a.slice();this.Ka = Math.max(1, this.Ta.length);this.Te = b;for (var c = 0; c < this.Ta.length; c++) {
            this.Ka += Nb(this.Ta[c]);
        }pf(this);
    }of.prototype.push = function (a) {
        0 < this.Ta.length && (this.Ka += 1);this.Ta.push(a);this.Ka += Nb(a);pf(this);
    };of.prototype.pop = function () {
        var a = this.Ta.pop();this.Ka -= Nb(a);0 < this.Ta.length && --this.Ka;
    };
    function pf(a) {
        if (768 < a.Ka) throw Error(a.Te + "has a key path longer than 768 bytes (" + a.Ka + ").");if (32 < a.Ta.length) throw Error(a.Te + "path specified exceeds the maximum depth that can be written (32) or object contains a cycle " + qf(a));
    }function qf(a) {
        return 0 == a.Ta.length ? "" : "in property '" + a.Ta.join(".") + "'";
    };function rf(a) {
        a instanceof sf || ed("Don't call new Database() directly - please use firebase.database().");this.ta = a;this.ba = new U(a, C);this.INTERNAL = new tf(this);
    }var uf = { TIMESTAMP: { ".sv": "timestamp" } };h = rf.prototype;h.app = null;h.pf = function (a) {
        vf(this, "ref");y("database.ref", 0, 1, arguments.length);return p(a) ? this.ba.m(a) : this.ba;
    };
    h.rg = function (a) {
        vf(this, "database.refFromURL");y("database.refFromURL", 1, 1, arguments.length);var b = fd(a);wf("database.refFromURL", b);var c = b.kc;c.host !== this.ta.M.host && ed("database.refFromURL: Host name does not match the current database: (found " + c.host + " but expected " + this.ta.M.host + ")");return this.pf(b.path.toString());
    };function vf(a, b) {
        null === a.ta && ed("Cannot call " + b + " on a deleted database.");
    }h.$f = function () {
        y("database.goOffline", 0, 0, arguments.length);vf(this, "goOffline");this.ta.eb();
    };
    h.ag = function () {
        y("database.goOnline", 0, 0, arguments.length);vf(this, "goOnline");this.ta.lc();
    };Object.defineProperty(rf.prototype, "app", { get: function get() {
            return this.ta.app;
        } });function tf(a) {
        this.$a = a;
    }tf.prototype.delete = function () {
        vf(this.$a, "delete");var a = xf.Wb(),
            b = this.$a.ta;x(a.nb, b.app.name) !== b && ed("Database " + b.app.name + " has already been deleted.");b.eb();delete a.nb[b.app.name];this.$a.ta = null;this.$a.ba = null;this.$a = this.$a.INTERNAL = null;return firebase.Promise.resolve();
    };
    rf.prototype.ref = rf.prototype.pf;rf.prototype.refFromURL = rf.prototype.rg;rf.prototype.goOnline = rf.prototype.ag;rf.prototype.goOffline = rf.prototype.$f;tf.prototype["delete"] = tf.prototype.delete;function Rc() {
        this.k = this.B = null;
    }Rc.prototype.find = function (a) {
        if (null != this.B) return this.B.Q(a);if (a.e() || null == this.k) return null;var b = J(a);a = D(a);return this.k.contains(b) ? this.k.get(b).find(a) : null;
    };function Tc(a, b, c) {
        if (b.e()) a.B = c, a.k = null;else if (null !== a.B) a.B = a.B.F(b, c);else {
            null == a.k && (a.k = new Ne());var d = J(b);a.k.contains(d) || a.k.add(d, new Rc());a = a.k.get(d);b = D(b);Tc(a, b, c);
        }
    }
    function yf(a, b) {
        if (b.e()) return a.B = null, a.k = null, !0;if (null !== a.B) {
            if (a.B.J()) return !1;var c = a.B;a.B = null;c.P(N, function (b, c) {
                Tc(a, new L(b), c);
            });return yf(a, b);
        }return null !== a.k ? (c = J(b), b = D(b), a.k.contains(c) && yf(a.k.get(c), b) && a.k.remove(c), a.k.e() ? (a.k = null, !0) : !1) : !0;
    }function Sc(a, b, c) {
        null !== a.B ? c(b, a.B) : a.P(function (a, e) {
            var f = new L(b.toString() + "/" + a);Sc(e, f, c);
        });
    }Rc.prototype.P = function (a) {
        null !== this.k && Oe(this.k, function (b, c) {
            a(b, c);
        });
    };var zf = /[\[\].#$\/\u0000-\u001F\u007F]/,
        Af = /[\[\].#$\u0000-\u001F\u007F]/;function Bf(a) {
        return q(a) && 0 !== a.length && !zf.test(a);
    }function Cf(a) {
        return null === a || q(a) || fa(a) && !gd(a) || ha(a) && Bb(a, ".sv");
    }function Df(a, b, c, d) {
        d && !p(b) || Ef(Db(a, 1, d), b, c);
    }
    function Ef(a, b, c) {
        c instanceof L && (c = new of(c, a));if (!p(b)) throw Error(a + "contains undefined " + qf(c));if (ga(b)) throw Error(a + "contains a function " + qf(c) + " with contents: " + b.toString());if (gd(b)) throw Error(a + "contains " + b.toString() + " " + qf(c));if (q(b) && b.length > 10485760 / 3 && 10485760 < Nb(b)) throw Error(a + "contains a string greater than 10485760 utf8 bytes " + qf(c) + " ('" + b.substring(0, 50) + "...')");if (ha(b)) {
            var d = !1,
                e = !1;Cb(b, function (b, g) {
                if (".value" === b) d = !0;else if (".priority" !== b && ".sv" !== b && (e = !0, !Bf(b))) throw Error(a + " contains an invalid key (" + b + ") " + qf(c) + '.  Keys must be non-empty strings and can\'t contain ".", "#", "$", "/", "[", or "]"');c.push(b);Ef(a, g, c);c.pop();
            });if (d && e) throw Error(a + ' contains ".value" child ' + qf(c) + " in addition to actual children.");
        }
    }
    function Ff(a, b) {
        var c, d;for (c = 0; c < b.length; c++) {
            d = b[c];for (var e = d.slice(), f = 0; f < e.length; f++) {
                if ((".priority" !== e[f] || f !== e.length - 1) && !Bf(e[f])) throw Error(a + "contains an invalid key (" + e[f] + ") in path " + d.toString() + '. Keys must be non-empty strings and can\'t contain ".", "#", "$", "/", "[", or "]"');
            }
        }b.sort(nf);e = null;for (c = 0; c < b.length; c++) {
            d = b[c];if (null !== e && e.contains(d)) throw Error(a + "contains a path " + e.toString() + " that is ancestor of another path " + d.toString());e = d;
        }
    }
    function Gf(a, b, c) {
        var d = Db(a, 1, !1);if (!ha(b) || da(b)) throw Error(d + " must be an object containing the children to replace.");var e = [];Cb(b, function (a, b) {
            var k = new L(a);Ef(d, b, c.m(k));if (".priority" === $d(k) && !Cf(b)) throw Error(d + "contains an invalid value for '" + k.toString() + "', which must be a valid Firebase priority (a string, finite number, server value, or null).");e.push(k);
        });Ff(d, e);
    }
    function Hf(a, b, c) {
        if (gd(c)) throw Error(Db(a, b, !1) + "is " + c.toString() + ", but must be a valid Firebase priority (a string, finite number, server value, or null).");if (!Cf(c)) throw Error(Db(a, b, !1) + "must be a valid Firebase priority (a string, finite number, server value, or null).");
    }
    function If(a, b, c) {
        if (!c || p(b)) switch (b) {case "value":case "child_added":case "child_removed":case "child_changed":case "child_moved":
                break;default:
                throw Error(Db(a, 1, c) + 'must be a valid event type: "value", "child_added", "child_removed", "child_changed", or "child_moved".');}
    }function Jf(a, b) {
        if (p(b) && !Bf(b)) throw Error(Db(a, 2, !0) + 'was an invalid key: "' + b + '".  Firebase keys must be non-empty strings and can\'t contain ".", "#", "$", "/", "[", or "]").');
    }
    function Kf(a, b) {
        if (!q(b) || 0 === b.length || Af.test(b)) throw Error(Db(a, 1, !1) + 'was an invalid path: "' + b + '". Paths must be non-empty strings and can\'t contain ".", "#", "$", "[", or "]"');
    }function Lf(a, b) {
        if (".info" === J(b)) throw Error(a + " failed: Can't modify data under /.info/");
    }
    function wf(a, b) {
        var c = b.path.toString(),
            d;!(d = !q(b.kc.host) || 0 === b.kc.host.length || !Bf(b.kc.pe)) && (d = 0 !== c.length) && (c && (c = c.replace(/^\/*\.info(\/|$)/, "/")), d = !(q(c) && 0 !== c.length && !Af.test(c)));if (d) throw Error(Db(a, 1, !1) + 'must be a valid firebase URL and the path can\'t contain ".", "#", "$", "[", or "]".');
    };function V(a, b) {
        this.ta = a;this.qa = b;
    }V.prototype.cancel = function (a) {
        y("Firebase.onDisconnect().cancel", 0, 1, arguments.length);A("Firebase.onDisconnect().cancel", 1, a, !0);var b = new Hb();this.ta.xd(this.qa, Ib(b, a));return b.ra;
    };V.prototype.cancel = V.prototype.cancel;V.prototype.remove = function (a) {
        y("Firebase.onDisconnect().remove", 0, 1, arguments.length);Lf("Firebase.onDisconnect().remove", this.qa);A("Firebase.onDisconnect().remove", 1, a, !0);var b = new Hb();Mf(this.ta, this.qa, null, Ib(b, a));return b.ra;
    };
    V.prototype.remove = V.prototype.remove;V.prototype.set = function (a, b) {
        y("Firebase.onDisconnect().set", 1, 2, arguments.length);Lf("Firebase.onDisconnect().set", this.qa);Df("Firebase.onDisconnect().set", a, this.qa, !1);A("Firebase.onDisconnect().set", 2, b, !0);var c = new Hb();Mf(this.ta, this.qa, a, Ib(c, b));return c.ra;
    };V.prototype.set = V.prototype.set;
    V.prototype.Kb = function (a, b, c) {
        y("Firebase.onDisconnect().setWithPriority", 2, 3, arguments.length);Lf("Firebase.onDisconnect().setWithPriority", this.qa);Df("Firebase.onDisconnect().setWithPriority", a, this.qa, !1);Hf("Firebase.onDisconnect().setWithPriority", 2, b);A("Firebase.onDisconnect().setWithPriority", 3, c, !0);var d = new Hb();Nf(this.ta, this.qa, a, b, Ib(d, c));return d.ra;
    };V.prototype.setWithPriority = V.prototype.Kb;
    V.prototype.update = function (a, b) {
        y("Firebase.onDisconnect().update", 1, 2, arguments.length);Lf("Firebase.onDisconnect().update", this.qa);if (da(a)) {
            for (var c = {}, d = 0; d < a.length; ++d) {
                c["" + d] = a[d];
            }a = c;O("Passing an Array to Firebase.onDisconnect().update() is deprecated. Use set() if you want to overwrite the existing data, or an Object with integer keys if you really do want to only update some of the children.");
        }Gf("Firebase.onDisconnect().update", a, this.qa);A("Firebase.onDisconnect().update", 2, b, !0);
        c = new Hb();Of(this.ta, this.qa, a, Ib(c, b));return c.ra;
    };V.prototype.update = V.prototype.update;function Pf(a) {
        H(da(a) && 0 < a.length, "Requires a non-empty array");this.Kf = a;this.Ec = {};
    }Pf.prototype.Ge = function (a, b) {
        var c;c = this.Ec[a] || [];var d = c.length;if (0 < d) {
            for (var e = Array(d), f = 0; f < d; f++) {
                e[f] = c[f];
            }c = e;
        } else c = [];for (d = 0; d < c.length; d++) {
            c[d].Ke.apply(c[d].Pa, Array.prototype.slice.call(arguments, 1));
        }
    };Pf.prototype.hc = function (a, b, c) {
        Qf(this, a);this.Ec[a] = this.Ec[a] || [];this.Ec[a].push({ Ke: b, Pa: c });(a = this.Ye(a)) && b.apply(c, a);
    };
    Pf.prototype.Jc = function (a, b, c) {
        Qf(this, a);a = this.Ec[a] || [];for (var d = 0; d < a.length; d++) {
            if (a[d].Ke === b && (!c || c === a[d].Pa)) {
                a.splice(d, 1);break;
            }
        }
    };function Qf(a, b) {
        H(Oa(a.Kf, function (a) {
            return a === b;
        }), "Unknown event: " + b);
    };function Rf() {
        Pf.call(this, ["online"]);this.ic = !0;if ("undefined" !== typeof window && "undefined" !== typeof window.addEventListener && !Qb()) {
            var a = this;window.addEventListener("online", function () {
                a.ic || (a.ic = !0, a.Ge("online", !0));
            }, !1);window.addEventListener("offline", function () {
                a.ic && (a.ic = !1, a.Ge("online", !1));
            }, !1);
        }
    }ka(Rf, Pf);Rf.prototype.Ye = function (a) {
        H("online" === a, "Unknown event type: " + a);return [this.ic];
    };ba(Rf);function Sf() {
        Pf.call(this, ["visible"]);var a, b;"undefined" !== typeof document && "undefined" !== typeof document.addEventListener && ("undefined" !== typeof document.hidden ? (b = "visibilitychange", a = "hidden") : "undefined" !== typeof document.mozHidden ? (b = "mozvisibilitychange", a = "mozHidden") : "undefined" !== typeof document.msHidden ? (b = "msvisibilitychange", a = "msHidden") : "undefined" !== typeof document.webkitHidden && (b = "webkitvisibilitychange", a = "webkitHidden"));this.Nb = !0;if (b) {
            var c = this;document.addEventListener(b, function () {
                var b = !document[a];b !== c.Nb && (c.Nb = b, c.Ge("visible", b));
            }, !1);
        }
    }ka(Sf, Pf);Sf.prototype.Ye = function (a) {
        H("visible" === a, "Unknown event type: " + a);return [this.Nb];
    };ba(Sf);var Tf = function () {
        var a = 0,
            b = [];return function (c) {
            var d = c === a;a = c;for (var e = Array(8), f = 7; 0 <= f; f--) {
                e[f] = "-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz".charAt(c % 64), c = Math.floor(c / 64);
            }H(0 === c, "Cannot push at time == 0");c = e.join("");if (d) {
                for (f = 11; 0 <= f && 63 === b[f]; f--) {
                    b[f] = 0;
                }b[f]++;
            } else for (f = 0; 12 > f; f++) {
                b[f] = Math.floor(64 * Math.random());
            }for (f = 0; 12 > f; f++) {
                c += "-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz".charAt(b[f]);
            }H(20 === c.length, "nextPushId: Length should be 20.");
            return c;
        };
    }();function Uf(a, b) {
        this.Oa = a;this.ba = b ? b : Vf;
    }h = Uf.prototype;h.Ra = function (a, b) {
        return new Uf(this.Oa, this.ba.Ra(a, b, this.Oa).Y(null, null, !1, null, null));
    };h.remove = function (a) {
        return new Uf(this.Oa, this.ba.remove(a, this.Oa).Y(null, null, !1, null, null));
    };h.get = function (a) {
        for (var b, c = this.ba; !c.e();) {
            b = this.Oa(a, c.key);if (0 === b) return c.value;0 > b ? c = c.left : 0 < b && (c = c.right);
        }return null;
    };
    function Wf(a, b) {
        for (var c, d = a.ba, e = null; !d.e();) {
            c = a.Oa(b, d.key);if (0 === c) {
                if (d.left.e()) return e ? e.key : null;for (d = d.left; !d.right.e();) {
                    d = d.right;
                }return d.key;
            }0 > c ? d = d.left : 0 < c && (e = d, d = d.right);
        }throw Error("Attempted to find predecessor key for a nonexistent key.  What gives?");
    }h.e = function () {
        return this.ba.e();
    };h.count = function () {
        return this.ba.count();
    };h.Hc = function () {
        return this.ba.Hc();
    };h.fc = function () {
        return this.ba.fc();
    };h.ia = function (a) {
        return this.ba.ia(a);
    };
    h.Xb = function (a) {
        return new Xf(this.ba, null, this.Oa, !1, a);
    };h.Yb = function (a, b) {
        return new Xf(this.ba, a, this.Oa, !1, b);
    };h.$b = function (a, b) {
        return new Xf(this.ba, a, this.Oa, !0, b);
    };h.$e = function (a) {
        return new Xf(this.ba, null, this.Oa, !0, a);
    };function Xf(a, b, c, d, e) {
        this.Hd = e || null;this.le = d;this.Sa = [];for (e = 1; !a.e();) {
            if (e = b ? c(a.key, b) : 1, d && (e *= -1), 0 > e) a = this.le ? a.left : a.right;else if (0 === e) {
                this.Sa.push(a);break;
            } else this.Sa.push(a), a = this.le ? a.right : a.left;
        }
    }
    function R(a) {
        if (0 === a.Sa.length) return null;var b = a.Sa.pop(),
            c;c = a.Hd ? a.Hd(b.key, b.value) : { key: b.key, value: b.value };if (a.le) for (b = b.left; !b.e();) {
            a.Sa.push(b), b = b.right;
        } else for (b = b.right; !b.e();) {
            a.Sa.push(b), b = b.left;
        }return c;
    }function Yf(a) {
        if (0 === a.Sa.length) return null;var b;b = a.Sa;b = b[b.length - 1];return a.Hd ? a.Hd(b.key, b.value) : { key: b.key, value: b.value };
    }function Zf(a, b, c, d, e) {
        this.key = a;this.value = b;this.color = null != c ? c : !0;this.left = null != d ? d : Vf;this.right = null != e ? e : Vf;
    }h = Zf.prototype;
    h.Y = function (a, b, c, d, e) {
        return new Zf(null != a ? a : this.key, null != b ? b : this.value, null != c ? c : this.color, null != d ? d : this.left, null != e ? e : this.right);
    };h.count = function () {
        return this.left.count() + 1 + this.right.count();
    };h.e = function () {
        return !1;
    };h.ia = function (a) {
        return this.left.ia(a) || a(this.key, this.value) || this.right.ia(a);
    };function $f(a) {
        return a.left.e() ? a : $f(a.left);
    }h.Hc = function () {
        return $f(this).key;
    };h.fc = function () {
        return this.right.e() ? this.key : this.right.fc();
    };
    h.Ra = function (a, b, c) {
        var d, e;e = this;d = c(a, e.key);e = 0 > d ? e.Y(null, null, null, e.left.Ra(a, b, c), null) : 0 === d ? e.Y(null, b, null, null, null) : e.Y(null, null, null, null, e.right.Ra(a, b, c));return ag(e);
    };function bg(a) {
        if (a.left.e()) return Vf;a.left.fa() || a.left.left.fa() || (a = cg(a));a = a.Y(null, null, null, bg(a.left), null);return ag(a);
    }
    h.remove = function (a, b) {
        var c, d;c = this;if (0 > b(a, c.key)) c.left.e() || c.left.fa() || c.left.left.fa() || (c = cg(c)), c = c.Y(null, null, null, c.left.remove(a, b), null);else {
            c.left.fa() && (c = dg(c));c.right.e() || c.right.fa() || c.right.left.fa() || (c = eg(c), c.left.left.fa() && (c = dg(c), c = eg(c)));if (0 === b(a, c.key)) {
                if (c.right.e()) return Vf;d = $f(c.right);c = c.Y(d.key, d.value, null, null, bg(c.right));
            }c = c.Y(null, null, null, null, c.right.remove(a, b));
        }return ag(c);
    };h.fa = function () {
        return this.color;
    };
    function ag(a) {
        a.right.fa() && !a.left.fa() && (a = fg(a));a.left.fa() && a.left.left.fa() && (a = dg(a));a.left.fa() && a.right.fa() && (a = eg(a));return a;
    }function cg(a) {
        a = eg(a);a.right.left.fa() && (a = a.Y(null, null, null, null, dg(a.right)), a = fg(a), a = eg(a));return a;
    }function fg(a) {
        return a.right.Y(null, null, a.color, a.Y(null, null, !0, null, a.right.left), null);
    }function dg(a) {
        return a.left.Y(null, null, a.color, null, a.Y(null, null, !0, a.left.right, null));
    }
    function eg(a) {
        return a.Y(null, null, !a.color, a.left.Y(null, null, !a.left.color, null, null), a.right.Y(null, null, !a.right.color, null, null));
    }function gg() {}h = gg.prototype;h.Y = function () {
        return this;
    };h.Ra = function (a, b) {
        return new Zf(a, b, null);
    };h.remove = function () {
        return this;
    };h.count = function () {
        return 0;
    };h.e = function () {
        return !0;
    };h.ia = function () {
        return !1;
    };h.Hc = function () {
        return null;
    };h.fc = function () {
        return null;
    };h.fa = function () {
        return !1;
    };var Vf = new gg();function P(a, b, c) {
        this.k = a;(this.aa = b) && qe(this.aa);a.e() && H(!this.aa || this.aa.e(), "An empty node cannot have a priority");this.zb = c;this.Eb = null;
    }h = P.prototype;h.J = function () {
        return !1;
    };h.C = function () {
        return this.aa || F;
    };h.ga = function (a) {
        return this.k.e() ? this : new P(this.k, a, this.zb);
    };h.R = function (a) {
        if (".priority" === a) return this.C();a = this.k.get(a);return null === a ? F : a;
    };h.Q = function (a) {
        var b = J(a);return null === b ? this : this.R(b).Q(D(a));
    };h.Fa = function (a) {
        return null !== this.k.get(a);
    };
    h.U = function (a, b) {
        H(b, "We should always be passing snapshot nodes");if (".priority" === a) return this.ga(b);var c = new K(a, b),
            d,
            e;b.e() ? (d = this.k.remove(a), c = Le(this.zb, c, this.k)) : (d = this.k.Ra(a, b), c = Je(this.zb, c, this.k));e = d.e() ? F : this.aa;return new P(d, e, c);
    };h.F = function (a, b) {
        var c = J(a);if (null === c) return b;H(".priority" !== J(a) || 1 === Zd(a), ".priority must be the last token in a path");var d = this.R(c).F(D(a), b);return this.U(c, d);
    };h.e = function () {
        return this.k.e();
    };h.Fb = function () {
        return this.k.count();
    };
    var hg = /^(0|[1-9]\d*)$/;h = P.prototype;h.H = function (a) {
        if (this.e()) return null;var b = {},
            c = 0,
            d = 0,
            e = !0;this.P(N, function (f, g) {
            b[f] = g.H(a);c++;e && hg.test(f) ? d = Math.max(d, Number(f)) : e = !1;
        });if (!a && e && d < 2 * c) {
            var f = [],
                g;for (g in b) {
                f[g] = b[g];
            }return f;
        }a && !this.C().e() && (b[".priority"] = this.C().H());return b;
    };h.hash = function () {
        if (null === this.Eb) {
            var a = "";this.C().e() || (a += "priority:" + se(this.C().H()) + ":");this.P(N, function (b, c) {
                var d = c.hash();"" !== d && (a += ":" + b + ":" + d);
            });this.Eb = "" === a ? "" : Zc(a);
        }return this.Eb;
    };
    h.Ze = function (a, b, c) {
        return (c = ig(this, c)) ? (a = Wf(c, new K(a, b))) ? a.name : null : Wf(this.k, a);
    };function oe(a, b) {
        var c;c = (c = ig(a, b)) ? (c = c.Hc()) && c.name : a.k.Hc();return c ? new K(c, a.k.get(c)) : null;
    }function pe(a, b) {
        var c;c = (c = ig(a, b)) ? (c = c.fc()) && c.name : a.k.fc();return c ? new K(c, a.k.get(c)) : null;
    }h.P = function (a, b) {
        var c = ig(this, a);return c ? c.ia(function (a) {
            return b(a.name, a.S);
        }) : this.k.ia(b);
    };h.Xb = function (a) {
        return this.Yb(a.Ic(), a);
    };
    h.Yb = function (a, b) {
        var c = ig(this, b);if (c) return c.Yb(a, function (a) {
            return a;
        });for (var c = this.k.Yb(a.name, Oc), d = Yf(c); null != d && 0 > b.compare(d, a);) {
            R(c), d = Yf(c);
        }return c;
    };h.$e = function (a) {
        return this.$b(a.Gc(), a);
    };h.$b = function (a, b) {
        var c = ig(this, b);if (c) return c.$b(a, function (a) {
            return a;
        });for (var c = this.k.$b(a.name, Oc), d = Yf(c); null != d && 0 < b.compare(d, a);) {
            R(c), d = Yf(c);
        }return c;
    };h.tc = function (a) {
        return this.e() ? a.e() ? 0 : -1 : a.J() || a.e() ? 1 : a === xe ? -1 : 0;
    };
    h.ob = function (a) {
        if (a === de || ua(this.zb.dc, a.toString())) return this;var b = this.zb,
            c = this.k;H(a !== de, "KeyIndex always exists and isn't meant to be added to the IndexMap.");for (var d = [], e = !1, c = c.Xb(Oc), f = R(c); f;) {
            e = e || a.yc(f.S), d.push(f), f = R(c);
        }d = e ? Ke(d, ne(a)) : ue;e = a.toString();c = ya(b.dc);c[e] = a;a = ya(b.od);a[e] = d;return new P(this.k, this.aa, new Ie(a, c));
    };h.zc = function (a) {
        return a === de || ua(this.zb.dc, a.toString());
    };
    h.ca = function (a) {
        if (a === this) return !0;if (a.J()) return !1;if (this.C().ca(a.C()) && this.k.count() === a.k.count()) {
            var b = this.Xb(N);a = a.Xb(N);for (var c = R(b), d = R(a); c && d;) {
                if (c.name !== d.name || !c.S.ca(d.S)) return !1;c = R(b);d = R(a);
            }return null === c && null === d;
        }return !1;
    };function ig(a, b) {
        return b === de ? null : a.zb.get(b.toString());
    }h.toString = function () {
        return B(this.H(!0));
    };function M(a, b) {
        if (null === a) return F;var c = null;"object" === (typeof a === "undefined" ? "undefined" : _typeof(a)) && ".priority" in a ? c = a[".priority"] : "undefined" !== typeof b && (c = b);H(null === c || "string" === typeof c || "number" === typeof c || "object" === (typeof c === "undefined" ? "undefined" : _typeof(c)) && ".sv" in c, "Invalid priority type found: " + (typeof c === "undefined" ? "undefined" : _typeof(c)));"object" === (typeof a === "undefined" ? "undefined" : _typeof(a)) && ".value" in a && null !== a[".value"] && (a = a[".value"]);if ("object" !== (typeof a === "undefined" ? "undefined" : _typeof(a)) || ".sv" in a) return new Vc(a, M(c));if (a instanceof Array) {
            var d = F,
                e = a;t(e, function (a, b) {
                if (Bb(e, b) && "." !== b.substring(0, 1)) {
                    var c = M(a);if (c.J() || !c.e()) d = d.U(b, c);
                }
            });return d.ga(M(c));
        }var f = [],
            g = !1,
            k = a;Cb(k, function (a) {
            if ("string" !== typeof a || "." !== a.substring(0, 1)) {
                var b = M(k[a]);b.e() || (g = g || !b.C().e(), f.push(new K(a, b)));
            }
        });if (0 == f.length) return F;var m = Ke(f, Lc, function (a) {
            return a.name;
        }, Nc);if (g) {
            var l = Ke(f, ne(N));return new P(m, M(c), new Ie({ ".priority": l }, { ".priority": N }));
        }return new P(m, M(c), Me);
    }var jg = Math.log(2);
    function kg(a) {
        this.count = parseInt(Math.log(a + 1) / jg, 10);this.Re = this.count - 1;this.Lf = a + 1 & parseInt(Array(this.count + 1).join("1"), 2);
    }function lg(a) {
        var b = !(a.Lf & 1 << a.Re);a.Re--;return b;
    }
    function Ke(a, b, c, d) {
        function e(b, d) {
            var f = d - b;if (0 == f) return null;if (1 == f) {
                var l = a[b],
                    u = c ? c(l) : l;return new Zf(u, l.S, !1, null, null);
            }var l = parseInt(f / 2, 10) + b,
                f = e(b, l),
                z = e(l + 1, d),
                l = a[l],
                u = c ? c(l) : l;return new Zf(u, l.S, !1, f, z);
        }a.sort(b);var f = function (b) {
            function d(b, g) {
                var k = u - b,
                    z = u;u -= b;var z = e(k + 1, z),
                    k = a[k],
                    G = c ? c(k) : k,
                    z = new Zf(G, k.S, g, null, z);f ? f.left = z : l = z;f = z;
            }for (var f = null, l = null, u = a.length, z = 0; z < b.count; ++z) {
                var G = lg(b),
                    td = Math.pow(2, b.count - (z + 1));G ? d(td, !1) : (d(td, !1), d(td, !0));
            }return l;
        }(new kg(a.length));
        return null !== f ? new Uf(d || b, f) : new Uf(d || b);
    }function se(a) {
        return "number" === typeof a ? "number:" + nd(a) : "string:" + a;
    }function qe(a) {
        if (a.J()) {
            var b = a.H();H("string" === typeof b || "number" === typeof b || "object" === (typeof b === "undefined" ? "undefined" : _typeof(b)) && Bb(b, ".sv"), "Priority must be a string or number.");
        } else H(a === xe || a.e(), "priority of unexpected type.");H(a === xe || a.C().e(), "Priority nodes can't have a priority of their own.");
    }var F = new P(new Uf(Nc), null, Me);function mg() {
        P.call(this, new Uf(Nc), F, Me);
    }ka(mg, P);h = mg.prototype;
    h.tc = function (a) {
        return a === this ? 0 : 1;
    };h.ca = function (a) {
        return a === this;
    };h.C = function () {
        return this;
    };h.R = function () {
        return F;
    };h.e = function () {
        return !1;
    };var xe = new mg(),
        ve = new K("[MIN_NAME]", F),
        Be = new K("[MAX_NAME]", xe);function W(a, b, c) {
        this.A = a;this.W = b;this.g = c;
    }W.prototype.H = function () {
        y("Firebase.DataSnapshot.val", 0, 0, arguments.length);return this.A.H();
    };W.prototype.val = W.prototype.H;W.prototype.Ue = function () {
        y("Firebase.DataSnapshot.exportVal", 0, 0, arguments.length);return this.A.H(!0);
    };W.prototype.exportVal = W.prototype.Ue;W.prototype.Vf = function () {
        y("Firebase.DataSnapshot.exists", 0, 0, arguments.length);return !this.A.e();
    };W.prototype.exists = W.prototype.Vf;
    W.prototype.m = function (a) {
        y("Firebase.DataSnapshot.child", 0, 1, arguments.length);fa(a) && (a = String(a));Kf("Firebase.DataSnapshot.child", a);var b = new L(a),
            c = this.W.m(b);return new W(this.A.Q(b), c, N);
    };W.prototype.child = W.prototype.m;W.prototype.Fa = function (a) {
        y("Firebase.DataSnapshot.hasChild", 1, 1, arguments.length);Kf("Firebase.DataSnapshot.hasChild", a);var b = new L(a);return !this.A.Q(b).e();
    };W.prototype.hasChild = W.prototype.Fa;
    W.prototype.C = function () {
        y("Firebase.DataSnapshot.getPriority", 0, 0, arguments.length);return this.A.C().H();
    };W.prototype.getPriority = W.prototype.C;W.prototype.forEach = function (a) {
        y("Firebase.DataSnapshot.forEach", 1, 1, arguments.length);A("Firebase.DataSnapshot.forEach", 1, a, !1);if (this.A.J()) return !1;var b = this;return !!this.A.P(this.g, function (c, d) {
            return a(new W(d, b.W.m(c), N));
        });
    };W.prototype.forEach = W.prototype.forEach;
    W.prototype.kd = function () {
        y("Firebase.DataSnapshot.hasChildren", 0, 0, arguments.length);return this.A.J() ? !1 : !this.A.e();
    };W.prototype.hasChildren = W.prototype.kd;W.prototype.getKey = function () {
        y("Firebase.DataSnapshot.key", 0, 0, arguments.length);return this.W.getKey();
    };pd(W.prototype, "key", W.prototype.getKey);W.prototype.Fb = function () {
        y("Firebase.DataSnapshot.numChildren", 0, 0, arguments.length);return this.A.Fb();
    };W.prototype.numChildren = W.prototype.Fb;
    W.prototype.xb = function () {
        y("Firebase.DataSnapshot.ref", 0, 0, arguments.length);return this.W;
    };pd(W.prototype, "ref", W.prototype.xb);function Xd(a, b) {
        this.O = a;this.Ld = b;
    }function Ud(a, b, c, d) {
        return new Xd(new Ec(b, c, d), a.Ld);
    }function Yd(a) {
        return a.O.ea ? a.O.j() : null;
    }Xd.prototype.u = function () {
        return this.Ld;
    };function Fc(a) {
        return a.Ld.ea ? a.Ld.j() : null;
    };function ng(a, b) {
        this.W = a;var c = a.n,
            d = new ee(c.g),
            c = S(c) ? new ee(c.g) : c.xa ? new ke(c) : new fe(c);this.of = new Od(c);var e = b.u(),
            f = b.O,
            g = d.za(F, e.j(), null),
            k = c.za(F, f.j(), null);this.Na = new Xd(new Ec(k, f.ea, c.Qa()), new Ec(g, e.ea, d.Qa()));this.ab = [];this.Sf = new Jd(a);
    }function og(a) {
        return a.W;
    }h = ng.prototype;h.u = function () {
        return this.Na.u().j();
    };h.jb = function (a) {
        var b = Fc(this.Na);return b && (S(this.W.n) || !a.e() && !b.R(J(a)).e()) ? b.Q(a) : null;
    };h.e = function () {
        return 0 === this.ab.length;
    };h.Ob = function (a) {
        this.ab.push(a);
    };
    h.mb = function (a, b) {
        var c = [];if (b) {
            H(null == a, "A cancel should cancel all event registrations.");var d = this.W.path;Ja(this.ab, function (a) {
                (a = a.Pe(b, d)) && c.push(a);
            });
        }if (a) {
            for (var e = [], f = 0; f < this.ab.length; ++f) {
                var g = this.ab[f];if (!g.matches(a)) e.push(g);else if (a.af()) {
                    e = e.concat(this.ab.slice(f + 1));break;
                }
            }this.ab = e;
        } else this.ab = [];return c;
    };
    h.gb = function (a, b, c) {
        a.type === Gd && null !== a.source.Ib && (H(Fc(this.Na), "We should always have a full cache before handling merges"), H(Yd(this.Na), "Missing event cache, even though we have a server cache"));var d = this.Na;a = this.of.gb(d, a, b, c);b = this.of;c = a.Sd;H(c.O.j().zc(b.V.g), "Event snap not indexed");H(c.u().j().zc(b.V.g), "Server snap not indexed");H(Ic(a.Sd.u()) || !Ic(d.u()), "Once a server snap is complete, it should never go back");this.Na = a.Sd;return pg(this, a.Mf, a.Sd.O.j(), null);
    };
    function qg(a, b) {
        var c = a.Na.O,
            d = [];c.j().J() || c.j().P(N, function (a, b) {
            d.push(new I("child_added", b, a));
        });c.ea && d.push(Gc(c.j()));return pg(a, d, c.j(), b);
    }function pg(a, b, c, d) {
        return Kd(a.Sf, b, c, d ? [d] : a.ab);
    };function rg(a, b, c) {
        this.Qb = a;this.sb = b;this.ub = c || null;
    }h = rg.prototype;h.tf = function (a) {
        return "value" === a;
    };h.createEvent = function (a, b) {
        var c = b.n.g;return new yc("value", this, new W(a.Ma, b.xb(), c));
    };h.Ub = function (a) {
        var b = this.ub;if ("cancel" === a.ge()) {
            H(this.sb, "Raising a cancel event on a listener with no cancel callback");var c = this.sb;return function () {
                c.call(b, a.error);
            };
        }var d = this.Qb;return function () {
            d.call(b, a.Md);
        };
    };h.Pe = function (a, b) {
        return this.sb ? new zc(this, a, b) : null;
    };
    h.matches = function (a) {
        return a instanceof rg ? a.Qb && this.Qb ? a.Qb === this.Qb && a.ub === this.ub : !0 : !1;
    };h.af = function () {
        return null !== this.Qb;
    };function sg(a, b, c) {
        this.ha = a;this.sb = b;this.ub = c;
    }h = sg.prototype;h.tf = function (a) {
        a = "children_added" === a ? "child_added" : a;return ("children_removed" === a ? "child_removed" : a) in this.ha;
    };h.Pe = function (a, b) {
        return this.sb ? new zc(this, a, b) : null;
    };
    h.createEvent = function (a, b) {
        H(null != a.Za, "Child events should have a childName.");var c = b.xb().m(a.Za);return new yc(a.type, this, new W(a.Ma, c, b.n.g), a.Dd);
    };h.Ub = function (a) {
        var b = this.ub;if ("cancel" === a.ge()) {
            H(this.sb, "Raising a cancel event on a listener with no cancel callback");var c = this.sb;return function () {
                c.call(b, a.error);
            };
        }var d = this.ha[a.gd];return function () {
            d.call(b, a.Md, a.Dd);
        };
    };
    h.matches = function (a) {
        if (a instanceof sg) {
            if (!this.ha || !a.ha) return !0;if (this.ub === a.ub) {
                var b = qa(a.ha);if (b === qa(this.ha)) {
                    if (1 === b) {
                        var b = ra(a.ha),
                            c = ra(this.ha);return c === b && (!a.ha[b] || !this.ha[c] || a.ha[b] === this.ha[c]);
                    }return pa(this.ha, function (b, c) {
                        return a.ha[c] === b;
                    });
                }
            }
        }return !1;
    };h.af = function () {
        return null !== this.ha;
    };function X(a, b, c, d) {
        this.w = a;this.path = b;this.n = c;this.Oc = d;
    }
    function tg(a) {
        var b = null,
            c = null;a.ka && (b = he(a));a.na && (c = je(a));if (a.g === de) {
            if (a.ka) {
                if ("[MIN_NAME]" != ge(a)) throw Error("Query: When ordering by key, you may only pass one argument to startAt(), endAt(), or equalTo().");if ("string" !== typeof b) throw Error("Query: When ordering by key, the argument passed to startAt(), endAt(),or equalTo() must be a string.");
            }if (a.na) {
                if ("[MAX_NAME]" != ie(a)) throw Error("Query: When ordering by key, you may only pass one argument to startAt(), endAt(), or equalTo().");if ("string" !== typeof c) throw Error("Query: When ordering by key, the argument passed to startAt(), endAt(),or equalTo() must be a string.");
            }
        } else if (a.g === N) {
            if (null != b && !Cf(b) || null != c && !Cf(c)) throw Error("Query: When ordering by priority, the first argument passed to startAt(), endAt(), or equalTo() must be a valid priority value (null, a number, or a string).");
        } else if (H(a.g instanceof we || a.g === Ce, "unknown index type."), null != b && "object" === (typeof b === "undefined" ? "undefined" : _typeof(b)) || null != c && "object" === (typeof c === "undefined" ? "undefined" : _typeof(c))) throw Error("Query: First argument passed to startAt(), endAt(), or equalTo() cannot be an object.");
    }function ug(a) {
        if (a.ka && a.na && a.xa && (!a.xa || "" === a.oc)) throw Error("Query: Can't combine startAt(), endAt(), and limit(). Use limitToFirst() or limitToLast() instead.");
    }function vg(a, b) {
        if (!0 === a.Oc) throw Error(b + ": You can't combine multiple orderBy calls.");
    }h = X.prototype;h.xb = function () {
        y("Query.ref", 0, 0, arguments.length);return new U(this.w, this.path);
    };
    h.hc = function (a, b, c, d) {
        y("Query.on", 2, 4, arguments.length);If("Query.on", a, !1);A("Query.on", 2, b, !1);var e = wg("Query.on", c, d);if ("value" === a) xg(this.w, this, new rg(b, e.cancel || null, e.Pa || null));else {
            var f = {};f[a] = b;xg(this.w, this, new sg(f, e.cancel, e.Pa));
        }return b;
    };
    h.Jc = function (a, b, c) {
        y("Query.off", 0, 3, arguments.length);If("Query.off", a, !0);A("Query.off", 2, b, !0);Eb("Query.off", 3, c);var d = null,
            e = null;"value" === a ? d = new rg(b || null, null, c || null) : a && (b && (e = {}, e[a] = b), d = new sg(e, null, c || null));e = this.w;d = ".info" === J(this.path) ? e.pd.mb(this, d) : e.K.mb(this, d);uc(e.da, this.path, d);
    };
    h.kg = function (a, b) {
        function c(k) {
            f && (f = !1, e.Jc(a, c), b && b.call(d.Pa, k), g.resolve(k));
        }y("Query.once", 1, 4, arguments.length);If("Query.once", a, !1);A("Query.once", 2, b, !0);var d = wg("Query.once", arguments[2], arguments[3]),
            e = this,
            f = !0,
            g = new Hb();Jb(g.ra);this.hc(a, c, function (b) {
            e.Jc(a, c);d.cancel && d.cancel.call(d.Pa, b);g.reject(b);
        });return g.ra;
    };
    h.ne = function (a) {
        y("Query.limitToFirst", 1, 1, arguments.length);if (!fa(a) || Math.floor(a) !== a || 0 >= a) throw Error("Query.limitToFirst: First argument must be a positive integer.");if (this.n.xa) throw Error("Query.limitToFirst: Limit was already set (by another call to limit, limitToFirst, or limitToLast).");return new X(this.w, this.path, this.n.ne(a), this.Oc);
    };
    h.oe = function (a) {
        y("Query.limitToLast", 1, 1, arguments.length);if (!fa(a) || Math.floor(a) !== a || 0 >= a) throw Error("Query.limitToLast: First argument must be a positive integer.");if (this.n.xa) throw Error("Query.limitToLast: Limit was already set (by another call to limit, limitToFirst, or limitToLast).");return new X(this.w, this.path, this.n.oe(a), this.Oc);
    };
    h.lg = function (a) {
        y("Query.orderByChild", 1, 1, arguments.length);if ("$key" === a) throw Error('Query.orderByChild: "$key" is invalid.  Use Query.orderByKey() instead.');if ("$priority" === a) throw Error('Query.orderByChild: "$priority" is invalid.  Use Query.orderByPriority() instead.');if ("$value" === a) throw Error('Query.orderByChild: "$value" is invalid.  Use Query.orderByValue() instead.');Kf("Query.orderByChild", a);vg(this, "Query.orderByChild");var b = new L(a);if (b.e()) throw Error("Query.orderByChild: cannot pass in empty path.  Use Query.orderByValue() instead.");
        b = new we(b);b = Ge(this.n, b);tg(b);return new X(this.w, this.path, b, !0);
    };h.mg = function () {
        y("Query.orderByKey", 0, 0, arguments.length);vg(this, "Query.orderByKey");var a = Ge(this.n, de);tg(a);return new X(this.w, this.path, a, !0);
    };h.ng = function () {
        y("Query.orderByPriority", 0, 0, arguments.length);vg(this, "Query.orderByPriority");var a = Ge(this.n, N);tg(a);return new X(this.w, this.path, a, !0);
    };
    h.og = function () {
        y("Query.orderByValue", 0, 0, arguments.length);vg(this, "Query.orderByValue");var a = Ge(this.n, Ce);tg(a);return new X(this.w, this.path, a, !0);
    };h.Nd = function (a, b) {
        y("Query.startAt", 0, 2, arguments.length);Df("Query.startAt", a, this.path, !0);Jf("Query.startAt", b);var c = this.n.Nd(a, b);ug(c);tg(c);if (this.n.ka) throw Error("Query.startAt: Starting point was already set (by another call to startAt or equalTo).");p(a) || (b = a = null);return new X(this.w, this.path, c, this.Oc);
    };
    h.fd = function (a, b) {
        y("Query.endAt", 0, 2, arguments.length);Df("Query.endAt", a, this.path, !0);Jf("Query.endAt", b);var c = this.n.fd(a, b);ug(c);tg(c);if (this.n.na) throw Error("Query.endAt: Ending point was already set (by another call to endAt or equalTo).");return new X(this.w, this.path, c, this.Oc);
    };
    h.Rf = function (a, b) {
        y("Query.equalTo", 1, 2, arguments.length);Df("Query.equalTo", a, this.path, !1);Jf("Query.equalTo", b);if (this.n.ka) throw Error("Query.equalTo: Starting point was already set (by another call to endAt or equalTo).");if (this.n.na) throw Error("Query.equalTo: Ending point was already set (by another call to endAt or equalTo).");return this.Nd(a, b).fd(a, b);
    };
    h.toString = function () {
        y("Query.toString", 0, 0, arguments.length);for (var a = this.path, b = "", c = a.Z; c < a.o.length; c++) {
            "" !== a.o[c] && (b += "/" + encodeURIComponent(String(a.o[c])));
        }return this.w.toString() + (b || "/");
    };h.ya = function () {
        var a = kd(He(this.n));return "{}" === a ? "default" : a;
    };
    function wg(a, b, c) {
        var d = { cancel: null, Pa: null };if (b && c) d.cancel = b, A(a, 3, d.cancel, !0), d.Pa = c, Eb(a, 4, d.Pa);else if (b) if ("object" === (typeof b === "undefined" ? "undefined" : _typeof(b)) && null !== b) d.Pa = b;else if ("function" === typeof b) d.cancel = b;else throw Error(Db(a, 3, !0) + " must either be a cancel callback or a context object.");return d;
    }X.prototype.on = X.prototype.hc;X.prototype.off = X.prototype.Jc;X.prototype.once = X.prototype.kg;X.prototype.limitToFirst = X.prototype.ne;X.prototype.limitToLast = X.prototype.oe;X.prototype.orderByChild = X.prototype.lg;
    X.prototype.orderByKey = X.prototype.mg;X.prototype.orderByPriority = X.prototype.ng;X.prototype.orderByValue = X.prototype.og;X.prototype.startAt = X.prototype.Nd;X.prototype.endAt = X.prototype.fd;X.prototype.equalTo = X.prototype.Rf;X.prototype.toString = X.prototype.toString;pd(X.prototype, "ref", X.prototype.xb);function yg(a, b) {
        this.value = a;this.children = b || zg;
    }var zg = new Uf(function (a, b) {
        return a === b ? 0 : a < b ? -1 : 1;
    });function Ag(a) {
        var b = Q;t(a, function (a, d) {
            b = b.set(new L(d), a);
        });return b;
    }h = yg.prototype;h.e = function () {
        return null === this.value && this.children.e();
    };function Bg(a, b, c) {
        if (null != a.value && c(a.value)) return { path: C, value: a.value };if (b.e()) return null;var d = J(b);a = a.children.get(d);return null !== a ? (b = Bg(a, D(b), c), null != b ? { path: new L(d).m(b.path), value: b.value } : null) : null;
    }
    function Cg(a, b) {
        return Bg(a, b, function () {
            return !0;
        });
    }h.subtree = function (a) {
        if (a.e()) return this;var b = this.children.get(J(a));return null !== b ? b.subtree(D(a)) : Q;
    };h.set = function (a, b) {
        if (a.e()) return new yg(b, this.children);var c = J(a),
            d = (this.children.get(c) || Q).set(D(a), b),
            c = this.children.Ra(c, d);return new yg(this.value, c);
    };
    h.remove = function (a) {
        if (a.e()) return this.children.e() ? Q : new yg(null, this.children);var b = J(a),
            c = this.children.get(b);return c ? (a = c.remove(D(a)), b = a.e() ? this.children.remove(b) : this.children.Ra(b, a), null === this.value && b.e() ? Q : new yg(this.value, b)) : this;
    };h.get = function (a) {
        if (a.e()) return this.value;var b = this.children.get(J(a));return b ? b.get(D(a)) : null;
    };
    function ce(a, b, c) {
        if (b.e()) return c;var d = J(b);b = ce(a.children.get(d) || Q, D(b), c);d = b.e() ? a.children.remove(d) : a.children.Ra(d, b);return new yg(a.value, d);
    }function Dg(a, b) {
        return Eg(a, C, b);
    }function Eg(a, b, c) {
        var d = {};a.children.ia(function (a, f) {
            d[a] = Eg(f, b.m(a), c);
        });return c(b, a.value, d);
    }function Fg(a, b, c) {
        return Gg(a, b, C, c);
    }function Gg(a, b, c, d) {
        var e = a.value ? d(c, a.value) : !1;if (e) return e;if (b.e()) return null;e = J(b);return (a = a.children.get(e)) ? Gg(a, D(b), c.m(e), d) : null;
    }
    function Hg(a, b, c) {
        Ig(a, b, C, c);
    }function Ig(a, b, c, d) {
        if (b.e()) return a;a.value && d(c, a.value);var e = J(b);return (a = a.children.get(e)) ? Ig(a, D(b), c.m(e), d) : Q;
    }function ae(a, b) {
        Jg(a, C, b);
    }function Jg(a, b, c) {
        a.children.ia(function (a, e) {
            Jg(e, b.m(a), c);
        });a.value && c(b, a.value);
    }function Kg(a, b) {
        a.children.ia(function (a, d) {
            d.value && b(a, d.value);
        });
    }var Q = new yg(null);yg.prototype.toString = function () {
        var a = {};ae(this, function (b, c) {
            a[b.toString()] = c.toString();
        });return B(a);
    };function Lg(a, b, c) {
        this.type = Td;this.source = Mg;this.path = a;this.Pb = b;this.Id = c;
    }Lg.prototype.Nc = function (a) {
        if (this.path.e()) {
            if (null != this.Pb.value) return H(this.Pb.children.e(), "affectedTree should not have overlapping affected paths."), this;a = this.Pb.subtree(new L(a));return new Lg(C, a, this.Id);
        }H(J(this.path) === a, "operationForChild called for unrelated child.");return new Lg(D(this.path), this.Pb, this.Id);
    };
    Lg.prototype.toString = function () {
        return "Operation(" + this.path + ": " + this.source.toString() + " ack write revert=" + this.Id + " affectedTree=" + this.Pb + ")";
    };var ac = 0,
        Gd = 1,
        Td = 2,
        cc = 3;function Ng(a, b, c, d) {
        this.ee = a;this.We = b;this.Ib = c;this.Ee = d;H(!d || b, "Tagged queries must be from server.");
    }var Mg = new Ng(!0, !1, null, !1),
        Og = new Ng(!1, !0, null, !1);Ng.prototype.toString = function () {
        return this.ee ? "user" : this.Ee ? "server(queryID=" + this.Ib + ")" : "server";
    };function Pg(a) {
        this.X = a;
    }var Qg = new Pg(new yg(null));function Rg(a, b, c) {
        if (b.e()) return new Pg(new yg(c));var d = Cg(a.X, b);if (null != d) {
            var e = d.path,
                d = d.value;b = T(e, b);d = d.F(b, c);return new Pg(a.X.set(e, d));
        }a = ce(a.X, b, new yg(c));return new Pg(a);
    }function Sg(a, b, c) {
        var d = a;Cb(c, function (a, c) {
            d = Rg(d, b.m(a), c);
        });return d;
    }Pg.prototype.Ed = function (a) {
        if (a.e()) return Qg;a = ce(this.X, a, Q);return new Pg(a);
    };function Tg(a, b) {
        var c = Cg(a.X, b);return null != c ? a.X.get(c.path).Q(T(c.path, b)) : null;
    }
    function Ug(a) {
        var b = [],
            c = a.X.value;null != c ? c.J() || c.P(N, function (a, c) {
            b.push(new K(a, c));
        }) : a.X.children.ia(function (a, c) {
            null != c.value && b.push(new K(a, c.value));
        });return b;
    }function Vg(a, b) {
        if (b.e()) return a;var c = Tg(a, b);return null != c ? new Pg(new yg(c)) : new Pg(a.X.subtree(b));
    }Pg.prototype.e = function () {
        return this.X.e();
    };Pg.prototype.apply = function (a) {
        return Wg(C, this.X, a);
    };
    function Wg(a, b, c) {
        if (null != b.value) return c.F(a, b.value);var d = null;b.children.ia(function (b, f) {
            ".priority" === b ? (H(null !== f.value, "Priority writes must always be leaf nodes"), d = f.value) : c = Wg(a.m(b), f, c);
        });c.Q(a).e() || null === d || (c = c.F(a.m(".priority"), d));return c;
    };function Xg() {
        this.Aa = {};
    }h = Xg.prototype;h.e = function () {
        return xa(this.Aa);
    };h.gb = function (a, b, c) {
        var d = a.source.Ib;if (null !== d) return d = x(this.Aa, d), H(null != d, "SyncTree gave us an op for an invalid query."), d.gb(a, b, c);var e = [];t(this.Aa, function (d) {
            e = e.concat(d.gb(a, b, c));
        });return e;
    };h.Ob = function (a, b, c, d, e) {
        var f = a.ya(),
            g = x(this.Aa, f);if (!g) {
            var g = c.Ba(e ? d : null),
                k = !1;g ? k = !0 : (g = d instanceof P ? c.sc(d) : F, k = !1);g = new ng(a, new Xd(new Ec(g, k, !1), new Ec(d, e, !1)));this.Aa[f] = g;
        }g.Ob(b);return qg(g, b);
    };
    h.mb = function (a, b, c) {
        var d = a.ya(),
            e = [],
            f = [],
            g = null != Yg(this);if ("default" === d) {
            var k = this;t(this.Aa, function (a, d) {
                f = f.concat(a.mb(b, c));a.e() && (delete k.Aa[d], S(a.W.n) || e.push(a.W));
            });
        } else {
            var m = x(this.Aa, d);m && (f = f.concat(m.mb(b, c)), m.e() && (delete this.Aa[d], S(m.W.n) || e.push(m.W)));
        }g && null == Yg(this) && e.push(new U(a.w, a.path));return { sg: e, Tf: f };
    };function Zg(a) {
        return Ka(sa(a.Aa), function (a) {
            return !S(a.W.n);
        });
    }h.jb = function (a) {
        var b = null;t(this.Aa, function (c) {
            b = b || c.jb(a);
        });return b;
    };
    function $g(a, b) {
        if (S(b.n)) return Yg(a);var c = b.ya();return x(a.Aa, c);
    }function Yg(a) {
        return wa(a.Aa, function (a) {
            return S(a.W.n);
        }) || null;
    };function ah() {
        this.T = Qg;this.la = [];this.Cc = -1;
    }function bh(a, b) {
        for (var c = 0; c < a.la.length; c++) {
            var d = a.la[c];if (d.Zc === b) return d;
        }return null;
    }h = ah.prototype;
    h.Ed = function (a) {
        var b = Pa(this.la, function (b) {
            return b.Zc === a;
        });H(0 <= b, "removeWrite called with nonexistent writeId.");var c = this.la[b];this.la.splice(b, 1);for (var d = c.visible, e = !1, f = this.la.length - 1; d && 0 <= f;) {
            var g = this.la[f];g.visible && (f >= b && ch(g, c.path) ? d = !1 : c.path.contains(g.path) && (e = !0));f--;
        }if (d) {
            if (e) this.T = dh(this.la, eh, C), this.Cc = 0 < this.la.length ? this.la[this.la.length - 1].Zc : -1;else if (c.Ja) this.T = this.T.Ed(c.path);else {
                var k = this;t(c.children, function (a, b) {
                    k.T = k.T.Ed(c.path.m(b));
                });
            }return !0;
        }return !1;
    };
    h.Ba = function (a, b, c, d) {
        if (c || d) {
            var e = Vg(this.T, a);return !d && e.e() ? b : d || null != b || null != Tg(e, C) ? (e = dh(this.la, function (b) {
                return (b.visible || d) && (!c || !(0 <= Ia(c, b.Zc))) && (b.path.contains(a) || a.contains(b.path));
            }, a), b = b || F, e.apply(b)) : null;
        }e = Tg(this.T, a);if (null != e) return e;e = Vg(this.T, a);return e.e() ? b : null != b || null != Tg(e, C) ? (b = b || F, e.apply(b)) : null;
    };
    h.sc = function (a, b) {
        var c = F,
            d = Tg(this.T, a);if (d) d.J() || d.P(N, function (a, b) {
            c = c.U(a, b);
        });else if (b) {
            var e = Vg(this.T, a);b.P(N, function (a, b) {
                var d = Vg(e, new L(a)).apply(b);c = c.U(a, d);
            });Ja(Ug(e), function (a) {
                c = c.U(a.name, a.S);
            });
        } else e = Vg(this.T, a), Ja(Ug(e), function (a) {
            c = c.U(a.name, a.S);
        });return c;
    };h.$c = function (a, b, c, d) {
        H(c || d, "Either existingEventSnap or existingServerSnap must exist");a = a.m(b);if (null != Tg(this.T, a)) return null;a = Vg(this.T, a);return a.e() ? d.Q(b) : a.apply(d.Q(b));
    };
    h.rc = function (a, b, c) {
        a = a.m(b);var d = Tg(this.T, a);return null != d ? d : Dc(c, b) ? Vg(this.T, a).apply(c.j().R(b)) : null;
    };h.mc = function (a) {
        return Tg(this.T, a);
    };h.Xd = function (a, b, c, d, e, f) {
        var g;a = Vg(this.T, a);g = Tg(a, C);if (null == g) if (null != b) g = a.apply(b);else return [];g = g.ob(f);if (g.e() || g.J()) return [];b = [];a = ne(f);e = e ? g.$b(c, f) : g.Yb(c, f);for (f = R(e); f && b.length < d;) {
            0 !== a(f, c) && b.push(f), f = R(e);
        }return b;
    };
    function ch(a, b) {
        return a.Ja ? a.path.contains(b) : !!va(a.children, function (c, d) {
            return a.path.m(d).contains(b);
        });
    }function eh(a) {
        return a.visible;
    }
    function dh(a, b, c) {
        for (var d = Qg, e = 0; e < a.length; ++e) {
            var f = a[e];if (b(f)) {
                var g = f.path;if (f.Ja) c.contains(g) ? (g = T(c, g), d = Rg(d, g, f.Ja)) : g.contains(c) && (g = T(g, c), d = Rg(d, C, f.Ja.Q(g)));else if (f.children) {
                    if (c.contains(g)) g = T(c, g), d = Sg(d, g, f.children);else {
                        if (g.contains(c)) if (g = T(g, c), g.e()) d = Sg(d, C, f.children);else if (f = x(f.children, J(g))) f = f.Q(D(g)), d = Rg(d, C, f);
                    }
                } else throw Xc("WriteRecord should have .snap or .children");
            }
        }return d;
    }function fh(a, b) {
        this.Mb = a;this.X = b;
    }h = fh.prototype;
    h.Ba = function (a, b, c) {
        return this.X.Ba(this.Mb, a, b, c);
    };h.sc = function (a) {
        return this.X.sc(this.Mb, a);
    };h.$c = function (a, b, c) {
        return this.X.$c(this.Mb, a, b, c);
    };h.mc = function (a) {
        return this.X.mc(this.Mb.m(a));
    };h.Xd = function (a, b, c, d, e) {
        return this.X.Xd(this.Mb, a, b, c, d, e);
    };h.rc = function (a, b) {
        return this.X.rc(this.Mb, a, b);
    };h.m = function (a) {
        return new fh(this.Mb.m(a), this.X);
    };function gh() {
        this.children = {};this.ad = 0;this.value = null;
    }function hh(a, b, c) {
        this.ud = a ? a : "";this.Ha = b ? b : null;this.A = c ? c : new gh();
    }function ih(a, b) {
        for (var c = b instanceof L ? b : new L(b), d = a, e; null !== (e = J(c));) {
            d = new hh(e, d, x(d.A.children, e) || new gh()), c = D(c);
        }return d;
    }h = hh.prototype;h.Ea = function () {
        return this.A.value;
    };function jh(a, b) {
        H("undefined" !== typeof b, "Cannot set value to undefined");a.A.value = b;kh(a);
    }h.clear = function () {
        this.A.value = null;this.A.children = {};this.A.ad = 0;kh(this);
    };
    h.kd = function () {
        return 0 < this.A.ad;
    };h.e = function () {
        return null === this.Ea() && !this.kd();
    };h.P = function (a) {
        var b = this;t(this.A.children, function (c, d) {
            a(new hh(d, b, c));
        });
    };function lh(a, b, c, d) {
        c && !d && b(a);a.P(function (a) {
            lh(a, b, !0, d);
        });c && d && b(a);
    }function mh(a, b) {
        for (var c = a.parent(); null !== c && !b(c);) {
            c = c.parent();
        }
    }h.path = function () {
        return new L(null === this.Ha ? this.ud : this.Ha.path() + "/" + this.ud);
    };h.name = function () {
        return this.ud;
    };h.parent = function () {
        return this.Ha;
    };
    function kh(a) {
        if (null !== a.Ha) {
            var b = a.Ha,
                c = a.ud,
                d = a.e(),
                e = Bb(b.A.children, c);d && e ? (delete b.A.children[c], b.A.ad--, kh(b)) : d || e || (b.A.children[c] = a.A, b.A.ad++, kh(b));
        }
    };function nh(a, b, c, d, e, f) {
        this.id = oh++;this.f = cd("p:" + this.id + ":");this.qd = {};this.$ = {};this.pa = [];this.Pc = 0;this.Lc = [];this.ma = !1;this.Va = 1E3;this.td = 3E5;this.Hb = b;this.Kc = c;this.ue = d;this.M = a;this.pb = this.Ia = this.Db = this.ze = null;this.Vd = e;this.de = !1;this.ke = 0;if (f) throw Error("Auth override specified in options, but not supported on non Node.js platforms");this.Je = f || null;this.vb = null;this.Nb = !1;this.Gd = {};this.tg = 0;this.Ve = !0;this.Bc = this.me = null;ph(this, 0);Sf.Wb().hc("visible", this.jg, this);-1 === a.host.indexOf("fblocal") && Rf.Wb().hc("online", this.ig, this);
    }var oh = 0,
        qh = 0;h = nh.prototype;h.ua = function (a, b, c) {
        var d = ++this.tg;a = { r: d, a: a, b: b };this.f(B(a));H(this.ma, "sendRequest call when we're not connected not allowed.");this.Ia.ua(a);c && (this.Gd[d] = c);
    };
    h.df = function (a, b, c, d) {
        var e = a.ya(),
            f = a.path.toString();this.f("Listen called for " + f + " " + e);this.$[f] = this.$[f] || {};H(Cd(a.n) || !S(a.n), "listen() called for non-default but complete query");H(!this.$[f][e], "listen() called twice for same path/queryId.");a = { G: d, ld: b, pg: a, tag: c };this.$[f][e] = a;this.ma && rh(this, a);
    };
    function rh(a, b) {
        var c = b.pg,
            d = c.path.toString(),
            e = c.ya();a.f("Listen on " + d + " for " + e);var f = { p: d };b.tag && (f.q = He(c.n), f.t = b.tag);f.h = b.ld();a.ua("q", f, function (f) {
            var k = f.d,
                m = f.s;if (k && "object" === (typeof k === "undefined" ? "undefined" : _typeof(k)) && Bb(k, "w")) {
                var l = x(k, "w");da(l) && 0 <= Ia(l, "no_index") && O("Using an unspecified index. Consider adding " + ('".indexOn": "' + c.n.g.toString() + '"') + " at " + c.path.toString() + " to your security rules for better performance");
            }(a.$[d] && a.$[d][e]) === b && (a.f("listen response", f), "ok" !== m && sh(a, d, e), b.G && b.G(m, k));
        });
    }h.qf = function (a) {
        this.pb = a;this.f("Auth token refreshed");this.pb ? th(this) : this.ma && this.ua("unauth", {}, function () {});if (a && 40 === a.length || sd(a)) this.f("Admin auth credential detected.  Reducing max reconnect time."), this.td = 3E4;
    };function th(a) {
        if (a.ma && a.pb) {
            var b = a.pb,
                c = rd(b) ? "auth" : "gauth",
                d = { cred: b };a.Je && (d.authvar = a.Je);a.ua(c, d, function (c) {
                var d = c.s;c = c.d || "error";a.pb === b && ("ok" === d ? this.ke = 0 : uh(a, d, c));
            });
        }
    }
    h.Ef = function (a, b) {
        var c = a.path.toString(),
            d = a.ya();this.f("Unlisten called for " + c + " " + d);H(Cd(a.n) || !S(a.n), "unlisten() called for non-default but complete query");if (sh(this, c, d) && this.ma) {
            var e = He(a.n);this.f("Unlisten on " + c + " for " + d);c = { p: c };b && (c.q = e, c.t = b);this.ua("n", c);
        }
    };h.re = function (a, b, c) {
        this.ma ? vh(this, "o", a, b, c) : this.Lc.push({ we: a, action: "o", data: b, G: c });
    };h.gf = function (a, b, c) {
        this.ma ? vh(this, "om", a, b, c) : this.Lc.push({ we: a, action: "om", data: b, G: c });
    };
    h.xd = function (a, b) {
        this.ma ? vh(this, "oc", a, null, b) : this.Lc.push({ we: a, action: "oc", data: null, G: b });
    };function vh(a, b, c, d, e) {
        c = { p: c, d: d };a.f("onDisconnect " + b, c);a.ua(b, c, function (a) {
            e && setTimeout(function () {
                e(a.s, a.d);
            }, Math.floor(0));
        });
    }h.put = function (a, b, c, d) {
        wh(this, "p", a, b, c, d);
    };h.ef = function (a, b, c, d) {
        wh(this, "m", a, b, c, d);
    };function wh(a, b, c, d, e, f) {
        d = { p: c, d: d };p(f) && (d.h = f);a.pa.push({ action: b, sf: d, G: e });a.Pc++;b = a.pa.length - 1;a.ma ? xh(a, b) : a.f("Buffering put: " + c);
    }
    function xh(a, b) {
        var c = a.pa[b].action,
            d = a.pa[b].sf,
            e = a.pa[b].G;a.pa[b].qg = a.ma;a.ua(c, d, function (d) {
            a.f(c + " response", d);delete a.pa[b];a.Pc--;0 === a.Pc && (a.pa = []);e && e(d.s, d.d);
        });
    }h.ye = function (a) {
        this.ma && (a = { c: a }, this.f("reportStats", a), this.ua("s", a, function (a) {
            "ok" !== a.s && this.f("reportStats", "Error sending stats: " + a.d);
        }));
    };
    h.wd = function (a) {
        if ("r" in a) {
            this.f("from server: " + B(a));var b = a.r,
                c = this.Gd[b];c && (delete this.Gd[b], c(a.b));
        } else {
            if ("error" in a) throw "A server-side error has occurred: " + a.error;"a" in a && (b = a.a, a = a.b, this.f("handleServerMessage", b, a), "d" === b ? this.Hb(a.p, a.d, !1, a.t) : "m" === b ? this.Hb(a.p, a.d, !0, a.t) : "c" === b ? yh(this, a.p, a.q) : "ac" === b ? uh(this, a.s, a.d) : "sd" === b ? this.ze ? this.ze(a) : "msg" in a && "undefined" !== typeof console && console.log("FIREBASE: " + a.msg.replace("\n", "\nFIREBASE: ")) : dd("Unrecognized action received from server: " + B(b) + "\nAre you using the latest client?"));
        }
    };h.Mc = function (a, b) {
        this.f("connection ready");this.ma = !0;this.Bc = new Date().getTime();this.ue({ serverTimeOffset: a - new Date().getTime() });this.Db = b;if (this.Ve) {
            var c = {};c["sdk.js." + firebase.SDK_VERSION.replace(/\./g, "-")] = 1;Qb() ? c["framework.cordova"] = 1 : "object" === (typeof navigator === "undefined" ? "undefined" : _typeof(navigator)) && "ReactNative" === navigator.product && (c["framework.reactnative"] = 1);this.ye(c);
        }zh(this);this.Ve = !1;this.Kc(!0);
    };
    function ph(a, b) {
        H(!a.Ia, "Scheduling a connect when we're already connected/ing?");a.vb && clearTimeout(a.vb);a.vb = setTimeout(function () {
            a.vb = null;Ah(a);
        }, Math.floor(b));
    }h.jg = function (a) {
        a && !this.Nb && this.Va === this.td && (this.f("Window became visible.  Reducing delay."), this.Va = 1E3, this.Ia || ph(this, 0));this.Nb = a;
    };h.ig = function (a) {
        a ? (this.f("Browser went online."), this.Va = 1E3, this.Ia || ph(this, 0)) : (this.f("Browser went offline.  Killing connection."), this.Ia && this.Ia.close());
    };
    h.jf = function () {
        this.f("data client disconnected");this.ma = !1;this.Ia = null;for (var a = 0; a < this.pa.length; a++) {
            var b = this.pa[a];b && "h" in b.sf && b.qg && (b.G && b.G("disconnect"), delete this.pa[a], this.Pc--);
        }0 === this.Pc && (this.pa = []);this.Gd = {};Bh(this) && (this.Nb ? this.Bc && (3E4 < new Date().getTime() - this.Bc && (this.Va = 1E3), this.Bc = null) : (this.f("Window isn't visible.  Delaying reconnect."), this.Va = this.td, this.me = new Date().getTime()), a = Math.max(0, this.Va - (new Date().getTime() - this.me)), a *= Math.random(), this.f("Trying to reconnect in " + a + "ms"), ph(this, a), this.Va = Math.min(this.td, 1.3 * this.Va));this.Kc(!1);
    };
    function Ah(a) {
        if (Bh(a)) {
            a.f("Making a connection attempt");a.me = new Date().getTime();a.Bc = null;var b = r(a.wd, a),
                c = r(a.Mc, a),
                d = r(a.jf, a),
                e = a.id + ":" + qh++,
                f = a.Db,
                g = !1,
                k = null,
                m = function m() {
                k ? k.close() : (g = !0, d());
            };a.Ia = { close: m, ua: function ua(a) {
                    H(k, "sendRequest call when we're not connected not allowed.");k.ua(a);
                } };var l = a.de;a.de = !1;a.Vd.getToken(l).then(function (l) {
                g ? E("getToken() completed but was canceled") : (E("getToken() completed. Creating connection."), a.pb = l && l.accessToken, k = new af(e, a.M, b, c, d, function (b) {
                    O(b + " (" + a.M.toString() + ")");a.eb("server_kill");
                }, f));
            }).then(null, function (b) {
                a.f("Failed to get token: " + b);g || m();
            });
        }
    }h.eb = function (a) {
        E("Interrupting connection for reason: " + a);this.qd[a] = !0;this.Ia ? this.Ia.close() : (this.vb && (clearTimeout(this.vb), this.vb = null), this.ma && this.jf());
    };h.lc = function (a) {
        E("Resuming connection for reason: " + a);delete this.qd[a];xa(this.qd) && (this.Va = 1E3, this.Ia || ph(this, 0));
    };
    function yh(a, b, c) {
        c = c ? La(c, function (a) {
            return kd(a);
        }).join("$") : "default";(a = sh(a, b, c)) && a.G && a.G("permission_denied");
    }function sh(a, b, c) {
        b = new L(b).toString();var d;p(a.$[b]) ? (d = a.$[b][c], delete a.$[b][c], 0 === qa(a.$[b]) && delete a.$[b]) : d = void 0;return d;
    }
    function uh(a, b, c) {
        E("Auth token revoked: " + b + "/" + c);a.pb = null;a.de = !0;a.Ia.close();"invalid_token" === b && (a.ke++, 3 <= a.ke && (a.Va = 3E4, O("Provided authentication credentials are invalid. This usually indicates your FirebaseApp instance was not initialized correctly. Make sure your apiKey and databaseURL match the values provided for your app at https://console.firebase.google.com/, or if you're using a service account, make sure it's authorized to access the specified databaseURL and is from the correct project.")));
    }
    function zh(a) {
        th(a);t(a.$, function (b) {
            t(b, function (b) {
                rh(a, b);
            });
        });for (var b = 0; b < a.pa.length; b++) {
            a.pa[b] && xh(a, b);
        }for (; a.Lc.length;) {
            b = a.Lc.shift(), vh(a, b.action, b.we, b.data, b.G);
        }
    }function Bh(a) {
        var b;b = Rf.Wb().ic;return xa(a.qd) && b;
    };var Y = { Xf: function Xf() {
            Qe = wd = !0;
        } };Y.forceLongPolling = Y.Xf;Y.Yf = function () {
        Re = !0;
    };Y.forceWebSockets = Y.Yf;Y.dg = function () {
        return vd.isAvailable();
    };Y.isWebSocketsAvailable = Y.dg;Y.wg = function (a, b) {
        a.w.Ua.ze = b;
    };Y.setSecurityDebugCallback = Y.wg;Y.Be = function (a, b) {
        a.w.Be(b);
    };Y.stats = Y.Be;Y.Ce = function (a, b) {
        a.w.Ce(b);
    };Y.statsIncrementCounter = Y.Ce;Y.ed = function (a) {
        return a.w.ed;
    };Y.dataUpdateCount = Y.ed;Y.cg = function (a, b) {
        a.w.je = b;
    };Y.interceptServerData = Y.cg;function Ch(a) {
        this.wa = Q;this.lb = new ah();this.De = {};this.jc = {};this.Dc = a;
    }function Dh(a, b, c, d, e) {
        var f = a.lb,
            g = e;H(d > f.Cc, "Stacking an older write on top of newer ones");p(g) || (g = !0);f.la.push({ path: b, Ja: c, Zc: d, visible: g });g && (f.T = Rg(f.T, b, c));f.Cc = d;return e ? Eh(a, new $b(Mg, b, c)) : [];
    }function Fh(a, b, c, d) {
        var e = a.lb;H(d > e.Cc, "Stacking an older merge on top of newer ones");e.la.push({ path: b, children: c, Zc: d, visible: !0 });e.T = Sg(e.T, b, c);e.Cc = d;c = Ag(c);return Eh(a, new Fd(Mg, b, c));
    }
    function Gh(a, b, c) {
        c = c || !1;var d = bh(a.lb, b);if (a.lb.Ed(b)) {
            var e = Q;null != d.Ja ? e = e.set(C, !0) : Cb(d.children, function (a, b) {
                e = e.set(new L(a), b);
            });return Eh(a, new Lg(d.path, e, c));
        }return [];
    }function Hh(a, b, c) {
        c = Ag(c);return Eh(a, new Fd(Og, b, c));
    }function Ih(a, b, c, d) {
        d = Jh(a, d);if (null != d) {
            var e = Kh(d);d = e.path;e = e.Ib;b = T(d, b);c = new $b(new Ng(!1, !0, e, !0), b, c);return Lh(a, d, c);
        }return [];
    }
    function Mh(a, b, c, d) {
        if (d = Jh(a, d)) {
            var e = Kh(d);d = e.path;e = e.Ib;b = T(d, b);c = Ag(c);c = new Fd(new Ng(!1, !0, e, !0), b, c);return Lh(a, d, c);
        }return [];
    }
    Ch.prototype.Ob = function (a, b) {
        var c = a.path,
            d = null,
            e = !1;Hg(this.wa, c, function (a, b) {
            var f = T(a, c);d = d || b.jb(f);e = e || null != Yg(b);
        });var f = this.wa.get(c);f ? (e = e || null != Yg(f), d = d || f.jb(C)) : (f = new Xg(), this.wa = this.wa.set(c, f));var g;null != d ? g = !0 : (g = !1, d = F, Kg(this.wa.subtree(c), function (a, b) {
            var c = b.jb(C);c && (d = d.U(a, c));
        }));var k = null != $g(f, a);if (!k && !S(a.n)) {
            var m = Nh(a);H(!(m in this.jc), "View does not exist, but we have a tag");var l = Oh++;this.jc[m] = l;this.De["_" + l] = m;
        }g = f.Ob(a, b, new fh(c, this.lb), d, g);k || e || (f = $g(f, a), g = g.concat(Ph(this, a, f)));return g;
    };
    Ch.prototype.mb = function (a, b, c) {
        var d = a.path,
            e = this.wa.get(d),
            f = [];if (e && ("default" === a.ya() || null != $g(e, a))) {
            f = e.mb(a, b, c);e.e() && (this.wa = this.wa.remove(d));e = f.sg;f = f.Tf;b = -1 !== Pa(e, function (a) {
                return S(a.n);
            });var g = Fg(this.wa, d, function (a, b) {
                return null != Yg(b);
            });if (b && !g && (d = this.wa.subtree(d), !d.e())) for (var d = Qh(d), k = 0; k < d.length; ++k) {
                var m = d[k],
                    l = m.W,
                    m = Rh(this, m);this.Dc.Ae(Sh(l), Th(this, l), m.ld, m.G);
            }if (!g && 0 < e.length && !c) if (b) this.Dc.Od(Sh(a), null);else {
                var u = this;Ja(e, function (a) {
                    a.ya();
                    var b = u.jc[Nh(a)];u.Dc.Od(Sh(a), b);
                });
            }Uh(this, e);
        }return f;
    };Ch.prototype.Ba = function (a, b) {
        var c = this.lb,
            d = Fg(this.wa, a, function (b, c) {
            var d = T(b, a);if (d = c.jb(d)) return d;
        });return c.Ba(a, d, b, !0);
    };function Qh(a) {
        return Dg(a, function (a, c, d) {
            if (c && null != Yg(c)) return [Yg(c)];var e = [];c && (e = Zg(c));t(d, function (a) {
                e = e.concat(a);
            });return e;
        });
    }function Uh(a, b) {
        for (var c = 0; c < b.length; ++c) {
            var d = b[c];if (!S(d.n)) {
                var d = Nh(d),
                    e = a.jc[d];delete a.jc[d];delete a.De["_" + e];
            }
        }
    }
    function Sh(a) {
        return S(a.n) && !Cd(a.n) ? a.xb() : a;
    }function Ph(a, b, c) {
        var d = b.path,
            e = Th(a, b);c = Rh(a, c);b = a.Dc.Ae(Sh(b), e, c.ld, c.G);d = a.wa.subtree(d);if (e) H(null == Yg(d.value), "If we're adding a query, it shouldn't be shadowed");else for (e = Dg(d, function (a, b, c) {
            if (!a.e() && b && null != Yg(b)) return [og(Yg(b))];var d = [];b && (d = d.concat(La(Zg(b), function (a) {
                return a.W;
            })));t(c, function (a) {
                d = d.concat(a);
            });return d;
        }), d = 0; d < e.length; ++d) {
            c = e[d], a.Dc.Od(Sh(c), Th(a, c));
        }return b;
    }
    function Rh(a, b) {
        var c = b.W,
            d = Th(a, c);return {
            ld: function ld() {
                return (b.u() || F).hash();
            }, G: function G(b) {
                if ("ok" === b) {
                    if (d) {
                        var f = c.path;if (b = Jh(a, d)) {
                            var g = Kh(b);b = g.path;g = g.Ib;f = T(b, f);f = new bc(new Ng(!1, !0, g, !0), f);b = Lh(a, b, f);
                        } else b = [];
                    } else b = Eh(a, new bc(Og, c.path));return b;
                }f = "Unknown Error";"too_big" === b ? f = "The data requested exceeds the maximum size that can be accessed with a single request." : "permission_denied" == b ? f = "Client doesn't have permission to access the desired data." : "unavailable" == b && (f = "The service is unavailable");f = Error(b + " at " + c.path.toString() + ": " + f);f.code = b.toUpperCase();return a.mb(c, null, f);
            }
        };
    }function Nh(a) {
        return a.path.toString() + "$" + a.ya();
    }function Kh(a) {
        var b = a.indexOf("$");H(-1 !== b && b < a.length - 1, "Bad queryKey.");return { Ib: a.substr(b + 1), path: new L(a.substr(0, b)) };
    }function Jh(a, b) {
        var c = a.De,
            d = "_" + b;return d in c ? c[d] : void 0;
    }function Th(a, b) {
        var c = Nh(b);return x(a.jc, c);
    }var Oh = 1;
    function Lh(a, b, c) {
        var d = a.wa.get(b);H(d, "Missing sync point for query tag that we're tracking");return d.gb(c, new fh(b, a.lb), null);
    }function Eh(a, b) {
        return Vh(a, b, a.wa, null, new fh(C, a.lb));
    }function Vh(a, b, c, d, e) {
        if (b.path.e()) return Wh(a, b, c, d, e);var f = c.get(C);null == d && null != f && (d = f.jb(C));var g = [],
            k = J(b.path),
            m = b.Nc(k);if ((c = c.children.get(k)) && m) var l = d ? d.R(k) : null,
            k = e.m(k),
            g = g.concat(Vh(a, m, c, l, k));f && (g = g.concat(f.gb(b, e, d)));return g;
    }
    function Wh(a, b, c, d, e) {
        var f = c.get(C);null == d && null != f && (d = f.jb(C));var g = [];c.children.ia(function (c, f) {
            var l = d ? d.R(c) : null,
                u = e.m(c),
                z = b.Nc(c);z && (g = g.concat(Wh(a, z, f, l, u)));
        });f && (g = g.concat(f.gb(b, e, d)));return g;
    };function sf(a, b, c) {
        this.app = c;var d = new dc(c);this.M = a;this.Xa = pc(a);this.Vc = null;this.da = new rc();this.vd = 1;this.Ua = null;if (b || 0 <= ("object" === (typeof window === "undefined" ? "undefined" : _typeof(window)) && window.navigator && window.navigator.userAgent || "").search(/googlebot|google webmaster tools|bingbot|yahoo! slurp|baiduspider|yandexbot|duckduckbot/i)) this.va = new Ad(this.M, r(this.Hb, this), d), setTimeout(r(this.Kc, this, !0), 0);else {
            b = c.options.databaseAuthVariableOverride || null;if (null !== b) {
                if ("object" !== ca(b)) throw Error("Only objects are supported for option databaseAuthVariableOverride");
                try {
                    B(b);
                } catch (e) {
                    throw Error("Invalid authOverride provided: " + e);
                }
            }this.va = this.Ua = new nh(this.M, r(this.Hb, this), r(this.Kc, this), r(this.ue, this), d, b);
        }var f = this;ec(d, function (a) {
            f.va.qf(a);
        });this.zg = qc(a, r(function () {
            return new jc(this.Xa, this.va);
        }, this));this.nc = new hh();this.ie = new fc();this.pd = new Ch({ Ae: function Ae(a, b, c, d) {
                b = [];c = f.ie.j(a.path);c.e() || (b = Eh(f.pd, new $b(Og, a.path, c)), setTimeout(function () {
                    d("ok");
                }, 0));return b;
            }, Od: aa });Xh(this, "connected", !1);this.ja = new Rc();this.$a = new rf(this);this.ed = 0;this.je = null;this.K = new Ch({ Ae: function Ae(a, b, c, d) {
                f.va.df(a, c, b, function (b, c) {
                    var e = d(b, c);wc(f.da, a.path, e);
                });return [];
            }, Od: function Od(a, b) {
                f.va.Ef(a, b);
            } });
    }h = sf.prototype;h.toString = function () {
        return (this.M.Sc ? "https://" : "http://") + this.M.host;
    };h.name = function () {
        return this.M.pe;
    };function Yh(a) {
        a = a.ie.j(new L(".info/serverTimeOffset")).H() || 0;return new Date().getTime() + a;
    }function Zh(a) {
        a = a = { timestamp: Yh(a) };a.timestamp = a.timestamp || new Date().getTime();return a;
    }
    h.Hb = function (a, b, c, d) {
        this.ed++;var e = new L(a);b = this.je ? this.je(a, b) : b;a = [];d ? c ? (b = oa(b, function (a) {
            return M(a);
        }), a = Mh(this.K, e, b, d)) : (b = M(b), a = Ih(this.K, e, b, d)) : c ? (d = oa(b, function (a) {
            return M(a);
        }), a = Hh(this.K, e, d)) : (d = M(b), a = Eh(this.K, new $b(Og, e, d)));d = e;0 < a.length && (d = $h(this, e));wc(this.da, d, a);
    };h.Kc = function (a) {
        Xh(this, "connected", a);!1 === a && ai(this);
    };h.ue = function (a) {
        var b = this;md(a, function (a, d) {
            Xh(b, d, a);
        });
    };
    function Xh(a, b, c) {
        b = new L("/.info/" + b);c = M(c);var d = a.ie;d.Jd = d.Jd.F(b, c);c = Eh(a.pd, new $b(Og, b, c));wc(a.da, b, c);
    }h.Kb = function (a, b, c, d) {
        this.f("set", { path: a.toString(), value: b, Gg: c });var e = Zh(this);b = M(b, c);var e = Uc(b, e),
            f = this.vd++,
            e = Dh(this.K, a, e, f, !0);sc(this.da, e);var g = this;this.va.put(a.toString(), b.H(!0), function (b, c) {
            var e = "ok" === b;e || O("set at " + a + " failed: " + b);e = Gh(g.K, f, !e);wc(g.da, a, e);bi(d, b, c);
        });e = ci(this, a);$h(this, e);wc(this.da, e, []);
    };
    h.update = function (a, b, c) {
        this.f("update", { path: a.toString(), value: b });var d = !0,
            e = Zh(this),
            f = {};t(b, function (a, b) {
            d = !1;var c = M(a);f[b] = Uc(c, e);
        });if (d) E("update() called with empty data.  Don't do anything."), bi(c, "ok");else {
            var g = this.vd++,
                k = Fh(this.K, a, f, g);sc(this.da, k);var m = this;this.va.ef(a.toString(), b, function (b, d) {
                var e = "ok" === b;e || O("update at " + a + " failed: " + b);var e = Gh(m.K, g, !e),
                    f = a;0 < e.length && (f = $h(m, a));wc(m.da, f, e);bi(c, b, d);
            });b = ci(this, a);$h(this, b);wc(this.da, a, []);
        }
    };
    function ai(a) {
        a.f("onDisconnectEvents");var b = Zh(a),
            c = [];Sc(Qc(a.ja, b), C, function (b, e) {
            c = c.concat(Eh(a.K, new $b(Og, b, e)));var f = ci(a, b);$h(a, f);
        });a.ja = new Rc();wc(a.da, C, c);
    }h.xd = function (a, b) {
        var c = this;this.va.xd(a.toString(), function (d, e) {
            "ok" === d && yf(c.ja, a);bi(b, d, e);
        });
    };function Mf(a, b, c, d) {
        var e = M(c);a.va.re(b.toString(), e.H(!0), function (c, g) {
            "ok" === c && Tc(a.ja, b, e);bi(d, c, g);
        });
    }function Nf(a, b, c, d, e) {
        var f = M(c, d);a.va.re(b.toString(), f.H(!0), function (c, d) {
            "ok" === c && Tc(a.ja, b, f);bi(e, c, d);
        });
    }
    function Of(a, b, c, d) {
        var e = !0,
            f;for (f in c) {
            e = !1;
        }e ? (E("onDisconnect().update() called with empty data.  Don't do anything."), bi(d, "ok")) : a.va.gf(b.toString(), c, function (e, f) {
            if ("ok" === e) for (var m in c) {
                var l = M(c[m]);Tc(a.ja, b.m(m), l);
            }bi(d, e, f);
        });
    }function xg(a, b, c) {
        c = ".info" === J(b.path) ? a.pd.Ob(b, c) : a.K.Ob(b, c);uc(a.da, b.path, c);
    }h.eb = function () {
        this.Ua && this.Ua.eb("repo_interrupt");
    };h.lc = function () {
        this.Ua && this.Ua.lc("repo_interrupt");
    };
    h.Be = function (a) {
        if ("undefined" !== typeof console) {
            a ? (this.Vc || (this.Vc = new kc(this.Xa)), a = this.Vc.get()) : a = this.Xa.get();var b = Ma(ta(a), function (a, b) {
                return Math.max(b.length, a);
            }, 0),
                c;for (c in a) {
                for (var d = a[c], e = c.length; e < b + 2; e++) {
                    c += " ";
                }console.log(c + d);
            }
        }
    };h.Ce = function (a) {
        mc(this.Xa, a);this.zg.zf[a] = !0;
    };h.f = function (a) {
        var b = "";this.Ua && (b = this.Ua.id + ":");E(b, arguments);
    };
    function bi(a, b, c) {
        a && Ub(function () {
            if ("ok" == b) a(null);else {
                var d = (b || "error").toUpperCase(),
                    e = d;c && (e += ": " + c);e = Error(e);e.code = d;a(e);
            }
        });
    };function di(a, b, c, d, e) {
        function f() {}a.f("transaction on " + b);var g = new U(a, b);g.hc("value", f);c = { path: b, update: c, G: d, status: null, lf: Wc(), Ie: e, wf: 0, Rd: function Rd() {
                g.Jc("value", f);
            }, Td: null, Da: null, bd: null, cd: null, dd: null };d = a.K.Ba(b, void 0) || F;c.bd = d;d = c.update(d.H());if (p(d)) {
            Ef("transaction failed: Data returned ", d, c.path);c.status = 1;e = ih(a.nc, b);var k = e.Ea() || [];k.push(c);jh(e, k);"object" === (typeof d === "undefined" ? "undefined" : _typeof(d)) && null !== d && Bb(d, ".priority") ? (k = x(d, ".priority"), H(Cf(k), "Invalid priority returned by transaction. Priority must be a valid string, finite number, server value, or null.")) : k = (a.K.Ba(b) || F).C().H();e = Zh(a);d = M(d, k);e = Uc(d, e);c.cd = d;c.dd = e;c.Da = a.vd++;c = Dh(a.K, b, e, c.Da, c.Ie);wc(a.da, b, c);ei(a);
        } else c.Rd(), c.cd = null, c.dd = null, c.G && (a = new W(c.bd, new U(a, c.path), N), c.G(null, !1, a));
    }function ei(a, b) {
        var c = b || a.nc;b || fi(a, c);if (null !== c.Ea()) {
            var d = gi(a, c);H(0 < d.length, "Sending zero length transaction queue");Na(d, function (a) {
                return 1 === a.status;
            }) && hi(a, c.path(), d);
        } else c.kd() && c.P(function (b) {
            ei(a, b);
        });
    }
    function hi(a, b, c) {
        for (var d = La(c, function (a) {
            return a.Da;
        }), e = a.K.Ba(b, d) || F, d = e, e = e.hash(), f = 0; f < c.length; f++) {
            var g = c[f];H(1 === g.status, "tryToSendTransactionQueue_: items in queue should all be run.");g.status = 2;g.wf++;var k = T(b, g.path),
                d = d.F(k, g.cd);
        }d = d.H(!0);a.va.put(b.toString(), d, function (d) {
            a.f("transaction put response", { path: b.toString(), status: d });var e = [];if ("ok" === d) {
                d = [];for (f = 0; f < c.length; f++) {
                    c[f].status = 3;e = e.concat(Gh(a.K, c[f].Da));if (c[f].G) {
                        var g = c[f].dd,
                            k = new U(a, c[f].path);d.push(r(c[f].G, null, null, !0, new W(g, k, N)));
                    }c[f].Rd();
                }fi(a, ih(a.nc, b));ei(a);wc(a.da, b, e);for (f = 0; f < d.length; f++) {
                    Ub(d[f]);
                }
            } else {
                if ("datastale" === d) for (f = 0; f < c.length; f++) {
                    c[f].status = 4 === c[f].status ? 5 : 1;
                } else for (O("transaction at " + b.toString() + " failed: " + d), f = 0; f < c.length; f++) {
                    c[f].status = 5, c[f].Td = d;
                }$h(a, b);
            }
        }, e);
    }function $h(a, b) {
        var c = ii(a, b),
            d = c.path(),
            c = gi(a, c);ji(a, c, d);return d;
    }
    function ji(a, b, c) {
        if (0 !== b.length) {
            for (var d = [], e = [], f = Ka(b, function (a) {
                return 1 === a.status;
            }), f = La(f, function (a) {
                return a.Da;
            }), g = 0; g < b.length; g++) {
                var k = b[g],
                    m = T(c, k.path),
                    l = !1,
                    u;H(null !== m, "rerunTransactionsUnderNode_: relativePath should not be null.");if (5 === k.status) l = !0, u = k.Td, e = e.concat(Gh(a.K, k.Da, !0));else if (1 === k.status) if (25 <= k.wf) l = !0, u = "maxretry", e = e.concat(Gh(a.K, k.Da, !0));else {
                    var z = a.K.Ba(k.path, f) || F;k.bd = z;var G = b[g].update(z.H());p(G) ? (Ef("transaction failed: Data returned ", G, k.path), m = M(G), "object" === (typeof G === "undefined" ? "undefined" : _typeof(G)) && null != G && Bb(G, ".priority") || (m = m.ga(z.C())), z = k.Da, G = Zh(a), G = Uc(m, G), k.cd = m, k.dd = G, k.Da = a.vd++, Qa(f, z), e = e.concat(Dh(a.K, k.path, G, k.Da, k.Ie)), e = e.concat(Gh(a.K, z, !0))) : (l = !0, u = "nodata", e = e.concat(Gh(a.K, k.Da, !0)));
                }wc(a.da, c, e);e = [];l && (b[g].status = 3, setTimeout(b[g].Rd, Math.floor(0)), b[g].G && ("nodata" === u ? (k = new U(a, b[g].path), d.push(r(b[g].G, null, null, !1, new W(b[g].bd, k, N)))) : d.push(r(b[g].G, null, Error(u), !1, null))));
            }fi(a, a.nc);for (g = 0; g < d.length; g++) {
                Ub(d[g]);
            }ei(a);
        }
    }
    function ii(a, b) {
        for (var c, d = a.nc; null !== (c = J(b)) && null === d.Ea();) {
            d = ih(d, c), b = D(b);
        }return d;
    }function gi(a, b) {
        var c = [];ki(a, b, c);c.sort(function (a, b) {
            return a.lf - b.lf;
        });return c;
    }function ki(a, b, c) {
        var d = b.Ea();if (null !== d) for (var e = 0; e < d.length; e++) {
            c.push(d[e]);
        }b.P(function (b) {
            ki(a, b, c);
        });
    }function fi(a, b) {
        var c = b.Ea();if (c) {
            for (var d = 0, e = 0; e < c.length; e++) {
                3 !== c[e].status && (c[d] = c[e], d++);
            }c.length = d;jh(b, 0 < c.length ? c : null);
        }b.P(function (b) {
            fi(a, b);
        });
    }
    function ci(a, b) {
        var c = ii(a, b).path(),
            d = ih(a.nc, b);mh(d, function (b) {
            li(a, b);
        });li(a, d);lh(d, function (b) {
            li(a, b);
        });return c;
    }
    function li(a, b) {
        var c = b.Ea();if (null !== c) {
            for (var d = [], e = [], f = -1, g = 0; g < c.length; g++) {
                4 !== c[g].status && (2 === c[g].status ? (H(f === g - 1, "All SENT items should be at beginning of queue."), f = g, c[g].status = 4, c[g].Td = "set") : (H(1 === c[g].status, "Unexpected transaction status in abort"), c[g].Rd(), e = e.concat(Gh(a.K, c[g].Da, !0)), c[g].G && d.push(r(c[g].G, null, Error("set"), !1, null))));
            }-1 === f ? jh(b, null) : c.length = f + 1;wc(a.da, b.path(), e);for (g = 0; g < d.length; g++) {
                Ub(d[g]);
            }
        }
    };function xf() {
        this.nb = {};this.Ff = !1;
    }xf.prototype.eb = function () {
        for (var a in this.nb) {
            this.nb[a].eb();
        }
    };xf.prototype.lc = function () {
        for (var a in this.nb) {
            this.nb[a].lc();
        }
    };xf.prototype.ce = function (a) {
        this.Ff = a;
    };ba(xf);xf.prototype.interrupt = xf.prototype.eb;xf.prototype.resume = xf.prototype.lc;var Z = {};Z.pc = nh;Z.DataConnection = Z.pc;nh.prototype.yg = function (a, b) {
        this.ua("q", { p: a }, b);
    };Z.pc.prototype.simpleListen = Z.pc.prototype.yg;nh.prototype.Qf = function (a, b) {
        this.ua("echo", { d: a }, b);
    };Z.pc.prototype.echo = Z.pc.prototype.Qf;nh.prototype.interrupt = nh.prototype.eb;Z.If = af;Z.RealTimeConnection = Z.If;af.prototype.sendRequest = af.prototype.ua;af.prototype.close = af.prototype.close;
    Z.bg = function (a) {
        var b = nh.prototype.put;nh.prototype.put = function (c, d, e, f) {
            p(f) && (f = a());b.call(this, c, d, e, f);
        };return function () {
            nh.prototype.put = b;
        };
    };Z.hijackHash = Z.bg;Z.Hf = gc;Z.ConnectionTarget = Z.Hf;Z.ya = function (a) {
        return a.ya();
    };Z.queryIdentifier = Z.ya;Z.eg = function (a) {
        return a.w.Ua.$;
    };Z.listens = Z.eg;Z.ce = function (a) {
        xf.Wb().ce(a);
    };Z.forceRestClient = Z.ce;Z.Context = xf;function U(a, b) {
        if (!(a instanceof sf)) throw Error("new Firebase() no longer supported - use app.database().");X.call(this, a, b, Ee, !1);this.then = void 0;this["catch"] = void 0;
    }ka(U, X);h = U.prototype;h.getKey = function () {
        y("Firebase.key", 0, 0, arguments.length);return this.path.e() ? null : $d(this.path);
    };
    h.m = function (a) {
        y("Firebase.child", 1, 1, arguments.length);if (fa(a)) a = String(a);else if (!(a instanceof L)) if (null === J(this.path)) {
            var b = a;b && (b = b.replace(/^\/*\.info(\/|$)/, "/"));Kf("Firebase.child", b);
        } else Kf("Firebase.child", a);return new U(this.w, this.path.m(a));
    };h.getParent = function () {
        y("Firebase.parent", 0, 0, arguments.length);var a = this.path.parent();return null === a ? null : new U(this.w, a);
    };
    h.Zf = function () {
        y("Firebase.ref", 0, 0, arguments.length);for (var a = this; null !== a.getParent();) {
            a = a.getParent();
        }return a;
    };h.Pf = function () {
        return this.w.$a;
    };h.set = function (a, b) {
        y("Firebase.set", 1, 2, arguments.length);Lf("Firebase.set", this.path);Df("Firebase.set", a, this.path, !1);A("Firebase.set", 2, b, !0);var c = new Hb();this.w.Kb(this.path, a, null, Ib(c, b));return c.ra;
    };
    h.update = function (a, b) {
        y("Firebase.update", 1, 2, arguments.length);Lf("Firebase.update", this.path);if (da(a)) {
            for (var c = {}, d = 0; d < a.length; ++d) {
                c["" + d] = a[d];
            }a = c;O("Passing an Array to Firebase.update() is deprecated. Use set() if you want to overwrite the existing data, or an Object with integer keys if you really do want to only update some of the children.");
        }Gf("Firebase.update", a, this.path);A("Firebase.update", 2, b, !0);c = new Hb();this.w.update(this.path, a, Ib(c, b));return c.ra;
    };
    h.Kb = function (a, b, c) {
        y("Firebase.setWithPriority", 2, 3, arguments.length);Lf("Firebase.setWithPriority", this.path);Df("Firebase.setWithPriority", a, this.path, !1);Hf("Firebase.setWithPriority", 2, b);A("Firebase.setWithPriority", 3, c, !0);if (".length" === this.getKey() || ".keys" === this.getKey()) throw "Firebase.setWithPriority failed: " + this.getKey() + " is a read-only object.";var d = new Hb();this.w.Kb(this.path, a, b, Ib(d, c));return d.ra;
    };
    h.remove = function (a) {
        y("Firebase.remove", 0, 1, arguments.length);Lf("Firebase.remove", this.path);A("Firebase.remove", 1, a, !0);return this.set(null, a);
    };
    h.transaction = function (a, b, c) {
        y("Firebase.transaction", 1, 3, arguments.length);Lf("Firebase.transaction", this.path);A("Firebase.transaction", 1, a, !1);A("Firebase.transaction", 2, b, !0);if (p(c) && "boolean" != typeof c) throw Error(Db("Firebase.transaction", 3, !0) + "must be a boolean.");if (".length" === this.getKey() || ".keys" === this.getKey()) throw "Firebase.transaction failed: " + this.getKey() + " is a read-only object.";"undefined" === typeof c && (c = !0);var d = new Hb();ga(b) && Jb(d.ra);di(this.w, this.path, a, function (a, c, g) {
            a ? d.reject(a) : d.resolve(new Pb(c, g));ga(b) && b(a, c, g);
        }, c);return d.ra;
    };h.vg = function (a, b) {
        y("Firebase.setPriority", 1, 2, arguments.length);Lf("Firebase.setPriority", this.path);Hf("Firebase.setPriority", 1, a);A("Firebase.setPriority", 2, b, !0);var c = new Hb();this.w.Kb(this.path.m(".priority"), a, null, Ib(c, b));return c.ra;
    };
    h.push = function (a, b) {
        y("Firebase.push", 0, 2, arguments.length);Lf("Firebase.push", this.path);Df("Firebase.push", a, this.path, !0);A("Firebase.push", 2, b, !0);var c = Yh(this.w),
            d = Tf(c),
            c = this.m(d);if (null != a) {
            var e = this,
                f = c.set(a, b).then(function () {
                return e.m(d);
            });c.then = r(f.then, f);c["catch"] = r(f.then, f, void 0);ga(b) && Jb(f);
        }return c;
    };h.kb = function () {
        Lf("Firebase.onDisconnect", this.path);return new V(this.w, this.path);
    };U.prototype.child = U.prototype.m;U.prototype.set = U.prototype.set;U.prototype.update = U.prototype.update;
    U.prototype.setWithPriority = U.prototype.Kb;U.prototype.remove = U.prototype.remove;U.prototype.transaction = U.prototype.transaction;U.prototype.setPriority = U.prototype.vg;U.prototype.push = U.prototype.push;U.prototype.onDisconnect = U.prototype.kb;pd(U.prototype, "database", U.prototype.Pf);pd(U.prototype, "key", U.prototype.getKey);pd(U.prototype, "parent", U.prototype.getParent);pd(U.prototype, "root", U.prototype.Zf);if ("undefined" === typeof firebase) throw Error("Cannot install Firebase Database - be sure to load firebase-app.js first.");
    try {
        firebase.INTERNAL.registerService("database", function (a) {
            var b = xf.Wb(),
                c = a.options.databaseURL;p(c) || ed("Can't determine Firebase Database URL.  Be sure to include databaseURL option when calling firebase.intializeApp().");var d = fd(c),
                c = d.kc;wf("Invalid Firebase Database URL", d);d.path.e() || ed("Database URL must point to the root of a Firebase Database (not including a child path).");(d = x(b.nb, a.name)) && ed("FIREBASE INTERNAL ERROR: Database initialized multiple times.");d = new sf(c, b.Ff, a);b.nb[a.name] = d;return d.$a;
        }, { Reference: U, Query: X, Database: rf, enableLogging: bd, INTERNAL: Y, TEST_ACCESS: Z, ServerValue: uf });
    } catch (mi) {
        ed("Failed to register the Firebase Database Service (" + mi + ")");
    };
})();

(function () {
    var k,
        aa = aa || {},
        m = this,
        n = function n(a) {
        return void 0 !== a;
    },
        ba = function ba() {},
        p = function p(a) {
        var b = typeof a === "undefined" ? "undefined" : _typeof(a);if ("object" == b) {
            if (a) {
                if (a instanceof Array) return "array";if (a instanceof Object) return b;var c = Object.prototype.toString.call(a);if ("[object Window]" == c) return "object";if ("[object Array]" == c || "number" == typeof a.length && "undefined" != typeof a.splice && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("splice")) return "array";if ("[object Function]" == c || "undefined" != typeof a.call && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("call")) return "function";
            } else return "null";
        } else if ("function" == b && "undefined" == typeof a.call) return "object";return b;
    },
        ca = function ca(a) {
        var b = p(a);return "array" == b || "object" == b && "number" == typeof a.length;
    },
        q = function q(a) {
        return "string" == typeof a;
    },
        r = function r(a) {
        return "function" == p(a);
    },
        da = function da(a) {
        var b = typeof a === "undefined" ? "undefined" : _typeof(a);return "object" == b && null != a || "function" == b;
    },
        ea = "closure_uid_" + (1E9 * Math.random() >>> 0),
        fa = 0,
        ga = function ga(a, b, c) {
        return a.call.apply(a.bind, arguments);
    },
        ha = function ha(a, b, c) {
        if (!a) throw Error();if (2 < arguments.length) {
            var d = Array.prototype.slice.call(arguments, 2);return function () {
                var c = Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c, d);return a.apply(b, c);
            };
        }return function () {
            return a.apply(b, arguments);
        };
    },
        _t = function t(a, b, c) {
        _t = Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? ga : ha;return _t.apply(null, arguments);
    },
        ia = Date.now || function () {
        return +new Date();
    },
        u = function u(a, b) {
        function c() {}
        c.prototype = b.prototype;a.I = b.prototype;a.prototype = new c();a.La = function (a, c, f) {
            for (var g = Array(arguments.length - 2), h = 2; h < arguments.length; h++) {
                g[h - 2] = arguments[h];
            }return b.prototype[c].apply(a, g);
        };
    };var ja = function ja(a, b, c) {
        function d() {
            ya || (ya = !0, b.apply(null, arguments));
        }function e(b) {
            l = setTimeout(function () {
                l = null;a(f, 2 === N);
            }, b);
        }function f(a, b) {
            if (!ya) if (a) d.apply(null, arguments);else if (2 === N || F) d.apply(null, arguments);else {
                64 > h && (h *= 2);var c;1 === N ? (N = 2, c = 0) : c = 1E3 * (h + Math.random());e(c);
            }
        }function g(a) {
            cc || (cc = !0, ya || (null !== l ? (a || (N = 2), clearTimeout(l), e(0)) : a || (N = 1)));
        }var h = 1,
            l = null,
            F = !1,
            N = 0,
            ya = !1,
            cc = !1;e(0);setTimeout(function () {
            F = !0;g(!0);
        }, c);return g;
    };var ka = "https://firebasestorage.googleapis.com";var v = function v(a, b) {
        this.code = "storage/" + a;this.message = "Firebase Storage: " + b;this.serverResponse = null;this.name = "FirebaseError";
    };u(v, Error);
    var la = function la() {
        return new v("unknown", "An unknown error occurred, please check the error payload for server response.");
    },
        ma = function ma() {
        return new v("canceled", "User canceled the upload/download.");
    },
        na = function na() {
        return new v("cannot-slice-blob", "Cannot slice blob for upload. Please retry the upload.");
    },
        oa = function oa(a, b, c) {
        return new v("invalid-argument", "Invalid argument in `" + b + "` at index " + a + ": " + c);
    },
        pa = function pa() {
        return new v("app-deleted", "The Firebase app was deleted.");
    },
        qa = function qa(a, b) {
        return new v("invalid-format", "String does not match format '" + a + "': " + b);
    };var ra = function ra(a, b) {
        for (var c in a) {
            Object.prototype.hasOwnProperty.call(a, c) && b(c, a[c]);
        }
    },
        sa = function sa(a) {
        var b = {};ra(a, function (a, d) {
            b[a] = d;
        });return b;
    };var w = function w(a, b, c, d) {
        this.l = a;this.f = {};this.i = b;this.b = {};this.c = "";this.M = c;this.g = this.a = null;this.h = [200];this.j = d;
    };var ta = { STATE_CHANGED: "state_changed" },
        ua = { RUNNING: "running", PAUSED: "paused", SUCCESS: "success", CANCELED: "canceled", ERROR: "error" },
        va = function va(a) {
        switch (a) {case "running":case "pausing":case "canceling":
                return "running";case "paused":
                return "paused";case "success":
                return "success";case "canceled":
                return "canceled";case "error":
                return "error";default:
                return "error";}
    };var x = function x(a) {
        return n(a) && null !== a;
    },
        wa = function wa(a) {
        return "string" === typeof a || a instanceof String;
    },
        xa = function xa() {
        return "undefined" !== typeof Blob;
    };var za = function za(a, b, c) {
        this.f = c;this.c = a;this.g = b;this.b = 0;this.a = null;
    };za.prototype.get = function () {
        var a;0 < this.b ? (this.b--, a = this.a, this.a = a.next, a.next = null) : a = this.c();return a;
    };var Aa = function Aa(a, b) {
        a.g(b);a.b < a.f && (a.b++, b.next = a.a, a.a = b);
    };var Ba = function Ba(a) {
        if (Error.captureStackTrace) Error.captureStackTrace(this, Ba);else {
            var b = Error().stack;b && (this.stack = b);
        }a && (this.message = String(a));
    };u(Ba, Error);Ba.prototype.name = "CustomError";var Ca = function Ca(a, b, c, d, e) {
        this.reset(a, b, c, d, e);
    };Ca.prototype.a = null;var Da = 0;Ca.prototype.reset = function (a, b, c, d, e) {
        "number" == typeof e || Da++;d || ia();this.b = b;delete this.a;
    };var Ea = function Ea(a) {
        var b = [],
            c = 0,
            d;for (d in a) {
            b[c++] = a[d];
        }return b;
    },
        Fa = function Fa(a) {
        var b = [],
            c = 0,
            d;for (d in a) {
            b[c++] = d;
        }return b;
    },
        Ga = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" "),
        Ha = function Ha(a, b) {
        for (var c, d, e = 1; e < arguments.length; e++) {
            d = arguments[e];for (c in d) {
                a[c] = d[c];
            }for (var f = 0; f < Ga.length; f++) {
                c = Ga[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
            }
        }
    };var Ia = function Ia(a) {
        a.prototype.then = a.prototype.then;a.prototype.$goog_Thenable = !0;
    },
        Ja = function Ja(a) {
        if (!a) return !1;try {
            return !!a.$goog_Thenable;
        } catch (b) {
            return !1;
        }
    };var Ka = function Ka(a) {
        Ka[" "](a);return a;
    };Ka[" "] = ba;var Ma = function Ma(a, b) {
        var c = La;return Object.prototype.hasOwnProperty.call(c, a) ? c[a] : c[a] = b(a);
    };var Na = function Na(a, b) {
        for (var c = a.split("%s"), d = "", e = Array.prototype.slice.call(arguments, 1); e.length && 1 < c.length;) {
            d += c.shift() + e.shift();
        }return d + c.join("%s");
    },
        Oa = String.prototype.trim ? function (a) {
        return a.trim();
    } : function (a) {
        return a.replace(/^[\s\xa0]+|[\s\xa0]+$/g, "");
    },
        Pa = function Pa(a, b) {
        return a < b ? -1 : a > b ? 1 : 0;
    };var Qa = function Qa(a, b) {
        this.a = a;this.b = b;
    };var y = function y(a, b) {
        this.bucket = a;this.path = b;
    },
        Ra = function Ra(a) {
        var b = encodeURIComponent;return "/b/" + b(a.bucket) + "/o/" + b(a.path);
    },
        Sa = function Sa(a) {
        for (var b = null, c = [{ ia: /^gs:\/\/([A-Za-z0-9.\-]+)(\/(.*))?$/i, ba: { bucket: 1, path: 3 }, ha: function ha(a) {
                "/" === a.path.charAt(a.path.length - 1) && (a.path = a.path.slice(0, -1));
            } }, { ia: /^https?:\/\/firebasestorage\.googleapis\.com\/v[A-Za-z0-9_]+\/b\/([A-Za-z0-9.\-]+)\/o(\/([^?#]*).*)?$/i, ba: { bucket: 1, path: 3 }, ha: function ha(a) {
                a.path = decodeURIComponent(a.path);
            } }], d = 0; d < c.length; d++) {
            var e = c[d],
                f = e.ia.exec(a);if (f) {
                b = f[e.ba.bucket];(f = f[e.ba.path]) || (f = "");b = new y(b, f);e.ha(b);break;
            }
        }if (null == b) throw new v("invalid-url", "Invalid URL '" + a + "'.");return b;
    };var Ta = function Ta(a, b, c) {
        r(a) || x(b) || x(c) ? (this.next = a, this.a = b || null, this.b = c || null) : (this.next = a.next || null, this.a = a.error || null, this.b = a.complete || null);
    };var Ua = { RAW: "raw", BASE64: "base64", BASE64URL: "base64url", DATA_URL: "data_url" },
        Va = function Va(a) {
        switch (a) {case "raw":case "base64":case "base64url":case "data_url":
                break;default:
                throw "Expected one of the event types: [raw, base64, base64url, data_url].";}
    },
        Wa = function Wa(a, b) {
        this.data = a;this.a = b || null;
    },
        $a = function $a(a, b) {
        switch (a) {case "raw":
                return new Wa(Xa(b));case "base64":case "base64url":
                return new Wa(Ya(a, b));case "data_url":
                return a = new Za(b), a = a.a ? Ya("base64", a.c) : Xa(a.c), new Wa(a, new Za(b).b);}throw la();
    },
        Xa = function Xa(a) {
        for (var b = [], c = 0; c < a.length; c++) {
            var d = a.charCodeAt(c);if (127 >= d) b.push(d);else if (2047 >= d) b.push(192 | d >> 6, 128 | d & 63);else if (55296 == (d & 64512)) {
                if (c < a.length - 1 && 56320 == (a.charCodeAt(c + 1) & 64512)) {
                    var e = a.charCodeAt(++c),
                        d = 65536 | (d & 1023) << 10 | e & 1023;b.push(240 | d >> 18, 128 | d >> 12 & 63, 128 | d >> 6 & 63, 128 | d & 63);
                } else b.push(239, 191, 189);
            } else 56320 == (d & 64512) ? b.push(239, 191, 189) : b.push(224 | d >> 12, 128 | d >> 6 & 63, 128 | d & 63);
        }return new Uint8Array(b);
    },
        Ya = function Ya(a, b) {
        switch (a) {
            case "base64":
                var c = -1 !== b.indexOf("-"),
                    d = -1 !== b.indexOf("_");if (c || d) throw qa(a, "Invalid character '" + (c ? "-" : "_") + "' found: is it base64url encoded?");break;case "base64url":
                c = -1 !== b.indexOf("+");d = -1 !== b.indexOf("/");if (c || d) throw qa(a, "Invalid character '" + (c ? "+" : "/") + "' found: is it base64 encoded?");b = b.replace(/-/g, "+").replace(/_/g, "/");
        }var e;try {
            e = atob(b);
        } catch (f) {
            throw qa(a, "Invalid character found");
        }a = new Uint8Array(e.length);for (b = 0; b < e.length; b++) {
            a[b] = e.charCodeAt(b);
        }return a;
    },
        Za = function Za(a) {
        var b = a.match(/^data:([^,]+)?,/);
        if (null === b) throw qa("data_url", "Must be formatted 'data:[<mediatype>][;base64],<data>");b = b[1] || null;this.a = !1;this.b = null;if (null != b) {
            var c = b.length - 7;this.b = (this.a = 0 <= c && b.indexOf(";base64", c) == c) ? b.substring(0, b.length - 7) : b;
        }this.c = a.substring(a.indexOf(",") + 1);
    };var bb = function bb(a) {
        var b = encodeURIComponent,
            c = "?";ra(a, function (a, e) {
            a = b(a) + "=" + b(e);c = c + a + "&";
        });return c = c.slice(0, -1);
    };var z = function z(a, b, c, d, e, f) {
        this.b = a;this.h = b;this.f = c;this.a = d;this.g = e;this.c = f;
    };k = z.prototype;k.oa = function () {
        return this.b;
    };k.Ka = function () {
        return this.h;
    };k.Ha = function () {
        return this.f;
    };k.Ca = function () {
        return this.a;
    };k.qa = function () {
        if (x(this.a)) {
            var a = this.a.downloadURLs;return x(a) && x(a[0]) ? a[0] : null;
        }return null;
    };k.Ja = function () {
        return this.g;
    };k.Fa = function () {
        return this.c;
    };var cb = function cb(a, b) {
        b.unshift(a);Ba.call(this, Na.apply(null, b));b.shift();
    };u(cb, Ba);cb.prototype.name = "AssertionError";
    var db = function db(a, b, c, d) {
        var e = "Assertion failed";if (c) var e = e + (": " + c),
            f = d;else a && (e += ": " + a, f = b);throw new cb("" + e, f || []);
    },
        A = function A(a, b, c) {
        a || db("", null, b, Array.prototype.slice.call(arguments, 2));
    },
        eb = function eb(a, b) {
        throw new cb("Failure" + (a ? ": " + a : ""), Array.prototype.slice.call(arguments, 1));
    },
        fb = function fb(a, b, c) {
        r(a) || db("Expected function but got %s: %s.", [p(a), a], b, Array.prototype.slice.call(arguments, 2));
    };var B = function B() {
        this.g = this.g;this.o = this.o;
    };B.prototype.g = !1;B.prototype.ea = function () {
        this.g || (this.g = !0, this.C());
    };B.prototype.C = function () {
        if (this.o) for (; this.o.length;) {
            this.o.shift()();
        }
    };var gb = "closure_listenable_" + (1E6 * Math.random() | 0),
        hb = 0;var ib;a: {
        var jb = m.navigator;if (jb) {
            var kb = jb.userAgent;if (kb) {
                ib = kb;break a;
            }
        }ib = "";
    }var C = function C(a) {
        return -1 != ib.indexOf(a);
    };var lb = function lb() {};lb.prototype.a = null;var nb = function nb(a) {
        var b;(b = a.a) || (b = {}, mb(a) && (b[0] = !0, b[1] = !0), b = a.a = b);return b;
    };var ob = Array.prototype.indexOf ? function (a, b, c) {
        A(null != a.length);return Array.prototype.indexOf.call(a, b, c);
    } : function (a, b, c) {
        c = null == c ? 0 : 0 > c ? Math.max(0, a.length + c) : c;if (q(a)) return q(b) && 1 == b.length ? a.indexOf(b, c) : -1;for (; c < a.length; c++) {
            if (c in a && a[c] === b) return c;
        }return -1;
    },
        pb = Array.prototype.forEach ? function (a, b, c) {
        A(null != a.length);Array.prototype.forEach.call(a, b, c);
    } : function (a, b, c) {
        for (var d = a.length, e = q(a) ? a.split("") : a, f = 0; f < d; f++) {
            f in e && b.call(c, e[f], f, a);
        }
    },
        qb = Array.prototype.filter ? function (a, b, c) {
        A(null != a.length);return Array.prototype.filter.call(a, b, c);
    } : function (a, b, c) {
        for (var d = a.length, e = [], f = 0, g = q(a) ? a.split("") : a, h = 0; h < d; h++) {
            if (h in g) {
                var l = g[h];b.call(c, l, h, a) && (e[f++] = l);
            }
        }return e;
    },
        rb = Array.prototype.map ? function (a, b, c) {
        A(null != a.length);return Array.prototype.map.call(a, b, c);
    } : function (a, b, c) {
        for (var d = a.length, e = Array(d), f = q(a) ? a.split("") : a, g = 0; g < d; g++) {
            g in f && (e[g] = b.call(c, f[g], g, a));
        }return e;
    },
        sb = Array.prototype.some ? function (a, b, c) {
        A(null != a.length);return Array.prototype.some.call(a, b, c);
    } : function (a, b, c) {
        for (var d = a.length, e = q(a) ? a.split("") : a, f = 0; f < d; f++) {
            if (f in e && b.call(c, e[f], f, a)) return !0;
        }return !1;
    },
        ub = function ub(a) {
        var b;a: {
            b = tb;for (var c = a.length, d = q(a) ? a.split("") : a, e = 0; e < c; e++) {
                if (e in d && b.call(void 0, d[e], e, a)) {
                    b = e;break a;
                }
            }b = -1;
        }return 0 > b ? null : q(a) ? a.charAt(b) : a[b];
    },
        vb = function vb(a) {
        if ("array" != p(a)) for (var b = a.length - 1; 0 <= b; b--) {
            delete a[b];
        }a.length = 0;
    },
        wb = function wb(a, b) {
        b = ob(a, b);var c;if (c = 0 <= b) A(null != a.length), Array.prototype.splice.call(a, b, 1);return c;
    },
        xb = function xb(a) {
        var b = a.length;if (0 < b) {
            for (var c = Array(b), d = 0; d < b; d++) {
                c[d] = a[d];
            }return c;
        }return [];
    };var zb = new za(function () {
        return new yb();
    }, function (a) {
        a.reset();
    }, 100),
        Bb = function Bb() {
        var a = Ab,
            b = null;a.a && (b = a.a, a.a = a.a.next, a.a || (a.b = null), b.next = null);return b;
    },
        yb = function yb() {
        this.next = this.b = this.a = null;
    };yb.prototype.set = function (a, b) {
        this.a = a;this.b = b;this.next = null;
    };yb.prototype.reset = function () {
        this.next = this.b = this.a = null;
    };var Cb = function Cb(a, b) {
        this.type = a;this.a = this.target = b;this.ja = !0;
    };Cb.prototype.b = function () {
        this.ja = !1;
    };var Db = function Db(a, b, c, d, e) {
        this.listener = a;this.a = null;this.src = b;this.type = c;this.V = !!d;this.M = e;++hb;this.N = this.U = !1;
    },
        Eb = function Eb(a) {
        a.N = !0;a.listener = null;a.a = null;a.src = null;a.M = null;
    };var Fb = /^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;var Gb = function Gb(a, b) {
        b = qb(b.split("/"), function (a) {
            return 0 < a.length;
        }).join("/");return 0 === a.length ? b : a + "/" + b;
    },
        Hb = function Hb(a) {
        var b = a.lastIndexOf("/", a.length - 2);return -1 === b ? a : a.slice(b + 1);
    };var Ib = function Ib(a) {
        this.src = a;this.a = {};this.b = 0;
    },
        Kb = function Kb(a, b, c, d, e, f) {
        var g = b.toString();b = a.a[g];b || (b = a.a[g] = [], a.b++);var h = Jb(b, c, e, f);-1 < h ? (a = b[h], d || (a.U = !1)) : (a = new Db(c, a.src, g, !!e, f), a.U = d, b.push(a));return a;
    },
        Lb = function Lb(a, b) {
        var c = b.type;c in a.a && wb(a.a[c], b) && (Eb(b), 0 == a.a[c].length && (delete a.a[c], a.b--));
    },
        Jb = function Jb(a, b, c, d) {
        for (var e = 0; e < a.length; ++e) {
            var f = a[e];if (!f.N && f.listener == b && f.V == !!c && f.M == d) return e;
        }return -1;
    };var Mb,
        Nb = function Nb() {};u(Nb, lb);var Ob = function Ob(a) {
        return (a = mb(a)) ? new ActiveXObject(a) : new XMLHttpRequest();
    },
        mb = function mb(a) {
        if (!a.b && "undefined" == typeof XMLHttpRequest && "undefined" != typeof ActiveXObject) {
            for (var b = ["MSXML2.XMLHTTP.6.0", "MSXML2.XMLHTTP.3.0", "MSXML2.XMLHTTP", "Microsoft.XMLHTTP"], c = 0; c < b.length; c++) {
                var d = b[c];try {
                    return new ActiveXObject(d), a.b = d;
                } catch (e) {}
            }throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");
        }return a.b;
    };Mb = new Nb();var Pb = function Pb(a) {
        this.a = [];if (a) a: {
            var b;if (a instanceof Pb) {
                if (b = a.H(), a = a.A(), 0 >= this.b()) {
                    for (var c = this.a, d = 0; d < b.length; d++) {
                        c.push(new Qa(b[d], a[d]));
                    }break a;
                }
            } else b = Fa(a), a = Ea(a);for (d = 0; d < b.length; d++) {
                Qb(this, b[d], a[d]);
            }
        }
    },
        Qb = function Qb(a, b, c) {
        var d = a.a;d.push(new Qa(b, c));b = d.length - 1;a = a.a;for (c = a[b]; 0 < b;) {
            if (d = b - 1 >> 1, a[d].a > c.a) a[b] = a[d], b = d;else break;
        }a[b] = c;
    };Pb.prototype.A = function () {
        for (var a = this.a, b = [], c = a.length, d = 0; d < c; d++) {
            b.push(a[d].b);
        }return b;
    };
    Pb.prototype.H = function () {
        for (var a = this.a, b = [], c = a.length, d = 0; d < c; d++) {
            b.push(a[d].a);
        }return b;
    };Pb.prototype.b = function () {
        return this.a.length;
    };var Rb = function Rb() {
        this.c = [];this.a = [];
    },
        Sb = function Sb(a) {
        0 == a.c.length && (a.c = a.a, a.c.reverse(), a.a = []);return a.c.pop();
    };Rb.prototype.b = function () {
        return this.c.length + this.a.length;
    };Rb.prototype.A = function () {
        for (var a = [], b = this.c.length - 1; 0 <= b; --b) {
            a.push(this.c[b]);
        }for (var c = this.a.length, b = 0; b < c; ++b) {
            a.push(this.a[b]);
        }return a;
    };var Tb = function Tb(a) {
        if (a.A && "function" == typeof a.A) return a.A();if (q(a)) return a.split("");if (ca(a)) {
            for (var b = [], c = a.length, d = 0; d < c; d++) {
                b.push(a[d]);
            }return b;
        }return Ea(a);
    },
        Ub = function Ub(a, b) {
        if (a.forEach && "function" == typeof a.forEach) a.forEach(b, void 0);else if (ca(a) || q(a)) pb(a, b, void 0);else {
            var c;if (a.H && "function" == typeof a.H) c = a.H();else if (a.A && "function" == typeof a.A) c = void 0;else if (ca(a) || q(a)) {
                c = [];for (var d = a.length, e = 0; e < d; e++) {
                    c.push(e);
                }
            } else c = Fa(a);for (var d = Tb(a), e = d.length, f = 0; f < e; f++) {
                b.call(void 0, d[f], c && c[f], a);
            }
        }
    };var Vb = function Vb(a) {
        m.setTimeout(function () {
            throw a;
        }, 0);
    },
        Wb,
        Xb = function Xb() {
        var a = m.MessageChannel;"undefined" === typeof a && "undefined" !== typeof window && window.postMessage && window.addEventListener && !C("Presto") && (a = function a() {
            var a = document.createElement("IFRAME");a.style.display = "none";a.src = "";document.documentElement.appendChild(a);var b = a.contentWindow,
                a = b.document;a.open();a.write("");a.close();var c = "callImmediate" + Math.random(),
                d = "file:" == b.location.protocol ? "*" : b.location.protocol + "//" + b.location.host,
                a = _t(function (a) {
                if (("*" == d || a.origin == d) && a.data == c) this.port1.onmessage();
            }, this);b.addEventListener("message", a, !1);this.port1 = {};this.port2 = { postMessage: function postMessage() {
                    b.postMessage(c, d);
                } };
        });if ("undefined" !== typeof a && !C("Trident") && !C("MSIE")) {
            var b = new a(),
                c = {},
                d = c;b.port1.onmessage = function () {
                if (n(c.next)) {
                    c = c.next;var a = c.da;c.da = null;a();
                }
            };return function (a) {
                d.next = { da: a };d = d.next;b.port2.postMessage(0);
            };
        }return "undefined" !== typeof document && "onreadystatechange" in document.createElement("SCRIPT") ? function (a) {
            var b = document.createElement("SCRIPT");b.onreadystatechange = function () {
                b.onreadystatechange = null;b.parentNode.removeChild(b);b = null;a();a = null;
            };document.documentElement.appendChild(b);
        } : function (a) {
            m.setTimeout(a, 0);
        };
    };var Yb = "StopIteration" in m ? m.StopIteration : { message: "StopIteration", stack: "" },
        Zb = function Zb() {};Zb.prototype.next = function () {
        throw Yb;
    };Zb.prototype.h = function () {
        return this;
    };var $b = function $b() {
        Pb.call(this);
    };u($b, Pb);var ac = C("Opera"),
        D = C("Trident") || C("MSIE"),
        bc = C("Edge"),
        dc = C("Gecko") && !(-1 != ib.toLowerCase().indexOf("webkit") && !C("Edge")) && !(C("Trident") || C("MSIE")) && !C("Edge"),
        ec = -1 != ib.toLowerCase().indexOf("webkit") && !C("Edge"),
        fc = function fc() {
        var a = m.document;return a ? a.documentMode : void 0;
    },
        gc;
    a: {
        var hc = "",
            ic = function () {
            var a = ib;if (dc) return (/rv\:([^\);]+)(\)|;)/.exec(a)
            );if (bc) return (/Edge\/([\d\.]+)/.exec(a)
            );if (D) return (/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a)
            );if (ec) return (/WebKit\/(\S+)/.exec(a)
            );if (ac) return (/(?:Version)[ \/]?(\S+)/.exec(a)
            );
        }();ic && (hc = ic ? ic[1] : "");if (D) {
            var jc = fc();if (null != jc && jc > parseFloat(hc)) {
                gc = String(jc);break a;
            }
        }gc = hc;
    }
    var kc = gc,
        La = {},
        E = function E(a) {
        return Ma(a, function () {
            for (var b = 0, c = Oa(String(kc)).split("."), d = Oa(String(a)).split("."), e = Math.max(c.length, d.length), f = 0; 0 == b && f < e; f++) {
                var g = c[f] || "",
                    h = d[f] || "";do {
                    g = /(\d*)(\D*)(.*)/.exec(g) || ["", "", "", ""];h = /(\d*)(\D*)(.*)/.exec(h) || ["", "", "", ""];if (0 == g[0].length && 0 == h[0].length) break;b = Pa(0 == g[1].length ? 0 : parseInt(g[1], 10), 0 == h[1].length ? 0 : parseInt(h[1], 10)) || Pa(0 == g[2].length, 0 == h[2].length) || Pa(g[2], h[2]);g = g[3];h = h[3];
                } while (0 == b);
            }return 0 <= b;
        });
    },
        lc = m.document,
        mc = lc && D ? fc() || ("CSS1Compat" == lc.compatMode ? parseInt(kc, 10) : 5) : void 0;var qc = function qc(a, b) {
        nc || oc();pc || (nc(), pc = !0);var c = Ab,
            d = zb.get();d.set(a, b);c.b ? c.b.next = d : (A(!c.a), c.a = d);c.b = d;
    },
        nc,
        oc = function oc() {
        if (m.Promise && m.Promise.resolve) {
            var a = m.Promise.resolve(void 0);nc = function nc() {
                a.then(rc);
            };
        } else nc = function nc() {
            var a = rc;!r(m.setImmediate) || m.Window && m.Window.prototype && !C("Edge") && m.Window.prototype.setImmediate == m.setImmediate ? (Wb || (Wb = Xb()), Wb(a)) : m.setImmediate(a);
        };
    },
        pc = !1,
        Ab = new function () {
        this.b = this.a = null;
    }(),
        rc = function rc() {
        for (var a; a = Bb();) {
            try {
                a.a.call(a.b);
            } catch (b) {
                Vb(b);
            }Aa(zb, a);
        }pc = !1;
    };var sc;(sc = !D) || (sc = 9 <= Number(mc));var tc = sc,
        uc = D && !E("9");!ec || E("528");dc && E("1.9b") || D && E("8") || ac && E("9.5") || ec && E("528");dc && !E("8") || D && E("9");var G = function G(a, b) {
        this.c = {};this.a = [];this.g = this.f = 0;var c = arguments.length;if (1 < c) {
            if (c % 2) throw Error("Uneven number of arguments");for (var d = 0; d < c; d += 2) {
                this.set(arguments[d], arguments[d + 1]);
            }
        } else if (a) {
            a instanceof G ? (c = a.H(), d = a.A()) : (c = Fa(a), d = Ea(a));for (var e = 0; e < c.length; e++) {
                this.set(c[e], d[e]);
            }
        }
    };G.prototype.b = function () {
        return this.f;
    };G.prototype.A = function () {
        vc(this);for (var a = [], b = 0; b < this.a.length; b++) {
            a.push(this.c[this.a[b]]);
        }return a;
    };G.prototype.H = function () {
        vc(this);return this.a.concat();
    };
    var wc = function wc(a, b) {
        return Object.prototype.hasOwnProperty.call(a.c, b) ? (delete a.c[b], a.f--, a.g++, a.a.length > 2 * a.f && vc(a), !0) : !1;
    },
        vc = function vc(a) {
        if (a.f != a.a.length) {
            for (var b = 0, c = 0; b < a.a.length;) {
                var d = a.a[b];Object.prototype.hasOwnProperty.call(a.c, d) && (a.a[c++] = d);b++;
            }a.a.length = c;
        }if (a.f != a.a.length) {
            for (var e = {}, c = b = 0; b < a.a.length;) {
                d = a.a[b], Object.prototype.hasOwnProperty.call(e, d) || (a.a[c++] = d, e[d] = 1), b++;
            }a.a.length = c;
        }
    };
    G.prototype.get = function (a, b) {
        return Object.prototype.hasOwnProperty.call(this.c, a) ? this.c[a] : b;
    };G.prototype.set = function (a, b) {
        Object.prototype.hasOwnProperty.call(this.c, a) || (this.f++, this.a.push(a), this.g++);this.c[a] = b;
    };G.prototype.forEach = function (a, b) {
        for (var c = this.H(), d = 0; d < c.length; d++) {
            var e = c[d],
                f = this.get(e);a.call(b, f, e, this);
        }
    };
    G.prototype.h = function (a) {
        vc(this);var b = 0,
            c = this.g,
            d = this,
            e = new Zb();e.next = function () {
            if (c != d.g) throw Error("The map has changed since the iterator was created");if (b >= d.a.length) throw Yb;var e = d.a[b++];return a ? e : d.c[e];
        };return e;
    };var xc = function xc(a, b) {
        Cb.call(this, a ? a.type : "");this.c = this.a = this.target = null;if (a) {
            this.type = a.type;this.target = a.target || a.srcElement;this.a = b;if ((b = a.relatedTarget) && dc) try {
                Ka(b.nodeName);
            } catch (c) {}this.c = a;a.defaultPrevented && this.b();
        }
    };u(xc, Cb);xc.prototype.b = function () {
        xc.I.b.call(this);var a = this.c;if (a.preventDefault) a.preventDefault();else if (a.returnValue = !1, uc) try {
            if (a.ctrlKey || 112 <= a.keyCode && 123 >= a.keyCode) a.keyCode = -1;
        } catch (b) {}
    };var H = function H(a, b) {
        this.a = 0;this.i = void 0;this.c = this.b = this.f = null;this.g = this.h = !1;if (a != ba) try {
            var c = this;a.call(b, function (a) {
                yc(c, 2, a);
            }, function (a) {
                try {
                    if (a instanceof Error) throw a;throw Error("Promise rejected.");
                } catch (b) {}yc(c, 3, a);
            });
        } catch (d) {
            yc(this, 3, d);
        }
    },
        zc = function zc() {
        this.next = this.f = this.c = this.a = this.b = null;this.g = !1;
    };zc.prototype.reset = function () {
        this.f = this.c = this.a = this.b = null;this.g = !1;
    };
    var Ac = new za(function () {
        return new zc();
    }, function (a) {
        a.reset();
    }, 100),
        Bc = function Bc(a, b, c) {
        var d = Ac.get();d.a = a;d.c = b;d.f = c;return d;
    },
        Cc = function Cc(a) {
        if (a instanceof H) return a;var b = new H(ba);yc(b, 2, a);return b;
    },
        Dc = function Dc(a) {
        return new H(function (b, c) {
            c(a);
        });
    };
    H.prototype.then = function (a, b, c) {
        null != a && fb(a, "opt_onFulfilled should be a function.");null != b && fb(b, "opt_onRejected should be a function. Did you pass opt_context as the second argument instead of the third?");return Ec(this, r(a) ? a : null, r(b) ? b : null, c);
    };Ia(H);H.prototype.l = function (a, b) {
        return Ec(this, null, a, b);
    };
    var Gc = function Gc(a, b) {
        a.b || 2 != a.a && 3 != a.a || Fc(a);A(null != b.a);a.c ? a.c.next = b : a.b = b;a.c = b;
    },
        Ec = function Ec(a, b, c, d) {
        var e = Bc(null, null, null);e.b = new H(function (a, g) {
            e.a = b ? function (c) {
                try {
                    var e = b.call(d, c);a(e);
                } catch (F) {
                    g(F);
                }
            } : a;e.c = c ? function (b) {
                try {
                    var e = c.call(d, b);a(e);
                } catch (F) {
                    g(F);
                }
            } : g;
        });e.b.f = a;Gc(a, e);return e.b;
    };H.prototype.o = function (a) {
        A(1 == this.a);this.a = 0;yc(this, 2, a);
    };H.prototype.m = function (a) {
        A(1 == this.a);this.a = 0;yc(this, 3, a);
    };
    var yc = function yc(a, b, c) {
        if (0 == a.a) {
            a === c && (b = 3, c = new TypeError("Promise cannot resolve to itself"));a.a = 1;var d;a: {
                var e = c,
                    f = a.o,
                    g = a.m;if (e instanceof H) null != f && fb(f, "opt_onFulfilled should be a function."), null != g && fb(g, "opt_onRejected should be a function. Did you pass opt_context as the second argument instead of the third?"), Gc(e, Bc(f || ba, g || null, a)), d = !0;else if (Ja(e)) e.then(f, g, a), d = !0;else {
                    if (da(e)) try {
                        var h = e.then;if (r(h)) {
                            Hc(e, h, f, g, a);d = !0;break a;
                        }
                    } catch (l) {
                        g.call(a, l);d = !0;break a;
                    }d = !1;
                }
            }d || (a.i = c, a.a = b, a.f = null, Fc(a), 3 != b || Ic(a, c));
        }
    },
        Hc = function Hc(a, b, c, d, e) {
        var f = !1,
            g = function g(a) {
            f || (f = !0, c.call(e, a));
        },
            h = function h(a) {
            f || (f = !0, d.call(e, a));
        };try {
            b.call(a, g, h);
        } catch (l) {
            h(l);
        }
    },
        Fc = function Fc(a) {
        a.h || (a.h = !0, qc(a.j, a));
    },
        Jc = function Jc(a) {
        var b = null;a.b && (b = a.b, a.b = b.next, b.next = null);a.b || (a.c = null);null != b && A(null != b.a);return b;
    };
    H.prototype.j = function () {
        for (var a; a = Jc(this);) {
            var b = this.a,
                c = this.i;if (3 == b && a.c && !a.g) {
                var d;for (d = this; d && d.g; d = d.f) {
                    d.g = !1;
                }
            }if (a.b) a.b.f = null, Kc(a, b, c);else try {
                a.g ? a.a.call(a.f) : Kc(a, b, c);
            } catch (e) {
                Lc.call(null, e);
            }Aa(Ac, a);
        }this.h = !1;
    };var Kc = function Kc(a, b, c) {
        2 == b ? a.a.call(a.f, c) : a.c && a.c.call(a.f, c);
    },
        Ic = function Ic(a, b) {
        a.g = !0;qc(function () {
            a.g && Lc.call(null, b);
        });
    },
        Lc = Vb;var Nc = function Nc(a) {
        this.a = new G();if (a) {
            a = Tb(a);for (var b = a.length, c = 0; c < b; c++) {
                var d = a[c];this.a.set(Mc(d), d);
            }
        }
    },
        Mc = function Mc(a) {
        var b = typeof a === "undefined" ? "undefined" : _typeof(a);return "object" == b && a || "function" == b ? "o" + (a[ea] || (a[ea] = ++fa)) : b.substr(0, 1) + a;
    };Nc.prototype.b = function () {
        return this.a.b();
    };Nc.prototype.A = function () {
        return this.a.A();
    };Nc.prototype.h = function () {
        return this.a.h(!1);
    };var Oc = function Oc(a) {
        return function () {
            var b = [];Array.prototype.push.apply(b, arguments);Cc(!0).then(function () {
                a.apply(null, b);
            });
        };
    };var Pc = "closure_lm_" + (1E6 * Math.random() | 0),
        Qc = {},
        Rc = 0,
        Sc = function Sc(a, b, c, d, e) {
        if ("array" == p(b)) {
            for (var f = 0; f < b.length; f++) {
                Sc(a, b[f], c, d, e);
            }return null;
        }c = Tc(c);a && a[gb] ? (Uc(a), a = Kb(a.b, String(b), c, !1, d, e)) : a = Vc(a, b, c, !1, d, e);return a;
    },
        Vc = function Vc(a, b, c, d, e, f) {
        if (!b) throw Error("Invalid event type");var g = !!e,
            h = Wc(a);h || (a[Pc] = h = new Ib(a));c = Kb(h, b, c, d, e, f);if (c.a) return c;d = Xc();c.a = d;d.src = a;d.listener = c;if (a.addEventListener) a.addEventListener(b.toString(), d, g);else if (a.attachEvent) a.attachEvent(Yc(b.toString()), d);else throw Error("addEventListener and attachEvent are unavailable.");Rc++;return c;
    },
        Xc = function Xc() {
        var a = Zc,
            b = tc ? function (c) {
            return a.call(b.src, b.listener, c);
        } : function (c) {
            c = a.call(b.src, b.listener, c);if (!c) return c;
        };return b;
    },
        $c = function $c(a, b, c, d, e) {
        if ("array" == p(b)) for (var f = 0; f < b.length; f++) {
            $c(a, b[f], c, d, e);
        } else c = Tc(c), a && a[gb] ? Kb(a.b, String(b), c, !0, d, e) : Vc(a, b, c, !0, d, e);
    },
        ad = function ad(a, b, c, d, e) {
        if ("array" == p(b)) for (var f = 0; f < b.length; f++) {
            ad(a, b[f], c, d, e);
        } else (c = Tc(c), a && a[gb]) ? (a = a.b, b = String(b).toString(), b in a.a && (f = a.a[b], c = Jb(f, c, d, e), -1 < c && (Eb(f[c]), A(null != f.length), Array.prototype.splice.call(f, c, 1), 0 == f.length && (delete a.a[b], a.b--)))) : a && (a = Wc(a)) && (b = a.a[b.toString()], a = -1, b && (a = Jb(b, c, !!d, e)), (c = -1 < a ? b[a] : null) && bd(c));
    },
        bd = function bd(a) {
        if ("number" != typeof a && a && !a.N) {
            var b = a.src;if (b && b[gb]) Lb(b.b, a);else {
                var c = a.type,
                    d = a.a;b.removeEventListener ? b.removeEventListener(c, d, a.V) : b.detachEvent && b.detachEvent(Yc(c), d);Rc--;(c = Wc(b)) ? (Lb(c, a), 0 == c.b && (c.src = null, b[Pc] = null)) : Eb(a);
            }
        }
    },
        Yc = function Yc(a) {
        return a in Qc ? Qc[a] : Qc[a] = "on" + a;
    },
        dd = function dd(a, b, c, d) {
        var e = !0;if (a = Wc(a)) if (b = a.a[b.toString()]) for (b = b.concat(), a = 0; a < b.length; a++) {
            var f = b[a];f && f.V == c && !f.N && (f = cd(f, d), e = e && !1 !== f);
        }return e;
    },
        cd = function cd(a, b) {
        var c = a.listener,
            d = a.M || a.src;a.U && bd(a);return c.call(d, b);
    },
        Zc = function Zc(a, b) {
        if (a.N) return !0;if (!tc) {
            if (!b) a: {
                b = ["window", "event"];for (var c = m, d; d = b.shift();) {
                    if (null != c[d]) c = c[d];else {
                        b = null;break a;
                    }
                }b = c;
            }d = b;b = new xc(d, this);c = !0;if (!(0 > d.keyCode || void 0 != d.returnValue)) {
                a: {
                    var e = !1;if (0 == d.keyCode) try {
                        d.keyCode = -1;break a;
                    } catch (g) {
                        e = !0;
                    }if (e || void 0 == d.returnValue) d.returnValue = !0;
                }d = [];for (e = b.a; e; e = e.parentNode) {
                    d.push(e);
                }a = a.type;for (e = d.length - 1; 0 <= e; e--) {
                    b.a = d[e];var f = dd(d[e], a, !0, b),
                        c = c && f;
                }for (e = 0; e < d.length; e++) {
                    b.a = d[e], f = dd(d[e], a, !1, b), c = c && f;
                }
            }return c;
        }return cd(a, new xc(b, this));
    },
        Wc = function Wc(a) {
        a = a[Pc];return a instanceof Ib ? a : null;
    },
        ed = "__closure_events_fn_" + (1E9 * Math.random() >>> 0),
        Tc = function Tc(a) {
        A(a, "Listener can not be null.");if (r(a)) return a;A(a.handleEvent, "An object listener must have handleEvent method.");
        a[ed] || (a[ed] = function (b) {
            return a.handleEvent(b);
        });return a[ed];
    };var I = function I(a, b) {
        B.call(this);this.m = a || 0;this.f = b || 10;if (this.m > this.f) throw Error("[goog.structs.Pool] Min can not be greater than max");this.a = new Rb();this.c = new Nc();this.j = null;this.T();
    };u(I, B);I.prototype.X = function () {
        var a = ia();if (!(null != this.j && 0 > a - this.j)) {
            for (var b; 0 < this.a.b() && (b = Sb(this.a), !this.l(b));) {
                this.T();
            }!b && this.b() < this.f && (b = this.i());b && (this.j = a, this.c.a.set(Mc(b), b));return b;
        }
    };var gd = function gd(a) {
        var b = fd;wc(b.c.a, Mc(a)) && b.$(a);
    };
    I.prototype.$ = function (a) {
        wc(this.c.a, Mc(a));this.l(a) && this.b() < this.f ? this.a.a.push(a) : hd(a);
    };I.prototype.T = function () {
        for (var a = this.a; this.b() < this.m;) {
            var b = this.i();a.a.push(b);
        }for (; this.b() > this.f && 0 < this.a.b();) {
            hd(Sb(a));
        }
    };I.prototype.i = function () {
        return {};
    };var hd = function hd(a) {
        if ("function" == typeof a.ea) a.ea();else for (var b in a) {
            a[b] = null;
        }
    };I.prototype.l = function (a) {
        return "function" == typeof a.pa ? a.pa() : !0;
    };I.prototype.b = function () {
        return this.a.b() + this.c.b();
    };
    I.prototype.C = function () {
        I.I.C.call(this);if (0 < this.c.b()) throw Error("[goog.structs.Pool] Objects not released");delete this.c;for (var a = this.a; 0 != a.c.length || 0 != a.a.length;) {
            hd(Sb(a));
        }delete this.a;
    }; /*
       Portions of this code are from MochiKit, received by
       The Closure Authors under the MIT license. All other code is Copyright
       2005-2009 The Closure Authors. All Rights Reserved.
       */
    var id = function id(a, b) {
        this.c = [];this.m = b || null;this.a = this.h = !1;this.b = void 0;this.j = this.g = !1;this.f = 0;this.i = null;this.o = 0;
    };id.prototype.l = function (a, b) {
        this.g = !1;this.h = !0;this.b = b;this.a = !a;jd(this);
    };var kd = function kd(a, b, c) {
        A(!a.j, "Blocking Deferreds can not be re-used");a.c.push([b, c, void 0]);a.h && jd(a);
    };id.prototype.then = function (a, b, c) {
        var d,
            e,
            f = new H(function (a, b) {
            d = a;e = b;
        });kd(this, d, function (a) {
            e(a);
        });return f.then(a, b, c);
    };Ia(id);
    var ld = function ld(a) {
        return sb(a.c, function (a) {
            return r(a[1]);
        });
    },
        jd = function jd(a) {
        if (a.f && a.h && ld(a)) {
            var b = a.f,
                c = md[b];c && (m.clearTimeout(c.a), delete md[b]);a.f = 0;
        }a.i && (a.i.o--, delete a.i);for (var b = a.b, d = c = !1; a.c.length && !a.g;) {
            var e = a.c.shift(),
                f = e[0],
                g = e[1],
                e = e[2];if (f = a.a ? g : f) try {
                var h = f.call(e || a.m, b);n(h) && (a.a = a.a && (h == b || h instanceof Error), a.b = b = h);if (Ja(b) || "function" === typeof m.Promise && b instanceof m.Promise) d = !0, a.g = !0;
            } catch (l) {
                b = l, a.a = !0, ld(a) || (c = !0);
            }
        }a.b = b;d && (h = _t(a.l, a, !0), d = _t(a.l, a, !1), b instanceof id ? (kd(b, h, d), b.j = !0) : b.then(h, d));c && (b = new nd(b), md[b.a] = b, a.f = b.a);
    },
        nd = function nd(a) {
        this.a = m.setTimeout(_t(this.c, this), 0);this.b = a;
    };nd.prototype.c = function () {
        A(md[this.a], "Cannot throw an error that is not scheduled.");delete md[this.a];throw this.b;
    };var md = {};var od = function od(a) {
        this.f = a;this.b = this.c = this.a = null;
    },
        pd = function pd(a, b) {
        this.name = a;this.value = b;
    };pd.prototype.toString = function () {
        return this.name;
    };var qd = new pd("SEVERE", 1E3),
        rd = new pd("CONFIG", 700),
        sd = new pd("FINE", 500),
        td = function td(a) {
        if (a.c) return a.c;if (a.a) return td(a.a);eb("Root logger has no level set.");return null;
    };
    od.prototype.log = function (a, b, c) {
        if (a.value >= td(this).value) for (r(b) && (b = b()), a = new Ca(a, String(b), this.f), c && (a.a = c), c = "log:" + a.b, m.console && (m.console.timeStamp ? m.console.timeStamp(c) : m.console.markTimeline && m.console.markTimeline(c)), m.msWriteProfilerMark && m.msWriteProfilerMark(c), c = this; c;) {
            c = c.a;
        }
    };
    var ud = {},
        vd = null,
        wd = function wd(a) {
        vd || (vd = new od(""), ud[""] = vd, vd.c = rd);var b;if (!(b = ud[a])) {
            b = new od(a);var c = a.lastIndexOf("."),
                d = a.substr(c + 1),
                c = wd(a.substr(0, c));c.b || (c.b = {});c.b[d] = b;b.a = c;ud[a] = b;
        }return b;
    };var xd = function xd() {
        B.call(this);this.b = new Ib(this);this.Z = this;this.G = null;
    };u(xd, B);xd.prototype[gb] = !0;xd.prototype.removeEventListener = function (a, b, c, d) {
        ad(this, a, b, c, d);
    };
    var J = function J(a, b) {
        Uc(a);var c,
            d = a.G;if (d) {
            c = [];for (var e = 1; d; d = d.G) {
                c.push(d), A(1E3 > ++e, "infinite loop");
            }
        }a = a.Z;d = b.type || b;q(b) ? b = new Cb(b, a) : b instanceof Cb ? b.target = b.target || a : (e = b, b = new Cb(d, a), Ha(b, e));var e = !0,
            f;if (c) for (var g = c.length - 1; 0 <= g; g--) {
            f = b.a = c[g], e = yd(f, d, !0, b) && e;
        }f = b.a = a;e = yd(f, d, !0, b) && e;e = yd(f, d, !1, b) && e;if (c) for (g = 0; g < c.length; g++) {
            f = b.a = c[g], e = yd(f, d, !1, b) && e;
        }
    };
    xd.prototype.C = function () {
        xd.I.C.call(this);if (this.b) {
            var a = this.b,
                b = 0,
                c;for (c in a.a) {
                for (var d = a.a[c], e = 0; e < d.length; e++) {
                    ++b, Eb(d[e]);
                }delete a.a[c];a.b--;
            }
        }this.G = null;
    };var yd = function yd(a, b, c, d) {
        b = a.b.a[String(b)];if (!b) return !0;b = b.concat();for (var e = !0, f = 0; f < b.length; ++f) {
            var g = b[f];if (g && !g.N && g.V == c) {
                var h = g.listener,
                    l = g.M || g.src;g.U && Lb(a.b, g);e = !1 !== h.call(l, d) && e;
            }
        }return e && 0 != d.ja;
    },
        Uc = function Uc(a) {
        A(a.b, "Event target is not initialized. Did you call the superclass (goog.events.EventTarget) constructor?");
    };var K = function K(a, b) {
        this.h = new $b();I.call(this, a, b);
    };u(K, I);k = K.prototype;k.X = function (a, b) {
        if (!a) return K.I.X.call(this);Qb(this.h, n(b) ? b : 100, a);this.aa();
    };k.aa = function () {
        for (var a = this.h; 0 < a.b();) {
            var b = this.X();if (b) {
                var c;var d = a,
                    e = d.a,
                    f = e.length;c = e[0];if (0 >= f) c = void 0;else {
                    if (1 == f) vb(e);else {
                        e[0] = e.pop();for (var e = 0, d = d.a, f = d.length, g = d[e]; e < f >> 1;) {
                            var h = 2 * e + 1,
                                l = 2 * e + 2,
                                h = l < f && d[l].a < d[h].a ? l : h;if (d[h].a > g.a) break;d[e] = d[h];e = h;
                        }d[e] = g;
                    }c = c.b;
                }c.apply(this, [b]);
            } else break;
        }
    };
    k.$ = function (a) {
        K.I.$.call(this, a);this.aa();
    };k.T = function () {
        K.I.T.call(this);this.aa();
    };k.C = function () {
        K.I.C.call(this);m.clearTimeout(void 0);vb(this.h.a);this.h = null;
    };var L = function L(a, b) {
        a && a.log(sd, b, void 0);
    };var zd = function zd(a, b, c) {
        if (r(a)) c && (a = _t(a, c));else if (a && "function" == typeof a.handleEvent) a = _t(a.handleEvent, a);else throw Error("Invalid listener argument");return 2147483647 < Number(b) ? -1 : m.setTimeout(a, b || 0);
    };var M = function M(a) {
        xd.call(this);this.K = new G();this.B = a || null;this.c = !1;this.w = this.a = null;this.O = this.l = "";this.J = 0;this.h = "";this.f = this.F = this.j = this.D = !1;this.i = 0;this.m = null;this.S = "";this.u = this.ca = this.Y = !1;
    };u(M, xd);var Ad = M.prototype,
        Bd = wd("goog.net.XhrIo");Ad.v = Bd;var Cd = /^https?$/i,
        Dd = ["POST", "PUT"];
    M.prototype.send = function (a, b, c, d) {
        if (this.a) throw Error("[goog.net.XhrIo] Object is active with another request=" + this.l + "; newUri=" + a);b = b ? b.toUpperCase() : "GET";this.l = a;this.h = "";this.J = 0;this.O = b;this.D = !1;this.c = !0;this.a = this.B ? Ob(this.B) : Ob(Mb);this.w = this.B ? nb(this.B) : nb(Mb);this.a.onreadystatechange = _t(this.R, this);this.ca && "onprogress" in this.a && (this.a.onprogress = _t(function (a) {
            this.P(a, !0);
        }, this), this.a.upload && (this.a.upload.onprogress = _t(this.P, this)));try {
            L(this.v, O(this, "Opening Xhr")), this.F = !0, this.a.open(b, String(a), !0), this.F = !1;
        } catch (f) {
            L(this.v, O(this, "Error opening Xhr: " + f.message));Ed(this, f);return;
        }a = c || "";var e = new G(this.K);d && Ub(d, function (a, b) {
            e.set(b, a);
        });d = ub(e.H());c = m.FormData && a instanceof m.FormData;!(0 <= ob(Dd, b)) || d || c || e.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");e.forEach(function (a, b) {
            this.a.setRequestHeader(b, a);
        }, this);this.S && (this.a.responseType = this.S);"withCredentials" in this.a && this.a.withCredentials !== this.Y && (this.a.withCredentials = this.Y);try {
            Fd(this), 0 < this.i && (this.u = Gd(this.a), L(this.v, O(this, "Will abort after " + this.i + "ms if incomplete, xhr2 " + this.u)), this.u ? (this.a.timeout = this.i, this.a.ontimeout = _t(this.L, this)) : this.m = zd(this.L, this.i, this)), L(this.v, O(this, "Sending request")), this.j = !0, this.a.send(a), this.j = !1;
        } catch (f) {
            L(this.v, O(this, "Send error: " + f.message)), Ed(this, f);
        }
    };var Gd = function Gd(a) {
        return D && E(9) && "number" == typeof a.timeout && n(a.ontimeout);
    },
        tb = function tb(a) {
        return "content-type" == a.toLowerCase();
    };
    M.prototype.L = function () {
        "undefined" != typeof aa && this.a && (this.h = "Timed out after " + this.i + "ms, aborting", this.J = 8, L(this.v, O(this, this.h)), J(this, "timeout"), Hd(this, 8));
    };var Ed = function Ed(a, b) {
        a.c = !1;a.a && (a.f = !0, a.a.abort(), a.f = !1);a.h = b;a.J = 5;Id(a);Kd(a);
    },
        Id = function Id(a) {
        a.D || (a.D = !0, J(a, "complete"), J(a, "error"));
    },
        Hd = function Hd(a, b) {
        a.a && a.c && (L(a.v, O(a, "Aborting")), a.c = !1, a.f = !0, a.a.abort(), a.f = !1, a.J = b || 7, J(a, "complete"), J(a, "abort"), Kd(a));
    };
    M.prototype.C = function () {
        this.a && (this.c && (this.c = !1, this.f = !0, this.a.abort(), this.f = !1), Kd(this, !0));M.I.C.call(this);
    };M.prototype.R = function () {
        this.g || (this.F || this.j || this.f ? Ld(this) : this.la());
    };M.prototype.la = function () {
        Ld(this);
    };
    var Ld = function Ld(a) {
        if (a.c && "undefined" != typeof aa) if (a.w[1] && 4 == Md(a) && 2 == P(a)) L(a.v, O(a, "Local request error detected and ignored"));else if (a.j && 4 == Md(a)) zd(a.R, 0, a);else if (J(a, "readystatechange"), 4 == Md(a)) {
            L(a.v, O(a, "Request complete"));a.c = !1;try {
                if (Nd(a)) J(a, "complete"), J(a, "success");else {
                    a.J = 6;var b;try {
                        b = 2 < Md(a) ? a.a.statusText : "";
                    } catch (c) {
                        L(a.v, "Can not get status: " + c.message), b = "";
                    }a.h = b + " [" + P(a) + "]";Id(a);
                }
            } finally {
                Kd(a);
            }
        }
    };
    M.prototype.P = function (a, b) {
        A("progress" === a.type, "goog.net.EventType.PROGRESS is of the same type as raw XHR progress.");J(this, Od(a, "progress"));J(this, Od(a, b ? "downloadprogress" : "uploadprogress"));
    };
    var Od = function Od(a, b) {
        return { type: b, lengthComputable: a.lengthComputable, loaded: a.loaded, total: a.total };
    },
        Kd = function Kd(a, b) {
        if (a.a) {
            Fd(a);var c = a.a,
                d = a.w[0] ? ba : null;a.a = null;a.w = null;b || J(a, "ready");try {
                c.onreadystatechange = d;
            } catch (e) {
                (a = a.v) && a.log(qd, "Problem encountered resetting onreadystatechange: " + e.message, void 0);
            }
        }
    },
        Fd = function Fd(a) {
        a.a && a.u && (a.a.ontimeout = null);"number" == typeof a.m && (m.clearTimeout(a.m), a.m = null);
    },
        Nd = function Nd(a) {
        var b = P(a),
            c;a: switch (b) {
            case 200:case 201:case 202:case 204:case 206:case 304:case 1223:
                c = !0;break a;default:
                c = !1;
        }if (!c) {
            if (b = 0 === b) a = String(a.l).match(Fb)[1] || null, !a && m.self && m.self.location && (a = m.self.location.protocol, a = a.substr(0, a.length - 1)), b = !Cd.test(a ? a.toLowerCase() : "");c = b;
        }return c;
    },
        Md = function Md(a) {
        return a.a ? a.a.readyState : 0;
    },
        P = function P(a) {
        try {
            return 2 < Md(a) ? a.a.status : -1;
        } catch (b) {
            return -1;
        }
    },
        Pd = function Pd(a) {
        try {
            return a.a ? a.a.responseText : "";
        } catch (b) {
            return L(a.v, "Can not get responseText: " + b.message), "";
        }
    },
        Qd = function Qd(a, b) {
        return a.a && 4 == Md(a) ? a.a.getResponseHeader(b) : void 0;
    },
        O = function O(a, b) {
        return b + " [" + a.O + " " + a.l + " " + P(a) + "]";
    };var Rd = function Rd(a, b, c, d) {
        this.u = a;this.w = !!d;K.call(this, b, c);
    };u(Rd, K);Rd.prototype.i = function () {
        var a = new M(),
            b = this.u;b && b.forEach(function (b, d) {
            a.K.set(d, b);
        });this.w && (a.Y = !0);return a;
    };Rd.prototype.l = function (a) {
        return !a.g && !a.a;
    };var fd = new Rd();var Td = function Td(a, b, c, d, e, f, g, h, l, F) {
        this.K = a;this.F = b;this.w = c;this.m = d;this.G = e.slice();this.l = this.o = this.f = this.c = null;this.h = this.i = !1;this.u = f;this.j = g;this.g = l;this.L = F;this.D = h;var N = this;this.B = new H(function (a, b) {
            N.o = a;N.l = b;Sd(N);
        });
    },
        Ud = function Ud(a, b, c) {
        this.b = a;this.c = b;this.a = !!c;
    },
        Sd = function Sd(a) {
        function b(a, b) {
            b ? a(!1, new Ud(!1, null, !0)) : fd.X(function (b) {
                b.Y = d.L;d.c = b;var c = null;null !== d.g && (b.ca = !0, c = Sc(b, "uploadprogress", function (a) {
                    d.g(a.loaded, a.lengthComputable ? a.total : -1);
                }), b.ca = null !== d.g);b.send(d.K, d.F, d.m, d.w);$c(b, "complete", function (b) {
                    null !== c && bd(c);d.c = null;b = b.target;var f = 6 === b.J && 100 <= P(b),
                        f = Nd(b) || f,
                        g = P(b);!f || 500 <= g && 600 > g || 429 === g ? (f = 7 === b.J, gd(b), a(!1, new Ud(!1, null, f))) : (f = 0 <= ob(d.G, g), a(!0, new Ud(f, b)));
                });
            });
        }function c(a, b) {
            var c = d.o;a = d.l;var h = b.c;if (b.b) try {
                var l = d.u(h, Pd(h));n(l) ? c(l) : c();
            } catch (F) {
                a(F);
            } else null !== h ? (b = la(), l = Pd(h), b.serverResponse = l, d.j ? a(d.j(h, b)) : a(b)) : (b = b.a ? d.h ? pa() : ma() : new v("retry-limit-exceeded", "Max retry time for operation exceeded, please try again."), a(b));gd(h);
        }var d = a;a.i ? c(0, new Ud(!1, null, !0)) : a.f = ja(b, c, a.D);
    };Td.prototype.a = function () {
        return this.B;
    };Td.prototype.b = function (a) {
        this.i = !0;this.h = a || !1;null !== this.f && (0, this.f)(!1);null !== this.c && Hd(this.c);
    };var Vd = function Vd(a, b, c) {
        var d = bb(a.f),
            d = a.l + d,
            e = a.b ? sa(a.b) : {};null !== b && 0 < b.length && (e.Authorization = "Firebase " + b);e["X-Firebase-Storage-Version"] = "webjs/" + ("undefined" !== typeof firebase ? firebase.SDK_VERSION : "AppManager");return new Td(d, a.i, e, a.c, a.h, a.M, a.a, a.j, a.g, c);
    };var Wd = function Wd(a) {
        var b = m.BlobBuilder || m.WebKitBlobBuilder;if (n(b)) {
            for (var b = new b(), c = 0; c < arguments.length; c++) {
                b.append(arguments[c]);
            }return b.getBlob();
        }b = xb(arguments);c = m.BlobBuilder || m.WebKitBlobBuilder;if (n(c)) {
            for (var c = new c(), d = 0; d < b.length; d++) {
                c.append(b[d], void 0);
            }b = c.getBlob(void 0);
        } else if (n(m.Blob)) b = new Blob(b, {});else throw Error("This browser doesn't seem to support creating Blobs");return b;
    },
        Xd = function Xd(a, b, c) {
        n(c) || (c = a.size);return a.webkitSlice ? a.webkitSlice(b, c) : a.mozSlice ? a.mozSlice(b, c) : a.slice ? dc && !E("13.0") || ec && !E("537.1") ? (0 > b && (b += a.size), 0 > b && (b = 0), 0 > c && (c += a.size), c < b && (c = b), a.slice(b, c - b)) : a.slice(b, c) : null;
    };var Q = function Q(a, b) {
        xa() && a instanceof Blob ? (this.s = a, b = a.size, a = a.type) : (a instanceof ArrayBuffer ? (b ? this.s = new Uint8Array(a) : (this.s = new Uint8Array(a.byteLength), this.s.set(new Uint8Array(a))), b = this.s.length) : (b ? this.s = a : (this.s = new Uint8Array(a.length), this.s.set(a)), b = a.length), a = "");this.a = b;this.b = a;
    };Q.prototype.type = function () {
        return this.b;
    };
    Q.prototype.slice = function (a, b) {
        if (xa() && this.s instanceof Blob) return a = Xd(this.s, a, b), null === a ? null : new Q(a);a = new Uint8Array(this.s.buffer, a, b - a);return new Q(a, !0);
    };
    var Yd = function Yd(a) {
        var b = [];Array.prototype.push.apply(b, arguments);if (xa()) return b = rb(b, function (a) {
            return a instanceof Q ? a.s : a;
        }), new Q(Wd.apply(null, b));var b = rb(b, function (a) {
            return wa(a) ? $a("raw", a).data.buffer : a.s.buffer;
        }),
            c = 0;pb(b, function (a) {
            c += a.byteLength;
        });var d = new Uint8Array(c),
            e = 0;pb(b, function (a) {
            a = new Uint8Array(a);for (var b = 0; b < a.length; b++) {
                d[e++] = a[b];
            }
        });return new Q(d, !0);
    };var Zd = function Zd(a) {
        this.c = Dc(a);
    };Zd.prototype.a = function () {
        return this.c;
    };Zd.prototype.b = function () {};var $d = function $d() {
        this.a = {};this.b = Number.MIN_SAFE_INTEGER;
    },
        ae = function ae(a, b) {
        function c() {
            delete e.a[d];
        }var d = a.b;a.b++;a.a[d] = b;var e = a;b.a().then(c, c);
    },
        be = function be(a) {
        ra(a.a, function (a, c) {
            c && c.b(!0);
        });a.a = {};
    };var ce = function ce(a, b, c, d) {
        this.a = a;this.g = null;if (null !== this.a && (a = this.a.options, x(a))) {
            a = a.storageBucket || null;if (null == a) a = null;else {
                var e = null;try {
                    e = Sa(a);
                } catch (f) {}if (null !== e) {
                    if ("" !== e.path) throw new v("invalid-default-bucket", "Invalid default bucket '" + a + "'.");a = e.bucket;
                }
            }this.g = a;
        }this.l = b;this.j = c;this.i = d;this.c = 12E4;this.b = 6E4;this.h = new $d();this.f = !1;
    },
        de = function de(a) {
        return null !== a.a && x(a.a.INTERNAL) && x(a.a.INTERNAL.getToken) ? a.a.INTERNAL.getToken().then(function (a) {
            return x(a) ? a.accessToken : null;
        }, function () {
            return null;
        }) : Cc(null);
    };ce.prototype.bucket = function () {
        if (this.f) throw pa();return this.g;
    };var R = function R(a, b, c) {
        if (a.f) return new Zd(pa());b = a.j(b, c, null === a.a);ae(a.h, b);return b;
    };var ee = function ee(a, b) {
        return b;
    },
        S = function S(a, b, c, d) {
        this.c = a;this.b = b || a;this.f = !!c;this.a = d || ee;
    },
        fe = null,
        ge = function ge() {
        if (fe) return fe;var a = [];a.push(new S("bucket"));a.push(new S("generation"));a.push(new S("metageneration"));a.push(new S("name", "fullPath", !0));var b = new S("name");b.a = function (a, b) {
            return !wa(b) || 2 > b.length ? b : Hb(b);
        };a.push(b);b = new S("size");b.a = function (a, b) {
            return x(b) ? +b : b;
        };a.push(b);a.push(new S("timeCreated"));a.push(new S("updated"));a.push(new S("md5Hash", null, !0));a.push(new S("cacheControl", null, !0));a.push(new S("contentDisposition", null, !0));a.push(new S("contentEncoding", null, !0));a.push(new S("contentLanguage", null, !0));a.push(new S("contentType", null, !0));a.push(new S("metadata", "customMetadata", !0));a.push(new S("downloadTokens", "downloadURLs", !1, function (a, b) {
            if (!(wa(b) && 0 < b.length)) return [];var e = encodeURIComponent;return rb(b.split(","), function (b) {
                var d = a.fullPath,
                    d = "https://firebasestorage.googleapis.com/v0" + ("/b/" + e(a.bucket) + "/o/" + e(d));b = bb({ alt: "media", token: b });return d + b;
            });
        }));return fe = a;
    },
        he = function he(a, b) {
        Object.defineProperty(a, "ref", { get: function get() {
                return b.l(b, new y(a.bucket, a.fullPath));
            } });
    },
        ie = function ie(a, b) {
        for (var c = {}, d = b.length, e = 0; e < d; e++) {
            var f = b[e];f.f && (c[f.c] = a[f.b]);
        }return JSON.stringify(c);
    },
        je = function je(a) {
        if (!a || "object" !== (typeof a === "undefined" ? "undefined" : _typeof(a))) throw "Expected Metadata object.";for (var b in a) {
            var c = a[b];if ("customMetadata" === b && "object" !== (typeof c === "undefined" ? "undefined" : _typeof(c))) throw "Expected object for 'customMetadata' mapping.";
        }
    };var T = function T(a, b, c) {
        for (var d = b.length, e = b.length, f = 0; f < b.length; f++) {
            if (b[f].b) {
                d = f;break;
            }
        }if (!(d <= c.length && c.length <= e)) throw d === e ? (b = d, d = 1 === d ? "argument" : "arguments") : (b = "between " + d + " and " + e, d = "arguments"), new v("invalid-argument-count", "Invalid argument count in `" + a + "`: Expected " + b + " " + d + ", received " + c.length + ".");for (f = 0; f < c.length; f++) {
            try {
                b[f].a(c[f]);
            } catch (g) {
                if (g instanceof Error) throw oa(f, a, g.message);throw oa(f, a, g);
            }
        }
    },
        U = function U(a, b) {
        var c = this;this.a = function (b) {
            c.b && !n(b) || a(b);
        };
        this.b = !!b;
    },
        ke = function ke(a, b) {
        return function (c) {
            a(c);b(c);
        };
    },
        le = function le(a, b) {
        function c(a) {
            if (!("string" === typeof a || a instanceof String)) throw "Expected string.";
        }var d;a ? d = ke(c, a) : d = c;return new U(d, b);
    },
        me = function me() {
        return new U(function (a) {
            if (!(a instanceof Uint8Array || a instanceof ArrayBuffer || xa() && a instanceof Blob)) throw "Expected Blob or File.";
        });
    },
        ne = function ne() {
        return new U(function (a) {
            if (!(("number" === typeof a || a instanceof Number) && 0 <= a)) throw "Expected a number 0 or greater.";
        });
    },
        oe = function oe(a, b) {
        return new U(function (b) {
            if (!(null === b || x(b) && b instanceof Object)) throw "Expected an Object.";x(a) && a(b);
        }, b);
    },
        pe = function pe() {
        return new U(function (a) {
            if (null !== a && !r(a)) throw "Expected a Function.";
        }, !0);
    };var qe = function qe(a) {
        if (!a) throw la();
    },
        re = function re(a, b) {
        return function (c, d) {
            a: {
                var e;try {
                    e = JSON.parse(d);
                } catch (h) {
                    c = null;break a;
                }c = da(e) ? e : null;
            }if (null === c) c = null;else {
                d = { type: "file" };e = b.length;for (var f = 0; f < e; f++) {
                    var g = b[f];d[g.b] = g.a(d, c[g.c]);
                }he(d, a);c = d;
            }qe(null !== c);return c;
        };
    },
        se = function se(a) {
        return function (b, c) {
            b = 401 === P(b) ? new v("unauthenticated", "User is not authenticated, please authenticate using Firebase Authentication and try again.") : 402 === P(b) ? new v("quota-exceeded", "Quota for bucket '" + a.bucket + "' exceeded, please view quota on https://firebase.google.com/pricing/.") : 403 === P(b) ? new v("unauthorized", "User does not have permission to access '" + a.path + "'.") : c;b.serverResponse = c.serverResponse;return b;
        };
    },
        te = function te(a) {
        var b = se(a);return function (c, d) {
            var e = b(c, d);404 === P(c) && (e = new v("object-not-found", "Object '" + a.path + "' does not exist."));e.serverResponse = d.serverResponse;return e;
        };
    },
        ue = function ue(a, b, c) {
        var d = Ra(b);a = new w(ka + "/v0" + d, "GET", re(a, c), a.c);a.a = te(b);return a;
    },
        ve = function ve(a, b) {
        var c = Ra(b);a = new w(ka + "/v0" + c, "DELETE", function () {}, a.c);a.h = [200, 204];a.a = te(b);return a;
    },
        we = function we(a, b, c) {
        c = c ? sa(c) : {};c.fullPath = a.path;c.size = b.a;c.contentType || (a = b && b.type() || "application/octet-stream", c.contentType = a);return c;
    },
        xe = function xe(a, b, c, d, e) {
        var f = "/b/" + encodeURIComponent(b.bucket) + "/o",
            g = { "X-Goog-Upload-Protocol": "multipart" },
            h;h = "";for (var l = 0; 2 > l; l++) {
            h += Math.random().toString().slice(2);
        }g["Content-Type"] = "multipart/related; boundary=" + h;e = we(b, d, e);l = ie(e, c);d = Yd("--" + h + "\r\nContent-Type: application/json; charset=utf-8\r\n\r\n" + l + "\r\n--" + h + "\r\nContent-Type: " + e.contentType + "\r\n\r\n", d, "\r\n--" + h + "--");if (null === d) throw na();a = new w(ka + "/v0" + f, "POST", re(a, c), a.b);a.f = { name: e.fullPath };a.b = g;a.c = d.s;a.a = se(b);return a;
    },
        ye = function ye(a, b, c, d) {
        this.a = a;this.total = b;this.b = !!c;this.c = d || null;
    },
        ze = function ze(a, b) {
        var c;try {
            c = Qd(a, "X-Goog-Upload-Status");
        } catch (d) {
            qe(!1);
        }a = 0 <= ob(b || ["active"], c);qe(a);return c;
    },
        Ae = function Ae(a, b, c, d, e) {
        var f = "/b/" + encodeURIComponent(b.bucket) + "/o",
            g = we(b, d, e);e = { name: g.fullPath };f = ka + "/v0" + f;d = {
            "X-Goog-Upload-Protocol": "resumable",
            "X-Goog-Upload-Command": "start", "X-Goog-Upload-Header-Content-Length": d.a, "X-Goog-Upload-Header-Content-Type": g.contentType, "Content-Type": "application/json; charset=utf-8"
        };c = ie(g, c);a = new w(f, "POST", function (a) {
            ze(a);var b;try {
                b = Qd(a, "X-Goog-Upload-URL");
            } catch (c) {
                qe(!1);
            }qe(wa(b));return b;
        }, a.b);a.f = e;a.b = d;a.c = c;a.a = se(b);return a;
    },
        Be = function Be(a, b, c, d) {
        a = new w(c, "POST", function (a) {
            var b = ze(a, ["active", "final"]),
                c;try {
                c = Qd(a, "X-Goog-Upload-Size-Received");
            } catch (h) {
                qe(!1);
            }a = c;isFinite(a) && (a = String(a));
            a = q(a) ? /^\s*-?0x/i.test(a) ? parseInt(a, 16) : parseInt(a, 10) : NaN;qe(!isNaN(a));return new ye(a, d.a, "final" === b);
        }, a.b);a.b = { "X-Goog-Upload-Command": "query" };a.a = se(b);return a;
    },
        Ce = function Ce(a, b, c, d, e, f) {
        var g = new ye(0, 0);f ? (g.a = f.a, g.total = f.total) : (g.a = 0, g.total = d.a);if (d.a !== g.total) throw new v("server-file-wrong-size", "Server recorded incorrect upload file size, please retry the upload.");var h = f = g.total - g.a,
            h = Math.min(h, 262144),
            l = g.a;f = { "X-Goog-Upload-Command": h === f ? "upload, finalize" : "upload", "X-Goog-Upload-Offset": g.a };
        l = d.slice(l, l + h);if (null === l) throw na();c = new w(c, "POST", function (a, c) {
            var f = ze(a, ["active", "final"]),
                l = g.a + h,
                Jd = d.a,
                ab;"final" === f ? ab = re(b, e)(a, c) : ab = null;return new ye(l, Jd, "final" === f, ab);
        }, b.b);c.b = f;c.c = l.s;c.g = null;c.a = se(a);return c;
    };var W = function W(a, b, c, d, e, f) {
        this.K = a;this.c = b;this.i = c;this.f = e;this.h = f || null;this.o = d;this.j = 0;this.G = this.m = !1;this.B = [];this.Z = 262144 < this.f.a;this.b = "running";this.a = this.u = this.g = null;var g = this;this.W = function (a) {
            g.a = null;"storage/canceled" === a.code ? (g.m = !0, De(g)) : (g.g = a, V(g, "error"));
        };this.S = function (a) {
            g.a = null;"storage/canceled" === a.code ? De(g) : (g.g = a, V(g, "error"));
        };this.w = this.l = null;this.F = new H(function (a, b) {
            g.l = a;g.w = b;Ee(g);
        });this.F.then(null, function () {});
    },
        Ee = function Ee(a) {
        "running" === a.b && null === a.a && (a.Z ? null === a.u ? Fe(a) : a.m ? Ge(a) : a.G ? He(a) : Ie(a) : Je(a));
    },
        Ke = function Ke(a, b) {
        de(a.c).then(function (c) {
            switch (a.b) {case "running":
                    b(c);break;case "canceling":
                    V(a, "canceled");break;case "pausing":
                    V(a, "paused");}
        });
    },
        Fe = function Fe(a) {
        Ke(a, function (b) {
            var c = Ae(a.c, a.i, a.o, a.f, a.h);a.a = R(a.c, c, b);a.a.a().then(function (b) {
                a.a = null;a.u = b;a.m = !1;De(a);
            }, this.W);
        });
    },
        Ge = function Ge(a) {
        var b = a.u;Ke(a, function (c) {
            var d = Be(a.c, a.i, b, a.f);a.a = R(a.c, d, c);a.a.a().then(function (b) {
                a.a = null;Le(a, b.a);a.m = !1;b.b && (a.G = !0);De(a);
            }, a.W);
        });
    },
        Ie = function Ie(a) {
        var b = new ye(a.j, a.f.a),
            c = a.u;Ke(a, function (d) {
            var e;try {
                e = Ce(a.i, a.c, c, a.f, a.o, b);
            } catch (f) {
                a.g = f;V(a, "error");return;
            }a.a = R(a.c, e, d);a.a.a().then(function (b) {
                a.a = null;Le(a, b.a);b.b ? (a.h = b.c, V(a, "success")) : De(a);
            }, a.W);
        });
    },
        He = function He(a) {
        Ke(a, function (b) {
            var c = ue(a.c, a.i, a.o);a.a = R(a.c, c, b);a.a.a().then(function (b) {
                a.a = null;a.h = b;V(a, "success");
            }, a.S);
        });
    },
        Je = function Je(a) {
        Ke(a, function (b) {
            var c = xe(a.c, a.i, a.o, a.f, a.h);a.a = R(a.c, c, b);a.a.a().then(function (b) {
                a.a = null;
                a.h = b;Le(a, a.f.a);V(a, "success");
            }, a.W);
        });
    },
        Le = function Le(a, b) {
        var c = a.j;a.j = b;a.j > c && Me(a);
    },
        V = function V(a, b) {
        if (a.b !== b) switch (b) {case "canceling":
                a.b = b;null !== a.a && a.a.b();break;case "pausing":
                a.b = b;null !== a.a && a.a.b();break;case "running":
                var c = "paused" === a.b;a.b = b;c && (Me(a), Ee(a));break;case "paused":
                a.b = b;Me(a);break;case "canceled":
                a.g = ma();a.b = b;Me(a);break;case "error":
                a.b = b;Me(a);break;case "success":
                a.b = b, Me(a);}
    },
        De = function De(a) {
        switch (a.b) {
            case "pausing":
                V(a, "paused");break;case "canceling":
                V(a, "canceled");break;case "running":
                Ee(a);
        }
    };W.prototype.D = function () {
        return new z(this.j, this.f.a, va(this.b), this.h, this, this.K);
    };
    W.prototype.O = function (a, b, c, d) {
        function e(a) {
            try {
                g(a);return;
            } catch (b) {}try {
                if (h(a), !(n(a.next) || n(a.error) || n(a.complete))) throw "";
            } catch (b) {
                throw "Expected a function or an Object with one of `next`, `error`, `complete` properties.";
            }
        }function f(a) {
            return function (b, c, d) {
                null !== a && T("on", a, arguments);var e = new Ta(b, c, d);Ne(l, e);return function () {
                    wb(l.B, e);
                };
            };
        }var g = pe().a,
            h = oe(null, !0).a;T("on", [le(function () {
            if ("state_changed" !== a) throw "Expected one of the event types: [state_changed].";
        }), oe(e, !0), pe(), pe()], arguments);var l = this,
            F = [oe(function (a) {
            if (null === a) throw "Expected a function or an Object with one of `next`, `error`, `complete` properties.";e(a);
        }), pe(), pe()];return n(b) || n(c) || n(d) ? f(null)(b, c, d) : f(F);
    };W.prototype.then = function (a, b) {
        return this.F.then(a, b);
    };
    var Ne = function Ne(a, b) {
        a.B.push(b);Oe(a, b);
    },
        Me = function Me(a) {
        Pe(a);var b = xb(a.B);pb(b, function (b) {
            Oe(a, b);
        });
    },
        Pe = function Pe(a) {
        if (null !== a.l) {
            var b = !0;switch (va(a.b)) {case "success":
                    Oc(a.l.bind(null, a.D()))();break;case "canceled":case "error":
                    Oc(a.w.bind(null, a.g))();break;default:
                    b = !1;}b && (a.l = null, a.w = null);
        }
    },
        Oe = function Oe(a, b) {
        switch (va(a.b)) {
            case "running":case "paused":
                null !== b.next && Oc(b.next.bind(b, a.D()))();break;case "success":
                null !== b.b && Oc(b.b.bind(b))();break;case "canceled":case "error":
                null !== b.a && Oc(b.a.bind(b, a.g))();break;default:
                null !== b.a && Oc(b.a.bind(b, a.g))();
        }
    };W.prototype.R = function () {
        T("resume", [], arguments);var a = "paused" === this.b || "pausing" === this.b;a && V(this, "running");return a;
    };W.prototype.P = function () {
        T("pause", [], arguments);var a = "running" === this.b;a && V(this, "pausing");return a;
    };W.prototype.L = function () {
        T("cancel", [], arguments);var a = "running" === this.b || "pausing" === this.b;a && V(this, "canceling");return a;
    };var X = function X(a, b) {
        this.b = a;if (b) this.a = b instanceof y ? b : Sa(b);else if (a = a.bucket(), null !== a) this.a = new y(a, "");else throw new v("no-default-bucket", "No default bucket found. Did you set the 'storageBucket' property when initializing the app?");
    };X.prototype.toString = function () {
        T("toString", [], arguments);return "gs://" + this.a.bucket + "/" + this.a.path;
    };var Qe = function Qe(a, b) {
        return new X(a, b);
    };k = X.prototype;
    k.fa = function (a) {
        T("child", [le()], arguments);var b = Gb(this.a.path, a);return Qe(this.b, new y(this.a.bucket, b));
    };k.Ea = function () {
        var a;a = this.a.path;if (0 == a.length) a = null;else {
            var b = a.lastIndexOf("/");a = -1 === b ? "" : a.slice(0, b);
        }return null === a ? null : Qe(this.b, new y(this.a.bucket, a));
    };k.Ga = function () {
        return Qe(this.b, new y(this.a.bucket, ""));
    };k.na = function () {
        return this.a.bucket;
    };k.za = function () {
        return this.a.path;
    };k.Da = function () {
        return Hb(this.a.path);
    };k.Ia = function () {
        return this.b.i;
    };
    k.sa = function (a, b) {
        T("put", [me(), new U(je, !0)], arguments);Re(this, "put");return new W(this, this.b, this.a, ge(), new Q(a), b);
    };k.ta = function (a, b, c) {
        T("putString", [le(), le(Va, !0), new U(je, !0)], arguments);Re(this, "putString");var d = $a(x(b) ? b : "raw", a),
            e = c ? sa(c) : {};e.contentType = d.a;return new W(this, this.b, this.a, ge(), new Q(d.data, !0), e);
    };k.delete = function () {
        T("delete", [], arguments);Re(this, "delete");var a = this;return de(this.b).then(function (b) {
            var c = ve(a.b, a.a);return R(a.b, c, b).a();
        });
    };
    k.ga = function () {
        T("getMetadata", [], arguments);Re(this, "getMetadata");var a = this;return de(this.b).then(function (b) {
            var c = ue(a.b, a.a, ge());return R(a.b, c, b).a();
        });
    };k.ua = function (a) {
        T("updateMetadata", [new U(je, void 0)], arguments);Re(this, "updateMetadata");var b = this;return de(this.b).then(function (c) {
            var d = b.b,
                e = b.a,
                f = a,
                g = ge(),
                h = Ra(e),
                h = ka + "/v0" + h,
                f = ie(f, g),
                d = new w(h, "PATCH", re(d, g), d.c);d.b = { "Content-Type": "application/json; charset=utf-8" };d.c = f;d.a = te(e);return R(b.b, d, c).a();
        });
    };
    k.ra = function () {
        T("getDownloadURL", [], arguments);Re(this, "getDownloadURL");return this.ga().then(function (a) {
            a = a.downloadURLs[0];if (x(a)) return a;throw new v("no-download-url", "The given file does not have any download URLs.");
        });
    };var Re = function Re(a, b) {
        if ("" === a.a.path) throw new v("invalid-root-operation", "The operation '" + b + "' cannot be performed on a root reference, create a non-root reference using child, such as .child('file.png').");
    };var Y = function Y(a) {
        this.a = new ce(a, function (a, c) {
            return new X(a, c);
        }, Vd, this);this.b = a;this.c = new Se(this);
    };k = Y.prototype;k.va = function (a) {
        T("ref", [le(function (a) {
            if (/^[A-Za-z]+:\/\//.test(a)) throw "Expected child path but got a URL, use refFromURL instead.";
        }, !0)], arguments);var b = new X(this.a);return n(a) ? b.fa(a) : b;
    };
    k.wa = function (a) {
        T("refFromURL", [le(function (a) {
            if (!/^[A-Za-z]+:\/\//.test(a)) throw "Expected full URL but got a child path, use ref instead.";try {
                Sa(a);
            } catch (c) {
                throw "Expected valid full URL but got an invalid one.";
            }
        }, !1)], arguments);return new X(this.a, a);
    };k.Ba = function () {
        return this.a.b;
    };k.ya = function (a) {
        T("setMaxUploadRetryTime", [ne()], arguments);this.a.b = a;
    };k.Aa = function () {
        return this.a.c;
    };k.xa = function (a) {
        T("setMaxOperationRetryTime", [ne()], arguments);this.a.c = a;
    };k.ma = function () {
        return this.b;
    };
    k.ka = function () {
        return this.c;
    };var Se = function Se(a) {
        this.a = a;
    };Se.prototype.delete = function () {
        var a = this.a.a;a.f = !0;a.a = null;be(a.h);
    };var Z = function Z(a, b, c) {
        Object.defineProperty(a, b, { get: c });
    };X.prototype.toString = X.prototype.toString;X.prototype.child = X.prototype.fa;X.prototype.put = X.prototype.sa;X.prototype.putString = X.prototype.ta;X.prototype["delete"] = X.prototype.delete;X.prototype.getMetadata = X.prototype.ga;X.prototype.updateMetadata = X.prototype.ua;X.prototype.getDownloadURL = X.prototype.ra;Z(X.prototype, "parent", X.prototype.Ea);Z(X.prototype, "root", X.prototype.Ga);Z(X.prototype, "bucket", X.prototype.na);
    Z(X.prototype, "fullPath", X.prototype.za);Z(X.prototype, "name", X.prototype.Da);Z(X.prototype, "storage", X.prototype.Ia);Y.prototype.ref = Y.prototype.va;Y.prototype.refFromURL = Y.prototype.wa;Z(Y.prototype, "maxOperationRetryTime", Y.prototype.Aa);Y.prototype.setMaxOperationRetryTime = Y.prototype.xa;Z(Y.prototype, "maxUploadRetryTime", Y.prototype.Ba);Y.prototype.setMaxUploadRetryTime = Y.prototype.ya;Z(Y.prototype, "app", Y.prototype.ma);Z(Y.prototype, "INTERNAL", Y.prototype.ka);Se.prototype["delete"] = Se.prototype.delete;
    Y.prototype.capi_ = function (a) {
        ka = a;
    };W.prototype.on = W.prototype.O;W.prototype.resume = W.prototype.R;W.prototype.pause = W.prototype.P;W.prototype.cancel = W.prototype.L;Z(W.prototype, "snapshot", W.prototype.D);Z(z.prototype, "bytesTransferred", z.prototype.oa);Z(z.prototype, "totalBytes", z.prototype.Ka);Z(z.prototype, "state", z.prototype.Ha);Z(z.prototype, "metadata", z.prototype.Ca);Z(z.prototype, "downloadURL", z.prototype.qa);Z(z.prototype, "task", z.prototype.Ja);Z(z.prototype, "ref", z.prototype.Fa);
    ta.STATE_CHANGED = "state_changed";ua.RUNNING = "running";ua.PAUSED = "paused";ua.SUCCESS = "success";ua.CANCELED = "canceled";ua.ERROR = "error";Ua.RAW = "raw";Ua.BASE64 = "base64";Ua.BASE64URL = "base64url";Ua.DATA_URL = "data_url";H.prototype["catch"] = H.prototype.l;H.prototype.then = H.prototype.then;
    (function () {
        function a(a) {
            return new Y(a);
        }var b = { TaskState: ua, TaskEvent: ta, StringFormat: Ua, Storage: Y, Reference: X };if (window.firebase && firebase.INTERNAL && firebase.INTERNAL.registerService) firebase.INTERNAL.registerService("storage", a, b);else throw Error("Cannot install Firebase Storage - be sure to load firebase-app.js first.");
    })();
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(20)))

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"red-hat-regular",attrs:{"id":"app"}},[(_vm.isActive)?_c('lco-loader'):_vm._e(),_vm._v(" "),(_vm.isMessage)?_c('lco-message',{attrs:{"message":_vm.message,"backgroundColor":_vm.backgroundColor,"leftalign":_vm.leftalign,"minwidth":_vm.minwidth,"snackbarClass":_vm.snackbarClass}}):_vm._e(),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loader_vue__ = __webpack_require__(104);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67b4906d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__ = __webpack_require__(204);
function injectStyle (ssrContext) {
  __webpack_require__(202)
}
var normalizeComponent = __webpack_require__(57)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67b4906d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67b4906d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(203);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(25)("9d57bcce", content, true, {});

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(19)(false);
// imports


// module
exports.push([module.i, ".loader[data-v-67b4906d]{width:100%;height:100vh;position:absolute;z-index:9999999;background:rgba(0,0,0,.5)}.loader-div[data-v-67b4906d]{width:16%;background-color:#fff;margin:18% 42%;padding:16px;border-radius:16px}.main-loader-div[data-v-67b4906d]{margin:auto;text-align:center}p[data-v-67b4906d]{color:#000;font-size:.8rem;text-align:center}.loading[data-v-67b4906d]:after{content:\" .\";animation:dots-data-v-67b4906d 1s steps(5) infinite}@keyframes dots-data-v-67b4906d{0%,20%{color:#000;text-shadow:.25em 0 0 transparent,.5em 0 0 transparent}40%{color:#000;text-shadow:.25em 0 0 transparent,.5em 0 0 transparent}60%{text-shadow:.25em 0 0 #000,.5em 0 0 transparent}80%,to{text-shadow:.25em 0 0 #000,.5em 0 0 #000}}@media only screen and (max-width:767px){.loader-div[data-v-67b4906d]{width:30%;margin:60% auto}}@media only screen and (min-width:1800px){.loader-div[data-v-67b4906d]{width:12%;margin:24% 44%}}", ""]);

// exports


/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader red-hat-medium"},[_c('div',{staticClass:"loader-div"},[_c('div',{staticClass:"main-loader-div"},[_c('img',{staticClass:"loader-image",attrs:{"src":__webpack_require__(205),"alt":"loader"}})]),_vm._v(" "),_c('p',{staticClass:"loading"},[_vm._v(" Please wait a moment")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "Loader2.svg?a6653612c8c8970706f38ad3dd49dd8f";

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Snackbar_vue__ = __webpack_require__(105);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6881934_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Snackbar_vue__ = __webpack_require__(209);
function injectStyle (ssrContext) {
  __webpack_require__(207)
}
var normalizeComponent = __webpack_require__(57)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a6881934"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Snackbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6881934_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Snackbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(208);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(25)("a28f4482", content, true, {});

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(19)(false);
// imports


// module
exports.push([module.i, ".snackbar[data-v-a6881934]{min-width:100%;background-color:#333;color:#fff;text-align:center;border-radius:2px;padding:10px;position:fixed;z-index:99999;font-size:15px;-webkit-animation:fadein-data-v-a6881934 .5s,fadeout-data-v-a6881934 .5s 3.8s;animation:fadein-data-v-a6881934 .5s,fadeout-data-v-a6881934 .5s 3.8s}@-webkit-keyframes fadein-data-v-a6881934{0%{top:0;opacity:0}to{top:0;opacity:1}}@keyframes fadein-data-v-a6881934{0%{top:0;opacity:0}to{top:0;opacity:1}}@-webkit-keyframes fadeout-data-v-a6881934{0%{top:0;opacity:1}to{top:0;opacity:0}}@keyframes fadeout-data-v-a6881934{0%{top:0;opacity:1}to{top:0;opacity:0}}.login-snackbar[data-v-a6881934]{min-width:85%;background-color:#333;color:#fff;text-align:center;border-radius:2px;padding:10px;position:fixed;z-index:9999;font-size:15px;-webkit-animation:fadeinlogin-data-v-a6881934 .5s,fadeoutlogin-data-v-a6881934 .5s 2.8s;animation:fadeinlogin-data-v-a6881934 .5s,fadeoutlogin-data-v-a6881934 .5s 2.8s}@-webkit-keyframes fadeinlogin-data-v-a6881934{0%{top:-40px;opacity:0}to{top:0;opacity:1}}@keyframes fadeinlogin-data-v-a6881934{0%{top:-40px;opacity:0}to{top:0;opacity:1}}@-webkit-keyframes fadeoutlogin-data-v-a6881934{0%{top:0;opacity:1}to{top:-40px;opacity:0}}@keyframes fadeoutlogin-data-v-a6881934{0%{top:0;opacity:1}to{top:-40px;opacity:0}}", ""]);

// exports


/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"red-hat-medium"},[_c('div',{staticClass:"snackbar",style:({ backgroundColor:_vm.backgroundColor })},[_vm._v(" "+_vm._s(_vm.message)+" ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return router; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes__ = __webpack_require__(212);



var originalPush = __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */].prototype.push;
__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */].prototype.push = function push(location) {
    return originalPush.call(this, location).catch(function (err) {
        return err;
    });
};
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* routes */],
    mode: 'history'
});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
  * vue-router v3.1.3
  * (c) 2019 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

function isExtendedError (constructor, err) {
  return (
    err instanceof constructor ||
    // _name is to support IE9 too
    (err && (err.name === constructor.name || err._name === constructor._name))
  )
}

function extend (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

var View = {
  name: 'RouterView',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    // used by devtools to display a router-view badge
    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      var vnodeData = parent.$vnode && parent.$vnode.data;
      if (vnodeData) {
        if (vnodeData.routerView) {
          depth++;
        }
        if (vnodeData.keepAlive && parent._inactive) {
          inactive = true;
        }
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // register instance in init hook
    // in case kept-alive component be actived when routes changed
    data.hook.init = function (vnode) {
      if (vnode.data.keepAlive &&
        vnode.componentInstance &&
        vnode.componentInstance !== matched.instances[name]
      ) {
        matched.instances[name] = vnode.componentInstance;
      }
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */

var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}
pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  params = params || {};
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));

    // Fix #2505 resolving asterisk routes { name: 'not-found', params: { pathMatch: '/not-found' }}
    if (params.pathMatch) { params[0] = params.pathMatch; }

    return filler(params, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  } finally {
    // delete the 0 if it was added
    delete params[0];
  }
}

/*  */

function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next._normalized) {
    return next
  } else if (next.name) {
    return extend({}, raw)
  }

  // relative params
  if (!next.path && next.params && current) {
    next = extend({}, next);
    next._normalized = true;
    var params = extend(extend({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var noop = function () {};

var Link = {
  name: 'RouterLink',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(
      this.to,
      current,
      this.append
    );
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback =
      globalActiveClass == null ? 'router-link-active' : globalActiveClass;
    var exactActiveClassFallback =
      globalExactActiveClass == null
        ? 'router-link-exact-active'
        : globalExactActiveClass;
    var activeClass =
      this.activeClass == null ? activeClassFallback : this.activeClass;
    var exactActiveClass =
      this.exactActiveClass == null
        ? exactActiveClassFallback
        : this.exactActiveClass;

    var compareTarget = route.redirectedFrom
      ? createRoute(null, normalizeLocation(route.redirectedFrom), null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location, noop);
        } else {
          router.push(location, noop);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) {
        on[e] = handler;
      });
    } else {
      on[this.event] = handler;
    }

    var data = { class: classes };

    var scopedSlot =
      !this.$scopedSlots.$hasNormal &&
      this.$scopedSlots.default &&
      this.$scopedSlots.default({
        href: href,
        route: route,
        navigate: handler,
        isActive: classes[activeClass],
        isExactActive: classes[exactActiveClass]
      });

    if (scopedSlot) {
      if (scopedSlot.length === 1) {
        return scopedSlot[0]
      } else if (scopedSlot.length > 1 || !scopedSlot.length) {
        if (false) {
          warn(
            false,
            ("RouterLink with to=\"" + (this.props.to) + "\" is trying to use a scoped slot but it didn't provide exactly one child.")
          );
        }
        return scopedSlot.length === 0 ? h() : h('span', {}, scopedSlot)
      }
    }

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var aData = (a.data = extend({}, a.data));
        aData.on = aData.on || {};
        // transform existing events in both objects into arrays so we can push later
        for (var event in aData.on) {
          var handler$1 = aData.on[event];
          if (event in on) {
            aData.on[event] = Array.isArray(handler$1) ? handler$1 : [handler$1];
          }
        }
        // append new listeners for router-link
        for (var event$1 in on) {
          if (event$1 in aData.on) {
            // on[event] is always a function
            aData.on[event$1].push(on[event$1]);
          } else {
            aData.on[event$1] = handler;
          }
        }

        var aAttrs = (a.data.attrs = extend({}, a.data.attrs));
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('RouterView', View);
  Vue.component('RouterLink', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  if (false) {
    // warn if routes do not include leading slashes
    var found = pathList
    // check for missing leading slash
      .filter(function (path) { return path && path.charAt(0) !== '*' && path.charAt(0) !== '/'; });

    if (found.length > 0) {
      var pathNames = found.map(function (path) { return ("- " + path); }).join('\n');
      warn(false, ("Non-nested routes must include a leading slash character. Fix the following routes: \n" + pathNames));
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(
        path || name
      )) + " cannot be a " + "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions =
    route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(path, parent, pathToRegexpOptions.strict);

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props:
      route.props == null
        ? {}
        : route.components
          ? route.props
          : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (
        route.name &&
        !route.redirect &&
        route.children.some(function (child) { return /^\/?$/.test(child.path); })
      ) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
            "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
            "the default child route will not be rendered. Remove the name from " +
            "this route and use the name of the default child route for named " +
            "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias) ? route.alias : [route.alias];
    for (var i = 0; i < aliases.length; ++i) {
      var alias = aliases[i];
      if (false) {
        warn(
          false,
          ("Found an alias with the same value as the path: \"" + path + "\". You have to remove that alias. It will be ignored in development.")
        );
        // skip in dev to make it work
        continue
      }

      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    }
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
          "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (
  path,
  pathToRegexpOptions
) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(
        !keys[key.name],
        ("Duplicate param keys in route with path: \"" + path + "\"")
      );
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (
  path,
  parent,
  strict
) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */



function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
      return _createRoute(record, location, redirectedFrom)
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
      ? originalRedirect(createRoute(record, location, null, router))
      : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      // Fix #1994: using * with props: true generates a param named 0
      params[key.name || 'pathMatch'] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */

// use User Timing api (if present) for more accurate key precision
var Time =
  inBrowser && window.performance && window.performance.now
    ? window.performance
    : Date;

function genStateKey () {
  return Time.now().toFixed(3)
}

var _key = genStateKey();

function getStateKey () {
  return _key
}

function setStateKey (key) {
  return (_key = key)
}

/*  */

var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  // Fix for #2195 Add optional third attribute to workaround a bug in safari https://bugs.webkit.org/show_bug.cgi?id=182678
  // Fix for #2774 Support for apps loaded from Windows file shares not mapped to network drives: replaced location.origin with
  // window.location.protocol + '//' + window.location.host
  // location.host contains the port and location.hostname doesn't
  var protocolAndPath = window.location.protocol + '//' + window.location.host;
  var absolutePath = window.location.href.replace(protocolAndPath, '');
  window.history.replaceState({ key: getStateKey() }, '', absolutePath);
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior.call(
      router,
      to,
      from,
      isPop ? position : null
    );

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll
        .then(function (shouldScroll) {
          scrollToPosition((shouldScroll), position);
        })
        .catch(function (err) {
          if (false) {
            assert(false, err.toString());
          }
        });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

var hashStartsWithNumberRE = /^#\d/;

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    // getElementById would still fail if the selector contains a more complicated query like #main[data-attr]
    // but at the same time, it doesn't make much sense to select an element with an id and an extra selector
    var el = hashStartsWithNumberRE.test(shouldScroll.selector) // $flow-disable-line
      ? document.getElementById(shouldScroll.selector.slice(1)) // $flow-disable-line
      : document.querySelector(shouldScroll.selector);

    if (el) {
      var offset =
        shouldScroll.offset && typeof shouldScroll.offset === 'object'
          ? shouldScroll.offset
          : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState =
  inBrowser &&
  (function () {
    var ua = window.navigator.userAgent;

    if (
      (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
      ua.indexOf('Mobile Safari') !== -1 &&
      ua.indexOf('Chrome') === -1 &&
      ua.indexOf('Windows Phone') === -1
    ) {
      return false
    }

    return window.history && 'pushState' in window.history
  })();

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: getStateKey() }, '', url);
    } else {
      history.pushState({ key: setStateKey(genStateKey()) }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

var NavigationDuplicated = /*@__PURE__*/(function (Error) {
  function NavigationDuplicated (normalizedLocation) {
    Error.call(this);
    this.name = this._name = 'NavigationDuplicated';
    // passing the message to super() doesn't seem to work in the transpiled version
    this.message = "Navigating to current location (\"" + (normalizedLocation.fullPath) + "\") is not allowed";
    // add a stack property so services like Sentry can correctly display it
    Object.defineProperty(this, 'stack', {
      value: new Error().stack,
      writable: true,
      configurable: true
    });
    // we could also have used
    // Error.captureStackTrace(this, this.constructor)
    // but it only exists on node and chrome
  }

  if ( Error ) NavigationDuplicated.__proto__ = Error;
  NavigationDuplicated.prototype = Object.create( Error && Error.prototype );
  NavigationDuplicated.prototype.constructor = NavigationDuplicated;

  return NavigationDuplicated;
}(Error));

// support IE9
NavigationDuplicated._name = 'NavigationDuplicated';

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (
  location,
  onComplete,
  onAbort
) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(
    route,
    function () {
      this$1.updateRoute(route);
      onComplete && onComplete(route);
      this$1.ensureURL();

      // fire ready cbs once
      if (!this$1.ready) {
        this$1.ready = true;
        this$1.readyCbs.forEach(function (cb) {
          cb(route);
        });
      }
    },
    function (err) {
      if (onAbort) {
        onAbort(err);
      }
      if (err && !this$1.ready) {
        this$1.ready = true;
        this$1.readyErrorCbs.forEach(function (cb) {
          cb(err);
        });
      }
    }
  );
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    // after merging https://github.com/vuejs/vue-router/pull/2771 we
    // When the user navigates through history through back/forward buttons
    // we do not want to throw the error. We only throw it if directly calling
    // push/replace. That's why it's not included in isError
    if (!isExtendedError(NavigationDuplicated, err) && isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) {
          cb(err);
        });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort(new NavigationDuplicated(route))
  }

  var ref = resolveQueue(
    this.current.matched,
    route.matched
  );
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' &&
            (typeof to.path === 'string' || typeof to.name === 'string'))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) {
            cb();
          });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(
    activated,
    'beforeRouteEnter',
    function (guard, _, match, key) {
      return bindEnterGuard(guard, match, key, cbs, isValid)
    }
  )
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
      next(cb);
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (
    instances[key] &&
    !instances[key]._isBeingDestroyed // do not reuse being destroyed instance
  ) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */

var HTML5History = /*@__PURE__*/(function (History) {
  function HTML5History (router, base) {
    var this$1 = this;

    History.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (supportsScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History ) HTML5History.__proto__ = History;
  HTML5History.prototype = Object.create( History && History.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = decodeURI(window.location.pathname);
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */

var HashHistory = /*@__PURE__*/(function (History) {
  function HashHistory (router, base, fallback) {
    History.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History ) HashHistory.__proto__ = History;
  HashHistory.prototype = Object.create( History && History.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(
      supportsPushState ? 'popstate' : 'hashchange',
      function () {
        var current = this$1.current;
        if (!ensureSlash()) {
          return
        }
        this$1.transitionTo(getHash(), function (route) {
          if (supportsScroll) {
            handleScroll(this$1.router, route, current, true);
          }
          if (!supportsPushState) {
            replaceHash(route.fullPath);
          }
        });
      }
    );
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(
      location,
      function (route) {
        pushHash(route.fullPath);
        handleScroll(this$1.router, route, fromRoute, false);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(
      location,
      function (route) {
        replaceHash(route.fullPath);
        handleScroll(this$1.router, route, fromRoute, false);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(cleanPath(base + '/#' + location));
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  // empty path
  if (index < 0) { return '' }

  href = href.slice(index + 1);
  // decode the hash but not the search or hash
  // as search(query) is already decoded
  // https://github.com/vuejs/vue-router/issues/2708
  var searchIndex = href.indexOf('?');
  if (searchIndex < 0) {
    var hashIndex = href.indexOf('#');
    if (hashIndex > -1) {
      href = decodeURI(href.slice(0, hashIndex)) + href.slice(hashIndex);
    } else { href = decodeURI(href); }
  } else {
    if (searchIndex > -1) {
      href = decodeURI(href.slice(0, searchIndex)) + href.slice(searchIndex);
    }
  }

  return href
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */

var AbstractHistory = /*@__PURE__*/(function (History) {
  function AbstractHistory (router, base) {
    History.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History ) AbstractHistory.__proto__ = History;
  AbstractHistory.prototype = Object.create( History && History.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(
      location,
      function (route) {
        this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
        this$1.index++;
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(
      location,
      function (route) {
        this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(
      route,
      function () {
        this$1.index = targetIndex;
        this$1.updateRoute(route);
      },
      function (err) {
        if (isExtendedError(NavigationDuplicated, err)) {
          this$1.index = targetIndex;
        }
      }
    );
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */



var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // set up app destroyed handler
  // https://github.com/vuejs/vue-router/issues/2639
  app.$once('hook:destroyed', function () {
    // clean out app from this.apps array once destroyed
    var index = this$1.apps.indexOf(app);
    if (index > -1) { this$1.apps.splice(index, 1); }
    // ensure we still have a main app or null if no apps
    // we do not release the router so it can be reused
    if (this$1.app === app) { this$1.app = this$1.apps[0] || null; }
  });

  // main app previously initialized
  // return as we don't need to set up new history listener
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1.history.push(location, resolve, reject);
    })
  } else {
    this.history.push(location, onComplete, onAbort);
  }
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1.history.replace(location, resolve, reject);
    })
  } else {
    this.history.replace(location, onComplete, onAbort);
  }
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  current = current || this.history.current;
  var location = normalizeLocation(
    to,
    current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '3.1.3';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return routes; });
var customerChild = [{
    path: '',
    component: function component() {
        return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 543));
    },
    name: 'customer',
    meta: {
        title: 'Home Page - Example App'
    }
}, {
    path: 'createcustomer',
    component: function component() {
        return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 544));
    },
    name: 'createcustomer'
}, {
    path: 'ticket',
    component: function component() {
        return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 545));
    },
    name: 'ticket',
    meta: {
        title: 'Home Page - Example App'
    }
}, {
    path: 'refund',
    component: function component() {
        return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 546));
    },
    name: 'refund'
}, {
    path: 'customerSelection',
    component: function component() {
        return __webpack_require__.e/* import() */(77).then(__webpack_require__.bind(null, 547));
    },
    name: 'customerSelection'
}, {
    path: 'proformainvoice',
    component: function component() {
        return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 548));
    },
    name: 'proformainvoice'
}, {
    path: 'subscriberlist',
    component: function component() {
        return __webpack_require__.e/* import() */(74).then(__webpack_require__.bind(null, 549));
    },
    name: 'subscriberlist'
}, {
    path: 'history',
    component: function component() {
        return __webpack_require__.e/* import() */(76).then(__webpack_require__.bind(null, 550));
    },
    name: 'history'
}];
var deviceChild = [{
    path: '',
    component: function component() {
        return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 551));
    },
    name: 'device'
}, {
    path: 'retrack-deactive',
    component: function component() {
        return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 552));
    },
    name: 'retrack-deactive'
}, {
    path: 'replacement',
    component: function component() {
        return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 553));
    },
    name: 'replacement'
}, {
    path: 'osd',
    component: function component() {
        return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 554));
    },
    name: 'osd'
}, {
    path: 'purchasestb',
    component: function component() {
        return __webpack_require__.e/* import() */(71).then(__webpack_require__.bind(null, 555));
    },
    name: 'purchasestb'
}, {
    path: 'andriodrequest',
    component: function component() {
        return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 556));
    },
    name: 'andriodrequest'
}, {
    path: 'sms',
    component: function component() {
        return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 557));
    },
    name: 'sms'
}, {
    path: 'stbreturn',
    component: function component() {
        return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 558));
    },
    name: 'stbreturn'
}, {
    path: 'trackstb',
    component: function component() {
        return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 559));
    },
    name: 'trackstb'
}, {
    path: 'statusreport',
    component: function component() {
        return __webpack_require__.e/* import() */(72).then(__webpack_require__.bind(null, 560));
    },
    name: 'statusreport'
}];
var productChild = [{
    path: '',
    component: function component() {
        return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 535));
    },
    name: 'product'
}, {
    path: 'renew',
    component: function component() {
        return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 536));
    },
    name: 'renew'
}, {
    path: 'modify',
    component: function component() {
        return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 537));
    },
    name: 'modify'
}, {
    path: 'planmaster',
    component: function component() {
        return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 561));
    },
    name: 'planmaster'
}, {
    path: 'knowyourpacks',
    component: function component() {
        return __webpack_require__.e/* import() */(63).then(__webpack_require__.bind(null, 562));
    },
    name: 'knowyourpacks'
}, {
    path: 'discontinuedpacks',
    component: function component() {
        return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 563));
    },
    name: 'discontinuedpacks'
}, {
    path: 'onedigitalpacks',
    component: function component() {
        return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 564));
    },
    name: 'onedigitalpacks'
}, {
    path: 'singleactivation',
    component: function component() {
        return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 538));
    },
    name: 'singleactivation'
}, {
    path: 'combopacks',
    component: function component() {
        return __webpack_require__.e/* import() */(64).then(__webpack_require__.bind(null, 565));
    },
    name: 'combopacks'
}, {
    path: 'bulkcomboactivation',
    component: function component() {
        return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 566));
    },
    name: 'bulkcomboactivation'
}];
var reportChild = [{
    path: '',
    component: function component() {
        return __webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, 534));
    },
    name: 'report'
}, {
    path: 'expiry',
    component: function component() {
        return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, 567));
    },
    name: 'reportExpiry'
}, {
    path: 'expired',
    component: function component() {
        return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, 568));
    },
    name: 'reportExpired'
}, {
    path: 'jobmonitor',
    component: function component() {
        return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 569));
    },
    name: 'reportJobMonitor'
}, {
    path: 'bills',
    component: function component() {
        return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, 570));
    },
    name: 'reportBills'
}, {
    path: 'refund',
    component: function component() {
        return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 571));
    },
    name: 'reportRefund'
}, {
    path: 'stbreplacement',
    component: function component() {
        return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 572));
    },
    name: 'reportStbreplacement'
}, {
    path: 'ekyc',
    component: function component() {
        return __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, 573));
    },
    name: 'reportEKYC'
}, {
    path: 'schedule/:id',
    component: function component() {
        return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 574));
    },
    name: 'reportSchedule'
}, {
    path: 'payment',
    component: function component() {
        return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 575));
    },
    name: 'reportPayment'
}, {
    path: 'modifiedCustomer',
    component: function component() {
        return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 576));
    },
    name: 'reportModifiedCustomer'
}, {
    path: 'accountstatement',
    component: function component() {
        return __webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, 577));
    },
    name: 'reportaccountstatement'
}, {
    path: 'channellineupgen1',
    component: function component() {
        return __webpack_require__.e/* import() */(82).then(__webpack_require__.bind(null, 578));
    },
    name: 'channellineupgen1'
}, {
    path: 'channellineupgen2',
    component: function component() {
        return __webpack_require__.e/* import() */(81).then(__webpack_require__.bind(null, 579));
    },
    name: 'channellineupgen2'
}, {
    path: 'walletdebit',
    component: function component() {
        return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, 580));
    },
    name: 'walletdebit'
}, {
    path: 'consolidatedreport',
    component: function component() {
        return __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, 581));
    },
    name: 'consolidatedreport'
}, {
    path: 'dcrefund',
    component: function component() {
        return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, 582));
    },
    name: 'dcrefund'
}];

var menuChildren = [{
    path: '',
    component: function component() {
        return __webpack_require__.e/* import() */(73).then(__webpack_require__.bind(null, 583));
    },
    name: 'dashboard'
}, {
    path: 'alert',
    component: function component() {
        return __webpack_require__.e/* import() */(79).then(__webpack_require__.bind(null, 584));
    },
    name: 'alert'
}, {
    path: 'bigbonanza',
    component: function component() {
        return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 585));
    },
    name: 'bigbonanza'
}, {
    path: 'bigbonanzalocation',
    component: function component() {
        return __webpack_require__.e/* import() */(4/* duplicate */).then(__webpack_require__.bind(null, 541));
    },
    name: 'bigbonanzalocation'
}, {
    path: 'quiz',
    component: function component() {
        return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 586));
    },
    name: 'quiz'
}, {
    path: 'thankyou',
    component: function component() {
        return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 587));
    },
    name: 'thankyou'
}, {
    path: 'device',
    component: function component() {
        return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 588));
    },
    children: deviceChild
}, {
    path: 'customer',
    component: function component() {
        return __webpack_require__.e/* import() */(78).then(__webpack_require__.bind(null, 589));
    },
    children: customerChild
}, {
    path: 'download',
    component: function component() {
        return __webpack_require__.e/* import() */(70).then(__webpack_require__.bind(null, 590));
    },
    name: 'download'
}, {
    path: 'report',
    component: function component() {
        return __webpack_require__.e/* import() */(62).then(__webpack_require__.bind(null, 591));
    },
    children: reportChild
}, {
    path: 'product',
    component: function component() {
        return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 592));
    },
    children: productChild
}, {
    path: 'checkout',
    component: function component() {
        return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 539));
    },
    name: 'checkout'
}, {
    path: 'generatenewinvoice',
    component: function component() {
        return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 593));
    },
    name: 'generatenewinvoice'
}, {
    path: 'invoicecheckout',
    component: function component() {
        return __webpack_require__.e/* import() */(75).then(__webpack_require__.bind(null, 594));
    },
    name: 'invoicecheckout'
}, {
    path: 'topup',
    component: function component() {
        return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 595));
    },
    name: 'topup'
}, {
    path: 'subuser',
    component: function component() {
        return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 596));
    },
    name: 'subuser'
}, {
    path: 'subscribeddetails',
    component: function component() {
        return __webpack_require__.e/* import() */(3/* duplicate */).then(__webpack_require__.bind(null, 540));
    },
    name: 'subuscribeddetails'
}, {
    path: '/helpvideos',
    component: function component() {
        return __webpack_require__.e/* import() */(66).then(__webpack_require__.bind(null, 597));
    },
    name: 'helpvideos'
}, {
    path: '/videoplayer',
    component: function component() {
        return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 598));
    },
    name: 'videoplayer'
}, {
    path: '/mibnotfications',
    component: function component() {
        return __webpack_require__.e/* import() */(65).then(__webpack_require__.bind(null, 599));
    },
    name: 'mibnotfications'
}, {
    path: "/description",
    component: function component() {
        return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 542));
    },
    name: "description"
}];

var routes = [{
    path: '/',
    component: function component() {
        return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 600));
    },
    name: 'login'
}, {
    path: '/contactverify',
    component: function component() {
        return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 601));
    },
    name: 'contactverify'
}, {
    path: '/nrnverify',
    component: function component() {
        return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 602));
    },
    name: 'nrnverify'
}, {
    path: '/maintenance',
    component: function component() {
        return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 603));
    },
    name: 'maintenance'
}, {
    path: '/covid19awareness/',
    component: function component() {
        return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 604));
    },
    name: 'covid19awareness'
}, {
    path: '/covid19awareness/:id',
    component: function component() {
        return __webpack_require__.e/* import() */(80).then(__webpack_require__.bind(null, 605));
    },
    name: 'covid19awarenessid'
}, {
    path: '/maintenancelogin',
    component: function component() {
        return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 606));
    },
    name: 'maintenancelogin'
}, {
    path: '/register',
    component: function component() {
        return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 607));
    },
    name: 'register'
}, {
    path: '/changepassword',
    component: function component() {
        return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 608));
    },
    name: 'changepassword'
}, {
    path: '/lcoportal',
    component: function component() {
        return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 609));
    },
    children: menuChildren,
    name: 'home'
}, {
    path: '/support',
    component: function component() {
        return __webpack_require__.e/* import() */(67).then(__webpack_require__.bind(null, 610));
    },
    name: 'support'
}, {
    path: '/helpcenter',
    component: function component() {
        return __webpack_require__.e/* import() */(69).then(__webpack_require__.bind(null, 611));
    },
    name: 'helpcenter'
}, {
    path: '/privacy',
    component: function component() {
        return __webpack_require__.e/* import() */(68).then(__webpack_require__.bind(null, 612));
    },
    name: 'privacy'
}, {
    path: '/termsandconditions',
    component: function component() {
        return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 613));
    },
    name: 'termsandconditions'
}, {
    path: '/paymentstatuscheck',
    component: function component() {
        return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 614));
    },
    name: 'paymentstatuscheck'
}, {
    path: '/paymentconfirm/:id',
    component: function component() {
        return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 615));
    },
    name: 'paymentconfirm'
}, {
    path: '/supportlogin',
    component: function component() {
        return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 616));
    },
    name: 'supportlogin'
}];

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "baseUrl", function() { return baseUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMode", function() { return getMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserInfo", function() { return getUserInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSubuserInfo", function() { return getSubuserInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getItemsInfoCart", function() { return getItemsInfoCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCustomerNo", function() { return getCustomerNo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPageName", function() { return getPageName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAutoRenewItem", function() { return getAutoRenewItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSubscriberDetails", function() { return getSubscriberDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getItemsCheckoutCart", function() { return getItemsCheckoutCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSideNavInfo", function() { return getSideNavInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getReportQueueing", function() { return getReportQueueing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInvoiceCartDetails", function() { return getInvoiceCartDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getsideNav", function() { return getsideNav; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCustomerEnterId", function() { return getCustomerEnterId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPlanListingData", function() { return getPlanListingData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "firebaseUrl", function() { return firebaseUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUniqueCustomerId", function() { return getUniqueCustomerId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getShowAllModule", function() { return getShowAllModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "portalCode", function() { return portalCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOTTVerifiedUsers", function() { return getOTTVerifiedUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getChangeBasePackDetails", function() { return getChangeBasePackDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getChangeValidityPackDetails", function() { return getChangeValidityPackDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSMSTemplates", function() { return getSMSTemplates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getVerifiedBroadbandCustomer", function() { return getVerifiedBroadbandCustomer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSiteKey", function() { return getSiteKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCryptoSecretKey", function() { return getCryptoSecretKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCryptoIVKey", function() { return getCryptoIVKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getWhatsappURL", function() { return getWhatsappURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUniqueNewCustomerId", function() { return getUniqueNewCustomerId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRenewTypeDashboard", function() { return getRenewTypeDashboard; });
var baseUrl = function baseUrl(state) {
    return state.baseUrl;
};
var getMode = function getMode(state) {
    return state.mode;
};
var getUserInfo = function getUserInfo(state) {
    return state.userInfo;
};
var getSubuserInfo = function getSubuserInfo(state) {
    return state.subuserInfo;
};
var getItemsInfoCart = function getItemsInfoCart(state) {
    return state.getCartDetails;
};
var getCustomerNo = function getCustomerNo(state) {
    return state.getCustomerNumber;
};
var getPageName = function getPageName(state) {
    return state.pageNameProduct;
};
var getAutoRenewItem = function getAutoRenewItem(state) {
    return state.AutoRenewItem;
};
var getSubscriberDetails = function getSubscriberDetails(state) {
    return state.SubscriberDetails;
};
var getItemsCheckoutCart = function getItemsCheckoutCart(state) {
    return state.getCheckoutDetails;
};
var getSideNavInfo = function getSideNavInfo(state) {
    return state.getSideNavInfoDetails;
};
var getReportQueueing = function getReportQueueing(state) {
    return state.ReportQueueing;
};
var getInvoiceCartDetails = function getInvoiceCartDetails(state) {
    return state.invoiceCartDetails;
};
var getsideNav = function getsideNav(state) {
    return state.sideNav;
};
var getCustomerEnterId = function getCustomerEnterId(state) {
    return state.customerEnteredId;
};
var getPlanListingData = function getPlanListingData(state) {
    return state.planListingData;
};
var firebaseUrl = function firebaseUrl(state) {
    return state.firebaseUrl;
};
var getUniqueCustomerId = function getUniqueCustomerId(state) {
    return state.uniqueCustomerId;
};
var getShowAllModule = function getShowAllModule(state) {
    return state.showAllModule;
};
var portalCode = function portalCode(state) {
    return state.portalCode;
};
var getOTTVerifiedUsers = function getOTTVerifiedUsers(state) {
    return state.ottVerifiedUsers;
};
var getChangeBasePackDetails = function getChangeBasePackDetails(state) {
    return state.changeBasePack;
};
var getChangeValidityPackDetails = function getChangeValidityPackDetails(state) {
    return state.changeValidity;
};
var getSMSTemplates = function getSMSTemplates(state) {
    return state.SMSTemplates;
};
var getVerifiedBroadbandCustomer = function getVerifiedBroadbandCustomer(state) {
    return state.verifiedBroadbandCustomer;
};
var getSiteKey = function getSiteKey(state) {
    return state.sitekey;
};
var getCryptoSecretKey = function getCryptoSecretKey(state) {
    return state.cryptoSecretKey;
};
var getCryptoIVKey = function getCryptoIVKey(state) {
    return state.cryptoIVKey;
};
var getWhatsappURL = function getWhatsappURL(state) {
    return state.whatsappURL;
};
var getUniqueNewCustomerId = function getUniqueNewCustomerId(state) {
    return state.uniqueNewCustomerId;
};
var getRenewTypeDashboard = function getRenewTypeDashboard(state) {
    return state.renewTypeDashboard;
};

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setNavMenus", function() { return setNavMenus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setUserInfo", function() { return setUserInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSubuserInfo", function() { return setSubuserInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setItemsInfoCart", function() { return setItemsInfoCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCustomerNo", function() { return setCustomerNo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPageName", function() { return setPageName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setAutoRenewItem", function() { return setAutoRenewItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSubscriberDetails", function() { return setSubscriberDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setItemsCheckoutCart", function() { return setItemsCheckoutCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSideNavInfo", function() { return setSideNavInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setReportQueueing", function() { return setReportQueueing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setInvoiceCartDetails", function() { return setInvoiceCartDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSideNav", function() { return setSideNav; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCustomerEnterId", function() { return setCustomerEnterId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setUniqueCustomerId", function() { return setUniqueCustomerId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setShowAllModule", function() { return setShowAllModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setOTTVerifiedUsers", function() { return setOTTVerifiedUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setChangeBasePackDetails", function() { return setChangeBasePackDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setChangeValidityPackDetails", function() { return setChangeValidityPackDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSmsTemplate", function() { return setSmsTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setVerifiedBroadbandCustomer", function() { return setVerifiedBroadbandCustomer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSiteKey", function() { return setSiteKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setUniqueNewCustomerId", function() { return setUniqueNewCustomerId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setRenewTypeDashboard", function() { return setRenewTypeDashboard; });
var setNavMenus = function setNavMenus(state, version) {
    state.setAppVersionName = version;
};
var setUserInfo = function setUserInfo(state, data) {
    state.userInfo = data;
};
var setSubuserInfo = function setSubuserInfo(state, data) {
    state.subuserInfo = data;
};
var setItemsInfoCart = function setItemsInfoCart(state, data) {
    state.getCartDetails = data;
};
var setCustomerNo = function setCustomerNo(state, data) {
    state.getCustomerNumber = data;
};
var setPageName = function setPageName(state, data) {
    state.pageNameProduct = data;
};
var setAutoRenewItem = function setAutoRenewItem(state, data) {
    state.AutoRenewItem = data;
};
var setSubscriberDetails = function setSubscriberDetails(state, data) {
    state.SubscriberDetails = data;
};
var setItemsCheckoutCart = function setItemsCheckoutCart(state, data) {
    state.getCheckoutDetails = data;
};
var setSideNavInfo = function setSideNavInfo(state, data) {
    state.getSideNavInfoDetails = data;
};
var setReportQueueing = function setReportQueueing(state, data) {
    state.ReportQueueing = data;
};
var setInvoiceCartDetails = function setInvoiceCartDetails(state, data) {
    state.invoiceCartDetails = data;
};
var setSideNav = function setSideNav(state, data) {
    state.sideNav = data;
};
var setCustomerEnterId = function setCustomerEnterId(state, data) {
    state.customerEnteredId = data;
};
var setUniqueCustomerId = function setUniqueCustomerId(state, data) {
    state.uniqueCustomerId = data;
};
var setShowAllModule = function setShowAllModule(state, data) {
    state.showAllModule = data;
};
var setOTTVerifiedUsers = function setOTTVerifiedUsers(state, data) {
    state.ottVerifiedUsers = data;
};
var setChangeBasePackDetails = function setChangeBasePackDetails(state, data) {
    state.changeBasePack = data;
};
var setChangeValidityPackDetails = function setChangeValidityPackDetails(state, data) {
    state.changeValidity = data;
};
var setSmsTemplate = function setSmsTemplate(state, data) {
    state.SMSTemplates = data;
};
var setVerifiedBroadbandCustomer = function setVerifiedBroadbandCustomer(state, data) {
    state.verifiedBroadbandCustomer = data;
};
var setSiteKey = function setSiteKey(state, data) {
    state.sitekey = data;
};
var setUniqueNewCustomerId = function setUniqueNewCustomerId(state, data) {
    state.uniqueNewCustomerId = data;
};
var setRenewTypeDashboard = function setRenewTypeDashboard(state, data) {
    state.renewTypeDashboard = data;
};

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actGetUserInfo", function() { return actGetUserInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(2);


var actGetUserInfo = function actGetUserInfo(context, payload) {
    return new Promise(function (resolve, reject) {
        var url = '';
        if (!payload) {
            url = '/lco/v1/lco.php';
        } else {
            url = '/lco/v1/subuser/' + payload.subuserid;
        }
        fetch(context.state.baseUrl + url).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
            return response.json();
        }).then(function (data) {
            resolve(data);
        }).catch(function (error) {
            reject(error);
        });
    });
};

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(2);



var state = {
    regSubData: undefined
};

var getters = {
    getRegSubData: function getRegSubData(state) {
        return state.regSubData;
    }
};

var mutations = {
    setRegSubData: function setRegSubData(state, data) {
        state.regSubData = data;
    }
};

var actions = {
    actGetlogin: function actGetlogin(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            var queryStr = '';
            queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(payload);

            fetch(context.getters.baseUrl + 'lco/v1/login.php' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {

                reject(error);
            });
        });
    },

    actregionRegister: function actregionRegister(context, payload) {
        return new Promise(function (resolve, reject) {
            fetch('https://iid.googleapis.com/iid/v1/' + payload.token + '/rel/topics/' + payload.region, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'key=AAAAxyanXP4:APA91bGKciVJii-BYh1OVNieNJ-JiqKI0S3btogVrqRxdxExZ0QmQzX7Yy1Nm_T_XrNcG_vKvk1dpNYhtKss4_FQew28htVCXBYna2qZ3NoFI0nQ8RES4xJTxfZa_t6IDqfDKDHc__VJ'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                if (context.getters.getMode == "development") {
                    resolve({ "lcoid": "h7juP6Xn", "lconame": "Thomas John", "frcode": "FR5125", "frcan": "20893551", "city": null, "region": "MUM", "country": "IN", "status": "ACTIVE", "mobileno": "7981891902", "contactname": "", "email": "harsha.arukala@gamil.com", "amount": "1675.42", "currency": "INR", "panno": "ACCPE3456", "dpid": "0roEv0l1", "connections": "0", "smstype": "SMS1", "quiz_complete": "NO", "lcoagreementtype": "NO", "lcoportalnumber": "THREE", "payment": "YES", "NCF": "ON" });
                }
                reject(error);
            });
        });
    },
    actGetSubuserlogin: function actGetSubuserlogin(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            var queryStr = '';
            queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(payload);

            fetch(context.getters.baseUrl + '/lco/v1/subuser/login' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    actGetfrcan: function actGetfrcan(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            var queryStr = '';
            queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(payload);

            fetch(context.getters.baseUrl + '/lco/v1/lco/frcan' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                if (context.getters.getMode == "development") {
                    resolve({ "success": "20893551", "type": "MOCA", "user": "LCO" });
                } else {
                    resolve(data);
                }
            }).catch(function (error) {
                if (context.getters.getMode == "development") {
                    resolve({ "success": "20893551", "type": "MOCA", "user": "LCO" });
                }
                reject(error);
            });
        });
    },
    actGetHeadend: function actGetHeadend(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            var queryStr = '';
            queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(payload);

            fetch(context.getters.baseUrl + '/lco/v1/lco/headend' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                if (context.getters.getMode == "development") {
                    resolve({ "headendid": "ADW", "headendname": "ANDHERI-W" });
                } else {
                    resolve(data);
                }
            }).catch(function (error) {
                if (context.getters.getMode == "development") {
                    resolve({ "headendid": "ADW", "headendname": "ANDHERI-W" });
                }
                reject(error);
            });
        });
    },
    actGetEmp: function actGetEmp(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            var queryStr = '';
            queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(payload);

            fetch(context.getters.baseUrl + '/lco/v1/lco/emp' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                if (context.getters.getMode == "development") {
                    resolve([{ "employee": "AVINASH TATE", "employeename": "AVINASH TATE" }]);
                } else {
                    resolve(data);
                }
            }).catch(function (error) {
                if (context.getters.getMode == "development") {
                    resolve([{ "employee": "AVINASH TATE", "employeename": "AVINASH TATE" }]);
                }
                reject(error);
            });
        });
    },
    actRegister: function actRegister(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);
            fetch(context.getters.baseUrl + '/lco/v1/account.php', {
                method: 'POST',
                body: data
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    actGetForgetPassword: function actGetForgetPassword(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            var queryStr = '';
            queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(payload);

            fetch(context.getters.baseUrl + '/lco/v1/passwordreset.php' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    actGetAdvt: function actGetAdvt(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            // let dataObj = {};
            var queryStr = '';
            // dataObj = {
            //     'adtype' : payload.adtype
            // }
            queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(payload);
            fetch(context.getters.baseUrl + '/lco/v1/banner' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                if (context.getters.getMode == "development") {
                    resolve([{
                        "promoadsid": "4",
                        "filename": "IlXPqBPk.jpg",
                        "adtype": "AD",
                        "weight": "1",
                        "adstatus": "ACTIVE",
                        "created": "2019-10-15 11:05:37",
                        "url": "https://s3.ap-south-1.amazonaws.com/com.kyc.dpcollection.incablenet.mum/images/promo/IlXPqBPk.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAI4W3T6IPZZE7ILKA%2F20191018%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20191018T073530Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=71ec1f05f73bba83a2838784913c2c40841df55c3ac276af9472f0dab24bb27c"
                    }, {
                        "promoadsid": "3",
                        "filename": "IlXPqBPk.jpg",
                        "adtype": "AD",
                        "weight": "1",
                        "adstatus": "ACTIVE",
                        "created": "2019-10-15 10:58:40",
                        "url": "https://s3.ap-south-1.amazonaws.com/com.kyc.dpcollection.incablenet.mum/images/promo/IlXPqBPk.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAI4W3T6IPZZE7ILKA%2F20191018%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20191018T073530Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=71ec1f05f73bba83a2838784913c2c40841df55c3ac276af9472f0dab24bb27c"
                    }]);
                } else {
                    resolve(data);
                }
            }).catch(function (error) {
                if (context.getters.getMode == "development") {

                    resolve([{
                        "promoadsid": "4",
                        "filename": "IlXPqBPk.jpg",
                        "adtype": "AD",
                        "weight": "1",
                        "adstatus": "ACTIVE",
                        "created": "2019-10-15 11:05:37",
                        "url": "https://s3.ap-south-1.amazonaws.com/com.kyc.dpcollection.incablenet.mum/images/promo/IlXPqBPk.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAI4W3T6IPZZE7ILKA%2F20191018%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20191018T073530Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=71ec1f05f73bba83a2838784913c2c40841df55c3ac276af9472f0dab24bb27c"
                    }, {
                        "promoadsid": "3",
                        "filename": "IlXPqBPk.jpg",
                        "adtype": "AD",
                        "weight": "1",
                        "adstatus": "ACTIVE",
                        "created": "2019-10-15 10:58:40",
                        "url": "https://s3.ap-south-1.amazonaws.com/com.kyc.dpcollection.incablenet.mum/images/promo/IlXPqBPk.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAI4W3T6IPZZE7ILKA%2F20191018%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20191018T073530Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=71ec1f05f73bba83a2838784913c2c40841df55c3ac276af9472f0dab24bb27c"
                    }]);
                }
                reject(error);
            });
        });
    },
    setUserAgreement: function setUserAgreement(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);
            fetch(context.getters.baseUrl + '/lco/v1/lco/lcoagreement', {
                method: 'POST',
                body: data
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    checkPortalMaintenance: function checkPortalMaintenance(context, payload) {
        var queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(payload);
        return new Promise(function (resolve, reject) {
            fetch(context.getters.baseUrl + "/lco/v1/lco/maintenance" + queryStr, {
                method: "GET"
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                if (context.getters.getMode == "development") {
                    resolve({
                        "maintenance": "OFF",
                        "header": "Portal Maintenance",
                        "image": "https://png.pngtree.com/thumb_back/fw800/background/20190813/pngtree-happy-ganesh-chaturthi-vector-banner-background-design-with-golden-color-gradient-image_299194.jpg",
                        "content": "We clearly live in unprecedented times as Covid-19 is changing the world around us. Our thoughts and prayers are with everyone who is impacted. Now more than ever, we must come together as a community. With the uncertainty of the physical event happening this year, we decided to launch the first virtual event in response to the coronavirus lockdown. We would like to welcome you to Neotia Arts Trust’s new chapter — The India Story Continues… We will be hosting a Live web series of conversations, workshops, and performances from artists, designers, influencers, and many from all over India. Live events will be broadcasted every Saturday through the months of August, September, and October. It is complimentary and open to all and will be available on all our platforms — Youtube, Facebook, & our website. We are excited to continue creating, sharing, and learning with you all.",
                        "style": ""
                    });
                    return;
                } else {
                    resolve(data);
                }
            }).catch(function (error) {
                if (context.getters.getMode == "development") {
                    resolve({
                        "maintenance": "OFF",
                        "redirect": "https://lcoportalv2.incablenet.net/",
                        "header": "Portal Maintenance",
                        "image": "https://png.pngtree.com/thumb_back/fw800/background/20190813/pngtree-happy-ganesh-chaturthi-vector-banner-background-design-with-golden-color-gradient-image_299194.jpg",
                        "content": "We clearly live in unprecedented times as Covid-19 is changing the world around us. Our thoughts and prayers are with everyone who is impacted. Now more than ever, we must come together as a community. With the uncertainty of the physical event happening this year, we decided to launch the first virtual event in response to the coronavirus lockdown. We would like to welcome you to Neotia Arts Trust’s new chapter — The India Story Continues… We will be hosting a Live web series of conversations, workshops, and performances from artists, designers, influencers, and many from all over India. Live events will be broadcasted every Saturday through the months of August, September, and October. It is complimentary and open to all and will be available on all our platforms — Youtube, Facebook, & our website. We are excited to continue creating, sharing, and learning with you all.",
                        "style": ""
                    });
                    return;
                }
                reject(error);
            });
        });
    },

    setSignalBreakNotice: function setSignalBreakNotice(context, payload) {
        console.log("Payload -> ", payload);
        var data = {
            updatesignalmessage: payload.updatesignalmessage,
            seen_by_lco: payload.seen_by_lco
        };
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            fetch(context.getters.baseUrl + '/lco/v1/lco/' + payload.id_message, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                if (context.getters.getMode == "development") {
                    console("Signal Update");
                    resolve({ "updated_count": 1 });
                } else {
                    resolve(data);
                    console.log("Singal response->", data);
                }
            }).catch(function (error) {
                if (context.getters.getMode == "development") {
                    resolve({ "updated_count": 1 });
                    console.log("Singal Error->");
                } else {
                    reject(error);
                }
            });
        });
    },
    actChangePassword: function actChangePassword(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            fetch(context.getters.baseUrl + 'lco/v1/changepassword', {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state, getters: getters, mutations: mutations, actions: actions
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(2);



var state = {
    profileData: undefined
};

var getters = {
    getprofileData: function getprofileData(state) {
        return state.profileData;
    }
};

var mutations = {
    setprofileData: function setprofileData(state, data) {
        state.profileData = data;
    }
};

var actions = {
    actCreatePayment: function actCreatePayment(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            console.log(payload);
            var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);
            fetch(context.getters.baseUrl + '/lco/v1/payment.php', {
                method: 'POST',
                body: data
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {

                resolve(data);
            }).catch(function (error) {

                reject(error);
            });
        });
    },
    actPayMobikwik: function actPayMobikwik(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            console.log(payload);
            var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);
            fetch(context.getters.baseUrl + '/lco/v1/payment/wallet', {
                method: 'POST',
                body: data
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {

                resolve(data);
            }).catch(function (error) {

                console.log("error", error);
                reject(error);
            });
        });
    },
    actPutProfileUpdate: function actPutProfileUpdate(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }

            console.log("payload ", payload);
            var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);
            var object = {};
            data.forEach(function (value, key) {
                object[key] = value;
            });
            data = JSON.stringify(object);

            console.log("data || before send ", data);
            fetch(context.getters.baseUrl + '/lco/v1/lco', {
                method: 'PUT',
                body: data
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                console.log("data", data);

                resolve(data);
            }).catch(function (error) {
                console.log("error", error);
                reject(error);
            });
        });
    },
    actPutSubuserProfileUpdate: function actPutSubuserProfileUpdate(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }

            console.log("payload ", payload);
            var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);

            var object = {};
            data.forEach(function (value, key) {
                object[key] = value;
            });
            data = JSON.stringify(object);

            console.log("data || before send ", data);
            fetch(context.getters.baseUrl + '/lco/v1/subuser/' + payload.subuserid, {
                method: 'PUT',
                body: data
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                console.log("data", data);

                resolve(data);
            }).catch(function (error) {
                console.log("error", error);
                reject(error);
            });
        });
    },
    actGetlogout: function actGetlogout(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }

            fetch(context.getters.baseUrl + '/lco/v1/logout.php/' + payload.lcoid, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    actGetSubuserlogout: function actGetSubuserlogout(context, payload) {
        return new Promise(function (resolve, reject) {
            fetch(context.getters.baseUrl + '/lco/v1/subuser/logout', {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    actGetPayments: function actGetPayments(context, payload) {
        return new Promise(function (resolve, reject) {
            var queryStr = '';
            queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(payload);
            fetch(context.getters.baseUrl + '/lco/v1/lco/payments' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {

                resolve(data);
            }).catch(function (error) {

                reject(error);
            });
        });
    },
    actGetLastSubuserId: function actGetLastSubuserId(context, payload) {
        return new Promise(function (resolve, reject) {
            fetch(context.getters.baseUrl + '/lco/v1/subuser/lastid', {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    actGetSubusers: function actGetSubusers(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            var queryStr = '';
            queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(payload);

            fetch(context.getters.baseUrl + '/lco/v1/subuser' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {

                resolve(data);
            }).catch(function (error) {

                reject(error);
            });
        });
    },
    actGetSingleSubuser: function actGetSingleSubuser(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            fetch(context.getters.baseUrl + '/lco/v1/subuser/' + payload, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {

                resolve(data);
            }).catch(function (error) {

                reject(error);
            });
        });
    },
    actPostSubuser: function actPostSubuser(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            console.log(payload);
            var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);
            fetch(context.getters.baseUrl + '/lco/v1/subuser', {
                method: 'POST',
                body: data
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {

                resolve(data);
            }).catch(function (error) {
                console.log("error", error);
                reject(error);
            });
        });
    },
    actPutSubuser: function actPutSubuser(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            console.log(payload);
            var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);

            var object = {};
            data.forEach(function (value, key) {
                object[key] = value;
            });
            data = JSON.stringify(object);
            fetch(context.getters.baseUrl + '/lco/v1/subuser/' + payload.lcosubuserid, {
                method: 'PUT',
                body: data
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {

                resolve(data);
            }).catch(function (error) {
                console.log("error", error);
                reject(error);
            });
        });
    },
    getPaymentStatus: function getPaymentStatus(context, dataObj) {
        return new Promise(function (resolve, reject) {
            var queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(dataObj);
            console.log(queryStr);
            fetch(context.getters.baseUrl + '/lco/v1/paymentstatuscheckapi' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    verifyContact: function verifyContact(context, payload) {
        return new Promise(function (resolve, reject) {
            var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);
            fetch(context.getters.baseUrl + '/lco/v1/lco/verifycontact', {
                method: 'POST',
                body: data
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    verifyUserContactOTP: function verifyUserContactOTP(context, payload) {
        return new Promise(function (resolve, reject) {
            var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);
            fetch(context.getters.baseUrl + '/lco/v1/lco/validateotp', {
                method: 'POST',
                body: data
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state, getters: getters, mutations: mutations, actions: actions
});

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(2);


var state = {
    graphsData: undefined,
    lowerGraphsData: undefined
};

var getters = {
    getgraphsData: function getgraphsData(state) {
        return state.graphsData;
    },
    getlowerGraphsData: function getlowerGraphsData(state) {
        console.log("getters ", state);
        return state.lowerGraphsData;
    }
};

var mutations = {
    setgraphsData: function setgraphsData(state, data) {
        console.log("mutation ", data);
        state.graphsData = data;
    },
    setlowerGraphsData: function setlowerGraphsData(state, data) {
        state.lowerGraphsData = data;
    }
};

var actions = {
    getMqStat: function getMqStat(context, payload) {
        return new Promise(function (resolve, reject) {
            // let graphData = JSON.parse(localStorage.getItem('mqstats'))
            // if (graphData) {
            //     if (Object.keys(graphData).length) {
            //     resolve(graphData)
            //     return
            //     }
            // }
            var queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(payload);
            fetch(context.getters.baseUrl + '/lco/v1/stat/mqstats' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                localStorage.setItem("mqstats", JSON.stringify(data));
                resolve(data);
                //type CLK DLK
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    getCredit: function getCredit(context, payload) {
        return new Promise(function (resolve, reject) {
            // let graphData = JSON.parse(localStorage.getItem('credits'))
            // if (graphData) {
            //     if (Object.keys(graphData).length) {
            //     resolve(graphData)
            //     return
            //     }
            // }
            var queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(payload);
            // fetch(context.getters.baseUrl + '/lco/v1/stat/credits' + queryStr, {
            fetch(context.getters.baseUrl + '/lco/v1/stat/creditdetails', {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                localStorage.setItem("credits", JSON.stringify(data));
                resolve(data);
                //type CLK DLK
            }).catch(function (error) {
                if (context.getters.getMode == "development") {

                    resolve(
                    //     {
                    //     "total": 10479637.34,
                    //     "day": {
                    //         "PENDING": 10,
                    //         "PAID": 20,
                    //         "FAILED": 30
                    //     },
                    //     "oneweek": {
                    //         "PENDING": 0,
                    //         "PAID": "1",
                    //         "FAILED": 0
                    //     },
                    //     "twoweek": {
                    //         "PENDING": 0,
                    //         "PAID": "1",
                    //         "FAILED": 0
                    //     },
                    //     "month": {
                    //         "PENDING": "15",
                    //         "PAID": "5",
                    //         "FAILED": 0
                    //     }
                    // },
                    {
                        "today": [{
                            "type": "DCREFUND",
                            "totalamount": "50021.00"
                        }, {
                            "type": "CASHBACK",
                            "totalamount": null
                        }, {
                            "type": "TOPUP",
                            "totalamount": "21.00"
                        }],
                        "yesterday": [{
                            "type": "DCREFUND",
                            "totalamount": null
                        }, {
                            "type": "CASHBACK",
                            "totalamount": "11.4"
                        }, {
                            "type": "TOPUP",
                            "totalamount": "200.2"
                        }],
                        "week": [{
                            "type": "DCREFUND",
                            "totalamount": "2.61"
                        }, {
                            "type": "CASHBACK",
                            "totalamount": "1.00"
                        }, {
                            "type": "TOPUP",
                            "totalamount": "3.00"
                        }],
                        "month": [{
                            "type": "DCREFUND",
                            "totalamount": "2.61"
                        }, {
                            "type": "CASHBACK",
                            "totalamount": "11.00"
                        }, {
                            "type": "TOPUP",
                            "totalamount": "7.00"
                        }],
                        "totalcredit": [{
                            "amount": "7.00"
                        }],
                        "totalcashback": [{
                            "amount": "13.61"
                        }],
                        "totalamount": [{
                            "amount": "12806902.89"
                        }]
                    });
                }
                reject(error);
            });
        });
    },
    getRenew: function getRenew(context, payload) {
        return new Promise(function (resolve, reject) {
            // let graphData = JSON.parse(localStorage.getItem('mqexpiry'))
            // if (graphData) {
            //     if (Object.keys(graphData).length) {
            //     resolve(graphData)
            //     return
            //     }
            // }
            var queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(payload);
            fetch(context.getters.baseUrl + '/lco/v1/stat/expiry' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                localStorage.setItem("mqexpiry", JSON.stringify(data));
                resolve(data);
                //type CLK DLK
            }).catch(function (error) {

                reject(error);
            });
        });
    },
    getRevenues: function getRevenues(context, payload) {
        return new Promise(function (resolve, reject) {
            // let graphData = JSON.parse(localStorage.getItem('revenues'))
            // if (graphData) {
            //     if (Object.keys(graphData).length) {
            //     resolve(graphData)
            //     return
            //     }
            // }
            var queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(payload);
            fetch(context.getters.baseUrl + '/lco/v1/stat/revenues' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                localStorage.setItem("revenues", JSON.stringify(data));
                resolve(data);
                //type CLK DLK
            }).catch(function (error) {
                reject(error);
            });
        });
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state, getters: getters, mutations: mutations, actions: actions
});

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(2);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var state = {};
var getters = {};
var mutations = {};
var actions = {
  getAlertMessage: function getAlertMessage(context, dataObj) {
    return new Promise(function (resolve, reject) {
      if (dataObj.alerttype == 'ALERT') {
        var alertMessage = JSON.parse(localStorage.getItem('alertMessage'));
        if (alertMessage) {
          if (Object.keys(alertMessage).length) {
            resolve(alertMessage);
            return;
          }
        }
      } else if (dataObj.alerttype == 'OFFERS') {
        var alertOffer = JSON.parse(localStorage.getItem('alertOffer'));
        if (alertOffer) {
          if (Object.keys(alertOffer).length) {
            resolve(alertOffer);
            return;
          }
        }
      } else if (dataObj.alerttype == 'NXT_UDAAN') {
        var alertNXTUddan = JSON.parse(localStorage.getItem('alertNXTUddan'));
        if (alertNXTUddan) {
          if (Object.keys(alertNXTUddan).length) {
            resolve(alertNXTUddan);
            return;
          }
        }
      } else if (dataObj.alerttype == 'SUPER_ACHIEVERS_LCO') {
        var alertSAL = JSON.parse(localStorage.getItem('alertSAL'));
        if (alertSAL) {
          if (Object.keys(alertSAL).length) {
            resolve(alertSAL);
            return;
          }
        }
      }
      console.log(_typeof(dataObj.alerttype));
      var queryStr = '';
      queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(dataObj);
      fetch(context.getters.baseUrl + '/lco/v1/alertmessage.php' + queryStr, {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        // if (dataObj.alerttype == 'ALERT') {
        //   localStorage.setItem("alertMessage",JSON.stringify(data))
        // } else if (dataObj.alerttype == 'OFFERS') {
        //   localStorage.setItem("alertOffer",JSON.stringify(data))
        // } else if (dataObj.alerttype == 'NXT_UDAAN') {
        //   localStorage.setItem("alertNXTUddan",JSON.stringify(data))
        // } else if (dataObj.alerttype == 'SUPER_ACHIEVERS_LCO') {
        //   localStorage.setItem("alertSAL",JSON.stringify(data))
        // }
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getAlertData: function getAlertData(context) {
    return new Promise(function (resolve, reject) {
      fetch(context.getters.baseUrl + '/lco/v1/alertmessage.php', {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  headendLocation: function headendLocation(context) {
    return new Promise(function (resolve, reject) {
      fetch(context.getters.baseUrl + '/lco/v1/headend/locations', {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  headendLocationByName: function headendLocationByName(context, dataObj) {
    return new Promise(function (resolve, reject) {
      var queryStr = '';
      queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(dataObj);
      fetch(context.getters.baseUrl + '/lco/v1/headend' + queryStr, {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  unreadClickedData: function unreadClickedData(context, payload) {
    console.log(payload);
    return new Promise(function (resolve, reject) {
      localStorage.removeItem("alertMessage");
      localStorage.removeItem("alertOffer");
      localStorage.removeItem("alertNXTUddan");
      localStorage.removeItem("alertSAL");
      var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);
      console.log("API CALL");
      fetch(context.getters.baseUrl + '/lco/v1/alertmessage', {
        method: 'POST',
        body: data
      }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  quizQuestions: function quizQuestions(context) {
    return new Promise(function (resolve, reject) {
      fetch(context.getters.baseUrl + '/lco/v1/quiz/questions', {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        if (context.getters.getMode == "development") {
          resolve([{ "ans1": "Tele Regulatory Associations of India ", "ans2": "Telecom Regulatory Authority of India", "ans3": "Telecom Regulatory Association of India", "key": "A", "question": "What is the full form of TRAI?" }, { "ans1": "ONE Email", "ans2": "ONE Broadband ", "ans3": "ONE Network ", "key": "B", "question": "What is the Internet Service Provider<b> ONE<\/b>OTT <b>INTERTAINMENT LIMITED<\/b> also called? " }, { "ans1": "<b>IN<\/b>Digital  ", "ans2": "<b>NXT<\/b>DIGITAL Limited", "ans3": "In Cable ", "key": "C", "question": "What is IMCL called post de-merger? " }, { "ans1": "My <b>NXT<\/b>", "ans2": "My <b>NXT<\/b>DIGITAL", "ans3": "<b>NXT<\/b>DIGITAL SELFCARE", "key": "D", "question": "What is the name of the mobile app for <b>NXT<\/b>DIGITAL-HITS platform? " }, { "ans1": "ICICI ", "ans2": "HDFC", "ans3": "STATE BANK OF INDIA ", "key": "E", "question": "Which bank is now integrated with the <b>NXT<\/b>DIGITAL-HITS Portal for direct payment through NEFT\/RTGS\/IMPS? " }]);
          return;
        }
        reject(error);
      });
    });
  },
  submitAnswerDetails: function submitAnswerDetails(context, payload) {
    return new Promise(function (resolve, reject) {
      fetch(context.getters.baseUrl + '/lco/v1/quiz', {
        method: 'POST',
        body: payload
      }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state, getters: getters, mutations: mutations, actions: actions
});

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(2);


var state = {};

var getters = {};

var mutations = {};

var actions = {

    getCustCpe: function getCustCpe(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }

            var dataObj = {};
            var queryStr = '';
            dataObj = {
                'customerid': payload
            };
            queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(dataObj);

            fetch(context.getters.baseUrl + '/lco/v1/subscriber/cpe' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {

                resolve(data);
            }).catch(function (error) {

                reject(error);
            });
        });
    },
    getCustProfile: function getCustProfile(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }

            var dataObj = {};
            var queryStr = '';
            dataObj = {
                'customerid': payload
            };
            queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(dataObj);

            fetch(context.getters.baseUrl + '/lco/v1/subscriber/subscriberinfo' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    getCustServices: function getCustServices(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            var dataObj = {};
            var queryStr = '';
            dataObj = {
                'customerid': payload
            };
            queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(dataObj);
            fetch(context.getters.baseUrl + '/lco/v1/subscriber/services' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {

                resolve(data);
            }).catch(function (error) {
                console.log("not reached");
                reject(error);
            });
        });
    },
    getCustBill: function getCustBill(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }

            var dataObj = {};
            var queryStr = '';
            dataObj = {
                'customerid': payload
            };

            queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(dataObj);

            fetch(context.getters.baseUrl + '/lco/v1/subscriber/bill' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {

                resolve(data);
            }).catch(function (error) {

                console.log("not reached");
                reject(error);
            });
        });
    },
    actGetTicket: function actGetTicket(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            var queryStr = '';
            queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(payload);

            if (!queryStr) reject({ error: "query not found" });
            fetch(context.getters.baseUrl + '/lco/v1/ticket/mqticket' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {

                resolve(data);
            }).catch(function (error) {
                console.log("not reached");
                reject(error);
            });
        });
    },
    actCloseTicket: function actCloseTicket(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            var tickeid = payload.ticketid;
            delete payload.ticketid;

            var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);
            var object = {};
            data.forEach(function (value, key) {
                object[key] = value;
            });
            data = JSON.stringify(object);
            fetch(context.getters.baseUrl + '/lco/v1/ticket/' + tickeid, {
                method: 'PUT',
                body: data
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {

                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    actGetLcoDetail: function actGetLcoDetail(context) {
        return new Promise(function (resolve, reject) {
            fetch(context.getters.baseUrl + '/lco/v1/lco', {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {

                resolve(data);
            }).catch(function (error) {

                console.log("not reached");
                reject(error);
            });
        });
    },
    actPostRefund: function actPostRefund(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            fetch(context.getters.baseUrl + '/lco/v1/refund', {
                method: 'POST',
                body: payload
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {

                resolve(data);
            }).catch(function (error) {
                console.log("not reached");
                reject(error);
            });
        });
    },
    actFileUpload: function actFileUpload(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }

            var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);

            fetch(context.getters.baseUrl + '/lco/v1/fileupload', {
                method: 'POST',
                body: data
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    actModifyCustomer: function actModifyCustomer(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            console.log('data ', payload);
            var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);
            fetch(context.getters.baseUrl + '/lco/v1/subscriber/subscriber', {
                method: 'POST',
                body: data
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {

                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    actGetCategory: function actGetCategory(context) {
        return new Promise(function (resolve, reject) {
            fetch(context.getters.baseUrl + '/lco/v1/ticket/category', {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {

                resolve(data);
            }).catch(function (error) {

                reject(error);
            });
        });
    },
    actPostTicket: function actPostTicket(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            console.log('data ', payload);
            var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);

            fetch(context.getters.baseUrl + '/lco/v1/ticket', {
                method: 'POST',
                body: data
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {

                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    getCustomerSelection: function getCustomerSelection(context, payload) {
        var queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(payload);
        return new Promise(function (resolve, reject) {
            fetch(context.getters.baseUrl + '/lco/v1/customerorder/offerplans' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                if (context.getters.getMode == "development") {
                    resolve();
                } else {
                    resolve(data);
                }
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    addReportQueue: function addReportQueue(context, queueData) {
        return new Promise(function (resolve, reject) {
            fetch(context.getters.baseUrl + '/lco/v1/reports', {
                method: 'POST',
                body: queueData
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.text();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    getProformInvoice: function getProformInvoice(context, filterData) {
        return new Promise(function (resolve, reject) {
            var queryStr = '';
            queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(filterData);

            fetch(context.getters.baseUrl + '/lco/v1/invoice' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                if (context.getters.getMode == "development") {
                    resolve({
                        "count": "20",
                        "data": [{
                            "idproforma_invoice": "9",
                            "filename": "PRgHcWk1P0220219",
                            "dphid": "RgHcWk1P",
                            "created": "2021-02-09 18:34:20",
                            "modified": null
                        }, {
                            "idproforma_invoice": "8",
                            "filename": "PRgHcWk1P0220218",
                            "dphid": "RgHcWk1P",
                            "created": "2021-02-09 18:27:36",
                            "modified": null
                        }, {
                            "idproforma_invoice": "7",
                            "filename": "PRgHcWk1P0220217",
                            "dphid": "RgHcWk1P",
                            "created": "2021-02-09 18:07:32",
                            "modified": null
                        }]
                    });
                }
                reject(error);
            });
        });
    },
    downloadProformInvoice: function downloadProformInvoice(context, payload) {
        return new Promise(function (resolve, reject) {
            fetch(context.getters.baseUrl + '/lco/v1/invoice/' + payload, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                if (context.getters.getMode == "development") {
                    resolve('https://s3.ap-south-1.amazonaws.com/com.kyc.dpcollection.incablenet.mum/invoice/RgHcWk1P/PRgHcWk1P02202138.pdf?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAZTWJZDEUJKBH6SWE%2F20210211%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20210211T105430Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=b8f1248dde00eb9ea5b3f2dfd714cead0dd345bcf6a0196688eff9d858fe78f1');
                    return;
                }
                reject(error);
            });
        });
    },
    getInvoicePlans: function getInvoicePlans(context, payload) {
        var queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(payload);
        return new Promise(function (resolve, reject) {
            fetch(context.getters.baseUrl + '/lco/v1/plan.php' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                if (context.getters.getMode == "development") {
                    resolve([{ "planid": "JWtNA2Kf", "planname": "&FLIX", "plantype": "CHANNEL", "plancode": "ALA0001PP", "servicecode": "[\"ALA0001CS\"]", "packagecode": null, "description": "&flix", "lcoprice": "13.50", "mrptariff": "15.00", "tariffperiod": "1", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "0.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NCF", "numchannels": "1" }, { "planid": "n9lfJByC", "planname": "&PICTURES", "plantype": "CHANNEL", "plancode": "ALA0002PP", "servicecode": "[\"ALA0002CS\"]", "packagecode": null, "description": "&pictures", "lcoprice": "5.40", "mrptariff": "6.00", "tariffperiod": "1", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "0.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NCF", "numchannels": "1" }, { "planid": "HDwdYiuq", "planname": "&TV", "plantype": "CHANNEL", "plancode": "ALA0003PP", "servicecode": "[\"ALA0003CS\"]", "packagecode": null, "description": "&TV", "lcoprice": "10.80", "mrptariff": "12.00", "tariffperiod": "1", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "0.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NCF", "numchannels": "1" }, { "planid": "quiyzZ9Q", "planname": "1 SPORTS", "plantype": "CHANNEL", "plancode": "ALA0413PP", "servicecode": "[\"ALA0413CS\"]", "packagecode": "", "description": "1 Sports", "lcoprice": "3.60", "mrptariff": "4.00", "tariffperiod": "1", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "0.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NCF", "numchannels": "1" }, { "planid": "eZdZvlwT", "planname": "24 GHANTA", "plantype": "CHANNEL", "plancode": "ALA0004PP", "servicecode": "[\"ALA0004CS\"]", "packagecode": null, "description": "24 Ghanta", "lcoprice": "0.09", "mrptariff": "0.10", "tariffperiod": "1", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "0.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NCF", "numchannels": "1" }, { "planid": "DBMveBre", "planname": "AAJ TAK", "plantype": "CHANNEL", "plancode": "ALA0010PP", "servicecode": "[\"ALA0010CS\"]", "packagecode": null, "description": "AAJ TAK", "lcoprice": "0.68", "mrptariff": "0.75", "tariffperiod": "1", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "0.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NCF", "numchannels": "1" }, { "planid": "1Ac7IMCW", "planname": "ADITHYA TV", "plantype": "CHANNEL", "plancode": "ALA0016PP", "servicecode": "[\"ALA0016CS\"]", "packagecode": null, "description": "Adithya TV", "lcoprice": "8.10", "mrptariff": "9.00", "tariffperiod": "1", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "0.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NCF", "numchannels": "1" }, { "planid": "FqTU6LZ9", "planname": "ALANKAR", "plantype": "CHANNEL", "plancode": "ALA0017PP", "servicecode": "[\"ALA0017CS\"]", "packagecode": null, "description": "ALANKAR", "lcoprice": "3.60", "mrptariff": "4.00", "tariffperiod": "1", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "0.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NCF", "numchannels": "1" }, { "planid": "qjOZN6KQ", "planname": "ANIMAL PLANET", "plantype": "CHANNEL", "plancode": "ALA0018PP", "servicecode": "[\"ALA0018CS\"]", "packagecode": null, "description": "Animal Planet", "lcoprice": "1.80", "mrptariff": "2.00", "tariffperiod": "1", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "0.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NCF", "numchannels": "1" }, { "planid": "7CCDA0o9", "planname": "APNA EPIC VALUE", "plantype": "PACKAGE", "plancode": "BQEPIC44PP", "servicecode": "[\"BQEPIC044CS\"]", "packagecode": "", "description": "Apna Epic Value", "lcoprice": "1.80", "mrptariff": "2.00", "tariffperiod": "1", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "0.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NCF", "numchannels": "3" }, { "planid": "lnaoTy1N", "planname": "ASIANET", "plantype": "CHANNEL", "plancode": "ALA0019PP", "servicecode": "[\"ALA0019CS\"]", "packagecode": null, "description": "Asianet", "lcoprice": "17.10", "mrptariff": "19.00", "tariffperiod": "1", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "0.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NCF", "numchannels": "1" }, { "planid": "XYfSzm2e", "planname": "ASIANET MOVIES", "plantype": "CHANNEL", "plancode": "ALA0020PP", "servicecode": "[\"ALA0020CS\"]", "packagecode": null, "description": "Asianet Movies", "lcoprice": "13.50", "mrptariff": "15.00", "tariffperiod": "1", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "0.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NCF", "numchannels": "1" }, { "planid": "NGw1VUkk", "planname": "ASIANET PLUS", "plantype": "CHANNEL", "plancode": "ALA0021PP", "servicecode": "[\"ALA0021CS\"]", "packagecode": null, "description": "Asianet Plus", "lcoprice": "4.50", "mrptariff": "5.00", "tariffperiod": "1", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "0.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NCF", "numchannels": "1" }, { "planid": "c4MuWrbQ", "planname": "BBC WORLD NEWS", "plantype": "CHANNEL", "plancode": "ALA0023PP", "servicecode": "[\"ALA0023CS\"]", "packagecode": null, "description": "BBC WORLD NEWS", "lcoprice": "0.90", "mrptariff": "1.00", "tariffperiod": "1", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "0.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NCF", "numchannels": "1" }, { "planid": "1nXYEDeG", "planname": "BENGALI PLUS", "plantype": "PACKAGE", "plancode": "INB0014PP", "servicecode": "[\"INB0014CS\"]", "packagecode": null, "description": "IN BANGALI PLUS", "lcoprice": "128.07", "mrptariff": "145.00", "tariffperiod": "1", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "9.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NORMAL", "numchannels": "61" }]);
                }
                console.log("not reached");
                reject(error);
            });
        });
    },
    getSTBCustomer: function getSTBCustomer(context, payload) {
        var queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(payload);
        return new Promise(function (resolve, reject) {
            fetch(context.getters.baseUrl + '/lco/v1/subscriber/list-stb-subscribers' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                if (context.getters.getMode == "development") {
                    resolve({ "count": "52", "data": [{ "city": "Mumbai", "frcode": "FR5125", "lco_name": "SHREE SAI CABLE VIDEO NETWORK", "customer_can": "27138231", "stb_number": "100132200289051", "stb_type": "SD", "status": "ACTIVE", "base_pack": "Foundation + Hindi  Smart", "validity": "1M", "expiry_date": "19-AUG-22", "last_dc_date": null, "firts_name": "Demo Life Time", "last_name": ".", "mobile_no": "9036623729", "stb_war_date": "26-JUN-23", "lco_war_date": "06\/26\/2023" }, { "city": "Mumbai", "frcode": "FR5125", "lco_name": "SHREE SAI CABLE VIDEO NETWORK", "customer_can": "27358692", "stb_number": "214121642530336", "stb_type": "SD", "status": "ACTIVE", "base_pack": "Foundation Pack MH", "validity": "3M", "expiry_date": "05-OCT-22", "last_dc_date": null, "firts_name": "FR5125(SHREE SAI CABLE VIDEO NETWORK)", "last_name": "SWO", "mobile_no": "9845198593", "stb_war_date": "26-JUN-24", "lco_war_date": "06\/02\/2024" }] });
                }
                console.log("not reached");
                reject(error);
            });
        });
    },
    sendBroadbandDetails: function sendBroadbandDetails(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            console.log('data ', payload);
            var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);

            fetch(context.getters.baseUrl + '/lco/v1/customer/broadbanddetails', {
                method: 'POST',
                body: data
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    getHistory: function getHistory(context, payload) {
        var queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(payload);
        return new Promise(function (resolve, reject) {
            fetch(context.getters.baseUrl + '/lco/v1/subscriber/history' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                if (context.getters.getMode == "development") {
                    resolve({ "count": "52", "data": [{ "date": "Mumbai", "description": "FR5125 Recharge a payment of 125" }, { "date": "Mumbai", "description": "FR5125 Recharge a payment of 125" }, { "date": "Mumbai", "description": "FR5125 Recharge a payment of 125" }] });
                }
                reject(error);
            });
        });
    },
    getCustomerType: function getCustomerType(context) {
        return new Promise(function (resolve, reject) {

            fetch(context.getters.baseUrl + '/lco/v1/customer.php/type', {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                if (context.getters.getMode == "development") {
                    resolve([{ "customerclass": "Customer", "customertype": "Normal", "customerclassid": "3", "customertypeid": "21" }]);
                    return;
                }
                reject(error);
            });
        });
    },
    getTitle: function getTitle(context) {
        return new Promise(function (resolve, reject) {
            fetch(context.getters.baseUrl + '/lco/v1/lco/title', {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    actGetPostal: function actGetPostal(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            var dataObj = {};
            var queryStr = '';
            dataObj = {
                'postal_code': payload
            };
            queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(dataObj);

            fetch(context.getters.baseUrl + '/lco/v1/lco/postalcode' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    getHardwarepacks: function getHardwarepacks(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            var dataObj = {};
            var queryStr = '';
            dataObj = {
                'customertypeid': payload.customertypeid,
                'postalcode': payload.postalcode,
                'customerclassid': payload.customerclassid
            };
            queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(dataObj);
            fetch(context.getters.baseUrl + '/lco/v1/product.php' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    actPostCreateCustomer: function actPostCreateCustomer(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);

            fetch(context.getters.baseUrl + '/lco/v1/customer/createcustomer', {
                method: 'POST',
                body: data
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    actGetDevice: function actGetDevice(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            var queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(payload);
            fetch(context.getters.baseUrl + '/lco/v1/hardware/deviceavailibility' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    getTotalPlanPrice: function getTotalPlanPrice(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }

            var queryStr = '';
            queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(payload);
            if (!queryStr) reject({ error: "query not found" });
            fetch(context.getters.baseUrl + '/lco/v1/product/totalplanprice' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    // Advance renew pack
    getCustPacks: function getCustPacks(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }

            var dataObj = {};
            var queryStr = '';
            dataObj = {
                'customerid': payload
            };
            queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(dataObj);

            fetch(context.getters.baseUrl + '/lco/v1/subscriber/services' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    // Bulk Customer
    postBulkCustomer: function postBulkCustomer(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);
            fetch(context.getters.baseUrl + '/lco/v1/plan/createcustomer', {
                method: 'POST',
                body: data
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    getDisconnectedPlanList: function getDisconnectedPlanList(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            var dataObj = {};
            var queryStr = '';
            dataObj = {
                'subscriberid': payload
            };
            queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(dataObj);
            fetch(context.getters.baseUrl + '/lco/v1/listdisconnectedplans' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    // Bulk Customer Modify
    postBulkCustomerModify: function postBulkCustomerModify(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);
            fetch(context.getters.baseUrl + '/lco/v1/plan/modifycustomer', {
                method: 'POST',
                body: data
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                if (context.getters.getMode == "development") {
                    resolve({ "success": "1001506184" });
                }
                reject(error);
            });
        });
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({ state: state, getters: getters, mutations: mutations, actions: actions });

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(2);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var state = {};
var getters = {};
var mutations = {};
var planListingData = [];
var actions = {
  getAddPacks: function getAddPacks(context, filterData) {
    var newurl = filterData.url;
    delete filterData.url;
    return new Promise(function (resolve, reject) {
      //Remove Multiple call code
      // if (newurl == '/lco/v1/plan/subscriber' &&  filterData.plantype != 'ONEDIGITAL') {
      //   let getRecordBySearch = JSON.parse(localStorage.getItem('getRecordBySearch'))
      //   let lastCustomerSearch = JSON.parse(localStorage.getItem('lastCustomerSearch'))
      //   if (getRecordBySearch && lastCustomerSearch) {
      //     if (Object.keys(getRecordBySearch).length && lastCustomerSearch == filterData.subscriberid) {
      //       resolve(getRecordBySearch)
      //       return
      //     }
      //   }
      // }
      //Remove Multiple call code End

      var queryStr = '';
      queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(filterData);

      //Remove multiple call for plan start
      if (newurl == '/lco/v1/plan.php') {
        if (planListingData.length) {
          for (var i in planListingData) {
            console.log(planListingData[i], queryStr);
            if (Object.keys(planListingData[i]) == queryStr) {
              resolve(planListingData[i][queryStr]);
              console.log(planListingData[i][queryStr]);
              return;
            }
          }
        }
      }
      //Remove multiple call for plan end

      fetch(context.getters.baseUrl + newurl + queryStr, {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        // if (newurl == '/lco/v1/plan/subscriber' && !data.error) {
        //   localStorage.setItem("getRecordBySearch",JSON.stringify(data))
        //   localStorage.setItem("lastCustomerSearch",JSON.stringify(filterData.subscriberid))
        // }
        if (newurl == '/lco/v1/plan.php') {
          var setPlan = {};
          setPlan[queryStr] = data;
          planListingData.push(setPlan);
        }
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getChannelList: function getChannelList(context, filterData) {
    console.log("got response in report module", filterData);
    return new Promise(function (resolve, reject) {
      var data = {};
      data.plancode = filterData;
      var queryStr = '';
      queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(data);

      fetch(context.getters.baseUrl + '/lco/v1/plan/channel' + queryStr, {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getMonsoonPack: function getMonsoonPack(context, queryStr) {
    queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(queryStr);
    return new Promise(function (resolve, reject) {
      fetch(context.getters.baseUrl + '/lco/v1/plan/imclschemes' + queryStr, {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  sendOTPToUser: function sendOTPToUser(context, payload) {
    var data = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["b" /* makeQueryFormDataDyn */])(payload);
    return new Promise(function (resolve, reject) {
      fetch(context.getters.baseUrl + '/lco/v1/customer/otp', {
        method: 'POST',
        body: data
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  verifyUserOTP: function verifyUserOTP(context, queryStr) {
    return new Promise(function (resolve, reject) {
      queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(queryStr);
      fetch(context.getters.baseUrl + '/lco/v1/customer/otp/verify' + queryStr, {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  downloadMasterPlanList: function downloadMasterPlanList(context, filterData) {
    return new Promise(function (resolve, reject) {
      var queryStr = '';
      queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(filterData);
      fetch(context.getters.baseUrl + '/lco/v1/plan' + queryStr, {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        if (context.getters.getMode == "development") {
          resolve([{ "planid": "OJt8QA3D", "planname": "FILAMCHI", "plantype": "CHANNEL", "plancode": "ALA0700PP", "servicecode": "[\"ALA0700CS\"]", "packagecode": "", "description": "FILAMCHI", "lcoprice": "0.09", "mrptariff": "0.09", "tariffperiod": "1", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "0.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NORMAL", "numchannels": "239" }, { "planid": "Gd0hcCu5", "planname": "HD EUROSPORT", "plantype": "CHANNEL", "plancode": "ALA0696PP", "servicecode": "[\"ALA0696CS\"]", "packagecode": "", "description": "HD EUROSPORT", "lcoprice": "5.40", "mrptariff": "6.00", "tariffperiod": "1", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "0.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NORMAL", "numchannels": "1", "url": "https:\/\/s3.ap-south-1.amazonaws.com\/com.kyc.dpcollection.incablenet.mum\/images\/oohq7FSV.png" }, { "planid": "7ZluYF9R", "planname": "OTT PLAN", "plantype": "CHANNEL", "plancode": "OTTPLAN", "servicecode": "[\"OTTSERVICE\"]", "packagecode": "", "description": "OTT PLAN", "lcoprice": "1800.00", "mrptariff": "1800.00", "tariffperiod": "6", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "0.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NORMAL", "numchannels": "0" }, { "planid": "MihDE2e5", "planname": "OTT PLAN", "plantype": "CHANNEL", "plancode": "OTTPLAN", "servicecode": "[\"OTTSERVICE\"]", "packagecode": "", "description": "OTT PLAN", "lcoprice": "3600.00", "mrptariff": "3600.00", "tariffperiod": "12", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "0.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NORMAL", "numchannels": "0" }, { "planid": "XX4u9SfH", "planname": "OTT PLAN", "plantype": "CHANNEL", "plancode": "OTTPLAN", "servicecode": "[\"OTTSERVICE\"]", "packagecode": "", "description": "OTT PLAN", "lcoprice": "300.00", "mrptariff": "300.00", "tariffperiod": "30", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "D", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "0.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NORMAL", "numchannels": "0" }, { "planid": "VvfdRUMU", "planname": "OTT PLAN", "plantype": "CHANNEL", "plancode": "OTTPLAN", "servicecode": "[\"OTTSERVICE\"]", "packagecode": "", "description": "OTT PLAN", "lcoprice": "1800.00", "mrptariff": "1800.00", "tariffperiod": "90", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "D", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "0.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NORMAL", "numchannels": "0" }, { "planid": "8El13Vr6", "planname": "OTTPREPAID", "plantype": "CHANNEL", "plancode": "OTTPREPAID", "servicecode": "[\"OTTSERVICE\"]", "packagecode": "", "description": "OTTPREPAID", "lcoprice": "1800.00", "mrptariff": "1800.00", "tariffperiod": "6", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "0.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NORMAL", "numchannels": "0" }, { "planid": "6gBtxEEm", "planname": "OTTPREPAID", "plantype": "CHANNEL", "plancode": "OTTPREPAID", "servicecode": "[\"OTTSERVICE\"]", "packagecode": "", "description": "OTTPREPAID", "lcoprice": "3600.00", "mrptariff": "3600.00", "tariffperiod": "12", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "0.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NORMAL", "numchannels": "0" }, { "planid": "oQ3Cebh2", "planname": "OTTPREPAID", "plantype": "CHANNEL", "plancode": "OTTPREPAID", "servicecode": "[\"OTTSERVICE\"]", "packagecode": "", "description": "OTTPREPAID", "lcoprice": "300.00", "mrptariff": "300.00", "tariffperiod": "30", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "D", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "0.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NORMAL", "numchannels": "0" }, { "planid": "F9SjXTCi", "planname": "OTTPREPAID", "plantype": "CHANNEL", "plancode": "OTTPREPAID", "servicecode": "[\"OTTSERVICE\"]", "packagecode": "", "description": "OTTPREPAID", "lcoprice": "1800.00", "mrptariff": "1800.00", "tariffperiod": "90", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "D", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "0.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NORMAL", "numchannels": "0" }]);
        } else {
          reject(error);
        }
      });
    });
  },
  getDiscontinuedPacksDetails: function getDiscontinuedPacksDetails(context, filterData) {
    return new Promise(function (resolve, reject) {
      var queryStr = '';
      queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(filterData);
      fetch(context.getters.baseUrl + '/lco/v1/plan/discontinued' + queryStr, {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        if (context.getters.getMode == "development") {
          var _ref;

          resolve([(_ref = { "plancode": "ALA0001PP", "expiry": "2022-06-06 00:00:00", "planname": "FOUNDATION + BANGLA POWER INDIA PACK", "plancategory": "NCF", "plantype": "PACKAGE", "numchannels": "1", "channellist": true, "recommended_plancode": "[\"ALA0002PP\",\"ALA0003PP\"]" }, _defineProperty(_ref, 'planname', "ENGLISH PREMIUM"), _defineProperty(_ref, 'plantype', "PACKAGE"), _defineProperty(_ref, 'plancategory', "NORMAL"), _defineProperty(_ref, 'numchannels', "84"), _ref), { "plancode": "INB0015PP", "expiry": "2022-05-30 00:00:00", "recommended_plancode": "[\"ALA0002PP\",\"ALA0003PP\"]", "planname": "BENGALI PREMIUM", "plantype": "PACKAGE", "plancategory": "NORMAL", "numchannels": "72" }, { "plancode": "ALA0002PP", "expiry": "2022-05-05 00:00:00", "recommended_plancode": "[\"ALA0002PP\",\"ALA0003PP\"]", "planname": "&PICTURES", "plantype": "CHANNEL", "plancategory": "NCF", "numchannels": "1" }, { "plancode": "BQ00060PP", "expiry": "2022-05-05 00:00:00", "recommended_plancode": "[\"ALA0002PP\",\"ALA0003PP\"]", "planname": "DISNEY KIDS PACK", "plantype": "PACKAGE", "plancategory": "NCF", "numchannels": "4" }, { "plancode": "BQ00082PP", "expiry": "2022-05-05 00:00:00", "recommended_plancode": "[\"ALA0002PP\",\"ALA0003PP\"]", "planname": "ZEE FAMILY PACK ALL SOUTH SD", "plantype": "PACKAGE", "plancategory": "NCF", "numchannels": "19" }, { "plancode": "BQ00087PP", "expiry": "2022-05-05 00:00:00", "recommended_plancode": "[\"ALA0002PP\",\"ALA0003PP\"]", "planname": "COLORS WALA HINDI VALUE PLUS", "plantype": "PACKAGE", "plancategory": "NCF", "numchannels": "22" }, { "plancode": "BQ00094PP", "expiry": "2022-05-05 00:00:00", "recommended_plancode": "[\"ALA0002PP\",\"ALA0003PP\"]", "planname": "COLORS WALA GUJARAT BUDGET PLUS", "plantype": "PACKAGE", "plancategory": "NCF", "numchannels": "17" }, { "plancode": "BQ00341PP", "expiry": "2022-05-05 00:00:00", "recommended_plancode": "[\"ALA0002PP\",\"ALA0003PP\"]", "planname": "STAR VALUE PACK TAMIL-TELUGU", "plantype": "PACKAGE", "plancategory": "NCF", "numchannels": "12" }, { "plancode": "INB0028PP", "expiry": "2022-05-05 00:00:00", "recommended_plancode": "[\"ALA0002PP\",\"ALA0003PP\"]", "planname": "ENGLISH STARTER", "plantype": "PACKAGE", "plancategory": "NORMAL", "numchannels": "45" }, { "plancode": "INB0033PP", "expiry": "2022-05-05 00:00:00", "recommended_plancode": "[\"ALA0002PP\",\"ALA0003PP\"]" }, { "plancode": "ALA0001PP", "expiry": "2022-05-10 00:00:00", "planname": "Z NEWS", "plancategory": "NCF", "plantype": "PACKAGE", "numchannels": "1", "channellist": true, "recommended_plancode": ['1', '2'] }, { "plancode": "ALA0001PP", "expiry": "2022-05-05 00:00:00", "planname": "Z NEWS", "plancategory": "NCF", "plantype": "PACKAGE", "numchannels": "1", "channellist": true }, { "plancode": "ALA0001PP", "expiry": "2022-05-05 00:00:00", "planname": "Z NEWS", "plancategory": "NCF", "plantype": "PACKAGE", "numchannels": "1", "channellist": true }, { "plancode": "ALA0001PP", "expiry": "2022-05-05 00:00:00", "planname": "Z NEWS", "plancategory": "NCF", "plantype": "PACKAGE", "numchannels": "1", "channellist": true }, { "plancode": "ALA0001PP", "expiry": "2022-05-05 00:00:00", "planname": "Z NEWS", "plancategory": "NCF", "plantype": "PACKAGE", "numchannels": "1", "channellist": true }, { "plancode": "ALA0001PP", "expiry": "2022-05-05 00:00:00", "planname": "Z NEWS", "plancategory": "NCF", "plantype": "PACKAGE", "numchannels": "1", "channellist": true }, { "plancode": "ALA0001PP", "expiry": "2022-05-05 00:00:00", "planname": "Z NEWS", "plancategory": "NCF", "plantype": "PACKAGE", "numchannels": "1", "channellist": true }, { "plancode": "ALA0001PP", "expiry": "2022-05-05 00:00:00", "planname": "Z NEWS", "plancategory": "NCF", "plantype": "PACKAGE", "numchannels": "1", "channellist": true }, { "plancode": "ALA0001PP", "expiry": "2022-05-05 00:00:00", "planname": "Z NEWS", "plancategory": "NCF", "plantype": "PACKAGE", "numchannels": "1", "channellist": true }, { "plancode": "ALA0001PP", "expiry": "2022-05-05 00:00:00", "planname": "Z NEWS", "plancategory": "NCF", "plantype": "PACKAGE", "numchannels": "1", "channellist": true }, { "plancode": "ALA0001PP", "expiry": "2022-05-05 00:00:00", "planname": "Z NEWS", "plancategory": "NCF", "plantype": "PACKAGE", "numchannels": "1", "channellist": true }]);
          return;
        }
        reject(error);
      });
    });
  },
  getRecommendedPlanList: function getRecommendedPlanList(context, filterData) {
    return new Promise(function (resolve, reject) {
      var queryStr = '';
      queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(filterData);
      fetch(context.getters.baseUrl + '/lco/v1/plan/discontinued' + queryStr, {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        if (context.getters.getMode == "development") {
          resolve([{ "planname": "COLORS WALA GUJARAT FAMILY", "plancode": "BQ00096PP", "lcoprice": "27.00", "ncfprice": "0.00", "plantype": "PACKAGE", "plancategory": "NCF", "numchannels": "29" }, { "planname": "COLORS WALA KERALA BUDGET PLUS", "plancode": "BQ00090PP", "lcoprice": "7.20", "ncfprice": "0.00", "plantype": "PACKAGE", "plancategory": "NCF", "numchannels": "12" }, { "planname": "MAVIS SATCOM BOUQUET 1", "plancode": "BQ00147PP", "lcoprice": "5.40", "ncfprice": "0.00", "plantype": "PACKAGE", "plancategory": "NCF", "numchannels": "4" }, { "planname": "NDTV ULTRA", "plancode": "BQ00148PP", "lcoprice": "3.15", "ncfprice": "0.00", "plantype": "PACKAGE", "plancategory": "NCF", "numchannels": "4" }, { "planname": "OTT PLAN", "plancode": "OTT00001PP", "lcoprice": "300.00", "ncfprice": "0.00", "plantype": "CHANNEL", "plancategory": "NORMAL", "numchannels": "5" }]);
          return;
        }
        reject(error);
      });
    });
  },
  deletePlanCache: function deletePlanCache() {
    console.log("Calling to Delete cache plan list");
    planListingData = [];
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state, getters: getters, mutations: mutations, actions: actions
});

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(2);

var state = {};
var getters = {};
var mutations = {};
var actions = {
    getAllPlanDetails: function getAllPlanDetails(context, filterData) {
        return new Promise(function (resolve, reject) {
            var queryStr = '';
            queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(filterData);
            console.log(queryStr);
            fetch(context.getters.baseUrl + '/lco/v1/product' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                if (context.getters.getMode == "development") {
                    resolve([{ "producttypename": "NXT Packs", "productid": 1206, "productname": " HINDI SUPER ENTMT PACK 6M", "tariffperiod": "HALFYEARLY", "lcoprice": 839.96, "msoprice": 0, "price": 1003.5, "ncfprice": 0, "tax": 180.64, "onlylcoprice": 0, "msoncfprice": 0, "lconcftax": 0, "lcotax": 151.2, "msotax": 0, "ncftax": 0, "msoncftax": 0, "lconcfprice": 0, "totallcoprice": 991.16, "totallcotax": 151.2, "totalmsoprice": 0, "totalmsotax": 0, "totalprice": 1184.14, "totaltax": 180.64, "channelcount": "105" }, { "producttypename": "Add-on", "productid": 1423, "productname": "SVP HD Marathi", "tariffperiod": "MONTHLY", "lcoprice": 839.96, "msoprice": 0, "price": 1003.5, "ncfprice": 0, "tax": 180.64, "onlylcoprice": 0, "msoncfprice": 0, "lconcftax": 0, "lcotax": 151.2, "msotax": 0, "ncftax": 0, "msoncftax": 0, "lconcfprice": 0, "totallcoprice": 991.16, "totallcotax": 151.2, "totalmsoprice": 0, "totalmsotax": 0, "totalprice": 1184.14, "totaltax": 180.64, "channelcount": "105" }, { "producttypename": "Base Packs", "productid": 1423, "productname": "SVP HD Marathi", "tariffperiod": "MONTHLY", "lcoprice": 839.96, "msoprice": 0, "price": 1003.5, "ncfprice": 0, "tax": 180.64, "onlylcoprice": 0, "msoncfprice": 0, "lconcftax": 0, "lcotax": 151.2, "msotax": 0, "ncftax": 0, "msoncftax": 0, "lconcfprice": 0, "totallcoprice": 991.16, "totallcotax": 151.2, "totalmsoprice": 0, "totalmsotax": 0, "totalprice": 1184.14, "totaltax": 180.64, "channelcount": "105" }, { "producttypename": "A-la-carte", "productid": 1062, "productname": "SHEMAROO KIDS", "tariffperiod": "MONTHLY", "lcoprice": 839.96, "msoprice": 0, "price": 1003.5, "ncfprice": 0, "tax": 180.64, "onlylcoprice": 0, "msoncfprice": 0, "lconcftax": 0, "lcotax": 151.2, "msotax": 0, "ncftax": 0, "msoncftax": 0, "lconcfprice": 0, "totallcoprice": 991.16, "totallcotax": 151.2, "totalmsoprice": 0, "totalmsotax": 0, "totalprice": 1184.14, "totaltax": 180.64, "channelcount": "1" }, { "producttypename": "NXT-Addon", "productid": 984, "productname": "Premium Vas 22", "tariffperiod": "MONTHLY", "lcoprice": 839.96, "msoprice": 0, "price": 1003.5, "ncfprice": 0, "tax": 180.64, "onlylcoprice": 0, "msoncfprice": 0, "lconcftax": 0, "lcotax": 151.2, "msotax": 0, "ncftax": 0, "msoncftax": 0, "lconcfprice": 0, "totallcoprice": 991.16, "totallcotax": 151.2, "totalmsoprice": 0, "totalmsotax": 0, "totalprice": 1184.14, "totaltax": 180.64, "channelcount": "1" }, { "producttypename": "Broadcaster Pack", "productid": 740, "productname": "Disney-Kids Bouquet", "tariffperiod": "MONTHLY", "lcoprice": 839.96, "msoprice": 0, "price": 1003.5, "ncfprice": 0, "tax": 180.64, "onlylcoprice": 0, "msoncfprice": 0, "lconcftax": 0, "lcotax": 151.2, "msotax": 0, "ncftax": 0, "msoncftax": 0, "lconcfprice": 0, "totallcoprice": 991.16, "totallcotax": 151.2, "totalmsoprice": 0, "totalmsotax": 0, "totalprice": 1184.14, "totaltax": 180.64, "channelcount": "1" }, { "producttypename": "Broadcaster Pack", "productid": 741, "productname": "ZEE Fmly Pck Mar-Kan SD", "tariffperiod": "MONTHLY", "lcoprice": 839.96, "msoprice": 0, "price": 1003.5, "ncfprice": 0, "tax": 180.64, "onlylcoprice": 0, "msoncfprice": 0, "lconcftax": 0, "lcotax": 151.2, "msotax": 0, "ncftax": 0, "msoncftax": 0, "lconcfprice": 0, "totallcoprice": 991.16, "totallcotax": 151.2, "totalmsoprice": 0, "totalmsotax": 0, "totalprice": 1184.14, "totaltax": 180.64, "channelcount": "1" }, { "producttypename": "Broadcaster Pack", "productid": 742, "productname": "Colors Wala Tamil Budget Plus", "tariffperiod": "MONTHLY", "lcoprice": 839.96, "msoprice": 0, "price": 1003.5, "ncfprice": 0, "tax": 180.64, "onlylcoprice": 0, "msoncfprice": 0, "lconcftax": 0, "lcotax": 151.2, "msotax": 0, "ncftax": 0, "msoncftax": 0, "lconcfprice": 0, "totallcoprice": 991.16, "totallcotax": 151.2, "totalmsoprice": 0, "totalmsotax": 0, "totalprice": 1184.14, "totaltax": 180.64, "channelcount": "10" }]);
                } else {
                    resolve(data);
                }
                resolve(data);
            }).catch(function (error) {
                if (context.getters.getMode == "development") {
                    resolve([{ "producttypename": "Base Packs", "productname": "Promo Foundation + Hindi Super ENTMT Pack", "productid": 1503, "tariffperiod": "MONTHLY", "lcoprice": "0.00", "msoprice": "0.00", "price": "0.00", "ncfprice": "0.00", "tax": "0.00", "onlylcoprice": 0, "msoncfprice": "0.00", "lconcftax": "0.00", "lcotax": "0.00", "msotax": "0.00", "ncftax": 0, "msoncftax": "0.00", "lconcfprice": "0.00", "totallcoprice": "00.00", "totallcotax": "0.00", "totalmsoprice": "0.00", "totalmsotax": "0.00", "totalprice": "12", "totaltax": "0.00", "channelcount": "206" }, { "producttypename": "Base Packs", "productname": "Foundation + Hindi Popular Pack 6M", "productid": 1194, "tariffperiod": "HALFYEARLY", "lcoprice": "1022.37", "msoprice": "0.00", "price": "1018.50", "ncfprice": "780.00", "tax": "183.34", "onlylcoprice": 0, "msoncfprice": "0.00", "lconcftax": "0.00", "lcotax": "184.04", "msotax": "0.00", "ncftax": 140.4, "msoncftax": "0.00", "lconcfprice": "0.00", "totallcoprice": "1206.41", "totallcotax": "184.04", "totalmsoprice": "0.00", "totalmsotax": "0.00", "totalprice": "2122.24", "totaltax": "323.74", "channelcount": "210" }, { "producttypename": "Base Packs", "productname": "Foundation + Hindi Popular Pack 3M", "productid": 1190, "tariffperiod": "QUARTERLY", "lcoprice": "522.18", "msoprice": "0.00", "price": "509.25", "ncfprice": "390.00", "tax": "91.66", "onlylcoprice": 0, "msoncfprice": "0.00", "lconcftax": "0.00", "lcotax": "94.00", "msotax": "0.00", "ncftax": 70.2, "msoncftax": "0.00", "lconcfprice": "0.00", "totallcoprice": "616.18", "totallcotax": "94.00", "totalmsoprice": "0.00", "totalmsotax": "0.00", "totalprice": "1061.11", "totaltax": "161.86", "channelcount": "210" }, { "producttypename": "Base Packs", "productname": "Foundation + Hindi Popular Pack 12M", "productid": 1198, "tariffperiod": "YEARLY", "lcoprice": "2000.76", "msoprice": "0.00", "price": "2041.50", "ncfprice": "1560.00", "tax": "367.48", "onlylcoprice": 0, "msoncfprice": "0.00", "lconcftax": "0.00", "lcotax": "360.12", "msotax": "0.00", "ncftax": 280.8, "msoncftax": "0.00", "lconcfprice": "0.00", "totallcoprice": "2360.88", "totallcotax": "360.12", "totalmsoprice": "0.00", "totalmsotax": "0.00", "totalprice": "4249.78", "totaltax": "648.28", "channelcount": "210" }, { "producttypename": "Base Packs", "productname": "Foundation + Gujarati Popular Pack 12M", "productid": 1213, "tariffperiod": "YEARLY", "lcoprice": "2000.76", "msoprice": "0.00", "price": "2037.00", "ncfprice": "1560.00", "tax": "366.66", "onlylcoprice": 0, "msoncfprice": "0.00", "lconcftax": "0.00", "lcotax": "360.12", "msotax": "0.00", "ncftax": 280.8, "msoncftax": "0.00", "lconcfprice": "0.00", "totallcoprice": "2360.88", "totallcotax": "360.12", "totalmsoprice": "0.00", "totalmsotax": "0.00", "totalprice": "4244.46", "totaltax": "647.46", "channelcount": "208" }, { "producttypename": "Base Packs", "productname": "Foundation + Gujarati Popular Pack 3M", "productid": 1211, "tariffperiod": "QUARTERLY", "lcoprice": "522.18", "msoprice": "0.00", "price": "509.25", "ncfprice": "390.00", "tax": "91.66", "onlylcoprice": 0, "msoncfprice": "0.00", "lconcftax": "0.00", "lcotax": "94.00", "msotax": "0.00", "ncftax": 70.2, "msoncftax": "0.00", "lconcfprice": "0.00", "totallcoprice": "616.18", "totallcotax": "94.00", "totalmsoprice": "0.00", "totalmsotax": "0.00", "totalprice": "1061.11", "totaltax": "161.86", "channelcount": "208" }, { "producttypename": "Base Packs", "productname": "Foundation Pack", "productid": 935, "tariffperiod": "MONTHLY", "lcoprice": "30.00", "msoprice": "0.00", "price": "0.00", "ncfprice": "130.00", "tax": "0.00", "onlylcoprice": 0, "msoncfprice": "0.00", "lconcftax": "0.00", "lcotax": "5.40", "msotax": "0.00", "ncftax": 23.4, "msoncftax": "0.00", "lconcfprice": "0.00", "totallcoprice": "35.40", "totallcotax": "5.40", "totalmsoprice": "0.00", "totalmsotax": "0.00", "totalprice": "153.40", "totaltax": "23.40", "channelcount": "100" }, { "producttypename": "Base Packs", "productname": "Foundation + Eng Mar Hin Cosmo Pack", "productid": 1063, "tariffperiod": "MONTHLY", "lcoprice": "295.95", "msoprice": "0.00", "price": "290.50", "ncfprice": "150.00", "tax": "52.30", "onlylcoprice": 0, "msoncfprice": "0.00", "lconcftax": "0.00", "lcotax": "53.28", "msotax": "0.00", "ncftax": 27, "msoncftax": "0.00", "lconcfprice": "0.00", "totallcoprice": "349.23", "totallcotax": "53.28", "totalmsoprice": "0.00", "totalmsotax": "0.00", "totalprice": "519.80", "totaltax": "79.30", "channelcount": "247" }, { "producttypename": "Base Packs", "productname": "Foundation + Eng Hin Cosmo Pack", "productid": 1064, "tariffperiod": "MONTHLY", "lcoprice": "295.95", "msoprice": "0.00", "price": "290.40", "ncfprice": "150.00", "tax": "52.28", "onlylcoprice": 0, "msoncfprice": "0.00", "lconcftax": "0.00", "lcotax": "53.28", "msotax": "0.00", "ncftax": 27, "msoncftax": "0.00", "lconcfprice": "0.00", "totallcoprice": "349.23", "totallcotax": "53.28", "totalmsoprice": "0.00", "totalmsotax": "0.00", "totalprice": "519.68", "totaltax": "79.28", "channelcount": "245" }, { "producttypename": "Base Packs", "productname": "Foundation + Mega SD Pack", "productid": 1065, "tariffperiod": "MONTHLY", "lcoprice": "297.84", "msoprice": "0.00", "price": "292.60", "ncfprice": "170.00", "tax": "52.66", "onlylcoprice": 0, "msoncfprice": "0.00", "lconcftax": "0.00", "lcotax": "53.62", "msotax": "0.00", "ncftax": 30.6, "msoncftax": "0.00", "lconcfprice": "0.00", "totallcoprice": "351.46", "totallcotax": "53.62", "totalmsoprice": "0.00", "totalmsotax": "0.00", "totalprice": "545.86", "totaltax": "83.26", "channelcount": "249" }, { "producttypename": "Base Packs", "productname": "Foundation + Telugu Smart Pack", "productid": 1067, "tariffperiod": "MONTHLY", "lcoprice": "131.70", "msoprice": "0.00", "price": "113.00", "ncfprice": "130.00", "tax": "20.34", "onlylcoprice": 0, "msoncfprice": "0.00", "lconcftax": "0.00", "lcotax": "23.70", "msotax": "0.00", "ncftax": 23.4, "msoncftax": "0.00", "lconcfprice": "0.00", "totallcoprice": "155.40", "totallcotax": "23.70", "totalmsoprice": "0.00", "totalmsotax": "0.00", "totalprice": "286.74", "totaltax": "43.74", "channelcount": "157" }, { "producttypename": "Base Packs", "productname": "Foundation + Malyalam Smart Pack", "productid": 1068, "tariffperiod": "MONTHLY", "lcoprice": "137.42", "msoprice": "0.00", "price": "119.35", "ncfprice": "130.00", "tax": "21.48", "onlylcoprice": 0, "msoncfprice": "0.00", "lconcftax": "0.00", "lcotax": "24.74", "msotax": "0.00", "ncftax": 23.4, "msoncftax": "0.00", "lconcfprice": "0.00", "totallcoprice": "162.16", "totallcotax": "24.74", "totalmsoprice": "0.00", "totalmsotax": "0.00", "totalprice": "294.23", "totaltax": "44.88", "channelcount": "147" }, { "producttypename": "Base Packs", "productname": "Foundation + Kannada Smart Pack", "productid": 1069, "tariffperiod": "MONTHLY", "lcoprice": "124.50", "msoprice": "0.00", "price": "105.00", "ncfprice": "130.00", "tax": "18.90", "onlylcoprice": 0, "msoncfprice": "0.00", "lconcftax": "0.00", "lcotax": "22.42", "msotax": "0.00", "ncftax": 23.4, "msoncftax": "0.00", "lconcfprice": "0.00", "totallcoprice": "146.92", "totallcotax": "22.42", "totalmsoprice": "0.00", "totalmsotax": "0.00", "totalprice": "277.30", "totaltax": "42.30", "channelcount": "141" }, { "producttypename": "Base Packs", "productname": "Foundation + Odia Smart Pack", "productid": 1070, "tariffperiod": "MONTHLY", "lcoprice": "115.19", "msoprice": "0.00", "price": "101.65", "ncfprice": "130.00", "tax": "18.30", "onlylcoprice": 0, "msoncfprice": "0.00", "lconcftax": "0.00", "lcotax": "20.74", "msotax": "0.00", "ncftax": 23.4, "msoncftax": "0.00", "lconcfprice": "0.00", "totallcoprice": "135.93", "totallcotax": "20.74", "totalmsoprice": "0.00", "totalmsotax": "0.00", "totalprice": "273.35", "totaltax": "41.70", "channelcount": "144" }, { "producttypename": "Base Packs", "productname": "Foundation + Bengali Smart Pack", "productid": 1071, "tariffperiod": "MONTHLY", "lcoprice": "125.58", "msoprice": "0.00", "price": "106.20", "ncfprice": "130.00", "tax": "19.12", "onlylcoprice": 0, "msoncfprice": "0.00", "lconcftax": "0.00", "lcotax": "22.60", "msotax": "0.00", "ncftax": 23.4, "msoncftax": "0.00", "lconcfprice": "0.00", "totallcoprice": "148.18", "totallcotax": "22.60", "totalmsoprice": "0.00", "totalmsotax": "0.00", "totalprice": "278.72", "totaltax": "42.52", "channelcount": "147" }, { "producttypename": "Base Packs", "productname": "Foundation + Gujarati Smart Pack", "productid": 1072, "tariffperiod": "MONTHLY", "lcoprice": "117.57", "msoprice": "0.00", "price": "103.80", "ncfprice": "130.00", "tax": "18.68", "onlylcoprice": 0, "msoncfprice": "0.00", "lconcftax": "0.00", "lcotax": "21.16", "msotax": "0.00", "ncftax": 23.4, "msoncftax": "0.00", "lconcfprice": "0.00", "totallcoprice": "138.73", "totallcotax": "21.16", "totalmsoprice": "0.00", "totalmsotax": "0.00", "totalprice": "275.88", "totaltax": "42.08", "channelcount": "162" }, { "producttypename": "Base Packs", "productname": "Foundation + Hindi Smart Pack", "productid": 1073, "tariffperiod": "MONTHLY", "lcoprice": "99.93", "msoprice": "0.00", "price": "105.70", "ncfprice": "130.00", "tax": "19.02", "onlylcoprice": 0, "msoncfprice": "0.00", "lconcftax": "0.00", "lcotax": "17.98", "msotax": "0.00", "ncftax": 23.4, "msoncftax": "0.00", "lconcfprice": "0.00", "totallcoprice": "117.91", "totallcotax": "17.98", "totalmsoprice": "0.00", "totalmsotax": "0.00", "totalprice": "278.12", "totaltax": "42.42", "channelcount": "137" }, { "producttypename": "Base Packs", "productname": "Foundation + Marathi Smart Pack", "productid": 1074, "tariffperiod": "MONTHLY", "lcoprice": "125.49", "msoprice": "0.00", "price": "105.60", "ncfprice": "130.00", "tax": "19.00", "onlylcoprice": 0, "msoncfprice": "0.00", "lconcftax": "0.00", "lcotax": "22.58", "msotax": "0.00", "ncftax": 23.4, "msoncftax": "0.00", "lconcfprice": "0.00", "totallcoprice": "148.07", "totallcotax": "22.58", "totalmsoprice": "0.00", "totalmsotax": "0.00", "totalprice": "278.00", "totaltax": "42.40", "channelcount": "133" }, { "producttypename": "Base Packs", "productname": "Foundation + Marathi Popular Pack", "productid": 1075, "tariffperiod": "MONTHLY", "lcoprice": "183.23", "msoprice": "0.00", "price": "169.75", "ncfprice": "130.00", "tax": "30.56", "onlylcoprice": 0, "msoncfprice": "0.00", "lconcftax": "0.00", "lcotax": "32.98", "msotax": "0.00", "ncftax": 23.4, "msoncftax": "0.00", "lconcfprice": "0.00", "totallcoprice": "216.21", "totallcotax": "32.98", "totalmsoprice": "0.00", "totalmsotax": "0.00", "totalprice": "353.71", "totaltax": "53.96", "channelcount": "204" }, { "producttypename": "Base Packs", "productname": "Foundation + Hindi Popular Pack", "productid": 1076, "tariffperiod": "MONTHLY", "lcoprice": "183.23", "msoprice": "0.00", "price": "169.75", "ncfprice": "130.00", "tax": "30.56", "onlylcoprice": 0, "msoncfprice": "0.00", "lconcftax": "0.00", "lcotax": "32.98", "msotax": "0.00", "ncftax": 23.4, "msoncftax": "0.00", "lconcfprice": "0.00", "totallcoprice": "216.21", "totallcotax": "32.98", "totalmsoprice": "0.00", "totalmsotax": "0.00", "totalprice": "353.71", "totaltax": "53.96", "channelcount": "210" }, { "producttypename": "Base Packs", "productname": "Foundation + Gujarati Popular Pack", "productid": 1077, "tariffperiod": "MONTHLY", "lcoprice": "183.23", "msoprice": "0.00", "price": "169.75", "ncfprice": "130.00", "tax": "30.56", "onlylcoprice": 0, "msoncfprice": "0.00", "lconcftax": "0.00", "lcotax": "32.98", "msotax": "0.00", "ncftax": 23.4, "msoncftax": "0.00", "lconcfprice": "0.00", "totallcoprice": "216.21", "totallcotax": "32.98", "totalmsoprice": "0.00", "totalmsotax": "0.00", "totalprice": "353.71", "totaltax": "53.96", "channelcount": "208" }, { "producttypename": "Base Packs", "productname": "Foundation + Odia Popular Pack", "productid": 1081, "tariffperiod": "MONTHLY", "lcoprice": "181.70", "msoprice": "0.00", "price": "169.00", "ncfprice": "130.00", "tax": "30.42", "onlylcoprice": 0, "msoncfprice": "0.00", "lconcftax": "0.00", "lcotax": "32.70", "msotax": "0.00", "ncftax": 23.4, "msoncftax": "0.00", "lconcfprice": "0.00", "totallcoprice": "214.40", "totallcotax": "32.70", "totalmsoprice": "0.00", "totalmsotax": "0.00", "totalprice": "352.82", "totaltax": "53.82", "channelcount": "206" }, { "producttypename": "Base Packs", "productname": "Foundation + Marathi Super Power Pack", "productid": 1085, "tariffperiod": "MONTHLY", "lcoprice": "221.70", "msoprice": "0.00", "price": "212.50", "ncfprice": "140.00", "tax": "38.26", "onlylcoprice": 0, "msoncfprice": "0.00", "lconcftax": "0.00", "lcotax": "39.90", "msotax": "0.00", "ncftax": 25.2, "msoncftax": "0.00", "lconcfprice": "0.00", "totallcoprice": "261.60", "totallcotax": "39.90", "totalmsoprice": "0.00", "totalmsotax": "0.00", "totalprice": "415.96", "totaltax": "63.46", "channelcount": "229" }, { "producttypename": "Base Packs", "productname": "Foundation + Hindi Super Power Pack", "productid": 1086, "tariffperiod": "MONTHLY", "lcoprice": "221.70", "msoprice": "0.00", "price": "212.50", "ncfprice": "140.00", "tax": "38.26", "onlylcoprice": 0, "msoncfprice": "0.00", "lconcftax": "0.00", "lcotax": "39.90", "msotax": "0.00", "ncftax": 25.2, "msoncftax": "0.00", "lconcfprice": "0.00", "totallcoprice": "261.60", "totallcotax": "39.90", "totalmsoprice": "0.00", "totalmsotax": "0.00", "totalprice": "415.96", "totaltax": "63.46", "channelcount": "228" }, { "producttypename": "Base Packs", "productname": "Foundation + Gujarati Super Power Pack", "productid": 1087, "tariffperiod": "MONTHLY", "lcoprice": "221.70", "msoprice": "0.00", "price": "212.50", "ncfprice": "140.00", "tax": "38.26", "onlylcoprice": 0, "msoncfprice": "0.00", "lconcftax": "0.00", "lcotax": "39.90", "msotax": "0.00", "ncftax": 25.2, "msoncftax": "0.00", "lconcfprice": "0.00", "totallcoprice": "261.60", "totallcotax": "39.90", "totalmsoprice": "0.00", "totalmsotax": "0.00", "totalprice": "415.96", "totaltax": "63.46", "channelcount": "233" }, { "producttypename": "Base Packs", "productname": "Foundation + Bangla  Super Power Pack", "productid": 1088, "tariffperiod": "MONTHLY", "lcoprice": "223.50", "msoprice": "0.00", "price": "214.50", "ncfprice": "140.00", "tax": "38.62", "onlylcoprice": 0, "msoncfprice": "0.00", "lconcftax": "0.00", "lcotax": "40.24", "msotax": "0.00", "ncftax": 25.2, "msoncftax": "0.00", "lconcfprice": "0.00", "totallcoprice": "263.74", "totallcotax": "40.24", "totalmsoprice": "0.00", "totalmsotax": "0.00", "totalprice": "418.32", "totaltax": "63.82", "channelcount": "220" }, { "producttypename": "Base Packs", "productname": "Foundation + Telugu Super Power Pack", "productid": 1090, "tariffperiod": "MONTHLY", "lcoprice": "214.95", "msoprice": "0.00", "price": "205.50", "ncfprice": "140.00", "tax": "37.00", "onlylcoprice": 0, "msoncfprice": "0.00", "lconcftax": "0.00", "lcotax": "38.70", "msotax": "0.00", "ncftax": 25.2, "msoncftax": "0.00", "lconcfprice": "0.00", "totallcoprice": "253.65", "totallcotax": "38.70", "totalmsoprice": "0.00", "totalmsotax": "0.00", "totalprice": "407.70", "totaltax": "62.20", "channelcount": "183" }, { "producttypename": "Base Packs", "productname": "Foundation + Telugu Mini Smart Pack", "productid": 1097, "tariffperiod": "MONTHLY", "lcoprice": "104.70", "msoprice": "0.00", "price": "83.00", "ncfprice": "130.00", "tax": "14.94", "onlylcoprice": 0, "msoncfprice": "0.00", "lconcftax": "0.00", "lcotax": "18.84", "msotax": "0.00", "ncftax": 23.4, "msoncftax": "0.00", "lconcfprice": "0.00", "totallcoprice": "123.54", "totallcotax": "18.84", "totalmsoprice": "0.00", "totalmsotax": "0.00", "totalprice": "251.34", "totaltax": "38.34", "channelcount": "127" }, { "producttypename": "Base Packs", "productname": "NXT Monitoring Pack", "productid": 245, "tariffperiod": "MONTHLY", "lcoprice": "0.00", "msoprice": "0.00", "price": "0.00", "ncfprice": "0.00", "tax": "0.00", "onlylcoprice": 0, "msoncfprice": "0.00", "lconcftax": "0.00", "lcotax": "0.00", "msotax": "0.00", "ncftax": 0, "msoncftax": "0.00", "lconcfprice": "0.00", "totallcoprice": "0.00", "totallcotax": "0.00", "totalmsoprice": "0.00", "totalmsotax": "0.00", "totalprice": "0.00", "totaltax": "0.00", "channelcount": "100" }, { "producttypename": "Base Packs", "productname": "Foundation Pack 12M", "productid": 1183, "tariffperiod": "YEARLY", "lcoprice": "327.60", "msoprice": "0.00", "price": "0.00", "ncfprice": "1560.00", "tax": "0.00", "onlylcoprice": 0, "msoncfprice": "0.00", "lconcftax": "0.00", "lcotax": "58.96", "msotax": "0.00", "ncftax": 280.8, "msoncftax": "0.00", "lconcfprice": "0.00", "totallcoprice": "386.56", "totallcotax": "58.96", "totalmsoprice": "0.00", "totalmsotax": "0.00", "totalprice": "1840.80", "totaltax": "280.80", "channelcount": "100" }, { "producttypename": "Base Packs", "productname": "Foundation Pack 6M", "productid": 1182, "tariffperiod": "HALFYEARLY", "lcoprice": "167.40", "msoprice": "0.00", "price": "0.00", "ncfprice": "780.00", "tax": "0.00", "onlylcoprice": 0, "msoncfprice": "0.00", "lconcftax": "0.00", "lcotax": "30.14", "msotax": "0.00", "ncftax": 140.4, "msoncftax": "0.00", "lconcfprice": "0.00", "totallcoprice": "197.54", "totallcotax": "30.14", "totalmsoprice": "0.00", "totalmsotax": "0.00", "totalprice": "920.40", "totaltax": "140.40", "channelcount": "100" }, { "producttypename": "Base Packs", "productname": "Foundation Pack 3M", "productid": 1181, "tariffperiod": "QUARTERLY", "lcoprice": "85.50", "msoprice": "0.00", "price": "0.00", "ncfprice": "390.00", "tax": "0.00", "onlylcoprice": 0, "msoncfprice": "0.00", "lconcftax": "0.00", "lcotax": "15.40", "msotax": "0.00", "ncftax": 70.2, "msoncftax": "0.00", "lconcfprice": "0.00", "totallcoprice": "100.90", "totallcotax": "15.40", "totalmsoprice": "0.00", "totalmsotax": "0.00", "totalprice": "460.20", "totaltax": "70.20", "channelcount": "100" }, { "producttypename": "Base Packs", "productname": "Foundation + Gujarati Popular Pack 6M", "productid": 1212, "tariffperiod": "HALFYEARLY", "lcoprice": "1022.37", "msoprice": "0.00", "price": "1018.50", "ncfprice": "780.00", "tax": "183.34", "onlylcoprice": 0, "msoncfprice": "0.00", "lconcftax": "0.00", "lcotax": "184.04", "msotax": "0.00", "ncftax": 140.4, "msoncftax": "0.00", "lconcfprice": "0.00", "totallcoprice": "1206.41", "totallcotax": "184.04", "totalmsoprice": "0.00", "totalmsotax": "0.00", "totalprice": "2122.24", "totaltax": "323.74", "channelcount": "208" }]);
                }
                reject(error);
            });
        });
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state, getters: getters, mutations: mutations, actions: actions
});

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(2);

var state = {};
var getters = {};
var mutations = {};
var actions = {
  getRenewPacks: function getRenewPacks(context, filterData) {
    console.log("got response in report module", filterData);
    return new Promise(function (resolve, reject) {

      //Remove Multiple call code
      // let getRenewSearch = JSON.parse(localStorage.getItem('getRenewSearch'))
      // let lastCustomerSearch = JSON.parse(localStorage.getItem('lastRenewCustomerSearch'))
      // if (getRenewSearch && lastCustomerSearch) {
      //   if (Object.keys(getRenewSearch).length && lastCustomerSearch == filterData.subscriberid) {
      //     resolve(getRenewSearch)
      //     return
      //   }
      // }
      //Remove Multiple call code End

      var queryStr = '';
      queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(filterData);

      fetch(context.getters.baseUrl + '/lco/v1/plan/subscriber' + queryStr, {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        localStorage.setItem("getRenewSearch", JSON.stringify(data));
        localStorage.setItem("lastRenewCustomerSearch", JSON.stringify(filterData.subscriberid));
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getRenewChannel: function getRenewChannel(context, filterData) {
    return new Promise(function (resolve, reject) {
      fetch(context.getters.baseUrl + '/lco/v1/plan/scheduleautorenew' + filterData, {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getAutoRenewPacks: function getAutoRenewPacks(context, filterData) {
    console.log("got response in report module", filterData);
    return new Promise(function (resolve, reject) {

      //Remove Multiple call code
      // let getAutoRenewSearch = JSON.parse(localStorage.getItem('getAutoRenewSearch'))
      // let lastCustomerSearch = JSON.parse(localStorage.getItem('lastAutoRenewCustomerSearch'))
      // if (getAutoRenewSearch && lastCustomerSearch) {
      //   if (Object.keys(getAutoRenewSearch).length && lastCustomerSearch == filterData.subscriberid) {
      //     resolve(getAutoRenewSearch)
      //     return
      //   }
      // }
      //Remove Multiple call code End

      var queryStr = '';
      queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(filterData);

      fetch(context.getters.baseUrl + '/lco/v1/plan/scheduleautorenew' + queryStr, {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        localStorage.setItem("getAutoRenewSearch", JSON.stringify(data));
        localStorage.setItem("lastAutoRenewCustomerSearch", JSON.stringify(filterData.subscriberid));
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  activateAutoRenew: function activateAutoRenew(context, formdata) {
    return new Promise(function (resolve, reject) {
      localStorage.removeItem("getAutoRenewSearch");
      localStorage.removeItem("lastAutoRenewCustomerSearch");

      if (!formdata) {
        reject({ error: "formdata not found" });
      }
      var data = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["b" /* makeQueryFormDataDyn */])(formdata);
      fetch(context.getters.baseUrl + '/lco/v1/plan/actiavteplan', {
        method: 'POST',
        body: data
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {

        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  deactivateAutoRenew: function deactivateAutoRenew(context, formdata) {
    return new Promise(function (resolve, reject) {
      localStorage.removeItem("getAutoRenewSearch");
      localStorage.removeItem("lastAutoRenewCustomerSearch");

      if (!formdata) {
        reject({ error: "formdata not found" });
      }
      var data = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["b" /* makeQueryFormDataDyn */])(formdata);
      fetch(context.getters.baseUrl + '/lco/v1/plan/deactiavteplan', {
        method: 'POST',
        body: data
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {

        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  changeValidity: function changeValidity(context, formdata) {
    return new Promise(function (resolve, reject) {
      localStorage.removeItem("getAutoRenewSearch");
      localStorage.removeItem("lastAutoRenewCustomerSearch");

      if (!formdata) {
        reject({ error: "formdata not found" });
      }
      var data = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["b" /* makeQueryFormDataDyn */])(formdata);
      fetch(context.getters.baseUrl + '/lco/v1/plan/changevalidity', {
        method: 'POST',
        body: data
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {

        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  autoSchedule: function autoSchedule(context, formdata) {
    return new Promise(function (resolve, reject) {
      localStorage.removeItem("getAutoRenewSearch");
      localStorage.removeItem("lastAutoRenewCustomerSearch");

      if (!formdata) {
        reject({ error: "formdata not found" });
      }
      var data = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["b" /* makeQueryFormDataDyn */])(formdata);
      fetch(context.getters.baseUrl + '/lco/v1/plan.php/schedule', {
        method: 'POST',
        body: data
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.text();
      }).then(function (data) {

        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state, getters: getters, mutations: mutations, actions: actions
});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(2);



var state = {
    selectedPackageDetails: []
};

var getters = {
    getSelectedPackageDetails: function getSelectedPackageDetails(state) {
        return state.selectedPackageDetails;
    }
};

var mutations = {
    setSelectedPackageDetails: function setSelectedPackageDetails(state, data) {
        state.selectedPackageDetails = data;
    }
};

var actions = {
    actGetDisconnectedList: function actGetDisconnectedList(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            //Remove Multiple call code
            // let getDisconnectSearch = JSON.parse(localStorage.getItem('getDisconnectSearch'))
            // let lastCustomerSearch = JSON.parse(localStorage.getItem('lastDisonnectCustomerSearch'))
            // if (getDisconnectSearch && lastCustomerSearch) {
            //     if (Object.keys(getDisconnectSearch).length && lastCustomerSearch == payload.subscriberid) {
            //     resolve(getDisconnectSearch)
            //     return
            //     }
            // }
            //Remove Multiple call code End

            var queryStr = '';
            queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(payload);
            fetch(context.getters.baseUrl + '/lco/v1/disconnect.php' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                localStorage.setItem("getDisconnectSearch", JSON.stringify(data));
                localStorage.setItem("lastDisonnectCustomerSearch", JSON.stringify(payload.subscriberid));
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    actGetReconnectList: function actGetReconnectList(context, payload) {
        return new Promise(function (resolve, reject) {
            //Remove Multiple call code
            // let getReconnectearch = JSON.parse(localStorage.getItem('getReconnectearch'))
            // let lastCustomerSearch = JSON.parse(localStorage.getItem('lastReconnectCustomerSearch'))
            // if (getReconnectearch && lastCustomerSearch) {
            //     if (Object.keys(getReconnectearch).length && lastCustomerSearch == payload.subscriberid) {
            //     resolve(getReconnectearch)
            //     return
            //     }
            // }
            //Remove Multiple call code End
            if (!payload) {
                reject({ error: "payload not found" });
            }

            var queryStr = '';

            queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(payload);

            fetch(context.getters.baseUrl + '/lco/v1/reconnect.php' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                localStorage.setItem("getReconnectearch", JSON.stringify(data));
                localStorage.setItem("lastReconnectCustomerSearch", JSON.stringify(payload.subscriberid));
                resolve(data);
            }).catch(function (error) {

                reject(error);
            });
        });
    },
    actGetCancelList: function actGetCancelList(context, payload) {
        return new Promise(function (resolve, reject) {

            //Remove Multiple call code
            // let getCancelSearch = JSON.parse(localStorage.getItem('getCancelSearch'))
            // let lastCustomerSearch = JSON.parse(localStorage.getItem('lastCancelCustomerSearch'))
            // if (getCancelSearch && lastCustomerSearch) {
            //     if (Object.keys(getCancelSearch).length && lastCustomerSearch == payload.subscriberid) {
            //     resolve(getCancelSearch)
            //     return
            //     }
            // }
            //Remove Multiple call code End

            if (!payload) {
                reject({ error: "payload not found" });
            }

            var queryStr = '';
            queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(payload);

            fetch(context.getters.baseUrl + '/lco/v1/plan/cancelproduct.php' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                localStorage.setItem("getCancelSearch", JSON.stringify(data));
                localStorage.setItem("lastCancelCustomerSearch", JSON.stringify(payload.subscriberid));
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    disconnectPack: function disconnectPack(context, formdata) {
        return new Promise(function (resolve, reject) {
            fetch(context.getters.baseUrl + '/lco/v1/disconnect.php', {
                method: 'POST',
                body: formdata
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {

                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    reconnectPack: function reconnectPack(context, formdata) {
        return new Promise(function (resolve, reject) {
            fetch(context.getters.baseUrl + '/lco/v1/reconnect.php', {
                method: 'POST',
                body: formdata
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {

                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    cancelPack: function cancelPack(context, formdata) {
        return new Promise(function (resolve, reject) {
            fetch(context.getters.baseUrl + '/lco/v1/plan/cancel', {
                method: 'POST',
                body: formdata
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    getbasepack: function getbasepack(context, filterData) {
        var newurl = filterData.url;
        delete filterData.url;
        return new Promise(function (resolve, reject) {
            //Remove Multiple call code
            // if (newurl == '/lco/v1/plan/subscriber') {
            //     let getChangeBaseSearch = JSON.parse(localStorage.getItem('getChangeBaseSearch'))
            //     let lastModifyCustomerSearch = JSON.parse(localStorage.getItem('lastChangebaseCustomerSearch'))
            //     if (getChangeBaseSearch && lastModifyCustomerSearch) {
            //         if (Object.keys(getChangeBaseSearch).length && lastModifyCustomerSearch == filterData.subscriberid) {
            //             resolve(getChangeBaseSearch)
            //             return
            //         }
            //     }
            // }
            //Remove Multiple call code End
            var queryStr = '';
            queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(filterData);

            fetch(context.getters.baseUrl + newurl + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                if (newurl == '/lco/v1/plan/subscriber') {
                    localStorage.setItem("getChangeBaseSearch", JSON.stringify(data));
                    localStorage.setItem("lastChangebaseCustomerSearch", JSON.stringify(filterData.subscriberid));
                }
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    getchangevaliditypackData: function getchangevaliditypackData(context, filterData) {
        var newurl = filterData.url;
        delete filterData.url;
        return new Promise(function (resolve, reject) {
            //Remove Multiple call code
            // let getChangeValiditySearch = JSON.parse(localStorage.getItem('getChangeValiditySearch'))
            // let lastModifyCustomerSearch = JSON.parse(localStorage.getItem('lastChangeValidiyCustomerSearch'))
            // if (getChangeValiditySearch && lastModifyCustomerSearch) {
            //     if (Object.keys(getChangeValiditySearch).length && lastModifyCustomerSearch == filterData.subscriberid) {
            //     resolve(getChangeValiditySearch)
            //     return
            //     }
            // }
            //Remove Multiple call code End
            var queryStr = '';
            queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(filterData);

            fetch(context.getters.baseUrl + newurl + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                localStorage.setItem("getChangeValiditySearch", JSON.stringify(data));
                localStorage.setItem("lastChangeValidiyCustomerSearch", JSON.stringify(filterData.subscriberid));
                resolve(data);
            }).catch(function (error) {
                if (context.getters.getMode == "development") {
                    resolve({ "status": "A", "name": "testtest test01", "mobile": 8987876767, "email": "", "balance": -354, "subscriberid": 27018460, "frcode": "FR5125", "frcan": 20893551, "region": "MUM", "customertype": "NPR02", "nonrenewable": false, "customertag": { "0": "SD STB Foundation FREE DN00368 2021SEP@Rs 800" }, "hardwaretype": "MPEG2", "basepack": "YES", "planlist": [{ "status": "ACTIVE", "contractstatus": "A", "planname": "Foundation + BANGLA Power", "contractno": 189775598, "plancode": "BST00032PP", "tariffperiod": "3", "validity": "2022-02-01", "planid": "JoJP9HYL", "plantype": "BASE", "servicecode": "[\"BST00014CS\",\"BST00032CS\"]", "packagecode": "[\"BST0033PKG\"]", "description": "Foundation + BANGLA Power", "lcoprice": "579.15", "mrptariff": "1455.00", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "discountedlcoprice": null, "ncfprice": "126.00", "hardwaretype": "ALL", "plancategory": "NORMAL", "numchannels": "216" }, { "status": "ACTIVE", "contractstatus": "A", "planname": "&FLIX", "contractno": 189775599, "plancode": "ALA0001PP", "tariffperiod": "1", "validity": "2021-12-01", "planid": "JWtNA2Kf", "plantype": "CHANNEL", "servicecode": "[\"ALA0001CS\"]", "packagecode": null, "description": "&flix", "lcoprice": "13.50", "mrptariff": "15.00", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "discountedlcoprice": null, "ncfprice": "0.00", "hardwaretype": "ALL", "plancategory": "NCF", "numchannels": "1" }, { "status": "ACTIVE", "contractstatus": "A", "planname": "CHHOTA PACK", "contractno": 189775623, "plancode": "INB090935D", "tariffperiod": "3", "validity": "2021-11-12", "planid": "91UTk6OR", "plantype": "PACKAGE", "servicecode": "[\"INB00118CS\"]", "packagecode": "", "description": "Test plan 3\/5Days", "lcoprice": "3.00", "mrptariff": "3.00", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "planmode": "RENEWABLE", "tariffperiodtype": "D", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "discountedlcoprice": null, "ncfprice": "0.00", "hardwaretype": "ALL", "plancategory": "NORMAL", "numchannels": "5" }, { "status": "ACTIVE", "contractstatus": "A", "planname": "OTT PLAN", "contractno": 189775571, "plancode": "OTTPLAN", "tariffperiod": "30", "validity": "2021-12-25", "planid": "XX4u9SfH", "plantype": "CHANNEL", "servicecode": "", "packagecode": "", "description": "OTT PLAN", "lcoprice": "300.00", "mrptariff": "300.00", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "planmode": "RENEWABLE", "tariffperiodtype": "D", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "discountedlcoprice": null, "ncfprice": "0.00", "hardwaretype": "ALL", "plancategory": "NORMAL", "numchannels": "5" }, { "status": "ACTIVE", "contractstatus": "A", "planname": "GUJARATI PLUS", "contractno": 189775624, "plancode": "INB0005PP", "tariffperiod": "3", "validity": "2022-02-09", "planid": "5Re42KuC", "plantype": "PACKAGE", "servicecode": "[\"INB0005CS\"]", "packagecode": "", "description": "GUJARATI PLUS", "lcoprice": "350.34", "mrptariff": "130.25", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "discountedlcoprice": null, "ncfprice": "27.00", "hardwaretype": "ALL", "plancategory": "NORMAL", "numchannels": "77" }], "channelcount": 1, "validityplans": [{ "planid": "Q0ug2Lt9", "planname": "Foundation + BANGLA Power", "plantype": "BASE", "plancode": "BST00032PP", "servicecode": "[\"BST00014CS\",\"BST00032CS\"]", "packagecode": "[\"BST0033PKG\"]", "description": "Foundation + BANGLA Power", "lcoprice": "2316.60", "mrptariff": "5820.00", "tariffperiod": "12", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "504.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NORMAL", "numchannels": "216", "schedulestatus": "NO", "renewtill": null }, { "planid": "qGrSCtdn", "planname": "Foundation + BANGLA Power", "plantype": "BASE", "plancode": "BST00032PP", "servicecode": "[\"BST00014CS\",\"BST00032CS\"]", "packagecode": "[\"BST0033PKG\"]", "description": "Foundation + BANGLA Power", "lcoprice": "1158.32", "mrptariff": "2910.00", "tariffperiod": "6", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "252.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NORMAL", "numchannels": "216", "schedulestatus": "NO", "renewtill": null }, { "planid": "rYn2NjRE", "planname": "FOUNDATION + BANGLA POWER", "plantype": "BASE", "plancode": "BST00032PP", "servicecode": "[\"BST00014CS\",\"BST00032CS\"]", "packagecode": "[\"BST0033PKG\"]", "description": "BST BANGLA Power", "lcoprice": "193.05", "mrptariff": "485.00", "tariffperiod": "1", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "42.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NORMAL", "numchannels": "216", "schedulestatus": "NO", "renewtill": null }, { "planid": "AeMbiAHk", "planname": "CHHOTA PACK", "plantype": "PACKAGE", "plancode": "INB090935D", "servicecode": "[\"INB00118CS\"]", "packagecode": "", "description": "Test plan 3\/5Days", "lcoprice": "5.00", "mrptariff": "5.00", "tariffperiod": "5", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "D", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "0.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NORMAL", "numchannels": "5", "schedulestatus": "NO", "renewtill": null }, { "planid": "DpRlX3GL", "planname": "OTT PLAN", "plantype": "CHANNEL", "plancode": "OTTPLAN", "servicecode": "", "packagecode": "", "description": "OTT PLAN", "lcoprice": "1800.00", "mrptariff": "1800.00", "tariffperiod": "180", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "D", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "0.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NORMAL", "numchannels": "5", "schedulestatus": "NO", "renewtill": null }, { "planid": "VvfdRUMU", "planname": "OTT PLAN", "plantype": "CHANNEL", "plancode": "OTTPLAN", "servicecode": "", "packagecode": "", "description": "OTT PLAN", "lcoprice": "900.00", "mrptariff": "900.00", "tariffperiod": "90", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "D", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "0.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NORMAL", "numchannels": "5", "schedulestatus": "NO", "renewtill": null }, { "planid": "3CmJPWYi", "planname": "GUJARATI PLUS", "plantype": "PACKAGE", "plancode": "INB0005PP", "servicecode": "[\"INB0005CS\"]", "packagecode": "", "description": "GUJARATI PLUS", "lcoprice": "1401.36", "mrptariff": "130.25", "tariffperiod": "12", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "108.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NORMAL", "numchannels": "77", "schedulestatus": "NO", "renewtill": null }, { "planid": "3ldoD8GJ", "planname": "GUJARATI PLUS", "plantype": "PACKAGE", "plancode": "INB0005PP", "servicecode": "[\"INB0005CS\"]", "packagecode": "", "description": "GUJARATI PLUS", "lcoprice": "700.68", "mrptariff": "130.25", "tariffperiod": "6", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "54.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NORMAL", "numchannels": "77", "schedulestatus": "NO", "renewtill": null }, { "planid": "9g8TJcca", "planname": "GUJARATI PLUS", "plantype": "PACKAGE", "plancode": "INB0005PP", "servicecode": "[\"INB0005CS\"]", "packagecode": null, "description": "GUJARATI PLUS", "lcoprice": "116.78", "mrptariff": "130.25", "tariffperiod": "1", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "9.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NORMAL", "numchannels": "77", "schedulestatus": "YES", "renewtill": null }] });
                    return;
                }
                reject(error);
            });
        });
    },
    actGetDisconnectForRefundList: function actGetDisconnectForRefundList(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }

            //Remove Multiple call code
            // let getDisconnectRefundSearch = JSON.parse(localStorage.getItem('getDisconnectRefundSearch'))
            // let lastModifyCustomerSearch = JSON.parse(localStorage.getItem('lastRefundCustomerSearch'))
            // if (getDisconnectRefundSearch && lastModifyCustomerSearch) {
            //     if (Object.keys(getDisconnectRefundSearch).length && lastModifyCustomerSearch == payload.subscriberid) {
            //     resolve(getDisconnectRefundSearch)
            //     return
            //     }
            // }
            //Remove Multiple call code End

            var queryStr = '';
            queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(payload);
            fetch(context.getters.baseUrl + '/lco/v1/disconnect.php' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                localStorage.setItem("getDisconnectRefundSearch", JSON.stringify(data));
                localStorage.setItem("lastRefundCustomerSearch", JSON.stringify(payload.subscriberid));
                resolve(data);
            }).catch(function (error) {
                if (context.getters.getMode == "development") {
                    resolve({ "0": { "status": "ACTIVE", "contractstatus": "A", "planname": "ALANKAR", "contractno": 141350963, "plancode": "ALA0017PP", "tariffperiod": "1", "validity": "2020-06-05", "planid": "FqTU6LZ9", "plantype": "CHANNEL", "servicecode": "[\"ALA0017CS\"]", "packagecode": null, "description": "ALANKAR", "lcoprice": "3.60", "mrptariff": "4.00", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "discountedlcoprice": null, "ncfprice": "0.00", "hardwaretype": "ALL", "plancategory": "NCF", "numchannels": "1" }, "1": { "status": "ACTIVE", "contractstatus": "A", "planname": "&FLIX", "contractno": 141198026, "plancode": "ALA0001PP", "tariffperiod": "1", "validity": "2020-06-04", "planid": "JWtNA2Kf", "plantype": "CHANNEL", "servicecode": "[\"ALA0001CS\"]", "packagecode": null, "description": "&flix", "lcoprice": "13.50", "mrptariff": "15.00", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "discountedlcoprice": null, "ncfprice": "0.00", "hardwaretype": "ALL", "plancategory": "NCF", "numchannels": "1" }, "2": { "status": "ACTIVE", "contractstatus": "A", "planname": "Foundation + IN HINDI SUPER ENTERTAINMENT PACK", "contractno": 141109084, "plancode": "BST00013PP", "tariffperiod": "1", "validity": "2020-06-03", "planid": "YW8Rel2U", "plantype": "BASE", "servicecode": "[\"BST00014CS\",\"INB00082CS\"]", "packagecode": "[\"BST0056PKG\"]", "description": "Foundation + IN HINDI SUPER ENTERTAINMENT PACK", "lcoprice": "151.43", "mrptariff": "168.25", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "discountedlcoprice": null, "ncfprice": "39.00", "hardwaretype": "ALL", "plancategory": "NORMAL", "numchannels": "201" }, "name": "Shree Sai Cable Video Network Swo" });
                }
                reject(error);
            });
        });
    },
    deactivateValidityPlan: function deactivateValidityPlan(context, payload) {
        return new Promise(function (resolve, reject) {
            var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);
            fetch(context.getters.baseUrl + '/lco/v1/plan/deactiavteplan', {
                method: 'POST',
                body: data
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                if (context.getters.getMode == "development") {
                    resolve({ "success": "1" });
                    return;
                }
                reject(error);
            });
        });
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state, getters: getters, mutations: mutations, actions: actions
});

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(2);

var state = {};
var getters = {};
var mutations = {};

var actions = {

    uploadCSVFile: function uploadCSVFile(context, formData) {
        console.log("reached");
        return new Promise(function (resolve, reject) {
            fetch(context.getters.baseUrl + '/lco/v1/fileupload.php', {
                method: 'POST',
                body: formData
            }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.text();
            }).then(function (data) {
                console.log("data", data);
                resolve(data);
            }).catch(function (error) {
                console.log("error", error);
                reject(error);
            });
        });
    },
    activateCSV: function activateCSV(context, formData) {
        console.log(formData);
        var url = formData.url;
        delete formData.url;
        return new Promise(function (resolve, reject) {
            var param = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["b" /* makeQueryFormDataDyn */])(formData);
            fetch(context.getters.baseUrl + '/lco/v1' + url, {
                method: 'POST',
                body: param
            }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.text();
            }).then(function (data) {

                resolve(data);
            }).catch(function (error) {
                console.log("error", error);

                reject(error);
            });
        });
    },
    downloadCSVFile: function downloadCSVFile(context) {
        return new Promise(function (resolve, reject) {
            fetch(context.getters.baseUrl + '/bulkactivatetemplatedownload.php', {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.text();
            }).then(function (data) {

                resolve(data);
            }).catch(function (error) {

                reject(error);
            });
        });
    },
    totalPlanPrice: function totalPlanPrice(context, data) {
        return new Promise(function (resolve, reject) {
            var queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(data);
            fetch(context.getters.baseUrl + '/lco/v1/plan/totalplanprice' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    }
};
/* harmony default export */ __webpack_exports__["a"] = ({
    state: state, getters: getters, mutations: mutations, actions: actions
});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(2);


var state = {
    stbData: undefined,
    smcData: undefined
};

var getters = {
    getStbData: function getStbData(state) {
        return state.stbData;
    },
    getSmcData: function getSmcData(state) {
        return state.smcData;
    }
};

var mutations = {
    setStbData: function setStbData(state, data) {
        state.stbData = data;
    },
    setSmcData: function setSmcData(state, data) {
        state.smcData = data;
    }
};

var actions = {

    actPostRetrack: function actPostRetrack(context, payload) {
        console.log("actPostRetrack module check");
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            console.log(payload);
            var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);
            fetch(context.getters.baseUrl + '/lco/v1/hardware/retrack', {
                method: 'POST',
                body: data
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    actPostRetrackDeactive: function actPostRetrackDeactive(context, payload) {
        console.log("actPostRetrack module check");
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            console.log(payload);
            var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);
            fetch(context.getters.baseUrl + '/lco/v1/hardware/retrack-deactive', {
                method: 'POST',
                body: data
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    actGetDeviceDeatils: function actGetDeviceDeatils(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }

            var dataObj = {};
            var queryStr = '';
            dataObj = {
                'customerno': payload.replacenum
            };

            queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(dataObj);

            fetch(context.getters.baseUrl + '/lco/v1/hardware/getdevicedetails' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                if (context.getters.getMode == "development") {
                    resolve({ "castype": "CLK", "stbno": "214121642536673", "stbitemcode": "MSTBNG01", "entityid": "FR5125", "customercan": "20788451", "smcno": "030080342527", "smcitemcode": "MSMC01" });
                    return;
                }
                reject(error);
            });
        });
    },
    actPostReplacement: function actPostReplacement(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);
            fetch(context.getters.baseUrl + '/lco/v1/hardware/swap', {
                method: 'POST',
                body: data
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    actGetBanner: function actGetBanner(context, payload) {
        return new Promise(function (resolve, reject) {
            if (payload.bannertype == 'BANNER') {
                var alertBANNER = JSON.parse(localStorage.getItem('alertBANNER'));
                if (alertBANNER) {
                    if (Object.keys(alertBANNER).length) {
                        resolve(alertBANNER);
                        return;
                    }
                }
            } else if (payload.bannertype == 'OFFER') {
                var alertOFFERBanner = JSON.parse(localStorage.getItem('alertOFFERBanner'));
                if (alertOFFERBanner) {
                    if (Object.keys(alertOFFERBanner).length) {
                        resolve(alertOFFERBanner);
                        return;
                    }
                }
            } else if (payload.bannertype == 'NXTUDAAN') {
                var alertNXTUDAANBanner = JSON.parse(localStorage.getItem('alertNXTUDAANBanner'));
                if (alertNXTUDAANBanner) {
                    if (Object.keys(alertNXTUDAANBanner).length) {
                        resolve(alertNXTUDAANBanner);
                        return;
                    }
                }
            } else if (payload.bannertype == 'SAL') {
                var alertSALBanner = JSON.parse(localStorage.getItem('alertSALBanner'));
                if (alertSALBanner) {
                    if (Object.keys(alertSALBanner).length) {
                        resolve(alertSALBanner);
                        return;
                    }
                }
            }

            if (!payload) {
                reject({ error: "payload not found" });
            }
            var dataObj = {};
            var queryStr = '';
            dataObj = {
                'bannertype': payload.bannertype,
                'page': '1'
            };
            queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(dataObj);
            fetch(context.getters.baseUrl + '/lco/v1/banner' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                if (payload.bannertype == 'BANNER') {
                    localStorage.setItem("alertBANNER", JSON.stringify(data));
                } else if (payload.bannertype == 'OFFER') {
                    localStorage.setItem("alertOFFERBanner", JSON.stringify(data));
                } else if (payload.bannertype == 'NXTUDAAN') {
                    localStorage.setItem("alertNXTUDAANBanner", JSON.stringify(data));
                } else if (payload.bannertype == 'SAL') {
                    localStorage.setItem("alertSALBanner", JSON.stringify(data));
                }
                resolve(data);
            }).catch(function (error) {
                if (context.getters.getMode == "development") {
                    resolve([{ "promoadsid": "31", "filename": "DP5vLzUv.jpg", "adtype": "BANNER", "weight": "1", "adstatus": "ACTIVE", "created": "2020-09-14 09:17:33", "url": "https:\/\/s3.ap-south-1.amazonaws.com\/com.kyc.dpcollection.incablenet.mum\/images\/promo\/DP5vLzUv.jpg" }, { "promoadsid": "27", "filename": "iNf87UUa.jpg", "adtype": "BANNER", "weight": "1", "adstatus": "ACTIVE", "created": "2020-07-31 10:29:53", "url": "https:\/\/s3.ap-south-1.amazonaws.com\/com.kyc.dpcollection.incablenet.mum\/images\/promo\/iNf87UUa.jpg" }, { "promoadsid": "28", "filename": "YoDbqAIx.jpg", "adtype": "BANNER", "weight": "2", "adstatus": "ACTIVE", "created": "2020-07-31 10:30:52", "url": "https:\/\/s3.ap-south-1.amazonaws.com\/com.kyc.dpcollection.incablenet.mum\/images\/promo\/YoDbqAIx.jpg" }]);
                }
                reject(error);
            });
        });
    },
    actPostOsd: function actPostOsd(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);
            fetch(context.getters.baseUrl + '/lco/v1/hardware/osd', {
                method: 'POST',
                body: data
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    getPayForBox: function getPayForBox(context, filterData) {
        return new Promise(function (resolve, reject) {
            var queryStr = '';
            queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(filterData);

            fetch(context.getters.baseUrl + '/lco/v1/lcopaymentreport/payforboxpayment' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                if (context.getters.getMode == "development") {
                    resolve([{ "payboxid": "6738687", "boxtype": "Adaptor - 5V", "quantity": "1", "model": "test", "comments": "test", "created": "2020-07-22 15:32:57", "lcoid": "h7juP6Xn", "totalprice": "150.00", "gateway": "PAYTM", "status": "CANCELLED", "boxprice": "150.00", "transactionid": "20200722111212800110168813737465650" }, { "payboxid": "6738662", "boxtype": "Adaptor - 12V", "quantity": "1", "model": "test", "comments": "test", "created": "2020-07-22 15:29:23", "lcoid": "h7juP6Xn", "totalprice": "150.00", "gateway": "PAYTM", "status": "CANCELLED", "boxprice": "150.00", "transactionid": "20200722111212800110168486737092817" }, { "payboxid": "6141945", "boxtype": "SD_STB to HD MPEG4 STB @599", "quantity": "1", "model": "saa", "comments": "", "created": "2020-05-25 12:33:34", "lcoid": "h7juP6Xn", "totalprice": "599.00", "gateway": "PAYTM", "status": "CANCELLED", "boxprice": "599.00", "transactionid": "20200525111212800110168463728802254" }, { "payboxid": "6112935", "boxtype": "Attenuator", "quantity": "1", "model": "Megha Test", "comments": "", "created": "2020-05-21 17:35:02", "lcoid": "h7juP6Xn", "totalprice": "10.00", "gateway": "PAYTM", "status": "PAID", "boxprice": "10.00", "transactionid": "20200521111212800110168497428417754" }, { "payboxid": "6112919", "boxtype": "Attenuator", "quantity": "1", "model": "Megha Test", "comments": "", "created": "2020-05-21 17:33:42", "lcoid": "h7juP6Xn", "totalprice": "1.00", "gateway": "PAYTM", "status": "CANCELLED", "boxprice": "10.00", "transactionid": "20200521111212800110168079728510941" }, { "payboxid": "6108001", "boxtype": "Conax Set Top Box", "quantity": "2", "model": "tt", "comments": "", "created": "2020-05-21 12:53:38", "lcoid": "h7juP6Xn", "totalprice": "2400.00", "gateway": "PAYTM", "status": "CANCELLED", "boxprice": "1200.00", "transactionid": "20200521111212800110168707028093422" }, { "payboxid": "6108000", "boxtype": "Conax Set Top Box", "quantity": "2", "model": "tt", "comments": "", "created": "2020-05-21 12:53:37", "lcoid": "h7juP6Xn", "totalprice": "2400.00", "gateway": "PAYTM", "status": "CANCELLED", "boxprice": "1200.00", "transactionid": "20200521111212800110168711328205563" }, { "payboxid": "6107997", "boxtype": "Adaptor - 12V", "quantity": "100", "model": "1000", "comments": "", "created": "2020-05-21 12:53:28", "lcoid": "h7juP6Xn", "totalprice": "15000.00", "gateway": "PAYTM", "status": "CANCELLED", "boxprice": "150.00", "transactionid": "20200521111212800110168273928652526" }, { "payboxid": "6105728", "boxtype": "Attenuator", "quantity": "1", "model": "trai", "comments": "test", "created": "2020-05-21 03:26:49", "lcoid": "h7juP6Xn", "totalprice": "1.00", "gateway": "PAYTM", "status": "PAID", "boxprice": "10.00", "transactionid": "20200521111212800110168476727953278" }, { "payboxid": "6105725", "boxtype": "Attenuator", "quantity": "1", "model": "STB Rukmini", "comments": "", "created": "2020-05-21 02:51:15", "lcoid": "h7juP6Xn", "totalprice": "1.00", "gateway": "PAYTM", "status": "PAID", "boxprice": "10.00", "transactionid": "20200521111212800110168504728248023" }, { "payboxid": "6105724", "boxtype": "Attenuator", "quantity": "1", "model": "test", "comments": "", "created": "2020-05-21 02:50:58", "lcoid": "h7juP6Xn", "totalprice": "1.00", "gateway": "PAYTM", "status": "CANCELLED", "boxprice": "10.00", "transactionid": "20200521111212800110168512428490411" }, { "payboxid": "6105719", "boxtype": "Attenuator", "quantity": "1", "model": "STB Safiqul", "comments": "For Test", "created": "2020-05-21 02:38:53", "lcoid": "h7juP6Xn", "totalprice": "1.00", "gateway": "PAYTM", "status": "PAID", "boxprice": "10.00", "transactionid": "20200521111212800110168776428122658" }, { "payboxid": "6105718", "boxtype": "Attenuator", "quantity": "1", "model": "", "comments": "for testing purpose", "created": "2020-05-21 02:36:57", "lcoid": "h7juP6Xn", "totalprice": "1.00", "gateway": "PAYTM", "status": "CANCELLED", "boxprice": "10.00", "transactionid": "20200521111212800110168787027934157" }, { "payboxid": "6105706", "boxtype": "Attenuator", "quantity": "1", "model": "", "comments": "for testing", "created": "2020-05-21 02:20:43", "lcoid": "h7juP6Xn", "totalprice": "1.00", "gateway": "PAYTM", "status": "PAID", "boxprice": "10.00", "transactionid": "20200521111212800110168112628405611" }, { "payboxid": "6105705", "boxtype": "Attenuator", "quantity": "1", "model": "stb vaibhav", "comments": "for testing", "created": "2020-05-21 02:17:19", "lcoid": "h7juP6Xn", "totalprice": "1.00", "gateway": "PAYTM", "status": "PAID", "boxprice": "10.00", "transactionid": "20200521111212800110168123528213447" }]);
                }
                reject(error);
            });
        });
    },
    getBOXTypeDetails: function getBOXTypeDetails(context, filterData) {
        return new Promise(function (resolve, reject) {

            fetch(context.getters.baseUrl + '/lco/v1/payment/boxprice', {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                if (context.getters.getMode == "development") {
                    resolve([{ "idboxtypeclass": "Adaptor - 12V", "price": "150.00" }, { "idboxtypeclass": "Adaptor - 5V", "price": "150.00" }, { "idboxtypeclass": "Adaptors", "price": "118.00" }, { "idboxtypeclass": "Attenuator", "price": "10.00" }, { "idboxtypeclass": "AV Chord 1 by 3", "price": "125.00" }, { "idboxtypeclass": "AV Chord 3 by 3", "price": "60.00" }, { "idboxtypeclass": "Conax HD Set Top Box", "price": "1550.00" }, { "idboxtypeclass": "Conax JV Set Top Box", "price": "1200.00" }, { "idboxtypeclass": "Conax Set Top Box", "price": "1200.00" }, { "idboxtypeclass": "HD 8120 FESTIVAL DHAMAKA", "price": "1149.00" }, { "idboxtypeclass": "HD 8120 FESTIVAL DHAMAKA - JV", "price": "1600.00" }, { "idboxtypeclass": "HD Hybrid Festival Dhamaka", "price": "1249.00" }, { "idboxtypeclass": "HD Hybrid Festival Dhamaka - J", "price": "1700.00" }, { "idboxtypeclass": "HDMI Cable", "price": "125.00" }, { "idboxtypeclass": "Merlin Embedded Card STB", "price": "399.00" }, { "idboxtypeclass": "Merlin Embedded Card STB - JV", "price": "799.00" }, { "idboxtypeclass": "NSTV Embedded MPEG4 HD HYBRID", "price": "1250.00" }, { "idboxtypeclass": "NSTV OVT Embedded MPEG4 SD", "price": "399.00" }, { "idboxtypeclass": "NSTV OVT Embedded MPEG4 SD - J", "price": "450.00" }, { "idboxtypeclass": "Refurbish MPEG4 MERLIN", "price": "350.00" }, { "idboxtypeclass": "Refurbished STB MPEG4 @ 350", "price": "350.00" }, { "idboxtypeclass": "Remote Type I - SD", "price": "50.00" }, { "idboxtypeclass": "Remote Type II - HD", "price": "125.00" }, { "idboxtypeclass": "Remotes", "price": "118.00" }, { "idboxtypeclass": "Replacement Hardware MPEG4 HD to MPEG4 HD HYBRID", "price": "999.00" }, { "idboxtypeclass": "Replacement Hardware MPEG4 SD to MPEG4 HD (CH8120)", "price": "950.00" }, { "idboxtypeclass": "Replacement Hardware SD to HD HYBRID FR STB @599", "price": "599.00" }, { "idboxtypeclass": "Replacement HD to MPEG4 HD-995", "price": "995.00" }, { "idboxtypeclass": "Replacement Lightning MerlinMPEG4 SD Embedded WithOut Warranty", "price": "700.00" }, { "idboxtypeclass": "Replacement Package Merlin Cardless WithOut Warranty 200", "price": "226.00" }, { "idboxtypeclass": "Replacement Package Merlin With Card WithOut Warranty 1125", "price": "625.00" }, { "idboxtypeclass": "Replacement Package MerlinMPEG4 HD Embedded WithOut Warranty", "price": "505.00" }, { "idboxtypeclass": "Replacement Package MPEG2 To MPEG4", "price": "500.00" }, { "idboxtypeclass": "SD_STB to HD HYBRID STB @599", "price": "599.00" }, { "idboxtypeclass": "SD_STB to HD MPEG4 STB @599", "price": "599.00" }, { "idboxtypeclass": "SD_STB TO OVT@ 399 PAN INDIA", "price": "399.00" }, { "idboxtypeclass": "SD_STB@399 PAN_INDIA", "price": "399.00" }]);
                    return;
                }
                reject(error);
            });
        });
    },
    paymentforPayBoxDetails: function paymentforPayBoxDetails(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);
            fetch(context.getters.baseUrl + '/lco/v1/payment/payforbox', {
                method: 'POST',
                body: data
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    actSendSms: function actSendSms(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);
            fetch(context.getters.baseUrl + '/lco/v1/sendsms', {
                method: 'POST',
                body: data
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    sendAndriodRequest: function sendAndriodRequest(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);
            fetch(context.getters.baseUrl + '/lco/v1/hardware/hwreplacement', {
                method: 'POST',
                body: data
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    actSendExpirySMS: function actSendExpirySMS(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            fetch(context.getters.baseUrl + '/lco/v1/sendsms/bulksendexpirysms', {
                method: 'POST',
                body: payload
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    actPostSTBReturn: function actPostSTBReturn(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            console.log(payload);
            var data = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* makeQueryFormDataDyn */])(payload);
            fetch(context.getters.baseUrl + '/lco/v1/hardware/stbreturn', {
                method: 'POST',
                body: data
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },

    actGetSTBTrack: function actGetSTBTrack(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            var queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(payload);
            fetch(context.getters.baseUrl + '/lco/v1/hardware/devicetrack' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    getDeviceStatus: function getDeviceStatus(context, payload) {
        var queryStr = Object(__WEBPACK_IMPORTED_MODULE_1__helper__["c" /* makeQueryStringDync */])(payload);
        return new Promise(function (resolve, reject) {
            fetch(context.getters.baseUrl + '/lco/v1/hardware/devicestatus' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                if (context.getters.getMode == "development") {
                    resolve({ "count": "52", "data": [{ "city": "Mumbai", "frcode": "FR5125", "lco_name": "SHREE SAI CABLE VIDEO NETWORK", "customer_can": "27138231", "stb_number": "100132200289051", "stb_type": "SD", "status": "ACTIVE", "base_pack": "Foundation + Hindi  Smart", "validity": "1M", "expiry_date": "19-AUG-22", "last_dc_date": null, "firts_name": "Demo Life Time", "last_name": ".", "mobile_no": "9036623729", "stb_war_date": "26-JUN-23", "lco_war_date": "06\/26\/2023" }, { "city": "Mumbai", "frcode": "FR5125", "lco_name": "SHREE SAI CABLE VIDEO NETWORK", "customer_can": "27358692", "stb_number": "214121642530336", "stb_type": "SD", "status": "ACTIVE", "base_pack": "Foundation Pack MH", "validity": "3M", "expiry_date": "05-OCT-22", "last_dc_date": null, "firts_name": "FR5125(SHREE SAI CABLE VIDEO NETWORK)", "last_name": "SWO", "mobile_no": "9845198593", "stb_war_date": "26-JUN-24", "lco_war_date": "06\/02\/2024" }] });
                }
                console.log("not reached");
                reject(error);
            });
        });
    }

};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state, getters: getters, mutations: mutations, actions: actions
});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(2);

var state = {};
var getters = {};
var mutations = {};
var actions = {
  getActivation: function getActivation(context, filterData) {
    return new Promise(function (resolve, reject) {
      var queryStr = '';
      queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(filterData);

      fetch(context.getters.baseUrl + '/lco/v1/activation.php' + queryStr, {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {

        resolve(data);
      }).catch(function (error) {

        reject(error);
      });
    });
  },
  getExpiryReport: function getExpiryReport(context, filterData) {
    return new Promise(function (resolve, reject) {
      var queryStr = '';
      queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(filterData);

      fetch(context.getters.baseUrl + '/lco/v1/expiry.php' + queryStr, {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {

        resolve(data);
      }).catch(function (error) {

        reject(error);
      });
    });
  },
  getExpiredReport: function getExpiredReport(context, filterData) {
    return new Promise(function (resolve, reject) {
      var queryStr = '';
      queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(filterData);

      fetch(context.getters.baseUrl + '/lco/v1/expiry.php/expired' + queryStr, {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getBillsMonthReport: function getBillsMonthReport(context) {
    return new Promise(function (resolve, reject) {
      fetch(context.getters.baseUrl + '/lco/v1/s3folderlist.php', {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (context.getters.getMode == "development") {
          resolve({ "2015": ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "SEP", "OCT", "NOV", "DEC"], "2016": ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"], "2017": ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"], "2018": ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"], "2019": ["JAN", "FEB Supplement", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"], "2020": ["JAN", "FEB", "MAR", "APR"], "temp": ["CRF"] });
        } else {
          resolve(data);
        }
      }).catch(function (error) {
        if (context.getters.getMode == "development") {
          resolve({ "2015": ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "SEP", "OCT", "NOV", "DEC"], "2016": ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"], "2017": ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"], "2018": ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"], "2019": ["JAN", "FEB Supplement", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"], "2020": ["JAN", "FEB", "MAR", "APR"], "temp": ["CRF"] });
          return;
        }
        reject(error);
      });
    });
  },
  getBillsReport: function getBillsReport(context, filterData) {
    return new Promise(function (resolve, reject) {
      var queryStr = '';
      queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(filterData);
      fetch(context.getters.baseUrl + '/lco/v1/bill.php' + queryStr, {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getJobMoniterCReport: function getJobMoniterCReport(context, filterData) {
    return new Promise(function (resolve, reject) {
      var queryStr = '';
      queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(filterData);
      fetch(context.getters.baseUrl + '/lco/v1/plan/bulkjob' + queryStr, {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getRefundReport: function getRefundReport(context, filterData) {
    return new Promise(function (resolve, reject) {
      var queryStr = '';
      queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(filterData);

      fetch(context.getters.baseUrl + '/lco/v1/commision.php' + queryStr, {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        console.log("pass1");

        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getstbReplacementReport: function getstbReplacementReport(context, filterData) {
    return new Promise(function (resolve, reject) {
      var queryStr = '';
      queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(filterData);

      fetch(context.getters.baseUrl + '/lco/v1/hardware/swapreport' + queryStr, {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {

        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getEKYCReport: function getEKYCReport(context, filterData) {
    return new Promise(function (resolve, reject) {
      var queryStr = '';
      queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(filterData);

      fetch(context.getters.baseUrl + '/lco/v1/subscriber/ekyc' + queryStr, {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {

        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getScheduleReport: function getScheduleReport(context, filterData) {
    return new Promise(function (resolve, reject) {
      var queryStr = '';
      queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(filterData);

      fetch(context.getters.baseUrl + '/lco/v1/schedulereport' + queryStr, {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {

        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getPaymentReport: function getPaymentReport(context, filterData) {
    return new Promise(function (resolve, reject) {
      var queryStr = '';
      queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(filterData);

      fetch(context.getters.baseUrl + '/lco/v1/lcopaymentreport.php' + queryStr, {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {

        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getModifiedCustomerReport: function getModifiedCustomerReport(context, filterData) {
    return new Promise(function (resolve, reject) {
      var queryStr = '';
      queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(filterData);

      fetch(context.getters.baseUrl + '/lco/v1/lcocustomerupdatereport' + queryStr, {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getAccountStatmentDetails: function getAccountStatmentDetails(context, filterData) {
    return new Promise(function (resolve, reject) {
      var queryStr = '';
      queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(filterData);

      fetch(context.getters.baseUrl + '/lco/v1/lco/ledgerreport' + queryStr, {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (context.getters.getMode == "development") {
          resolve();
        } else {
          resolve(data);
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getLineGen: function getLineGen(context, filterData) {
    return new Promise(function (resolve, reject) {

      fetch(context.getters.baseUrl + '/lco/v1/lco/lcnandgener', {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        if (context.getters.getMode == "development") {
          resolve([{
            "url": "https://s3.ap-south-1.amazonaws.com/com.kyc.dpcollection.incablenet.mum/LCN&GENER/MUMBAI/INDigital_Mumbai_GEN_I_30092020.pdf",
            "name": "CHANNEL LINE UP"
          }, {
            "url": "https://s3.ap-south-1.amazonaws.com/com.kyc.dpcollection.incablenet.mum/LCN&GENER/MUMBAI/INDigital_Mumbai_GEN_II_30092020.pdf",
            "name": "Channel Line Up GEN II"
          }]);
        }
        return;
        reject(error);
      });
    });
  },
  getWalletDebit: function getWalletDebit(context, filterData) {
    return new Promise(function (resolve, reject) {
      var queryStr = '';
      queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(filterData);
      fetch(context.getters.baseUrl + '/lco/v1/lco/debit' + queryStr, {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        if (context.getters.getMode == "development") {
          resolve({ "count": "21", "data": [{ "paymentid": "4232", "entityid": "h7juP6Xn", "amount": "1.00", "frcode": "FR5125", "comment": "for testing purpose", "authorisedby": "vaibhav", "created": "2020-09-11 18:24:01", "paymentmode": "CA" }, { "paymentid": "4138", "entityid": "h7juP6Xn", "amount": "3.00", "frcode": "FR5125", "comment": "lco debit", "authorisedby": "Megha", "created": "2020-09-08 18:03:55", "paymentmode": "CA" }, { "paymentid": "4137", "entityid": "h7juP6Xn", "amount": "4.00", "frcode": "FR5125", "comment": "lco debit", "authorisedby": "Megha", "created": "2020-09-08 17:53:57", "paymentmode": "CA" }, { "paymentid": "4136", "entityid": "h7juP6Xn", "amount": "1.00", "frcode": "FR5125", "comment": "lco debit testing needs to be done1", "authorisedby": "SANITH", "created": "2020-09-08 17:06:22", "paymentmode": "CA" }, { "paymentid": "4135", "entityid": "h7juP6Xn", "amount": "1.00", "frcode": "FR5125", "comment": "lco debit testing needs to be done1", "authorisedby": "SANITH", "created": "2020-09-08 17:05:46", "paymentmode": "CA" }, { "paymentid": "4134", "entityid": "h7juP6Xn", "amount": "1.00", "frcode": "FR5125", "comment": "lco debit testing needs to be done", "authorisedby": "SANITH", "created": "2020-09-08 15:50:08", "paymentmode": "CA" }, { "paymentid": "4133", "entityid": "h7juP6Xn", "amount": "2.00", "frcode": "FR5125", "comment": "lco debit", "authorisedby": "SANITH", "created": "2020-09-08 15:43:05", "paymentmode": "CA" }, { "paymentid": "4132", "entityid": "h7juP6Xn", "amount": "1.00", "frcode": "FR5125", "comment": "lco debit", "authorisedby": "test", "created": "2020-09-08 15:40:57", "paymentmode": "CA" }, { "paymentid": "4131", "entityid": "h7juP6Xn", "amount": "1.00", "frcode": "FR5125", "comment": "lco debit", "authorisedby": "Megha", "created": "2020-09-08 15:39:32", "paymentmode": "CA" }, { "paymentid": "4130", "entityid": "h7juP6Xn", "amount": "10.00", "frcode": "FR5125", "comment": "lco debit", "authorisedby": "test", "created": "2020-09-08 15:39:02", "paymentmode": "CA" }, { "paymentid": "4127", "entityid": "h7juP6Xn", "amount": "1.00", "frcode": "FR5125", "comment": "lco debit", "authorisedby": "Megha", "created": "2020-09-08 15:34:55", "paymentmode": "CA" }, { "paymentid": "4128", "entityid": "h7juP6Xn", "amount": "1.00", "frcode": "FR5125", "comment": "testing", "authorisedby": "Rukmini", "created": "2020-09-08 15:34:55", "paymentmode": "CA" }, { "paymentid": "3400", "entityid": "h7juP6Xn", "amount": "50.62", "frcode": "FR5125", "comment": "Amount Debited towards Vishesh Manoranjan Pack", "authorisedby": "VP", "created": "2020-09-08 12:47:00", "paymentmode": "CA" }] });
        }
        return;
        reject(error);
      });
    });
  },
  getSingleCustomerPlanList: function getSingleCustomerPlanList(context, payload) {
    return new Promise(function (resolve, reject) {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      var dataObj = {};
      var queryStr = '';
      dataObj = {
        'subscriberid': payload,
        'page': '1',
        'pagelimit': '10'
      };
      queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(dataObj);
      fetch(context.getters.baseUrl + '/lco/v1/expiry/details' + queryStr, {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getConsolidatedData: function getConsolidatedData(context, filterData) {
    return new Promise(function (resolve, reject) {
      var queryStr = '';
      queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(filterData);
      fetch(context.getters.baseUrl + '/lco/v1/consolidatereport-list' + queryStr, {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getDCRefundData: function getDCRefundData(context, filterData) {
    return new Promise(function (resolve, reject) {
      var queryStr = '';
      queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(filterData);
      fetch(context.getters.baseUrl + '/lco/v1/lcodcrefundreport/dcrefundreport' + queryStr, {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  get15DaysReport: function get15DaysReport(context) {
    return new Promise(function (resolve, reject) {
      fetch(context.getters.baseUrl + 'lco/v1/expiry-download-report', {
        method: 'GET'
      }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
        return response.blob();
      }).then(function (blob) {
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = 'expiry15days.csv';
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);

        resolve(true);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state, getters: getters, mutations: mutations, actions: actions
});

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(2);

var state = {};
var getters = {};
var mutations = {};
var actions = {
    getPDFDetails: function getPDFDetails(context) {
        return new Promise(function (resolve, reject) {
            var url = '/lco/v1/downloadfile';
            fetch(context.getters.baseUrl + url, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                if (context.getters.getMode == "development") {
                    resolve([{ "iddownloadablefiles": "17", "name": "COVID-19 AWARENESS", "filename": "Userguide_v1.11.pdf", "purpose": "LCO Portal User Guide", "created": "2020-09-21 11:58:00", "type": "PDF", "url": "https:\/\/s3.ap-south-1.amazonaws.com\/com.kyc.dpcollection.incablenet.mum\/download\/Userguide_v1.11.pdf?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAZTWJZDEUJKBH6SWE%2F20201209%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20201209T145832Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=488e11278238410304d36235a62833f80b8c2ec404535822fc19294c9fe9e430", "thumbnail": null, "category": null, "categoryid": null }, { "iddownloadablefiles": "19", "name": "GST FAQ", "filename": "FREQUENTLY_ASKED_QUESTIONS_GST.pdf", "purpose": "GST FAQ", "created": "2020-10-14 18:24:04", "type": "PDF", "url": "https:\/\/s3.ap-south-1.amazonaws.com\/com.kyc.dpcollection.incablenet.mum\/download\/FREQUENTLY_ASKED_QUESTIONS_GST.pdf?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAZTWJZDEUJKBH6SWE%2F20201209%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20201209T145832Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=8771dd3a71468daef3e8cf094769b8c0014a939f1c785e40f76c27c1739da6c0", "thumbnail": null, "category": null, "categoryid": null }, { "iddownloadablefiles": "20", "name": "Axis Bank Easy Pay Slip", "filename": "axiseasypayslip.pdf", "purpose": "Axis Bank Easy Pay Slip", "created": "2020-10-14 18:24:42", "type": "PDF", "url": "https:\/\/s3.ap-south-1.amazonaws.com\/com.kyc.dpcollection.incablenet.mum\/download\/axiseasypayslip.pdf?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAZTWJZDEUJKBH6SWE%2F20201209%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20201209T145832Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=f87cc1e9b679ea2a89ea48e68165d58111d481d9a93a3a8a555eb70b22c5ce08", "thumbnail": null, "category": null, "categoryid": null }, { "iddownloadablefiles": "21", "name": "MIB Letter", "filename": "MIB_Letter_to_ALL_DM.pdf", "purpose": "MIB Letter", "created": "2020-10-14 18:25:21", "type": "PDF", "url": "https:\/\/s3.ap-south-1.amazonaws.com\/com.kyc.dpcollection.incablenet.mum\/download\/MIB_Letter_to_ALL_DM.pdf?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAZTWJZDEUJKBH6SWE%2F20201209%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20201209T145832Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=c7eda036cfa4b01f0c7c8d3293ea380e65ead7603fc3aa971da9613368d6531b", "thumbnail": null, "category": null, "categoryid": null }, { "iddownloadablefiles": "22", "name": "MIB Advisory", "filename": "MIB_Advisory_to_MSO_LCO.pdf", "purpose": "MIB Advisory", "created": "2020-10-14 18:26:02", "type": "PDF", "url": "https:\/\/s3.ap-south-1.amazonaws.com\/com.kyc.dpcollection.incablenet.mum\/download\/MIB_Advisory_to_MSO_LCO.pdf?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAZTWJZDEUJKBH6SWE%2F20201209%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20201209T145832Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=974203cca5cacd931057449c0d03fe5b409e7ef17a98051f57702bad9cf10bb4", "thumbnail": null, "category": null, "categoryid": null }, { "iddownloadablefiles": "23", "name": "Third Party Deposit Authorization", "filename": "authorisation_letter.pdf", "purpose": "Third Party Deposit Authorization", "created": "2020-10-14 18:27:09", "type": "PDF", "url": "https:\/\/s3.ap-south-1.amazonaws.com\/com.kyc.dpcollection.incablenet.mum\/download\/authorisation_letter.pdf?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAZTWJZDEUJKBH6SWE%2F20201209%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20201209T145832Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=9de969b8be753a64a78f5705b9ef1a264710820a1a94a997572933bd74bb2308", "thumbnail": null, "category": null, "categoryid": null }, { "iddownloadablefiles": "26", "name": "Axis EasyPay Circular", "filename": "PDF_Notification.pdf", "purpose": "Axis EasyPay Circular", "created": "2020-10-14 18:51:26", "type": "PDF", "url": "https:\/\/s3.ap-south-1.amazonaws.com\/com.kyc.dpcollection.incablenet.mum\/download\/PDF_Notification.pdf?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAZTWJZDEUJKBH6SWE%2F20201209%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20201209T145832Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=9e0b6a7569e3b7d74e88772e9891d6aa10733a4f3680343846a2029176ca579b", "thumbnail": null, "category": null, "categoryid": null }, { "iddownloadablefiles": "35", "name": "HELP VIDEOS", "filename": null, "purpose": "Helping", "created": "2020-12-09 12:32:55", "type": "PDF", "url": "https:\/\/s3.ap-south-1.amazonaws.com\/com.kyc.dpcollection.incablenet.mum\/download\/?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAZTWJZDEUJKBH6SWE%2F20201209%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20201209T145832Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=dfef63c2a9e085a9a7dc0869d38c23b38f874e53036258570b5002dc3b21bb5c", "thumbnail": null, "category": null, "categoryid": null }, { "iddownloadablefiles": "35", "name": "COVID-19 AWARENESS", "filename": null, "purpose": "covid", "created": "2020-12-09 12:32:55", "type": "PDF", "url": "https:\/\/s3.ap-south-1.amazonaws.com\/com.kyc.dpcollection.incablenet.mum\/download\/?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAZTWJZDEUJKBH6SWE%2F20201209%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20201209T145832Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=dfef63c2a9e085a9a7dc0869d38c23b38f874e53036258570b5002dc3b21bb5c", "thumbnail": null, "category": null, "categoryid": null }]);
                    return;
                }
                reject(error);
            });
        });
    },
    getPDFLink: function getPDFLink(context, filename) {
        return new Promise(function (resolve, reject) {
            var url = '/lco/v1/downloadfile/';
            fetch(context.getters.baseUrl + url + filename, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {

                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    getVideoDetails: function getVideoDetails(context, payload) {
        return new Promise(function (resolve, reject) {
            var queryStr = '';
            queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(payload);
            var url = '/lco/v1/downloadfile';
            fetch(context.getters.baseUrl + url + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                if (context.getters.getMode == "development") {
                    resolve([{ "iddownloadablefiles": "27", "name": "Help Vedio -1 ", "filename": null, "purpose": "Helping", "created": "2020-12-07 10:08:36", "type": "MP4", "url": "https:\/\/d9xhhw2q0vx7g.cloudfront.net\/videos\/7JoYo5Xf\/9ufqizffEy1C_manifest.mpd", "thumbnail": "http:\/\/indigital.co.in\/media\/images\/IN_Digital_Direct%20Point%20Subscribers.png", "category": "HINDI", "categoryid": "1" }, { "iddownloadablefiles": "28", "name": "Help Vedio -1 ", "filename": null, "purpose": "Helping", "created": "2020-12-07 10:08:36", "type": "MP4", "url": "https:\/\/d9xhhw2q0vx7g.cloudfront.net\/videos\/7JoYo5Xf\/9ufqizffEy1C_manifest.mpd", "thumbnail": "http:\/\/indigital.co.in\/media\/images\/IN_Digital_Direct%20Point%20Subscribers.png", "category": "ENGLISH", "categoryid": "1" }, { "iddownloadablefiles": "29", "name": "Help Vedio -2", "filename": null, "purpose": "Helping", "created": "2020-12-07 10:08:36", "type": "MP4", "url": "https:\/\/d9xhhw2q0vx7g.cloudfront.net\/videos\/7JoYo5Xf\/9ufqizffEy1C_manifest.mpd", "thumbnail": "http:\/\/indigital.co.in\/media\/images\/IN_Digital_Direct%20Point%20Subscribers.png", "category": "HINDI", "categoryid": "2" }, { "iddownloadablefiles": "30", "name": "Help Vedio -2", "filename": null, "purpose": "Helping", "created": "2020-12-07 10:08:36", "type": "MP4", "url": "https:\/\/d9xhhw2q0vx7g.cloudfront.net\/videos\/7JoYo5Xf\/9ufqizffEy1C_manifest.mpd", "thumbnail": "http:\/\/indigital.co.in\/media\/images\/IN_Digital_Direct%20Point%20Subscribers.png", "category": "ENGLISH", "categoryid": "2" }, { "iddownloadablefiles": "31", "name": "Help Vedio -3", "filename": null, "purpose": "Helping", "created": "2020-12-07 10:08:36", "type": "MP4", "url": "https:\/\/d9xhhw2q0vx7g.cloudfront.net\/videos\/7JoYo5Xf\/9ufqizffEy1C_manifest.mpd", "thumbnail": "http:\/\/indigital.co.in\/media\/images\/IN_Digital_Direct%20Point%20Subscribers.png", "category": "HINDI", "categoryid": "3" }, { "iddownloadablefiles": "32", "name": "Help Vedio -3", "filename": null, "purpose": "Helping", "created": "2020-12-07 10:08:36", "type": "MP4", "url": "https:\/\/d9xhhw2q0vx7g.cloudfront.net\/videos\/7JoYo5Xf\/9ufqizffEy1C_manifest.mpd", "thumbnail": "http:\/\/indigital.co.in\/media\/images\/IN_Digital_Direct%20Point%20Subscribers.png", "category": "ENGLISH", "categoryid": "3" }, { "iddownloadablefiles": "33", "name": "Help Vedio -4", "filename": null, "purpose": "Helping", "created": "2020-12-07 10:08:36", "type": "MP4", "url": "https:\/\/d9xhhw2q0vx7g.cloudfront.net\/videos\/7JoYo5Xf\/9ufqizffEy1C_manifest.mpd", "thumbnail": "http:\/\/indigital.co.in\/media\/images\/IN_Digital_Direct%20Point%20Subscribers.png", "category": "HINDI", "categoryid": "4" }, { "iddownloadablefiles": "34", "name": "Help Vedio -4", "filename": null, "purpose": "Helping", "created": "2020-12-07 10:08:36", "type": "MP4", "url": "https:\/\/d9xhhw2q0vx7g.cloudfront.net\/videos\/7JoYo5Xf\/9ufqizffEy1C_manifest.mpd", "thumbnail": "http:\/\/indigital.co.in\/media\/images\/IN_Digital_Direct%20Point%20Subscribers.png", "category": "ENGLISH", "categoryid": "4" }]);
                    return;
                }
                resolve(data);
            }).catch(function (error) {
                if (context.getters.getMode == "development") {
                    resolve([{
                        "iddownloadablefiles": "45",
                        "name": "MODIFY PACKS / SCHEDULE PACKS / HARDWARE REPLACEMENT / MANAGING TICKETS",
                        "filename": "HELP VIDEO",
                        "purpose": "HELP VIDEO",
                        "created": "2024-06-14 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/%281%29Modifying%20Packs%20%282%29Schedule%20Packs%20%283%29Hardware%20Replacement%20%284%29Managing%20Tickets_ENGLISH.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                        "category": "ENGLISH",
                        "categoryid": "1"
                    }, {
                        "iddownloadablefiles": "46",
                        "name": "MODIFY PACKS / SCHEDULE PACKS / HARDWARE REPLACEMENT / MANAGING TICKETS",
                        "filename": "HELP VIDEO",
                        "purpose": "HELP VIDEO",
                        "created": "2024-06-14 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/%281%29Modifying%20Packs%20%282%29Schedule%20Packs%20%283%29Hardware%20Replacement%20%284%29Managing%20Tickets_HINDI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                        "category": "HINDI",
                        "categoryid": "1"
                    }, {
                        "iddownloadablefiles": "47",
                        "name": "MODIFY PACKS / SCHEDULE PACKS / HARDWARE REPLACEMENT / MANAGING TICKETS",
                        "filename": "HELP VIDEO",
                        "purpose": "HELP VIDEO",
                        "created": "2024-06-14 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/%281%29Modifying%20Packs%20%282%29Schedule%20Packs%20%283%29Hardware%20Replacement%20%284%29Managing%20Tickets_MARATHI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                        "category": "MARATHI",
                        "categoryid": "1"
                    }, {
                        "iddownloadablefiles": "48",
                        "name": "MODIFY PACKS / SCHEDULE PACKS / HARDWARE REPLACEMENT / MANAGING TICKETS",
                        "filename": "HELP VIDEO",
                        "purpose": "HELP VIDEO",
                        "created": "2024-06-14 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/%281%29Modifying%20Packs%20%282%29Schedule%20Packs%20%283%29Hardware%20Replacement%20%284%29Managing%20Tickets_GUJARATI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                        "category": "GUJARATI",
                        "categoryid": "1"
                    }, {
                        "iddownloadablefiles": "49",
                        "name": "MODIFY PACKS / SCHEDULE PACKS / HARDWARE REPLACEMENT / MANAGING TICKETS",
                        "filename": "HELP VIDEO",
                        "purpose": "HELP VIDEO",
                        "created": "2024-06-14 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/%281%29Modifying%20Packs%20%282%29Schedule%20Packs%20%283%29Hardware%20Replacement%20%284%29Managing%20Tickets_BENGALI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                        "category": "BANGALI",
                        "categoryid": "1"
                    }, {
                        "iddownloadablefiles": "50",
                        "name": "MODIFY PACKS / SCHEDULE PACKS / HARDWARE REPLACEMENT / MANAGING TICKETS",
                        "filename": "HELP VIDEO",
                        "purpose": "HELP VIDEO",
                        "created": "2024-06-14 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/%281%29Modifying%20Packs%20%282%29Schedule%20Packs%20%283%29Hardware%20Replacement%20%284%29Managing%20Tickets_ODIA.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                        "category": "ODIA",
                        "categoryid": "1"
                    }, {
                        "iddownloadablefiles": "51",
                        "name": "MODIFY PACKS / SCHEDULE PACKS / HARDWARE REPLACEMENT / MANAGING TICKETS",
                        "filename": "HELP VIDEO",
                        "purpose": "HELP VIDEO",
                        "created": "2024-06-14 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/%281%29Modifying%20Packs%20%282%29Schedule%20Packs%20%283%29Hardware%20Replacement%20%284%29Managing%20Tickets_TAMIL.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                        "category": "TAMIL",
                        "categoryid": "1"
                    }, {
                        "iddownloadablefiles": "52",
                        "name": "MODIFY PACKS / SCHEDULE PACKS / HARDWARE REPLACEMENT / MANAGING TICKETS",
                        "filename": "HELP VIDEO",
                        "purpose": "HELP VIDEO",
                        "created": "2024-06-14 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/%281%29Modifying%20Packs%20%282%29Schedule%20Packs%20%283%29Hardware%20Replacement%20%284%29Managing%20Tickets_TELUGU.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                        "category": "TELUGU",
                        "categoryid": "1"
                    }, {
                        "iddownloadablefiles": "53",
                        "name": "MODIFY PACKS / SCHEDULE PACKS / HARDWARE REPLACEMENT / MANAGING TICKETS",
                        "filename": "HELP VIDEO",
                        "purpose": "HELP VIDEO",
                        "created": "2024-06-14 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/%281%29Modifying%20Packs%20%282%29Schedule%20Packs%20%283%29Hardware%20Replacement%20%284%29Managing%20Tickets_KANNADA.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                        "category": "KANNADA",
                        "categoryid": "1"
                    }, {
                        "iddownloadablefiles": "54",
                        "name": "MODIFY PACKS / SCHEDULE PACKS / HARDWARE REPLACEMENT / MANAGING TICKETS",
                        "filename": "HELP VIDEO",
                        "purpose": "HELP VIDEO",
                        "created": "2024-06-14 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/%281%29Modifying%20Packs%20%282%29Schedule%20Packs%20%283%29Hardware%20Replacement%20%284%29Managing%20Tickets_PunjabiiI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                        "category": "PUNJABI",
                        "categoryid": "1"
                    }, {
                        "iddownloadablefiles": "55",
                        "name": "MANAGE SUBSCRIBERS / RENEW PACKS / LATEST ANNOUNCEMENTS",
                        "filename": "HELP VIDEO",
                        "purpose": "HELP VIDEO",
                        "created": "2024-06-14 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/%281%29Manage%20Subscribers%20%282%29Renew%20Packs%20%283%29Latest%20Announcements_ENGLISH.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                        "category": "ENGLISH",
                        "categoryid": "2"
                    }, {
                        "iddownloadablefiles": "56",
                        "name": "MANAGE SUBSCRIBERS / RENEW PACKS / LATEST ANNOUNCEMENTS",
                        "filename": "HELP VIDEO",
                        "purpose": "HELP VIDEO",
                        "created": "2024-06-14 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/%281%29Manage%20Subscribers%20%282%29Renew%20Packs%20%283%29Latest%20Announcements_HINDI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                        "category": "HINDI",
                        "categoryid": "2"
                    }, {
                        "iddownloadablefiles": "57",
                        "name": "MANAGE SUBSCRIBERS / RENEW PACKS / LATEST ANNOUNCEMENTS",
                        "filename": "HELP VIDEO",
                        "purpose": "HELP VIDEO",
                        "created": "2024-06-14 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/%281%29Manage%20Subscribers%20%282%29Renew%20Packs%20%283%29Latest%20Announcements_MARATHI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                        "category": "MARATHI",
                        "categoryid": "2"
                    }, {
                        "iddownloadablefiles": "58",
                        "name": "MANAGE SUBSCRIBERS / RENEW PACKS / LATEST ANNOUNCEMENTS",
                        "filename": "HELP VIDEO",
                        "purpose": "HELP VIDEO",
                        "created": "2024-06-14 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/%281%29Manage%20Subscribers%20%282%29Perform%20Transactions%20%283%29Latest%20Announcements_GUJARATI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                        "category": "GUJARATI",
                        "categoryid": "2"
                    }, {
                        "iddownloadablefiles": "59",
                        "name": "MANAGE SUBSCRIBERS / RENEW PACKS / LATEST ANNOUNCEMENTS",
                        "filename": "HELP VIDEO",
                        "purpose": "HELP VIDEO",
                        "created": "2024-06-14 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/%281%29Manage%20Subscribers%20%282%29Renew%20Packs%20%283%29Latest%20Announcements_BENGALI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                        "category": "BANGALI",
                        "categoryid": "2"
                    }, {
                        "iddownloadablefiles": "60",
                        "name": "MANAGE SUBSCRIBERS / RENEW PACKS / LATEST ANNOUNCEMENTS",
                        "filename": "HELP VIDEO",
                        "purpose": "HELP VIDEO",
                        "created": "2024-06-14 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/%281%29Manage%20Subscribers%20%282%29Perform%20Transactions%20%283%29Latest%20Announcements_ODIA.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                        "category": "ODIA",
                        "categoryid": "2"
                    }, {
                        "iddownloadablefiles": "61",
                        "name": "MANAGE SUBSCRIBERS / RENEW PACKS / LATEST ANNOUNCEMENTS",
                        "filename": "HELP VIDEO",
                        "purpose": "HELP VIDEO",
                        "created": "2024-06-14 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/%281%29Manage%20Subscribers%20%282%29Renew%20Packs%20%283%29Latest%20Announcements_TAMIL.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                        "category": "TAMIL",
                        "categoryid": "2"
                    }, {
                        "iddownloadablefiles": "62",
                        "name": "MANAGE SUBSCRIBERS / RENEW PACKS / LATEST ANNOUNCEMENTS",
                        "filename": "HELP VIDEO",
                        "purpose": "HELP VIDEO",
                        "created": "2024-06-14 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/%281%29Manage%20Subscribers%20%282%29Renew%20Packs%20%283%29Latest%20Announcements_TELUGU.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                        "category": "TELUGU",
                        "categoryid": "2"
                    }, {
                        "iddownloadablefiles": "63",
                        "name": "MANAGE SUBSCRIBERS / RENEW PACKS / LATEST ANNOUNCEMENTS",
                        "filename": "HELP VIDEO",
                        "purpose": "HELP VIDEO",
                        "created": "2024-06-14 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/%281%29Manage%20Subscribers%20%282%29Renew%20Packs%20%283%29Latest%20Announcements_KANNADA.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                        "category": "KANNADA",
                        "categoryid": "2"
                    }, {
                        "iddownloadablefiles": "64",
                        "name": "MANAGE SUBSCRIBERS / RENEW PACKS / LATEST ANNOUNCEMENTS",
                        "filename": "HELP VIDEO",
                        "purpose": "HELP VIDEO",
                        "created": "2024-06-14 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/%281%29Manage%20Subscribers%20%282%29Renew%20Packs%20%283%29Latest%20Announcements_PunjabiiI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                        "category": "PUNJABI",
                        "categoryid": "2"
                    }, {
                        "iddownloadablefiles": "65",
                        "name": "BULK PROCESSING /  CREATE SUBUSERS / COMPREHENSIVE REPORTS",
                        "filename": "HELP VIDEO",
                        "purpose": "HELP VIDEO",
                        "created": "2024-06-14 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video3/%281%29Bulk%20Processing%20%282%29Create%20Sub%20Users%20%283%29Comprehensive%20Reports_ENGLISH.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                        "category": "ENGLISH",
                        "categoryid": "3"
                    }, {
                        "iddownloadablefiles": "66",
                        "name": "BULK PROCESSING /  CREATE SUBUSERS / COMPREHENSIVE REPORTS",
                        "filename": "HELP VIDEO",
                        "purpose": "HELP VIDEO",
                        "created": "2024-06-14 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video3/%281%29Bulk%20Processing%20%282%29Create%20Sub%20Users%20%283%29%20Comprehensive%20Reports_HINDI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                        "category": "HINDI",
                        "categoryid": "3"
                    }, {
                        "iddownloadablefiles": "67",
                        "name": "BULK PROCESSING /  CREATE SUBUSERS / COMPREHENSIVE REPORTS",
                        "filename": "HELP VIDEO",
                        "purpose": "HELP VIDEO",
                        "created": "2024-06-14 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video3/%281%29Bulk%20Processing%20%282%29Create%20Sub%20Users%20%283%29%20Comprehensive%20Reports_MARATHI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                        "category": "MARATHI",
                        "categoryid": "3"
                    }, {
                        "iddownloadablefiles": "68",
                        "name": "BULK PROCESSING /  CREATE SUBUSERS / COMPREHENSIVE REPORTS",
                        "filename": "HELP VIDEO",
                        "purpose": "HELP VIDEO",
                        "created": "2024-06-14 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video3/%281%29Bulk%20Processing%20%282%29Create%20Sub%20Users%20%283%29Comprehensive%20Reports_GUJARATI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                        "category": "GUJARATI",
                        "categoryid": "3"
                    }, {
                        "iddownloadablefiles": "69",
                        "name": "BULK PROCESSING /  CREATE SUBUSERS / COMPREHENSIVE REPORTS",
                        "filename": "HELP VIDEO",
                        "purpose": "HELP VIDEO",
                        "created": "2024-06-14 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video3/%281%29Bulk%20Processing%20%282%29Create%20Sub%20Users%20%283%29Comprehensive%20Reports_BENGALI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                        "category": "BANGALI",
                        "categoryid": "3"
                    }, {
                        "iddownloadablefiles": "70",
                        "name": "BULK PROCESSING /  CREATE SUBUSERS / COMPREHENSIVE REPORTS",
                        "filename": "HELP VIDEO",
                        "purpose": "HELP VIDEO",
                        "created": "2024-06-14 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video3/%281%29Bulk%20Processing%20%282%29Create%20Sub%20Users%20%283%29%20Comprehensive%20Reports_ODIA.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                        "category": "ODIA",
                        "categoryid": "3"
                    }, {
                        "iddownloadablefiles": "71",
                        "name": "BULK PROCESSING /  CREATE SUBUSERS / COMPREHENSIVE REPORTS",
                        "filename": "HELP VIDEO",
                        "purpose": "HELP VIDEO",
                        "created": "2024-06-14 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video3/%281%29Bulk%20Processing%20%282%29Create%20Sub%20Users%20%283%29%20Comprehensive%20Reports_TAMIL.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                        "category": "TAMIL",
                        "categoryid": "3"
                    }, {
                        "iddownloadablefiles": "72",
                        "name": "BULK PROCESSING /  CREATE SUBUSERS / COMPREHENSIVE REPORTS",
                        "filename": "HELP VIDEO",
                        "purpose": "HELP VIDEO",
                        "created": "2024-06-14 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video3/%281%29Bulk%20Processing%20%282%29Create%20Sub%20Users%20%283%29%20Comprehensive%20Reports_TELUGU.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                        "category": "TELUGU",
                        "categoryid": "3"
                    }, {
                        "iddownloadablefiles": "73",
                        "name": "BULK PROCESSING /  CREATE SUBUSERS / COMPREHENSIVE REPORTS",
                        "filename": "HELP VIDEO",
                        "purpose": "HELP VIDEO",
                        "created": "2024-06-14 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video3/%281%29Bulk%20Processing%20%282%29Create%20Sub%20Users%20%283%29%20Comprehensive%20Reports_KANNADA.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                        "category": "KANNADA",
                        "categoryid": "3"
                    }, {
                        "iddownloadablefiles": "74",
                        "name": "BULK PROCESSING /  CREATE SUBUSERS / COMPREHENSIVE REPORTS",
                        "filename": "HELP VIDEO",
                        "purpose": "HELP VIDEO",
                        "created": "2024-06-14 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video3/%281%29Bulk%20Processing%20%282%29Create%20Sub%20Users%20%283%29%20Comprehensive%20Reports_PunjabiiI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                        "category": "PUNJABI",
                        "categoryid": "3"
                    }, {
                        "iddownloadablefiles": "76",
                        "name": "LCO MOBILE APP",
                        "filename": "HELP VIDEO",
                        "purpose": "HELP VIDEO",
                        "created": "2024-06-14 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/%281%29Manage%20Subscribers%20%282%29Perform%20Transactions%20%283%29Latest%20Announcements_ENGLISH.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO%20APP.png",
                        "category": "ENGLISH",
                        "categoryid": "4"
                    }, {
                        "iddownloadablefiles": "77",
                        "name": "LCO MOBILE APP",
                        "filename": "HELP VIDEO",
                        "purpose": "HELP VIDEO",
                        "created": "2024-06-14 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/%281%29Manage%20Subscribers%20%282%29Perform%20Transactions%20%283%29Latest%20Announcements_HINDI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO%20APP.png",
                        "category": "HINDI",
                        "categoryid": "4"
                    }, {
                        "iddownloadablefiles": "78",
                        "name": "LCO MOBILE APP",
                        "filename": "HELP VIDEO",
                        "purpose": "HELP VIDEO",
                        "created": "2024-06-14 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/%281%29Manage%20Subscribers%20%282%29Perform%20Transactions%20%283%29Latest%20Announcements_MARATHI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO%20APP.png",
                        "category": "MARATHI",
                        "categoryid": "4"
                    }, {
                        "iddownloadablefiles": "79",
                        "name": "LCO MOBILE APP",
                        "filename": "HELP VIDEO",
                        "purpose": "HELP VIDEO",
                        "created": "2024-06-14 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/%281%29Manage%20Subscribers%20%282%29Perform%20Transactions%20%283%29Latest%20Announcements_GUJARATI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO%20APP.png",
                        "category": "GUJARATI",
                        "categoryid": "4"
                    }, {
                        "iddownloadablefiles": "80",
                        "name": "LCO MOBILE APP",
                        "filename": "HELP VIDEO",
                        "purpose": "HELP VIDEO",
                        "created": "2024-06-14 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/%281%29Manage%20Subscribers%20%282%29Perform%20Transactions%20%283%29Latest%20Announcements_GUJARATI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO%20APP.png",
                        "category": "BENGALI",
                        "categoryid": "4"
                    }, {
                        "iddownloadablefiles": "81",
                        "name": "LCO MOBILE APP",
                        "filename": "HELP VIDEO",
                        "purpose": "HELP VIDEO",
                        "created": "2024-06-14 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/%281%29Manage%20Subscribers%20%282%29Perform%20Transactions%20%283%29Latest%20Announcements_ODIA.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO%20APP.png",
                        "category": "ODIA",
                        "categoryid": "4"
                    }, {
                        "iddownloadablefiles": "82",
                        "name": "LCO MOBILE APP",
                        "filename": "HELP VIDEO",
                        "purpose": "HELP VIDEO",
                        "created": "2024-06-14 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/%281%29Manage%20Subscribers%20%282%29Perform%20Transactions%20%283%29Latest%20Announcements_TAMIL.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO%20APP.png",
                        "category": "TAMIL",
                        "categoryid": "4"
                    }, {
                        "iddownloadablefiles": "83",
                        "name": "LCO MOBILE APP",
                        "filename": "HELP VIDEO",
                        "purpose": "HELP VIDEO",
                        "created": "2024-06-14 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/%281%29Manage%20Subscribers%20%282%29Perform%20Transactions%20%283%29Latest%20Announcements_TELUGU.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO%20APP.png",
                        "category": "TELUGU",
                        "categoryid": "4"
                    }, {
                        "iddownloadablefiles": "84",
                        "name": "LCO MOBILE APP",
                        "filename": "HELP VIDEO",
                        "purpose": "HELP VIDEO",
                        "created": "2024-06-14 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/%281%29Manage%20Subscribers%20%282%29Perform%20Transactions%20%283%29Latest%20Announcements_KANNADA.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO%20APP.png",
                        "category": "KANNADA",
                        "categoryid": "4"
                    }, {
                        "iddownloadablefiles": "85",
                        "name": "LCO MOBILE APP",
                        "filename": "HELP VIDEO",
                        "purpose": "HELP VIDEO",
                        "created": "2024-06-14 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/%281%29Manage%20Subscribers%20%282%29Perform%20Transactions%20%283%29Latest%20Announcements_PunjabiiI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO%20APP.png",
                        "category": "PUNJABI",
                        "categoryid": "4"
                    }, {
                        "iddownloadablefiles": "207",
                        "name": "Modifying Packs / Schedule Packs",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video%20-%20%281%29Modifying%20Packs%20%2B%20Schedule%20Packs-ENGLISH.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "ENGLISH",
                        "categoryid": "6"
                    }, {
                        "iddownloadablefiles": "208",
                        "name": "Modifying Packs / Schedule Packs",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/%281%29Modifying%20Packs%20%282%29Schedule%20Packs%20%283%29Hardware%20Replacement%20%284%29Managing%20Tickets_HINDI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "HINDI",
                        "categoryid": "6"
                    }, {
                        "iddownloadablefiles": "209",
                        "name": "Modifying Packs / Schedule Packs",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/%281%29Modifying%20Packs%20%282%29Schedule%20Packs%20%283%29Hardware%20Replacement%20%284%29Managing%20Tickets_MARATHI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "MARATHI",
                        "categoryid": "6"
                    }, {
                        "iddownloadablefiles": "210",
                        "name": "Modifying Packs / Schedule Packs",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/%281%29Modifying%20Packs%20%282%29Schedule%20Packs%20%283%29Hardware%20Replacement%20%284%29Managing%20Tickets_GUJARATI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "GUJARATI",
                        "categoryid": "6"
                    }, {
                        "iddownloadablefiles": "211",
                        "name": "Modifying Packs / Schedule Packs",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/%281%29Modifying%20Packs%20%282%29Schedule%20Packs%20%283%29Hardware%20Replacement%20%284%29Managing%20Tickets_BENGALI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "BENGALI",
                        "categoryid": "6"
                    }, {
                        "iddownloadablefiles": "212",
                        "name": "Modifying Packs / Schedule Packs",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/%281%29Modifying%20Packs%20%282%29Schedule%20Packs%20%283%29Hardware%20Replacement%20%284%29Managing%20Tickets_ODIA.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "ODIA",
                        "categoryid": "6"
                    }, {
                        "iddownloadablefiles": "213",
                        "name": "Modifying Packs / Schedule Packs",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/%281%29Modifying%20Packs%20%282%29Schedule%20Packs%20%283%29Hardware%20Replacement%20%284%29Managing%20Tickets_TAMIL.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "TAMIL",
                        "categoryid": "6"
                    }, {
                        "iddownloadablefiles": "214",
                        "name": "Modifying Packs / Schedule Packs",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/%281%29Modifying%20Packs%20%282%29Schedule%20Packs%20%283%29Hardware%20Replacement%20%284%29Managing%20Tickets_TELUGU.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "TELUGU",
                        "categoryid": "6"
                    }, {
                        "iddownloadablefiles": "215",
                        "name": "Modifying Packs / Schedule Packs",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/%281%29Modifying%20Packs%20%282%29Schedule%20Packs%20%283%29Hardware%20Replacement%20%284%29Managing%20Tickets_KANNADA.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "KANNADA",
                        "categoryid": "6"
                    }, {
                        "iddownloadablefiles": "216",
                        "name": "Modifying Packs / Schedule Packs",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/%281%29Modifying%20Packs%20%282%29Schedule%20Packs%20%283%29Hardware%20Replacement%20%284%29Managing%20Tickets_PunjabiiI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "PUNJABI",
                        "categoryid": "6"
                    }, {
                        "iddownloadablefiles": "217",
                        "name": "Retrack / Hardware Replacement",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-%282%29Retrack%20%2B%20Hardware%20Replacement-ENGLISH.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "ENGLISH",
                        "categoryid": "7"
                    }, {
                        "iddownloadablefiles": "218",
                        "name": "Retrack / Hardware Replacement",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-%282%29Retrack%20%2B%20Hardware%20Replacement-HINDI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "HINDI",
                        "categoryid": "7"
                    }, {
                        "iddownloadablefiles": "219",
                        "name": "Retrack / Hardware Replacement",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-%282%29Retrack%20%2B%20Hardware%20Replacement-MARATHI%281%29.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "MARATHI",
                        "categoryid": "7"
                    }, {
                        "iddownloadablefiles": "220",
                        "name": "Retrack / Hardware Replacement",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-%282%29Retrack%20%2B%20Hardware%20Replacement-GUJARATI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "GUJARATI",
                        "categoryid": "7"
                    }, {
                        "iddownloadablefiles": "221",
                        "name": "Retrack / Hardware Replacement",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-%282%29Retrack%20%2B%20Hardware%20Replacement-BANGALI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "BENGALI",
                        "categoryid": "7"
                    }, {
                        "iddownloadablefiles": "222",
                        "name": "Retrack / Hardware Replacement",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-%282%29Retrack%20%2B%20Hardware%20Replacement-ODIA.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "ODIA",
                        "categoryid": "7"
                    }, {
                        "iddownloadablefiles": "223",
                        "name": "Retrack / Hardware Replacement",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-%282%29Retrack%20%2B%20Hardware%20Replacement-TAMIL.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "TAMIL",
                        "categoryid": "7"
                    }, {
                        "iddownloadablefiles": "224",
                        "name": "Retrack / Hardware Replacement",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-%282%29Retrack%20%2B%20Hardware%20Replacement-TELUGU.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "TELUGU",
                        "categoryid": "7"
                    }, {
                        "iddownloadablefiles": "225",
                        "name": "Retrack / Hardware Replacement",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-%282%29Retrack%20%2B%20Hardware%20Replacement-KANNADA.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "KANNADA",
                        "categoryid": "7"
                    }, {
                        "iddownloadablefiles": "226",
                        "name": "Retrack / Hardware Replacement",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-%282%29Retrack%20%2B%20Hardware%20Replacement-PunjabiiI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "PUNJABI",
                        "categoryid": "7"
                    }, {
                        "iddownloadablefiles": "227",
                        "name": "Customer Profile / KYC /  Managing Tickets",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-%283%29Customer%20Profile%20%2B%20KYC%20%2B%20Managing%20Tickets-ENGLISH.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "ENGLISH",
                        "categoryid": "8"
                    }, {
                        "iddownloadablefiles": "228",
                        "name": "Customer Profile / KYC /  Managing Tickets",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-%283%29Customer%20Profile%20%2B%20KYC%20%2B%20Managing%20Tickets-HINDI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "HINDI",
                        "categoryid": "8"
                    }, {
                        "iddownloadablefiles": "229",
                        "name": "Customer Profile / KYC /  Managing Tickets",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-%283%29Customer%20Profile%20%2B%20KYC%20%2B%20Managing%20Tickets-MARATHI%281%29.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "MARATHI",
                        "categoryid": "8"
                    }, {
                        "iddownloadablefiles": "230",
                        "name": "Customer Profile / KYC /  Managing Tickets",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-%283%29Customer%20Profile%20%2B%20KYC%20%2B%20Managing%20Tickets-GUJARATI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "GUJARATI",
                        "categoryid": "8"
                    }, {
                        "iddownloadablefiles": "231",
                        "name": "Customer Profile / KYC /  Managing Tickets",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-%283%29Customer%20Profile%20%2B%20KYC%20%2B%20Managing%20Tickets-BANGALI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "BENGALI",
                        "categoryid": "8"
                    }, {
                        "iddownloadablefiles": "232",
                        "name": "Customer Profile / KYC /  Managing Tickets",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-%283%29Customer%20Profile%20%2B%20KYC%20%2B%20Managing%20Tickets-ODIA.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "ODIA",
                        "categoryid": "8"
                    }, {
                        "iddownloadablefiles": "233",
                        "name": "Customer Profile / KYC /  Managing Tickets",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-%283%29Customer%20Profile%20%2B%20KYC%20%2B%20Managing%20Tickets-TAMIL.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "TAMIL",
                        "categoryid": "8"
                    }, {
                        "iddownloadablefiles": "234",
                        "name": "Customer Profile / KYC /  Managing Tickets",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-%283%29Customer%20Profile%20%2B%20KYC%20%2B%20Managing%20Tickets-TELUGU.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "TELUGU",
                        "categoryid": "8"
                    }, {
                        "iddownloadablefiles": "235",
                        "name": "Customer Profile / KYC /  Managing Tickets",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-%283%29Customer%20Profile%20%2B%20KYC%20%2B%20Managing%20Tickets-KANNADA.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "KANNADA",
                        "categoryid": "8"
                    }, {
                        "iddownloadablefiles": "236",
                        "name": "Customer Profile / KYC /  Managing Tickets",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-%283%29Customer%20Profile%20%2B%20KYC%20%2B%20Managing%20Tickets-PunjabiiI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "PUNJABI",
                        "categoryid": "8"
                    }, {
                        "iddownloadablefiles": "237",
                        "name": "Manage Subscribers",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Manage%20Subscribers-ENGLISH.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "ENGLISH",
                        "categoryid": "9"
                    }, {
                        "iddownloadablefiles": "238",
                        "name": "Manage Subscribers",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Manage%20Subscribers-HINDI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "HINDI",
                        "categoryid": "9"
                    }, {
                        "iddownloadablefiles": "239",
                        "name": "Manage Subscribers",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Manage%20Subscribers-MARATHI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "MARATHI",
                        "categoryid": "9"
                    }, {
                        "iddownloadablefiles": "240",
                        "name": "Manage Subscribers",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Manage%20Subscribers-GUJARATI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "GUJARATI",
                        "categoryid": "9"
                    }, {
                        "iddownloadablefiles": "241",
                        "name": "Manage Subscribers",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Manage%20Subscribers-BANGALI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "BENGALI",
                        "categoryid": "9"
                    }, {
                        "iddownloadablefiles": "242",
                        "name": "Manage Subscribers",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Manage%20Subscribers-ODIA.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "ODIA",
                        "categoryid": "9"
                    }, {
                        "iddownloadablefiles": "243",
                        "name": "Manage Subscribers",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Manage%20Subscribers-TAMIL.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "TAMIL",
                        "categoryid": "9"
                    }, {
                        "iddownloadablefiles": "244",
                        "name": "Manage Subscribers",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Manage%20Subscribers-TELUGU.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "TELUGU",
                        "categoryid": "9"
                    }, {
                        "iddownloadablefiles": "245",
                        "name": "Manage Subscribers",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Manage%20Subscribers-KANNADA.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "KANNADA",
                        "categoryid": "9"
                    }, {
                        "iddownloadablefiles": "246",
                        "name": "Manage Subscribers",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Manage%20Subscribers-PunjabiiI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "PUNJABI",
                        "categoryid": "9"
                    }, {
                        "iddownloadablefiles": "247",
                        "name": "Top Up / Add Packs",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Top%20Up%20%2B%20Add%20Packs-ENGLISH.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "ENGLISH",
                        "categoryid": "10"
                    }, {
                        "iddownloadablefiles": "248",
                        "name": "Top Up / Add Packs",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Top%20Up%20%2B%20Add%20Packs-HINDI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "HINDI",
                        "categoryid": "10"
                    }, {
                        "iddownloadablefiles": "249",
                        "name": "Top Up / Add Packs",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Top%20Up%20%2B%20Add%20Packs-MARATHI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "MARATHI",
                        "categoryid": "10"
                    }, {
                        "iddownloadablefiles": "250",
                        "name": "Top Up / Add Packs",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Top%20Up%20%2B%20Add%20Packs-GUJARATI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "GUJARATI",
                        "categoryid": "10"
                    }, {
                        "iddownloadablefiles": "251",
                        "name": "Top Up / Add Packs",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Top%20Up%20%2B%20Add%20Packs-BANGALI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "BENGALI",
                        "categoryid": "10"
                    }, {
                        "iddownloadablefiles": "252",
                        "name": "Top Up / Add Packs",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Top%20Up%20%2B%20Add%20Packs-ODIA.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "ODIA",
                        "categoryid": "10"
                    }, {
                        "iddownloadablefiles": "253",
                        "name": "Top Up / Add Packs",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Top%20Up%20%2B%20Add%20Packs-TAMIL.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "TAMIL",
                        "categoryid": "10"
                    }, {
                        "iddownloadablefiles": "254",
                        "name": "Top Up / Add Packs",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Top%20Up%20%2B%20Add%20Packs-TELUGU.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "TELUGU",
                        "categoryid": "10"
                    }, {
                        "iddownloadablefiles": "255",
                        "name": "Top Up / Add Packs",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Top%20Up%20%2B%20Add%20Packs-KANNADA.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "KANNADA",
                        "categoryid": "10"
                    }, {
                        "iddownloadablefiles": "256",
                        "name": "Top Up / Add Packs",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Top%20Up%20%2B%20Add%20Packs-PunjabiiI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "PUNJABI",
                        "categoryid": "10"
                    }, {
                        "iddownloadablefiles": "257",
                        "name": "Renew Packs / Stay updated with Latest Announcements",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Renew%20Packs%20%2B%20Stay%20updated%20with%20Latest%20Announcements-ENGLISH.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "ENGLISH",
                        "categoryid": "11"
                    }, {
                        "iddownloadablefiles": "258",
                        "name": "Renew Packs / Stay updated with Latest Announcements",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Renew%20Packs%20%2B%20Stay%20updated%20with%20Latest%20Announcements-HINDI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "HINDI",
                        "categoryid": "11"
                    }, {
                        "iddownloadablefiles": "259",
                        "name": "Renew Packs / Stay updated with Latest Announcements",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Renew%20Packs%20%2B%20Stay%20updated%20with%20Latest%20Announcements-MARATHI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "MARATHI",
                        "categoryid": "11"
                    }, {
                        "iddownloadablefiles": "260",
                        "name": "Renew Packs / Stay updated with Latest Announcements",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Renew%20Packs%20%2B%20Stay%20updated%20with%20Latest%20Announcements-GUJARATI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "GUJARATI",
                        "categoryid": "11"
                    }, {
                        "iddownloadablefiles": "261",
                        "name": "Renew Packs / Stay updated with Latest Announcements",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Renew%20Packs%20%2B%20Stay%20updated%20with%20Latest%20Announcements-BANGALI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "BENGALI",
                        "categoryid": "11"
                    }, {
                        "iddownloadablefiles": "262",
                        "name": "Renew Packs / Stay updated with Latest Announcements",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Renew%20Packs%20%2B%20Stay%20updated%20with%20Latest%20Announcements-ODIA.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "ODIA",
                        "categoryid": "11"
                    }, {
                        "iddownloadablefiles": "263",
                        "name": "Renew Packs / Stay updated with Latest Announcements",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Renew%20Packs%20%2B%20Stay%20updated%20with%20Latest%20Announcements-TAMIL.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "TAMIL",
                        "categoryid": "11"
                    }, {
                        "iddownloadablefiles": "264",
                        "name": "Renew Packs / Stay updated with Latest Announcements",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Renew%20Packs%20%2B%20Stay%20updated%20with%20Latest%20Announcements-TELUGU.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "TELUGU",
                        "categoryid": "11"
                    }, {
                        "iddownloadablefiles": "265",
                        "name": "Renew Packs / Stay updated with Latest Announcements",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Renew%20Packs%20%2B%20Stay%20updated%20with%20Latest%20Announcements-KANNADA.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "KANNADA",
                        "categoryid": "11"
                    }, {
                        "iddownloadablefiles": "266",
                        "name": "Renew Packs / Stay updated with Latest Announcements",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Renew%20Packs%20%2B%20Stay%20updated%20with%20Latest%20Announcements-PunjabiiI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "PUNJABI",
                        "categoryid": "11"
                    }, {
                        "iddownloadablefiles": "267",
                        "name": "Create Sub-Users",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Create%20Sub%20Users-ENGLISH.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "ENGLISH",
                        "categoryid": "12"
                    }, {
                        "iddownloadablefiles": "268",
                        "name": "Create Sub-Users",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Create%20New%20Subscriber%20Details%20%2B%20Bulk%20Processing_HINDI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "HINDI",
                        "categoryid": "12"
                    }, {
                        "iddownloadablefiles": "269",
                        "name": "Create Sub-Users",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Create%20New%20Subscriber%20Details%20%2B%20Bulk%20Processing%20MARATHI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "MARATHI",
                        "categoryid": "12"
                    }, {
                        "iddownloadablefiles": "270",
                        "name": "Create Sub-Users",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Create%20New%20Subscriber%20Details%20%2B%20Bulk%20Processing_GUJARATI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "GUJARATI",
                        "categoryid": "12"
                    }, {
                        "iddownloadablefiles": "271",
                        "name": "Create Sub-Users",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Create%20New%20Subscriber%20Details%20%2B%20Bulk%20Processing_BENGALI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "BENGALI",
                        "categoryid": "12"
                    }, {
                        "iddownloadablefiles": "272",
                        "name": "Create Sub-Users",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Create%20New%20Subscriber%20Details%20%2B%20Bulk%20Processing_ODIA.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "ODIA",
                        "categoryid": "12"
                    }, {
                        "iddownloadablefiles": "273",
                        "name": "Create Sub-Users",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video%20-%20Create%20New%20Subscriber%20Details%20%2B%20Bulk%20Processing_TAMIL.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "TAMIL",
                        "categoryid": "12"
                    }, {
                        "iddownloadablefiles": "274",
                        "name": "Create Sub-Users",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video%20-%20Create%20New%20Subscriber%20Details%20%2B%20Bulk%20Processing_TELUGU.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "TELUGU",
                        "categoryid": "12"
                    }, {
                        "iddownloadablefiles": "275",
                        "name": "Create Sub-Users",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Create%20New%20Subscriber%20Details%20%2B%20Bulk%20Processing_KANNADA.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "KANNADA",
                        "categoryid": "12"
                    }, {
                        "iddownloadablefiles": "276",
                        "name": "Create Sub-Users",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Create%20Sub%20Users-PunjabiiI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "PUNJABI",
                        "categoryid": "12"
                    }, {
                        "iddownloadablefiles": "277",
                        "name": "Bulk Processing / Create new subscriber",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Create%20New%20Subscriber%20Details%20%2B%20Bulk%20Processing_ENGLISH.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "ENGLISH",
                        "categoryid": "13"
                    }, {
                        "iddownloadablefiles": "278",
                        "name": "Bulk Processing / Create new subscriber",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Create%20Sub%20Users-HINDI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "HINDI",
                        "categoryid": "13"
                    }, {
                        "iddownloadablefiles": "279",
                        "name": "Bulk Processing / Create new subscriber",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Create%20Sub%20Users-MARATHI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "MARATHI",
                        "categoryid": "13"
                    }, {
                        "iddownloadablefiles": "280",
                        "name": "Bulk Processing / Create new subscriber",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Create%20Sub%20Users-GUJARATI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "GUJARATI",
                        "categoryid": "13"
                    }, {
                        "iddownloadablefiles": "281",
                        "name": "Bulk Processing / Create new subscriber",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Create%20Sub%20Users-BENGALI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "BENGALI",
                        "categoryid": "13"
                    }, {
                        "iddownloadablefiles": "282",
                        "name": "Bulk Processing / Create new subscriber",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Create%20Sub%20Users-ODIA.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "ODIA",
                        "categoryid": "13"
                    }, {
                        "iddownloadablefiles": "283",
                        "name": "Bulk Processing / Create new subscriber",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video%20-%20Create%20Sub%20Users-TAMIL.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "TAMIL",
                        "categoryid": "13"
                    }, {
                        "iddownloadablefiles": "284",
                        "name": "Bulk Processing / Create new subscriber",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video%20-%20Create%20Sub%20Users-TELUGU.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "TELUGU",
                        "categoryid": "13"
                    }, {
                        "iddownloadablefiles": "285",
                        "name": "Bulk Processing / Create new subscriber",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Create%20Sub%20Users-KANNADA.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "KANNADA",
                        "categoryid": "13"
                    }, {
                        "iddownloadablefiles": "286",
                        "name": "Bulk Processing / Create new subscriber",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Create%20New%20Subscriber%20Details%20%2B%20Bulk%20Processing_PunjabiiI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "PUNJABI",
                        "categoryid": "13"
                    }, {
                        "iddownloadablefiles": "287",
                        "name": "Business Performance / Comprehensive Reports",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Business%20Performance%20%2B%20Comprehensive%20Reports-ENGLISH.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "ENGLISH",
                        "categoryid": "14"
                    }, {
                        "iddownloadablefiles": "288",
                        "name": "Business Performance / Comprehensive Reports",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Business%20Performance%20%2B%20Comprehensive%20Reports-HINDI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "HINDI",
                        "categoryid": "14"
                    }, {
                        "iddownloadablefiles": "289",
                        "name": "Business Performance / Comprehensive Reports",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Business%20Performance%20%2B%20Comprehensive%20Reports-MARATHI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "MARATHI",
                        "categoryid": "14"
                    }, {
                        "iddownloadablefiles": "290",
                        "name": "Business Performance / Comprehensive Reports",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Business%20Performance%20%2B%20Comprehensive%20Reports-GUJARATI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "GUJARATI",
                        "categoryid": "14"
                    }, {
                        "iddownloadablefiles": "291",
                        "name": "Business Performance / Comprehensive Reports",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Business%20Performance%20%2B%20Comprehensive%20Reports-BENGALI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "BENGALI",
                        "categoryid": "14"
                    }, {
                        "iddownloadablefiles": "292",
                        "name": "Business Performance / Comprehensive Reports",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Business%20Performance%20%2B%20Comprehensive%20Reports-ODIA.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "ODIA",
                        "categoryid": "14"
                    }, {
                        "iddownloadablefiles": "293",
                        "name": "Business Performance / Comprehensive Reports",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video%20-%20Business%20Performance%20%2B%20Comprehensive%20Reports-TAMIL.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "TAMIL",
                        "categoryid": "14"
                    }, {
                        "iddownloadablefiles": "294",
                        "name": "Business Performance / Comprehensive Reports",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Business%20Performance%20%2B%20Comprehensive%20Reports-TELUGU.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "TELUGU",
                        "categoryid": "14"
                    }, {
                        "iddownloadablefiles": "295",
                        "name": "Business Performance / Comprehensive Reports",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Business%20Performance%20%2B%20Comprehensive%20Reports-KANNADA.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "KANNADA",
                        "categoryid": "14"
                    }, {
                        "iddownloadablefiles": "296",
                        "name": "Business Performance / Comprehensive Reports",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Business%20Performance%20%2B%20Comprehensive%20Reports-PunjabiiI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                        "category": "PUNJABI",
                        "categoryid": "14"
                    }, {
                        "iddownloadablefiles": "297",
                        "name": "Manage Subscribers / Overview of your subscribers / Add packs/ Top up your wallets easily",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%281%29Manage%20Subscribers%20-%20%28a%29%20Overview%20of%20your%20subscribers%20%28b%29%20Add%20packs%20%28c%29%20Top%20up%20your%20wallets%20easily-ENGLISH.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                        "category": "ENGLISH",
                        "categoryid": "15"
                    }, {
                        "iddownloadablefiles": "298",
                        "name": "Manage Subscribers / Overview of your subscribers / Add packs / Top up your wallets easily",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%281%29Manage%20Subscribers%20-%20%28a%29%20Overview%20of%20your%20subscribers%20%28b%29%20Add%20packs%20%28c%29%20Top%20up%20your%20wallets%20easily-HINDI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                        "category": "HINDI",
                        "categoryid": "15"
                    }, {
                        "iddownloadablefiles": "299",
                        "name": "Manage Subscribers / Overview of your subscribers / Add packs / Top up your wallets easily",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%281%29Manage%20Subscribers%20-%20%28a%29%20Overview%20of%20your%20subscribers%20%28b%29%20Add%20packs%20%28c%29%20Top%20up%20your%20wallets%20easily-MARATHI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                        "category": "MARATHI",
                        "categoryid": "15"
                    }, {
                        "iddownloadablefiles": "300",
                        "name": "Manage Subscribers / Overview of your subscribers / Add packs / Top up your wallets easily",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%281%29Manage%20Subscribers%20-%20%28a%29%20Overview%20of%20your%20subscribers%20%28b%29%20Add%20packs%20%28c%29%20Top%20up%20your%20wallets%20easily-GUJARATI%20%281%29.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                        "category": "GUJARATI",
                        "categoryid": "15"
                    }, {
                        "iddownloadablefiles": "301",
                        "name": "Manage Subscribers /Overview of your subscribers / Add packs / Top up your wallets easily",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%281%29Manage%20Subscribers%20-%20%28a%29%20Overview%20of%20your%20subscribers%20%28b%29%20Add%20packs%20%28c%29%20Top%20up%20your%20wallets%20easily-BENGALI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                        "category": "BENGALI",
                        "categoryid": "15"
                    }, {
                        "iddownloadablefiles": "302",
                        "name": "Manage Subscribers /Overview of your subscribers / Add packs / Top up your wallets easily",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%281%29Manage%20Subscribers%20-%20%28a%29%20Overview%20of%20your%20subscribers%20%28b%29%20Add%20packs%20%28c%29%20Top%20up%20your%20wallets%20easily-ODIA.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                        "category": "ODIA",
                        "categoryid": "15"
                    }, {
                        "iddownloadablefiles": "303",
                        "name": "Manage Subscribers /Overview of your subscribers / Add packs / Top up your wallets easily",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%281%29Manage%20Subscribers%20-%20%28a%29%20Overview%20of%20your%20subscribers%20%28b%29%20Add%20packs%20%28c%29%20Top%20up%20your%20wallets%20easily-TAMIL.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                        "category": "TAMIL",
                        "categoryid": "15"
                    }, {
                        "iddownloadablefiles": "304",
                        "name": "Manage Subscribers /Overview of your subscribers / Add packs / Top up your wallets easily",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%281%29Manage%20Subscribers%20-%20%28a%29%20Overview%20of%20your%20subscribers%20%28b%29%20Add%20packs%20%28c%29%20Top%20up%20your%20wallets%20easily-TELUGU.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                        "category": "TELUGU",
                        "categoryid": "15"
                    }, {
                        "iddownloadablefiles": "305",
                        "name": "Manage Subscribers /Overview of your subscribers / Add packs / Top up your wallets easily",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%281%29Manage%20Subscribers%20-%20%28a%29%20Overview%20of%20your%20subscribers%20%28b%29%20Add%20packs%20%28c%29%20Top%20up%20your%20wallets%20easily-KANNADA.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                        "category": "KANNADA",
                        "categoryid": "15"
                    }, {
                        "iddownloadablefiles": "306",
                        "name": "Manage Subscribers /Overview of your subscribers / Add packs / Top up your wallets easily",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%281%29Manage%20Subscribers%20-%20%28a%29%20Overview%20of%20your%20subscribers%20%28b%29%20Add%20packs%20%28c%29%20Top%20up%20your%20wallets%20easily-PunjabiiI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                        "category": "PUNJABI",
                        "categoryid": "15"
                    }, {
                        "iddownloadablefiles": "307",
                        "name": "Perform Transactions / View your subscriber details / Create and manage tickets",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%282%29Perform%20Transactions%20-%20%28a%29%20View%20your%20subscriber%20details%20%28b%29%20Create%20and%20manage%20tickets%20%28c%29%20Resolve%20errors%20easily%20through%20the%20App-%20ENGLISH.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                        "category": "ENGLISH",
                        "categoryid": "16"
                    }, {
                        "iddownloadablefiles": "308",
                        "name": "Perform Transactions / View your subscriber details / Create and manage tickets",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%282%29Perform%20Transactions%20-%20%28a%29%20View%20your%20subscriber%20details%20%28b%29%20Create%20and%20manage%20tickets%20%28c%29%20Resolve%20errors%20easily%20through%20the%20App-%20HINDI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                        "category": "HINDI",
                        "categoryid": "16"
                    }, {
                        "iddownloadablefiles": "309",
                        "name": "Perform Transactions / View your subscriber details / Create and manage tickets",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%282%29Perform%20Transactions%20-%20%28a%29%20View%20your%20subscriber%20details%20%28b%29%20Create%20and%20manage%20tickets%20%28c%29%20Resolve%20errors%20easily%20through%20the%20App-%20MARATHI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                        "category": "MARATHI",
                        "categoryid": "16"
                    }, {
                        "iddownloadablefiles": "310",
                        "name": "Perform Transactions / View your subscriber details / Create and manage tickets",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%282%29Perform%20Transactions%20-%20%28a%29%20View%20your%20subscriber%20details%20%28b%29%20Create%20and%20manage%20tickets%20%28c%29%20Resolve%20errors%20easily%20through%20the%20App-%20GUJARATI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                        "category": "GUJARATI",
                        "categoryid": "16"
                    }, {
                        "iddownloadablefiles": "311",
                        "name": "Perform Transactions / View your subscriber details / Create and manage tickets",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%282%29Perform%20Transactions%20-%20%28a%29%20View%20your%20subscriber%20details%20%28b%29%20Create%20and%20manage%20tickets%20%28c%29%20Resolve%20errors%20easily%20through%20the%20App-%20BENGALI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                        "category": "BENGALI",
                        "categoryid": "16"
                    }, {
                        "iddownloadablefiles": "312",
                        "name": "Perform Transactions / View your subscriber details / Create and manage tickets",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%282%29Perform%20Transactions%20-%20%28a%29%20View%20your%20subscriber%20details%20%28b%29%20Create%20and%20manage%20tickets%20%28c%29%20Resolve%20errors%20easily%20through%20the%20App-%20ODIA.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                        "category": "ODIA",
                        "categoryid": "16"
                    }, {
                        "iddownloadablefiles": "313",
                        "name": "Perform Transactions / View your subscriber details / Create and manage tickets",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%282%29Perform%20Transactions%20-%20%28a%29%20View%20your%20subscriber%20details%20%28b%29%20Create%20and%20manage%20tickets%20%28c%29%20Resolve%20errors%20easily%20through%20the%20App-%20TAMIL.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                        "category": "TAMIL",
                        "categoryid": "16"
                    }, {
                        "iddownloadablefiles": "314",
                        "name": "Perform Transactions / View your subscriber details / Create and manage tickets",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%282%29Perform%20Transactions%20-%20%28a%29%20View%20your%20subscriber%20details%20%28b%29%20Create%20and%20manage%20tickets%20%28c%29%20Resolve%20errors%20easily%20through%20the%20App-TELUGU.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                        "category": "TELUGU",
                        "categoryid": "16"
                    }, {
                        "iddownloadablefiles": "315",
                        "name": "Perform Transactions / View your subscriber details / Create and manage tickets",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%282%29Perform%20Transactions%20-%20%28a%29%20View%20your%20subscriber%20details%20%28b%29%20Create%20and%20manage%20tickets%20%28c%29%20Resolve%20errors%20easily%20through%20the%20App-KANNADA.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                        "category": "KANNADA",
                        "categoryid": "16"
                    }, {
                        "iddownloadablefiles": "316",
                        "name": "Perform Transactions / View your subscriber details / Create and manage tickets",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%282%29Perform%20Transactions%20-%20%28a%29%20View%20your%20subscriber%20details%20%28b%29%20Create%20and%20manage%20tickets%20%28c%29%20Resolve%20errors%20easily%20through%20the%20App-%20PunjabiiI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                        "category": "PUNJABI",
                        "categoryid": "16"
                    }, {
                        "iddownloadablefiles": "317",
                        "name": "Latest Announcements / Access all reports for your business / Change your email ID or mobile number",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%283%29Latest%20Announcements%20-%20%28a%29%20Access%20all%20reports%20for%20your%20business%20%28b%29%20Change%20your%20email%20ID%20or%20mobile%20number%20%28c%29%20Add%20sub-users%2C%20and%20stay%20updated%20-ENGLISH.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                        "category": "ENGLISH",
                        "categoryid": "17"
                    }, {
                        "iddownloadablefiles": "318",
                        "name": "Latest Announcements / Access all reports for your business / Change your email ID or mobile number",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%283%29Latest%20Announcements%20-%20%28a%29%20Access%20all%20reports%20for%20your%20business%20%28b%29%20Change%20your%20email%20ID%20or%20mobile%20number%20%28c%29%20Add%20sub-users%2C%20and%20stay%20updated%20-HINDI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                        "category": "HINDI",
                        "categoryid": "17"
                    }, {
                        "iddownloadablefiles": "319",
                        "name": "Latest Announcements / Access all reports for your business / Change your email ID or mobile number",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%283%29Latest%20Announcements%20-%20%28a%29%20Access%20all%20reports%20for%20your%20business%20%28b%29%20Change%20your%20email%20ID%20or%20mobile%20number%20%28c%29%20Add%20sub-users%2C%20and%20stay%20updated%20-MARATHI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                        "category": "MARATHI",
                        "categoryid": "17"
                    }, {
                        "iddownloadablefiles": "320",
                        "name": "Latest Announcements / Access all reports for your business / Change your email ID or mobile number",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%283%29Latest%20Announcements%20-%20%28a%29%20Access%20all%20reports%20for%20your%20business%20%28b%29%20Change%20your%20email%20ID%20or%20mobile%20number%20%28c%29%20Add%20sub-users%2C%20and%20stay%20updated%20-GUJARATI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                        "category": "GUJARATI",
                        "categoryid": "17"
                    }, {
                        "iddownloadablefiles": "321",
                        "name": "Latest Announcements / Access all reports for your business / Change your email ID or mobile number",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%283%29Latest%20Announcements%20-%20%28a%29%20Access%20all%20reports%20for%20your%20business%20%28b%29%20Change%20your%20email%20ID%20or%20mobile%20number%20%28c%29%20Add%20sub-users%2C%20and%20stay%20updated%20-%20BENGALI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                        "category": "BENGALI",
                        "categoryid": "17"
                    }, {
                        "iddownloadablefiles": "322",
                        "name": "Latest Announcements / Access all reports for your business / Change your email ID or mobile number",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%283%29Latest%20Announcements%20-%20%28a%29%20Access%20all%20reports%20for%20your%20business%20%28b%29%20Change%20your%20email%20ID%20or%20mobile%20number%20%28c%29%20Add%20sub-users%2C%20and%20stay%20updated%20-ODIA.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                        "category": "ODIA",
                        "categoryid": "17"
                    }, {
                        "iddownloadablefiles": "323",
                        "name": "Latest Announcements / Access all reports for your business / Change your email ID or mobile number",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%283%29Latest%20Announcements%20-%20%28a%29%20Access%20all%20reports%20for%20your%20business%20%28b%29%20Change%20your%20email%20ID%20or%20mobile%20number%20%28c%29%20Add%20sub-users%2C%20and%20stay%20updated%20-TAMIL.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                        "category": "TAMIL",
                        "categoryid": "17"
                    }, {
                        "iddownloadablefiles": "324",
                        "name": "Latest Announcements / Access all reports for your business / Change your email ID or mobile number",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%283%29Latest%20Announcements%20-%20%28a%29%20Access%20all%20reports%20for%20your%20business%20%28b%29%20Change%20your%20email%20ID%20or%20mobile%20number%20%28c%29%20Add%20sub-users%2C%20and%20stay%20updated%20-TELUGU.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                        "category": "TELUGU",
                        "categoryid": "17"
                    }, {
                        "iddownloadablefiles": "325",
                        "name": "Latest Announcements / Access all reports for your business / Change your email ID or mobile number",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%283%29Latest%20Announcements%20-%20%28a%29%20Access%20all%20reports%20for%20your%20business%20%28b%29%20Change%20your%20email%20ID%20or%20mobile%20number%20%28c%29%20Add%20sub-users%2C%20and%20stay%20updated%20-KANNADA.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                        "category": "KANNADA",
                        "categoryid": "17"
                    }, {
                        "iddownloadablefiles": "326",
                        "name": "Latest Announcements / Access all reports for your business / Change your email ID or mobile number",
                        "filename": "SHORT HELP VIDEOS",
                        "purpose": "HELP VIDEO",
                        "created": "2024-07-01 10:08:36",
                        "type": "MP4",
                        "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%283%29Latest%20Announcements%20-%20%28a%29%20Access%20all%20reports%20for%20your%20business%20%28b%29%20Change%20your%20email%20ID%20or%20mobile%20number%20%28c%29%20Add%20sub-users%2C%20and%20stay%20updated%20-PunjabiiI.mp4",
                        "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                        "category": "PUNJABI",
                        "categoryid": "17"
                    }]);
                    return;
                }
                reject(error);
            });
        });
    }

};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state, getters: getters, mutations: mutations, actions: actions
});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(2);
var _this = this;


var state = {};
var getters = {};
var mutations = {};

var actions = {

    actPostCheckout: function actPostCheckout(context, payload) {
        return new Promise(function (resolve, reject) {
            fetch(context.getters.baseUrl + '/lco/v1/cart/checkout', {
                method: 'POST'
            }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.text();
            }).then(function (data) {
                console.log("data", data);
                resolve(data);
            }).catch(function (error) {
                if (context.getters.getMode == "development") {
                    resolve('{"completed":1,"total":1,"order":{"customerid":"27026088","type":"NEW","planid":"MPnY8Ti1","plandetails":{"idplan":"MPnY8Ti1","planname":"BENGALI STARTER","plantype":"PACKAGE","plancode":"INB0013PP","packagecode":null,"description":"BENGALI STARTER","tariffperiod":"1","currency":"INR","region":"MUM","lcoregion":"MUM","status":"ACTIVE","created":"2019-01-30 07:45:36","lcoprice":"73.44","mrptariff":"81.60","planmode":"RENEWABLE","tariffperiodtype":"M","effectivedate":null,"newlcoprice":null,"newmrptariff":null,"discountedlcoprice":null,"ncfprice":"6.00","servicecode1":null,"renewperiod":"12","hardwaretype":"ALL","numchannels":"42","plancategory":"NORMAL","planid":"MPnY8Ti1","enteredid":"CAN27026088"},"plantype":"PACKAGE","enteredid":"CAN27026088"},"result":{"success":37505469,"planprice":93.74,"customercan":"CAN27026088","validity":"2021-10-06"}}/r/nnull');
                    return;
                }
                reject(error);
            });
        });
    },

    actRemoveCart: function actRemoveCart(context, payload) {
        return new Promise(function (resolve, reject) {
            if (!payload) {
                reject({ error: "payload not found" });
            }

            var queryStr = '';
            queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(payload);

            fetch(context.getters.baseUrl + '/lco/v1/cart/remove' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                if (response.ok && response.status == 200) {
                    return response.json();
                } else if (response.status == 401) {
                    reject({ error: 'Sorry, Your Session has been expired' });
                    setTimeout(function () {
                        return _this.$router.push({ name: '/' });
                    }, 3000);
                } else {
                    reject({ error: 'Getting recently watched error' });
                }
            }).then(function (data) {

                resolve(data);

                //type CLK DLK
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    addPackInCart: function addPackInCart(context, data) {
        console.log("before call api", data);
        return new Promise(function (resolve, reject) {
            fetch(context.getters.baseUrl + '/lco/v1/cart', {
                method: 'POST',
                body: data
            }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },

    removePackFromCart: function removePackFromCart(context, data) {
        var queryStr = '';
        queryStr = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* makeQueryStringDync */])(data);
        return new Promise(function (resolve, reject) {
            fetch(context.getters.baseUrl + '/lco/v1/cart/remove' + queryStr, {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    emptyCart: function emptyCart(context) {
        return new Promise(function (resolve, reject) {
            fetch(context.getters.baseUrl + '/lco/v1/cart/delete', {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    getCartData: function getCartData(context) {
        return new Promise(function (resolve, reject) {
            // let getCartData = JSON.parse(localStorage.getItem('getCartData'))
            // if (getCartData) {
            //     if (Object.keys(getCartData).length) {
            //         resolve(getCartData)
            //         return
            //     }
            // }
            fetch(context.getters.baseUrl + '/lco/v1/cart', {
                method: 'GET'
            }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                localStorage.setItem("getCartData", JSON.stringify(data));
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    addNewInvoice: function addNewInvoice(context, payload) {
        return new Promise(function (resolve, reject) {
            var data = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["b" /* makeQueryFormDataDyn */])(payload);
            fetch(context.getters.baseUrl + '/lco/v1/invoice', {
                method: 'POST',
                body: data
            }).then(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* errorServeiceHandler */]).then(function (response) {
                return response.json();
            }).then(function (data) {
                resolve(data);
            }).catch(function (error) {
                reject(error);
            });
        });
    }
};
/* harmony default export */ __webpack_exports__["a"] = ({
    state: state, getters: getters, mutations: mutations, actions: actions
});

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export name */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return version; });
/* unused harmony export description */
/* unused harmony export keywords */
/* unused harmony export homepage */
/* unused harmony export license */
/* unused harmony export author */
/* unused harmony export main */
/* unused harmony export unpkg */
/* unused harmony export jsdelivr */
/* unused harmony export module */
/* unused harmony export repository */
/* unused harmony export scripts */
/* unused harmony export devDependencies */
/* unused harmony export dependencies */
var name = "d3";
var version = "4.13.0";
var description = "Data-Driven Documents";
var keywords = ["dom","visualization","svg","animation","canvas"];
var homepage = "https://d3js.org";
var license = "BSD-3-Clause";
var author = {"name":"Mike Bostock","url":"https://bost.ocks.org/mike"};
var main = "build/d3.node.js";
var unpkg = "build/d3.min.js";
var jsdelivr = "build/d3.min.js";
var module = "index";
var repository = {"type":"git","url":"https://github.com/d3/d3.git"};
var scripts = {"pretest":"rimraf build && mkdir build && json2module package.json > build/package.js && node rollup.node","test":"tape 'test/**/*-test.js'","prepublishOnly":"npm run test && rollup -c --banner \"$(preamble)\" && uglifyjs -b beautify=false,preamble=\"'$(preamble)'\" build/d3.js -c negate_iife=false -m -o build/d3.min.js","postpublish":"git push && git push --tags && cd ../d3.github.com && git pull && cp ../d3/build/d3.js d3.v4.js && cp ../d3/build/d3.min.js d3.v4.min.js && git add d3.v4.js d3.v4.min.js && git commit -m \"d3 ${npm_package_version}\" && git push && cd - && cd ../d3-bower && git pull && cp ../d3/LICENSE ../d3/README.md ../d3/build/d3.js ../d3/build/d3.min.js . && git add -- LICENSE README.md d3.js d3.min.js && git commit -m \"${npm_package_version}\" && git tag -am \"${npm_package_version}\" v${npm_package_version} && git push && git push --tags && cd - && zip -j build/d3.zip -- LICENSE README.md API.md CHANGES.md build/d3.js build/d3.min.js"};
var devDependencies = {"json2module":"0.0","package-preamble":"0.1","rimraf":"2","rollup":"0.53","rollup-plugin-ascii":"0.0","rollup-plugin-node-resolve":"3","tape":"4","uglify-js":"3.2"};
var dependencies = {"d3-array":"1.2.1","d3-axis":"1.0.8","d3-brush":"1.0.4","d3-chord":"1.0.4","d3-collection":"1.0.4","d3-color":"1.0.3","d3-dispatch":"1.0.3","d3-drag":"1.2.1","d3-dsv":"1.0.8","d3-ease":"1.0.3","d3-force":"1.1.0","d3-format":"1.2.2","d3-geo":"1.9.1","d3-hierarchy":"1.1.5","d3-interpolate":"1.1.6","d3-path":"1.0.5","d3-polygon":"1.0.3","d3-quadtree":"1.0.3","d3-queue":"3.0.7","d3-random":"1.1.0","d3-request":"1.0.6","d3-scale":"1.0.7","d3-selection":"1.3.0","d3-shape":"1.2.0","d3-time":"1.0.8","d3-time-format":"2.1.1","d3-timer":"1.0.7","d3-transition":"1.1.1","d3-voronoi":"1.1.2","d3-zoom":"1.7.1"};


/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pairs__ = __webpack_require__(109);


/* harmony default export */ __webpack_exports__["a"] = (function(values0, values1, reduce) {
  var n0 = values0.length,
      n1 = values1.length,
      values = new Array(n0 * n1),
      i0,
      i1,
      i,
      value0;

  if (reduce == null) reduce = __WEBPACK_IMPORTED_MODULE_0__pairs__["b" /* pair */];

  for (i0 = i = 0; i0 < n0; ++i0) {
    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
      values[i] = reduce(value0, values1[i1]);
    }
  }

  return values;
});


/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});


/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisect__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extent__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__identity__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__range__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ticks__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__ = __webpack_require__(116);









/* harmony default export */ __webpack_exports__["a"] = (function() {
  var value = __WEBPACK_IMPORTED_MODULE_4__identity__["a" /* default */],
      domain = __WEBPACK_IMPORTED_MODULE_3__extent__["a" /* default */],
      threshold = __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__["a" /* default */];

  function histogram(data) {
    var i,
        n = data.length,
        x,
        values = new Array(n);

    for (i = 0; i < n; ++i) {
      values[i] = value(data[i], i, data);
    }

    var xz = domain(values),
        x0 = xz[0],
        x1 = xz[1],
        tz = threshold(values, x0, x1);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      tz = Object(__WEBPACK_IMPORTED_MODULE_6__ticks__["c" /* tickStep */])(x0, x1, tz);
      tz = Object(__WEBPACK_IMPORTED_MODULE_5__range__["a" /* default */])(Math.ceil(x0 / tz) * tz, Math.floor(x1 / tz) * tz, tz); // exclusive
    }

    // Remove any thresholds outside the domain.
    var m = tz.length;
    while (tz[0] <= x0) tz.shift(), --m;
    while (tz[m - 1] > x1) tz.pop(), --m;

    var bins = new Array(m + 1),
        bin;

    // Initialize bins.
    for (i = 0; i <= m; ++i) {
      bin = bins[i] = [];
      bin.x0 = i > 0 ? tz[i - 1] : x0;
      bin.x1 = i < m ? tz[i] : x1;
    }

    // Assign data to bins by value, ignoring any outside the domain.
    for (i = 0; i < n; ++i) {
      x = values[i];
      if (x0 <= x && x <= x1) {
        bins[Object(__WEBPACK_IMPORTED_MODULE_1__bisect__["c" /* default */])(tz, x, 0, m)].push(data[i]);
      }
    }

    return bins;
  }

  histogram.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : value;
  };

  histogram.domain = function(_) {
    return arguments.length ? (domain = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])([_[0], _[1]]), histogram) : domain;
  };

  histogram.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["b" /* slice */].call(_)) : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : threshold;
  };

  return histogram;
});


/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__quantile__ = __webpack_require__(58);





/* harmony default export */ __webpack_exports__["a"] = (function(values, min, max) {
  values = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(values, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]).sort(__WEBPACK_IMPORTED_MODULE_1__ascending__["a" /* default */]);
  return Math.ceil((max - min) / (2 * (Object(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.75) - Object(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.25)) * Math.pow(values.length, -1 / 3)));
});


/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deviation__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = (function(values, min, max) {
  return Math.ceil((max - min) / (3.5 * Object(__WEBPACK_IMPORTED_MODULE_0__deviation__["a" /* default */])(values) * Math.pow(values.length, -1 / 3)));
});


/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  return max;
});


/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(26);


/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      m = n,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) sum += value;
      else --m;
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) sum += value;
      else --m;
    }
  }

  if (m) return sum / m;
});


/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__number__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__quantile__ = __webpack_require__(58);




/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      numbers = [];

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(values[i]))) {
        numbers.push(value);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(valueof(values[i], i, values)))) {
        numbers.push(value);
      }
    }
  }

  return Object(__WEBPACK_IMPORTED_MODULE_2__quantile__["a" /* default */])(numbers.sort(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]), 0.5);
});


/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(arrays) {
  var n = arrays.length,
      m,
      i = -1,
      j = 0,
      merged,
      array;

  while (++i < n) j += arrays[i].length;
  merged = new Array(j);

  while (--n >= 0) {
    array = arrays[n];
    m = array.length;
    while (--m >= 0) {
      merged[--j] = array[m];
    }
  }

  return merged;
});


/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(array, indexes) {
  var i = indexes.length, permutes = new Array(i);
  while (i--) permutes[i] = array[indexes[i]];
  return permutes;
});


/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(21);


/* harmony default export */ __webpack_exports__["a"] = (function(values, compare) {
  if (!(n = values.length)) return;
  var n,
      i = 0,
      j = 0,
      xi,
      xj = values[j];

  if (compare == null) compare = __WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */];

  while (++i < n) {
    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
      xj = xi, j = i;
    }
  }

  if (compare(xj, xj) === 0) return j;
});


/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(array, i0, i1) {
  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m + i0];
    array[m + i0] = array[i + i0];
    array[i + i0] = t;
  }

  return array;
});


/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    }
  }

  else {
    while (++i < n) {
      if (value = +valueof(values[i], i, values)) sum += value;
    }
  }

  return sum;
});


/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transpose__ = __webpack_require__(118);


/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__transpose__["a" /* default */])(arguments);
});


/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_axis__ = __webpack_require__(248);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__src_axis__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__src_axis__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_axis__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_axis__["b"]; });



/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = axisTop;
/* harmony export (immutable) */ __webpack_exports__["c"] = axisRight;
/* harmony export (immutable) */ __webpack_exports__["a"] = axisBottom;
/* harmony export (immutable) */ __webpack_exports__["b"] = axisLeft;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__identity__ = __webpack_require__(250);



var top = 1,
    right = 2,
    bottom = 3,
    left = 4,
    epsilon = 1e-6;

function translateX(x) {
  return "translate(" + (x + 0.5) + ",0)";
}

function translateY(y) {
  return "translate(0," + (y + 0.5) + ")";
}

function number(scale) {
  return function(d) {
    return +scale(d);
  };
}

function center(scale) {
  var offset = Math.max(0, scale.bandwidth() - 1) / 2; // Adjust for 0.5px offset.
  if (scale.round()) offset = Math.round(offset);
  return function(d) {
    return +scale(d) + offset;
  };
}

function entering() {
  return !this.__axis;
}

function axis(orient, scale) {
  var tickArguments = [],
      tickValues = null,
      tickFormat = null,
      tickSizeInner = 6,
      tickSizeOuter = 6,
      tickPadding = 3,
      k = orient === top || orient === left ? -1 : 1,
      x = orient === left || orient === right ? "x" : "y",
      transform = orient === top || orient === bottom ? translateX : translateY;

  function axis(context) {
    var values = tickValues == null ? (scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain()) : tickValues,
        format = tickFormat == null ? (scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */]) : tickFormat,
        spacing = Math.max(tickSizeInner, 0) + tickPadding,
        range = scale.range(),
        range0 = +range[0] + 0.5,
        range1 = +range[range.length - 1] + 0.5,
        position = (scale.bandwidth ? center : number)(scale.copy()),
        selection = context.selection ? context.selection() : context,
        path = selection.selectAll(".domain").data([null]),
        tick = selection.selectAll(".tick").data(values, scale).order(),
        tickExit = tick.exit(),
        tickEnter = tick.enter().append("g").attr("class", "tick"),
        line = tick.select("line"),
        text = tick.select("text");

    path = path.merge(path.enter().insert("path", ".tick")
        .attr("class", "domain")
        .attr("stroke", "#000"));

    tick = tick.merge(tickEnter);

    line = line.merge(tickEnter.append("line")
        .attr("stroke", "#000")
        .attr(x + "2", k * tickSizeInner));

    text = text.merge(tickEnter.append("text")
        .attr("fill", "#000")
        .attr(x, k * spacing)
        .attr("dy", orient === top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));

    if (context !== selection) {
      path = path.transition(context);
      tick = tick.transition(context);
      line = line.transition(context);
      text = text.transition(context);

      tickExit = tickExit.transition(context)
          .attr("opacity", epsilon)
          .attr("transform", function(d) { return isFinite(d = position(d)) ? transform(d) : this.getAttribute("transform"); });

      tickEnter
          .attr("opacity", epsilon)
          .attr("transform", function(d) { var p = this.parentNode.__axis; return transform(p && isFinite(p = p(d)) ? p : position(d)); });
    }

    tickExit.remove();

    path
        .attr("d", orient === left || orient == right
            ? "M" + k * tickSizeOuter + "," + range0 + "H0.5V" + range1 + "H" + k * tickSizeOuter
            : "M" + range0 + "," + k * tickSizeOuter + "V0.5H" + range1 + "V" + k * tickSizeOuter);

    tick
        .attr("opacity", 1)
        .attr("transform", function(d) { return transform(position(d)); });

    line
        .attr(x + "2", k * tickSizeInner);

    text
        .attr(x, k * spacing)
        .text(format);

    selection.filter(entering)
        .attr("fill", "none")
        .attr("font-size", 10)
        .attr("font-family", "sans-serif")
        .attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");

    selection
        .each(function() { this.__axis = position; });
  }

  axis.scale = function(_) {
    return arguments.length ? (scale = _, axis) : scale;
  };

  axis.ticks = function() {
    return tickArguments = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(arguments), axis;
  };

  axis.tickArguments = function(_) {
    return arguments.length ? (tickArguments = _ == null ? [] : __WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_), axis) : tickArguments.slice();
  };

  axis.tickValues = function(_) {
    return arguments.length ? (tickValues = _ == null ? null : __WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_), axis) : tickValues && tickValues.slice();
  };

  axis.tickFormat = function(_) {
    return arguments.length ? (tickFormat = _, axis) : tickFormat;
  };

  axis.tickSize = function(_) {
    return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
  };

  axis.tickSizeInner = function(_) {
    return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
  };

  axis.tickSizeOuter = function(_) {
    return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
  };

  axis.tickPadding = function(_) {
    return arguments.length ? (tickPadding = +_, axis) : tickPadding;
  };

  return axis;
}

function axisTop(scale) {
  return axis(top, scale);
}

function axisRight(scale) {
  return axis(right, scale);
}

function axisBottom(scale) {
  return axis(bottom, scale);
}

function axisLeft(scale) {
  return axis(left, scale);
}


/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var slice = Array.prototype.slice;


/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_brush__ = __webpack_require__(252);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_brush__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__src_brush__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__src_brush__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_brush__["a"]; });



/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = brushSelection;
/* harmony export (immutable) */ __webpack_exports__["b"] = brushX;
/* harmony export (immutable) */ __webpack_exports__["c"] = brushY;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dispatch__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_drag__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_interpolate__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_selection__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_transition__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constant__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__event__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__noevent__ = __webpack_require__(337);









var MODE_DRAG = {name: "drag"},
    MODE_SPACE = {name: "space"},
    MODE_HANDLE = {name: "handle"},
    MODE_CENTER = {name: "center"};

var X = {
  name: "x",
  handles: ["e", "w"].map(type),
  input: function(x, e) { return x && [[x[0], e[0][1]], [x[1], e[1][1]]]; },
  output: function(xy) { return xy && [xy[0][0], xy[1][0]]; }
};

var Y = {
  name: "y",
  handles: ["n", "s"].map(type),
  input: function(y, e) { return y && [[e[0][0], y[0]], [e[1][0], y[1]]]; },
  output: function(xy) { return xy && [xy[0][1], xy[1][1]]; }
};

var XY = {
  name: "xy",
  handles: ["n", "e", "s", "w", "nw", "ne", "se", "sw"].map(type),
  input: function(xy) { return xy; },
  output: function(xy) { return xy; }
};

var cursors = {
  overlay: "crosshair",
  selection: "move",
  n: "ns-resize",
  e: "ew-resize",
  s: "ns-resize",
  w: "ew-resize",
  nw: "nwse-resize",
  ne: "nesw-resize",
  se: "nwse-resize",
  sw: "nesw-resize"
};

var flipX = {
  e: "w",
  w: "e",
  nw: "ne",
  ne: "nw",
  se: "sw",
  sw: "se"
};

var flipY = {
  n: "s",
  s: "n",
  nw: "sw",
  ne: "se",
  se: "ne",
  sw: "nw"
};

var signsX = {
  overlay: +1,
  selection: +1,
  n: null,
  e: +1,
  s: null,
  w: -1,
  nw: -1,
  ne: +1,
  se: +1,
  sw: -1
};

var signsY = {
  overlay: +1,
  selection: +1,
  n: -1,
  e: null,
  s: +1,
  w: null,
  nw: -1,
  ne: -1,
  se: +1,
  sw: +1
};

function type(t) {
  return {type: t};
}

// Ignore right-click, since that should open the context menu.
function defaultFilter() {
  return !__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].button;
}

function defaultExtent() {
  var svg = this.ownerSVGElement || this;
  return [[0, 0], [svg.width.baseVal.value, svg.height.baseVal.value]];
}

// Like d3.local, but with the name “__brush” rather than auto-generated.
function local(node) {
  while (!node.__brush) if (!(node = node.parentNode)) return;
  return node.__brush;
}

function empty(extent) {
  return extent[0][0] === extent[1][0]
      || extent[0][1] === extent[1][1];
}

function brushSelection(node) {
  var state = node.__brush;
  return state ? state.dim.output(state.selection) : null;
}

function brushX() {
  return brush(X);
}

function brushY() {
  return brush(Y);
}

/* harmony default export */ __webpack_exports__["d"] = (function() {
  return brush(XY);
});

function brush(dim) {
  var extent = defaultExtent,
      filter = defaultFilter,
      listeners = Object(__WEBPACK_IMPORTED_MODULE_0_d3_dispatch__["a" /* dispatch */])(brush, "start", "brush", "end"),
      handleSize = 6,
      touchending;

  function brush(group) {
    var overlay = group
        .property("__brush", initialize)
      .selectAll(".overlay")
      .data([type("overlay")]);

    overlay.enter().append("rect")
        .attr("class", "overlay")
        .attr("pointer-events", "all")
        .attr("cursor", cursors.overlay)
      .merge(overlay)
        .each(function() {
          var extent = local(this).extent;
          Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["k" /* select */])(this)
              .attr("x", extent[0][0])
              .attr("y", extent[0][1])
              .attr("width", extent[1][0] - extent[0][0])
              .attr("height", extent[1][1] - extent[0][1]);
        });

    group.selectAll(".selection")
      .data([type("selection")])
      .enter().append("rect")
        .attr("class", "selection")
        .attr("cursor", cursors.selection)
        .attr("fill", "#777")
        .attr("fill-opacity", 0.3)
        .attr("stroke", "#fff")
        .attr("shape-rendering", "crispEdges");

    var handle = group.selectAll(".handle")
      .data(dim.handles, function(d) { return d.type; });

    handle.exit().remove();

    handle.enter().append("rect")
        .attr("class", function(d) { return "handle handle--" + d.type; })
        .attr("cursor", function(d) { return cursors[d.type]; });

    group
        .each(redraw)
        .attr("fill", "none")
        .attr("pointer-events", "all")
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)")
        .on("mousedown.brush touchstart.brush", started);
  }

  brush.move = function(group, selection) {
    if (group.selection) {
      group
          .on("start.brush", function() { emitter(this, arguments).beforestart().start(); })
          .on("interrupt.brush end.brush", function() { emitter(this, arguments).end(); })
          .tween("brush", function() {
            var that = this,
                state = that.__brush,
                emit = emitter(that, arguments),
                selection0 = state.selection,
                selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent),
                i = Object(__WEBPACK_IMPORTED_MODULE_2_d3_interpolate__["a" /* interpolate */])(selection0, selection1);

            function tween(t) {
              state.selection = t === 1 && empty(selection1) ? null : i(t);
              redraw.call(that);
              emit.brush();
            }

            return selection0 && selection1 ? tween : tween(1);
          });
    } else {
      group
          .each(function() {
            var that = this,
                args = arguments,
                state = that.__brush,
                selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent),
                emit = emitter(that, args).beforestart();

            Object(__WEBPACK_IMPORTED_MODULE_4_d3_transition__["b" /* interrupt */])(that);
            state.selection = selection1 == null || empty(selection1) ? null : selection1;
            redraw.call(that);
            emit.start().brush().end();
          });
    }
  };

  function redraw() {
    var group = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["k" /* select */])(this),
        selection = local(this).selection;

    if (selection) {
      group.selectAll(".selection")
          .style("display", null)
          .attr("x", selection[0][0])
          .attr("y", selection[0][1])
          .attr("width", selection[1][0] - selection[0][0])
          .attr("height", selection[1][1] - selection[0][1]);

      group.selectAll(".handle")
          .style("display", null)
          .attr("x", function(d) { return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2; })
          .attr("y", function(d) { return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2; })
          .attr("width", function(d) { return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize; })
          .attr("height", function(d) { return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize; });
    }

    else {
      group.selectAll(".selection,.handle")
          .style("display", "none")
          .attr("x", null)
          .attr("y", null)
          .attr("width", null)
          .attr("height", null);
    }
  }

  function emitter(that, args) {
    return that.__brush.emitter || new Emitter(that, args);
  }

  function Emitter(that, args) {
    this.that = that;
    this.args = args;
    this.state = that.__brush;
    this.active = 0;
  }

  Emitter.prototype = {
    beforestart: function() {
      if (++this.active === 1) this.state.emitter = this, this.starting = true;
      return this;
    },
    start: function() {
      if (this.starting) this.starting = false, this.emit("start");
      return this;
    },
    brush: function() {
      this.emit("brush");
      return this;
    },
    end: function() {
      if (--this.active === 0) delete this.state.emitter, this.emit("end");
      return this;
    },
    emit: function(type) {
      Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["d" /* customEvent */])(new __WEBPACK_IMPORTED_MODULE_6__event__["a" /* default */](brush, type, dim.output(this.state.selection)), listeners.apply, listeners, [type, this.that, this.args]);
    }
  };

  function started() {
    if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].touches) { if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].changedTouches.length < __WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].touches.length) return Object(__WEBPACK_IMPORTED_MODULE_7__noevent__["a" /* default */])(); }
    else if (touchending) return;
    if (!filter.apply(this, arguments)) return;

    var that = this,
        type = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].target.__data__.type,
        mode = (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].metaKey ? type = "overlay" : type) === "selection" ? MODE_DRAG : (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].altKey ? MODE_CENTER : MODE_HANDLE),
        signX = dim === Y ? null : signsX[type],
        signY = dim === X ? null : signsY[type],
        state = local(that),
        extent = state.extent,
        selection = state.selection,
        W = extent[0][0], w0, w1,
        N = extent[0][1], n0, n1,
        E = extent[1][0], e0, e1,
        S = extent[1][1], s0, s1,
        dx,
        dy,
        moving,
        shifting = signX && signY && __WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].shiftKey,
        lockX,
        lockY,
        point0 = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["h" /* mouse */])(that),
        point = point0,
        emit = emitter(that, arguments).beforestart();

    if (type === "overlay") {
      state.selection = selection = [
        [w0 = dim === Y ? W : point0[0], n0 = dim === X ? N : point0[1]],
        [e0 = dim === Y ? E : w0, s0 = dim === X ? S : n0]
      ];
    } else {
      w0 = selection[0][0];
      n0 = selection[0][1];
      e0 = selection[1][0];
      s0 = selection[1][1];
    }

    w1 = w0;
    n1 = n0;
    e1 = e0;
    s1 = s0;

    var group = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["k" /* select */])(that)
        .attr("pointer-events", "none");

    var overlay = group.selectAll(".overlay")
        .attr("cursor", cursors[type]);

    if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].touches) {
      group
          .on("touchmove.brush", moved, true)
          .on("touchend.brush touchcancel.brush", ended, true);
    } else {
      var view = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["k" /* select */])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].view)
          .on("keydown.brush", keydowned, true)
          .on("keyup.brush", keyupped, true)
          .on("mousemove.brush", moved, true)
          .on("mouseup.brush", ended, true);

      Object(__WEBPACK_IMPORTED_MODULE_1_d3_drag__["b" /* dragDisable */])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].view);
    }

    Object(__WEBPACK_IMPORTED_MODULE_7__noevent__["b" /* nopropagation */])();
    Object(__WEBPACK_IMPORTED_MODULE_4_d3_transition__["b" /* interrupt */])(that);
    redraw.call(that);
    emit.start();

    function moved() {
      var point1 = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["h" /* mouse */])(that);
      if (shifting && !lockX && !lockY) {
        if (Math.abs(point1[0] - point[0]) > Math.abs(point1[1] - point[1])) lockY = true;
        else lockX = true;
      }
      point = point1;
      moving = true;
      Object(__WEBPACK_IMPORTED_MODULE_7__noevent__["a" /* default */])();
      move();
    }

    function move() {
      var t;

      dx = point[0] - point0[0];
      dy = point[1] - point0[1];

      switch (mode) {
        case MODE_SPACE:
        case MODE_DRAG: {
          if (signX) dx = Math.max(W - w0, Math.min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
          if (signY) dy = Math.max(N - n0, Math.min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
          break;
        }
        case MODE_HANDLE: {
          if (signX < 0) dx = Math.max(W - w0, Math.min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
          else if (signX > 0) dx = Math.max(W - e0, Math.min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
          if (signY < 0) dy = Math.max(N - n0, Math.min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
          else if (signY > 0) dy = Math.max(N - s0, Math.min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
          break;
        }
        case MODE_CENTER: {
          if (signX) w1 = Math.max(W, Math.min(E, w0 - dx * signX)), e1 = Math.max(W, Math.min(E, e0 + dx * signX));
          if (signY) n1 = Math.max(N, Math.min(S, n0 - dy * signY)), s1 = Math.max(N, Math.min(S, s0 + dy * signY));
          break;
        }
      }

      if (e1 < w1) {
        signX *= -1;
        t = w0, w0 = e0, e0 = t;
        t = w1, w1 = e1, e1 = t;
        if (type in flipX) overlay.attr("cursor", cursors[type = flipX[type]]);
      }

      if (s1 < n1) {
        signY *= -1;
        t = n0, n0 = s0, s0 = t;
        t = n1, n1 = s1, s1 = t;
        if (type in flipY) overlay.attr("cursor", cursors[type = flipY[type]]);
      }

      if (state.selection) selection = state.selection; // May be set by brush.move!
      if (lockX) w1 = selection[0][0], e1 = selection[1][0];
      if (lockY) n1 = selection[0][1], s1 = selection[1][1];

      if (selection[0][0] !== w1
          || selection[0][1] !== n1
          || selection[1][0] !== e1
          || selection[1][1] !== s1) {
        state.selection = [[w1, n1], [e1, s1]];
        redraw.call(that);
        emit.brush();
      }
    }

    function ended() {
      Object(__WEBPACK_IMPORTED_MODULE_7__noevent__["b" /* nopropagation */])();
      if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].touches) {
        if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].touches.length) return;
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() { touchending = null; }, 500); // Ghost clicks are delayed!
        group.on("touchmove.brush touchend.brush touchcancel.brush", null);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_d3_drag__["c" /* dragEnable */])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].view, moving);
        view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
      }
      group.attr("pointer-events", "all");
      overlay.attr("cursor", cursors.overlay);
      if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
      if (empty(selection)) state.selection = null, redraw.call(that);
      emit.end();
    }

    function keydowned() {
      switch (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].keyCode) {
        case 16: { // SHIFT
          shifting = signX && signY;
          break;
        }
        case 18: { // ALT
          if (mode === MODE_HANDLE) {
            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
            mode = MODE_CENTER;
            move();
          }
          break;
        }
        case 32: { // SPACE; takes priority over ALT
          if (mode === MODE_HANDLE || mode === MODE_CENTER) {
            if (signX < 0) e0 = e1 - dx; else if (signX > 0) w0 = w1 - dx;
            if (signY < 0) s0 = s1 - dy; else if (signY > 0) n0 = n1 - dy;
            mode = MODE_SPACE;
            overlay.attr("cursor", cursors.selection);
            move();
          }
          break;
        }
        default: return;
      }
      Object(__WEBPACK_IMPORTED_MODULE_7__noevent__["a" /* default */])();
    }

    function keyupped() {
      switch (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].keyCode) {
        case 16: { // SHIFT
          if (shifting) {
            lockX = lockY = shifting = false;
            move();
          }
          break;
        }
        case 18: { // ALT
          if (mode === MODE_CENTER) {
            if (signX < 0) e0 = e1; else if (signX > 0) w0 = w1;
            if (signY < 0) s0 = s1; else if (signY > 0) n0 = n1;
            mode = MODE_HANDLE;
            move();
          }
          break;
        }
        case 32: { // SPACE
          if (mode === MODE_SPACE) {
            if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].altKey) {
              if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
              if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
              mode = MODE_CENTER;
            } else {
              if (signX < 0) e0 = e1; else if (signX > 0) w0 = w1;
              if (signY < 0) s0 = s1; else if (signY > 0) n0 = n1;
              mode = MODE_HANDLE;
            }
            overlay.attr("cursor", cursors[type]);
            move();
          }
          break;
        }
        default: return;
      }
      Object(__WEBPACK_IMPORTED_MODULE_7__noevent__["a" /* default */])();
    }
  }

  function initialize() {
    var state = this.__brush || {selection: null};
    state.extent = extent.apply(this, arguments);
    state.dim = dim;
    return state;
  }

  brush.extent = function(_) {
    return arguments.length ? (extent = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_5__constant__["a" /* default */])([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), brush) : extent;
  };

  brush.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_5__constant__["a" /* default */])(!!_), brush) : filter;
  };

  brush.handleSize = function(_) {
    return arguments.length ? (handleSize = +_, brush) : handleSize;
  };

  brush.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? brush : value;
  };

  return brush;
}


/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var noop = {value: function() {}};

function dispatch() {
  for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
    if (!(t = arguments[i] + "") || (t in _)) throw new Error("illegal type: " + t);
    _[t] = [];
  }
  return new Dispatch(_);
}

function Dispatch(_) {
  this._ = _;
}

function parseTypenames(typenames, types) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    return {type: t, name: name};
  });
}

Dispatch.prototype = dispatch.prototype = {
  constructor: Dispatch,
  on: function(typename, callback) {
    var _ = this._,
        T = parseTypenames(typename + "", _),
        t,
        i = -1,
        n = T.length;

    // If no callback was specified, return the callback of the given type and name.
    if (arguments.length < 2) {
      while (++i < n) if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
      return;
    }

    // If a type was specified, set the callback for the given type and name.
    // Otherwise, if a null callback was specified, remove callbacks of the given name.
    if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
    while (++i < n) {
      if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);
      else if (callback == null) for (t in _) _[t] = set(_[t], typename.name, null);
    }

    return this;
  },
  copy: function() {
    var copy = {}, _ = this._;
    for (var t in _) copy[t] = _[t].slice();
    return new Dispatch(copy);
  },
  call: function(type, that) {
    if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  },
  apply: function(type, that, args) {
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (var t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  }
};

function get(type, name) {
  for (var i = 0, n = type.length, c; i < n; ++i) {
    if ((c = type[i]).name === name) {
      return c.value;
    }
  }
}

function set(type, name, callback) {
  for (var i = 0, n = type.length; i < n; ++i) {
    if (type[i].name === name) {
      type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
      break;
    }
  }
  if (callback != null) type.push({name: name, value: callback});
  return type;
}

/* harmony default export */ __webpack_exports__["a"] = (dispatch);


/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dispatch__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_selection__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodrag__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__noevent__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constant__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__event__ = __webpack_require__(290);







// Ignore right-click, since that should open the context menu.
function defaultFilter() {
  return !__WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" /* event */].button;
}

function defaultContainer() {
  return this.parentNode;
}

function defaultSubject(d) {
  return d == null ? {x: __WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" /* event */].x, y: __WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" /* event */].y} : d;
}

function defaultTouchable() {
  return "ontouchstart" in this;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var filter = defaultFilter,
      container = defaultContainer,
      subject = defaultSubject,
      touchable = defaultTouchable,
      gestures = {},
      listeners = Object(__WEBPACK_IMPORTED_MODULE_0_d3_dispatch__["a" /* dispatch */])("start", "drag", "end"),
      active = 0,
      mousedownx,
      mousedowny,
      mousemoving,
      touchending,
      clickDistance2 = 0;

  function drag(selection) {
    selection
        .on("mousedown.drag", mousedowned)
      .filter(touchable)
        .on("touchstart.drag", touchstarted)
        .on("touchmove.drag", touchmoved)
        .on("touchend.drag touchcancel.drag", touchended)
        .style("touch-action", "none")
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }

  function mousedowned() {
    if (touchending || !filter.apply(this, arguments)) return;
    var gesture = beforestart("mouse", container.apply(this, arguments), __WEBPACK_IMPORTED_MODULE_1_d3_selection__["h" /* mouse */], this, arguments);
    if (!gesture) return;
    Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["k" /* select */])(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" /* event */].view).on("mousemove.drag", mousemoved, true).on("mouseup.drag", mouseupped, true);
    Object(__WEBPACK_IMPORTED_MODULE_2__nodrag__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" /* event */].view);
    Object(__WEBPACK_IMPORTED_MODULE_3__noevent__["b" /* nopropagation */])();
    mousemoving = false;
    mousedownx = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" /* event */].clientX;
    mousedowny = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" /* event */].clientY;
    gesture("start");
  }

  function mousemoved() {
    Object(__WEBPACK_IMPORTED_MODULE_3__noevent__["a" /* default */])();
    if (!mousemoving) {
      var dx = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" /* event */].clientX - mousedownx, dy = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" /* event */].clientY - mousedowny;
      mousemoving = dx * dx + dy * dy > clickDistance2;
    }
    gestures.mouse("drag");
  }

  function mouseupped() {
    Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["k" /* select */])(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" /* event */].view).on("mousemove.drag mouseup.drag", null);
    Object(__WEBPACK_IMPORTED_MODULE_2__nodrag__["b" /* yesdrag */])(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" /* event */].view, mousemoving);
    Object(__WEBPACK_IMPORTED_MODULE_3__noevent__["a" /* default */])();
    gestures.mouse("end");
  }

  function touchstarted() {
    if (!filter.apply(this, arguments)) return;
    var touches = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" /* event */].changedTouches,
        c = container.apply(this, arguments),
        n = touches.length, i, gesture;

    for (i = 0; i < n; ++i) {
      if (gesture = beforestart(touches[i].identifier, c, __WEBPACK_IMPORTED_MODULE_1_d3_selection__["q" /* touch */], this, arguments)) {
        Object(__WEBPACK_IMPORTED_MODULE_3__noevent__["b" /* nopropagation */])();
        gesture("start");
      }
    }
  }

  function touchmoved() {
    var touches = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" /* event */].changedTouches,
        n = touches.length, i, gesture;

    for (i = 0; i < n; ++i) {
      if (gesture = gestures[touches[i].identifier]) {
        Object(__WEBPACK_IMPORTED_MODULE_3__noevent__["a" /* default */])();
        gesture("drag");
      }
    }
  }

  function touchended() {
    var touches = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" /* event */].changedTouches,
        n = touches.length, i, gesture;

    if (touchending) clearTimeout(touchending);
    touchending = setTimeout(function() { touchending = null; }, 500); // Ghost clicks are delayed!
    for (i = 0; i < n; ++i) {
      if (gesture = gestures[touches[i].identifier]) {
        Object(__WEBPACK_IMPORTED_MODULE_3__noevent__["b" /* nopropagation */])();
        gesture("end");
      }
    }
  }

  function beforestart(id, container, point, that, args) {
    var p = point(container, id), s, dx, dy,
        sublisteners = listeners.copy();

    if (!Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["d" /* customEvent */])(new __WEBPACK_IMPORTED_MODULE_5__event__["a" /* default */](drag, "beforestart", s, id, active, p[0], p[1], 0, 0, sublisteners), function() {
      if ((__WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" /* event */].subject = s = subject.apply(that, args)) == null) return false;
      dx = s.x - p[0] || 0;
      dy = s.y - p[1] || 0;
      return true;
    })) return;

    return function gesture(type) {
      var p0 = p, n;
      switch (type) {
        case "start": gestures[id] = gesture, n = active++; break;
        case "end": delete gestures[id], --active; // nobreak
        case "drag": p = point(container, id), n = active; break;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["d" /* customEvent */])(new __WEBPACK_IMPORTED_MODULE_5__event__["a" /* default */](drag, type, s, id, n, p[0] + dx, p[1] + dy, p[0] - p0[0], p[1] - p0[1], sublisteners), sublisteners.apply, sublisteners, [type, that, args]);
    };
  }

  drag.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_4__constant__["a" /* default */])(!!_), drag) : filter;
  };

  drag.container = function(_) {
    return arguments.length ? (container = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_4__constant__["a" /* default */])(_), drag) : container;
  };

  drag.subject = function(_) {
    return arguments.length ? (subject = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_4__constant__["a" /* default */])(_), drag) : subject;
  };

  drag.touchable = function(_) {
    return arguments.length ? (touchable = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_4__constant__["a" /* default */])(!!_), drag) : touchable;
  };

  drag.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? drag : value;
  };

  drag.clickDistance = function(_) {
    return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
  };

  return drag;
});


/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__creator__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__select__ = __webpack_require__(119);



/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__select__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(name).call(document.documentElement));
});


/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(62);



/* harmony default export */ __webpack_exports__["a"] = (function(select) {
  if (typeof select !== "function") select = Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* default */])(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](subgroups, this._parents);
});


/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectorAll__ = __webpack_require__(120);



/* harmony default export */ __webpack_exports__["a"] = (function(select) {
  if (typeof select !== "function") select = Object(__WEBPACK_IMPORTED_MODULE_1__selectorAll__["a" /* default */])(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        subgroups.push(select.call(node, node.__data__, i, group));
        parents.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](subgroups, parents);
});


/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__matcher__ = __webpack_require__(121);



/* harmony default export */ __webpack_exports__["a"] = (function(match) {
  if (typeof match !== "function") match = Object(__WEBPACK_IMPORTED_MODULE_1__matcher__["a" /* default */])(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](subgroups, this._parents);
});


/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enter__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(260);




var keyPrefix = "$"; // Protect against keys like “__proto__”.

function bindIndex(parent, group, enter, update, exit, data) {
  var i = 0,
      node,
      groupLength = group.length,
      dataLength = data.length;

  // Put any non-null nodes that fit into update.
  // Put any null nodes into enter.
  // Put any remaining data into enter.
  for (; i < dataLength; ++i) {
    if (node = group[i]) {
      node.__data__ = data[i];
      update[i] = node;
    } else {
      enter[i] = new __WEBPACK_IMPORTED_MODULE_1__enter__["a" /* EnterNode */](parent, data[i]);
    }
  }

  // Put any non-null nodes that don’t fit into exit.
  for (; i < groupLength; ++i) {
    if (node = group[i]) {
      exit[i] = node;
    }
  }
}

function bindKey(parent, group, enter, update, exit, data, key) {
  var i,
      node,
      nodeByKeyValue = {},
      groupLength = group.length,
      dataLength = data.length,
      keyValues = new Array(groupLength),
      keyValue;

  // Compute the key for each node.
  // If multiple nodes have the same key, the duplicates are added to exit.
  for (i = 0; i < groupLength; ++i) {
    if (node = group[i]) {
      keyValues[i] = keyValue = keyPrefix + key.call(node, node.__data__, i, group);
      if (keyValue in nodeByKeyValue) {
        exit[i] = node;
      } else {
        nodeByKeyValue[keyValue] = node;
      }
    }
  }

  // Compute the key for each datum.
  // If there a node associated with this key, join and add it to update.
  // If there is not (or the key is a duplicate), add it to enter.
  for (i = 0; i < dataLength; ++i) {
    keyValue = keyPrefix + key.call(parent, data[i], i, data);
    if (node = nodeByKeyValue[keyValue]) {
      update[i] = node;
      node.__data__ = data[i];
      nodeByKeyValue[keyValue] = null;
    } else {
      enter[i] = new __WEBPACK_IMPORTED_MODULE_1__enter__["a" /* EnterNode */](parent, data[i]);
    }
  }

  // Add any remaining nodes that were not bound to data to exit.
  for (i = 0; i < groupLength; ++i) {
    if ((node = group[i]) && (nodeByKeyValue[keyValues[i]] === node)) {
      exit[i] = node;
    }
  }
}

/* harmony default export */ __webpack_exports__["a"] = (function(value, key) {
  if (!value) {
    data = new Array(this.size()), j = -1;
    this.each(function(d) { data[++j] = d; });
    return data;
  }

  var bind = key ? bindKey : bindIndex,
      parents = this._parents,
      groups = this._groups;

  if (typeof value !== "function") value = Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(value);

  for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
    var parent = parents[j],
        group = groups[j],
        groupLength = group.length,
        data = value.call(parent, parent && parent.__data__, j, parents),
        dataLength = data.length,
        enterGroup = enter[j] = new Array(dataLength),
        updateGroup = update[j] = new Array(dataLength),
        exitGroup = exit[j] = new Array(groupLength);

    bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);

    // Now connect the enter nodes to their following update node, such that
    // appendChild can insert the materialized enter node before this node,
    // rather than at the end of the parent node.
    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
      if (previous = enterGroup[i0]) {
        if (i0 >= i1) i1 = i0 + 1;
        while (!(next = updateGroup[i1]) && ++i1 < dataLength);
        previous._next = next || null;
      }
    }
  }

  update = new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](update, parents);
  update._enter = enter;
  update._exit = exit;
  return update;
});


/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sparse__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(6);



/* harmony default export */ __webpack_exports__["a"] = (function() {
  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Selection */](this._exit || this._groups.map(__WEBPACK_IMPORTED_MODULE_0__sparse__["a" /* default */]), this._parents);
});


/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = (function(selection) {

  for (var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](merges, this._parents);
});


/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {

  for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
    for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
      if (node = group[i]) {
        if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
        next = node;
      }
    }
  }

  return this;
});


/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = (function(compare) {
  if (!compare) compare = ascending;

  function compareNode(a, b) {
    return a && b ? compare(a.__data__, b.__data__) : !a - !b;
  }

  for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        sortgroup[i] = node;
      }
    }
    sortgroup.sort(compareNode);
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](sortgroups, this._parents).order();
});

function ascending(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}


/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var callback = arguments[0];
  arguments[0] = this;
  callback.apply(null, arguments);
  return this;
});


/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var nodes = new Array(this.size()), i = -1;
  this.each(function() { nodes[++i] = this; });
  return nodes;
});


/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
      var node = group[i];
      if (node) return node;
    }
  }

  return null;
});


/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var size = 0;
  this.each(function() { ++size; });
  return size;
});


/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  return !this.node();
});


/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(callback) {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
      if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
  }

  return this;
});


/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__namespace__ = __webpack_require__(60);


function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant(name, value) {
  return function() {
    this.setAttribute(name, value);
  };
}

function attrConstantNS(fullname, value) {
  return function() {
    this.setAttributeNS(fullname.space, fullname.local, value);
  };
}

function attrFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttribute(name);
    else this.setAttribute(name, v);
  };
}

function attrFunctionNS(fullname, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
    else this.setAttributeNS(fullname.space, fullname.local, v);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var fullname = Object(__WEBPACK_IMPORTED_MODULE_0__namespace__["a" /* default */])(name);

  if (arguments.length < 2) {
    var node = this.node();
    return fullname.local
        ? node.getAttributeNS(fullname.space, fullname.local)
        : node.getAttribute(fullname);
  }

  return this.each((value == null
      ? (fullname.local ? attrRemoveNS : attrRemove) : (typeof value === "function"
      ? (fullname.local ? attrFunctionNS : attrFunction)
      : (fullname.local ? attrConstantNS : attrConstant)))(fullname, value));
});


/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function propertyRemove(name) {
  return function() {
    delete this[name];
  };
}

function propertyConstant(name, value) {
  return function() {
    this[name] = value;
  };
}

function propertyFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) delete this[name];
    else this[name] = v;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  return arguments.length > 1
      ? this.each((value == null
          ? propertyRemove : typeof value === "function"
          ? propertyFunction
          : propertyConstant)(name, value))
      : this.node()[name];
});


/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function classArray(string) {
  return string.trim().split(/^|\s+/);
}

function classList(node) {
  return node.classList || new ClassList(node);
}

function ClassList(node) {
  this._node = node;
  this._names = classArray(node.getAttribute("class") || "");
}

ClassList.prototype = {
  add: function(name) {
    var i = this._names.indexOf(name);
    if (i < 0) {
      this._names.push(name);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  remove: function(name) {
    var i = this._names.indexOf(name);
    if (i >= 0) {
      this._names.splice(i, 1);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  contains: function(name) {
    return this._names.indexOf(name) >= 0;
  }
};

function classedAdd(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.add(names[i]);
}

function classedRemove(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.remove(names[i]);
}

function classedTrue(names) {
  return function() {
    classedAdd(this, names);
  };
}

function classedFalse(names) {
  return function() {
    classedRemove(this, names);
  };
}

function classedFunction(names, value) {
  return function() {
    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var names = classArray(name + "");

  if (arguments.length < 2) {
    var list = classList(this.node()), i = -1, n = names.length;
    while (++i < n) if (!list.contains(names[i])) return false;
    return true;
  }

  return this.each((typeof value === "function"
      ? classedFunction : value
      ? classedTrue
      : classedFalse)(names, value));
});


/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function textRemove() {
  this.textContent = "";
}

function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.textContent = v == null ? "" : v;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return arguments.length
      ? this.each(value == null
          ? textRemove : (typeof value === "function"
          ? textFunction
          : textConstant)(value))
      : this.node().textContent;
});


/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function htmlRemove() {
  this.innerHTML = "";
}

function htmlConstant(value) {
  return function() {
    this.innerHTML = value;
  };
}

function htmlFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.innerHTML = v == null ? "" : v;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return arguments.length
      ? this.each(value == null
          ? htmlRemove : (typeof value === "function"
          ? htmlFunction
          : htmlConstant)(value))
      : this.node().innerHTML;
});


/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function raise() {
  if (this.nextSibling) this.parentNode.appendChild(this);
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.each(raise);
});


/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function lower() {
  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.each(lower);
});


/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__creator__ = __webpack_require__(39);


/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var create = typeof name === "function" ? name : Object(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(name);
  return this.select(function() {
    return this.appendChild(create.apply(this, arguments));
  });
});


/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__creator__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(62);



function constantNull() {
  return null;
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, before) {
  var create = typeof name === "function" ? name : Object(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(name),
      select = before == null ? constantNull : typeof before === "function" ? before : Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* default */])(before);
  return this.select(function() {
    return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
  });
});


/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function remove() {
  var parent = this.parentNode;
  if (parent) parent.removeChild(this);
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.each(remove);
});


/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function selection_cloneShallow() {
  return this.parentNode.insertBefore(this.cloneNode(false), this.nextSibling);
}

function selection_cloneDeep() {
  return this.parentNode.insertBefore(this.cloneNode(true), this.nextSibling);
}

/* harmony default export */ __webpack_exports__["a"] = (function(deep) {
  return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
});


/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return arguments.length
      ? this.property("__data__", value)
      : this.node().__data__;
});


/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__window__ = __webpack_require__(63);


function dispatchEvent(node, type, params) {
  var window = Object(__WEBPACK_IMPORTED_MODULE_0__window__["a" /* default */])(node),
      event = window.CustomEvent;

  if (typeof event === "function") {
    event = new event(type, params);
  } else {
    event = window.document.createEvent("Event");
    if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
    else event.initEvent(type, false, false);
  }

  node.dispatchEvent(event);
}

function dispatchConstant(type, params) {
  return function() {
    return dispatchEvent(this, type, params);
  };
}

function dispatchFunction(type, params) {
  return function() {
    return dispatchEvent(this, type, params.apply(this, arguments));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(type, params) {
  return this.each((typeof params === "function"
      ? dispatchFunction
      : dispatchConstant)(type, params));
});


/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = local;
var nextId = 0;

function local() {
  return new Local;
}

function Local() {
  this._ = "@" + (++nextId).toString(36);
}

Local.prototype = local.prototype = {
  constructor: Local,
  get: function(node) {
    var id = this._;
    while (!(id in node)) if (!(node = node.parentNode)) return;
    return node[id];
  },
  set: function(node, value) {
    return node[this._] = value;
  },
  remove: function(node) {
    return this._ in node && delete node[this._];
  },
  toString: function() {
    return this._;
  }
};


/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sourceEvent__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(40);



/* harmony default export */ __webpack_exports__["a"] = (function(node) {
  var event = Object(__WEBPACK_IMPORTED_MODULE_0__sourceEvent__["a" /* default */])();
  if (event.changedTouches) event = event.changedTouches[0];
  return Object(__WEBPACK_IMPORTED_MODULE_1__point__["a" /* default */])(node, event);
});


/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selection_index__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return typeof selector === "string"
      ? new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([document.querySelectorAll(selector)], [document.documentElement])
      : new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([selector == null ? [] : selector], __WEBPACK_IMPORTED_MODULE_0__selection_index__["c" /* root */]);
});


/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sourceEvent__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(40);



/* harmony default export */ __webpack_exports__["a"] = (function(node, touches, identifier) {
  if (arguments.length < 3) identifier = touches, touches = Object(__WEBPACK_IMPORTED_MODULE_0__sourceEvent__["a" /* default */])().changedTouches;

  for (var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i) {
    if ((touch = touches[i]).identifier === identifier) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__point__["a" /* default */])(node, touch);
    }
  }

  return null;
});


/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sourceEvent__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(40);



/* harmony default export */ __webpack_exports__["a"] = (function(node, touches) {
  if (touches == null) touches = Object(__WEBPACK_IMPORTED_MODULE_0__sourceEvent__["a" /* default */])().touches;

  for (var i = 0, n = touches ? touches.length : 0, points = new Array(n); i < n; ++i) {
    points[i] = Object(__WEBPACK_IMPORTED_MODULE_1__point__["a" /* default */])(node, touches[i]);
  }

  return points;
});


/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DragEvent;
function DragEvent(target, type, subject, id, active, x, y, dx, dy, dispatch) {
  this.target = target;
  this.type = type;
  this.subject = subject;
  this.identifier = id;
  this.active = active;
  this.x = x;
  this.y = y;
  this.dx = dx;
  this.dy = dy;
  this._ = dispatch;
}

DragEvent.prototype.on = function() {
  var value = this._.on.apply(this._, arguments);
  return value === this._ ? this : value;
};


/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lab;
/* unused harmony export Lab */
/* harmony export (immutable) */ __webpack_exports__["b"] = hcl;
/* unused harmony export Hcl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(127);




var Kn = 18,
    Xn = 0.950470, // D65 standard referent
    Yn = 1,
    Zn = 1.088830,
    t0 = 4 / 29,
    t1 = 6 / 29,
    t2 = 3 * t1 * t1,
    t3 = t1 * t1 * t1;

function labConvert(o) {
  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl) {
    var h = o.h * __WEBPACK_IMPORTED_MODULE_2__math__["a" /* deg2rad */];
    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
  }
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */])) o = Object(__WEBPACK_IMPORTED_MODULE_1__color__["h" /* rgbConvert */])(o);
  var b = rgb2xyz(o.r),
      a = rgb2xyz(o.g),
      l = rgb2xyz(o.b),
      x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn),
      y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / Yn),
      z = xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / Zn);
  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}

function lab(l, a, b, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}

function Lab(l, a, b, opacity) {
  this.l = +l;
  this.a = +a;
  this.b = +b;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Lab, lab, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* Color */], {
  brighter: function(k) {
    return new Lab(this.l + Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  darker: function(k) {
    return new Lab(this.l - Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  rgb: function() {
    var y = (this.l + 16) / 116,
        x = isNaN(this.a) ? y : y + this.a / 500,
        z = isNaN(this.b) ? y : y - this.b / 200;
    y = Yn * lab2xyz(y);
    x = Xn * lab2xyz(x);
    z = Zn * lab2xyz(z);
    return new __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */](
      xyz2rgb( 3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
      xyz2rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z),
      xyz2rgb( 0.0556434 * x - 0.2040259 * y + 1.0572252 * z),
      this.opacity
    );
  }
}));

function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}

function lab2xyz(t) {
  return t > t1 ? t * t * t : t2 * (t - t0);
}

function xyz2rgb(x) {
  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}

function rgb2xyz(x) {
  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}

function hclConvert(o) {
  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab)) o = labConvert(o);
  var h = Math.atan2(o.b, o.a) * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* rad2deg */];
  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}

function hcl(h, c, l, opacity) {
  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function Hcl(h, c, l, opacity) {
  this.h = +h;
  this.c = +c;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Hcl, hcl, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* Color */], {
  brighter: function(k) {
    return new Hcl(this.h, this.c, this.l + Kn * (k == null ? 1 : k), this.opacity);
  },
  darker: function(k) {
    return new Hcl(this.h, this.c, this.l - Kn * (k == null ? 1 : k), this.opacity);
  },
  rgb: function() {
    return labConvert(this).rgb();
  }
}));


/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cubehelix;
/* unused harmony export Cubehelix */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(127);




var A = -0.14861,
    B = +1.78277,
    C = -0.29227,
    D = -0.90649,
    E = +1.97294,
    ED = E * D,
    EB = E * B,
    BC_DA = B * C - D * A;

function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */])) o = Object(__WEBPACK_IMPORTED_MODULE_1__color__["h" /* rgbConvert */])(o);
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
      bl = b - l,
      k = (E * (g - l) - C * bl) / D,
      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
      h = s ? Math.atan2(k, bl) * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* rad2deg */] - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}

function cubehelix(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}

function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Cubehelix, cubehelix, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* Color */], {
  brighter: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["c" /* brighter */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* brighter */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["d" /* darker */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["d" /* darker */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * __WEBPACK_IMPORTED_MODULE_2__math__["a" /* deg2rad */],
        l = +this.l,
        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
        cosh = Math.cos(h),
        sinh = Math.sin(h);
    return new __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */](
      255 * (l + a * (A * cosh + B * sinh)),
      255 * (l + a * (C * cosh + D * sinh)),
      255 * (l + a * (E * cosh)),
      this.opacity
    );
  }
}));


/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return Math.round(a + b * t);
  };
});


/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return interpolateTransformCss; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return interpolateTransformSvg; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse__ = __webpack_require__(295);



function interpolateTransform(parse, pxComma, pxParen, degParen) {

  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({i: i - 4, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({i: i - 4, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function(a, b) {
    var s = [], // string constants and placeholders
        q = []; // number interpolators
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["a" /* parseCss */], "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["b" /* parseSvg */], ", ", ")", ")");


/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseCss;
/* harmony export (immutable) */ __webpack_exports__["b"] = parseSvg;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__decompose__ = __webpack_require__(296);


var cssNode,
    cssRoot,
    cssView,
    svgNode;

function parseCss(value) {
  if (value === "none") return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
  cssNode.style.transform = value;
  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
  cssRoot.removeChild(cssNode);
  value = value.slice(7, -1).split(",");
  return Object(__WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* default */])(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}

function parseSvg(value) {
  if (value == null) return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  value = value.matrix;
  return Object(__WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* default */])(value.a, value.b, value.c, value.d, value.e, value.f);
}


/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return identity; });
var degrees = 180 / Math.PI;

var identity = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

/* harmony default export */ __webpack_exports__["a"] = (function(a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
});


/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var rho = Math.SQRT2,
    rho2 = 2,
    rho4 = 4,
    epsilon2 = 1e-12;

function cosh(x) {
  return ((x = Math.exp(x)) + 1 / x) / 2;
}

function sinh(x) {
  return ((x = Math.exp(x)) - 1 / x) / 2;
}

function tanh(x) {
  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}

// p0 = [ux0, uy0, w0]
// p1 = [ux1, uy1, w1]
/* harmony default export */ __webpack_exports__["a"] = (function(p0, p1) {
  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
      dx = ux1 - ux0,
      dy = uy1 - uy0,
      d2 = dx * dx + dy * dy,
      i,
      S;

  // Special case for u0 ≅ u1.
  if (d2 < epsilon2) {
    S = Math.log(w1 / w0) / rho;
    i = function(t) {
      return [
        ux0 + t * dx,
        uy0 + t * dy,
        w0 * Math.exp(rho * t * S)
      ];
    }
  }

  // General case.
  else {
    var d1 = Math.sqrt(d2),
        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
    S = (r1 - r0) / rho;
    i = function(t) {
      var s = t * S,
          coshr0 = cosh(r0),
          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
      return [
        ux0 + u * dx,
        uy0 + u * dy,
        w0 * coshr0 / cosh(rho * s + r0)
      ];
    }
  }

  i.duration = S * 1000;

  return i;
});


/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hslLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(27);



function hsl(hue) {
  return function(start, end) {
    var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" /* hsl */])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" /* hsl */])(end)).h),
        s = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
        l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.s = s(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* harmony default export */ __webpack_exports__["a"] = (hsl(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var hslLong = hsl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lab;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(27);



function lab(start, end) {
  var l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* lab */])(start)).l, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* lab */])(end)).l),
      a = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.a, end.a),
      b = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.b, end.b),
      opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
  return function(t) {
    start.l = l(t);
    start.a = a(t);
    start.b = b(t);
    start.opacity = opacity(t);
    return start + "";
  };
}


/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hclLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(27);



function hcl(hue) {
  return function(start, end) {
    var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["c" /* hcl */])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["c" /* hcl */])(end)).h),
        c = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.c, end.c),
        l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.c = c(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* harmony default export */ __webpack_exports__["a"] = (hcl(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var hclLong = hcl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cubehelixLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(27);



function cubehelix(hue) {
  return (function cubehelixGamma(y) {
    y = +y;

    function cubehelix(start, end) {
      var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(end)).h),
          s = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
          l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
          opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
      return function(t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + "";
      };
    }

    cubehelix.gamma = cubehelixGamma;

    return cubehelix;
  })(1);
}

/* harmony default export */ __webpack_exports__["b"] = (cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var cubehelixLong = cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(interpolator, n) {
  var samples = new Array(n);
  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
  return samples;
});


/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__interrupt__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__transition__ = __webpack_require__(307);




__WEBPACK_IMPORTED_MODULE_0_d3_selection__["m" /* selection */].prototype.interrupt = __WEBPACK_IMPORTED_MODULE_1__interrupt__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_d3_selection__["m" /* selection */].prototype.transition = __WEBPACK_IMPORTED_MODULE_2__transition__["a" /* default */];


/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interrupt__ = __webpack_require__(135);


/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  return this.each(function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__interrupt__["a" /* default */])(this, name);
  });
});


/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__timer__ = __webpack_require__(71);


/* harmony default export */ __webpack_exports__["a"] = (function(callback, delay, time) {
  var t = new __WEBPACK_IMPORTED_MODULE_0__timer__["a" /* Timer */];
  delay = delay == null ? 0 : +delay;
  t.restart(function(elapsed) {
    t.stop();
    callback(elapsed + delay);
  }, delay, time);
  return t;
});


/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__timer__ = __webpack_require__(71);


/* harmony default export */ __webpack_exports__["a"] = (function(callback, delay, time) {
  var t = new __WEBPACK_IMPORTED_MODULE_0__timer__["a" /* Timer */], total = delay;
  if (delay == null) return t.restart(callback, delay, time), t;
  delay = +delay, time = time == null ? Object(__WEBPACK_IMPORTED_MODULE_0__timer__["b" /* now */])() : +time;
  t.restart(function tick(elapsed) {
    elapsed += total;
    t.restart(tick, total += delay, time);
    callback(elapsed);
  }, delay, time);
  return t;
});


/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transition_index__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transition_schedule__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_ease__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_timer__ = __webpack_require__(42);





var defaultTiming = {
  time: null, // Set on use.
  delay: 0,
  duration: 250,
  ease: __WEBPACK_IMPORTED_MODULE_2_d3_ease__["o" /* easeCubicInOut */]
};

function inherit(node, id) {
  var timing;
  while (!(timing = node.__transition) || !(timing = timing[id])) {
    if (!(node = node.parentNode)) {
      return defaultTiming.time = Object(__WEBPACK_IMPORTED_MODULE_3_d3_timer__["b" /* now */])(), defaultTiming;
    }
  }
  return timing;
}

/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var id,
      timing;

  if (name instanceof __WEBPACK_IMPORTED_MODULE_0__transition_index__["a" /* Transition */]) {
    id = name._id, name = name._name;
  } else {
    id = Object(__WEBPACK_IMPORTED_MODULE_0__transition_index__["c" /* newId */])(), (timing = defaultTiming).time = Object(__WEBPACK_IMPORTED_MODULE_3_d3_timer__["b" /* now */])(), name = name == null ? null : name + "";
  }

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        Object(__WEBPACK_IMPORTED_MODULE_1__transition_schedule__["e" /* default */])(node, name, id, i, group, timing || inherit(node, id));
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__transition_index__["a" /* Transition */](groups, this._parents, name, id);
});


/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_selection__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tween__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__interpolate__ = __webpack_require__(136);





function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant(name, interpolate, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = this.getAttribute(name);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value1);
  };
}

function attrConstantNS(fullname, interpolate, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = this.getAttributeNS(fullname.space, fullname.local);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value1);
  };
}

function attrFunction(name, interpolate, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0, value1 = value(this);
    if (value1 == null) return void this.removeAttribute(name);
    value0 = this.getAttribute(name);
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

function attrFunctionNS(fullname, interpolate, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0, value1 = value(this);
    if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
    value0 = this.getAttributeNS(fullname.space, fullname.local);
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var fullname = Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["i" /* namespace */])(name), i = fullname === "transform" ? __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__["u" /* interpolateTransformSvg */] : __WEBPACK_IMPORTED_MODULE_3__interpolate__["a" /* default */];
  return this.attrTween(name, typeof value === "function"
      ? (fullname.local ? attrFunctionNS : attrFunction)(fullname, i, Object(__WEBPACK_IMPORTED_MODULE_2__tween__["b" /* tweenValue */])(this, "attr." + name, value))
      : value == null ? (fullname.local ? attrRemoveNS : attrRemove)(fullname)
      : (fullname.local ? attrConstantNS : attrConstant)(fullname, i, value + ""));
});


/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(1);


function attrTweenNS(fullname, value) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.setAttributeNS(fullname.space, fullname.local, i(t));
    };
  }
  tween._value = value;
  return tween;
}

function attrTween(name, value) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.setAttribute(name, i(t));
    };
  }
  tween._value = value;
  return tween;
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var key = "attr." + name;
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  var fullname = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["i" /* namespace */])(name);
  return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
});


/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(8);


function delayFunction(id, value) {
  return function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["g" /* init */])(this, id).delay = +value.apply(this, arguments);
  };
}

function delayConstant(id, value) {
  return value = +value, function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["g" /* init */])(this, id).delay = value;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? delayFunction
          : delayConstant)(id, value))
      : Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).delay;
});


/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(8);


function durationFunction(id, value) {
  return function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id).duration = +value.apply(this, arguments);
  };
}

function durationConstant(id, value) {
  return value = +value, function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id).duration = value;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? durationFunction
          : durationConstant)(id, value))
      : Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).duration;
});


/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(8);


function easeConstant(id, value) {
  if (typeof value !== "function") throw new Error;
  return function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id).ease = value;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  var id = this._id;

  return arguments.length
      ? this.each(easeConstant(id, value))
      : Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).ease;
});


/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(12);



/* harmony default export */ __webpack_exports__["a"] = (function(match) {
  if (typeof match !== "function") match = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["g" /* matcher */])(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Transition */](subgroups, this._parents, this._name, this._id);
});


/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(12);


/* harmony default export */ __webpack_exports__["a"] = (function(transition) {
  if (transition._id !== this._id) throw new Error;

  for (var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Transition */](merges, this._parents, this._name, this._id);
});


/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(8);


function start(name) {
  return (name + "").trim().split(/^|\s+/).every(function(t) {
    var i = t.indexOf(".");
    if (i >= 0) t = t.slice(0, i);
    return !t || t === "start";
  });
}

function onFunction(id, name, listener) {
  var on0, on1, sit = start(name) ? __WEBPACK_IMPORTED_MODULE_0__schedule__["g" /* init */] : __WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */];
  return function() {
    var schedule = sit(this, id),
        on = schedule.on;

    // If this node shared a dispatch with the previous node,
    // just assign the updated shared dispatch and we’re done!
    // Otherwise, copy-on-write.
    if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);

    schedule.on = on1;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, listener) {
  var id = this._id;

  return arguments.length < 2
      ? Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).on.on(name)
      : this.each(onFunction(id, name, listener));
});


/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function removeFunction(id) {
  return function() {
    var parent = this.parentNode;
    for (var i in this.__transition) if (+i !== id) return;
    if (parent) parent.removeChild(this);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.on("end.remove", removeFunction(this._id));
});


/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__schedule__ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["a"] = (function(select) {
  var name = this._name,
      id = this._id;

  if (typeof select !== "function") select = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["n" /* selector */])(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
        Object(__WEBPACK_IMPORTED_MODULE_2__schedule__["e" /* default */])(subgroup[i], name, id, i, subgroup, Object(__WEBPACK_IMPORTED_MODULE_2__schedule__["f" /* get */])(node, id));
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Transition */](subgroups, this._parents, name, id);
});


/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__schedule__ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["a"] = (function(select) {
  var name = this._name,
      id = this._id;

  if (typeof select !== "function") select = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["o" /* selectorAll */])(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        for (var children = select.call(node, node.__data__, i, group), child, inherit = Object(__WEBPACK_IMPORTED_MODULE_2__schedule__["f" /* get */])(node, id), k = 0, l = children.length; k < l; ++k) {
          if (child = children[k]) {
            Object(__WEBPACK_IMPORTED_MODULE_2__schedule__["e" /* default */])(child, name, id, k, children, inherit);
          }
        }
        subgroups.push(children);
        parents.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Transition */](subgroups, parents, name, id);
});


/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(1);


var Selection = __WEBPACK_IMPORTED_MODULE_0_d3_selection__["m" /* selection */].prototype.constructor;

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return new Selection(this._groups, this._parents);
});


/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_selection__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tween__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__interpolate__ = __webpack_require__(136);





function styleRemove(name, interpolate) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0 = Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["p" /* style */])(this, name),
        value1 = (this.style.removeProperty(name), Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["p" /* style */])(this, name));
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

function styleRemoveEnd(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant(name, interpolate, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["p" /* style */])(this, name);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value1);
  };
}

function styleFunction(name, interpolate, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0 = Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["p" /* style */])(this, name),
        value1 = value(this);
    if (value1 == null) value1 = (this.style.removeProperty(name), Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["p" /* style */])(this, name));
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value, priority) {
  var i = (name += "") === "transform" ? __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__["t" /* interpolateTransformCss */] : __WEBPACK_IMPORTED_MODULE_3__interpolate__["a" /* default */];
  return value == null ? this
          .styleTween(name, styleRemove(name, i))
          .on("end.style." + name, styleRemoveEnd(name))
      : this.styleTween(name, typeof value === "function"
          ? styleFunction(name, i, Object(__WEBPACK_IMPORTED_MODULE_2__tween__["b" /* tweenValue */])(this, "style." + name, value))
          : styleConstant(name, i, value + ""), priority);
});


/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function styleTween(name, value, priority) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.style.setProperty(name, i(t), priority);
    };
  }
  tween._value = value;
  return tween;
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value, priority) {
  var key = "style." + (name += "");
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
});


/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tween__ = __webpack_require__(43);


function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction(value) {
  return function() {
    var value1 = value(this);
    this.textContent = value1 == null ? "" : value1;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return this.tween("text", typeof value === "function"
      ? textFunction(Object(__WEBPACK_IMPORTED_MODULE_0__tween__["b" /* tweenValue */])(this, "text", value))
      : textConstant(value == null ? "" : value + ""));
});


/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__schedule__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = (function() {
  var name = this._name,
      id0 = this._id,
      id1 = Object(__WEBPACK_IMPORTED_MODULE_0__index__["c" /* newId */])();

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        var inherit = Object(__WEBPACK_IMPORTED_MODULE_1__schedule__["f" /* get */])(node, id0);
        Object(__WEBPACK_IMPORTED_MODULE_1__schedule__["e" /* default */])(node, name, id1, i, group, {
          time: inherit.time + inherit.delay + inherit.duration,
          delay: 0,
          duration: inherit.duration,
          ease: inherit.ease
        });
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Transition */](groups, this._parents, name, id1);
});


/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = linear;
function linear(t) {
  return +t;
}


/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quadIn;
/* harmony export (immutable) */ __webpack_exports__["c"] = quadOut;
/* harmony export (immutable) */ __webpack_exports__["b"] = quadInOut;
function quadIn(t) {
  return t * t;
}

function quadOut(t) {
  return t * (2 - t);
}

function quadInOut(t) {
  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
}


/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cubicIn;
/* harmony export (immutable) */ __webpack_exports__["c"] = cubicOut;
/* harmony export (immutable) */ __webpack_exports__["b"] = cubicInOut;
function cubicIn(t) {
  return t * t * t;
}

function cubicOut(t) {
  return --t * t * t + 1;
}

function cubicInOut(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}


/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return polyIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return polyOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return polyInOut; });
var exponent = 3;

var polyIn = (function custom(e) {
  e = +e;

  function polyIn(t) {
    return Math.pow(t, e);
  }

  polyIn.exponent = custom;

  return polyIn;
})(exponent);

var polyOut = (function custom(e) {
  e = +e;

  function polyOut(t) {
    return 1 - Math.pow(1 - t, e);
  }

  polyOut.exponent = custom;

  return polyOut;
})(exponent);

var polyInOut = (function custom(e) {
  e = +e;

  function polyInOut(t) {
    return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
  }

  polyInOut.exponent = custom;

  return polyInOut;
})(exponent);


/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sinIn;
/* harmony export (immutable) */ __webpack_exports__["c"] = sinOut;
/* harmony export (immutable) */ __webpack_exports__["b"] = sinInOut;
var pi = Math.PI,
    halfPi = pi / 2;

function sinIn(t) {
  return 1 - Math.cos(t * halfPi);
}

function sinOut(t) {
  return Math.sin(t * halfPi);
}

function sinInOut(t) {
  return (1 - Math.cos(pi * t)) / 2;
}


/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = expIn;
/* harmony export (immutable) */ __webpack_exports__["c"] = expOut;
/* harmony export (immutable) */ __webpack_exports__["b"] = expInOut;
function expIn(t) {
  return Math.pow(2, 10 * t - 10);
}

function expOut(t) {
  return 1 - Math.pow(2, -10 * t);
}

function expInOut(t) {
  return ((t *= 2) <= 1 ? Math.pow(2, 10 * t - 10) : 2 - Math.pow(2, 10 - 10 * t)) / 2;
}


/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = circleIn;
/* harmony export (immutable) */ __webpack_exports__["c"] = circleOut;
/* harmony export (immutable) */ __webpack_exports__["b"] = circleInOut;
function circleIn(t) {
  return 1 - Math.sqrt(1 - t * t);
}

function circleOut(t) {
  return Math.sqrt(1 - --t * t);
}

function circleInOut(t) {
  return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
}


/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bounceIn;
/* harmony export (immutable) */ __webpack_exports__["c"] = bounceOut;
/* harmony export (immutable) */ __webpack_exports__["b"] = bounceInOut;
var b1 = 4 / 11,
    b2 = 6 / 11,
    b3 = 8 / 11,
    b4 = 3 / 4,
    b5 = 9 / 11,
    b6 = 10 / 11,
    b7 = 15 / 16,
    b8 = 21 / 22,
    b9 = 63 / 64,
    b0 = 1 / b1 / b1;

function bounceIn(t) {
  return 1 - bounceOut(1 - t);
}

function bounceOut(t) {
  return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
}

function bounceInOut(t) {
  return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
}


/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return backIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return backOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return backInOut; });
var overshoot = 1.70158;

var backIn = (function custom(s) {
  s = +s;

  function backIn(t) {
    return t * t * ((s + 1) * t - s);
  }

  backIn.overshoot = custom;

  return backIn;
})(overshoot);

var backOut = (function custom(s) {
  s = +s;

  function backOut(t) {
    return --t * t * ((s + 1) * t + s) + 1;
  }

  backOut.overshoot = custom;

  return backOut;
})(overshoot);

var backInOut = (function custom(s) {
  s = +s;

  function backInOut(t) {
    return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
  }

  backInOut.overshoot = custom;

  return backInOut;
})(overshoot);


/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return elasticIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return elasticOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return elasticInOut; });
var tau = 2 * Math.PI,
    amplitude = 1,
    period = 0.3;

var elasticIn = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticIn(t) {
    return a * Math.pow(2, 10 * --t) * Math.sin((s - t) / p);
  }

  elasticIn.amplitude = function(a) { return custom(a, p * tau); };
  elasticIn.period = function(p) { return custom(a, p); };

  return elasticIn;
})(amplitude, period);

var elasticOut = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticOut(t) {
    return 1 - a * Math.pow(2, -10 * (t = +t)) * Math.sin((t + s) / p);
  }

  elasticOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticOut.period = function(p) { return custom(a, p); };

  return elasticOut;
})(amplitude, period);

var elasticInOut = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticInOut(t) {
    return ((t = t * 2 - 1) < 0
        ? a * Math.pow(2, 10 * t) * Math.sin((s - t) / p)
        : 2 - a * Math.pow(2, -10 * t) * Math.sin((s + t) / p)) / 2;
  }

  elasticInOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticInOut.period = function(p) { return custom(a, p); };

  return elasticInOut;
})(amplitude, period);


/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transition_index__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transition_schedule__ = __webpack_require__(8);



var root = [null];

/* harmony default export */ __webpack_exports__["a"] = (function(node, name) {
  var schedules = node.__transition,
      schedule,
      i;

  if (schedules) {
    name = name == null ? null : name + "";
    for (i in schedules) {
      if ((schedule = schedules[i]).state > __WEBPACK_IMPORTED_MODULE_1__transition_schedule__["c" /* SCHEDULED */] && schedule.name === name) {
        return new __WEBPACK_IMPORTED_MODULE_0__transition_index__["a" /* Transition */]([[node]], root, name, +i);
      }
    }
  }

  return null;
});


/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(target, type, selection) {
  this.target = target;
  this.type = type;
  this.selection = selection;
});


/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = nopropagation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(1);


function nopropagation() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["e" /* event */].stopImmediatePropagation();
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["e" /* event */].preventDefault();
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["e" /* event */].stopImmediatePropagation();
});


/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_chord__ = __webpack_require__(339);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_chord__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_ribbon__ = __webpack_require__(340);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_ribbon__["a"]; });




/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(138);



function compareValue(compare) {
  return function(a, b) {
    return compare(
      a.source.value + a.target.value,
      b.source.value + b.target.value
    );
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var padAngle = 0,
      sortGroups = null,
      sortSubgroups = null,
      sortChords = null;

  function chord(matrix) {
    var n = matrix.length,
        groupSums = [],
        groupIndex = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["s" /* range */])(n),
        subgroupIndex = [],
        chords = [],
        groups = chords.groups = new Array(n),
        subgroups = new Array(n * n),
        k,
        x,
        x0,
        dx,
        i,
        j;

    // Compute the sum.
    k = 0, i = -1; while (++i < n) {
      x = 0, j = -1; while (++j < n) {
        x += matrix[i][j];
      }
      groupSums.push(x);
      subgroupIndex.push(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["s" /* range */])(n));
      k += x;
    }

    // Sort groups…
    if (sortGroups) groupIndex.sort(function(a, b) {
      return sortGroups(groupSums[a], groupSums[b]);
    });

    // Sort subgroups…
    if (sortSubgroups) subgroupIndex.forEach(function(d, i) {
      d.sort(function(a, b) {
        return sortSubgroups(matrix[i][a], matrix[i][b]);
      });
    });

    // Convert the sum to scaling factor for [0, 2pi].
    // TODO Allow start and end angle to be specified?
    // TODO Allow padding to be specified as percentage?
    k = Object(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* max */])(0, __WEBPACK_IMPORTED_MODULE_1__math__["e" /* tau */] - padAngle * n) / k;
    dx = k ? padAngle : __WEBPACK_IMPORTED_MODULE_1__math__["e" /* tau */] / n;

    // Compute the start and end angle for each group and subgroup.
    // Note: Opera has a bug reordering object literal properties!
    x = 0, i = -1; while (++i < n) {
      x0 = x, j = -1; while (++j < n) {
        var di = groupIndex[i],
            dj = subgroupIndex[di][j],
            v = matrix[di][dj],
            a0 = x,
            a1 = x += v * k;
        subgroups[dj * n + di] = {
          index: di,
          subindex: dj,
          startAngle: a0,
          endAngle: a1,
          value: v
        };
      }
      groups[di] = {
        index: di,
        startAngle: x0,
        endAngle: x,
        value: groupSums[di]
      };
      x += dx;
    }

    // Generate chords for each (non-empty) subgroup-subgroup link.
    i = -1; while (++i < n) {
      j = i - 1; while (++j < n) {
        var source = subgroups[j * n + i],
            target = subgroups[i * n + j];
        if (source.value || target.value) {
          chords.push(source.value < target.value
              ? {source: target, target: source}
              : {source: source, target: target});
        }
      }
    }

    return sortChords ? chords.sort(sortChords) : chords;
  }

  chord.padAngle = function(_) {
    return arguments.length ? (padAngle = Object(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* max */])(0, _), chord) : padAngle;
  };

  chord.sortGroups = function(_) {
    return arguments.length ? (sortGroups = _, chord) : sortGroups;
  };

  chord.sortSubgroups = function(_) {
    return arguments.length ? (sortSubgroups = _, chord) : sortSubgroups;
  };

  chord.sortChords = function(_) {
    return arguments.length ? (_ == null ? sortChords = null : (sortChords = compareValue(_))._ = _, chord) : sortChords && sortChords._;
  };

  return chord;
});


/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_path__ = __webpack_require__(15);





function defaultSource(d) {
  return d.source;
}

function defaultTarget(d) {
  return d.target;
}

function defaultRadius(d) {
  return d.radius;
}

function defaultStartAngle(d) {
  return d.startAngle;
}

function defaultEndAngle(d) {
  return d.endAngle;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var source = defaultSource,
      target = defaultTarget,
      radius = defaultRadius,
      startAngle = defaultStartAngle,
      endAngle = defaultEndAngle,
      context = null;

  function ribbon() {
    var buffer,
        argv = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(arguments),
        s = source.apply(this, argv),
        t = target.apply(this, argv),
        sr = +radius.apply(this, (argv[0] = s, argv)),
        sa0 = startAngle.apply(this, argv) - __WEBPACK_IMPORTED_MODULE_2__math__["b" /* halfPi */],
        sa1 = endAngle.apply(this, argv) - __WEBPACK_IMPORTED_MODULE_2__math__["b" /* halfPi */],
        sx0 = sr * Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* cos */])(sa0),
        sy0 = sr * Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sin */])(sa0),
        tr = +radius.apply(this, (argv[0] = t, argv)),
        ta0 = startAngle.apply(this, argv) - __WEBPACK_IMPORTED_MODULE_2__math__["b" /* halfPi */],
        ta1 = endAngle.apply(this, argv) - __WEBPACK_IMPORTED_MODULE_2__math__["b" /* halfPi */];

    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_3_d3_path__["a" /* path */])();

    context.moveTo(sx0, sy0);
    context.arc(0, 0, sr, sa0, sa1);
    if (sa0 !== ta0 || sa1 !== ta1) { // TODO sr !== tr?
      context.quadraticCurveTo(0, 0, tr * Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* cos */])(ta0), tr * Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sin */])(ta0));
      context.arc(0, 0, tr, ta0, ta1);
    }
    context.quadraticCurveTo(0, 0, sx0, sy0);
    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  ribbon.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), ribbon) : radius;
  };

  ribbon.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), ribbon) : startAngle;
  };

  ribbon.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), ribbon) : endAngle;
  };

  ribbon.source = function(_) {
    return arguments.length ? (source = _, ribbon) : source;
  };

  ribbon.target = function(_) {
    return arguments.length ? (target = _, ribbon) : target;
  };

  ribbon.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), ribbon) : context;
  };

  return ribbon;
});


/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var slice = Array.prototype.slice;


/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var pi = Math.PI,
    tau = 2 * pi,
    epsilon = 1e-6,
    tauEpsilon = tau - epsilon;

function Path() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null; // end of current subpath
  this._ = "";
}

function path() {
  return new Path;
}

Path.prototype = path.prototype = {
  constructor: Path,
  moveTo: function(x, y) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
  },
  closePath: function() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  },
  lineTo: function(x, y) {
    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  quadraticCurveTo: function(x1, y1, x, y) {
    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  arcTo: function(x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
    var x0 = this._x1,
        y0 = this._y1,
        x21 = x2 - x1,
        y21 = y2 - y1,
        x01 = x0 - x1,
        y01 = y0 - y1,
        l01_2 = x01 * x01 + y01 * y01;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x1,y1).
    if (this._x1 === null) {
      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
    else if (!(l01_2 > epsilon)) {}

    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
    // Equivalently, is (x1,y1) coincident with (x2,y2)?
    // Or, is the radius zero? Line to (x1,y1).
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Otherwise, draw an arc!
    else {
      var x20 = x2 - x0,
          y20 = y2 - y0,
          l21_2 = x21 * x21 + y21 * y21,
          l20_2 = x20 * x20 + y20 * y20,
          l21 = Math.sqrt(l21_2),
          l01 = Math.sqrt(l01_2),
          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
          t01 = l / l01,
          t21 = l / l21;

      // If the start tangent is not coincident with (x0,y0), line to.
      if (Math.abs(t01 - 1) > epsilon) {
        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
      }

      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
    }
  },
  arc: function(x, y, r, a0, a1, ccw) {
    x = +x, y = +y, r = +r;
    var dx = r * Math.cos(a0),
        dy = r * Math.sin(a0),
        x0 = x + dx,
        y0 = y + dy,
        cw = 1 ^ ccw,
        da = ccw ? a0 - a1 : a1 - a0;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x0,y0).
    if (this._x1 === null) {
      this._ += "M" + x0 + "," + y0;
    }

    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
      this._ += "L" + x0 + "," + y0;
    }

    // Is this arc empty? We’re done.
    if (!r) return;

    // Does the angle go the wrong way? Flip the direction.
    if (da < 0) da = da % tau + tau;

    // Is this a complete circle? Draw two arcs to complete the circle.
    if (da > tauEpsilon) {
      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
    }

    // Is this arc non-empty? Draw an arc!
    else if (da > epsilon) {
      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    }
  },
  rect: function(x, y, w, h) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
  },
  toString: function() {
    return this._;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (path);


/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(72);


/* harmony default export */ __webpack_exports__["a"] = (function() {
  var keys = [],
      sortKeys = [],
      sortValues,
      rollup,
      nest;

  function apply(array, depth, createResult, setResult) {
    if (depth >= keys.length) {
      if (sortValues != null) array.sort(sortValues);
      return rollup != null ? rollup(array) : array;
    }

    var i = -1,
        n = array.length,
        key = keys[depth++],
        keyValue,
        value,
        valuesByKey = Object(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */])(),
        values,
        result = createResult();

    while (++i < n) {
      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
        values.push(value);
      } else {
        valuesByKey.set(keyValue, [value]);
      }
    }

    valuesByKey.each(function(values, key) {
      setResult(result, key, apply(values, depth, createResult, setResult));
    });

    return result;
  }

  function entries(map, depth) {
    if (++depth > keys.length) return map;
    var array, sortKey = sortKeys[depth - 1];
    if (rollup != null && depth >= keys.length) array = map.entries();
    else array = [], map.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
  }

  return nest = {
    object: function(array) { return apply(array, 0, createObject, setObject); },
    map: function(array) { return apply(array, 0, createMap, setMap); },
    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
    key: function(d) { keys.push(d); return nest; },
    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
    sortValues: function(order) { sortValues = order; return nest; },
    rollup: function(f) { rollup = f; return nest; }
  };
});

function createObject() {
  return {};
}

function setObject(object, key, value) {
  object[key] = value;
}

function createMap() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */])();
}

function setMap(map, key, value) {
  map.set(key, value);
}


/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(72);


function Set() {}

var proto = __WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */].prototype;

Set.prototype = set.prototype = {
  constructor: Set,
  has: proto.has,
  add: function(value) {
    value += "";
    this[__WEBPACK_IMPORTED_MODULE_0__map__["b" /* prefix */] + value] = value;
    return this;
  },
  remove: proto.remove,
  clear: proto.clear,
  values: proto.keys,
  size: proto.size,
  empty: proto.empty,
  each: proto.each
};

function set(object, f) {
  var set = new Set;

  // Copy constructor.
  if (object instanceof Set) object.each(function(value) { set.add(value); });

  // Otherwise, assume it’s an array.
  else if (object) {
    var i = -1, n = object.length;
    if (f == null) while (++i < n) set.add(object[i]);
    else while (++i < n) set.add(f(object[i], i, object));
  }

  return set;
}

/* harmony default export */ __webpack_exports__["a"] = (set);


/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(map) {
  var keys = [];
  for (var key in map) keys.push(key);
  return keys;
});


/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(map) {
  var values = [];
  for (var key in map) values.push(map[key]);
  return values;
});


/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(map) {
  var entries = [];
  for (var key in map) entries.push({key: key, value: map[key]});
  return entries;
});


/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return csvParse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return csvParseRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return csvFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return csvFormatRows; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dsv__ = __webpack_require__(74);


var csv = Object(__WEBPACK_IMPORTED_MODULE_0__dsv__["a" /* default */])(",");

var csvParse = csv.parse;
var csvParseRows = csv.parseRows;
var csvFormat = csv.format;
var csvFormatRows = csv.formatRows;


/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return tsvParse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return tsvParseRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tsvFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return tsvFormatRows; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dsv__ = __webpack_require__(74);


var tsv = Object(__WEBPACK_IMPORTED_MODULE_0__dsv__["a" /* default */])("\t");

var tsvParse = tsv.parse;
var tsvParseRows = tsv.parseRows;
var tsvFormat = tsv.format;
var tsvFormatRows = tsv.formatRows;


/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_center__ = __webpack_require__(352);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_center__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_collide__ = __webpack_require__(353);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_collide__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_link__ = __webpack_require__(367);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__src_link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_manyBody__ = __webpack_require__(368);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__src_manyBody__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_radial__ = __webpack_require__(369);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__src_radial__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_simulation__ = __webpack_require__(139);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__src_simulation__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_x__ = __webpack_require__(370);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__src_x__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_y__ = __webpack_require__(371);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__src_y__["a"]; });










/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x, y) {
  var nodes;

  if (x == null) x = 0;
  if (y == null) y = 0;

  function force() {
    var i,
        n = nodes.length,
        node,
        sx = 0,
        sy = 0;

    for (i = 0; i < n; ++i) {
      node = nodes[i], sx += node.x, sy += node.y;
    }

    for (sx = sx / n - x, sy = sy / n - y, i = 0; i < n; ++i) {
      node = nodes[i], node.x -= sx, node.y -= sy;
    }
  }

  force.initialize = function(_) {
    nodes = _;
  };

  force.x = function(_) {
    return arguments.length ? (x = +_, force) : x;
  };

  force.y = function(_) {
    return arguments.length ? (y = +_, force) : y;
  };

  return force;
});


/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiggle__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_quadtree__ = __webpack_require__(76);




function x(d) {
  return d.x + d.vx;
}

function y(d) {
  return d.y + d.vy;
}

/* harmony default export */ __webpack_exports__["a"] = (function(radius) {
  var nodes,
      radii,
      strength = 1,
      iterations = 1;

  if (typeof radius !== "function") radius = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(radius == null ? 1 : +radius);

  function force() {
    var i, n = nodes.length,
        tree,
        node,
        xi,
        yi,
        ri,
        ri2;

    for (var k = 0; k < iterations; ++k) {
      tree = Object(__WEBPACK_IMPORTED_MODULE_2_d3_quadtree__["a" /* quadtree */])(nodes, x, y).visitAfter(prepare);
      for (i = 0; i < n; ++i) {
        node = nodes[i];
        ri = radii[node.index], ri2 = ri * ri;
        xi = node.x + node.vx;
        yi = node.y + node.vy;
        tree.visit(apply);
      }
    }

    function apply(quad, x0, y0, x1, y1) {
      var data = quad.data, rj = quad.r, r = ri + rj;
      if (data) {
        if (data.index > node.index) {
          var x = xi - data.x - data.vx,
              y = yi - data.y - data.vy,
              l = x * x + y * y;
          if (l < r * r) {
            if (x === 0) x = Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])(), l += x * x;
            if (y === 0) y = Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])(), l += y * y;
            l = (r - (l = Math.sqrt(l))) / l * strength;
            node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
            node.vy += (y *= l) * r;
            data.vx -= x * (r = 1 - r);
            data.vy -= y * r;
          }
        }
        return;
      }
      return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
    }
  }

  function prepare(quad) {
    if (quad.data) return quad.r = radii[quad.data.index];
    for (var i = quad.r = 0; i < 4; ++i) {
      if (quad[i] && quad[i].r > quad.r) {
        quad.r = quad[i].r;
      }
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length, node;
    radii = new Array(n);
    for (i = 0; i < n; ++i) node = nodes[i], radii[node.index] = +radius(node, i, nodes);
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.iterations = function(_) {
    return arguments.length ? (iterations = +_, force) : iterations;
  };

  force.strength = function(_) {
    return arguments.length ? (strength = +_, force) : strength;
  };

  force.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : radius;
  };

  return force;
});


/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quadtree;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__add__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cover__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extent__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__find__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__remove__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__root__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__size__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__visit__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__visitAfter__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__x__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__y__ = __webpack_require__(366);













function quadtree(nodes, x, y) {
  var tree = new Quadtree(x == null ? __WEBPACK_IMPORTED_MODULE_10__x__["b" /* defaultX */] : x, y == null ? __WEBPACK_IMPORTED_MODULE_11__y__["b" /* defaultY */] : y, NaN, NaN, NaN, NaN);
  return nodes == null ? tree : tree.addAll(nodes);
}

function Quadtree(x, y, x0, y0, x1, y1) {
  this._x = x;
  this._y = y;
  this._x0 = x0;
  this._y0 = y0;
  this._x1 = x1;
  this._y1 = y1;
  this._root = undefined;
}

function leaf_copy(leaf) {
  var copy = {data: leaf.data}, next = copy;
  while (leaf = leaf.next) next = next.next = {data: leaf.data};
  return copy;
}

var treeProto = quadtree.prototype = Quadtree.prototype;

treeProto.copy = function() {
  var copy = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1),
      node = this._root,
      nodes,
      child;

  if (!node) return copy;

  if (!node.length) return copy._root = leaf_copy(node), copy;

  nodes = [{source: node, target: copy._root = new Array(4)}];
  while (node = nodes.pop()) {
    for (var i = 0; i < 4; ++i) {
      if (child = node.source[i]) {
        if (child.length) nodes.push({source: child, target: node.target[i] = new Array(4)});
        else node.target[i] = leaf_copy(child);
      }
    }
  }

  return copy;
};

treeProto.add = __WEBPACK_IMPORTED_MODULE_0__add__["b" /* default */];
treeProto.addAll = __WEBPACK_IMPORTED_MODULE_0__add__["a" /* addAll */];
treeProto.cover = __WEBPACK_IMPORTED_MODULE_1__cover__["a" /* default */];
treeProto.data = __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */];
treeProto.extent = __WEBPACK_IMPORTED_MODULE_3__extent__["a" /* default */];
treeProto.find = __WEBPACK_IMPORTED_MODULE_4__find__["a" /* default */];
treeProto.remove = __WEBPACK_IMPORTED_MODULE_5__remove__["a" /* default */];
treeProto.removeAll = __WEBPACK_IMPORTED_MODULE_5__remove__["b" /* removeAll */];
treeProto.root = __WEBPACK_IMPORTED_MODULE_6__root__["a" /* default */];
treeProto.size = __WEBPACK_IMPORTED_MODULE_7__size__["a" /* default */];
treeProto.visit = __WEBPACK_IMPORTED_MODULE_8__visit__["a" /* default */];
treeProto.visitAfter = __WEBPACK_IMPORTED_MODULE_9__visitAfter__["a" /* default */];
treeProto.x = __WEBPACK_IMPORTED_MODULE_10__x__["a" /* default */];
treeProto.y = __WEBPACK_IMPORTED_MODULE_11__y__["a" /* default */];


/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addAll;
/* harmony default export */ __webpack_exports__["b"] = (function(d) {
  var x = +this._x.call(null, d),
      y = +this._y.call(null, d);
  return add(this.cover(x, y), x, y, d);
});

function add(tree, x, y, d) {
  if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points

  var parent,
      node = tree._root,
      leaf = {data: d},
      x0 = tree._x0,
      y0 = tree._y0,
      x1 = tree._x1,
      y1 = tree._y1,
      xm,
      ym,
      xp,
      yp,
      right,
      bottom,
      i,
      j;

  // If the tree is empty, initialize the root as a leaf.
  if (!node) return tree._root = leaf, tree;

  // Find the existing leaf for the new point, or add it.
  while (node.length) {
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
    if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
  }

  // Is the new point is exactly coincident with the existing point?
  xp = +tree._x.call(null, node.data);
  yp = +tree._y.call(null, node.data);
  if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;

  // Otherwise, split the leaf node until the old and new point are separated.
  do {
    parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
  } while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | (xp >= xm)));
  return parent[j] = node, parent[i] = leaf, tree;
}

function addAll(data) {
  var d, i, n = data.length,
      x,
      y,
      xz = new Array(n),
      yz = new Array(n),
      x0 = Infinity,
      y0 = Infinity,
      x1 = -Infinity,
      y1 = -Infinity;

  // Compute the points and their extent.
  for (i = 0; i < n; ++i) {
    if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
    xz[i] = x;
    yz[i] = y;
    if (x < x0) x0 = x;
    if (x > x1) x1 = x;
    if (y < y0) y0 = y;
    if (y > y1) y1 = y;
  }

  // If there were no (valid) points, inherit the existing extent.
  if (x1 < x0) x0 = this._x0, x1 = this._x1;
  if (y1 < y0) y0 = this._y0, y1 = this._y1;

  // Expand the tree to cover the new points.
  this.cover(x0, y0).cover(x1, y1);

  // Add the new points.
  for (i = 0; i < n; ++i) {
    add(this, xz[i], yz[i], data[i]);
  }

  return this;
}


/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x, y) {
  if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points

  var x0 = this._x0,
      y0 = this._y0,
      x1 = this._x1,
      y1 = this._y1;

  // If the quadtree has no extent, initialize them.
  // Integer extent are necessary so that if we later double the extent,
  // the existing quadrant boundaries don’t change due to floating point error!
  if (isNaN(x0)) {
    x1 = (x0 = Math.floor(x)) + 1;
    y1 = (y0 = Math.floor(y)) + 1;
  }

  // Otherwise, double repeatedly to cover.
  else if (x0 > x || x > x1 || y0 > y || y > y1) {
    var z = x1 - x0,
        node = this._root,
        parent,
        i;

    switch (i = (y < (y0 + y1) / 2) << 1 | (x < (x0 + x1) / 2)) {
      case 0: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x1 = x0 + z, y1 = y0 + z, x > x1 || y > y1);
        break;
      }
      case 1: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x0 = x1 - z, y1 = y0 + z, x0 > x || y > y1);
        break;
      }
      case 2: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x1 = x0 + z, y0 = y1 - z, x > x1 || y0 > y);
        break;
      }
      case 3: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x0 = x1 - z, y0 = y1 - z, x0 > x || y0 > y);
        break;
      }
    }

    if (this._root && this._root.length) this._root = node;
  }

  // If the quadtree covers the point already, just return.
  else return this;

  this._x0 = x0;
  this._y0 = y0;
  this._x1 = x1;
  this._y1 = y1;
  return this;
});


/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var data = [];
  this.visit(function(node) {
    if (!node.length) do data.push(node.data); while (node = node.next)
  });
  return data;
});


/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(_) {
  return arguments.length
      ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1])
      : isNaN(this._x0) ? undefined : [[this._x0, this._y0], [this._x1, this._y1]];
});


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__quad__ = __webpack_require__(77);


/* harmony default export */ __webpack_exports__["a"] = (function(x, y, radius) {
  var data,
      x0 = this._x0,
      y0 = this._y0,
      x1,
      y1,
      x2,
      y2,
      x3 = this._x1,
      y3 = this._y1,
      quads = [],
      node = this._root,
      q,
      i;

  if (node) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node, x0, y0, x3, y3));
  if (radius == null) radius = Infinity;
  else {
    x0 = x - radius, y0 = y - radius;
    x3 = x + radius, y3 = y + radius;
    radius *= radius;
  }

  while (q = quads.pop()) {

    // Stop searching if this quadrant can’t contain a closer node.
    if (!(node = q.node)
        || (x1 = q.x0) > x3
        || (y1 = q.y0) > y3
        || (x2 = q.x1) < x0
        || (y2 = q.y1) < y0) continue;

    // Bisect the current quadrant.
    if (node.length) {
      var xm = (x1 + x2) / 2,
          ym = (y1 + y2) / 2;

      quads.push(
        new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node[3], xm, ym, x2, y2),
        new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node[2], x1, ym, xm, y2),
        new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node[1], xm, y1, x2, ym),
        new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node[0], x1, y1, xm, ym)
      );

      // Visit the closest quadrant first.
      if (i = (y >= ym) << 1 | (x >= xm)) {
        q = quads[quads.length - 1];
        quads[quads.length - 1] = quads[quads.length - 1 - i];
        quads[quads.length - 1 - i] = q;
      }
    }

    // Visit this point. (Visiting coincident points isn’t necessary!)
    else {
      var dx = x - +this._x.call(null, node.data),
          dy = y - +this._y.call(null, node.data),
          d2 = dx * dx + dy * dy;
      if (d2 < radius) {
        var d = Math.sqrt(radius = d2);
        x0 = x - d, y0 = y - d;
        x3 = x + d, y3 = y + d;
        data = node.data;
      }
    }
  }

  return data;
});


/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = removeAll;
/* harmony default export */ __webpack_exports__["a"] = (function(d) {
  if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points

  var parent,
      node = this._root,
      retainer,
      previous,
      next,
      x0 = this._x0,
      y0 = this._y0,
      x1 = this._x1,
      y1 = this._y1,
      x,
      y,
      xm,
      ym,
      right,
      bottom,
      i,
      j;

  // If the tree is empty, initialize the root as a leaf.
  if (!node) return this;

  // Find the leaf node for the point.
  // While descending, also retain the deepest parent with a non-removed sibling.
  if (node.length) while (true) {
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
    if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
    if (!node.length) break;
    if (parent[(i + 1) & 3] || parent[(i + 2) & 3] || parent[(i + 3) & 3]) retainer = parent, j = i;
  }

  // Find the point to remove.
  while (node.data !== d) if (!(previous = node, node = node.next)) return this;
  if (next = node.next) delete node.next;

  // If there are multiple coincident points, remove just the point.
  if (previous) return (next ? previous.next = next : delete previous.next), this;

  // If this is the root point, remove it.
  if (!parent) return this._root = next, this;

  // Remove this leaf.
  next ? parent[i] = next : delete parent[i];

  // If the parent now contains exactly one leaf, collapse superfluous parents.
  if ((node = parent[0] || parent[1] || parent[2] || parent[3])
      && node === (parent[3] || parent[2] || parent[1] || parent[0])
      && !node.length) {
    if (retainer) retainer[j] = node;
    else this._root = node;
  }

  return this;
});

function removeAll(data) {
  for (var i = 0, n = data.length; i < n; ++i) this.remove(data[i]);
  return this;
}


/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this._root;
});


/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var size = 0;
  this.visit(function(node) {
    if (!node.length) do ++size; while (node = node.next)
  });
  return size;
});


/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__quad__ = __webpack_require__(77);


/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var quads = [], q, node = this._root, child, x0, y0, x1, y1;
  if (node) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node, this._x0, this._y0, this._x1, this._y1));
  while (q = quads.pop()) {
    if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
      var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
      if (child = node[3]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, xm, ym, x1, y1));
      if (child = node[2]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, x0, ym, xm, y1));
      if (child = node[1]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, xm, y0, x1, ym));
      if (child = node[0]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, x0, y0, xm, ym));
    }
  }
  return this;
});


/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__quad__ = __webpack_require__(77);


/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var quads = [], next = [], q;
  if (this._root) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](this._root, this._x0, this._y0, this._x1, this._y1));
  while (q = quads.pop()) {
    var node = q.node;
    if (node.length) {
      var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
      if (child = node[0]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, x0, y0, xm, ym));
      if (child = node[1]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, xm, y0, x1, ym));
      if (child = node[2]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, x0, ym, xm, y1));
      if (child = node[3]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, xm, ym, x1, y1));
    }
    next.push(q);
  }
  while (q = next.pop()) {
    callback(q.node, q.x0, q.y0, q.x1, q.y1);
  }
  return this;
});


/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = defaultX;
function defaultX(d) {
  return d[0];
}

/* harmony default export */ __webpack_exports__["a"] = (function(_) {
  return arguments.length ? (this._x = _, this) : this._x;
});


/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = defaultY;
function defaultY(d) {
  return d[1];
}

/* harmony default export */ __webpack_exports__["a"] = (function(_) {
  return arguments.length ? (this._y = _, this) : this._y;
});


/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiggle__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_collection__ = __webpack_require__(28);




function index(d) {
  return d.index;
}

function find(nodeById, nodeId) {
  var node = nodeById.get(nodeId);
  if (!node) throw new Error("missing: " + nodeId);
  return node;
}

/* harmony default export */ __webpack_exports__["a"] = (function(links) {
  var id = index,
      strength = defaultStrength,
      strengths,
      distance = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(30),
      distances,
      nodes,
      count,
      bias,
      iterations = 1;

  if (links == null) links = [];

  function defaultStrength(link) {
    return 1 / Math.min(count[link.source.index], count[link.target.index]);
  }

  function force(alpha) {
    for (var k = 0, n = links.length; k < iterations; ++k) {
      for (var i = 0, link, source, target, x, y, l, b; i < n; ++i) {
        link = links[i], source = link.source, target = link.target;
        x = target.x + target.vx - source.x - source.vx || Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])();
        y = target.y + target.vy - source.y - source.vy || Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])();
        l = Math.sqrt(x * x + y * y);
        l = (l - distances[i]) / l * alpha * strengths[i];
        x *= l, y *= l;
        target.vx -= x * (b = bias[i]);
        target.vy -= y * b;
        source.vx += x * (b = 1 - b);
        source.vy += y * b;
      }
    }
  }

  function initialize() {
    if (!nodes) return;

    var i,
        n = nodes.length,
        m = links.length,
        nodeById = Object(__WEBPACK_IMPORTED_MODULE_2_d3_collection__["c" /* map */])(nodes, id),
        link;

    for (i = 0, count = new Array(n); i < m; ++i) {
      link = links[i], link.index = i;
      if (typeof link.source !== "object") link.source = find(nodeById, link.source);
      if (typeof link.target !== "object") link.target = find(nodeById, link.target);
      count[link.source.index] = (count[link.source.index] || 0) + 1;
      count[link.target.index] = (count[link.target.index] || 0) + 1;
    }

    for (i = 0, bias = new Array(m); i < m; ++i) {
      link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
    }

    strengths = new Array(m), initializeStrength();
    distances = new Array(m), initializeDistance();
  }

  function initializeStrength() {
    if (!nodes) return;

    for (var i = 0, n = links.length; i < n; ++i) {
      strengths[i] = +strength(links[i], i, links);
    }
  }

  function initializeDistance() {
    if (!nodes) return;

    for (var i = 0, n = links.length; i < n; ++i) {
      distances[i] = +distance(links[i], i, links);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.links = function(_) {
    return arguments.length ? (links = _, initialize(), force) : links;
  };

  force.id = function(_) {
    return arguments.length ? (id = _, force) : id;
  };

  force.iterations = function(_) {
    return arguments.length ? (iterations = +_, force) : iterations;
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initializeStrength(), force) : strength;
  };

  force.distance = function(_) {
    return arguments.length ? (distance = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initializeDistance(), force) : distance;
  };

  return force;
});


/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiggle__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_quadtree__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__simulation__ = __webpack_require__(139);





/* harmony default export */ __webpack_exports__["a"] = (function() {
  var nodes,
      node,
      alpha,
      strength = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(-30),
      strengths,
      distanceMin2 = 1,
      distanceMax2 = Infinity,
      theta2 = 0.81;

  function force(_) {
    var i, n = nodes.length, tree = Object(__WEBPACK_IMPORTED_MODULE_2_d3_quadtree__["a" /* quadtree */])(nodes, __WEBPACK_IMPORTED_MODULE_3__simulation__["b" /* x */], __WEBPACK_IMPORTED_MODULE_3__simulation__["c" /* y */]).visitAfter(accumulate);
    for (alpha = _, i = 0; i < n; ++i) node = nodes[i], tree.visit(apply);
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length, node;
    strengths = new Array(n);
    for (i = 0; i < n; ++i) node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
  }

  function accumulate(quad) {
    var strength = 0, q, c, weight = 0, x, y, i;

    // For internal nodes, accumulate forces from child quadrants.
    if (quad.length) {
      for (x = y = i = 0; i < 4; ++i) {
        if ((q = quad[i]) && (c = Math.abs(q.value))) {
          strength += q.value, weight += c, x += c * q.x, y += c * q.y;
        }
      }
      quad.x = x / weight;
      quad.y = y / weight;
    }

    // For leaf nodes, accumulate forces from coincident quadrants.
    else {
      q = quad;
      q.x = q.data.x;
      q.y = q.data.y;
      do strength += strengths[q.data.index];
      while (q = q.next);
    }

    quad.value = strength;
  }

  function apply(quad, x1, _, x2) {
    if (!quad.value) return true;

    var x = quad.x - node.x,
        y = quad.y - node.y,
        w = x2 - x1,
        l = x * x + y * y;

    // Apply the Barnes-Hut approximation if possible.
    // Limit forces for very close nodes; randomize direction if coincident.
    if (w * w / theta2 < l) {
      if (l < distanceMax2) {
        if (x === 0) x = Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])(), l += x * x;
        if (y === 0) y = Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])(), l += y * y;
        if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
        node.vx += x * quad.value * alpha / l;
        node.vy += y * quad.value * alpha / l;
      }
      return true;
    }

    // Otherwise, process points directly.
    else if (quad.length || l >= distanceMax2) return;

    // Limit forces for very close nodes; randomize direction if coincident.
    if (quad.data !== node || quad.next) {
      if (x === 0) x = Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])(), l += x * x;
      if (y === 0) y = Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])(), l += y * y;
      if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
    }

    do if (quad.data !== node) {
      w = strengths[quad.data.index] * alpha / l;
      node.vx += x * w;
      node.vy += y * w;
    } while (quad = quad.next);
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : strength;
  };

  force.distanceMin = function(_) {
    return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
  };

  force.distanceMax = function(_) {
    return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
  };

  force.theta = function(_) {
    return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
  };

  return force;
});


/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = (function(radius, x, y) {
  var nodes,
      strength = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0.1),
      strengths,
      radiuses;

  if (typeof radius !== "function") radius = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+radius);
  if (x == null) x = 0;
  if (y == null) y = 0;

  function force(alpha) {
    for (var i = 0, n = nodes.length; i < n; ++i) {
      var node = nodes[i],
          dx = node.x - x || 1e-6,
          dy = node.y - y || 1e-6,
          r = Math.sqrt(dx * dx + dy * dy),
          k = (radiuses[i] - r) * strengths[i] * alpha / r;
      node.vx += dx * k;
      node.vy += dy * k;
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    radiuses = new Array(n);
    for (i = 0; i < n; ++i) {
      radiuses[i] = +radius(nodes[i], i, nodes);
      strengths[i] = isNaN(radiuses[i]) ? 0 : +strength(nodes[i], i, nodes);
    }
  }

  force.initialize = function(_) {
    nodes = _, initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : strength;
  };

  force.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : radius;
  };

  force.x = function(_) {
    return arguments.length ? (x = +_, force) : x;
  };

  force.y = function(_) {
    return arguments.length ? (y = +_, force) : y;
  };

  return force;
});


/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  var strength = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0.1),
      nodes,
      strengths,
      xz;

  if (typeof x !== "function") x = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(x == null ? 0 : +x);

  function force(alpha) {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    xz = new Array(n);
    for (i = 0; i < n; ++i) {
      strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : strength;
  };

  force.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : x;
  };

  return force;
});


/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = (function(y) {
  var strength = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0.1),
      nodes,
      strengths,
      yz;

  if (typeof y !== "function") y = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(y == null ? 0 : +y);

  function force(alpha) {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    yz = new Array(n);
    for (i = 0; i < n; ++i) {
      strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : strength;
  };

  force.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : y;
  };

  return force;
});


/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return format; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return formatPrefix; });
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultLocale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__(140);


var locale;
var format;
var formatPrefix;

defaultLocale({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});

function defaultLocale(definition) {
  locale = Object(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* default */])(definition);
  format = locale.format;
  formatPrefix = locale.formatPrefix;
  return locale;
}


/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
});


/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
});


/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  x = x.toPrecision(p);

  out: for (var n = x.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (x[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      case "e": break out;
      default: if (i0 > 0) i0 = 0; break;
    }
  }

  return i0 > 0 ? x.slice(0, i0) + x.slice(i1 + 1) : x;
});


/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(79);


/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  var d = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
});


/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(44);


/* harmony default export */ __webpack_exports__["a"] = (function(step) {
  return Math.max(0, -Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(Math.abs(step)));
});


/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(44);


/* harmony default export */ __webpack_exports__["a"] = (function(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(value) / 3))) * 3 - Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(Math.abs(step)));
});


/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(44);


/* harmony default export */ __webpack_exports__["a"] = (function(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(max) - Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(step)) + 1;
});


/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_area__ = __webpack_require__(144);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__src_area__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_bounds__ = __webpack_require__(382);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__src_bounds__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_centroid__ = __webpack_require__(383);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_2__src_centroid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_circle__ = __webpack_require__(145);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_3__src_circle__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_clip_antimeridian__ = __webpack_require__(147);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_4__src_clip_antimeridian__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_clip_circle__ = __webpack_require__(153);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_5__src_clip_circle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_clip_extent__ = __webpack_require__(385);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_6__src_clip_extent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_clip_rectangle__ = __webpack_require__(46);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_7__src_clip_rectangle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_contains__ = __webpack_require__(387);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_8__src_contains__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_distance__ = __webpack_require__(154);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_9__src_distance__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_graticule__ = __webpack_require__(388);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_10__src_graticule__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_10__src_graticule__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_interpolate__ = __webpack_require__(389);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_11__src_interpolate__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_length__ = __webpack_require__(155);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_12__src_length__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_path_index__ = __webpack_require__(390);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_13__src_path_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_projection_albers__ = __webpack_require__(157);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_14__src_projection_albers__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_projection_albersUsa__ = __webpack_require__(398);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_15__src_projection_albersUsa__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_projection_azimuthalEqualArea__ = __webpack_require__(399);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_16__src_projection_azimuthalEqualArea__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_16__src_projection_azimuthalEqualArea__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_projection_azimuthalEquidistant__ = __webpack_require__(400);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_17__src_projection_azimuthalEquidistant__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_17__src_projection_azimuthalEquidistant__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_projection_conicConformal__ = __webpack_require__(401);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_18__src_projection_conicConformal__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_18__src_projection_conicConformal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_projection_conicEqualArea__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_19__src_projection_conicEqualArea__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_19__src_projection_conicEqualArea__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_projection_conicEquidistant__ = __webpack_require__(402);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_20__src_projection_conicEquidistant__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_20__src_projection_conicEquidistant__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_projection_equirectangular__ = __webpack_require__(158);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_21__src_projection_equirectangular__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_21__src_projection_equirectangular__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_projection_gnomonic__ = __webpack_require__(403);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_22__src_projection_gnomonic__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_22__src_projection_gnomonic__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_projection_identity__ = __webpack_require__(404);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_23__src_projection_identity__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_projection_index__ = __webpack_require__(10);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_24__src_projection_index__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_24__src_projection_index__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__src_projection_mercator__ = __webpack_require__(84);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_25__src_projection_mercator__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_25__src_projection_mercator__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__src_projection_naturalEarth1__ = __webpack_require__(405);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_26__src_projection_naturalEarth1__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_26__src_projection_naturalEarth1__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__src_projection_orthographic__ = __webpack_require__(406);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_27__src_projection_orthographic__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_27__src_projection_orthographic__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__src_projection_stereographic__ = __webpack_require__(407);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_28__src_projection_stereographic__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_28__src_projection_stereographic__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__src_projection_transverseMercator__ = __webpack_require__(408);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_29__src_projection_transverseMercator__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_29__src_projection_transverseMercator__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__src_rotation__ = __webpack_require__(45);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_30__src_rotation__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__src_stream__ = __webpack_require__(16);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_31__src_stream__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__src_transform__ = __webpack_require__(47);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_32__src_transform__["a"]; });






 // DEPRECATED! Use d3.geoIdentity().clipExtent(…).




























/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__area__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cartesian__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stream__ = __webpack_require__(16);






var lambda0, phi0, lambda1, phi1, // bounds
    lambda2, // previous lambda-coordinate
    lambda00, phi00, // first point
    p0, // previous 3D point
    deltaSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    ranges,
    range;

var boundsStream = {
  point: boundsPoint,
  lineStart: boundsLineStart,
  lineEnd: boundsLineEnd,
  polygonStart: function() {
    boundsStream.point = boundsRingPoint;
    boundsStream.lineStart = boundsRingStart;
    boundsStream.lineEnd = boundsRingEnd;
    deltaSum.reset();
    __WEBPACK_IMPORTED_MODULE_1__area__["b" /* areaStream */].polygonStart();
  },
  polygonEnd: function() {
    __WEBPACK_IMPORTED_MODULE_1__area__["b" /* areaStream */].polygonEnd();
    boundsStream.point = boundsPoint;
    boundsStream.lineStart = boundsLineStart;
    boundsStream.lineEnd = boundsLineEnd;
    if (__WEBPACK_IMPORTED_MODULE_1__area__["a" /* areaRingSum */] < 0) lambda0 = -(lambda1 = 180), phi0 = -(phi1 = 90);
    else if (deltaSum > __WEBPACK_IMPORTED_MODULE_3__math__["i" /* epsilon */]) phi1 = 90;
    else if (deltaSum < -__WEBPACK_IMPORTED_MODULE_3__math__["i" /* epsilon */]) phi0 = -90;
    range[0] = lambda0, range[1] = lambda1;
  }
};

function boundsPoint(lambda, phi) {
  ranges.push(range = [lambda0 = lambda, lambda1 = lambda]);
  if (phi < phi0) phi0 = phi;
  if (phi > phi1) phi1 = phi;
}

function linePoint(lambda, phi) {
  var p = Object(__WEBPACK_IMPORTED_MODULE_2__cartesian__["a" /* cartesian */])([lambda * __WEBPACK_IMPORTED_MODULE_3__math__["r" /* radians */], phi * __WEBPACK_IMPORTED_MODULE_3__math__["r" /* radians */]]);
  if (p0) {
    var normal = Object(__WEBPACK_IMPORTED_MODULE_2__cartesian__["c" /* cartesianCross */])(p0, p),
        equatorial = [normal[1], -normal[0], 0],
        inflection = Object(__WEBPACK_IMPORTED_MODULE_2__cartesian__["c" /* cartesianCross */])(equatorial, normal);
    Object(__WEBPACK_IMPORTED_MODULE_2__cartesian__["e" /* cartesianNormalizeInPlace */])(inflection);
    inflection = Object(__WEBPACK_IMPORTED_MODULE_2__cartesian__["g" /* spherical */])(inflection);
    var delta = lambda - lambda2,
        sign = delta > 0 ? 1 : -1,
        lambdai = inflection[0] * __WEBPACK_IMPORTED_MODULE_3__math__["h" /* degrees */] * sign,
        phii,
        antimeridian = Object(__WEBPACK_IMPORTED_MODULE_3__math__["a" /* abs */])(delta) > 180;
    if (antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
      phii = inflection[1] * __WEBPACK_IMPORTED_MODULE_3__math__["h" /* degrees */];
      if (phii > phi1) phi1 = phii;
    } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
      phii = -inflection[1] * __WEBPACK_IMPORTED_MODULE_3__math__["h" /* degrees */];
      if (phii < phi0) phi0 = phii;
    } else {
      if (phi < phi0) phi0 = phi;
      if (phi > phi1) phi1 = phi;
    }
    if (antimeridian) {
      if (lambda < lambda2) {
        if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
      } else {
        if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
      }
    } else {
      if (lambda1 >= lambda0) {
        if (lambda < lambda0) lambda0 = lambda;
        if (lambda > lambda1) lambda1 = lambda;
      } else {
        if (lambda > lambda2) {
          if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
        } else {
          if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
        }
      }
    }
  } else {
    ranges.push(range = [lambda0 = lambda, lambda1 = lambda]);
  }
  if (phi < phi0) phi0 = phi;
  if (phi > phi1) phi1 = phi;
  p0 = p, lambda2 = lambda;
}

function boundsLineStart() {
  boundsStream.point = linePoint;
}

function boundsLineEnd() {
  range[0] = lambda0, range[1] = lambda1;
  boundsStream.point = boundsPoint;
  p0 = null;
}

function boundsRingPoint(lambda, phi) {
  if (p0) {
    var delta = lambda - lambda2;
    deltaSum.add(Object(__WEBPACK_IMPORTED_MODULE_3__math__["a" /* abs */])(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
  } else {
    lambda00 = lambda, phi00 = phi;
  }
  __WEBPACK_IMPORTED_MODULE_1__area__["b" /* areaStream */].point(lambda, phi);
  linePoint(lambda, phi);
}

function boundsRingStart() {
  __WEBPACK_IMPORTED_MODULE_1__area__["b" /* areaStream */].lineStart();
}

function boundsRingEnd() {
  boundsRingPoint(lambda00, phi00);
  __WEBPACK_IMPORTED_MODULE_1__area__["b" /* areaStream */].lineEnd();
  if (Object(__WEBPACK_IMPORTED_MODULE_3__math__["a" /* abs */])(deltaSum) > __WEBPACK_IMPORTED_MODULE_3__math__["i" /* epsilon */]) lambda0 = -(lambda1 = 180);
  range[0] = lambda0, range[1] = lambda1;
  p0 = null;
}

// Finds the left-right distance between two longitudes.
// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
// the distance between ±180° to be 360°.
function angle(lambda0, lambda1) {
  return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
}

function rangeCompare(a, b) {
  return a[0] - b[0];
}

function rangeContains(range, x) {
  return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
}

/* harmony default export */ __webpack_exports__["a"] = (function(feature) {
  var i, n, a, b, merged, deltaMax, delta;

  phi1 = lambda1 = -(lambda0 = phi0 = Infinity);
  ranges = [];
  Object(__WEBPACK_IMPORTED_MODULE_4__stream__["a" /* default */])(feature, boundsStream);

  // First, sort ranges by their minimum longitudes.
  if (n = ranges.length) {
    ranges.sort(rangeCompare);

    // Then, merge any ranges that overlap.
    for (i = 1, a = ranges[0], merged = [a]; i < n; ++i) {
      b = ranges[i];
      if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
        if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
        if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
      } else {
        merged.push(a = b);
      }
    }

    // Finally, find the largest gap between the merged ranges.
    // The final bounding box will be the inverse of this gap.
    for (deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i) {
      b = merged[i];
      if ((delta = angle(a[1], b[0])) > deltaMax) deltaMax = delta, lambda0 = b[0], lambda1 = a[1];
    }
  }

  ranges = range = null;

  return lambda0 === Infinity || phi0 === Infinity
      ? [[NaN, NaN], [NaN, NaN]]
      : [[lambda0, phi0], [lambda1, phi1]];
});


/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stream__ = __webpack_require__(16);




var W0, W1,
    X0, Y0, Z0,
    X1, Y1, Z1,
    X2, Y2, Z2,
    lambda00, phi00, // first point
    x0, y0, z0; // previous point

var centroidStream = {
  sphere: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  point: centroidPoint,
  lineStart: centroidLineStart,
  lineEnd: centroidLineEnd,
  polygonStart: function() {
    centroidStream.lineStart = centroidRingStart;
    centroidStream.lineEnd = centroidRingEnd;
  },
  polygonEnd: function() {
    centroidStream.lineStart = centroidLineStart;
    centroidStream.lineEnd = centroidLineEnd;
  }
};

// Arithmetic mean of Cartesian vectors.
function centroidPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */];
  var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(phi);
  centroidPointCartesian(cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(lambda), cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(lambda), Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(phi));
}

function centroidPointCartesian(x, y, z) {
  ++W0;
  X0 += (x - X0) / W0;
  Y0 += (y - Y0) / W0;
  Z0 += (z - Z0) / W0;
}

function centroidLineStart() {
  centroidStream.point = centroidLinePointFirst;
}

function centroidLinePointFirst(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */];
  var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(phi);
  x0 = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(lambda);
  y0 = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(lambda);
  z0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(phi);
  centroidStream.point = centroidLinePoint;
  centroidPointCartesian(x0, y0, z0);
}

function centroidLinePoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */];
  var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(phi),
      x = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(lambda),
      y = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(lambda),
      z = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(phi),
      w = Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
  W1 += w;
  X1 += w * (x0 + (x0 = x));
  Y1 += w * (y0 + (y0 = y));
  Z1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0, y0, z0);
}

function centroidLineEnd() {
  centroidStream.point = centroidPoint;
}

// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
// J. Applied Mechanics 42, 239 (1975).
function centroidRingStart() {
  centroidStream.point = centroidRingPointFirst;
}

function centroidRingEnd() {
  centroidRingPoint(lambda00, phi00);
  centroidStream.point = centroidPoint;
}

function centroidRingPointFirst(lambda, phi) {
  lambda00 = lambda, phi00 = phi;
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */];
  centroidStream.point = centroidRingPoint;
  var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(phi);
  x0 = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(lambda);
  y0 = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(lambda);
  z0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(phi);
  centroidPointCartesian(x0, y0, z0);
}

function centroidRingPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */];
  var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(phi),
      x = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(lambda),
      y = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(lambda),
      z = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(phi),
      cx = y0 * z - z0 * y,
      cy = z0 * x - x0 * z,
      cz = x0 * y - y0 * x,
      m = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(cx * cx + cy * cy + cz * cz),
      w = Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])(m), // line weight = angle
      v = m && -w / m; // area weight multiplier
  X2 += v * cx;
  Y2 += v * cy;
  Z2 += v * cz;
  W1 += w;
  X1 += w * (x0 + (x0 = x));
  Y1 += w * (y0 + (y0 = y));
  Z1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0, y0, z0);
}

/* harmony default export */ __webpack_exports__["a"] = (function(object) {
  W0 = W1 =
  X0 = Y0 = Z0 =
  X1 = Y1 = Z1 =
  X2 = Y2 = Z2 = 0;
  Object(__WEBPACK_IMPORTED_MODULE_2__stream__["a" /* default */])(object, centroidStream);

  var x = X2,
      y = Y2,
      z = Z2,
      m = x * x + y * y + z * z;

  // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
  if (m < __WEBPACK_IMPORTED_MODULE_0__math__["j" /* epsilon2 */]) {
    x = X1, y = Y1, z = Z1;
    // If the feature has zero length, fall back to arithmetic mean of point vectors.
    if (W1 < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]) x = X0, y = Y0, z = Z0;
    m = x * x + y * y + z * z;
    // If the feature still has an undefined ccentroid, then return.
    if (m < __WEBPACK_IMPORTED_MODULE_0__math__["j" /* epsilon2 */]) return [NaN, NaN];
  }

  return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(y, x) * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */], Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])(z / Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(m)) * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */]];
});


/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rectangle__ = __webpack_require__(46);


/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x0 = 0,
      y0 = 0,
      x1 = 960,
      y1 = 500,
      cache,
      cacheStream,
      clip;

  return clip = {
    stream: function(stream) {
      return cache && cacheStream === stream ? cache : cache = Object(__WEBPACK_IMPORTED_MODULE_0__rectangle__["a" /* default */])(x0, y0, x1, y1)(cacheStream = stream);
    },
    extent: function(_) {
      return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [[x0, y0], [x1, y1]];
    }
  };
});


/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b, x0, y0, x1, y1) {
  var ax = a[0],
      ay = a[1],
      bx = b[0],
      by = b[1],
      t0 = 0,
      t1 = 1,
      dx = bx - ax,
      dy = by - ay,
      r;

  r = x0 - ax;
  if (!dx && r > 0) return;
  r /= dx;
  if (dx < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dx > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = x1 - ax;
  if (!dx && r < 0) return;
  r /= dx;
  if (dx < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dx > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  r = y0 - ay;
  if (!dy && r > 0) return;
  r /= dy;
  if (dy < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dy > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = y1 - ay;
  if (!dy && r < 0) return;
  r /= dy;
  if (dy < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dy > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
  if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
  return true;
});


/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polygonContains__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__distance__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(0);




var containsObjectType = {
  Feature: function(object, point) {
    return containsGeometry(object.geometry, point);
  },
  FeatureCollection: function(object, point) {
    var features = object.features, i = -1, n = features.length;
    while (++i < n) if (containsGeometry(features[i].geometry, point)) return true;
    return false;
  }
};

var containsGeometryType = {
  Sphere: function() {
    return true;
  },
  Point: function(object, point) {
    return containsPoint(object.coordinates, point);
  },
  MultiPoint: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsPoint(coordinates[i], point)) return true;
    return false;
  },
  LineString: function(object, point) {
    return containsLine(object.coordinates, point);
  },
  MultiLineString: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsLine(coordinates[i], point)) return true;
    return false;
  },
  Polygon: function(object, point) {
    return containsPolygon(object.coordinates, point);
  },
  MultiPolygon: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsPolygon(coordinates[i], point)) return true;
    return false;
  },
  GeometryCollection: function(object, point) {
    var geometries = object.geometries, i = -1, n = geometries.length;
    while (++i < n) if (containsGeometry(geometries[i], point)) return true;
    return false;
  }
};

function containsGeometry(geometry, point) {
  return geometry && containsGeometryType.hasOwnProperty(geometry.type)
      ? containsGeometryType[geometry.type](geometry, point)
      : false;
}

function containsPoint(coordinates, point) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__distance__["a" /* default */])(coordinates, point) === 0;
}

function containsLine(coordinates, point) {
  var ab = Object(__WEBPACK_IMPORTED_MODULE_1__distance__["a" /* default */])(coordinates[0], coordinates[1]),
      ao = Object(__WEBPACK_IMPORTED_MODULE_1__distance__["a" /* default */])(coordinates[0], point),
      ob = Object(__WEBPACK_IMPORTED_MODULE_1__distance__["a" /* default */])(point, coordinates[1]);
  return ao + ob <= ab + __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */];
}

function containsPolygon(coordinates, point) {
  return !!Object(__WEBPACK_IMPORTED_MODULE_0__polygonContains__["a" /* default */])(coordinates.map(ringRadians), pointRadians(point));
}

function ringRadians(ring) {
  return ring = ring.map(pointRadians), ring.pop(), ring;
}

function pointRadians(point) {
  return [point[0] * __WEBPACK_IMPORTED_MODULE_2__math__["r" /* radians */], point[1] * __WEBPACK_IMPORTED_MODULE_2__math__["r" /* radians */]];
}

/* harmony default export */ __webpack_exports__["a"] = (function(object, point) {
  return (object && containsObjectType.hasOwnProperty(object.type)
      ? containsObjectType[object.type]
      : containsGeometry)(object, point);
});


/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = graticule;
/* harmony export (immutable) */ __webpack_exports__["b"] = graticule10;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(0);



function graticuleX(y0, y1, dy) {
  var y = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["s" /* range */])(y0, y1 - __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */], dy).concat(y1);
  return function(x) { return y.map(function(y) { return [x, y]; }); };
}

function graticuleY(x0, x1, dx) {
  var x = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["s" /* range */])(x0, x1 - __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */], dx).concat(x1);
  return function(y) { return x.map(function(x) { return [x, y]; }); };
}

function graticule() {
  var x1, x0, X1, X0,
      y1, y0, Y1, Y0,
      dx = 10, dy = dx, DX = 90, DY = 360,
      x, y, X, Y,
      precision = 2.5;

  function graticule() {
    return {type: "MultiLineString", coordinates: lines()};
  }

  function lines() {
    return Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["s" /* range */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* ceil */])(X0 / DX) * DX, X1, DX).map(X)
        .concat(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["s" /* range */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* ceil */])(Y0 / DY) * DY, Y1, DY).map(Y))
        .concat(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["s" /* range */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* ceil */])(x0 / dx) * dx, x1, dx).filter(function(x) { return Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(x % DX) > __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]; }).map(x))
        .concat(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["s" /* range */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* ceil */])(y0 / dy) * dy, y1, dy).filter(function(y) { return Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(y % DY) > __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]; }).map(y));
  }

  graticule.lines = function() {
    return lines().map(function(coordinates) { return {type: "LineString", coordinates: coordinates}; });
  };

  graticule.outline = function() {
    return {
      type: "Polygon",
      coordinates: [
        X(X0).concat(
        Y(Y1).slice(1),
        X(X1).reverse().slice(1),
        Y(Y0).reverse().slice(1))
      ]
    };
  };

  graticule.extent = function(_) {
    if (!arguments.length) return graticule.extentMinor();
    return graticule.extentMajor(_).extentMinor(_);
  };

  graticule.extentMajor = function(_) {
    if (!arguments.length) return [[X0, Y0], [X1, Y1]];
    X0 = +_[0][0], X1 = +_[1][0];
    Y0 = +_[0][1], Y1 = +_[1][1];
    if (X0 > X1) _ = X0, X0 = X1, X1 = _;
    if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
    return graticule.precision(precision);
  };

  graticule.extentMinor = function(_) {
    if (!arguments.length) return [[x0, y0], [x1, y1]];
    x0 = +_[0][0], x1 = +_[1][0];
    y0 = +_[0][1], y1 = +_[1][1];
    if (x0 > x1) _ = x0, x0 = x1, x1 = _;
    if (y0 > y1) _ = y0, y0 = y1, y1 = _;
    return graticule.precision(precision);
  };

  graticule.step = function(_) {
    if (!arguments.length) return graticule.stepMinor();
    return graticule.stepMajor(_).stepMinor(_);
  };

  graticule.stepMajor = function(_) {
    if (!arguments.length) return [DX, DY];
    DX = +_[0], DY = +_[1];
    return graticule;
  };

  graticule.stepMinor = function(_) {
    if (!arguments.length) return [dx, dy];
    dx = +_[0], dy = +_[1];
    return graticule;
  };

  graticule.precision = function(_) {
    if (!arguments.length) return precision;
    precision = +_;
    x = graticuleX(y0, y1, 90);
    y = graticuleY(x0, x1, precision);
    X = graticuleX(Y0, Y1, 90);
    Y = graticuleY(X0, X1, precision);
    return graticule;
  };

  return graticule
      .extentMajor([[-180, -90 + __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]], [180, 90 - __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]]])
      .extentMinor([[-180, -80 - __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]], [180, 80 + __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]]]);
}

function graticule10() {
  return graticule()();
}


/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var x0 = a[0] * __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */],
      y0 = a[1] * __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */],
      x1 = b[0] * __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */],
      y1 = b[1] * __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */],
      cy0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y0),
      sy0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y0),
      cy1 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y1),
      sy1 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y1),
      kx0 = cy0 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(x0),
      ky0 = cy0 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(x0),
      kx1 = cy1 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(x1),
      ky1 = cy1 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(x1),
      d = 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["m" /* haversin */])(y1 - y0) + cy0 * cy1 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["m" /* haversin */])(x1 - x0))),
      k = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(d);

  var interpolate = d ? function(t) {
    var B = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(t *= d) / k,
        A = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(d - t) / k,
        x = A * kx0 + B * kx1,
        y = A * ky0 + B * ky1,
        z = A * sy0 + B * sy1;
    return [
      Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(y, x) * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */],
      Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(z, Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(x * x + y * y)) * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */]
    ];
  } : function() {
    return [x0 * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */], y0 * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */]];
  };

  interpolate.distance = d;

  return interpolate;
});


/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stream__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__area__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bounds__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__centroid__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__context__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__measure__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__string__ = __webpack_require__(395);









/* harmony default export */ __webpack_exports__["a"] = (function(projection, context) {
  var pointRadius = 4.5,
      projectionStream,
      contextStream;

  function path(object) {
    if (object) {
      if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
      Object(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(contextStream));
    }
    return contextStream.result();
  }

  path.area = function(object) {
    Object(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_2__area__["a" /* default */]));
    return __WEBPACK_IMPORTED_MODULE_2__area__["a" /* default */].result();
  };

  path.measure = function(object) {
    Object(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_6__measure__["a" /* default */]));
    return __WEBPACK_IMPORTED_MODULE_6__measure__["a" /* default */].result();
  };

  path.bounds = function(object) {
    Object(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_3__bounds__["a" /* default */]));
    return __WEBPACK_IMPORTED_MODULE_3__bounds__["a" /* default */].result();
  };

  path.centroid = function(object) {
    Object(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_4__centroid__["a" /* default */]));
    return __WEBPACK_IMPORTED_MODULE_4__centroid__["a" /* default */].result();
  };

  path.projection = function(_) {
    return arguments.length ? (projectionStream = _ == null ? (projection = null, __WEBPACK_IMPORTED_MODULE_0__identity__["a" /* default */]) : (projection = _).stream, path) : projection;
  };

  path.context = function(_) {
    if (!arguments.length) return context;
    contextStream = _ == null ? (context = null, new __WEBPACK_IMPORTED_MODULE_7__string__["a" /* default */]) : new __WEBPACK_IMPORTED_MODULE_5__context__["a" /* default */](context = _);
    if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
    return path;
  };

  path.pointRadius = function(_) {
    if (!arguments.length) return pointRadius;
    pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
    return path;
  };

  return path.projection(projection).context(context);
});


/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noop__ = __webpack_require__(13);




var areaSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    areaRingSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    x00,
    y00,
    x0,
    y0;

var areaStream = {
  point: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineStart: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineEnd: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  polygonStart: function() {
    areaStream.lineStart = areaRingStart;
    areaStream.lineEnd = areaRingEnd;
  },
  polygonEnd: function() {
    areaStream.lineStart = areaStream.lineEnd = areaStream.point = __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */];
    areaSum.add(Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(areaRingSum));
    areaRingSum.reset();
  },
  result: function() {
    var area = areaSum / 2;
    areaSum.reset();
    return area;
  }
};

function areaRingStart() {
  areaStream.point = areaPointFirst;
}

function areaPointFirst(x, y) {
  areaStream.point = areaPoint;
  x00 = x0 = x, y00 = y0 = y;
}

function areaPoint(x, y) {
  areaRingSum.add(y0 * x - x0 * y);
  x0 = x, y0 = y;
}

function areaRingEnd() {
  areaPoint(x00, y00);
}

/* harmony default export */ __webpack_exports__["a"] = (areaStream);


/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);


// TODO Enforce positive area for exterior, negative area for interior?

var X0 = 0,
    Y0 = 0,
    Z0 = 0,
    X1 = 0,
    Y1 = 0,
    Z1 = 0,
    X2 = 0,
    Y2 = 0,
    Z2 = 0,
    x00,
    y00,
    x0,
    y0;

var centroidStream = {
  point: centroidPoint,
  lineStart: centroidLineStart,
  lineEnd: centroidLineEnd,
  polygonStart: function() {
    centroidStream.lineStart = centroidRingStart;
    centroidStream.lineEnd = centroidRingEnd;
  },
  polygonEnd: function() {
    centroidStream.point = centroidPoint;
    centroidStream.lineStart = centroidLineStart;
    centroidStream.lineEnd = centroidLineEnd;
  },
  result: function() {
    var centroid = Z2 ? [X2 / Z2, Y2 / Z2]
        : Z1 ? [X1 / Z1, Y1 / Z1]
        : Z0 ? [X0 / Z0, Y0 / Z0]
        : [NaN, NaN];
    X0 = Y0 = Z0 =
    X1 = Y1 = Z1 =
    X2 = Y2 = Z2 = 0;
    return centroid;
  }
};

function centroidPoint(x, y) {
  X0 += x;
  Y0 += y;
  ++Z0;
}

function centroidLineStart() {
  centroidStream.point = centroidPointFirstLine;
}

function centroidPointFirstLine(x, y) {
  centroidStream.point = centroidPointLine;
  centroidPoint(x0 = x, y0 = y);
}

function centroidPointLine(x, y) {
  var dx = x - x0, dy = y - y0, z = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(dx * dx + dy * dy);
  X1 += z * (x0 + x) / 2;
  Y1 += z * (y0 + y) / 2;
  Z1 += z;
  centroidPoint(x0 = x, y0 = y);
}

function centroidLineEnd() {
  centroidStream.point = centroidPoint;
}

function centroidRingStart() {
  centroidStream.point = centroidPointFirstRing;
}

function centroidRingEnd() {
  centroidPointRing(x00, y00);
}

function centroidPointFirstRing(x, y) {
  centroidStream.point = centroidPointRing;
  centroidPoint(x00 = x0 = x, y00 = y0 = y);
}

function centroidPointRing(x, y) {
  var dx = x - x0,
      dy = y - y0,
      z = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(dx * dx + dy * dy);

  X1 += z * (x0 + x) / 2;
  Y1 += z * (y0 + y) / 2;
  Z1 += z;

  z = y0 * x - x0 * y;
  X2 += z * (x0 + x);
  Y2 += z * (y0 + y);
  Z2 += z * 3;
  centroidPoint(x0 = x, y0 = y);
}

/* harmony default export */ __webpack_exports__["a"] = (centroidStream);


/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PathContext;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop__ = __webpack_require__(13);



function PathContext(context) {
  this._context = context;
}

PathContext.prototype = {
  _radius: 4.5,
  pointRadius: function(_) {
    return this._radius = _, this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0) this._context.closePath();
    this._point = NaN;
  },
  point: function(x, y) {
    switch (this._point) {
      case 0: {
        this._context.moveTo(x, y);
        this._point = 1;
        break;
      }
      case 1: {
        this._context.lineTo(x, y);
        break;
      }
      default: {
        this._context.moveTo(x + this._radius, y);
        this._context.arc(x, y, this._radius, 0, __WEBPACK_IMPORTED_MODULE_0__math__["w" /* tau */]);
        break;
      }
    }
  },
  result: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */]
};


/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noop__ = __webpack_require__(13);




var lengthSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    lengthRing,
    x00,
    y00,
    x0,
    y0;

var lengthStream = {
  point: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineStart: function() {
    lengthStream.point = lengthPointFirst;
  },
  lineEnd: function() {
    if (lengthRing) lengthPoint(x00, y00);
    lengthStream.point = __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */];
  },
  polygonStart: function() {
    lengthRing = true;
  },
  polygonEnd: function() {
    lengthRing = null;
  },
  result: function() {
    var length = +lengthSum;
    lengthSum.reset();
    return length;
  }
};

function lengthPointFirst(x, y) {
  lengthStream.point = lengthPoint;
  x00 = x0 = x, y00 = y0 = y;
}

function lengthPoint(x, y) {
  x0 -= x, y0 -= y;
  lengthSum.add(Object(__WEBPACK_IMPORTED_MODULE_1__math__["u" /* sqrt */])(x0 * x0 + y0 * y0));
  x0 = x, y0 = y;
}

/* harmony default export */ __webpack_exports__["a"] = (lengthStream);


/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PathString;
function PathString() {
  this._string = [];
}

PathString.prototype = {
  _radius: 4.5,
  _circle: circle(4.5),
  pointRadius: function(_) {
    if ((_ = +_) !== this._radius) this._radius = _, this._circle = null;
    return this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0) this._string.push("Z");
    this._point = NaN;
  },
  point: function(x, y) {
    switch (this._point) {
      case 0: {
        this._string.push("M", x, ",", y);
        this._point = 1;
        break;
      }
      case 1: {
        this._string.push("L", x, ",", y);
        break;
      }
      default: {
        if (this._circle == null) this._circle = circle(this._radius);
        this._string.push("M", x, ",", y, this._circle);
        break;
      }
    }
  },
  result: function() {
    if (this._string.length) {
      var result = this._string.join("");
      this._string = [];
      return result;
    } else {
      return null;
    }
  }
};

function circle(radius) {
  return "m0," + radius
      + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius
      + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius
      + "z";
}


/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cartesian__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__transform__ = __webpack_require__(47);




var maxDepth = 16, // maximum depth of subdivision
    cosMinDistance = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(30 * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */]); // cos(minimum angular distance)

/* harmony default export */ __webpack_exports__["a"] = (function(project, delta2) {
  return +delta2 ? resample(project, delta2) : resampleNone(project);
});

function resampleNone(project) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__transform__["b" /* transformer */])({
    point: function(x, y) {
      x = project(x, y);
      this.stream.point(x[0], x[1]);
    }
  });
}

function resample(project, delta2) {

  function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
    var dx = x1 - x0,
        dy = y1 - y0,
        d2 = dx * dx + dy * dy;
    if (d2 > 4 * delta2 && depth--) {
      var a = a0 + a1,
          b = b0 + b1,
          c = c0 + c1,
          m = Object(__WEBPACK_IMPORTED_MODULE_1__math__["u" /* sqrt */])(a * a + b * b + c * c),
          phi2 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* asin */])(c /= m),
          lambda2 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(c) - 1) < __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */] || Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(lambda0 - lambda1) < __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */] ? (lambda0 + lambda1) / 2 : Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(b, a),
          p = project(lambda2, phi2),
          x2 = p[0],
          y2 = p[1],
          dx2 = x2 - x0,
          dy2 = y2 - y0,
          dz = dy * dx2 - dx * dy2;
      if (dz * dz / d2 > delta2 // perpendicular projected distance
          || Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
          || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) { // angular distance
        resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
        stream.point(x2, y2);
        resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
      }
    }
  }
  return function(stream) {
    var lambda00, x00, y00, a00, b00, c00, // first point
        lambda0, x0, y0, a0, b0, c0; // previous point

    var resampleStream = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() { stream.polygonStart(); resampleStream.lineStart = ringStart; },
      polygonEnd: function() { stream.polygonEnd(); resampleStream.lineStart = lineStart; }
    };

    function point(x, y) {
      x = project(x, y);
      stream.point(x[0], x[1]);
    }

    function lineStart() {
      x0 = NaN;
      resampleStream.point = linePoint;
      stream.lineStart();
    }

    function linePoint(lambda, phi) {
      var c = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["a" /* cartesian */])([lambda, phi]), p = project(lambda, phi);
      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
      stream.point(x0, y0);
    }

    function lineEnd() {
      resampleStream.point = point;
      stream.lineEnd();
    }

    function ringStart() {
      lineStart();
      resampleStream.point = ringPoint;
      resampleStream.lineEnd = ringEnd;
    }

    function ringPoint(lambda, phi) {
      linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
      resampleStream.point = linePoint;
    }

    function ringEnd() {
      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
      resampleStream.lineEnd = lineEnd;
      lineEnd();
    }

    return resampleStream;
  };
}


/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cylindricalEqualAreaRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);


function cylindricalEqualAreaRaw(phi0) {
  var cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(phi0);

  function forward(lambda, phi) {
    return [lambda * cosPhi0, Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(phi) / cosPhi0];
  }

  forward.invert = function(x, y) {
    return [x / cosPhi0, Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])(y * cosPhi0)];
  };

  return forward;
}


/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__albers__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__conicEqualArea__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fit__ = __webpack_require__(83);





// The projections must have mutually exclusive clip regions on the sphere,
// as this will avoid emitting interleaving lines and polygons.
function multiplex(streams) {
  var n = streams.length;
  return {
    point: function(x, y) { var i = -1; while (++i < n) streams[i].point(x, y); },
    sphere: function() { var i = -1; while (++i < n) streams[i].sphere(); },
    lineStart: function() { var i = -1; while (++i < n) streams[i].lineStart(); },
    lineEnd: function() { var i = -1; while (++i < n) streams[i].lineEnd(); },
    polygonStart: function() { var i = -1; while (++i < n) streams[i].polygonStart(); },
    polygonEnd: function() { var i = -1; while (++i < n) streams[i].polygonEnd(); }
  };
}

// A composite projection for the United States, configured by default for
// 960×500. The projection also works quite well at 960×600 if you change the
// scale to 1285 and adjust the translate accordingly. The set of standard
// parallels for each region comes from USGS, which is published here:
// http://egsc.usgs.gov/isb/pubs/MapProjections/projections.html#albers
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var cache,
      cacheStream,
      lower48 = Object(__WEBPACK_IMPORTED_MODULE_1__albers__["a" /* default */])(), lower48Point,
      alaska = Object(__WEBPACK_IMPORTED_MODULE_2__conicEqualArea__["b" /* default */])().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), alaskaPoint, // EPSG:3338
      hawaii = Object(__WEBPACK_IMPORTED_MODULE_2__conicEqualArea__["b" /* default */])().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), hawaiiPoint, // ESRI:102007
      point, pointStream = {point: function(x, y) { point = [x, y]; }};

  function albersUsa(coordinates) {
    var x = coordinates[0], y = coordinates[1];
    return point = null,
        (lower48Point.point(x, y), point)
        || (alaskaPoint.point(x, y), point)
        || (hawaiiPoint.point(x, y), point);
  }

  albersUsa.invert = function(coordinates) {
    var k = lower48.scale(),
        t = lower48.translate(),
        x = (coordinates[0] - t[0]) / k,
        y = (coordinates[1] - t[1]) / k;
    return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska
        : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii
        : lower48).invert(coordinates);
  };

  albersUsa.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = multiplex([lower48.stream(cacheStream = stream), alaska.stream(stream), hawaii.stream(stream)]);
  };

  albersUsa.precision = function(_) {
    if (!arguments.length) return lower48.precision();
    lower48.precision(_), alaska.precision(_), hawaii.precision(_);
    return reset();
  };

  albersUsa.scale = function(_) {
    if (!arguments.length) return lower48.scale();
    lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
    return albersUsa.translate(lower48.translate());
  };

  albersUsa.translate = function(_) {
    if (!arguments.length) return lower48.translate();
    var k = lower48.scale(), x = +_[0], y = +_[1];

    lower48Point = lower48
        .translate(_)
        .clipExtent([[x - 0.455 * k, y - 0.238 * k], [x + 0.455 * k, y + 0.238 * k]])
        .stream(pointStream);

    alaskaPoint = alaska
        .translate([x - 0.307 * k, y + 0.201 * k])
        .clipExtent([[x - 0.425 * k + __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */], y + 0.120 * k + __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]], [x - 0.214 * k - __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */], y + 0.234 * k - __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]]])
        .stream(pointStream);

    hawaiiPoint = hawaii
        .translate([x - 0.205 * k, y + 0.212 * k])
        .clipExtent([[x - 0.214 * k + __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */], y + 0.166 * k + __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]], [x - 0.115 * k - __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */], y + 0.234 * k - __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]]])
        .stream(pointStream);

    return reset();
  };

  albersUsa.fitExtent = function(extent, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["a" /* fitExtent */])(albersUsa, extent, object);
  };

  albersUsa.fitSize = function(size, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["c" /* fitSize */])(albersUsa, size, object);
  };

  albersUsa.fitWidth = function(width, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["d" /* fitWidth */])(albersUsa, width, object);
  };

  albersUsa.fitHeight = function(height, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["b" /* fitHeight */])(albersUsa, height, object);
  };

  function reset() {
    cache = cacheStream = null;
    return albersUsa;
  }

  return albersUsa.scale(1070);
});


/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return azimuthalEqualAreaRaw; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(10);




var azimuthalEqualAreaRaw = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["b" /* azimuthalRaw */])(function(cxcy) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(2 / (1 + cxcy));
});

azimuthalEqualAreaRaw.invert = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(function(z) {
  return 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])(z / 2);
});

/* harmony default export */ __webpack_exports__["b"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(azimuthalEqualAreaRaw)
      .scale(124.75)
      .clipAngle(180 - 1e-3);
});


/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return azimuthalEquidistantRaw; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(10);




var azimuthalEquidistantRaw = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["b" /* azimuthalRaw */])(function(c) {
  return (c = Object(__WEBPACK_IMPORTED_MODULE_0__math__["b" /* acos */])(c)) && c / Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(c);
});

azimuthalEquidistantRaw.invert = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(function(z) {
  return z;
});

/* harmony default export */ __webpack_exports__["b"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(azimuthalEquidistantRaw)
      .scale(79.4188)
      .clipAngle(180 - 1e-3);
});


/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = conicConformalRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conic__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mercator__ = __webpack_require__(84);




function tany(y) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__math__["v" /* tan */])((__WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */] + y) / 2);
}

function conicConformalRaw(y0, y1) {
  var cy0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y0),
      n = y0 === y1 ? Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y0) : Object(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* log */])(cy0 / Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y1)) / Object(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* log */])(tany(y1) / tany(y0)),
      f = cy0 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["p" /* pow */])(tany(y0), n) / n;

  if (!n) return __WEBPACK_IMPORTED_MODULE_2__mercator__["c" /* mercatorRaw */];

  function project(x, y) {
    if (f > 0) { if (y < -__WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */] + __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]) y = -__WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */] + __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]; }
    else { if (y > __WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */] - __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]) y = __WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */] - __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]; }
    var r = f / Object(__WEBPACK_IMPORTED_MODULE_0__math__["p" /* pow */])(tany(y), n);
    return [r * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(n * x), f - r * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(n * x)];
  }

  project.invert = function(x, y) {
    var fy = f - y, r = Object(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(n) * Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(x * x + fy * fy);
    return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(x, Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(fy)) / n * Object(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(fy), 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* atan */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["p" /* pow */])(f / r, 1 / n)) - __WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */]];
  };

  return project;
}

/* harmony default export */ __webpack_exports__["b"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__conic__["a" /* conicProjection */])(conicConformalRaw)
      .scale(109.5)
      .parallels([30, 30]);
});


/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = conicEquidistantRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conic__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__equirectangular__ = __webpack_require__(158);




function conicEquidistantRaw(y0, y1) {
  var cy0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y0),
      n = y0 === y1 ? Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y0) : (cy0 - Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y1)) / (y1 - y0),
      g = cy0 / n + y0;

  if (Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(n) < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]) return __WEBPACK_IMPORTED_MODULE_2__equirectangular__["b" /* equirectangularRaw */];

  function project(x, y) {
    var gy = g - y, nx = n * x;
    return [gy * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(nx), g - gy * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(nx)];
  }

  project.invert = function(x, y) {
    var gy = g - y;
    return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(x, Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(gy)) / n * Object(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(gy), g - Object(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(n) * Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(x * x + gy * gy)];
  };

  return project;
}

/* harmony default export */ __webpack_exports__["b"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__conic__["a" /* conicProjection */])(conicEquidistantRaw)
      .scale(131.154)
      .center([0, 13.9389]);
});


/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = gnomonicRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(10);




function gnomonicRaw(x, y) {
  var cy = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y), k = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(x) * cy;
  return [cy * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(x) / k, Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y) / k];
}

gnomonicRaw.invert = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* atan */]);

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(gnomonicRaw)
      .scale(144.049)
      .clipAngle(60);
});


/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__clip_rectangle__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__identity__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__transform__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fit__ = __webpack_require__(83);





function scaleTranslate(kx, ky, tx, ty) {
  return kx === 1 && ky === 1 && tx === 0 && ty === 0 ? __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */] : Object(__WEBPACK_IMPORTED_MODULE_2__transform__["b" /* transformer */])({
    point: function(x, y) {
      this.stream.point(x * kx + tx, y * ky + ty);
    }
  });
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, transform = __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */], // scale, translate and reflect
      x0 = null, y0, x1, y1, // clip extent
      postclip = __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */],
      cache,
      cacheStream,
      projection;

  function reset() {
    cache = cacheStream = null;
    return projection;
  }

  return projection = {
    stream: function(stream) {
      return cache && cacheStream === stream ? cache : cache = transform(postclip(cacheStream = stream));
    },
    postclip: function(_) {
      return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
    },
    clipExtent: function(_) {
      return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */]) : Object(__WEBPACK_IMPORTED_MODULE_0__clip_rectangle__["a" /* default */])(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
    },
    scale: function(_) {
      return arguments.length ? (transform = scaleTranslate((k = +_) * sx, k * sy, tx, ty), reset()) : k;
    },
    translate: function(_) {
      return arguments.length ? (transform = scaleTranslate(k * sx, k * sy, tx = +_[0], ty = +_[1]), reset()) : [tx, ty];
    },
    reflectX: function(_) {
      return arguments.length ? (transform = scaleTranslate(k * (sx = _ ? -1 : 1), k * sy, tx, ty), reset()) : sx < 0;
    },
    reflectY: function(_) {
      return arguments.length ? (transform = scaleTranslate(k * sx, k * (sy = _ ? -1 : 1), tx, ty), reset()) : sy < 0;
    },
    fitExtent: function(extent, object) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["a" /* fitExtent */])(projection, extent, object);
    },
    fitSize: function(size, object) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["c" /* fitSize */])(projection, size, object);
    },
    fitWidth: function(width, object) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["d" /* fitWidth */])(projection, width, object);
    },
    fitHeight: function(height, object) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["b" /* fitHeight */])(projection, height, object);
    }
  };
});


/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = naturalEarth1Raw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(0);



function naturalEarth1Raw(lambda, phi) {
  var phi2 = phi * phi, phi4 = phi2 * phi2;
  return [
    lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (0.003971 * phi2 - 0.001529 * phi4))),
    phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4)))
  ];
}

naturalEarth1Raw.invert = function(x, y) {
  var phi = y, i = 25, delta;
  do {
    var phi2 = phi * phi, phi4 = phi2 * phi2;
    phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4))) - y) /
        (1.007226 + phi2 * (0.015085 * 3 + phi4 * (-0.044475 * 7 + 0.028874 * 9 * phi2 - 0.005916 * 11 * phi4)));
  } while (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(delta) > __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */] && --i > 0);
  return [
    x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (0.003971 - 0.001529 * phi2)))),
    phi
  ];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])(naturalEarth1Raw)
      .scale(175.295);
});


/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = orthographicRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(10);




function orthographicRaw(x, y) {
  return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y) * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(x), Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y)];
}

orthographicRaw.invert = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */]);

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(orthographicRaw)
      .scale(249.5)
      .clipAngle(90 + __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]);
});


/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = stereographicRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(10);




function stereographicRaw(x, y) {
  var cy = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y), k = 1 + Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(x) * cy;
  return [cy * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(x) / k, Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y) / k];
}

stereographicRaw.invert = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(function(z) {
  return 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* atan */])(z);
});

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(stereographicRaw)
      .scale(250)
      .clipAngle(142);
});


/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = transverseMercatorRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mercator__ = __webpack_require__(84);



function transverseMercatorRaw(lambda, phi) {
  return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* log */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["v" /* tan */])((__WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */] + phi) / 2)), -lambda];
}

transverseMercatorRaw.invert = function(x, y) {
  return [-y, 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* atan */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["k" /* exp */])(x)) - __WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */]];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var m = Object(__WEBPACK_IMPORTED_MODULE_1__mercator__["b" /* mercatorProjection */])(transverseMercatorRaw),
      center = m.center,
      rotate = m.rotate;

  m.center = function(_) {
    return arguments.length ? center([-_[1], _[0]]) : (_ = center(), [_[1], -_[0]]);
  };

  m.rotate = function(_) {
    return arguments.length ? rotate([_[0], _[1], _.length > 2 ? _[2] + 90 : 90]) : (_ = rotate(), [_[0], _[1], _[2] - 90]);
  };

  return rotate([0, 0, 90])
      .scale(159.155);
});


/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_cluster__ = __webpack_require__(410);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_cluster__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_hierarchy_index__ = __webpack_require__(85);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_hierarchy_index__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_pack_index__ = __webpack_require__(422);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__src_pack_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_pack_siblings__ = __webpack_require__(159);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__src_pack_siblings__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_pack_enclose__ = __webpack_require__(160);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__src_pack_enclose__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_partition__ = __webpack_require__(424);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__src_partition__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_stratify__ = __webpack_require__(425);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__src_stratify__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_tree__ = __webpack_require__(426);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__src_tree__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_treemap_index__ = __webpack_require__(427);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_8__src_treemap_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_treemap_binary__ = __webpack_require__(428);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_9__src_treemap_binary__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_treemap_dice__ = __webpack_require__(31);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_10__src_treemap_dice__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_treemap_slice__ = __webpack_require__(48);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_11__src_treemap_slice__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_treemap_sliceDice__ = __webpack_require__(429);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_12__src_treemap_sliceDice__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_treemap_squarify__ = __webpack_require__(87);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_13__src_treemap_squarify__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_treemap_resquarify__ = __webpack_require__(430);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_14__src_treemap_resquarify__["a"]; });

















/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function defaultSeparation(a, b) {
  return a.parent === b.parent ? 1 : 2;
}

function meanX(children) {
  return children.reduce(meanXReduce, 0) / children.length;
}

function meanXReduce(x, c) {
  return x + c.x;
}

function maxY(children) {
  return 1 + children.reduce(maxYReduce, 0);
}

function maxYReduce(y, c) {
  return Math.max(y, c.y);
}

function leafLeft(node) {
  var children;
  while (children = node.children) node = children[0];
  return node;
}

function leafRight(node) {
  var children;
  while (children = node.children) node = children[children.length - 1];
  return node;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var separation = defaultSeparation,
      dx = 1,
      dy = 1,
      nodeSize = false;

  function cluster(root) {
    var previousNode,
        x = 0;

    // First walk, computing the initial x & y values.
    root.eachAfter(function(node) {
      var children = node.children;
      if (children) {
        node.x = meanX(children);
        node.y = maxY(children);
      } else {
        node.x = previousNode ? x += separation(node, previousNode) : 0;
        node.y = 0;
        previousNode = node;
      }
    });

    var left = leafLeft(root),
        right = leafRight(root),
        x0 = left.x - separation(left, right) / 2,
        x1 = right.x + separation(right, left) / 2;

    // Second walk, normalizing x & y to the desired size.
    return root.eachAfter(nodeSize ? function(node) {
      node.x = (node.x - root.x) * dx;
      node.y = (root.y - node.y) * dy;
    } : function(node) {
      node.x = (node.x - x0) / (x1 - x0) * dx;
      node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
    });
  }

  cluster.separation = function(x) {
    return arguments.length ? (separation = x, cluster) : separation;
  };

  cluster.size = function(x) {
    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? null : [dx, dy]);
  };

  cluster.nodeSize = function(x) {
    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? [dx, dy] : null);
  };

  return cluster;
});


/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function count(node) {
  var sum = 0,
      children = node.children,
      i = children && children.length;
  if (!i) sum = 1;
  else while (--i >= 0) sum += children[i].value;
  node.value = sum;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.eachAfter(count);
});


/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var node = this, current, next = [node], children, i, n;
  do {
    current = next.reverse(), next = [];
    while (node = current.pop()) {
      callback(node), children = node.children;
      if (children) for (i = 0, n = children.length; i < n; ++i) {
        next.push(children[i]);
      }
    }
  } while (next.length);
  return this;
});


/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var node = this, nodes = [node], children, i;
  while (node = nodes.pop()) {
    callback(node), children = node.children;
    if (children) for (i = children.length - 1; i >= 0; --i) {
      nodes.push(children[i]);
    }
  }
  return this;
});


/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var node = this, nodes = [node], next = [], children, i, n;
  while (node = nodes.pop()) {
    next.push(node), children = node.children;
    if (children) for (i = 0, n = children.length; i < n; ++i) {
      nodes.push(children[i]);
    }
  }
  while (node = next.pop()) {
    callback(node);
  }
  return this;
});


/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return this.eachAfter(function(node) {
    var sum = +value(node.data) || 0,
        children = node.children,
        i = children && children.length;
    while (--i >= 0) sum += children[i].value;
    node.value = sum;
  });
});


/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(compare) {
  return this.eachBefore(function(node) {
    if (node.children) {
      node.children.sort(compare);
    }
  });
});


/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(end) {
  var start = this,
      ancestor = leastCommonAncestor(start, end),
      nodes = [start];
  while (start !== ancestor) {
    start = start.parent;
    nodes.push(start);
  }
  var k = nodes.length;
  while (end !== ancestor) {
    nodes.splice(k, 0, end);
    end = end.parent;
  }
  return nodes;
});

function leastCommonAncestor(a, b) {
  if (a === b) return a;
  var aNodes = a.ancestors(),
      bNodes = b.ancestors(),
      c = null;
  a = aNodes.pop();
  b = bNodes.pop();
  while (a === b) {
    c = a;
    a = aNodes.pop();
    b = bNodes.pop();
  }
  return c;
}


/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var node = this, nodes = [node];
  while (node = node.parent) {
    nodes.push(node);
  }
  return nodes;
});


/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var nodes = [];
  this.each(function(node) {
    nodes.push(node);
  });
  return nodes;
});


/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var leaves = [];
  this.eachBefore(function(node) {
    if (!node.children) {
      leaves.push(node);
    }
  });
  return leaves;
});


/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var root = this, links = [];
  root.each(function(node) {
    if (node !== root) { // Don’t include the root’s parent, if any.
      links.push({source: node.parent, target: node});
    }
  });
  return links;
});


/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__siblings__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessors__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(161);




function defaultRadius(d) {
  return Math.sqrt(d.value);
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var radius = null,
      dx = 1,
      dy = 1,
      padding = __WEBPACK_IMPORTED_MODULE_2__constant__["a" /* constantZero */];

  function pack(root) {
    root.x = dx / 2, root.y = dy / 2;
    if (radius) {
      root.eachBefore(radiusLeaf(radius))
          .eachAfter(packChildren(padding, 0.5))
          .eachBefore(translateChild(1));
    } else {
      root.eachBefore(radiusLeaf(defaultRadius))
          .eachAfter(packChildren(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* constantZero */], 1))
          .eachAfter(packChildren(padding, root.r / Math.min(dx, dy)))
          .eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
    }
    return root;
  }

  pack.radius = function(x) {
    return arguments.length ? (radius = Object(__WEBPACK_IMPORTED_MODULE_1__accessors__["a" /* optional */])(x), pack) : radius;
  };

  pack.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [dx, dy];
  };

  pack.padding = function(x) {
    return arguments.length ? (padding = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["b" /* default */])(+x), pack) : padding;
  };

  return pack;
});

function radiusLeaf(radius) {
  return function(node) {
    if (!node.children) {
      node.r = Math.max(0, +radius(node) || 0);
    }
  };
}

function packChildren(padding, k) {
  return function(node) {
    if (children = node.children) {
      var children,
          i,
          n = children.length,
          r = padding(node) * k || 0,
          e;

      if (r) for (i = 0; i < n; ++i) children[i].r += r;
      e = Object(__WEBPACK_IMPORTED_MODULE_0__siblings__["b" /* packEnclose */])(children);
      if (r) for (i = 0; i < n; ++i) children[i].r -= r;
      node.r = e + r;
    }
  };
}

function translateChild(k) {
  return function(node) {
    var parent = node.parent;
    node.r *= k;
    if (parent) {
      node.x = parent.x + k * node.x;
      node.y = parent.y + k * node.y;
    }
  };
}


/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
/* harmony export (immutable) */ __webpack_exports__["a"] = shuffle;
var slice = Array.prototype.slice;

function shuffle(array) {
  var m = array.length,
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m];
    array[m] = array[i];
    array[i] = t;
  }

  return array;
}


/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__treemap_round__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__treemap_dice__ = __webpack_require__(31);



/* harmony default export */ __webpack_exports__["a"] = (function() {
  var dx = 1,
      dy = 1,
      padding = 0,
      round = false;

  function partition(root) {
    var n = root.height + 1;
    root.x0 =
    root.y0 = padding;
    root.x1 = dx;
    root.y1 = dy / n;
    root.eachBefore(positionNode(dy, n));
    if (round) root.eachBefore(__WEBPACK_IMPORTED_MODULE_0__treemap_round__["a" /* default */]);
    return root;
  }

  function positionNode(dy, n) {
    return function(node) {
      if (node.children) {
        Object(__WEBPACK_IMPORTED_MODULE_1__treemap_dice__["a" /* default */])(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
      }
      var x0 = node.x0,
          y0 = node.y0,
          x1 = node.x1 - padding,
          y1 = node.y1 - padding;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      node.x0 = x0;
      node.y0 = y0;
      node.x1 = x1;
      node.y1 = y1;
    };
  }

  partition.round = function(x) {
    return arguments.length ? (round = !!x, partition) : round;
  };

  partition.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [dx, dy];
  };

  partition.padding = function(x) {
    return arguments.length ? (padding = +x, partition) : padding;
  };

  return partition;
});


/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__accessors__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hierarchy_index__ = __webpack_require__(85);



var keyPrefix = "$", // Protect against keys like “__proto__”.
    preroot = {depth: -1},
    ambiguous = {};

function defaultId(d) {
  return d.id;
}

function defaultParentId(d) {
  return d.parentId;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var id = defaultId,
      parentId = defaultParentId;

  function stratify(data) {
    var d,
        i,
        n = data.length,
        root,
        parent,
        node,
        nodes = new Array(n),
        nodeId,
        nodeKey,
        nodeByKey = {};

    for (i = 0; i < n; ++i) {
      d = data[i], node = nodes[i] = new __WEBPACK_IMPORTED_MODULE_1__hierarchy_index__["a" /* Node */](d);
      if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
        nodeKey = keyPrefix + (node.id = nodeId);
        nodeByKey[nodeKey] = nodeKey in nodeByKey ? ambiguous : node;
      }
    }

    for (i = 0; i < n; ++i) {
      node = nodes[i], nodeId = parentId(data[i], i, data);
      if (nodeId == null || !(nodeId += "")) {
        if (root) throw new Error("multiple roots");
        root = node;
      } else {
        parent = nodeByKey[keyPrefix + nodeId];
        if (!parent) throw new Error("missing: " + nodeId);
        if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
        if (parent.children) parent.children.push(node);
        else parent.children = [node];
        node.parent = parent;
      }
    }

    if (!root) throw new Error("no root");
    root.parent = preroot;
    root.eachBefore(function(node) { node.depth = node.parent.depth + 1; --n; }).eachBefore(__WEBPACK_IMPORTED_MODULE_1__hierarchy_index__["b" /* computeHeight */]);
    root.parent = null;
    if (n > 0) throw new Error("cycle");

    return root;
  }

  stratify.id = function(x) {
    return arguments.length ? (id = Object(__WEBPACK_IMPORTED_MODULE_0__accessors__["b" /* required */])(x), stratify) : id;
  };

  stratify.parentId = function(x) {
    return arguments.length ? (parentId = Object(__WEBPACK_IMPORTED_MODULE_0__accessors__["b" /* required */])(x), stratify) : parentId;
  };

  return stratify;
});


/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hierarchy_index__ = __webpack_require__(85);


function defaultSeparation(a, b) {
  return a.parent === b.parent ? 1 : 2;
}

// function radialSeparation(a, b) {
//   return (a.parent === b.parent ? 1 : 2) / a.depth;
// }

// This function is used to traverse the left contour of a subtree (or
// subforest). It returns the successor of v on this contour. This successor is
// either given by the leftmost child of v or by the thread of v. The function
// returns null if and only if v is on the highest level of its subtree.
function nextLeft(v) {
  var children = v.children;
  return children ? children[0] : v.t;
}

// This function works analogously to nextLeft.
function nextRight(v) {
  var children = v.children;
  return children ? children[children.length - 1] : v.t;
}

// Shifts the current subtree rooted at w+. This is done by increasing
// prelim(w+) and mod(w+) by shift.
function moveSubtree(wm, wp, shift) {
  var change = shift / (wp.i - wm.i);
  wp.c -= change;
  wp.s += shift;
  wm.c += change;
  wp.z += shift;
  wp.m += shift;
}

// All other shifts, applied to the smaller subtrees between w- and w+, are
// performed by this function. To prepare the shifts, we have to adjust
// change(w+), shift(w+), and change(w-).
function executeShifts(v) {
  var shift = 0,
      change = 0,
      children = v.children,
      i = children.length,
      w;
  while (--i >= 0) {
    w = children[i];
    w.z += shift;
    w.m += shift;
    shift += w.s + (change += w.c);
  }
}

// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
// returns the specified (default) ancestor.
function nextAncestor(vim, v, ancestor) {
  return vim.a.parent === v.parent ? vim.a : ancestor;
}

function TreeNode(node, i) {
  this._ = node;
  this.parent = null;
  this.children = null;
  this.A = null; // default ancestor
  this.a = this; // ancestor
  this.z = 0; // prelim
  this.m = 0; // mod
  this.c = 0; // change
  this.s = 0; // shift
  this.t = null; // thread
  this.i = i; // number
}

TreeNode.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_0__hierarchy_index__["a" /* Node */].prototype);

function treeRoot(root) {
  var tree = new TreeNode(root, 0),
      node,
      nodes = [tree],
      child,
      children,
      i,
      n;

  while (node = nodes.pop()) {
    if (children = node._.children) {
      node.children = new Array(n = children.length);
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = node.children[i] = new TreeNode(children[i], i));
        child.parent = node;
      }
    }
  }

  (tree.parent = new TreeNode(null, 0)).children = [tree];
  return tree;
}

// Node-link tree diagram using the Reingold-Tilford "tidy" algorithm
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var separation = defaultSeparation,
      dx = 1,
      dy = 1,
      nodeSize = null;

  function tree(root) {
    var t = treeRoot(root);

    // Compute the layout using Buchheim et al.’s algorithm.
    t.eachAfter(firstWalk), t.parent.m = -t.z;
    t.eachBefore(secondWalk);

    // If a fixed node size is specified, scale x and y.
    if (nodeSize) root.eachBefore(sizeNode);

    // If a fixed tree size is specified, scale x and y based on the extent.
    // Compute the left-most, right-most, and depth-most nodes for extents.
    else {
      var left = root,
          right = root,
          bottom = root;
      root.eachBefore(function(node) {
        if (node.x < left.x) left = node;
        if (node.x > right.x) right = node;
        if (node.depth > bottom.depth) bottom = node;
      });
      var s = left === right ? 1 : separation(left, right) / 2,
          tx = s - left.x,
          kx = dx / (right.x + s + tx),
          ky = dy / (bottom.depth || 1);
      root.eachBefore(function(node) {
        node.x = (node.x + tx) * kx;
        node.y = node.depth * ky;
      });
    }

    return root;
  }

  // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
  // applied recursively to the children of v, as well as the function
  // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
  // node v is placed to the midpoint of its outermost children.
  function firstWalk(v) {
    var children = v.children,
        siblings = v.parent.children,
        w = v.i ? siblings[v.i - 1] : null;
    if (children) {
      executeShifts(v);
      var midpoint = (children[0].z + children[children.length - 1].z) / 2;
      if (w) {
        v.z = w.z + separation(v._, w._);
        v.m = v.z - midpoint;
      } else {
        v.z = midpoint;
      }
    } else if (w) {
      v.z = w.z + separation(v._, w._);
    }
    v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
  }

  // Computes all real x-coordinates by summing up the modifiers recursively.
  function secondWalk(v) {
    v._.x = v.z + v.parent.m;
    v.m += v.parent.m;
  }

  // The core of the algorithm. Here, a new subtree is combined with the
  // previous subtrees. Threads are used to traverse the inside and outside
  // contours of the left and right subtree up to the highest common level. The
  // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
  // superscript o means outside and i means inside, the subscript - means left
  // subtree and + means right subtree. For summing up the modifiers along the
  // contour, we use respective variables si+, si-, so-, and so+. Whenever two
  // nodes of the inside contours conflict, we compute the left one of the
  // greatest uncommon ancestors using the function ANCESTOR and call MOVE
  // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
  // Finally, we add a new thread (if necessary).
  function apportion(v, w, ancestor) {
    if (w) {
      var vip = v,
          vop = v,
          vim = w,
          vom = vip.parent.children[0],
          sip = vip.m,
          sop = vop.m,
          sim = vim.m,
          som = vom.m,
          shift;
      while (vim = nextRight(vim), vip = nextLeft(vip), vim && vip) {
        vom = nextLeft(vom);
        vop = nextRight(vop);
        vop.a = v;
        shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
        if (shift > 0) {
          moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
          sip += shift;
          sop += shift;
        }
        sim += vim.m;
        sip += vip.m;
        som += vom.m;
        sop += vop.m;
      }
      if (vim && !nextRight(vop)) {
        vop.t = vim;
        vop.m += sim - sop;
      }
      if (vip && !nextLeft(vom)) {
        vom.t = vip;
        vom.m += sip - som;
        ancestor = v;
      }
    }
    return ancestor;
  }

  function sizeNode(node) {
    node.x *= dx;
    node.y = node.depth * dy;
  }

  tree.separation = function(x) {
    return arguments.length ? (separation = x, tree) : separation;
  };

  tree.size = function(x) {
    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : (nodeSize ? null : [dx, dy]);
  };

  tree.nodeSize = function(x) {
    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : (nodeSize ? [dx, dy] : null);
  };

  return tree;
});


/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__round__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__squarify__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__accessors__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__(161);





/* harmony default export */ __webpack_exports__["a"] = (function() {
  var tile = __WEBPACK_IMPORTED_MODULE_1__squarify__["a" /* default */],
      round = false,
      dx = 1,
      dy = 1,
      paddingStack = [0],
      paddingInner = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */],
      paddingTop = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */],
      paddingRight = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */],
      paddingBottom = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */],
      paddingLeft = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */];

  function treemap(root) {
    root.x0 =
    root.y0 = 0;
    root.x1 = dx;
    root.y1 = dy;
    root.eachBefore(positionNode);
    paddingStack = [0];
    if (round) root.eachBefore(__WEBPACK_IMPORTED_MODULE_0__round__["a" /* default */]);
    return root;
  }

  function positionNode(node) {
    var p = paddingStack[node.depth],
        x0 = node.x0 + p,
        y0 = node.y0 + p,
        x1 = node.x1 - p,
        y1 = node.y1 - p;
    if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
    if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
    node.x0 = x0;
    node.y0 = y0;
    node.x1 = x1;
    node.y1 = y1;
    if (node.children) {
      p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
      x0 += paddingLeft(node) - p;
      y0 += paddingTop(node) - p;
      x1 -= paddingRight(node) - p;
      y1 -= paddingBottom(node) - p;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      tile(node, x0, y0, x1, y1);
    }
  }

  treemap.round = function(x) {
    return arguments.length ? (round = !!x, treemap) : round;
  };

  treemap.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [dx, dy];
  };

  treemap.tile = function(x) {
    return arguments.length ? (tile = Object(__WEBPACK_IMPORTED_MODULE_2__accessors__["b" /* required */])(x), treemap) : tile;
  };

  treemap.padding = function(x) {
    return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
  };

  treemap.paddingInner = function(x) {
    return arguments.length ? (paddingInner = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingInner;
  };

  treemap.paddingOuter = function(x) {
    return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
  };

  treemap.paddingTop = function(x) {
    return arguments.length ? (paddingTop = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingTop;
  };

  treemap.paddingRight = function(x) {
    return arguments.length ? (paddingRight = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingRight;
  };

  treemap.paddingBottom = function(x) {
    return arguments.length ? (paddingBottom = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingBottom;
  };

  treemap.paddingLeft = function(x) {
    return arguments.length ? (paddingLeft = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingLeft;
  };

  return treemap;
});


/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      i, n = nodes.length,
      sum, sums = new Array(n + 1);

  for (sums[0] = sum = i = 0; i < n; ++i) {
    sums[i + 1] = sum += nodes[i].value;
  }

  partition(0, n, parent.value, x0, y0, x1, y1);

  function partition(i, j, value, x0, y0, x1, y1) {
    if (i >= j - 1) {
      var node = nodes[i];
      node.x0 = x0, node.y0 = y0;
      node.x1 = x1, node.y1 = y1;
      return;
    }

    var valueOffset = sums[i],
        valueTarget = (value / 2) + valueOffset,
        k = i + 1,
        hi = j - 1;

    while (k < hi) {
      var mid = k + hi >>> 1;
      if (sums[mid] < valueTarget) k = mid + 1;
      else hi = mid;
    }

    if ((valueTarget - sums[k - 1]) < (sums[k] - valueTarget) && i + 1 < k) --k;

    var valueLeft = sums[k] - valueOffset,
        valueRight = value - valueLeft;

    if ((x1 - x0) > (y1 - y0)) {
      var xk = (x0 * valueRight + x1 * valueLeft) / value;
      partition(i, k, valueLeft, x0, y0, xk, y1);
      partition(k, j, valueRight, xk, y0, x1, y1);
    } else {
      var yk = (y0 * valueRight + y1 * valueLeft) / value;
      partition(i, k, valueLeft, x0, y0, x1, yk);
      partition(k, j, valueRight, x0, yk, x1, y1);
    }
  }
});


/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dice__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slice__ = __webpack_require__(48);



/* harmony default export */ __webpack_exports__["a"] = (function(parent, x0, y0, x1, y1) {
  (parent.depth & 1 ? __WEBPACK_IMPORTED_MODULE_1__slice__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_0__dice__["a" /* default */])(parent, x0, y0, x1, y1);
});


/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dice__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slice__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__squarify__ = __webpack_require__(87);




/* harmony default export */ __webpack_exports__["a"] = ((function custom(ratio) {

  function resquarify(parent, x0, y0, x1, y1) {
    if ((rows = parent._squarify) && (rows.ratio === ratio)) {
      var rows,
          row,
          nodes,
          i,
          j = -1,
          n,
          m = rows.length,
          value = parent.value;

      while (++j < m) {
        row = rows[j], nodes = row.children;
        for (i = row.value = 0, n = nodes.length; i < n; ++i) row.value += nodes[i].value;
        if (row.dice) Object(__WEBPACK_IMPORTED_MODULE_0__dice__["a" /* default */])(row, x0, y0, x1, y0 += (y1 - y0) * row.value / value);
        else Object(__WEBPACK_IMPORTED_MODULE_1__slice__["a" /* default */])(row, x0, y0, x0 += (x1 - x0) * row.value / value, y1);
        value -= row.value;
      }
    } else {
      parent._squarify = rows = Object(__WEBPACK_IMPORTED_MODULE_2__squarify__["c" /* squarifyRatio */])(ratio, parent, x0, y0, x1, y1);
      rows.ratio = ratio;
    }
  }

  resquarify.ratio = function(x) {
    return custom((x = +x) > 1 ? x : 1);
  };

  return resquarify;
})(__WEBPACK_IMPORTED_MODULE_2__squarify__["b" /* phi */]));


/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_area__ = __webpack_require__(432);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_area__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_centroid__ = __webpack_require__(433);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_centroid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_hull__ = __webpack_require__(434);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__src_hull__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_contains__ = __webpack_require__(436);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__src_contains__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_length__ = __webpack_require__(437);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__src_length__["a"]; });







/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(polygon) {
  var i = -1,
      n = polygon.length,
      a,
      b = polygon[n - 1],
      area = 0;

  while (++i < n) {
    a = b;
    b = polygon[i];
    area += a[1] * b[0] - a[0] * b[1];
  }

  return area / 2;
});


/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(polygon) {
  var i = -1,
      n = polygon.length,
      x = 0,
      y = 0,
      a,
      b = polygon[n - 1],
      c,
      k = 0;

  while (++i < n) {
    a = b;
    b = polygon[i];
    k += c = a[0] * b[1] - b[0] * a[1];
    x += (a[0] + b[0]) * c;
    y += (a[1] + b[1]) * c;
  }

  return k *= 3, [x / k, y / k];
});


/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cross__ = __webpack_require__(435);


function lexicographicOrder(a, b) {
  return a[0] - b[0] || a[1] - b[1];
}

// Computes the upper convex hull per the monotone chain algorithm.
// Assumes points.length >= 3, is sorted by x, unique in y.
// Returns an array of indices into points in left-to-right order.
function computeUpperHullIndexes(points) {
  var n = points.length,
      indexes = [0, 1],
      size = 2;

  for (var i = 2; i < n; ++i) {
    while (size > 1 && Object(__WEBPACK_IMPORTED_MODULE_0__cross__["a" /* default */])(points[indexes[size - 2]], points[indexes[size - 1]], points[i]) <= 0) --size;
    indexes[size++] = i;
  }

  return indexes.slice(0, size); // remove popped points
}

/* harmony default export */ __webpack_exports__["a"] = (function(points) {
  if ((n = points.length) < 3) return null;

  var i,
      n,
      sortedPoints = new Array(n),
      flippedPoints = new Array(n);

  for (i = 0; i < n; ++i) sortedPoints[i] = [+points[i][0], +points[i][1], i];
  sortedPoints.sort(lexicographicOrder);
  for (i = 0; i < n; ++i) flippedPoints[i] = [sortedPoints[i][0], -sortedPoints[i][1]];

  var upperIndexes = computeUpperHullIndexes(sortedPoints),
      lowerIndexes = computeUpperHullIndexes(flippedPoints);

  // Construct the hull polygon, removing possible duplicate endpoints.
  var skipLeft = lowerIndexes[0] === upperIndexes[0],
      skipRight = lowerIndexes[lowerIndexes.length - 1] === upperIndexes[upperIndexes.length - 1],
      hull = [];

  // Add upper hull in right-to-l order.
  // Then add lower hull in left-to-right order.
  for (i = upperIndexes.length - 1; i >= 0; --i) hull.push(points[sortedPoints[upperIndexes[i]][2]]);
  for (i = +skipLeft; i < lowerIndexes.length - skipRight; ++i) hull.push(points[sortedPoints[lowerIndexes[i]][2]]);

  return hull;
});


/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Returns the 2D cross product of AB and AC vectors, i.e., the z-component of
// the 3D cross product in a quadrant I Cartesian coordinate system (+x is
// right, +y is up). Returns a positive value if ABC is counter-clockwise,
// negative if clockwise, and zero if the points are collinear.
/* harmony default export */ __webpack_exports__["a"] = (function(a, b, c) {
  return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
});


/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(polygon, point) {
  var n = polygon.length,
      p = polygon[n - 1],
      x = point[0], y = point[1],
      x0 = p[0], y0 = p[1],
      x1, y1,
      inside = false;

  for (var i = 0; i < n; ++i) {
    p = polygon[i], x1 = p[0], y1 = p[1];
    if (((y1 > y) !== (y0 > y)) && (x < (x0 - x1) * (y - y1) / (y0 - y1) + x1)) inside = !inside;
    x0 = x1, y0 = y1;
  }

  return inside;
});


/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(polygon) {
  var i = -1,
      n = polygon.length,
      b = polygon[n - 1],
      xa,
      ya,
      xb = b[0],
      yb = b[1],
      perimeter = 0;

  while (++i < n) {
    xa = xb;
    ya = yb;
    b = polygon[i];
    xb = b[0];
    yb = b[1];
    xa -= xb;
    ya -= yb;
    perimeter += Math.sqrt(xa * xa + ya * ya);
  }

  return perimeter;
});


/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_queue__ = __webpack_require__(439);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_queue__["a"]; });



/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = queue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(440);


var noabort = {};

function Queue(size) {
  this._size = size;
  this._call =
  this._error = null;
  this._tasks = [];
  this._data = [];
  this._waiting =
  this._active =
  this._ended =
  this._start = 0; // inside a synchronous task callback?
}

Queue.prototype = queue.prototype = {
  constructor: Queue,
  defer: function(callback) {
    if (typeof callback !== "function") throw new Error("invalid callback");
    if (this._call) throw new Error("defer after await");
    if (this._error != null) return this;
    var t = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(arguments, 1);
    t.push(callback);
    ++this._waiting, this._tasks.push(t);
    poke(this);
    return this;
  },
  abort: function() {
    if (this._error == null) abort(this, new Error("abort"));
    return this;
  },
  await: function(callback) {
    if (typeof callback !== "function") throw new Error("invalid callback");
    if (this._call) throw new Error("multiple await");
    this._call = function(error, results) { callback.apply(null, [error].concat(results)); };
    maybeNotify(this);
    return this;
  },
  awaitAll: function(callback) {
    if (typeof callback !== "function") throw new Error("invalid callback");
    if (this._call) throw new Error("multiple await");
    this._call = callback;
    maybeNotify(this);
    return this;
  }
};

function poke(q) {
  if (!q._start) {
    try { start(q); } // let the current task complete
    catch (e) {
      if (q._tasks[q._ended + q._active - 1]) abort(q, e); // task errored synchronously
      else if (!q._data) throw e; // await callback errored synchronously
    }
  }
}

function start(q) {
  while (q._start = q._waiting && q._active < q._size) {
    var i = q._ended + q._active,
        t = q._tasks[i],
        j = t.length - 1,
        c = t[j];
    t[j] = end(q, i);
    --q._waiting, ++q._active;
    t = c.apply(null, t);
    if (!q._tasks[i]) continue; // task finished synchronously
    q._tasks[i] = t || noabort;
  }
}

function end(q, i) {
  return function(e, r) {
    if (!q._tasks[i]) return; // ignore multiple callbacks
    --q._active, ++q._ended;
    q._tasks[i] = null;
    if (q._error != null) return; // ignore secondary errors
    if (e != null) {
      abort(q, e);
    } else {
      q._data[i] = r;
      if (q._waiting) poke(q);
      else maybeNotify(q);
    }
  };
}

function abort(q, e) {
  var i = q._tasks.length, t;
  q._error = e; // ignore active callbacks
  q._data = undefined; // allow gc
  q._waiting = NaN; // prevent starting

  while (--i >= 0) {
    if (t = q._tasks[i]) {
      q._tasks[i] = null;
      if (t.abort) {
        try { t.abort(); }
        catch (e) { /* ignore */ }
      }
    }
  }

  q._active = NaN; // allow notification
  maybeNotify(q);
}

function maybeNotify(q) {
  if (!q._active && q._call) {
    var d = q._data;
    q._data = undefined; // allow gc
    q._call(q._error, d);
  }
}

function queue(concurrency) {
  if (concurrency == null) concurrency = Infinity;
  else if (!((concurrency = +concurrency) >= 1)) throw new Error("invalid concurrency");
  return new Queue(concurrency);
}


/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var slice = [].slice;


/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_uniform__ = __webpack_require__(442);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__src_uniform__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_normal__ = __webpack_require__(163);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__src_normal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_logNormal__ = __webpack_require__(443);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__src_logNormal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_bates__ = __webpack_require__(444);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__src_bates__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_irwinHall__ = __webpack_require__(164);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__src_irwinHall__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_exponential__ = __webpack_require__(445);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__src_exponential__["a"]; });








/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultSource__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ((function sourceRandomUniform(source) {
  function randomUniform(min, max) {
    min = min == null ? 0 : +min;
    max = max == null ? 1 : +max;
    if (arguments.length === 1) max = min, min = 0;
    else max -= min;
    return function() {
      return source() * max + min;
    };
  }

  randomUniform.source = sourceRandomUniform;

  return randomUniform;
})(__WEBPACK_IMPORTED_MODULE_0__defaultSource__["a" /* default */]));


/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultSource__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__normal__ = __webpack_require__(163);



/* harmony default export */ __webpack_exports__["a"] = ((function sourceRandomLogNormal(source) {
  function randomLogNormal() {
    var randomNormal = __WEBPACK_IMPORTED_MODULE_1__normal__["a" /* default */].source(source).apply(this, arguments);
    return function() {
      return Math.exp(randomNormal());
    };
  }

  randomLogNormal.source = sourceRandomLogNormal;

  return randomLogNormal;
})(__WEBPACK_IMPORTED_MODULE_0__defaultSource__["a" /* default */]));


/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultSource__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__irwinHall__ = __webpack_require__(164);



/* harmony default export */ __webpack_exports__["a"] = ((function sourceRandomBates(source) {
  function randomBates(n) {
    var randomIrwinHall = __WEBPACK_IMPORTED_MODULE_1__irwinHall__["a" /* default */].source(source)(n);
    return function() {
      return randomIrwinHall() / n;
    };
  }

  randomBates.source = sourceRandomBates;

  return randomBates;
})(__WEBPACK_IMPORTED_MODULE_0__defaultSource__["a" /* default */]));


/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultSource__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ((function sourceRandomExponential(source) {
  function randomExponential(lambda) {
    return function() {
      return -Math.log(1 - source()) / lambda;
    };
  }

  randomExponential.source = sourceRandomExponential;

  return randomExponential;
})(__WEBPACK_IMPORTED_MODULE_0__defaultSource__["a" /* default */]));


/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_request__ = __webpack_require__(88);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__src_request__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_html__ = __webpack_require__(447);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_html__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_json__ = __webpack_require__(448);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__src_json__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_text__ = __webpack_require__(449);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__src_text__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_xml__ = __webpack_require__(450);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_4__src_xml__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_csv__ = __webpack_require__(451);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__src_csv__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_tsv__ = __webpack_require__(452);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_6__src_tsv__["a"]; });









/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type__ = __webpack_require__(49);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__type__["a" /* default */])("text/html", function(xhr) {
  return document.createRange().createContextualFragment(xhr.responseText);
}));


/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type__ = __webpack_require__(49);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__type__["a" /* default */])("application/json", function(xhr) {
  return JSON.parse(xhr.responseText);
}));


/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type__ = __webpack_require__(49);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__type__["a" /* default */])("text/plain", function(xhr) {
  return xhr.responseText;
}));


/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type__ = __webpack_require__(49);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__type__["a" /* default */])("application/xml", function(xhr) {
  var xml = xhr.responseXML;
  if (!xml) throw new Error("parse error");
  return xml;
}));


/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dsv__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dsv__ = __webpack_require__(165);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__dsv__["a" /* default */])("text/csv", __WEBPACK_IMPORTED_MODULE_0_d3_dsv__["c" /* csvParse */]));


/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dsv__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dsv__ = __webpack_require__(165);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__dsv__["a" /* default */])("text/tab-separated-values", __WEBPACK_IMPORTED_MODULE_0_d3_dsv__["h" /* tsvParse */]));


/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_band__ = __webpack_require__(454);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0__src_band__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_0__src_band__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_identity__ = __webpack_require__(455);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_1__src_identity__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_linear__ = __webpack_require__(32);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_2__src_linear__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_log__ = __webpack_require__(457);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_3__src_log__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_ordinal__ = __webpack_require__(166);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_4__src_ordinal__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_4__src_ordinal__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_pow__ = __webpack_require__(458);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_5__src_pow__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_5__src_pow__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_quantile__ = __webpack_require__(459);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_6__src_quantile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_quantize__ = __webpack_require__(460);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_7__src_quantize__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_threshold__ = __webpack_require__(461);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_8__src_threshold__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_time__ = __webpack_require__(169);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_9__src_time__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_utcTime__ = __webpack_require__(477);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_10__src_utcTime__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_category10__ = __webpack_require__(478);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_11__src_category10__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_category20b__ = __webpack_require__(479);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_12__src_category20b__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_category20c__ = __webpack_require__(480);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_13__src_category20c__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_category20__ = __webpack_require__(481);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_14__src_category20__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__ = __webpack_require__(482);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_rainbow__ = __webpack_require__(483);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_16__src_rainbow__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_16__src_rainbow__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_16__src_rainbow__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_viridis__ = __webpack_require__(484);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_17__src_viridis__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_17__src_viridis__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_17__src_viridis__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_17__src_viridis__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_sequential__ = __webpack_require__(485);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_18__src_sequential__["a"]; });







































/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = band;
/* harmony export (immutable) */ __webpack_exports__["b"] = point;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ordinal__ = __webpack_require__(166);



function band() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_1__ordinal__["a" /* default */])().unknown(undefined),
      domain = scale.domain,
      ordinalRange = scale.range,
      range = [0, 1],
      step,
      bandwidth,
      round = false,
      paddingInner = 0,
      paddingOuter = 0,
      align = 0.5;

  delete scale.unknown;

  function rescale() {
    var n = domain().length,
        reverse = range[1] < range[0],
        start = range[reverse - 0],
        stop = range[1 - reverse];
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["s" /* range */])(n).map(function(i) { return start + step * i; });
    return ordinalRange(reverse ? values.reverse() : values);
  }

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.range = function(_) {
    return arguments.length ? (range = [+_[0], +_[1]], rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = [+_[0], +_[1]], round = true, rescale();
  };

  scale.bandwidth = function() {
    return bandwidth;
  };

  scale.step = function() {
    return step;
  };

  scale.round = function(_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };

  scale.padding = function(_) {
    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
  };

  scale.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };

  scale.copy = function() {
    return band()
        .domain(domain())
        .range(range)
        .round(round)
        .paddingInner(paddingInner)
        .paddingOuter(paddingOuter)
        .align(align);
  };

  return rescale();
}

function pointish(scale) {
  var copy = scale.copy;

  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;

  scale.copy = function() {
    return pointish(copy());
  };

  return scale;
}

function point() {
  return pointish(band().paddingInner(1));
}


/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = identity;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(167);




function identity() {
  var domain = [0, 1];

  function scale(x) {
    return +x;
  }

  scale.invert = scale;

  scale.domain = scale.range = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]), scale) : domain.slice();
  };

  scale.copy = function() {
    return identity().domain(domain);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_1__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(78);



/* harmony default export */ __webpack_exports__["a"] = (function(domain, count, specifier) {
  var start = domain[0],
      stop = domain[domain.length - 1],
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["A" /* tickStep */])(start, stop, count == null ? 10 : count),
      precision;
  specifier = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["e" /* formatSpecifier */])(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["g" /* precisionPrefix */])(step, value))) specifier.precision = precision;
      return Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["d" /* formatPrefix */])(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["h" /* precisionRound */])(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["f" /* precisionFixed */])(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a" /* format */])(specifier);
});


/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = log;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nice__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__continuous__ = __webpack_require__(50);






function deinterpolate(a, b) {
  return (b = Math.log(b / a))
      ? function(x) { return Math.log(x / a) / b; }
      : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(b);
}

function reinterpolate(a, b) {
  return a < 0
      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
}

function pow10(x) {
  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}

function powp(base) {
  return base === 10 ? pow10
      : base === Math.E ? Math.exp
      : function(x) { return Math.pow(base, x); };
}

function logp(base) {
  return base === Math.E ? Math.log
      : base === 10 && Math.log10
      || base === 2 && Math.log2
      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
}

function reflect(f) {
  return function(x) {
    return -f(-x);
  };
}

function log() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_4__continuous__["b" /* default */])(deinterpolate, reinterpolate).domain([1, 10]),
      domain = scale.domain,
      base = 10,
      logs = logp(10),
      pows = powp(10);

  function rescale() {
    logs = logp(base), pows = powp(base);
    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
    return scale;
  }

  scale.base = function(_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.ticks = function(count) {
    var d = domain(),
        u = d[0],
        v = d[d.length - 1],
        r;

    if (r = v < u) i = u, u = v, v = i;

    var i = logs(u),
        j = logs(v),
        p,
        k,
        t,
        n = count == null ? 10 : +count,
        z = [];

    if (!(base % 1) && j - i < n) {
      i = Math.round(i) - 1, j = Math.round(j) + 1;
      if (u > 0) for (; i < j; ++i) {
        for (k = 1, p = pows(i); k < base; ++k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      } else for (; i < j; ++i) {
        for (k = base - 1, p = pows(i); k >= 1; --k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      }
    } else {
      z = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["B" /* ticks */])(i, j, Math.min(j - i, n)).map(pows);
    }

    return r ? z.reverse() : z;
  };

  scale.tickFormat = function(count, specifier) {
    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
    if (typeof specifier !== "function") specifier = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a" /* format */])(specifier);
    if (count === Infinity) return specifier;
    if (count == null) count = 10;
    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
    return function(d) {
      var i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5) i *= base;
      return i <= k ? specifier(d) : "";
    };
  };

  scale.nice = function() {
    return domain(Object(__WEBPACK_IMPORTED_MODULE_3__nice__["a" /* default */])(domain(), {
      floor: function(x) { return pows(Math.floor(logs(x))); },
      ceil: function(x) { return pows(Math.ceil(logs(x))); }
    }));
  };

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_4__continuous__["a" /* copy */])(scale, log().base(base));
  };

  return scale;
}


/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pow;
/* harmony export (immutable) */ __webpack_exports__["b"] = sqrt;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__(50);




function raise(x, exponent) {
  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
}

function pow() {
  var exponent = 1,
      scale = Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["b" /* default */])(deinterpolate, reinterpolate),
      domain = scale.domain;

  function deinterpolate(a, b) {
    return (b = raise(b, exponent) - (a = raise(a, exponent)))
        ? function(x) { return (raise(x, exponent) - a) / b; }
        : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(b);
  }

  function reinterpolate(a, b) {
    b = raise(b, exponent) - (a = raise(a, exponent));
    return function(t) { return raise(a + b * t, 1 / exponent); };
  }

  scale.exponent = function(_) {
    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
  };

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" /* copy */])(scale, pow().exponent(exponent));
  };

  return Object(__WEBPACK_IMPORTED_MODULE_1__linear__["b" /* linearish */])(scale);
}

function sqrt() {
  return pow().exponent(0.5);
}


/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quantile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(17);



function quantile() {
  var domain = [],
      range = [],
      thresholds = [];

  function rescale() {
    var i = 0, n = Math.max(1, range.length);
    thresholds = new Array(n - 1);
    while (++i < n) thresholds[i - 1] = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["r" /* quantile */])(domain, i / n);
    return scale;
  }

  function scale(x) {
    if (!isNaN(x = +x)) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(thresholds, x)];
  }

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN] : [
      i > 0 ? thresholds[i - 1] : domain[0],
      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
    ];
  };

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
    domain.sort(__WEBPACK_IMPORTED_MODULE_0_d3_array__["a" /* ascending */]);
    return rescale();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.quantiles = function() {
    return thresholds.slice();
  };

  scale.copy = function() {
    return quantile()
        .domain(domain)
        .range(range);
  };

  return scale;
}


/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quantize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linear__ = __webpack_require__(32);




function quantize() {
  var x0 = 0,
      x1 = 1,
      n = 1,
      domain = [0.5],
      range = [0, 1];

  function scale(x) {
    if (x <= x) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(domain, x, 0, n)];
  }

  function rescale() {
    var i = -1;
    domain = new Array(n);
    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
    return scale;
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
  };

  scale.range = function(_) {
    return arguments.length ? (n = (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_)).length - 1, rescale()) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN]
        : i < 1 ? [x0, domain[0]]
        : i >= n ? [domain[n - 1], x1]
        : [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return quantize()
        .domain([x0, x1])
        .range(range);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_2__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = threshold;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(17);



function threshold() {
  var domain = [0.5],
      range = [0, 1],
      n = 1;

  function scale(x) {
    if (x <= x) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(domain, x, 0, n)];
  }

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return threshold()
        .domain(domain)
        .range(range);
  };

  return scale;
}


/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return milliseconds; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(3);


var millisecond = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function() {
  // noop
}, function(date, step) {
  date.setTime(+date + step);
}, function(start, end) {
  return end - start;
});

// An optimized implementation for this simple case.
millisecond.every = function(k) {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond;
  return Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setTime(Math.floor(date / k) * k);
  }, function(date, step) {
    date.setTime(+date + step * k);
  }, function(start, end) {
    return (end - start) / k;
  });
};

/* harmony default export */ __webpack_exports__["a"] = (millisecond);
var milliseconds = millisecond.range;


/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return seconds; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(11);



var second = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setTime(Math.floor(date / __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationSecond */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationSecond */]);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationSecond */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationSecond */];
}, function(date) {
  return date.getUTCSeconds();
});

/* harmony default export */ __webpack_exports__["a"] = (second);
var seconds = second.range;


/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return minutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(11);



var minute = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setTime(Math.floor(date / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */];
}, function(date) {
  return date.getMinutes();
});

/* harmony default export */ __webpack_exports__["a"] = (minute);
var minutes = minute.range;


/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hours; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(11);



var hour = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  var offset = date.getTimezoneOffset() * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */] % __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */];
  if (offset < 0) offset += __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */];
  date.setTime(Math.floor((+date - offset) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */] + offset);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */];
}, function(date) {
  return date.getHours();
});

/* harmony default export */ __webpack_exports__["a"] = (hour);
var hours = hour.range;


/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return days; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(11);



var day = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setDate(date.getDate() + step);
}, function(start, end) {
  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]) / __WEBPACK_IMPORTED_MODULE_1__duration__["a" /* durationDay */];
}, function(date) {
  return date.getDate() - 1;
});

/* harmony default export */ __webpack_exports__["b"] = (day);
var days = day.range;


/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return sunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return monday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return tuesday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return wednesday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return thursday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return friday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return saturday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return sundays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return mondays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return tuesdays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return wednesdays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return thursdays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fridays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return saturdays; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(11);



function weekday(i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]) / __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationWeek */];
  });
}

var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);

var sundays = sunday.range;
var mondays = monday.range;
var tuesdays = tuesday.range;
var wednesdays = wednesday.range;
var thursdays = thursday.range;
var fridays = friday.range;
var saturdays = saturday.range;


/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return months; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(3);


var month = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setMonth(date.getMonth() + step);
}, function(start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
  return date.getMonth();
});

/* harmony default export */ __webpack_exports__["a"] = (month);
var months = month.range;


/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return years; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(3);


var year = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
  return end.getFullYear() - start.getFullYear();
}, function(date) {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
year.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (year);
var years = year.range;


/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcMinutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(11);



var utcMinute = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCSeconds(0, 0);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */];
}, function(date) {
  return date.getUTCMinutes();
});

/* harmony default export */ __webpack_exports__["a"] = (utcMinute);
var utcMinutes = utcMinute.range;


/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcHours; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(11);



var utcHour = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */];
}, function(date) {
  return date.getUTCHours();
});

/* harmony default export */ __webpack_exports__["a"] = (utcHour);
var utcHours = utcHour.range;


/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcDays; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(11);



var utcDay = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["a" /* durationDay */];
}, function(date) {
  return date.getUTCDate() - 1;
});

/* harmony default export */ __webpack_exports__["a"] = (utcDay);
var utcDays = utcDay.range;


/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return utcSunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return utcMonday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return utcTuesday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return utcWednesday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return utcThursday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return utcFriday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return utcSaturday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return utcSundays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return utcMondays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return utcTuesdays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return utcWednesdays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return utcThursdays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcFridays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return utcSaturdays; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(11);



function utcWeekday(i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function(start, end) {
    return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationWeek */];
  });
}

var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);

var utcSundays = utcSunday.range;
var utcMondays = utcMonday.range;
var utcTuesdays = utcTuesday.range;
var utcWednesdays = utcWednesday.range;
var utcThursdays = utcThursday.range;
var utcFridays = utcFriday.range;
var utcSaturdays = utcSaturday.range;


/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcMonths; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(3);


var utcMonth = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
  return date.getUTCMonth();
});

/* harmony default export */ __webpack_exports__["a"] = (utcMonth);
var utcMonths = utcMonth.range;


/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcYears; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(3);


var utcYear = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (utcYear);
var utcYears = utcYear.range;


/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isoFormat__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultLocale__ = __webpack_require__(91);



function parseIsoNative(string) {
  var date = new Date(string);
  return isNaN(date) ? null : date;
}

var parseIso = +new Date("2000-01-01T00:00:00.000Z")
    ? parseIsoNative
    : Object(__WEBPACK_IMPORTED_MODULE_1__defaultLocale__["e" /* utcParse */])(__WEBPACK_IMPORTED_MODULE_0__isoFormat__["b" /* isoSpecifier */]);

/* harmony default export */ __webpack_exports__["a"] = (parseIso);


/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__time__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_time_format__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(51);




/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__time__["a" /* calendar */])(__WEBPACK_IMPORTED_MODULE_2_d3_time__["_7" /* utcYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["R" /* utcMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["_5" /* utcWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["F" /* utcDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["J" /* utcHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["N" /* utcMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["V" /* utcSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["L" /* utcMillisecond */], __WEBPACK_IMPORTED_MODULE_1_d3_time_format__["g" /* utcFormat */]).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
});


/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(33);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"));


/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(33);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6"));


/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(33);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9"));


/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(33);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5"));


/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["f" /* interpolateCubehelixLong */])(Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(300, 0.5, 0.0), Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(-240, 0.5, 1.0)));


/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return warm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cool; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(7);



var warm = Object(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["f" /* interpolateCubehelixLong */])(Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(-100, 0.75, 0.35), Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(80, 1.50, 0.8));

var cool = Object(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["f" /* interpolateCubehelixLong */])(Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(260, 0.75, 0.35), Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(80, 1.50, 0.8));

var rainbow = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])();

/* harmony default export */ __webpack_exports__["b"] = (function(t) {
  if (t < 0 || t > 1) t -= Math.floor(t);
  var ts = Math.abs(t - 0.5);
  rainbow.h = 360 * t - 100;
  rainbow.s = 1.5 - 1.5 * ts;
  rainbow.l = 0.8 - 0.9 * ts;
  return rainbow + "";
});


/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return magma; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return inferno; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return plasma; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(33);


function ramp(range) {
  var n = range.length;
  return function(t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725")));

var magma = ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));

var inferno = ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));

var plasma = ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));


/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sequential;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(32);


function sequential(interpolator) {
  var x0 = 0,
      x1 = 1,
      clamp = false;

  function scale(x) {
    var t = (x - x0) / (x1 - x0);
    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.copy = function() {
    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_arc__ = __webpack_require__(487);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_arc__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_area__ = __webpack_require__(172);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_area__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_line__ = __webpack_require__(92);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_2__src_line__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_pie__ = __webpack_require__(488);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_3__src_pie__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_areaRadial__ = __webpack_require__(491);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__src_areaRadial__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_4__src_areaRadial__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_lineRadial__ = __webpack_require__(174);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_5__src_lineRadial__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_5__src_lineRadial__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_pointRadial__ = __webpack_require__(175);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_6__src_pointRadial__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_link_index__ = __webpack_require__(492);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_7__src_link_index__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_7__src_link_index__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_7__src_link_index__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_symbol__ = __webpack_require__(493);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_8__src_symbol__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_8__src_symbol__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_symbol_circle__ = __webpack_require__(177);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_9__src_symbol_circle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_symbol_cross__ = __webpack_require__(178);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_10__src_symbol_cross__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_symbol_diamond__ = __webpack_require__(179);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_11__src_symbol_diamond__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_symbol_square__ = __webpack_require__(181);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_12__src_symbol_square__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_symbol_star__ = __webpack_require__(180);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_13__src_symbol_star__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_symbol_triangle__ = __webpack_require__(182);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_14__src_symbol_triangle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_symbol_wye__ = __webpack_require__(183);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_15__src_symbol_wye__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_curve_basisClosed__ = __webpack_require__(494);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_16__src_curve_basisClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_curve_basisOpen__ = __webpack_require__(495);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_17__src_curve_basisOpen__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_curve_basis__ = __webpack_require__(54);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_18__src_curve_basis__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_curve_bundle__ = __webpack_require__(496);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_19__src_curve_bundle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_curve_cardinalClosed__ = __webpack_require__(184);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_20__src_curve_cardinalClosed__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_curve_cardinalOpen__ = __webpack_require__(185);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_21__src_curve_cardinalOpen__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_curve_cardinal__ = __webpack_require__(55);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_22__src_curve_cardinal__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_curve_catmullRomClosed__ = __webpack_require__(497);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_23__src_curve_catmullRomClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_curve_catmullRomOpen__ = __webpack_require__(498);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_24__src_curve_catmullRomOpen__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__src_curve_catmullRom__ = __webpack_require__(94);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_25__src_curve_catmullRom__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__src_curve_linearClosed__ = __webpack_require__(499);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_26__src_curve_linearClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__src_curve_linear__ = __webpack_require__(52);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_27__src_curve_linear__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__src_curve_monotone__ = __webpack_require__(500);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_28__src_curve_monotone__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_28__src_curve_monotone__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__src_curve_natural__ = __webpack_require__(501);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_29__src_curve_natural__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__src_curve_step__ = __webpack_require__(502);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_30__src_curve_step__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_30__src_curve_step__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_30__src_curve_step__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__src_stack__ = __webpack_require__(503);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_31__src_stack__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__src_offset_expand__ = __webpack_require__(504);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_32__src_offset_expand__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__src_offset_diverging__ = __webpack_require__(505);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_33__src_offset_diverging__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__src_offset_none__ = __webpack_require__(35);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_34__src_offset_none__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__src_offset_silhouette__ = __webpack_require__(506);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_35__src_offset_silhouette__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__src_offset_wiggle__ = __webpack_require__(507);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_36__src_offset_wiggle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__src_order_ascending__ = __webpack_require__(95);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_37__src_order_ascending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__src_order_descending__ = __webpack_require__(508);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_38__src_order_descending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__src_order_insideOut__ = __webpack_require__(509);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_39__src_order_insideOut__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__src_order_none__ = __webpack_require__(36);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_40__src_order_none__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__src_order_reverse__ = __webpack_require__(510);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_41__src_order_reverse__["a"]; });




 // Note: radialArea is deprecated!
 // Note: radialLine is deprecated!









































/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(34);




function arcInnerRadius(d) {
  return d.innerRadius;
}

function arcOuterRadius(d) {
  return d.outerRadius;
}

function arcStartAngle(d) {
  return d.startAngle;
}

function arcEndAngle(d) {
  return d.endAngle;
}

function arcPadAngle(d) {
  return d && d.padAngle; // Note: optional!
}

function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0, y10 = y1 - y0,
      x32 = x3 - x2, y32 = y3 - y2,
      t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
  return [x0 + t * x10, y0 + t * y10];
}

// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1,
      y01 = y0 - y1,
      lo = (cw ? rc : -rc) / Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(x01 * x01 + y01 * y01),
      ox = lo * y01,
      oy = -lo * x01,
      x11 = x0 + ox,
      y11 = y0 + oy,
      x10 = x1 + ox,
      y10 = y1 + oy,
      x00 = (x11 + x10) / 2,
      y00 = (y11 + y10) / 2,
      dx = x10 - x11,
      dy = y10 - y11,
      d2 = dx * dx + dy * dy,
      r = r1 - rc,
      D = x11 * y10 - x10 * y11,
      d = (dy < 0 ? -1 : 1) * Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(Object(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* max */])(0, r * r * d2 - D * D)),
      cx0 = (D * dy - dx * d) / d2,
      cy0 = (-D * dx - dy * d) / d2,
      cx1 = (D * dy + dx * d) / d2,
      cy1 = (-D * dx + dy * d) / d2,
      dx0 = cx0 - x00,
      dy0 = cy0 - y00,
      dx1 = cx1 - x00,
      dy1 = cy1 - y00;

  // Pick the closer of the two intersection points.
  // TODO Is there a faster way to determine which intersection to use?
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;

  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var innerRadius = arcInnerRadius,
      outerRadius = arcOuterRadius,
      cornerRadius = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(0),
      padRadius = null,
      startAngle = arcStartAngle,
      endAngle = arcEndAngle,
      padAngle = arcPadAngle,
      context = null;

  function arc() {
    var buffer,
        r,
        r0 = +innerRadius.apply(this, arguments),
        r1 = +outerRadius.apply(this, arguments),
        a0 = startAngle.apply(this, arguments) - __WEBPACK_IMPORTED_MODULE_2__math__["g" /* halfPi */],
        a1 = endAngle.apply(this, arguments) - __WEBPACK_IMPORTED_MODULE_2__math__["g" /* halfPi */],
        da = Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(a1 - a0),
        cw = a1 > a0;

    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();

    // Ensure that the outer radius is always larger than the inner radius.
    if (r1 < r0) r = r1, r1 = r0, r0 = r;

    // Is it a point?
    if (!(r1 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */])) context.moveTo(0, 0);

    // Or is it a circle or annulus?
    else if (da > __WEBPACK_IMPORTED_MODULE_2__math__["m" /* tau */] - __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
      context.moveTo(r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a0), r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        context.moveTo(r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a1), r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    }

    // Or is it a circular or annular sector?
    else {
      var a01 = a0,
          a11 = a1,
          a00 = a0,
          a10 = a1,
          da0 = da,
          da1 = da,
          ap = padAngle.apply(this, arguments) / 2,
          rp = (ap > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) && (padRadius ? +padRadius.apply(this, arguments) : Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(r0 * r0 + r1 * r1)),
          rc = Object(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* min */])(Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
          rc0 = rc,
          rc1 = rc,
          t0,
          t1;

      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
      if (rp > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        var p0 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* asin */])(rp / r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(ap)),
            p1 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* asin */])(rp / r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(ap));
        if ((da0 -= p0 * 2) > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }

      var x01 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a01),
          y01 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a01),
          x10 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a10),
          y10 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a10);

      // Apply rounded corners?
      if (rc > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        var x11 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a11),
            y11 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a11),
            x00 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a00),
            y00 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a00);

        // Restrict the corner radius according to the sector angle.
        if (da < __WEBPACK_IMPORTED_MODULE_2__math__["j" /* pi */]) {
          var oc = da0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */] ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
              ax = x01 - oc[0],
              ay = y01 - oc[1],
              bx = x11 - oc[0],
              by = y11 - oc[1],
              kc = 1 / Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(Object(__WEBPACK_IMPORTED_MODULE_2__math__["b" /* acos */])((ax * bx + ay * by) / (Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(ax * ax + ay * ay) * Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(bx * bx + by * by))) / 2),
              lc = Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* min */])(rc, (r0 - lc) / (kc - 1));
          rc1 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* min */])(rc, (r1 - lc) / (kc + 1));
        }
      }

      // Is the sector collapsed to a line?
      if (!(da1 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */])) context.moveTo(x01, y01);

      // Does the sector’s outer ring have rounded corners?
      else if (rc1 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);

        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.cy + t0.y11, t0.cx + t0.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
          context.arc(t1.cx, t1.cy, rc1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y11, t1.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the outer ring just a circular arc?
      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);

      // Is there no inner ring, and it’s a circular sector?
      // Or perhaps it’s an annular sector collapsed due to padding?
      if (!(r0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) || !(da0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */])) context.lineTo(x10, y10);

      // Does the sector’s inner ring (or point) have rounded corners?
      else if (rc0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);

        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.cy + t0.y11, t0.cx + t0.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.cy + t1.y11, t1.cx + t1.x11), cw);
          context.arc(t1.cx, t1.cy, rc0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y11, t1.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the inner ring just a circular arc?
      else context.arc(0, 0, r0, a10, a00, cw);
    }

    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  arc.centroid = function() {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - __WEBPACK_IMPORTED_MODULE_2__math__["j" /* pi */] / 2;
    return [Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a) * r, Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a) * r];
  };

  arc.innerRadius = function(_) {
    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : innerRadius;
  };

  arc.outerRadius = function(_) {
    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : outerRadius;
  };

  arc.cornerRadius = function(_) {
    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : cornerRadius;
  };

  arc.padRadius = function(_) {
    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : padRadius;
  };

  arc.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : startAngle;
  };

  arc.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : endAngle;
  };

  arc.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : padAngle;
  };

  arc.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
  };

  return arc;
});


/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__descending__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__math__ = __webpack_require__(34);





/* harmony default export */ __webpack_exports__["a"] = (function() {
  var value = __WEBPACK_IMPORTED_MODULE_2__identity__["a" /* default */],
      sortValues = __WEBPACK_IMPORTED_MODULE_1__descending__["a" /* default */],
      sort = null,
      startAngle = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0),
      endAngle = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__math__["m" /* tau */]),
      padAngle = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0);

  function pie(data) {
    var i,
        n = data.length,
        j,
        k,
        sum = 0,
        index = new Array(n),
        arcs = new Array(n),
        a0 = +startAngle.apply(this, arguments),
        da = Math.min(__WEBPACK_IMPORTED_MODULE_3__math__["m" /* tau */], Math.max(-__WEBPACK_IMPORTED_MODULE_3__math__["m" /* tau */], endAngle.apply(this, arguments) - a0)),
        a1,
        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
        pa = p * (da < 0 ? -1 : 1),
        v;

    for (i = 0; i < n; ++i) {
      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
        sum += v;
      }
    }

    // Optionally sort the arcs by previously-computed values or by data.
    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });

    // Compute the arcs! They are stored in the original data's order.
    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
        data: data[j],
        index: i,
        value: v,
        startAngle: a0,
        endAngle: a1,
        padAngle: p
      };
    }

    return arcs;
  }

  pie.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : value;
  };

  pie.sortValues = function(_) {
    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
  };

  pie.sort = function(_) {
    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
  };

  pie.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : startAngle;
  };

  pie.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : endAngle;
  };

  pie.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : padAngle;
  };

  return pie;
});


/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});


/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(d) {
  return d;
});


/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curve_radial__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__area__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lineRadial__ = __webpack_require__(174);




/* harmony default export */ __webpack_exports__["a"] = (function() {
  var a = Object(__WEBPACK_IMPORTED_MODULE_1__area__["a" /* default */])().curve(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["a" /* curveRadialLinear */]),
      c = a.curve,
      x0 = a.lineX0,
      x1 = a.lineX1,
      y0 = a.lineY0,
      y1 = a.lineY1;

  a.angle = a.x, delete a.x;
  a.startAngle = a.x0, delete a.x0;
  a.endAngle = a.x1, delete a.x1;
  a.radius = a.y, delete a.y;
  a.innerRadius = a.y0, delete a.y0;
  a.outerRadius = a.y1, delete a.y1;
  a.lineStartAngle = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["b" /* lineRadial */])(x0()); }, delete a.lineX0;
  a.lineEndAngle = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["b" /* lineRadial */])(x1()); }, delete a.lineX1;
  a.lineInnerRadius = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["b" /* lineRadial */])(y0()); }, delete a.lineY0;
  a.lineOuterRadius = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["b" /* lineRadial */])(y1()); }, delete a.lineY1;

  a.curve = function(_) {
    return arguments.length ? c(Object(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["b" /* default */])(_)) : c()._curve;
  };

  return a;
});


/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = linkHorizontal;
/* harmony export (immutable) */ __webpack_exports__["c"] = linkVertical;
/* harmony export (immutable) */ __webpack_exports__["b"] = linkRadial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__point__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pointRadial__ = __webpack_require__(175);






function linkSource(d) {
  return d.source;
}

function linkTarget(d) {
  return d.target;
}

function link(curve) {
  var source = linkSource,
      target = linkTarget,
      x = __WEBPACK_IMPORTED_MODULE_3__point__["a" /* x */],
      y = __WEBPACK_IMPORTED_MODULE_3__point__["b" /* y */],
      context = null;

  function link() {
    var buffer, argv = __WEBPACK_IMPORTED_MODULE_1__array__["a" /* slice */].call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();
    curve(context, +x.apply(this, (argv[0] = s, argv)), +y.apply(this, argv), +x.apply(this, (argv[0] = t, argv)), +y.apply(this, argv));
    if (buffer) return context = null, buffer + "" || null;
  }

  link.source = function(_) {
    return arguments.length ? (source = _, link) : source;
  };

  link.target = function(_) {
    return arguments.length ? (target = _, link) : target;
  };

  link.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(+_), link) : x;
  };

  link.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(+_), link) : y;
  };

  link.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), link) : context;
  };

  return link;
}

function curveHorizontal(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
}

function curveVertical(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
}

function curveRadial(context, x0, y0, x1, y1) {
  var p0 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x0, y0),
      p1 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x0, y0 = (y0 + y1) / 2),
      p2 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x1, y0),
      p3 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x1, y1);
  context.moveTo(p0[0], p0[1]);
  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
}

function linkHorizontal() {
  return link(curveHorizontal);
}

function linkVertical() {
  return link(curveVertical);
}

function linkRadial() {
  var l = link(curveRadial);
  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;
  return l;
}


/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return symbols; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__symbol_circle__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__symbol_cross__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__symbol_diamond__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__symbol_star__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__symbol_square__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__symbol_triangle__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__symbol_wye__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constant__ = __webpack_require__(18);










var symbols = [
  __WEBPACK_IMPORTED_MODULE_1__symbol_circle__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_2__symbol_cross__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_3__symbol_diamond__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_5__symbol_square__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_4__symbol_star__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_6__symbol_triangle__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_7__symbol_wye__["a" /* default */]
];

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var type = Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__symbol_circle__["a" /* default */]),
      size = Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(64),
      context = null;

  function symbol() {
    var buffer;
    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();
    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
    if (buffer) return context = null, buffer + "" || null;
  }

  symbol.type = function(_) {
    return arguments.length ? (type = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(_), symbol) : type;
  };

  symbol.size = function(_) {
    return arguments.length ? (size = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(+_), symbol) : size;
  };

  symbol.context = function(_) {
    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
  };

  return symbol;
});


/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis__ = __webpack_require__(54);



function BasisClosed(context) {
  this._context = context;
}

BasisClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2);
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
      default: Object(__WEBPACK_IMPORTED_MODULE_1__basis__["c" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new BasisClosed(context);
});


/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(54);


function BasisOpen(context) {
  this._context = context;
}

BasisOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
      case 3: this._point = 4; // proceed
      default: Object(__WEBPACK_IMPORTED_MODULE_0__basis__["c" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new BasisOpen(context);
});


/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(54);


function Bundle(context, beta) {
  this._basis = new __WEBPACK_IMPORTED_MODULE_0__basis__["a" /* Basis */](context);
  this._beta = beta;
}

Bundle.prototype = {
  lineStart: function() {
    this._x = [];
    this._y = [];
    this._basis.lineStart();
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        j = x.length - 1;

    if (j > 0) {
      var x0 = x[0],
          y0 = y[0],
          dx = x[j] - x0,
          dy = y[j] - y0,
          i = -1,
          t;

      while (++i <= j) {
        t = i / j;
        this._basis.point(
          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
        );
      }
    }

    this._x = this._y = null;
    this._basis.lineEnd();
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ((function custom(beta) {

  function bundle(context) {
    return beta === 1 ? new __WEBPACK_IMPORTED_MODULE_0__basis__["a" /* Basis */](context) : new Bundle(context, beta);
  }

  bundle.beta = function(beta) {
    return custom(+beta);
  };

  return bundle;
})(0.85));


/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinalClosed__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__catmullRom__ = __webpack_require__(94);




function CatmullRomClosed(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: Object(__WEBPACK_IMPORTED_MODULE_2__catmullRom__["b" /* point */])(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomClosed(context, alpha) : new __WEBPACK_IMPORTED_MODULE_0__cardinalClosed__["a" /* CardinalClosed */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinalOpen__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__catmullRom__ = __webpack_require__(94);



function CatmullRomOpen(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: Object(__WEBPACK_IMPORTED_MODULE_1__catmullRom__["b" /* point */])(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomOpen(context, alpha) : new __WEBPACK_IMPORTED_MODULE_0__cardinalOpen__["a" /* CardinalOpen */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(53);


function LinearClosed(context) {
  this._context = context;
}

LinearClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._point) this._context.closePath();
  },
  point: function(x, y) {
    x = +x, y = +y;
    if (this._point) this._context.lineTo(x, y);
    else this._point = 1, this._context.moveTo(x, y);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new LinearClosed(context);
});


/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = monotoneX;
/* harmony export (immutable) */ __webpack_exports__["b"] = monotoneY;
function sign(x) {
  return x < 0 ? -1 : 1;
}

// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
  var h0 = that._x1 - that._x0,
      h1 = x2 - that._x1,
      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
      p = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}

// Calculate a one-sided slope.
function slope2(that, t) {
  var h = that._x1 - that._x0;
  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}

// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point(that, t0, t1) {
  var x0 = that._x0,
      y0 = that._y0,
      x1 = that._x1,
      y1 = that._y1,
      dx = (x1 - x0) / 3;
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}

function MonotoneX(context) {
  this._context = context;
}

MonotoneX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 =
    this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x1, this._y1); break;
      case 3: point(this, this._t0, slope2(this, this._t0)); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    var t1 = NaN;

    x = +x, y = +y;
    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; point(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
      default: point(this, this._t0, t1 = slope3(this, x, y)); break;
    }

    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
    this._t0 = t1;
  }
}

function MonotoneY(context) {
  this._context = new ReflectContext(context);
}

(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
  MonotoneX.prototype.point.call(this, y, x);
};

function ReflectContext(context) {
  this._context = context;
}

ReflectContext.prototype = {
  moveTo: function(x, y) { this._context.moveTo(y, x); },
  closePath: function() { this._context.closePath(); },
  lineTo: function(x, y) { this._context.lineTo(y, x); },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
};

function monotoneX(context) {
  return new MonotoneX(context);
}

function monotoneY(context) {
  return new MonotoneY(context);
}


/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function Natural(context) {
  this._context = context;
}

Natural.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [];
    this._y = [];
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        n = x.length;

    if (n) {
      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
      if (n === 2) {
        this._context.lineTo(x[1], y[1]);
      } else {
        var px = controlPoints(x),
            py = controlPoints(y);
        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
        }
      }
    }

    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
    this._line = 1 - this._line;
    this._x = this._y = null;
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
  var i,
      n = x.length - 1,
      m,
      a = new Array(n),
      b = new Array(n),
      r = new Array(n);
  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
  a[n - 1] = r[n - 1] / b[n - 1];
  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
  b[n - 1] = (x[n] + a[n - 1]) / 2;
  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
  return [a, b];
}

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Natural(context);
});


/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = stepBefore;
/* harmony export (immutable) */ __webpack_exports__["b"] = stepAfter;
function Step(context, t) {
  this._context = context;
  this._t = t;
}

Step.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: {
        if (this._t <= 0) {
          this._context.lineTo(this._x, y);
          this._context.lineTo(x, y);
        } else {
          var x1 = this._x * (1 - this._t) + x * this._t;
          this._context.lineTo(x1, this._y);
          this._context.lineTo(x1, y);
        }
        break;
      }
    }
    this._x = x, this._y = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Step(context, 0.5);
});

function stepBefore(context) {
  return new Step(context, 0);
}

function stepAfter(context) {
  return new Step(context, 1);
}


/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__offset_none__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__order_none__ = __webpack_require__(36);





function stackValue(d, key) {
  return d[key];
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var keys = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])([]),
      order = __WEBPACK_IMPORTED_MODULE_3__order_none__["a" /* default */],
      offset = __WEBPACK_IMPORTED_MODULE_2__offset_none__["a" /* default */],
      value = stackValue;

  function stack(data) {
    var kz = keys.apply(this, arguments),
        i,
        m = data.length,
        n = kz.length,
        sz = new Array(n),
        oz;

    for (i = 0; i < n; ++i) {
      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
        si[j] = sij = [0, +value(data[j], ki, j, data)];
        sij.data = data[j];
      }
      si.key = ki;
    }

    for (i = 0, oz = order(sz); i < n; ++i) {
      sz[oz[i]].index = i;
    }

    offset(sz, oz);
    return sz;
  }

  stack.keys = function(_) {
    return arguments.length ? (keys = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_)), stack) : keys;
  };

  stack.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), stack) : value;
  };

  stack.order = function(_) {
    return arguments.length ? (order = _ == null ? __WEBPACK_IMPORTED_MODULE_3__order_none__["a" /* default */] : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_)), stack) : order;
  };

  stack.offset = function(_) {
    return arguments.length ? (offset = _ == null ? __WEBPACK_IMPORTED_MODULE_2__offset_none__["a" /* default */] : _, stack) : offset;
  };

  return stack;
});


/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(35);


/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
    for (yp = yn = 0, i = 0; i < n; ++i) {
      if ((dy = (d = series[order[i]][j])[1] - d[0]) >= 0) {
        d[0] = yp, d[1] = yp += dy;
      } else if (dy < 0) {
        d[1] = yn, d[0] = yn += dy;
      } else {
        d[0] = yp;
      }
    }
  }
});


/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(35);


/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
    s0[j][1] += s0[j][0] = -y / 2;
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(35);


/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
      var si = series[order[i]],
          sij0 = si[j][1] || 0,
          sij1 = si[j - 1][1] || 0,
          s3 = (sij0 - sij1) / 2;
      for (var k = 0; k < i; ++k) {
        var sk = series[order[k]],
            skj0 = sk[j][1] || 0,
            skj1 = sk[j - 1][1] || 0;
        s3 += skj0 - skj1;
      }
      s1 += sij0, s2 += s3 * sij0;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    if (s1) y -= s2 / s1;
  }
  s0[j - 1][1] += s0[j - 1][0] = y;
  Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */])(series).reverse();
});


/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(95);



/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  var n = series.length,
      i,
      j,
      sums = series.map(__WEBPACK_IMPORTED_MODULE_1__ascending__["b" /* sum */]),
      order = Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).sort(function(a, b) { return sums[b] - sums[a]; }),
      top = 0,
      bottom = 0,
      tops = [],
      bottoms = [];

  for (i = 0; i < n; ++i) {
    j = order[i];
    if (top < bottom) {
      top += sums[j];
      tops.push(j);
    } else {
      bottom += sums[j];
      bottoms.push(j);
    }
  }

  return bottoms.reverse().concat(tops);
});


/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(36);


/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).reverse();
});


/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_voronoi__ = __webpack_require__(512);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_voronoi__["a"]; });



/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Diagram__ = __webpack_require__(37);




/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x = __WEBPACK_IMPORTED_MODULE_1__point__["a" /* x */],
      y = __WEBPACK_IMPORTED_MODULE_1__point__["b" /* y */],
      extent = null;

  function voronoi(data) {
    return new __WEBPACK_IMPORTED_MODULE_2__Diagram__["d" /* default */](data.map(function(d, i) {
      var s = [Math.round(x(d, i, data) / __WEBPACK_IMPORTED_MODULE_2__Diagram__["f" /* epsilon */]) * __WEBPACK_IMPORTED_MODULE_2__Diagram__["f" /* epsilon */], Math.round(y(d, i, data) / __WEBPACK_IMPORTED_MODULE_2__Diagram__["f" /* epsilon */]) * __WEBPACK_IMPORTED_MODULE_2__Diagram__["f" /* epsilon */]];
      s.index = i;
      s.data = d;
      return s;
    }), extent);
  }

  voronoi.polygons = function(data) {
    return voronoi(data).polygons();
  };

  voronoi.links = function(data) {
    return voronoi(data).links();
  };

  voronoi.triangles = function(data) {
    return voronoi(data).triangles();
  };

  voronoi.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), voronoi) : x;
  };

  voronoi.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), voronoi) : y;
  };

  voronoi.extent = function(_) {
    return arguments.length ? (extent = _ == null ? null : [[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]], voronoi) : extent && [[extent[0][0], extent[0][1]], [extent[1][0], extent[1][1]]];
  };

  voronoi.size = function(_) {
    return arguments.length ? (extent = _ == null ? null : [[0, 0], [+_[0], +_[1]]], voronoi) : extent && [extent[1][0] - extent[0][0], extent[1][1] - extent[0][1]];
  };

  return voronoi;
});


/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = x;
/* harmony export (immutable) */ __webpack_exports__["b"] = y;
function x(d) {
  return d[0];
}

function y(d) {
  return d[1];
}


/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = removeBeach;
/* harmony export (immutable) */ __webpack_exports__["a"] = addBeach;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RedBlackTree__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Cell__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Circle__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Edge__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Diagram__ = __webpack_require__(37);






var beachPool = [];

function Beach() {
  Object(__WEBPACK_IMPORTED_MODULE_0__RedBlackTree__["a" /* RedBlackNode */])(this);
  this.edge =
  this.site =
  this.circle = null;
}

function createBeach(site) {
  var beach = beachPool.pop() || new Beach;
  beach.site = site;
  return beach;
}

function detachBeach(beach) {
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(beach);
  __WEBPACK_IMPORTED_MODULE_4__Diagram__["a" /* beaches */].remove(beach);
  beachPool.push(beach);
  Object(__WEBPACK_IMPORTED_MODULE_0__RedBlackTree__["a" /* RedBlackNode */])(beach);
}

function removeBeach(beach) {
  var circle = beach.circle,
      x = circle.x,
      y = circle.cy,
      vertex = [x, y],
      previous = beach.P,
      next = beach.N,
      disappearing = [beach];

  detachBeach(beach);

  var lArc = previous;
  while (lArc.circle
      && Math.abs(x - lArc.circle.x) < __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]
      && Math.abs(y - lArc.circle.cy) < __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]) {
    previous = lArc.P;
    disappearing.unshift(lArc);
    detachBeach(lArc);
    lArc = previous;
  }

  disappearing.unshift(lArc);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(lArc);

  var rArc = next;
  while (rArc.circle
      && Math.abs(x - rArc.circle.x) < __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]
      && Math.abs(y - rArc.circle.cy) < __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]) {
    next = rArc.N;
    disappearing.push(rArc);
    detachBeach(rArc);
    rArc = next;
  }

  disappearing.push(rArc);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(rArc);

  var nArcs = disappearing.length,
      iArc;
  for (iArc = 1; iArc < nArcs; ++iArc) {
    rArc = disappearing[iArc];
    lArc = disappearing[iArc - 1];
    Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["d" /* setEdgeEnd */])(rArc.edge, lArc.site, rArc.site, vertex);
  }

  lArc = disappearing[0];
  rArc = disappearing[nArcs - 1];
  rArc.edge = Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" /* createEdge */])(lArc.site, rArc.site, null, vertex);

  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* attachCircle */])(lArc);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* attachCircle */])(rArc);
}

function addBeach(site) {
  var x = site[0],
      directrix = site[1],
      lArc,
      rArc,
      dxl,
      dxr,
      node = __WEBPACK_IMPORTED_MODULE_4__Diagram__["a" /* beaches */]._;

  while (node) {
    dxl = leftBreakPoint(node, directrix) - x;
    if (dxl > __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]) node = node.L; else {
      dxr = x - rightBreakPoint(node, directrix);
      if (dxr > __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]) {
        if (!node.R) {
          lArc = node;
          break;
        }
        node = node.R;
      } else {
        if (dxl > -__WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]) {
          lArc = node.P;
          rArc = node;
        } else if (dxr > -__WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]) {
          lArc = node;
          rArc = node.N;
        } else {
          lArc = rArc = node;
        }
        break;
      }
    }
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__Cell__["c" /* createCell */])(site);
  var newArc = createBeach(site);
  __WEBPACK_IMPORTED_MODULE_4__Diagram__["a" /* beaches */].insert(lArc, newArc);

  if (!lArc && !rArc) return;

  if (lArc === rArc) {
    Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(lArc);
    rArc = createBeach(lArc.site);
    __WEBPACK_IMPORTED_MODULE_4__Diagram__["a" /* beaches */].insert(newArc, rArc);
    newArc.edge = rArc.edge = Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" /* createEdge */])(lArc.site, newArc.site);
    Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* attachCircle */])(lArc);
    Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* attachCircle */])(rArc);
    return;
  }

  if (!rArc) { // && lArc
    newArc.edge = Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" /* createEdge */])(lArc.site, newArc.site);
    return;
  }

  // else lArc !== rArc
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(lArc);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(rArc);

  var lSite = lArc.site,
      ax = lSite[0],
      ay = lSite[1],
      bx = site[0] - ax,
      by = site[1] - ay,
      rSite = rArc.site,
      cx = rSite[0] - ax,
      cy = rSite[1] - ay,
      d = 2 * (bx * cy - by * cx),
      hb = bx * bx + by * by,
      hc = cx * cx + cy * cy,
      vertex = [(cy * hb - by * hc) / d + ax, (bx * hc - cx * hb) / d + ay];

  Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["d" /* setEdgeEnd */])(rArc.edge, lSite, rSite, vertex);
  newArc.edge = Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" /* createEdge */])(lSite, site, null, vertex);
  rArc.edge = Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" /* createEdge */])(site, rSite, null, vertex);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* attachCircle */])(lArc);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* attachCircle */])(rArc);
}

function leftBreakPoint(arc, directrix) {
  var site = arc.site,
      rfocx = site[0],
      rfocy = site[1],
      pby2 = rfocy - directrix;

  if (!pby2) return rfocx;

  var lArc = arc.P;
  if (!lArc) return -Infinity;

  site = lArc.site;
  var lfocx = site[0],
      lfocy = site[1],
      plby2 = lfocy - directrix;

  if (!plby2) return lfocx;

  var hl = lfocx - rfocx,
      aby2 = 1 / pby2 - 1 / plby2,
      b = hl / plby2;

  if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;

  return (rfocx + lfocx) / 2;
}

function rightBreakPoint(arc, directrix) {
  var rArc = arc.N;
  if (rArc) return leftBreakPoint(rArc, directrix);
  var site = arc.site;
  return site[1] === directrix ? site[0] : Infinity;
}


/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_zoom__ = __webpack_require__(517);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_zoom__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_transform__ = __webpack_require__(188);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__src_transform__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_transform__["c"]; });




/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dispatch__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_drag__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_interpolate__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_selection__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_transition__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constant__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__event__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__transform__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__noevent__ = __webpack_require__(520);










// Ignore right-click, since that should open the context menu.
function defaultFilter() {
  return !__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].button;
}

function defaultExtent() {
  var e = this, w, h;
  if (e instanceof SVGElement) {
    e = e.ownerSVGElement || e;
    w = e.width.baseVal.value;
    h = e.height.baseVal.value;
  } else {
    w = e.clientWidth;
    h = e.clientHeight;
  }
  return [[0, 0], [w, h]];
}

function defaultTransform() {
  return this.__zoom || __WEBPACK_IMPORTED_MODULE_7__transform__["c" /* identity */];
}

function defaultWheelDelta() {
  return -__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].deltaY * (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].deltaMode ? 120 : 1) / 500;
}

function defaultTouchable() {
  return "ontouchstart" in this;
}

function defaultConstrain(transform, extent, translateExtent) {
  var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0],
      dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0],
      dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1],
      dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
  return transform.translate(
    dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1),
    dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1)
  );
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var filter = defaultFilter,
      extent = defaultExtent,
      constrain = defaultConstrain,
      wheelDelta = defaultWheelDelta,
      touchable = defaultTouchable,
      scaleExtent = [0, Infinity],
      translateExtent = [[-Infinity, -Infinity], [Infinity, Infinity]],
      duration = 250,
      interpolate = __WEBPACK_IMPORTED_MODULE_2_d3_interpolate__["v" /* interpolateZoom */],
      gestures = [],
      listeners = Object(__WEBPACK_IMPORTED_MODULE_0_d3_dispatch__["a" /* dispatch */])("start", "zoom", "end"),
      touchstarting,
      touchending,
      touchDelay = 500,
      wheelDelay = 150,
      clickDistance2 = 0;

  function zoom(selection) {
    selection
        .property("__zoom", defaultTransform)
        .on("wheel.zoom", wheeled)
        .on("mousedown.zoom", mousedowned)
        .on("dblclick.zoom", dblclicked)
      .filter(touchable)
        .on("touchstart.zoom", touchstarted)
        .on("touchmove.zoom", touchmoved)
        .on("touchend.zoom touchcancel.zoom", touchended)
        .style("touch-action", "none")
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }

  zoom.transform = function(collection, transform) {
    var selection = collection.selection ? collection.selection() : collection;
    selection.property("__zoom", defaultTransform);
    if (collection !== selection) {
      schedule(collection, transform);
    } else {
      selection.interrupt().each(function() {
        gesture(this, arguments)
            .start()
            .zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform)
            .end();
      });
    }
  };

  zoom.scaleBy = function(selection, k) {
    zoom.scaleTo(selection, function() {
      var k0 = this.__zoom.k,
          k1 = typeof k === "function" ? k.apply(this, arguments) : k;
      return k0 * k1;
    });
  };

  zoom.scaleTo = function(selection, k) {
    zoom.transform(selection, function() {
      var e = extent.apply(this, arguments),
          t0 = this.__zoom,
          p0 = centroid(e),
          p1 = t0.invert(p0),
          k1 = typeof k === "function" ? k.apply(this, arguments) : k;
      return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
    });
  };

  zoom.translateBy = function(selection, x, y) {
    zoom.transform(selection, function() {
      return constrain(this.__zoom.translate(
        typeof x === "function" ? x.apply(this, arguments) : x,
        typeof y === "function" ? y.apply(this, arguments) : y
      ), extent.apply(this, arguments), translateExtent);
    });
  };

  zoom.translateTo = function(selection, x, y) {
    zoom.transform(selection, function() {
      var e = extent.apply(this, arguments),
          t = this.__zoom,
          p = centroid(e);
      return constrain(__WEBPACK_IMPORTED_MODULE_7__transform__["c" /* identity */].translate(p[0], p[1]).scale(t.k).translate(
        typeof x === "function" ? -x.apply(this, arguments) : -x,
        typeof y === "function" ? -y.apply(this, arguments) : -y
      ), e, translateExtent);
    });
  };

  function scale(transform, k) {
    k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
    return k === transform.k ? transform : new __WEBPACK_IMPORTED_MODULE_7__transform__["a" /* Transform */](k, transform.x, transform.y);
  }

  function translate(transform, p0, p1) {
    var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
    return x === transform.x && y === transform.y ? transform : new __WEBPACK_IMPORTED_MODULE_7__transform__["a" /* Transform */](transform.k, x, y);
  }

  function centroid(extent) {
    return [(+extent[0][0] + +extent[1][0]) / 2, (+extent[0][1] + +extent[1][1]) / 2];
  }

  function schedule(transition, transform, center) {
    transition
        .on("start.zoom", function() { gesture(this, arguments).start(); })
        .on("interrupt.zoom end.zoom", function() { gesture(this, arguments).end(); })
        .tween("zoom", function() {
          var that = this,
              args = arguments,
              g = gesture(that, args),
              e = extent.apply(that, args),
              p = center || centroid(e),
              w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]),
              a = that.__zoom,
              b = typeof transform === "function" ? transform.apply(that, args) : transform,
              i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
          return function(t) {
            if (t === 1) t = b; // Avoid rounding error on end.
            else { var l = i(t), k = w / l[2]; t = new __WEBPACK_IMPORTED_MODULE_7__transform__["a" /* Transform */](k, p[0] - l[0] * k, p[1] - l[1] * k); }
            g.zoom(null, t);
          };
        });
  }

  function gesture(that, args) {
    for (var i = 0, n = gestures.length, g; i < n; ++i) {
      if ((g = gestures[i]).that === that) {
        return g;
      }
    }
    return new Gesture(that, args);
  }

  function Gesture(that, args) {
    this.that = that;
    this.args = args;
    this.index = -1;
    this.active = 0;
    this.extent = extent.apply(that, args);
  }

  Gesture.prototype = {
    start: function() {
      if (++this.active === 1) {
        this.index = gestures.push(this) - 1;
        this.emit("start");
      }
      return this;
    },
    zoom: function(key, transform) {
      if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
      if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
      if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
      this.that.__zoom = transform;
      this.emit("zoom");
      return this;
    },
    end: function() {
      if (--this.active === 0) {
        gestures.splice(this.index, 1);
        this.index = -1;
        this.emit("end");
      }
      return this;
    },
    emit: function(type) {
      Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["d" /* customEvent */])(new __WEBPACK_IMPORTED_MODULE_6__event__["a" /* default */](zoom, type, this.that.__zoom), listeners.apply, listeners, [type, this.that, this.args]);
    }
  };

  function wheeled() {
    if (!filter.apply(this, arguments)) return;
    var g = gesture(this, arguments),
        t = this.__zoom,
        k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))),
        p = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["h" /* mouse */])(this);

    // If the mouse is in the same location as before, reuse it.
    // If there were recent wheel events, reset the wheel idle timeout.
    if (g.wheel) {
      if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) {
        g.mouse[1] = t.invert(g.mouse[0] = p);
      }
      clearTimeout(g.wheel);
    }

    // If this wheel event won’t trigger a transform change, ignore it.
    else if (t.k === k) return;

    // Otherwise, capture the mouse point and location at the start.
    else {
      g.mouse = [p, t.invert(p)];
      Object(__WEBPACK_IMPORTED_MODULE_4_d3_transition__["b" /* interrupt */])(this);
      g.start();
    }

    Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["a" /* default */])();
    g.wheel = setTimeout(wheelidled, wheelDelay);
    g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));

    function wheelidled() {
      g.wheel = null;
      g.end();
    }
  }

  function mousedowned() {
    if (touchending || !filter.apply(this, arguments)) return;
    var g = gesture(this, arguments),
        v = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["k" /* select */])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true),
        p = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["h" /* mouse */])(this),
        x0 = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].clientX,
        y0 = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].clientY;

    Object(__WEBPACK_IMPORTED_MODULE_1_d3_drag__["b" /* dragDisable */])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].view);
    Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["b" /* nopropagation */])();
    g.mouse = [p, this.__zoom.invert(p)];
    Object(__WEBPACK_IMPORTED_MODULE_4_d3_transition__["b" /* interrupt */])(this);
    g.start();

    function mousemoved() {
      Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["a" /* default */])();
      if (!g.moved) {
        var dx = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].clientX - x0, dy = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].clientY - y0;
        g.moved = dx * dx + dy * dy > clickDistance2;
      }
      g.zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["h" /* mouse */])(g.that), g.mouse[1]), g.extent, translateExtent));
    }

    function mouseupped() {
      v.on("mousemove.zoom mouseup.zoom", null);
      Object(__WEBPACK_IMPORTED_MODULE_1_d3_drag__["c" /* dragEnable */])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].view, g.moved);
      Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["a" /* default */])();
      g.end();
    }
  }

  function dblclicked() {
    if (!filter.apply(this, arguments)) return;
    var t0 = this.__zoom,
        p0 = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["h" /* mouse */])(this),
        p1 = t0.invert(p0),
        k1 = t0.k * (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].shiftKey ? 0.5 : 2),
        t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, arguments), translateExtent);

    Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["a" /* default */])();
    if (duration > 0) Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["k" /* select */])(this).transition().duration(duration).call(schedule, t1, p0);
    else Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["k" /* select */])(this).call(zoom.transform, t1);
  }

  function touchstarted() {
    if (!filter.apply(this, arguments)) return;
    var g = gesture(this, arguments),
        touches = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].changedTouches,
        started,
        n = touches.length, i, t, p;

    Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["b" /* nopropagation */])();
    for (i = 0; i < n; ++i) {
      t = touches[i], p = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["q" /* touch */])(this, touches, t.identifier);
      p = [p, this.__zoom.invert(p), t.identifier];
      if (!g.touch0) g.touch0 = p, started = true;
      else if (!g.touch1) g.touch1 = p;
    }

    // If this is a dbltap, reroute to the (optional) dblclick.zoom handler.
    if (touchstarting) {
      touchstarting = clearTimeout(touchstarting);
      if (!g.touch1) {
        g.end();
        p = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["k" /* select */])(this).on("dblclick.zoom");
        if (p) p.apply(this, arguments);
        return;
      }
    }

    if (started) {
      touchstarting = setTimeout(function() { touchstarting = null; }, touchDelay);
      Object(__WEBPACK_IMPORTED_MODULE_4_d3_transition__["b" /* interrupt */])(this);
      g.start();
    }
  }

  function touchmoved() {
    var g = gesture(this, arguments),
        touches = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].changedTouches,
        n = touches.length, i, t, p, l;

    Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["a" /* default */])();
    if (touchstarting) touchstarting = clearTimeout(touchstarting);
    for (i = 0; i < n; ++i) {
      t = touches[i], p = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["q" /* touch */])(this, touches, t.identifier);
      if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
      else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
    }
    t = g.that.__zoom;
    if (g.touch1) {
      var p0 = g.touch0[0], l0 = g.touch0[1],
          p1 = g.touch1[0], l1 = g.touch1[1],
          dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp,
          dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
      t = scale(t, Math.sqrt(dp / dl));
      p = [(p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2];
      l = [(l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2];
    }
    else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
    else return;
    g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
  }

  function touchended() {
    var g = gesture(this, arguments),
        touches = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].changedTouches,
        n = touches.length, i, t;

    Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["b" /* nopropagation */])();
    if (touchending) clearTimeout(touchending);
    touchending = setTimeout(function() { touchending = null; }, touchDelay);
    for (i = 0; i < n; ++i) {
      t = touches[i];
      if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
      else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
    }
    if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
    if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
    else g.end();
  }

  zoom.wheelDelta = function(_) {
    return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_5__constant__["a" /* default */])(+_), zoom) : wheelDelta;
  };

  zoom.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_5__constant__["a" /* default */])(!!_), zoom) : filter;
  };

  zoom.touchable = function(_) {
    return arguments.length ? (touchable = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_5__constant__["a" /* default */])(!!_), zoom) : touchable;
  };

  zoom.extent = function(_) {
    return arguments.length ? (extent = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_5__constant__["a" /* default */])([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), zoom) : extent;
  };

  zoom.scaleExtent = function(_) {
    return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [scaleExtent[0], scaleExtent[1]];
  };

  zoom.translateExtent = function(_) {
    return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [[translateExtent[0][0], translateExtent[0][1]], [translateExtent[1][0], translateExtent[1][1]]];
  };

  zoom.constrain = function(_) {
    return arguments.length ? (constrain = _, zoom) : constrain;
  };

  zoom.duration = function(_) {
    return arguments.length ? (duration = +_, zoom) : duration;
  };

  zoom.interpolate = function(_) {
    return arguments.length ? (interpolate = _, zoom) : interpolate;
  };

  zoom.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? zoom : value;
  };

  zoom.clickDistance = function(_) {
    return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
  };

  return zoom;
});


/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ZoomEvent;
function ZoomEvent(target, type, transform) {
  this.target = target;
  this.type = type;
  this.transform = transform;
}


/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = nopropagation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(1);


function nopropagation() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["e" /* event */].stopImmediatePropagation();
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["e" /* event */].preventDefault();
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["e" /* event */].stopImmediatePropagation();
});


/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_messaging__ = __webpack_require__(524);


console.log("firebase ", __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a);
if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('./sw.js').then(function (success) {
        console.log("sw register successfully");
        callFirebase();
    }, function (error) {
        console.log(" not register successfully", error);
    });
} else {
    console.log("not present");
}
__WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.initializeApp({
    apiKey: "AIzaSyDAaRa-gLsgzcxbfHxaqnF3VuuBg5Dy3gg",
    authDomain: "imcl-lco-portal.firebaseapp.com",
    databaseURL: "https://imcl-lco-portal.firebaseio.com",
    projectId: "imcl-lco-portal",
    storageBucket: "imcl-lco-portal.appspot.com",
    messagingSenderId: "855346994430",
    appId: "1:855346994430:web:5dcf825fa8a9c1a3bbd9af",
    measurementId: "G-ZXG0PE26ZX"
});
function callFirebase() {
    console.log('callFirebase');
    var tokengen = "";
    __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.messaging().requestPermission().then(function () {
        return __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.messaging().getToken();
    }).then(function (token) {
        console.log("token", token);
        localStorage.setItem("token", token);
        tokengen = token;
    }).catch(function (error) {
        console.log('[App | initAWSMA | Notification | requestPermission | error ]', error);
    });

    var messageNotification = "";
    var createdDate = "";
    var imagePath = "";
    navigator.serviceWorker.addEventListener("message", function (message) {
        navigator.serviceWorker.ready.then(function (registration) {
            console.log(message);

            console.log("message data ", message);
            messageNotification = message.data['firebase-messaging-msg-data'].notification.body;
            createdDate = message.data['firebase-messaging-msg-data'].notification.createddate;
            imagePath = message.data['firebase-messaging-msg-data'].notification.image_url;

            var notificationTitle = message.data['firebase-messaging-msg-data'].notification.title;
            var notificationOptions = {
                body: messageNotification
            };

            if (localStorage.getItem("fcm-data")) {
                var getLocalFcm = JSON.parse(localStorage.getItem("fcm-data"));
                console.log(getLocalFcm);
                getLocalFcm.push({ 'message': messageNotification, 'createddate': createdDate, "imagepath": imagePath });
                localStorage.setItem("fcm-data", JSON.stringify(getLocalFcm));
            } else {
                var localfcm = [{ 'message': messageNotification }];
                localStorage.setItem("fcm-data", JSON.stringify(localfcm));
            }

            registration.showNotification(notificationTitle, notificationOptions);
        });
    });
}

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var firebase = __webpack_require__(98);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var firebase__default = /*#__PURE__*/_interopDefaultLegacy(firebase);

var name = "firebase";
var version = "7.24.0";

/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
firebase__default['default'].registerVersion(name, version, 'app');

module.exports = firebase__default['default'];
//# sourceMappingURL=index.cjs.js.map


/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LogLevel", function() { return LogLevel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Logger", function() { return Logger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLogLevel", function() { return setLogLevel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setUserLogHandler", function() { return setUserLogHandler; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a;
/**
 * A container for all of the Logger instances
 */
var instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})(LogLevel || (LogLevel = {}));
var levelStringToEnum = {
    'debug': LogLevel.DEBUG,
    'verbose': LogLevel.VERBOSE,
    'info': LogLevel.INFO,
    'warn': LogLevel.WARN,
    'error': LogLevel.ERROR,
    'silent': LogLevel.SILENT
};
/**
 * The default log level
 */
var defaultLogLevel = LogLevel.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */
var ConsoleMethod = (_a = {},
    _a[LogLevel.DEBUG] = 'log',
    _a[LogLevel.VERBOSE] = 'log',
    _a[LogLevel.INFO] = 'info',
    _a[LogLevel.WARN] = 'warn',
    _a[LogLevel.ERROR] = 'error',
    _a);
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */
var defaultLogHandler = function (instance, logType) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    if (logType < instance.logLevel) {
        return;
    }
    var now = new Date().toISOString();
    var method = ConsoleMethod[logType];
    if (method) {
        console[method].apply(console, __spreadArrays(["[" + now + "]  " + instance.name + ":"], args));
    }
    else {
        throw new Error("Attempted to log a message with an invalid logType (value: " + logType + ")");
    }
};
var Logger = /** @class */ (function () {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */
    function Logger(name) {
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */
        this._logLevel = defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */
        this._logHandler = defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */
        this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */
        instances.push(this);
    }
    Object.defineProperty(Logger.prototype, "logLevel", {
        get: function () {
            return this._logLevel;
        },
        set: function (val) {
            if (!(val in LogLevel)) {
                throw new TypeError("Invalid value \"" + val + "\" assigned to `logLevel`");
            }
            this._logLevel = val;
        },
        enumerable: false,
        configurable: true
    });
    // Workaround for setter/getter having to be the same type.
    Logger.prototype.setLogLevel = function (val) {
        this._logLevel = typeof val === 'string' ? levelStringToEnum[val] : val;
    };
    Object.defineProperty(Logger.prototype, "logHandler", {
        get: function () {
            return this._logHandler;
        },
        set: function (val) {
            if (typeof val !== 'function') {
                throw new TypeError('Value assigned to `logHandler` must be a function');
            }
            this._logHandler = val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Logger.prototype, "userLogHandler", {
        get: function () {
            return this._userLogHandler;
        },
        set: function (val) {
            this._userLogHandler = val;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * The functions below are all based on the `console` interface
     */
    Logger.prototype.debug = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._userLogHandler && this._userLogHandler.apply(this, __spreadArrays([this, LogLevel.DEBUG], args));
        this._logHandler.apply(this, __spreadArrays([this, LogLevel.DEBUG], args));
    };
    Logger.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._userLogHandler && this._userLogHandler.apply(this, __spreadArrays([this, LogLevel.VERBOSE], args));
        this._logHandler.apply(this, __spreadArrays([this, LogLevel.VERBOSE], args));
    };
    Logger.prototype.info = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._userLogHandler && this._userLogHandler.apply(this, __spreadArrays([this, LogLevel.INFO], args));
        this._logHandler.apply(this, __spreadArrays([this, LogLevel.INFO], args));
    };
    Logger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._userLogHandler && this._userLogHandler.apply(this, __spreadArrays([this, LogLevel.WARN], args));
        this._logHandler.apply(this, __spreadArrays([this, LogLevel.WARN], args));
    };
    Logger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._userLogHandler && this._userLogHandler.apply(this, __spreadArrays([this, LogLevel.ERROR], args));
        this._logHandler.apply(this, __spreadArrays([this, LogLevel.ERROR], args));
    };
    return Logger;
}());
function setLogLevel(level) {
    instances.forEach(function (inst) {
        inst.setLogLevel(level);
    });
}
function setUserLogHandler(logCallback, options) {
    var _loop_1 = function (instance) {
        var customLogLevel = null;
        if (options && options.level) {
            customLogLevel = levelStringToEnum[options.level];
        }
        if (logCallback === null) {
            instance.userLogHandler = null;
        }
        else {
            instance.userLogHandler = function (instance, level) {
                var args = [];
                for (var _i = 2; _i < arguments.length; _i++) {
                    args[_i - 2] = arguments[_i];
                }
                var message = args
                    .map(function (arg) {
                    if (arg == null) {
                        return null;
                    }
                    else if (typeof arg === 'string') {
                        return arg;
                    }
                    else if (typeof arg === 'number' || typeof arg === 'boolean') {
                        return arg.toString();
                    }
                    else if (arg instanceof Error) {
                        return arg.message;
                    }
                    else {
                        try {
                            return JSON.stringify(arg);
                        }
                        catch (ignored) {
                            return null;
                        }
                    }
                })
                    .filter(function (arg) { return arg; })
                    .join(' ');
                if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) {
                    logCallback({
                        level: LogLevel[level].toLowerCase(),
                        message: message,
                        args: args,
                        type: instance.name
                    });
                }
            };
        }
    };
    for (var _i = 0, instances_1 = instances; _i < instances_1.length; _i++) {
        var instance = instances_1[_i];
        _loop_1(instance);
    }
}


//# sourceMappingURL=index.esm.js.map


/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_messaging__ = __webpack_require__(525);

//# sourceMappingURL=index.esm.js.map


/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_installations__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase_component__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__firebase_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase_util__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__firebase_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tslib__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_idb__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_idb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_idb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__firebase_app__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__firebase_app__);







/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a;
var ERROR_MAP = (_a = {},
    _a["missing-app-config-values" /* MISSING_APP_CONFIG_VALUES */] = 'Missing App configuration value: "{$valueName}"',
    _a["only-available-in-window" /* AVAILABLE_IN_WINDOW */] = 'This method is available in a Window context.',
    _a["only-available-in-sw" /* AVAILABLE_IN_SW */] = 'This method is available in a service worker context.',
    _a["permission-default" /* PERMISSION_DEFAULT */] = 'The notification permission was not granted and dismissed instead.',
    _a["permission-blocked" /* PERMISSION_BLOCKED */] = 'The notification permission was not granted and blocked instead.',
    _a["unsupported-browser" /* UNSUPPORTED_BROWSER */] = "This browser doesn't support the API's required to use the firebase SDK.",
    _a["failed-service-worker-registration" /* FAILED_DEFAULT_REGISTRATION */] = 'We are unable to register the default service worker. {$browserErrorMessage}',
    _a["token-subscribe-failed" /* TOKEN_SUBSCRIBE_FAILED */] = 'A problem occurred while subscribing the user to FCM: {$errorInfo}',
    _a["token-subscribe-no-token" /* TOKEN_SUBSCRIBE_NO_TOKEN */] = 'FCM returned no token when subscribing the user to push.',
    _a["token-unsubscribe-failed" /* TOKEN_UNSUBSCRIBE_FAILED */] = 'A problem occurred while unsubscribing the ' +
        'user from FCM: {$errorInfo}',
    _a["token-update-failed" /* TOKEN_UPDATE_FAILED */] = 'A problem occurred while updating the user from FCM: {$errorInfo}',
    _a["token-update-no-token" /* TOKEN_UPDATE_NO_TOKEN */] = 'FCM returned no token when updating the user to push.',
    _a["use-sw-after-get-token" /* USE_SW_AFTER_GET_TOKEN */] = 'The useServiceWorker() method may only be called once and must be ' +
        'called before calling getToken() to ensure your service worker is used.',
    _a["invalid-sw-registration" /* INVALID_SW_REGISTRATION */] = 'The input to useServiceWorker() must be a ServiceWorkerRegistration.',
    _a["invalid-bg-handler" /* INVALID_BG_HANDLER */] = 'The input to setBackgroundMessageHandler() must be a function.',
    _a["invalid-vapid-key" /* INVALID_VAPID_KEY */] = 'The public VAPID key must be a string.',
    _a["use-vapid-key-after-get-token" /* USE_VAPID_KEY_AFTER_GET_TOKEN */] = 'The usePublicVapidKey() method may only be called once and must be ' +
        'called before calling getToken() to ensure your VAPID key is used.',
    _a);
var ERROR_FACTORY = new __WEBPACK_IMPORTED_MODULE_2__firebase_util__["ErrorFactory"]('messaging', 'Messaging', ERROR_MAP);

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DEFAULT_SW_PATH = '/firebase-messaging-sw.js';
var DEFAULT_SW_SCOPE = '/firebase-cloud-messaging-push-scope';
var DEFAULT_VAPID_KEY = 'BDOU99-h67HcA6JeFXHbSNMu7e2yNNu3RzoMj8TM4W88jITfq7ZmPvIM1Iv-4_l2LxQcYwhqby2xGpWwzjfAnG4';
var ENDPOINT = 'https://fcmregistrations.googleapis.com/v1';
/** Key of FCM Payload in Notification's data field. */
var FCM_MSG = 'FCM_MSG';
var CONSOLE_CAMPAIGN_ID = 'google.c.a.c_id';
var CONSOLE_CAMPAIGN_NAME = 'google.c.a.c_l';
var CONSOLE_CAMPAIGN_TIME = 'google.c.a.ts';
/** Set to '1' if Analytics is enabled for the campaign */
var CONSOLE_CAMPAIGN_ANALYTICS_ENABLED = 'google.c.a.e';
var TAG = 'FirebaseMessaging: ';

/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the License
 * is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
 * or implied. See the License for the specific language governing permissions and limitations under
 * the License.
 */
var MessageType;
(function (MessageType) {
    MessageType["PUSH_RECEIVED"] = "push-received";
    MessageType["NOTIFICATION_CLICKED"] = "notification-clicked";
})(MessageType || (MessageType = {}));

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function arrayToBase64(array) {
    var uint8Array = new Uint8Array(array);
    var base64String = btoa(String.fromCharCode.apply(String, Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__spread"])(uint8Array)));
    return base64String.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
function base64ToArray(base64String) {
    var padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    var base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');
    var rawData = atob(base64);
    var outputArray = new Uint8Array(rawData.length);
    for (var i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var OLD_DB_NAME = 'fcm_token_details_db';
/**
 * The last DB version of 'fcm_token_details_db' was 4. This is one higher, so that the upgrade
 * callback is called for all versions of the old DB.
 */
var OLD_DB_VERSION = 5;
var OLD_OBJECT_STORE_NAME = 'fcm_token_object_Store';
function migrateOldDatabase(senderId) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var databases, dbNames, tokenDetails, db;
        var _this = this;
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!('databases' in indexedDB)) return [3 /*break*/, 2];
                    return [4 /*yield*/, indexedDB.databases()];
                case 1:
                    databases = _a.sent();
                    dbNames = databases.map(function (db) { return db.name; });
                    if (!dbNames.includes(OLD_DB_NAME)) {
                        // old DB didn't exist, no need to open.
                        return [2 /*return*/, null];
                    }
                    _a.label = 2;
                case 2:
                    tokenDetails = null;
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_4_idb__["openDb"])(OLD_DB_NAME, OLD_DB_VERSION, function (db) { return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(_this, void 0, void 0, function () {
                            var objectStore, value, oldDetails, oldDetails, oldDetails;
                            var _a;
                            return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        if (db.oldVersion < 2) {
                                            // Database too old, skip migration.
                                            return [2 /*return*/];
                                        }
                                        if (!db.objectStoreNames.contains(OLD_OBJECT_STORE_NAME)) {
                                            // Database did not exist. Nothing to do.
                                            return [2 /*return*/];
                                        }
                                        objectStore = db.transaction.objectStore(OLD_OBJECT_STORE_NAME);
                                        return [4 /*yield*/, objectStore.index('fcmSenderId').get(senderId)];
                                    case 1:
                                        value = _b.sent();
                                        return [4 /*yield*/, objectStore.clear()];
                                    case 2:
                                        _b.sent();
                                        if (!value) {
                                            // No entry in the database, nothing to migrate.
                                            return [2 /*return*/];
                                        }
                                        if (db.oldVersion === 2) {
                                            oldDetails = value;
                                            if (!oldDetails.auth || !oldDetails.p256dh || !oldDetails.endpoint) {
                                                return [2 /*return*/];
                                            }
                                            tokenDetails = {
                                                token: oldDetails.fcmToken,
                                                createTime: (_a = oldDetails.createTime) !== null && _a !== void 0 ? _a : Date.now(),
                                                subscriptionOptions: {
                                                    auth: oldDetails.auth,
                                                    p256dh: oldDetails.p256dh,
                                                    endpoint: oldDetails.endpoint,
                                                    swScope: oldDetails.swScope,
                                                    vapidKey: typeof oldDetails.vapidKey === 'string'
                                                        ? oldDetails.vapidKey
                                                        : arrayToBase64(oldDetails.vapidKey)
                                                }
                                            };
                                        }
                                        else if (db.oldVersion === 3) {
                                            oldDetails = value;
                                            tokenDetails = {
                                                token: oldDetails.fcmToken,
                                                createTime: oldDetails.createTime,
                                                subscriptionOptions: {
                                                    auth: arrayToBase64(oldDetails.auth),
                                                    p256dh: arrayToBase64(oldDetails.p256dh),
                                                    endpoint: oldDetails.endpoint,
                                                    swScope: oldDetails.swScope,
                                                    vapidKey: arrayToBase64(oldDetails.vapidKey)
                                                }
                                            };
                                        }
                                        else if (db.oldVersion === 4) {
                                            oldDetails = value;
                                            tokenDetails = {
                                                token: oldDetails.fcmToken,
                                                createTime: oldDetails.createTime,
                                                subscriptionOptions: {
                                                    auth: arrayToBase64(oldDetails.auth),
                                                    p256dh: arrayToBase64(oldDetails.p256dh),
                                                    endpoint: oldDetails.endpoint,
                                                    swScope: oldDetails.swScope,
                                                    vapidKey: arrayToBase64(oldDetails.vapidKey)
                                                }
                                            };
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                case 3:
                    db = _a.sent();
                    db.close();
                    // Delete all old databases.
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_4_idb__["deleteDb"])(OLD_DB_NAME)];
                case 4:
                    // Delete all old databases.
                    _a.sent();
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_4_idb__["deleteDb"])('fcm_vapid_details_db')];
                case 5:
                    _a.sent();
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_4_idb__["deleteDb"])('undefined')];
                case 6:
                    _a.sent();
                    return [2 /*return*/, checkTokenDetails(tokenDetails) ? tokenDetails : null];
            }
        });
    });
}
function checkTokenDetails(tokenDetails) {
    if (!tokenDetails || !tokenDetails.subscriptionOptions) {
        return false;
    }
    var subscriptionOptions = tokenDetails.subscriptionOptions;
    return (typeof tokenDetails.createTime === 'number' &&
        tokenDetails.createTime > 0 &&
        typeof tokenDetails.token === 'string' &&
        tokenDetails.token.length > 0 &&
        typeof subscriptionOptions.auth === 'string' &&
        subscriptionOptions.auth.length > 0 &&
        typeof subscriptionOptions.p256dh === 'string' &&
        subscriptionOptions.p256dh.length > 0 &&
        typeof subscriptionOptions.endpoint === 'string' &&
        subscriptionOptions.endpoint.length > 0 &&
        typeof subscriptionOptions.swScope === 'string' &&
        subscriptionOptions.swScope.length > 0 &&
        typeof subscriptionOptions.vapidKey === 'string' &&
        subscriptionOptions.vapidKey.length > 0);
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Exported for tests.
var DATABASE_NAME = 'firebase-messaging-database';
var DATABASE_VERSION = 1;
var OBJECT_STORE_NAME = 'firebase-messaging-store';
var dbPromise = null;
function getDbPromise() {
    if (!dbPromise) {
        dbPromise = Object(__WEBPACK_IMPORTED_MODULE_4_idb__["openDb"])(DATABASE_NAME, DATABASE_VERSION, function (upgradeDb) {
            // We don't use 'break' in this switch statement, the fall-through behavior is what we want,
            // because if there are multiple versions between the old version and the current version, we
            // want ALL the migrations that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch (upgradeDb.oldVersion) {
                case 0:
                    upgradeDb.createObjectStore(OBJECT_STORE_NAME);
            }
        });
    }
    return dbPromise;
}
/** Gets record(s) from the objectStore that match the given key. */
function dbGet(firebaseDependencies) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var key, db, tokenDetails, oldTokenDetails;
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    key = getKey(firebaseDependencies);
                    return [4 /*yield*/, getDbPromise()];
                case 1:
                    db = _a.sent();
                    return [4 /*yield*/, db
                            .transaction(OBJECT_STORE_NAME)
                            .objectStore(OBJECT_STORE_NAME)
                            .get(key)];
                case 2:
                    tokenDetails = _a.sent();
                    if (!tokenDetails) return [3 /*break*/, 3];
                    return [2 /*return*/, tokenDetails];
                case 3: return [4 /*yield*/, migrateOldDatabase(firebaseDependencies.appConfig.senderId)];
                case 4:
                    oldTokenDetails = _a.sent();
                    if (!oldTokenDetails) return [3 /*break*/, 6];
                    return [4 /*yield*/, dbSet(firebaseDependencies, oldTokenDetails)];
                case 5:
                    _a.sent();
                    return [2 /*return*/, oldTokenDetails];
                case 6: return [2 /*return*/];
            }
        });
    });
}
/** Assigns or overwrites the record for the given key with the given value. */
function dbSet(firebaseDependencies, tokenDetails) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var key, db, tx;
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    key = getKey(firebaseDependencies);
                    return [4 /*yield*/, getDbPromise()];
                case 1:
                    db = _a.sent();
                    tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
                    return [4 /*yield*/, tx.objectStore(OBJECT_STORE_NAME).put(tokenDetails, key)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, tx.complete];
                case 3:
                    _a.sent();
                    return [2 /*return*/, tokenDetails];
            }
        });
    });
}
/** Removes record(s) from the objectStore that match the given key. */
function dbRemove(firebaseDependencies) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var key, db, tx;
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    key = getKey(firebaseDependencies);
                    return [4 /*yield*/, getDbPromise()];
                case 1:
                    db = _a.sent();
                    tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
                    return [4 /*yield*/, tx.objectStore(OBJECT_STORE_NAME).delete(key)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, tx.complete];
                case 3:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function getKey(_a) {
    var appConfig = _a.appConfig;
    return appConfig.appId;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function requestGetToken(firebaseDependencies, subscriptionOptions) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var headers, body, subscribeOptions, responseData, response, err_1, message;
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getHeaders(firebaseDependencies)];
                case 1:
                    headers = _a.sent();
                    body = getBody(subscriptionOptions);
                    subscribeOptions = {
                        method: 'POST',
                        headers: headers,
                        body: JSON.stringify(body)
                    };
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 5, , 6]);
                    return [4 /*yield*/, fetch(getEndpoint(firebaseDependencies.appConfig), subscribeOptions)];
                case 3:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 4:
                    responseData = _a.sent();
                    return [3 /*break*/, 6];
                case 5:
                    err_1 = _a.sent();
                    throw ERROR_FACTORY.create("token-subscribe-failed" /* TOKEN_SUBSCRIBE_FAILED */, {
                        errorInfo: err_1
                    });
                case 6:
                    if (responseData.error) {
                        message = responseData.error.message;
                        throw ERROR_FACTORY.create("token-subscribe-failed" /* TOKEN_SUBSCRIBE_FAILED */, {
                            errorInfo: message
                        });
                    }
                    if (!responseData.token) {
                        throw ERROR_FACTORY.create("token-subscribe-no-token" /* TOKEN_SUBSCRIBE_NO_TOKEN */);
                    }
                    return [2 /*return*/, responseData.token];
            }
        });
    });
}
function requestUpdateToken(firebaseDependencies, tokenDetails) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var headers, body, updateOptions, responseData, response, err_2, message;
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getHeaders(firebaseDependencies)];
                case 1:
                    headers = _a.sent();
                    body = getBody(tokenDetails.subscriptionOptions);
                    updateOptions = {
                        method: 'PATCH',
                        headers: headers,
                        body: JSON.stringify(body)
                    };
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 5, , 6]);
                    return [4 /*yield*/, fetch(getEndpoint(firebaseDependencies.appConfig) + "/" + tokenDetails.token, updateOptions)];
                case 3:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 4:
                    responseData = _a.sent();
                    return [3 /*break*/, 6];
                case 5:
                    err_2 = _a.sent();
                    throw ERROR_FACTORY.create("token-update-failed" /* TOKEN_UPDATE_FAILED */, {
                        errorInfo: err_2
                    });
                case 6:
                    if (responseData.error) {
                        message = responseData.error.message;
                        throw ERROR_FACTORY.create("token-update-failed" /* TOKEN_UPDATE_FAILED */, {
                            errorInfo: message
                        });
                    }
                    if (!responseData.token) {
                        throw ERROR_FACTORY.create("token-update-no-token" /* TOKEN_UPDATE_NO_TOKEN */);
                    }
                    return [2 /*return*/, responseData.token];
            }
        });
    });
}
function requestDeleteToken(firebaseDependencies, token) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var headers, unsubscribeOptions, response, responseData, message, err_3;
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getHeaders(firebaseDependencies)];
                case 1:
                    headers = _a.sent();
                    unsubscribeOptions = {
                        method: 'DELETE',
                        headers: headers
                    };
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 5, , 6]);
                    return [4 /*yield*/, fetch(getEndpoint(firebaseDependencies.appConfig) + "/" + token, unsubscribeOptions)];
                case 3:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 4:
                    responseData = _a.sent();
                    if (responseData.error) {
                        message = responseData.error.message;
                        throw ERROR_FACTORY.create("token-unsubscribe-failed" /* TOKEN_UNSUBSCRIBE_FAILED */, {
                            errorInfo: message
                        });
                    }
                    return [3 /*break*/, 6];
                case 5:
                    err_3 = _a.sent();
                    throw ERROR_FACTORY.create("token-unsubscribe-failed" /* TOKEN_UNSUBSCRIBE_FAILED */, {
                        errorInfo: err_3
                    });
                case 6: return [2 /*return*/];
            }
        });
    });
}
function getEndpoint(_a) {
    var projectId = _a.projectId;
    return ENDPOINT + "/projects/" + projectId + "/registrations";
}
function getHeaders(_a) {
    var appConfig = _a.appConfig, installations = _a.installations;
    return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var authToken;
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, installations.getToken()];
                case 1:
                    authToken = _b.sent();
                    return [2 /*return*/, new Headers({
                            'Content-Type': 'application/json',
                            Accept: 'application/json',
                            'x-goog-api-key': appConfig.apiKey,
                            'x-goog-firebase-installations-auth': "FIS " + authToken
                        })];
            }
        });
    });
}
function getBody(_a) {
    var p256dh = _a.p256dh, auth = _a.auth, endpoint = _a.endpoint, vapidKey = _a.vapidKey;
    var body = {
        web: {
            endpoint: endpoint,
            auth: auth,
            p256dh: p256dh
        }
    };
    if (vapidKey !== DEFAULT_VAPID_KEY) {
        body.web.applicationPubKey = vapidKey;
    }
    return body;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** UpdateRegistration will be called once every week. */
var TOKEN_EXPIRATION_MS = 7 * 24 * 60 * 60 * 1000; // 7 days
function getToken(firebaseDependencies, swRegistration, vapidKey) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var pushSubscription, tokenDetails, subscriptionOptions, e_1;
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (Notification.permission !== 'granted') {
                        throw ERROR_FACTORY.create("permission-blocked" /* PERMISSION_BLOCKED */);
                    }
                    return [4 /*yield*/, getPushSubscription(swRegistration, vapidKey)];
                case 1:
                    pushSubscription = _a.sent();
                    return [4 /*yield*/, dbGet(firebaseDependencies)];
                case 2:
                    tokenDetails = _a.sent();
                    subscriptionOptions = {
                        vapidKey: vapidKey,
                        swScope: swRegistration.scope,
                        endpoint: pushSubscription.endpoint,
                        auth: arrayToBase64(pushSubscription.getKey('auth')),
                        p256dh: arrayToBase64(pushSubscription.getKey('p256dh'))
                    };
                    if (!!tokenDetails) return [3 /*break*/, 3];
                    // No token, get a new one.
                    return [2 /*return*/, getNewToken(firebaseDependencies, subscriptionOptions)];
                case 3:
                    if (!!isTokenValid(tokenDetails.subscriptionOptions, subscriptionOptions)) return [3 /*break*/, 8];
                    _a.label = 4;
                case 4:
                    _a.trys.push([4, 6, , 7]);
                    return [4 /*yield*/, requestDeleteToken(firebaseDependencies, tokenDetails.token)];
                case 5:
                    _a.sent();
                    return [3 /*break*/, 7];
                case 6:
                    e_1 = _a.sent();
                    // Suppress errors because of #2364
                    console.warn(e_1);
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/, getNewToken(firebaseDependencies, subscriptionOptions)];
                case 8:
                    if (Date.now() >= tokenDetails.createTime + TOKEN_EXPIRATION_MS) {
                        // Weekly token refresh
                        return [2 /*return*/, updateToken({
                                token: tokenDetails.token,
                                createTime: Date.now(),
                                subscriptionOptions: subscriptionOptions
                            }, firebaseDependencies, swRegistration)];
                    }
                    else {
                        // Valid token, nothing to do.
                        return [2 /*return*/, tokenDetails.token];
                    }
                case 9: return [2 /*return*/];
            }
        });
    });
}
/**
 * This method deletes the token from the database, unsubscribes the token from FCM, and unregisters
 * the push subscription if it exists.
 */
function deleteToken(firebaseDependencies, swRegistration) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var tokenDetails, pushSubscription;
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dbGet(firebaseDependencies)];
                case 1:
                    tokenDetails = _a.sent();
                    if (!tokenDetails) return [3 /*break*/, 4];
                    return [4 /*yield*/, requestDeleteToken(firebaseDependencies, tokenDetails.token)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, dbRemove(firebaseDependencies)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [4 /*yield*/, swRegistration.pushManager.getSubscription()];
                case 5:
                    pushSubscription = _a.sent();
                    if (pushSubscription) {
                        return [2 /*return*/, pushSubscription.unsubscribe()];
                    }
                    // If there's no SW, consider it a success.
                    return [2 /*return*/, true];
            }
        });
    });
}
function updateToken(tokenDetails, firebaseDependencies, swRegistration) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var updatedToken, updatedTokenDetails, e_2;
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 5]);
                    return [4 /*yield*/, requestUpdateToken(firebaseDependencies, tokenDetails)];
                case 1:
                    updatedToken = _a.sent();
                    updatedTokenDetails = Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__assign"])(Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__assign"])({}, tokenDetails), { token: updatedToken, createTime: Date.now() });
                    return [4 /*yield*/, dbSet(firebaseDependencies, updatedTokenDetails)];
                case 2:
                    _a.sent();
                    return [2 /*return*/, updatedToken];
                case 3:
                    e_2 = _a.sent();
                    return [4 /*yield*/, deleteToken(firebaseDependencies, swRegistration)];
                case 4:
                    _a.sent();
                    throw e_2;
                case 5: return [2 /*return*/];
            }
        });
    });
}
function getNewToken(firebaseDependencies, subscriptionOptions) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var token, tokenDetails;
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, requestGetToken(firebaseDependencies, subscriptionOptions)];
                case 1:
                    token = _a.sent();
                    tokenDetails = {
                        token: token,
                        createTime: Date.now(),
                        subscriptionOptions: subscriptionOptions
                    };
                    return [4 /*yield*/, dbSet(firebaseDependencies, tokenDetails)];
                case 2:
                    _a.sent();
                    return [2 /*return*/, tokenDetails.token];
            }
        });
    });
}
/**
 * Gets a PushSubscription for the current user.
 */
function getPushSubscription(swRegistration, vapidKey) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var subscription;
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, swRegistration.pushManager.getSubscription()];
                case 1:
                    subscription = _a.sent();
                    if (subscription) {
                        return [2 /*return*/, subscription];
                    }
                    return [2 /*return*/, swRegistration.pushManager.subscribe({
                            userVisibleOnly: true,
                            // Chrome <= 75 doesn't support base64-encoded VAPID key. For backward compatibility, VAPID key
                            // submitted to pushManager#subscribe must be of type Uint8Array.
                            applicationServerKey: base64ToArray(vapidKey)
                        })];
            }
        });
    });
}
/**
 * Checks if the saved tokenDetails object matches the configuration provided.
 */
function isTokenValid(dbOptions, currentOptions) {
    var isVapidKeyEqual = currentOptions.vapidKey === dbOptions.vapidKey;
    var isEndpointEqual = currentOptions.endpoint === dbOptions.endpoint;
    var isAuthEqual = currentOptions.auth === dbOptions.auth;
    var isP256dhEqual = currentOptions.p256dh === dbOptions.p256dh;
    return isVapidKeyEqual && isEndpointEqual && isAuthEqual && isP256dhEqual;
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function externalizePayload(internalPayload) {
    var payload = {
        from: internalPayload.from,
        // eslint-disable-next-line camelcase
        collapseKey: internalPayload.collapse_key
    };
    propagateNotificationPayload(payload, internalPayload);
    propagateDataPayload(payload, internalPayload);
    propagateFcmOptions(payload, internalPayload);
    return payload;
}
function propagateNotificationPayload(payload, messagePayloadInternal) {
    if (!messagePayloadInternal.notification) {
        return;
    }
    payload.notification = {};
    var title = messagePayloadInternal.notification.title;
    if (!!title) {
        payload.notification.title = title;
    }
    var body = messagePayloadInternal.notification.body;
    if (!!body) {
        payload.notification.body = body;
    }
    var image = messagePayloadInternal.notification.image;
    if (!!image) {
        payload.notification.image = image;
    }
}
function propagateDataPayload(payload, messagePayloadInternal) {
    if (!messagePayloadInternal.data) {
        return;
    }
    payload.data = messagePayloadInternal.data;
}
function propagateFcmOptions(payload, messagePayloadInternal) {
    if (!messagePayloadInternal.fcmOptions) {
        return;
    }
    payload.fcmOptions = {};
    var link = messagePayloadInternal.fcmOptions.link;
    if (!!link) {
        payload.fcmOptions.link = link;
    }
    // eslint-disable-next-line camelcase
    var analyticsLabel = messagePayloadInternal.fcmOptions.analytics_label;
    if (!!analyticsLabel) {
        payload.fcmOptions.analyticsLabel = analyticsLabel;
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function isConsoleMessage(data) {
    // This message has a campaign ID, meaning it was sent using the Firebase Console.
    return typeof data === 'object' && !!data && CONSOLE_CAMPAIGN_ID in data;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Returns a promise that resolves after given time passes. */
function sleep(ms) {
    return new Promise(function (resolve) {
        setTimeout(resolve, ms);
    });
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var SwController = /** @class */ (function () {
    function SwController(firebaseDependencies) {
        var _this = this;
        this.firebaseDependencies = firebaseDependencies;
        // A boolean flag to determine wether an app is using onBackgroundMessage or
        // setBackgroundMessageHandler. onBackgroundMessage will receive a MessagePayload regardless of if
        // a notification is displayed. Whereas, setBackgroundMessageHandler will swallow the
        // MessagePayload if a NotificationPayload is included.
        this.isOnBackgroundMessageUsed = null;
        this.vapidKey = null;
        this.bgMessageHandler = null;
        self.addEventListener('push', function (e) {
            e.waitUntil(_this.onPush(e));
        });
        self.addEventListener('pushsubscriptionchange', function (e) {
            e.waitUntil(_this.onSubChange(e));
        });
        self.addEventListener('notificationclick', function (e) {
            e.waitUntil(_this.onNotificationClick(e));
        });
    }
    Object.defineProperty(SwController.prototype, "app", {
        get: function () {
            return this.firebaseDependencies.app;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @deprecated. Use onBackgroundMessage(nextOrObserver: NextFn<object> | Observer<object>):
     * Unsubscribe instead.
     *
     * Calling setBackgroundMessageHandler will opt in to some specific behaviors.
     *
     * 1.) If a notification doesn't need to be shown due to a window already being visible, then push
     * messages will be sent to the page. 2.) If a notification needs to be shown, and the message
     * contains no notification data this method will be called and the promise it returns will be
     * passed to event.waitUntil. If you do not set this callback then all push messages will let and
     * the developer can handle them in a their own 'push' event callback
     *
     * @param callback The callback to be called when a push message is received and a notification
     * must be shown. The callback will be given the data from the push message.
     */
    SwController.prototype.setBackgroundMessageHandler = function (callback) {
        this.isOnBackgroundMessageUsed = false;
        if (!callback || typeof callback !== 'function') {
            throw ERROR_FACTORY.create("invalid-bg-handler" /* INVALID_BG_HANDLER */);
        }
        this.bgMessageHandler = callback;
    };
    SwController.prototype.onBackgroundMessage = function (nextOrObserver) {
        var _this = this;
        this.isOnBackgroundMessageUsed = true;
        this.bgMessageHandler = nextOrObserver;
        return function () {
            _this.bgMessageHandler = null;
        };
    };
    // TODO: Remove getToken from SW Controller. Calling this from an old SW can cause all kinds of
    // trouble.
    SwController.prototype.getToken = function () {
        var _a, _b;
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var tokenDetails;
            return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!!this.vapidKey) return [3 /*break*/, 2];
                        return [4 /*yield*/, dbGet(this.firebaseDependencies)];
                    case 1:
                        tokenDetails = _c.sent();
                        this.vapidKey = (_b = (_a = tokenDetails === null || tokenDetails === void 0 ? void 0 : tokenDetails.subscriptionOptions) === null || _a === void 0 ? void 0 : _a.vapidKey) !== null && _b !== void 0 ? _b : DEFAULT_VAPID_KEY;
                        _c.label = 2;
                    case 2: return [2 /*return*/, getToken(this.firebaseDependencies, self.registration, this.vapidKey)];
                }
            });
        });
    };
    // TODO: Remove deleteToken from SW Controller. Calling this from an old SW can cause all kinds of
    // trouble.
    SwController.prototype.deleteToken = function () {
        return deleteToken(this.firebaseDependencies, self.registration);
    };
    SwController.prototype.requestPermission = function () {
        throw ERROR_FACTORY.create("only-available-in-window" /* AVAILABLE_IN_WINDOW */);
    };
    // TODO: Remove this together with getToken from SW Controller.
    SwController.prototype.usePublicVapidKey = function (vapidKey) {
        if (this.vapidKey !== null) {
            throw ERROR_FACTORY.create("use-vapid-key-after-get-token" /* USE_VAPID_KEY_AFTER_GET_TOKEN */);
        }
        if (typeof vapidKey !== 'string' || vapidKey.length === 0) {
            throw ERROR_FACTORY.create("invalid-vapid-key" /* INVALID_VAPID_KEY */);
        }
        this.vapidKey = vapidKey;
    };
    SwController.prototype.useServiceWorker = function () {
        throw ERROR_FACTORY.create("only-available-in-window" /* AVAILABLE_IN_WINDOW */);
    };
    SwController.prototype.onMessage = function () {
        throw ERROR_FACTORY.create("only-available-in-window" /* AVAILABLE_IN_WINDOW */);
    };
    SwController.prototype.onTokenRefresh = function () {
        throw ERROR_FACTORY.create("only-available-in-window" /* AVAILABLE_IN_WINDOW */);
    };
    /**
     * A handler for push events that shows notifications based on the content of the payload.
     *
     * The payload must be a JSON-encoded Object with a `notification` key. The value of the
     * `notification` property will be used as the NotificationOptions object passed to
     * showNotification. Additionally, the `title` property of the notification object will be used as
     * the title.
     *
     * If there is no notification data in the payload then no notification will be shown.
     */
    SwController.prototype.onPush = function (event) {
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var internalPayload, clientList, isNotificationShown, payload;
            return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        internalPayload = getMessagePayloadInternal(event);
                        if (!internalPayload) {
                            console.debug(TAG +
                                'failed to get parsed MessagePayload from the PushEvent. Skip handling the push.');
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, getClientList()];
                    case 1:
                        clientList = _a.sent();
                        if (hasVisibleClients(clientList)) {
                            return [2 /*return*/, sendMessagePayloadInternalToWindows(clientList, internalPayload)];
                        }
                        isNotificationShown = false;
                        if (!!!internalPayload.notification) return [3 /*break*/, 3];
                        return [4 /*yield*/, showNotification(wrapInternalPayload(internalPayload))];
                    case 2:
                        _a.sent();
                        isNotificationShown = true;
                        _a.label = 3;
                    case 3:
                        // MessagePayload is only passed to `onBackgroundMessage`. Skip passing MessagePayload for
                        // the legacy `setBackgroundMessageHandler` to preserve the SDK behaviors.
                        if (isNotificationShown === true &&
                            this.isOnBackgroundMessageUsed === false) {
                            return [2 /*return*/];
                        }
                        if (!!this.bgMessageHandler) {
                            payload = externalizePayload(internalPayload);
                            if (typeof this.bgMessageHandler === 'function') {
                                this.bgMessageHandler(payload);
                            }
                            else {
                                this.bgMessageHandler.next(payload);
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    SwController.prototype.onSubChange = function (event) {
        var _a, _b;
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var newSubscription, tokenDetails;
            return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        newSubscription = event.newSubscription;
                        if (!!newSubscription) return [3 /*break*/, 2];
                        // Subscription revoked, delete token
                        return [4 /*yield*/, deleteToken(this.firebaseDependencies, self.registration)];
                    case 1:
                        // Subscription revoked, delete token
                        _c.sent();
                        return [2 /*return*/];
                    case 2: return [4 /*yield*/, dbGet(this.firebaseDependencies)];
                    case 3:
                        tokenDetails = _c.sent();
                        return [4 /*yield*/, deleteToken(this.firebaseDependencies, self.registration)];
                    case 4:
                        _c.sent();
                        return [4 /*yield*/, getToken(this.firebaseDependencies, self.registration, (_b = (_a = tokenDetails === null || tokenDetails === void 0 ? void 0 : tokenDetails.subscriptionOptions) === null || _a === void 0 ? void 0 : _a.vapidKey) !== null && _b !== void 0 ? _b : DEFAULT_VAPID_KEY)];
                    case 5:
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SwController.prototype.onNotificationClick = function (event) {
        var _a, _b;
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var internalPayload, link, url, originUrl, client;
            return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        internalPayload = (_b = (_a = event.notification) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b[FCM_MSG];
                        if (!internalPayload) {
                            return [2 /*return*/];
                        }
                        else if (event.action) {
                            // User clicked on an action button. This will allow developers to act on action button clicks
                            // by using a custom onNotificationClick listener that they define.
                            return [2 /*return*/];
                        }
                        // Prevent other listeners from receiving the event
                        event.stopImmediatePropagation();
                        event.notification.close();
                        link = getLink(internalPayload);
                        if (!link) {
                            return [2 /*return*/];
                        }
                        url = new URL(link, self.location.href);
                        originUrl = new URL(self.location.origin);
                        if (url.host !== originUrl.host) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, getWindowClient(url)];
                    case 1:
                        client = _c.sent();
                        if (!!client) return [3 /*break*/, 4];
                        return [4 /*yield*/, self.clients.openWindow(link)];
                    case 2:
                        client = _c.sent();
                        // Wait three seconds for the client to initialize and set up the message handler so that it
                        // can receive the message.
                        return [4 /*yield*/, sleep(3000)];
                    case 3:
                        // Wait three seconds for the client to initialize and set up the message handler so that it
                        // can receive the message.
                        _c.sent();
                        return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, client.focus()];
                    case 5:
                        client = _c.sent();
                        _c.label = 6;
                    case 6:
                        if (!client) {
                            // Window Client will not be returned if it's for a third party origin.
                            return [2 /*return*/];
                        }
                        internalPayload.messageType = MessageType.NOTIFICATION_CLICKED;
                        internalPayload.isFirebaseMessaging = true;
                        return [2 /*return*/, client.postMessage(internalPayload)];
                }
            });
        });
    };
    return SwController;
}());
function wrapInternalPayload(internalPayload) {
    var _a;
    var wrappedInternalPayload = Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__assign"])({}, internalPayload.notification);
    // Put the message payload under FCM_MSG name so we can identify the notification as being an FCM
    // notification vs a notification from somewhere else (i.e. normal web push or developer generated
    // notification).
    wrappedInternalPayload.data = (_a = {},
        _a[FCM_MSG] = internalPayload,
        _a);
    return wrappedInternalPayload;
}
function getMessagePayloadInternal(_a) {
    var data = _a.data;
    if (!data) {
        return null;
    }
    try {
        return data.json();
    }
    catch (err) {
        // Not JSON so not an FCM message.
        return null;
    }
}
/**
 * @param url The URL to look for when focusing a client.
 * @return Returns an existing window client or a newly opened WindowClient.
 */
function getWindowClient(url) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var clientList, clientList_1, clientList_1_1, client, clientUrl;
        var e_1, _a;
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getClientList()];
                case 1:
                    clientList = _b.sent();
                    try {
                        for (clientList_1 = Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__values"])(clientList), clientList_1_1 = clientList_1.next(); !clientList_1_1.done; clientList_1_1 = clientList_1.next()) {
                            client = clientList_1_1.value;
                            clientUrl = new URL(client.url, self.location.href);
                            if (url.host === clientUrl.host) {
                                return [2 /*return*/, client];
                            }
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (clientList_1_1 && !clientList_1_1.done && (_a = clientList_1.return)) _a.call(clientList_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                    return [2 /*return*/, null];
            }
        });
    });
}
/**
 * @returns If there is currently a visible WindowClient, this method will resolve to true,
 * otherwise false.
 */
function hasVisibleClients(clientList) {
    return clientList.some(function (client) {
        return client.visibilityState === 'visible' &&
            // Ignore chrome-extension clients as that matches the background pages of extensions, which
            // are always considered visible for some reason.
            !client.url.startsWith('chrome-extension://');
    });
}
function sendMessagePayloadInternalToWindows(clientList, internalPayload) {
    var e_2, _a;
    internalPayload.isFirebaseMessaging = true;
    internalPayload.messageType = MessageType.PUSH_RECEIVED;
    try {
        for (var clientList_2 = Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__values"])(clientList), clientList_2_1 = clientList_2.next(); !clientList_2_1.done; clientList_2_1 = clientList_2.next()) {
            var client = clientList_2_1.value;
            client.postMessage(internalPayload);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (clientList_2_1 && !clientList_2_1.done && (_a = clientList_2.return)) _a.call(clientList_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
}
function getClientList() {
    return self.clients.matchAll({
        type: 'window',
        includeUncontrolled: true
        // TS doesn't know that "type: 'window'" means it'll return WindowClient[]
    });
}
function showNotification(notificationPayloadInternal) {
    var _a;
    // Note: Firefox does not support the maxActions property.
    // https://developer.mozilla.org/en-US/docs/Web/API/notification/maxActions
    var actions = notificationPayloadInternal.actions;
    var maxActions = Notification.maxActions;
    if (actions && maxActions && actions.length > maxActions) {
        console.warn("This browser only supports " + maxActions + " actions. The remaining actions will not be displayed.");
    }
    return self.registration.showNotification((_a = 
    /* title= */ notificationPayloadInternal.title) !== null && _a !== void 0 ? _a : '', notificationPayloadInternal);
}
function getLink(payload) {
    var _a, _b, _c;
    // eslint-disable-next-line camelcase
    var link = (_b = (_a = payload.fcmOptions) === null || _a === void 0 ? void 0 : _a.link) !== null && _b !== void 0 ? _b : (_c = payload.notification) === null || _c === void 0 ? void 0 : _c.click_action;
    if (link) {
        return link;
    }
    if (isConsoleMessage(payload.data)) {
        // Notification created in the Firebase Console. Redirect to origin.
        return self.location.origin;
    }
    else {
        return null;
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var WindowController = /** @class */ (function () {
    function WindowController(firebaseDependencies) {
        var _this = this;
        this.firebaseDependencies = firebaseDependencies;
        this.vapidKey = null;
        this.onMessageCallback = null;
        navigator.serviceWorker.addEventListener('message', function (e) {
            return _this.messageEventListener(e);
        });
    }
    Object.defineProperty(WindowController.prototype, "app", {
        get: function () {
            return this.firebaseDependencies.app;
        },
        enumerable: false,
        configurable: true
    });
    WindowController.prototype.messageEventListener = function (event) {
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var internalPayload, dataPayload;
            return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        internalPayload = event.data;
                        if (!internalPayload.isFirebaseMessaging) {
                            return [2 /*return*/];
                        }
                        // onMessageCallback is either a function or observer/subscriber.
                        // TODO: in the modularization release, have onMessage handle type MessagePayload as supposed to
                        // the legacy payload where some fields are in snake cases.
                        if (this.onMessageCallback &&
                            internalPayload.messageType === MessageType.PUSH_RECEIVED) {
                            if (typeof this.onMessageCallback === 'function') {
                                this.onMessageCallback(stripInternalFields(Object.assign({}, internalPayload)));
                            }
                            else {
                                this.onMessageCallback.next(Object.assign({}, internalPayload));
                            }
                        }
                        dataPayload = internalPayload.data;
                        if (!(isConsoleMessage(dataPayload) &&
                            dataPayload[CONSOLE_CAMPAIGN_ANALYTICS_ENABLED] === '1')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.logEvent(internalPayload.messageType, dataPayload)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    WindowController.prototype.getVapidKey = function () {
        return this.vapidKey;
    };
    WindowController.prototype.getSwReg = function () {
        return this.swRegistration;
    };
    WindowController.prototype.getToken = function (options) {
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(Notification.permission === 'default')) return [3 /*break*/, 2];
                        return [4 /*yield*/, Notification.requestPermission()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (Notification.permission !== 'granted') {
                            throw ERROR_FACTORY.create("permission-blocked" /* PERMISSION_BLOCKED */);
                        }
                        return [4 /*yield*/, this.updateVapidKey(options === null || options === void 0 ? void 0 : options.vapidKey)];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, this.updateSwReg(options === null || options === void 0 ? void 0 : options.serviceWorkerRegistration)];
                    case 4:
                        _a.sent();
                        return [2 /*return*/, getToken(this.firebaseDependencies, this.swRegistration, this.vapidKey)];
                }
            });
        });
    };
    WindowController.prototype.updateVapidKey = function (vapidKey) {
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_a) {
                if (!!vapidKey) {
                    this.vapidKey = vapidKey;
                }
                else if (!this.vapidKey) {
                    this.vapidKey = DEFAULT_VAPID_KEY;
                }
                return [2 /*return*/];
            });
        });
    };
    WindowController.prototype.updateSwReg = function (swRegistration) {
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!swRegistration && !this.swRegistration)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.registerDefaultSw()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!swRegistration && !!this.swRegistration) {
                            return [2 /*return*/];
                        }
                        if (!(swRegistration instanceof ServiceWorkerRegistration)) {
                            throw ERROR_FACTORY.create("invalid-sw-registration" /* INVALID_SW_REGISTRATION */);
                        }
                        this.swRegistration = swRegistration;
                        return [2 /*return*/];
                }
            });
        });
    };
    WindowController.prototype.registerDefaultSw = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var _a, e_1;
            return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        _a = this;
                        return [4 /*yield*/, navigator.serviceWorker.register(DEFAULT_SW_PATH, {
                                scope: DEFAULT_SW_SCOPE
                            })];
                    case 1:
                        _a.swRegistration = _b.sent();
                        // The timing when browser updates sw when sw has an update is unreliable by my experiment. It
                        // leads to version conflict when the SDK upgrades to a newer version in the main page, but sw
                        // is stuck with the old version. For example,
                        // https://github.com/firebase/firebase-js-sdk/issues/2590 The following line reliably updates
                        // sw if there was an update.
                        this.swRegistration.update().catch(function () {
                            /* it is non blocking and we don't care if it failed */
                        });
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _b.sent();
                        throw ERROR_FACTORY.create("failed-service-worker-registration" /* FAILED_DEFAULT_REGISTRATION */, {
                            browserErrorMessage: e_1.message
                        });
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    WindowController.prototype.deleteToken = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.swRegistration) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.registerDefaultSw()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, deleteToken(this.firebaseDependencies, this.swRegistration)];
                }
            });
        });
    };
    /**
     * Request permission if it is not currently granted.
     *
     * @return Resolves if the permission was granted, rejects otherwise.
     *
     * @deprecated Use Notification.requestPermission() instead.
     * https://developer.mozilla.org/en-US/docs/Web/API/Notification/requestPermission
     */
    WindowController.prototype.requestPermission = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var permissionResult;
            return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (Notification.permission === 'granted') {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, Notification.requestPermission()];
                    case 1:
                        permissionResult = _a.sent();
                        if (permissionResult === 'granted') {
                            return [2 /*return*/];
                        }
                        else if (permissionResult === 'denied') {
                            throw ERROR_FACTORY.create("permission-blocked" /* PERMISSION_BLOCKED */);
                        }
                        else {
                            throw ERROR_FACTORY.create("permission-default" /* PERMISSION_DEFAULT */);
                        }
                }
            });
        });
    };
    /**
     * @deprecated. Use getToken(options?: {vapidKey?: string; serviceWorkerRegistration?:
     * ServiceWorkerRegistration;}): Promise<string> instead.
     */
    WindowController.prototype.usePublicVapidKey = function (vapidKey) {
        if (this.vapidKey !== null) {
            throw ERROR_FACTORY.create("use-vapid-key-after-get-token" /* USE_VAPID_KEY_AFTER_GET_TOKEN */);
        }
        if (typeof vapidKey !== 'string' || vapidKey.length === 0) {
            throw ERROR_FACTORY.create("invalid-vapid-key" /* INVALID_VAPID_KEY */);
        }
        this.vapidKey = vapidKey;
    };
    /**
     * @deprecated. Use getToken(options?: {vapidKey?: string; serviceWorkerRegistration?:
     * ServiceWorkerRegistration;}): Promise<string> instead.
     */
    WindowController.prototype.useServiceWorker = function (swRegistration) {
        if (!(swRegistration instanceof ServiceWorkerRegistration)) {
            throw ERROR_FACTORY.create("invalid-sw-registration" /* INVALID_SW_REGISTRATION */);
        }
        if (this.swRegistration) {
            throw ERROR_FACTORY.create("use-sw-after-get-token" /* USE_SW_AFTER_GET_TOKEN */);
        }
        this.swRegistration = swRegistration;
    };
    /**
     * @param nextOrObserver An observer object or a function triggered on message.
     *
     * @return The unsubscribe function for the observer.
     */
    WindowController.prototype.onMessage = function (nextOrObserver) {
        var _this = this;
        this.onMessageCallback = nextOrObserver;
        return function () {
            _this.onMessageCallback = null;
        };
    };
    WindowController.prototype.setBackgroundMessageHandler = function () {
        throw ERROR_FACTORY.create("only-available-in-sw" /* AVAILABLE_IN_SW */);
    };
    WindowController.prototype.onBackgroundMessage = function () {
        throw ERROR_FACTORY.create("only-available-in-sw" /* AVAILABLE_IN_SW */);
    };
    /**
     * @deprecated No-op. It was initially designed with token rotation requests from server in mind.
     * However, the plan to implement such feature was abandoned.
     */
    WindowController.prototype.onTokenRefresh = function () {
        return function () { };
    };
    WindowController.prototype.logEvent = function (messageType, data) {
        return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var eventType, analytics;
            return Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        eventType = getEventType(messageType);
                        return [4 /*yield*/, this.firebaseDependencies.analyticsProvider.get()];
                    case 1:
                        analytics = _a.sent();
                        analytics.logEvent(eventType, {
                            /* eslint-disable camelcase */
                            message_id: data[CONSOLE_CAMPAIGN_ID],
                            message_name: data[CONSOLE_CAMPAIGN_NAME],
                            message_time: data[CONSOLE_CAMPAIGN_TIME],
                            message_device_time: Math.floor(Date.now() / 1000)
                            /* eslint-enable camelcase */
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    return WindowController;
}());
function getEventType(messageType) {
    switch (messageType) {
        case MessageType.NOTIFICATION_CLICKED:
            return 'notification_open';
        case MessageType.PUSH_RECEIVED:
            return 'notification_foreground';
        default:
            throw new Error();
    }
}
function stripInternalFields(internalPayload) {
    delete internalPayload.messageType;
    delete internalPayload.isFirebaseMessaging;
    return internalPayload;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function extractAppConfig(app) {
    var e_1, _a;
    if (!app || !app.options) {
        throw getMissingValueError('App Configuration Object');
    }
    if (!app.name) {
        throw getMissingValueError('App Name');
    }
    // Required app config keys
    var configKeys = [
        'projectId',
        'apiKey',
        'appId',
        'messagingSenderId'
    ];
    var options = app.options;
    try {
        for (var configKeys_1 = Object(__WEBPACK_IMPORTED_MODULE_3_tslib__["__values"])(configKeys), configKeys_1_1 = configKeys_1.next(); !configKeys_1_1.done; configKeys_1_1 = configKeys_1.next()) {
            var keyName = configKeys_1_1.value;
            if (!options[keyName]) {
                throw getMissingValueError(keyName);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (configKeys_1_1 && !configKeys_1_1.done && (_a = configKeys_1.return)) _a.call(configKeys_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return {
        appName: app.name,
        projectId: options.projectId,
        apiKey: options.apiKey,
        appId: options.appId,
        senderId: options.messagingSenderId
    };
}
function getMissingValueError(valueName) {
    return ERROR_FACTORY.create("missing-app-config-values" /* MISSING_APP_CONFIG_VALUES */, {
        valueName: valueName
    });
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var MESSAGING_NAME = 'messaging';
function factoryMethod(container) {
    // Dependencies.
    var app = container.getProvider('app').getImmediate();
    var appConfig = extractAppConfig(app);
    var installations = container.getProvider('installations').getImmediate();
    var analyticsProvider = container.getProvider('analytics-internal');
    var firebaseDependencies = {
        app: app,
        appConfig: appConfig,
        installations: installations,
        analyticsProvider: analyticsProvider
    };
    if (!isSupported()) {
        throw ERROR_FACTORY.create("unsupported-browser" /* UNSUPPORTED_BROWSER */);
    }
    if (self && 'ServiceWorkerGlobalScope' in self) {
        // Running in ServiceWorker context
        return new SwController(firebaseDependencies);
    }
    else {
        // Assume we are in the window context.
        return new WindowController(firebaseDependencies);
    }
}
var NAMESPACE_EXPORTS = {
    isSupported: isSupported
};
__WEBPACK_IMPORTED_MODULE_5__firebase_app___default.a.INTERNAL.registerComponent(new __WEBPACK_IMPORTED_MODULE_1__firebase_component__["Component"](MESSAGING_NAME, factoryMethod, "PUBLIC" /* PUBLIC */).setServiceProps(NAMESPACE_EXPORTS));
function isSupported() {
    if (self && 'ServiceWorkerGlobalScope' in self) {
        // Running in ServiceWorker context
        return isSWControllerSupported();
    }
    else {
        // Assume we are in the window context.
        return isWindowControllerSupported();
    }
}
/**
 * Checks to see if the required APIs exist.
 */
function isWindowControllerSupported() {
    return ('indexedDB' in window &&
        indexedDB !== null &&
        navigator.cookieEnabled &&
        'serviceWorker' in navigator &&
        'PushManager' in window &&
        'Notification' in window &&
        'fetch' in window &&
        ServiceWorkerRegistration.prototype.hasOwnProperty('showNotification') &&
        PushSubscription.prototype.hasOwnProperty('getKey'));
}
/**
 * Checks to see if the required APIs exist within SW Context.
 */
function isSWControllerSupported() {
    return ('indexedDB' in self &&
        indexedDB !== null &&
        'PushManager' in self &&
        'Notification' in self &&
        ServiceWorkerRegistration.prototype.hasOwnProperty('showNotification') &&
        PushSubscription.prototype.hasOwnProperty('getKey'));
}
//# sourceMappingURL=index.esm.js.map


/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export registerInstallations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_app__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase_component__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__firebase_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tslib__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__firebase_util__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__firebase_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__firebase_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_idb__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_idb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_idb__);






var name = "@firebase/installations";
var version = "0.4.17";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var PENDING_TIMEOUT_MS = 10000;
var PACKAGE_VERSION = "w:" + version;
var INTERNAL_AUTH_VERSION = 'FIS_v2';
var INSTALLATIONS_API_URL = 'https://firebaseinstallations.googleapis.com/v1';
var TOKEN_EXPIRATION_BUFFER = 60 * 60 * 1000; // One hour
var SERVICE = 'installations';
var SERVICE_NAME = 'Installations';

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a;
var ERROR_DESCRIPTION_MAP = (_a = {},
    _a["missing-app-config-values" /* MISSING_APP_CONFIG_VALUES */] = 'Missing App configuration value: "{$valueName}"',
    _a["not-registered" /* NOT_REGISTERED */] = 'Firebase Installation is not registered.',
    _a["installation-not-found" /* INSTALLATION_NOT_FOUND */] = 'Firebase Installation not found.',
    _a["request-failed" /* REQUEST_FAILED */] = '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"',
    _a["app-offline" /* APP_OFFLINE */] = 'Could not process request. Application offline.',
    _a["delete-pending-registration" /* DELETE_PENDING_REGISTRATION */] = "Can't delete installation while there is a pending registration request.",
    _a);
var ERROR_FACTORY = new __WEBPACK_IMPORTED_MODULE_3__firebase_util__["ErrorFactory"](SERVICE, SERVICE_NAME, ERROR_DESCRIPTION_MAP);
/** Returns true if error is a FirebaseError that is based on an error from the server. */
function isServerError(error) {
    return (error instanceof __WEBPACK_IMPORTED_MODULE_3__firebase_util__["FirebaseError"] &&
        error.code.includes("request-failed" /* REQUEST_FAILED */));
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getInstallationsEndpoint(_a) {
    var projectId = _a.projectId;
    return INSTALLATIONS_API_URL + "/projects/" + projectId + "/installations";
}
function extractAuthTokenInfoFromResponse(response) {
    return {
        token: response.token,
        requestStatus: 2 /* COMPLETED */,
        expiresIn: getExpiresInFromResponseExpiresIn(response.expiresIn),
        creationTime: Date.now()
    };
}
function getErrorFromResponse(requestName, response) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var responseJson, errorData;
        return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, response.json()];
                case 1:
                    responseJson = _a.sent();
                    errorData = responseJson.error;
                    return [2 /*return*/, ERROR_FACTORY.create("request-failed" /* REQUEST_FAILED */, {
                            requestName: requestName,
                            serverCode: errorData.code,
                            serverMessage: errorData.message,
                            serverStatus: errorData.status
                        })];
            }
        });
    });
}
function getHeaders(_a) {
    var apiKey = _a.apiKey;
    return new Headers({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'x-goog-api-key': apiKey
    });
}
function getHeadersWithAuth(appConfig, _a) {
    var refreshToken = _a.refreshToken;
    var headers = getHeaders(appConfig);
    headers.append('Authorization', getAuthorizationHeader(refreshToken));
    return headers;
}
/**
 * Calls the passed in fetch wrapper and returns the response.
 * If the returned response has a status of 5xx, re-runs the function once and
 * returns the response.
 */
function retryIfServerError(fn) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var result;
        return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fn()];
                case 1:
                    result = _a.sent();
                    if (result.status >= 500 && result.status < 600) {
                        // Internal Server Error. Retry request.
                        return [2 /*return*/, fn()];
                    }
                    return [2 /*return*/, result];
            }
        });
    });
}
function getExpiresInFromResponseExpiresIn(responseExpiresIn) {
    // This works because the server will never respond with fractions of a second.
    return Number(responseExpiresIn.replace('s', '000'));
}
function getAuthorizationHeader(refreshToken) {
    return INTERNAL_AUTH_VERSION + " " + refreshToken;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function createInstallationRequest(appConfig, _a) {
    var fid = _a.fid;
    return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var endpoint, headers, body, request, response, responseValue, registeredInstallationEntry;
        return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0:
                    endpoint = getInstallationsEndpoint(appConfig);
                    headers = getHeaders(appConfig);
                    body = {
                        fid: fid,
                        authVersion: INTERNAL_AUTH_VERSION,
                        appId: appConfig.appId,
                        sdkVersion: PACKAGE_VERSION
                    };
                    request = {
                        method: 'POST',
                        headers: headers,
                        body: JSON.stringify(body)
                    };
                    return [4 /*yield*/, retryIfServerError(function () { return fetch(endpoint, request); })];
                case 1:
                    response = _b.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    responseValue = _b.sent();
                    registeredInstallationEntry = {
                        fid: responseValue.fid || fid,
                        registrationStatus: 2 /* COMPLETED */,
                        refreshToken: responseValue.refreshToken,
                        authToken: extractAuthTokenInfoFromResponse(responseValue.authToken)
                    };
                    return [2 /*return*/, registeredInstallationEntry];
                case 3: return [4 /*yield*/, getErrorFromResponse('Create Installation', response)];
                case 4: throw _b.sent();
            }
        });
    });
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Returns a promise that resolves after given time passes. */
function sleep(ms) {
    return new Promise(function (resolve) {
        setTimeout(resolve, ms);
    });
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function bufferToBase64UrlSafe(array) {
    var b64 = btoa(String.fromCharCode.apply(String, Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__spread"])(array)));
    return b64.replace(/\+/g, '-').replace(/\//g, '_');
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var VALID_FID_PATTERN = /^[cdef][\w-]{21}$/;
var INVALID_FID = '';
/**
 * Generates a new FID using random values from Web Crypto API.
 * Returns an empty string if FID generation fails for any reason.
 */
function generateFid() {
    try {
        // A valid FID has exactly 22 base64 characters, which is 132 bits, or 16.5
        // bytes. our implementation generates a 17 byte array instead.
        var fidByteArray = new Uint8Array(17);
        var crypto_1 = self.crypto || self.msCrypto;
        crypto_1.getRandomValues(fidByteArray);
        // Replace the first 4 random bits with the constant FID header of 0b0111.
        fidByteArray[0] = 112 + (fidByteArray[0] % 16);
        var fid = encode(fidByteArray);
        return VALID_FID_PATTERN.test(fid) ? fid : INVALID_FID;
    }
    catch (_a) {
        // FID generation errored
        return INVALID_FID;
    }
}
/** Converts a FID Uint8Array to a base64 string representation. */
function encode(fidByteArray) {
    var b64String = bufferToBase64UrlSafe(fidByteArray);
    // Remove the 23rd character that was added because of the extra 4 bits at the
    // end of our 17 byte array, and the '=' padding.
    return b64String.substr(0, 22);
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Returns a string key that can be used to identify the app. */
function getKey(appConfig) {
    return appConfig.appName + "!" + appConfig.appId;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var fidChangeCallbacks = new Map();
/**
 * Calls the onIdChange callbacks with the new FID value, and broadcasts the
 * change to other tabs.
 */
function fidChanged(appConfig, fid) {
    var key = getKey(appConfig);
    callFidChangeCallbacks(key, fid);
    broadcastFidChange(key, fid);
}
function addCallback(appConfig, callback) {
    // Open the broadcast channel if it's not already open,
    // to be able to listen to change events from other tabs.
    getBroadcastChannel();
    var key = getKey(appConfig);
    var callbackSet = fidChangeCallbacks.get(key);
    if (!callbackSet) {
        callbackSet = new Set();
        fidChangeCallbacks.set(key, callbackSet);
    }
    callbackSet.add(callback);
}
function removeCallback(appConfig, callback) {
    var key = getKey(appConfig);
    var callbackSet = fidChangeCallbacks.get(key);
    if (!callbackSet) {
        return;
    }
    callbackSet.delete(callback);
    if (callbackSet.size === 0) {
        fidChangeCallbacks.delete(key);
    }
    // Close broadcast channel if there are no more callbacks.
    closeBroadcastChannel();
}
function callFidChangeCallbacks(key, fid) {
    var e_1, _a;
    var callbacks = fidChangeCallbacks.get(key);
    if (!callbacks) {
        return;
    }
    try {
        for (var callbacks_1 = Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__values"])(callbacks), callbacks_1_1 = callbacks_1.next(); !callbacks_1_1.done; callbacks_1_1 = callbacks_1.next()) {
            var callback = callbacks_1_1.value;
            callback(fid);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (callbacks_1_1 && !callbacks_1_1.done && (_a = callbacks_1.return)) _a.call(callbacks_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
function broadcastFidChange(key, fid) {
    var channel = getBroadcastChannel();
    if (channel) {
        channel.postMessage({ key: key, fid: fid });
    }
    closeBroadcastChannel();
}
var broadcastChannel = null;
/** Opens and returns a BroadcastChannel if it is supported by the browser. */
function getBroadcastChannel() {
    if (!broadcastChannel && 'BroadcastChannel' in self) {
        broadcastChannel = new BroadcastChannel('[Firebase] FID Change');
        broadcastChannel.onmessage = function (e) {
            callFidChangeCallbacks(e.data.key, e.data.fid);
        };
    }
    return broadcastChannel;
}
function closeBroadcastChannel() {
    if (fidChangeCallbacks.size === 0 && broadcastChannel) {
        broadcastChannel.close();
        broadcastChannel = null;
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DATABASE_NAME = 'firebase-installations-database';
var DATABASE_VERSION = 1;
var OBJECT_STORE_NAME = 'firebase-installations-store';
var dbPromise = null;
function getDbPromise() {
    if (!dbPromise) {
        dbPromise = Object(__WEBPACK_IMPORTED_MODULE_4_idb__["openDb"])(DATABASE_NAME, DATABASE_VERSION, function (upgradeDB) {
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch (upgradeDB.oldVersion) {
                case 0:
                    upgradeDB.createObjectStore(OBJECT_STORE_NAME);
            }
        });
    }
    return dbPromise;
}
/** Assigns or overwrites the record for the given key with the given value. */
function set(appConfig, value) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var key, db, tx, objectStore, oldValue;
        return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    key = getKey(appConfig);
                    return [4 /*yield*/, getDbPromise()];
                case 1:
                    db = _a.sent();
                    tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
                    objectStore = tx.objectStore(OBJECT_STORE_NAME);
                    return [4 /*yield*/, objectStore.get(key)];
                case 2:
                    oldValue = _a.sent();
                    return [4 /*yield*/, objectStore.put(value, key)];
                case 3:
                    _a.sent();
                    return [4 /*yield*/, tx.complete];
                case 4:
                    _a.sent();
                    if (!oldValue || oldValue.fid !== value.fid) {
                        fidChanged(appConfig, value.fid);
                    }
                    return [2 /*return*/, value];
            }
        });
    });
}
/** Removes record(s) from the objectStore that match the given key. */
function remove(appConfig) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var key, db, tx;
        return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    key = getKey(appConfig);
                    return [4 /*yield*/, getDbPromise()];
                case 1:
                    db = _a.sent();
                    tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
                    return [4 /*yield*/, tx.objectStore(OBJECT_STORE_NAME).delete(key)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, tx.complete];
                case 3:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
/**
 * Atomically updates a record with the result of updateFn, which gets
 * called with the current value. If newValue is undefined, the record is
 * deleted instead.
 * @return Updated value
 */
function update(appConfig, updateFn) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var key, db, tx, store, oldValue, newValue;
        return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    key = getKey(appConfig);
                    return [4 /*yield*/, getDbPromise()];
                case 1:
                    db = _a.sent();
                    tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
                    store = tx.objectStore(OBJECT_STORE_NAME);
                    return [4 /*yield*/, store.get(key)];
                case 2:
                    oldValue = _a.sent();
                    newValue = updateFn(oldValue);
                    if (!(newValue === undefined)) return [3 /*break*/, 4];
                    return [4 /*yield*/, store.delete(key)];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 4: return [4 /*yield*/, store.put(newValue, key)];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6: return [4 /*yield*/, tx.complete];
                case 7:
                    _a.sent();
                    if (newValue && (!oldValue || oldValue.fid !== newValue.fid)) {
                        fidChanged(appConfig, newValue.fid);
                    }
                    return [2 /*return*/, newValue];
            }
        });
    });
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Updates and returns the InstallationEntry from the database.
 * Also triggers a registration request if it is necessary and possible.
 */
function getInstallationEntry(appConfig) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var registrationPromise, installationEntry;
        var _a;
        return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, update(appConfig, function (oldEntry) {
                        var installationEntry = updateOrCreateInstallationEntry(oldEntry);
                        var entryWithPromise = triggerRegistrationIfNecessary(appConfig, installationEntry);
                        registrationPromise = entryWithPromise.registrationPromise;
                        return entryWithPromise.installationEntry;
                    })];
                case 1:
                    installationEntry = _b.sent();
                    if (!(installationEntry.fid === INVALID_FID)) return [3 /*break*/, 3];
                    _a = {};
                    return [4 /*yield*/, registrationPromise];
                case 2: 
                // FID generation failed. Waiting for the FID from the server.
                return [2 /*return*/, (_a.installationEntry = _b.sent(), _a)];
                case 3: return [2 /*return*/, {
                        installationEntry: installationEntry,
                        registrationPromise: registrationPromise
                    }];
            }
        });
    });
}
/**
 * Creates a new Installation Entry if one does not exist.
 * Also clears timed out pending requests.
 */
function updateOrCreateInstallationEntry(oldEntry) {
    var entry = oldEntry || {
        fid: generateFid(),
        registrationStatus: 0 /* NOT_STARTED */
    };
    return clearTimedOutRequest(entry);
}
/**
 * If the Firebase Installation is not registered yet, this will trigger the
 * registration and return an InProgressInstallationEntry.
 *
 * If registrationPromise does not exist, the installationEntry is guaranteed
 * to be registered.
 */
function triggerRegistrationIfNecessary(appConfig, installationEntry) {
    if (installationEntry.registrationStatus === 0 /* NOT_STARTED */) {
        if (!navigator.onLine) {
            // Registration required but app is offline.
            var registrationPromiseWithError = Promise.reject(ERROR_FACTORY.create("app-offline" /* APP_OFFLINE */));
            return {
                installationEntry: installationEntry,
                registrationPromise: registrationPromiseWithError
            };
        }
        // Try registering. Change status to IN_PROGRESS.
        var inProgressEntry = {
            fid: installationEntry.fid,
            registrationStatus: 1 /* IN_PROGRESS */,
            registrationTime: Date.now()
        };
        var registrationPromise = registerInstallation(appConfig, inProgressEntry);
        return { installationEntry: inProgressEntry, registrationPromise: registrationPromise };
    }
    else if (installationEntry.registrationStatus === 1 /* IN_PROGRESS */) {
        return {
            installationEntry: installationEntry,
            registrationPromise: waitUntilFidRegistration(appConfig)
        };
    }
    else {
        return { installationEntry: installationEntry };
    }
}
/** This will be executed only once for each new Firebase Installation. */
function registerInstallation(appConfig, installationEntry) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var registeredInstallationEntry, e_1;
        return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 7]);
                    return [4 /*yield*/, createInstallationRequest(appConfig, installationEntry)];
                case 1:
                    registeredInstallationEntry = _a.sent();
                    return [2 /*return*/, set(appConfig, registeredInstallationEntry)];
                case 2:
                    e_1 = _a.sent();
                    if (!(isServerError(e_1) && e_1.serverCode === 409)) return [3 /*break*/, 4];
                    // Server returned a "FID can not be used" error.
                    // Generate a new ID next time.
                    return [4 /*yield*/, remove(appConfig)];
                case 3:
                    // Server returned a "FID can not be used" error.
                    // Generate a new ID next time.
                    _a.sent();
                    return [3 /*break*/, 6];
                case 4: 
                // Registration failed. Set FID as not registered.
                return [4 /*yield*/, set(appConfig, {
                        fid: installationEntry.fid,
                        registrationStatus: 0 /* NOT_STARTED */
                    })];
                case 5:
                    // Registration failed. Set FID as not registered.
                    _a.sent();
                    _a.label = 6;
                case 6: throw e_1;
                case 7: return [2 /*return*/];
            }
        });
    });
}
/** Call if FID registration is pending in another request. */
function waitUntilFidRegistration(appConfig) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var entry, _a, installationEntry, registrationPromise;
        return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, updateInstallationRequest(appConfig)];
                case 1:
                    entry = _b.sent();
                    _b.label = 2;
                case 2:
                    if (!(entry.registrationStatus === 1 /* IN_PROGRESS */)) return [3 /*break*/, 5];
                    // createInstallation request still in progress.
                    return [4 /*yield*/, sleep(100)];
                case 3:
                    // createInstallation request still in progress.
                    _b.sent();
                    return [4 /*yield*/, updateInstallationRequest(appConfig)];
                case 4:
                    entry = _b.sent();
                    return [3 /*break*/, 2];
                case 5:
                    if (!(entry.registrationStatus === 0 /* NOT_STARTED */)) return [3 /*break*/, 7];
                    return [4 /*yield*/, getInstallationEntry(appConfig)];
                case 6:
                    _a = _b.sent(), installationEntry = _a.installationEntry, registrationPromise = _a.registrationPromise;
                    if (registrationPromise) {
                        return [2 /*return*/, registrationPromise];
                    }
                    else {
                        // if there is no registrationPromise, entry is registered.
                        return [2 /*return*/, installationEntry];
                    }
                case 7: return [2 /*return*/, entry];
            }
        });
    });
}
/**
 * Called only if there is a CreateInstallation request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * CreateInstallation request.
 *
 * Returns the updated InstallationEntry.
 */
function updateInstallationRequest(appConfig) {
    return update(appConfig, function (oldEntry) {
        if (!oldEntry) {
            throw ERROR_FACTORY.create("installation-not-found" /* INSTALLATION_NOT_FOUND */);
        }
        return clearTimedOutRequest(oldEntry);
    });
}
function clearTimedOutRequest(entry) {
    if (hasInstallationRequestTimedOut(entry)) {
        return {
            fid: entry.fid,
            registrationStatus: 0 /* NOT_STARTED */
        };
    }
    return entry;
}
function hasInstallationRequestTimedOut(installationEntry) {
    return (installationEntry.registrationStatus === 1 /* IN_PROGRESS */ &&
        installationEntry.registrationTime + PENDING_TIMEOUT_MS < Date.now());
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function generateAuthTokenRequest(_a, installationEntry) {
    var appConfig = _a.appConfig, platformLoggerProvider = _a.platformLoggerProvider;
    return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var endpoint, headers, platformLogger, body, request, response, responseValue, completedAuthToken;
        return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0:
                    endpoint = getGenerateAuthTokenEndpoint(appConfig, installationEntry);
                    headers = getHeadersWithAuth(appConfig, installationEntry);
                    platformLogger = platformLoggerProvider.getImmediate({
                        optional: true
                    });
                    if (platformLogger) {
                        headers.append('x-firebase-client', platformLogger.getPlatformInfoString());
                    }
                    body = {
                        installation: {
                            sdkVersion: PACKAGE_VERSION
                        }
                    };
                    request = {
                        method: 'POST',
                        headers: headers,
                        body: JSON.stringify(body)
                    };
                    return [4 /*yield*/, retryIfServerError(function () { return fetch(endpoint, request); })];
                case 1:
                    response = _b.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    responseValue = _b.sent();
                    completedAuthToken = extractAuthTokenInfoFromResponse(responseValue);
                    return [2 /*return*/, completedAuthToken];
                case 3: return [4 /*yield*/, getErrorFromResponse('Generate Auth Token', response)];
                case 4: throw _b.sent();
            }
        });
    });
}
function getGenerateAuthTokenEndpoint(appConfig, _a) {
    var fid = _a.fid;
    return getInstallationsEndpoint(appConfig) + "/" + fid + "/authTokens:generate";
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a valid authentication token for the installation. Generates a new
 * token if one doesn't exist, is expired or about to expire.
 *
 * Should only be called if the Firebase Installation is registered.
 */
function refreshAuthToken(dependencies, forceRefresh) {
    if (forceRefresh === void 0) { forceRefresh = false; }
    return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var tokenPromise, entry, authToken, _a;
        return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, update(dependencies.appConfig, function (oldEntry) {
                        if (!isEntryRegistered(oldEntry)) {
                            throw ERROR_FACTORY.create("not-registered" /* NOT_REGISTERED */);
                        }
                        var oldAuthToken = oldEntry.authToken;
                        if (!forceRefresh && isAuthTokenValid(oldAuthToken)) {
                            // There is a valid token in the DB.
                            return oldEntry;
                        }
                        else if (oldAuthToken.requestStatus === 1 /* IN_PROGRESS */) {
                            // There already is a token request in progress.
                            tokenPromise = waitUntilAuthTokenRequest(dependencies, forceRefresh);
                            return oldEntry;
                        }
                        else {
                            // No token or token expired.
                            if (!navigator.onLine) {
                                throw ERROR_FACTORY.create("app-offline" /* APP_OFFLINE */);
                            }
                            var inProgressEntry = makeAuthTokenRequestInProgressEntry(oldEntry);
                            tokenPromise = fetchAuthTokenFromServer(dependencies, inProgressEntry);
                            return inProgressEntry;
                        }
                    })];
                case 1:
                    entry = _b.sent();
                    if (!tokenPromise) return [3 /*break*/, 3];
                    return [4 /*yield*/, tokenPromise];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _a = entry.authToken;
                    _b.label = 4;
                case 4:
                    authToken = _a;
                    return [2 /*return*/, authToken];
            }
        });
    });
}
/**
 * Call only if FID is registered and Auth Token request is in progress.
 *
 * Waits until the current pending request finishes. If the request times out,
 * tries once in this thread as well.
 */
function waitUntilAuthTokenRequest(dependencies, forceRefresh) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var entry, authToken;
        return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, updateAuthTokenRequest(dependencies.appConfig)];
                case 1:
                    entry = _a.sent();
                    _a.label = 2;
                case 2:
                    if (!(entry.authToken.requestStatus === 1 /* IN_PROGRESS */)) return [3 /*break*/, 5];
                    // generateAuthToken still in progress.
                    return [4 /*yield*/, sleep(100)];
                case 3:
                    // generateAuthToken still in progress.
                    _a.sent();
                    return [4 /*yield*/, updateAuthTokenRequest(dependencies.appConfig)];
                case 4:
                    entry = _a.sent();
                    return [3 /*break*/, 2];
                case 5:
                    authToken = entry.authToken;
                    if (authToken.requestStatus === 0 /* NOT_STARTED */) {
                        // The request timed out or failed in a different call. Try again.
                        return [2 /*return*/, refreshAuthToken(dependencies, forceRefresh)];
                    }
                    else {
                        return [2 /*return*/, authToken];
                    }
            }
        });
    });
}
/**
 * Called only if there is a GenerateAuthToken request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * GenerateAuthToken request.
 *
 * Returns the updated InstallationEntry.
 */
function updateAuthTokenRequest(appConfig) {
    return update(appConfig, function (oldEntry) {
        if (!isEntryRegistered(oldEntry)) {
            throw ERROR_FACTORY.create("not-registered" /* NOT_REGISTERED */);
        }
        var oldAuthToken = oldEntry.authToken;
        if (hasAuthTokenRequestTimedOut(oldAuthToken)) {
            return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])(Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])({}, oldEntry), { authToken: { requestStatus: 0 /* NOT_STARTED */ } });
        }
        return oldEntry;
    });
}
function fetchAuthTokenFromServer(dependencies, installationEntry) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var authToken, updatedInstallationEntry, e_1, updatedInstallationEntry;
        return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 8]);
                    return [4 /*yield*/, generateAuthTokenRequest(dependencies, installationEntry)];
                case 1:
                    authToken = _a.sent();
                    updatedInstallationEntry = Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])(Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])({}, installationEntry), { authToken: authToken });
                    return [4 /*yield*/, set(dependencies.appConfig, updatedInstallationEntry)];
                case 2:
                    _a.sent();
                    return [2 /*return*/, authToken];
                case 3:
                    e_1 = _a.sent();
                    if (!(isServerError(e_1) && (e_1.serverCode === 401 || e_1.serverCode === 404))) return [3 /*break*/, 5];
                    // Server returned a "FID not found" or a "Invalid authentication" error.
                    // Generate a new ID next time.
                    return [4 /*yield*/, remove(dependencies.appConfig)];
                case 4:
                    // Server returned a "FID not found" or a "Invalid authentication" error.
                    // Generate a new ID next time.
                    _a.sent();
                    return [3 /*break*/, 7];
                case 5:
                    updatedInstallationEntry = Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])(Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])({}, installationEntry), { authToken: { requestStatus: 0 /* NOT_STARTED */ } });
                    return [4 /*yield*/, set(dependencies.appConfig, updatedInstallationEntry)];
                case 6:
                    _a.sent();
                    _a.label = 7;
                case 7: throw e_1;
                case 8: return [2 /*return*/];
            }
        });
    });
}
function isEntryRegistered(installationEntry) {
    return (installationEntry !== undefined &&
        installationEntry.registrationStatus === 2 /* COMPLETED */);
}
function isAuthTokenValid(authToken) {
    return (authToken.requestStatus === 2 /* COMPLETED */ &&
        !isAuthTokenExpired(authToken));
}
function isAuthTokenExpired(authToken) {
    var now = Date.now();
    return (now < authToken.creationTime ||
        authToken.creationTime + authToken.expiresIn < now + TOKEN_EXPIRATION_BUFFER);
}
/** Returns an updated InstallationEntry with an InProgressAuthToken. */
function makeAuthTokenRequestInProgressEntry(oldEntry) {
    var inProgressAuthToken = {
        requestStatus: 1 /* IN_PROGRESS */,
        requestTime: Date.now()
    };
    return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])(Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])({}, oldEntry), { authToken: inProgressAuthToken });
}
function hasAuthTokenRequestTimedOut(authToken) {
    return (authToken.requestStatus === 1 /* IN_PROGRESS */ &&
        authToken.requestTime + PENDING_TIMEOUT_MS < Date.now());
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getId(dependencies) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var _a, installationEntry, registrationPromise;
        return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getInstallationEntry(dependencies.appConfig)];
                case 1:
                    _a = _b.sent(), installationEntry = _a.installationEntry, registrationPromise = _a.registrationPromise;
                    if (registrationPromise) {
                        registrationPromise.catch(console.error);
                    }
                    else {
                        // If the installation is already registered, update the authentication
                        // token if needed.
                        refreshAuthToken(dependencies).catch(console.error);
                    }
                    return [2 /*return*/, installationEntry.fid];
            }
        });
    });
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getToken(dependencies, forceRefresh) {
    if (forceRefresh === void 0) { forceRefresh = false; }
    return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var authToken;
        return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, completeInstallationRegistration(dependencies.appConfig)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, refreshAuthToken(dependencies, forceRefresh)];
                case 2:
                    authToken = _a.sent();
                    return [2 /*return*/, authToken.token];
            }
        });
    });
}
function completeInstallationRegistration(appConfig) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var registrationPromise;
        return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getInstallationEntry(appConfig)];
                case 1:
                    registrationPromise = (_a.sent()).registrationPromise;
                    if (!registrationPromise) return [3 /*break*/, 3];
                    // A createInstallation request is in progress. Wait until it finishes.
                    return [4 /*yield*/, registrationPromise];
                case 2:
                    // A createInstallation request is in progress. Wait until it finishes.
                    _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function deleteInstallationRequest(appConfig, installationEntry) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var endpoint, headers, request, response;
        return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    endpoint = getDeleteEndpoint(appConfig, installationEntry);
                    headers = getHeadersWithAuth(appConfig, installationEntry);
                    request = {
                        method: 'DELETE',
                        headers: headers
                    };
                    return [4 /*yield*/, retryIfServerError(function () { return fetch(endpoint, request); })];
                case 1:
                    response = _a.sent();
                    if (!!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, getErrorFromResponse('Delete Installation', response)];
                case 2: throw _a.sent();
                case 3: return [2 /*return*/];
            }
        });
    });
}
function getDeleteEndpoint(appConfig, _a) {
    var fid = _a.fid;
    return getInstallationsEndpoint(appConfig) + "/" + fid;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function deleteInstallation(dependencies) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var appConfig, entry;
        return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    appConfig = dependencies.appConfig;
                    return [4 /*yield*/, update(appConfig, function (oldEntry) {
                            if (oldEntry && oldEntry.registrationStatus === 0 /* NOT_STARTED */) {
                                // Delete the unregistered entry without sending a deleteInstallation request.
                                return undefined;
                            }
                            return oldEntry;
                        })];
                case 1:
                    entry = _a.sent();
                    if (!entry) return [3 /*break*/, 6];
                    if (!(entry.registrationStatus === 1 /* IN_PROGRESS */)) return [3 /*break*/, 2];
                    // Can't delete while trying to register.
                    throw ERROR_FACTORY.create("delete-pending-registration" /* DELETE_PENDING_REGISTRATION */);
                case 2:
                    if (!(entry.registrationStatus === 2 /* COMPLETED */)) return [3 /*break*/, 6];
                    if (!!navigator.onLine) return [3 /*break*/, 3];
                    throw ERROR_FACTORY.create("app-offline" /* APP_OFFLINE */);
                case 3: return [4 /*yield*/, deleteInstallationRequest(appConfig, entry)];
                case 4:
                    _a.sent();
                    return [4 /*yield*/, remove(appConfig)];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    });
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Sets a new callback that will get called when Installation ID changes.
 * Returns an unsubscribe function that will remove the callback when called.
 */
function onIdChange(_a, callback) {
    var appConfig = _a.appConfig;
    addCallback(appConfig, callback);
    return function () {
        removeCallback(appConfig, callback);
    };
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function extractAppConfig(app) {
    var e_1, _a;
    if (!app || !app.options) {
        throw getMissingValueError('App Configuration');
    }
    if (!app.name) {
        throw getMissingValueError('App Name');
    }
    // Required app config keys
    var configKeys = [
        'projectId',
        'apiKey',
        'appId'
    ];
    try {
        for (var configKeys_1 = Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__values"])(configKeys), configKeys_1_1 = configKeys_1.next(); !configKeys_1_1.done; configKeys_1_1 = configKeys_1.next()) {
            var keyName = configKeys_1_1.value;
            if (!app.options[keyName]) {
                throw getMissingValueError(keyName);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (configKeys_1_1 && !configKeys_1_1.done && (_a = configKeys_1.return)) _a.call(configKeys_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return {
        appName: app.name,
        projectId: app.options.projectId,
        apiKey: app.options.apiKey,
        appId: app.options.appId
    };
}
function getMissingValueError(valueName) {
    return ERROR_FACTORY.create("missing-app-config-values" /* MISSING_APP_CONFIG_VALUES */, {
        valueName: valueName
    });
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function registerInstallations(instance) {
    var installationsName = 'installations';
    instance.INTERNAL.registerComponent(new __WEBPACK_IMPORTED_MODULE_1__firebase_component__["Component"](installationsName, function (container) {
        var app = container.getProvider('app').getImmediate();
        // Throws if app isn't configured properly.
        var appConfig = extractAppConfig(app);
        var platformLoggerProvider = container.getProvider('platform-logger');
        var dependencies = {
            appConfig: appConfig,
            platformLoggerProvider: platformLoggerProvider
        };
        var installations = {
            app: app,
            getId: function () { return getId(dependencies); },
            getToken: function (forceRefresh) {
                return getToken(dependencies, forceRefresh);
            },
            delete: function () { return deleteInstallation(dependencies); },
            onIdChange: function (callback) {
                return onIdChange(dependencies, callback);
            }
        };
        return installations;
    }, "PUBLIC" /* PUBLIC */));
    instance.registerVersion(name, version);
}
registerInstallations(__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a);


//# sourceMappingURL=index.esm.js.map


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(528);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(25)("7dc8347e", content, true, {});

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(190);
exports = module.exports = __webpack_require__(19)(false);
// imports
exports.i(__webpack_require__(529), "");

// module
exports.push([module.i, "body{overflow:hidden;margin:0;padding:0;font-family:Red Hat Text,sans-serif}*{box-sizing:border-box}p{margin:0}.margin-left-1{margin-left:1rem}.btn,.btn:hover{color:#fff;background-color:#07579a;cursor:pointer}.btn:hover{box-shadow:1px 2px 4px rgba(0,0,0,.6)}::placeholder{color:#a0a0a0!important;font-size:.8rem;font-weight:500}.errorMessage{color:#ec4c47;font-size:14px}button:disabled{opacity:.5}button:disabled,input[type=checkbox]:disabled~.checkmark{cursor:not-allowed}.under-process{font-size:17px;font-weight:700;text-align:center;border-top:1px solid green}.table-setup-padding{padding:5px 0!important}.table-setup-padding-body{padding:8p 0!important}.mx-calendar-icon{color:#07579a!important}.btn-purple,.btn-purple:hover{background-color:#07579a;color:#fff;border-radius:16px;border:2px solid #fff;padding:10px 25px;font-size:14px;text-align:center;text-decoration:none;display:inline-block;cursor:pointer;box-shadow:1px 2px 4px rgba(0,0,0,.2)}.btn-purple:hover{background-color:#fff;color:#07579a;border:2px solid #07579a}.btn-purple:active,.btn-purple:focus{outline:none!important}.btn-purple:active{box-shadow:none}.btn-blue{background-color:#07579a;color:#f6f9fc;border-radius:16px;border:none;padding:.5rem .75rem;white-space:nowrap;font-size:14px;text-align:center;text-decoration:none;display:inline-block;cursor:pointer;box-shadow:1px 2px 4px rgba(0,0,0,.2)}.btn-blue:hover{background-color:#fff;color:#07579a;border:2px solid #07579a}.btn-blue:active,.btn-blue:focus{outline:none!important}.btn-blue:active{box-shadow:none}input[type=number]{-moz-appearance:textfield}.mx-datepicker{position:relative;display:inline-block;height:35px!important;width:160px!important}.input-control{display:block;width:100%;padding:.375rem .65rem;line-height:1.5;font-size:1rem;border:1px solid #9b9b9b;border-radius:.25rem}.input-control:focus{outline:none}.input-control::placeholder{font-size:14px}.margin-top-2{margin-top:.5rem}.margin-top-3{margin-top:1rem}.margin-top-4{margin-top:1.5rem}.margin-top-5{margin-top:2rem}.margin-top-6{margin-top:3rem}.table-header{width:100%;margin-top:2%;background-color:#07579a;table-layout:fixed;word-break:break-word;color:#fff;border-radius:8px}.tab-content{margin-top:2%;margin-right:3%}@media screen and (min-width:1800px) and (max-width:4000px){.mx-datepicker{position:relative;display:inline-block;height:35px!important;width:250px!important}.table-header{min-height:65px}th{font-size:1rem}td{font-size:.9rem}}@media screen and (min-width:320px) and (max-width:767px){.mx-datepicker{position:relative;display:inline-block;height:35px!important;width:140px!important}.table-header{display:none}.no-data{padding:3%;margin-top:2%!important}input::placeholder{font-size:.6rem}}@media screen and (min-width:768px) and (max-width:1024px){.mx-datepicker{position:relative;display:inline-block;height:35px!important;width:120px!important}}@media screen and (min-width:1800px) and (max-width:2000px){.mx-datepicker{width:200px!important}}.mx-input-wrapper{position:relative}.mx-input-wrapper .mx-input{display:inline-block;width:100%;height:35px!important;padding:6px 30px;padding-left:10px;font-weight:550!important;font-size:.8rem!important;line-height:1.4;color:#555;background-color:#fff;border:none!important;box-shadow:1px 1px 4px rgba(0,0,0,.2)!important}.center-align{text-align:center}.right-align{text-align:right}.table{width:100%;margin-top:2%;background-color:#fff;table-layout:fixed;word-break:break-word}th{padding:15px 5px 15px 26px;position:relative;font-size:.9rem;text-align:center;width:5%;opacity:1}.tablular-view{width:100%;margin-top:.5%;background-color:#fff;table-layout:fixed;word-break:break-word;border-radius:16px;box-shadow:0 1px 1px rgba(0,0,0,.1)}td{color:#5d5d5d}.show-data{margin-top:-1.2%}.no-data{font-size:1rem;margin-top:-.8%!important;text-align:center;color:#5d5d5d;background:#fff;padding:1.5%;border-radius:16px;box-shadow:0 1px 1px rgba(0,0,0,.1)}.container-table{display:block;position:relative;cursor:pointer;font-size:22px;margin-left:31%}.container-table input{position:absolute;opacity:0;cursor:pointer;height:0;width:0}.checkmark{position:absolute;top:0;left:0;height:16px;width:16px;border-radius:4px;background-color:#fff;border:3px solid #eee}.container-table:hover input~.checkmark{opacity:1}.container-table input:checked~.checkmark{background-color:#07579a;border:none}.checkmark:after{content:\"\";position:absolute;display:none;border:none}.container-table input:checked~.checkmark:after{display:block}.container-table .checkmark:after{left:6px;top:3px;width:5px;height:10px;border:solid #fff;border-width:0 3px 3px 0;-webkit-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg)}::-webkit-scrollbar{width:8px;cursor:pointer}::-webkit-scrollbar-track{box-shadow:inset 0 0 5px #d3d3d3;border-radius:10px}::-webkit-scrollbar-thumb{background:#a9a9a9;border-radius:5px}::-webkit-scrollbar-thumb:hover{background:#5d5d55}.custom-modal{display:none;position:fixed;z-index:1;padding-top:100px;left:0;top:0;width:100%;height:100%;overflow:auto;background-color:#000;background-color:rgba(0,0,0,.4)}.custom-modal-content{background-color:#fefefe;margin:auto;padding:20px;border:1px solid #888;width:80%}.custom-close{color:#aaa;float:right;font-size:28px;font-weight:700}.custom-close:focus,.custom-close:hover{color:#000;text-decoration:none;cursor:pointer}.page-link{color:#07579a!important}.page-item.active .page-link{border-color:#07579a!important}.page-item.active .page-link,.page-link:hover{background-color:#07579a!important;color:#fff!important}.disabled{cursor:not-allowed}.mx-calendar-content .cell.actived{background-color:#07579a!important}.mandatory{color:red;padding-left:3px}select{background:url(" + escape(__webpack_require__(530)) + ") no-repeat 100%;-webkit-appearance:none;background-position-x:95%;background-size:.6rem;cursor:pointer}select option{color:#5d5d5d}.modal-backdrop{z-index:9999!important}.flip-box{background-color:transparent;width:300px;height:200px;perspective:1000px}.flip-box-inner{position:relative;width:100%;height:100%;text-align:center;transition:transform .8s;transform-style:preserve-3d}.flip-box:hover .flip-box-inner{transform:rotateY(180deg)}.flip-box-back,.flip-box-front{position:absolute;width:100%;height:100%;-webkit-backface-visibility:hidden;backface-visibility:hidden}.flip-box-front{color:#000}.flip-box-back{background-color:#555;color:#fff;transform:rotateY(180deg)}.cancelbutton{border:none;outline:none;background-color:#fff;margin-top:1%;margin-bottom:5%;cursor:pointer;color:#212529;font-size:.8rem}.cancelbutton:hover{color:#07579a}.grecaptcha-badge,.rc-anchor-light{margin-bottom:3%!important;z-index:9!important}", ""]);

// exports


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(19)(false);
// imports


// module
exports.push([module.i, ".red-hat-bold{font-weight:700}.red-hat-medium{font-weight:500}.red-hat-regular{font-weight:400}", ""]);

// exports


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "arrow.svg?e1498c933718bed1dfbfd0172a46dd18";

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(532);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(25)("3eb2e9cd", content, true, {});

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(19)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

(function () {
  var VueD3 = {};
  var D3 =  true
    ? __webpack_require__(191)
    : window.D3;

  if (!D3) {
    throw new Error('[vue-d3] cannot locate d3');
  }

  VueD3.install = function (Vue) {
    Vue.prototype.$d3 = D3;
  };

  if (true) {
    module.exports = VueD3;
  } else if (typeof define == 'function' && define.amd) {
    define([], function(){ return VueD3; })
  } else if (window.Vue) {
    window.VueD3 = VueD3;
    Vue.use(VueD3);
  }
})();


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build-ffcb87c77253e9779e24.js